import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  GraphQLDate: { input: number; output: number; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddUserInput = {
  emailAddress: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  isEmployee: Scalars['Boolean']['input'];
  lastname: Scalars['String']['input'];
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type AdvertisementScreenConfigUpdateInput = {
  _id: Scalars['ID']['input'];
  images: Array<Scalars['Upload']['input']>;
};

export type AppleAuthenticationCredentials = {
  authorizationCode: Scalars['String']['input'];
  fullName?: InputMaybe<AppleFullName>;
  identityToken: Scalars['String']['input'];
};

export type AppleFullName = {
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};

export enum AugmentedSenseiBasketState {
  Created = 'Created',
  Expired = 'Expired',
  Pending = 'Pending',
  Validated = 'Validated'
}

export enum AuthProvider {
  Apple = 'apple',
  Google = 'google',
  Totem = 'totem'
}

export enum BadgeName {
  FairTrade = 'FairTrade',
  Local = 'Local',
  MadeInFrance = 'MadeInFrance',
  Organic = 'Organic',
  Vegan = 'Vegan',
  Vegetarian = 'Vegetarian',
  WithoutGluten = 'WithoutGluten',
  WithoutPlastic = 'WithoutPlastic',
  WithoutSugar = 'WithoutSugar'
}

export enum BadgeType {
  Diet = 'diet',
  Preference = 'preference'
}

export type BakeryRecordInput = {
  productId: Scalars['String']['input'];
  quantityUsed: Scalars['Int']['input'];
  serialNumber: Scalars['String']['input'];
  useDate: Scalars['String']['input'];
};

export type BarcodeInput = {
  barcode: Scalars['String']['input'];
  type: BarcodeType;
};

export enum BarcodeType {
  Packaging = 'Packaging',
  Product = 'Product'
}

export type BoxInput = {
  _id: Scalars['ID']['input'];
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  products: Array<BoxProductInput>;
  state?: InputMaybe<BoxState>;
};

export type BoxProductInput = {
  _id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  quantityPicked?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type BoxQuantityInfoInput = {
  boxId: Scalars['String']['input'];
  quantityPicked: Scalars['Int']['input'];
};

export enum BoxScanStep {
  DepartureScanned = 'DepartureScanned',
  Loaded = 'Loaded',
  Returned = 'Returned',
  SetupScanned = 'SetupScanned'
}

export enum BoxState {
  Aborted = 'Aborted',
  Created = 'Created',
  Ready = 'Ready'
}

export type BundleInput = {
  _id: Scalars['ID']['input'];
  boxes: Array<BoxInput>;
  state: BundleState;
};

export enum BundleState {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Completed = 'Completed',
  Created = 'Created',
  InProgress = 'InProgress',
  Paused = 'Paused',
  Started = 'Started'
}

export type BundlesFilterInput = {
  containerType?: InputMaybe<Array<ContainerType>>;
  createdAt?: InputMaybe<DateFilter>;
  operatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduledPreparationDate?: InputMaybe<DateFilter>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<Array<BundleState>>;
  type?: InputMaybe<Array<ProductFlow>>;
  warehouseColumnIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum CardType {
  Bimpli = 'Bimpli',
  Edenred = 'Edenred',
  Pluxee = 'Pluxee',
  RestoFlash = 'RestoFlash',
  Sodexo = 'Sodexo',
  Swile = 'Swile',
  TitreRestaurants = 'TitreRestaurants',
  Up = 'Up',
  UpFrance = 'UpFrance'
}

export type CatalogProductsFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  flow?: InputMaybe<Array<ProductFlow>>;
  infos?: InputMaybe<Array<InfoType>>;
  isFreefood?: InputMaybe<Scalars['Boolean']['input']>;
  isMicrostore?: InputMaybe<Scalars['Boolean']['input']>;
  isToBeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutStock?: InputMaybe<Scalars['Boolean']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProductState>>;
  subcategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  suppliers?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CatalogSectionType {
  Badge = 'Badge',
  Category = 'Category',
  Subcategory = 'Subcategory'
}

export enum CatalogTitleColor {
  Blue = 'Blue',
  Green = 'Green',
  Orange = 'Orange',
  Pink = 'Pink',
  Purple = 'Purple'
}

export enum CategoryState {
  Archived = 'Archived',
  Created = 'Created',
  Regular = 'Regular'
}

export type CategoryUpdateInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  indexDisplay: Scalars['Int']['input'];
  isFreefood: Scalars['Boolean']['input'];
  isMicrostore: Scalars['Boolean']['input'];
  isPunctual: Scalars['Boolean']['input'];
  shouldShowSubcategories: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type CheckoutInput = {
  oldState?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export enum ColumnInventoryStockType {
  AutoComputed = 'AutoComputed',
  AutoInitial = 'AutoInitial',
  ManualAdmin = 'ManualAdmin',
  ManualSetup = 'ManualSetup',
  ManualTotops = 'ManualTotops'
}

export type ColumnProductRefInput = {
  columnId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};

export type ColumnProductsFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  flow?: InputMaybe<Array<ProductFlow>>;
  infos?: InputMaybe<Array<InfoType>>;
  isFreefood?: InputMaybe<Scalars['Boolean']['input']>;
  isMicrostore?: InputMaybe<Scalars['Boolean']['input']>;
  isToBeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutStock?: InputMaybe<Scalars['Boolean']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProductState>>;
  subcategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  suppliers?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ColumnType {
  BrokenProductsWarehouse = 'BrokenProductsWarehouse',
  ExpiredProductsWarehouse = 'ExpiredProductsWarehouse',
  SecuredMicrostore = 'SecuredMicrostore',
  UnsecuredMicrostore = 'UnsecuredMicrostore',
  VirtualMicrostore = 'VirtualMicrostore',
  Warehouse = 'Warehouse'
}

export type ColumnsFilterInput = {
  prioritizeWarehouseTypes?: InputMaybe<Scalars['Boolean']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<MicrostoreElementState>>;
  types?: InputMaybe<Array<ColumnType>>;
};

export enum CommentState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type ConsumptionColumnInput = {
  microstoreColumnIds: Array<Scalars['ID']['input']>;
  priceOptionType: PriceOptionType;
  priceTiers: Array<PriceTierInput>;
  tva?: InputMaybe<Scalars['Float']['input']>;
};

export type ConsumptionVariationCreateInput = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type ConsumptionVariationUpdateInput = {
  _id: Scalars['ID']['input'];
  dessert: QuantityVariationInput;
  endDate: Scalars['String']['input'];
  main: QuantityVariationInput;
  smallBites: QuantityVariationInput;
  startDate: Scalars['String']['input'];
  starter: QuantityVariationInput;
};

export enum ContainerType {
  Box = 'box',
  FreshParcel = 'freshParcel',
  Kangabox = 'kangabox',
  Kraft = 'kraft',
  Palette = 'palette',
  Parcel = 'parcel'
}

export type ControlPhotoInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  deliveryId?: InputMaybe<Scalars['ID']['input']>;
  isMandatory: Scalars['Boolean']['input'];
  issueType: PhotoIssueTypeInput;
  photoIndex: Scalars['Int']['input'];
  setupInstructionId?: InputMaybe<Scalars['ID']['input']>;
  state: PhotoState;
  taskInstructionId?: InputMaybe<Scalars['ID']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateBadgeInput = {
  image: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  type: BadgeType;
};

export type CreateDeliveryZoneInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateMessagesSetInput = {
  messages: Array<MessageInput>;
  name: Scalars['String']['input'];
  state: MessagesSetState;
};

export type CreateMicrostoreColumnGroupInput = {
  avaSalePlaceLocationId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  positionInSite: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateMicrostoreColumnInput = {
  columnGroupId: Scalars['ID']['input'];
  microstoreColumnTemplateId: Scalars['String']['input'];
  nayaxMDBTemplateId?: InputMaybe<Scalars['String']['input']>;
  positionInColumnGroup: Scalars['Int']['input'];
};

export type CreateMobilePopupInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['GraphQLDate']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startsAt: Scalars['GraphQLDate']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNayaxMdbTemplateInput = {
  associations: Array<NayaxMdbTemplateAssociationInput>;
  name: Scalars['String']['input'];
};

export type CreateOdooTicketInput = {
  criticality: OdooTicketCriticality;
  description: Scalars['String']['input'];
  microstoreColumnId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateRitualInput = {
  activeDate?: InputMaybe<Scalars['String']['input']>;
  activeWeekdays?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  associatedDiscount?: InputMaybe<Scalars['Float']['input']>;
  billToOrganizationId?: InputMaybe<Scalars['String']['input']>;
  expiringProductsOnly: Scalars['Boolean']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  messagesSetId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  repetition: RitualRepetition;
  requiresParticipation: Scalars['Boolean']['input'];
  resetsBetweenPurchases: Scalars['Boolean']['input'];
  restrictedBadgeIds: Array<Scalars['String']['input']>;
  restrictedCategoryIds: Array<Scalars['String']['input']>;
  restrictedOrganizationIds: Array<Scalars['String']['input']>;
  restrictedProductIds: Array<Scalars['String']['input']>;
  restrictedSiteIds: Array<Scalars['String']['input']>;
  restrictedSubcategoryIds: Array<Scalars['ID']['input']>;
  restrictedTagIds: Array<Scalars['String']['input']>;
  restrictedUserIds: Array<Scalars['String']['input']>;
  supplierPartnershipId?: InputMaybe<Scalars['String']['input']>;
  timeWindow: RitualTimeWindowInput;
};

export type CreateSubventionInput = {
  billToOrganizationId?: InputMaybe<Scalars['String']['input']>;
  categories: Array<InputMaybe<Scalars['ID']['input']>>;
  coverageRate?: InputMaybe<Scalars['Float']['input']>;
  cumulative?: InputMaybe<Scalars['Boolean']['input']>;
  currentAmount?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  hoursIntervalsAvailable: Array<Array<Scalars['String']['input']>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  reload?: InputMaybe<SubventionReloadPeriod>;
};

export type CreateSupplierDiscountInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
  purchaseEndDate: Scalars['GraphQLDate']['input'];
  purchaseStartDate: Scalars['GraphQLDate']['input'];
  rate: Scalars['Float']['input'];
  salesEndDate: Scalars['GraphQLDate']['input'];
  salesStartDate: Scalars['GraphQLDate']['input'];
};

export type CreateTagInput = {
  displayIndex: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  state: TagState;
  type: TagType;
};

export type CreateTaskInput = {
  birthdayDate: Scalars['String']['input'];
  description: Scalars['String']['input'];
  instructions: Array<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  type: TaskType;
};

export type CreateTemperatureMeasureInput = {
  coldRoomMeasure: Scalars['Float']['input'];
  thermometerMeasure?: InputMaybe<Scalars['Float']['input']>;
  type: TemperatureMeasureType;
};

export type CreateTotemClosedDayInput = {
  date: Scalars['String']['input'];
  type: TotemClosedDayType;
};

export type CreateTotemClosedReceptionDayInput = {
  date: Scalars['String']['input'];
};

export type CreateTourInput = {
  birthdayDate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  stops: Array<TourStopInput>;
};

export enum CreditCardProvider {
  Paygreen = 'paygreen',
  Stripe = 'stripe'
}

export type CreditImagesInput = {
  bannerUrl: Scalars['String']['input'];
  homeUrl: Scalars['String']['input'];
  iconUrl: Scalars['String']['input'];
};

export type CreditInput = {
  initialAmount: Scalars['Float']['input'];
};

export enum CreditType {
  Cash = 'Cash',
  Marketing = 'Marketing',
  Onboarding = 'Onboarding',
  Refund = 'Refund',
  TotrouletteReward = 'TotrouletteReward'
}

export type CreditsBatchFilter = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CreditsHistoryType {
  Credit = 'Credit',
  Debit = 'Debit'
}

export type DateFilter = {
  eq?: InputMaybe<Scalars['GraphQLDate']['input']>;
  gt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  gte?: InputMaybe<Scalars['GraphQLDate']['input']>;
  lt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  lte?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export enum DayOfTheWeek {
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday'
}

export enum DebitType {
  Edenred = 'Edenred',
  Paygreen = 'Paygreen',
  Stripe = 'Stripe',
  Swile = 'Swile'
}

export type DeliveriesFilterInput = {
  filterString?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum DeliveryDestinationType {
  Freefood = 'freefood',
  Store = 'store'
}

export type DeliveryHoursInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type DeliveryInfoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_details?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  consigneDelivery?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryInput = {
  _id: Scalars['ID']['input'];
  boxes: Array<BoxInput>;
  state: DeliveryState;
};

export type DeliveryPlanningBatchUpdateInput = {
  date: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  siteId: Scalars['ID']['input'];
};

export type DeliveryPlanningCreateInput = {
  date: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isManual: Scalars['Boolean']['input'];
  siteId: Scalars['ID']['input'];
};

export enum DeliveryState {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Created = 'Created',
  Delivered = 'Delivered',
  InProgress = 'InProgress',
  NotDelivered = 'NotDelivered',
  Packaging = 'Packaging',
  Paused = 'Paused',
  Ready = 'Ready'
}

export type DeliveryTimeWindowInput = {
  start: Scalars['String']['input'];
  stop: Scalars['String']['input'];
};

export enum DeliveryType {
  Order = 'order',
  PackageDelivery = 'packageDelivery',
  Punctual = 'punctual',
  RefrigeratedTruckDelivery = 'refrigeratedTruckDelivery',
  StockTransfer = 'stockTransfer',
  WarehouseDelivery = 'warehouseDelivery'
}

export enum DeliveryZoneState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type DimensionsInput = {
  height: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
  weightWithoutPackaging?: InputMaybe<Scalars['Float']['input']>;
  width: Scalars['Float']['input'];
};

export type DraftRitual = {
  activeDate: Scalars['String']['input'];
  associatedDiscount: Scalars['Float']['input'];
  existingRitualId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
  restrictedCategoryIds: Array<Scalars['String']['input']>;
  restrictedOrganizationIds: Array<Scalars['String']['input']>;
  restrictedSiteIds: Array<Scalars['String']['input']>;
  restrictedUserIds: Array<Scalars['String']['input']>;
  supplierPartnershipId?: InputMaybe<Scalars['String']['input']>;
  timeWindow: RitualTimeWindowInput;
};

export enum DynamicDeliveryBucket {
  Critical = 'Critical',
  MaxDays = 'MaxDays',
  Required = 'Required'
}

export type DynamicDeliveryConfigInput = {
  capacity: Scalars['Int']['input'];
  estimatedTransactionCapacities: Array<DynamicDeliveryTemplateCapacityInput>;
  thresholds: Array<DynamicDeliveryThresholdEntryInput>;
};

export enum DynamicDeliveryContractType {
  FixedDelivery = 'FixedDelivery',
  FreeDeposit = 'FreeDeposit',
  Subscription = 'Subscription'
}

export type DynamicDeliveryPlanningBatchUpdateInput = {
  columnId: Scalars['ID']['input'];
  date: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type DynamicDeliveryTemplateCapacityInput = {
  estimatedTransactionCapacity: Scalars['Int']['input'];
  templateType: MicrostoreColumnTemplateType;
};

export type DynamicDeliveryThresholdEntryInput = {
  contractType: DynamicDeliveryContractType;
  criticalGroupingPercent: Scalars['Float']['input'];
  criticalPassPercent: Scalars['Float']['input'];
  groupingRadiusKm: Scalars['Float']['input'];
  maxDaysWithoutDelivery: Scalars['Int']['input'];
  qualityPassPercent: Scalars['Float']['input'];
  requiredGroupingPercent: Scalars['Float']['input'];
  requiredPassPercent: Scalars['Float']['input'];
  templateType: MicrostoreColumnTemplateType;
};

export enum EasterEggFamily {
  Christmas2023 = 'Christmas2023',
  Easter2023 = 'Easter2023'
}

export enum EasterEggIdentifier {
  Christmas2023Reindeer1Dasher = 'Christmas2023Reindeer1Dasher',
  Christmas2023Reindeer2Dancer = 'Christmas2023Reindeer2Dancer',
  Christmas2023Reindeer3Prancer = 'Christmas2023Reindeer3Prancer',
  Christmas2023Reindeer4Vixen = 'Christmas2023Reindeer4Vixen',
  Christmas2023Reindeer5Comet = 'Christmas2023Reindeer5Comet',
  Christmas2023Reindeer6Cupid = 'Christmas2023Reindeer6Cupid',
  Christmas2023Reindeer7Donner = 'Christmas2023Reindeer7Donner',
  Christmas2023Reindeer8Blitzen = 'Christmas2023Reindeer8Blitzen',
  Christmas2023Reindeer9Rudolph = 'Christmas2023Reindeer9Rudolph',
  Easter2023Egg1 = 'Easter2023Egg1',
  Easter2023Egg2 = 'Easter2023Egg2',
  Easter2023Egg3 = 'Easter2023Egg3',
  Easter2023Egg4 = 'Easter2023Egg4',
  Easter2023Egg5 = 'Easter2023Egg5',
  Easter2023Egg6 = 'Easter2023Egg6',
  Easter2023Egg7 = 'Easter2023Egg7',
  Easter2023Egg8 = 'Easter2023Egg8',
  Easter2023Egg9 = 'Easter2023Egg9',
  Easter2023Egg10 = 'Easter2023Egg10',
  Easter2023Egg11 = 'Easter2023Egg11',
  Easter2023Egg12 = 'Easter2023Egg12'
}

export enum EdenredPaymentType {
  Edenred = 'EDENRED'
}

export enum EquipmentCategoryState {
  Archived = 'Archived',
  Created = 'Created',
  Regular = 'Regular'
}

export type EquipmentCategoryUpdateInput = {
  displayIndex: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export enum EquipmentRequestContractor {
  CafeRichard = 'CafeRichard',
  Kawa = 'Kawa',
  MyTroopers = 'MyTroopers',
  Provea = 'Provea',
  Sadim = 'Sadim',
  True = 'True',
  Unknown = 'Unknown',
  Waterlogic = 'Waterlogic'
}

export enum EquipmentRequestEquipmentType {
  CoffeeMachine = 'CoffeeMachine',
  FreefoodFurniture = 'FreefoodFurniture',
  StoreFurniture = 'StoreFurniture',
  Unknown = 'Unknown',
  WaterFountain = 'WaterFountain'
}

export enum EquipmentRequestStage {
  Blocked = 'Blocked',
  Completed = 'Completed',
  Ignored = 'Ignored',
  InProgress = 'InProgress',
  New = 'New',
  OnHold = 'OnHold',
  Unknown = 'Unknown'
}

export enum EquipmentRequestType {
  Installation = 'Installation',
  Removal = 'Removal',
  Repair = 'Repair',
  Unknown = 'Unknown'
}

export enum EquipmentRequestUrgencyLevel {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  RelativeToClient = 'RelativeToClient',
  Unknown = 'Unknown'
}

export enum EquipmentState {
  Archived = 'Archived',
  Regular = 'Regular',
  Testing = 'Testing'
}

export type EquipmentSubcategoryInput = {
  displayIndex: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  state: EquipmentSubcategoryState;
};

export enum EquipmentSubcategoryState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type EquipmentUpdateFields = {
  brand: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  equipmentCategoryId?: InputMaybe<Scalars['String']['input']>;
  equipmentSubcategoryId?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  hidden: Scalars['Boolean']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
  volume: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type EvenOddWeekMetadataInput = {
  evenWeek: Scalars['Boolean']['input'];
  oddWeek: Scalars['Boolean']['input'];
};

export type EvenOddWeekMetadataInputOptionnal = {
  evenWeek?: InputMaybe<Scalars['Boolean']['input']>;
  oddWeek?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ExpiryDateRecordState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type ExternalColumnConfigInput = {
  nayaxMDBIntervals: Array<ExternalColumnConfigNayaxMdbIntervalInput>;
};

export type ExternalColumnConfigNayaxMdbIntervalInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export enum ExternalColumnType {
  Default = 'Default',
  Digitiz = 'Digitiz',
  Nayax = 'Nayax',
  NayaxNeocorner = 'NayaxNeocorner',
  Nu = 'Nu',
  Odoo = 'Odoo',
  Sensei = 'Sensei',
  Vendon = 'Vendon'
}

export type FlowParameterInput = {
  bundleCapacity: Scalars['Int']['input'];
  emptyWeightBox: Scalars['Float']['input'];
  externalVolumeBox: Scalars['Float']['input'];
  flow: ProductFlow;
  volumeBox: Scalars['Float']['input'];
  weightBox: Scalars['Float']['input'];
};

/** Server-side filters for the freefood ordering catalogue (freefood app). */
export type FreefoodCatalogueFilterInput = {
  brands?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** Badge ids — diets and preferences share product.badgeIds. */
  labelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  priceMax?: InputMaybe<Scalars['Float']['input']>;
  priceMin?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Lead captured by the public freefood marketing quote form (DevisForm). No auth — rate limited per IP. */
export type FreefoodQuoteRequestInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  /** Headcount bracket (e.g. « 20 – 50 »). */
  companySize?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable solution labels the prospect selected (e.g. « Free food entreprise »). */
  needs: Array<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum FreefoodSetupState {
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export enum FutureStockVariationIssueType {
  AbortedBundle = 'AbortedBundle',
  AbortedDelivery = 'AbortedDelivery',
  AbortedSupplyOrder = 'AbortedSupplyOrder',
  CanceledOrder = 'CanceledOrder',
  CanceledStockTransfer = 'CanceledStockTransfer',
  CanceledSupplyOrder = 'CanceledSupplyOrder',
  DeletedProduct = 'DeletedProduct',
  ExpiredOngoing = 'ExpiredOngoing',
  InsufficientReadyOrderStock = 'InsufficientReadyOrderStock',
  ManualBugFix = 'ManualBugFix',
  NegativeReadyOrderStock = 'NegativeReadyOrderStock',
  OrderDateChanged = 'OrderDateChanged',
  PartialBoxPrepared = 'PartialBoxPrepared',
  PartialSupplyOrderReceived = 'PartialSupplyOrderReceived',
  PausedOrder = 'PausedOrder',
  QuantityOrDateChange = 'QuantityOrDateChange',
  RemovedProduct = 'RemovedProduct',
  ReplacedProduct = 'ReplacedProduct',
  RolledBackSupplyOrder = 'RolledBackSupplyOrder',
  SupplyOrderOnHold = 'SupplyOrderOnHold',
  TotopsRevertedProduct = 'TotopsRevertedProduct'
}

export enum FutureStockVariationState {
  Aborted = 'Aborted',
  Completed = 'Completed',
  Ongoing = 'Ongoing'
}

export enum FutureStockVariationType {
  OrderPrediction = 'OrderPrediction',
  PunctualOrder = 'PunctualOrder',
  RecurringOrder = 'RecurringOrder',
  StockTransfer = 'StockTransfer',
  StockTransferPrediction = 'StockTransferPrediction',
  SupplyOrder = 'SupplyOrder'
}

export enum HotDrinksIngredientUnit {
  G = 'g',
  Unit = 'unit'
}

export type HotDrinksLocationInput = {
  initialTrayLevel: Scalars['Int']['input'];
  microstoreLocationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  targetTrayLevel: Scalars['Int']['input'];
};

export enum InAppNotificationIconName {
  Alarm = 'Alarm',
  AlertCircle = 'AlertCircle',
  Award = 'Award',
  BadgeOutline = 'BadgeOutline',
  Bell = 'Bell',
  BellRinging = 'BellRinging',
  CalendarNumber = 'CalendarNumber',
  CalendarPlus = 'CalendarPlus',
  CardOff = 'CardOff',
  CreditCard = 'CreditCard',
  Cutlery = 'Cutlery',
  Feedback = 'Feedback',
  Lock = 'Lock',
  ParticipationPlus = 'ParticipationPlus',
  Receipt = 'Receipt',
  Recommendation = 'Recommendation',
  SpecialOffer = 'SpecialOffer',
  ThumbUp = 'ThumbUp',
  TruckDelivery = 'TruckDelivery'
}

export enum InfoType {
  IsBeingTested = 'IsBeingTested',
  IsInShortage = 'IsInShortage',
  IsToBeArchived = 'IsToBeArchived',
  New = 'New',
  OutOfStock = 'OutOfStock',
  Paused = 'Paused',
  Private = 'Private'
}

export enum InternalUserRole {
  Deliverer = 'Deliverer',
  Preparer = 'Preparer',
  Toteam = 'Toteam'
}

export type InventoryCheckedLocationInput = {
  microstoreLocationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantityDetails: Array<InventoryCheckedLocationQuantityDetailInput>;
};

export type InventoryCheckedLocationQuantityDetailInput = {
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type KnownLossesInput = {
  expirationDate: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export enum LevelUpRewardType {
  Cash10 = 'Cash10',
  Cash20 = 'Cash20',
  Cash50 = 'Cash50',
  Cash100 = 'Cash100'
}

export enum LocationAisle {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  K = 'K',
  L = 'L'
}

export enum LocationState {
  Hidden = 'Hidden',
  Regular = 'Regular'
}

export type LocationToUpdateInput = {
  currentProductId?: InputMaybe<Scalars['String']['input']>;
  dayIndex: Scalars['Int']['input'];
  locationId: Scalars['String']['input'];
  newProductId?: InputMaybe<Scalars['String']['input']>;
};

export enum LocationType {
  Picking = 'Picking',
  Reserve = 'Reserve'
}

export enum LocationZone {
  Bak = 'BAK',
  Cat = 'CAT',
  Dry = 'DRY',
  Fre = 'FRE',
  Fru = 'FRU',
  Kum = 'KUM'
}

export type ManualReassortFromTruckEntryInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type ManualReassortInventoryEntryInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type ManualSupplyOrderProductUpdateInput = {
  _id: Scalars['String']['input'];
  colis: Scalars['Float']['input'];
  conditionning?: InputMaybe<Scalars['Float']['input']>;
  confirmedQuantity?: InputMaybe<Scalars['Int']['input']>;
  packagesPerBatch?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ManualSupplyOrderUpdateInput = {
  _id: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dateDeliveryScheduled?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  nextOrderDate?: InputMaybe<Scalars['String']['input']>;
  orderDate?: InputMaybe<Scalars['String']['input']>;
  priceHTInvoice?: InputMaybe<Scalars['Float']['input']>;
  priceTTCInvoice?: InputMaybe<Scalars['Float']['input']>;
  products: Array<ManualSupplyOrderProductUpdateInput>;
};

export enum MealVoucherProvider {
  Edenred = 'edenred',
  Paygreen = 'paygreen',
  PaygreenV3 = 'paygreenV3',
  Swile = 'swile'
}

export type MenuInstructionDeleteInput = {
  categoryId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  microstoreColumnId: Scalars['String']['input'];
  type: MenuInstructionType;
};

export type MenuInstructionInput = {
  categoryId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  microstoreColumnId: Scalars['String']['input'];
  type: MenuInstructionType;
  value: Scalars['Int']['input'];
};

export enum MenuInstructionType {
  AddPercentageQuantities = 'AddPercentageQuantities',
  AddUnitQuantities = 'AddUnitQuantities',
  SetupFacing = 'SetupFacing',
  SetupQuantities = 'SetupQuantities'
}

export type MessageInput = {
  body: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum MessagesSetState {
  Regular = 'Regular'
}

export type MicrostoreColumnGroupFilterInput = {
  searchValue?: InputMaybe<Scalars['String']['input']>;
  siteIdsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum MicrostoreColumnGroupSetupState {
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export type MicrostoreColumnGroupUpdateInput = {
  avaSalePlaceLocationId?: InputMaybe<Scalars['Int']['input']>;
  columns: Array<MicrostoreColumnUpdateInput>;
  name: Scalars['String']['input'];
  positionInSite: Scalars['Int']['input'];
};

export enum MicrostoreColumnInventoryState {
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export enum MicrostoreColumnSetupState {
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export type MicrostoreColumnTemplateCreateInput = {
  name: Scalars['String']['input'];
  type: MicrostoreColumnTemplateType;
};

export enum MicrostoreColumnTemplateState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum MicrostoreColumnTemplateType {
  Cutlery = 'Cutlery',
  Drinks = 'Drinks',
  Essentials = 'Essentials',
  Fridge = 'Fridge',
  HotDrinks = 'HotDrinks',
  Microwave = 'Microwave',
  Snacks = 'Snacks',
  Vrac = 'Vrac'
}

export type MicrostoreColumnTemplateUpdateInput = {
  _id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shelfTemplates: Array<MicrostoreShelfTemplateCreateOrUpdateInput>;
  state: MicrostoreColumnTemplateState;
  type: MicrostoreColumnTemplateType;
};

export enum MicrostoreColumnType {
  SecuredMicrostore = 'SecuredMicrostore',
  UnsecuredMicrostore = 'UnsecuredMicrostore'
}

export type MicrostoreColumnUpdateInput = {
  _id: Scalars['String']['input'];
  avaSalePlaceId?: InputMaybe<Scalars['Int']['input']>;
  externalColumnConfig?: InputMaybe<ExternalColumnConfigInput>;
  externalColumnId?: InputMaybe<Scalars['String']['input']>;
  externalColumnType: ExternalColumnType;
  isPaused: Scalars['Boolean']['input'];
  machineCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  positionInColumnGroup: Scalars['Int']['input'];
  removalDate?: InputMaybe<Scalars['String']['input']>;
  shelves?: InputMaybe<Array<MicrostoreShelfUpdateInput>>;
  shouldIgnoreReassortThresholds: Scalars['Boolean']['input'];
  shouldSendNayaxPrices: Scalars['Boolean']['input'];
  shouldUpdateStockOnTransaction: Scalars['Boolean']['input'];
  startingDate?: InputMaybe<Scalars['String']['input']>;
  useDynamicDelivery: Scalars['Boolean']['input'];
};

export type MicrostoreColumnsFilterInput = {
  avaSalePlaceId?: InputMaybe<Scalars['Int']['input']>;
  externalColumnId?: InputMaybe<Scalars['String']['input']>;
  externalColumnTypes?: InputMaybe<Array<ExternalColumnType>>;
  isRegular?: InputMaybe<Scalars['Boolean']['input']>;
  microstoreColumnTemplateName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<MicrostoreElementState>>;
  types?: InputMaybe<Array<MicrostoreColumnTemplateType>>;
};

export enum MicrostoreElementState {
  Archived = 'Archived',
  Disabled = 'Disabled',
  Regular = 'Regular'
}

export type MicrostoreItemInput = {
  itemId: Scalars['String']['input'];
  itemType: MicrostoreItemType;
};

export enum MicrostoreItemType {
  Product = 'Product',
  ProductArrangement = 'ProductArrangement'
}

export type MicrostoreItemsFilterInput = {
  searchValue?: InputMaybe<Scalars['String']['input']>;
};

export type MicrostoreLocationExpiryDateInput = {
  expiryDate: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  shouldRemoveFromSite: Scalars['Boolean']['input'];
};

export type MicrostoreLocationIdWithTargetStockInput = {
  locationId: Scalars['String']['input'];
  targetStock?: InputMaybe<Scalars['Int']['input']>;
};

export type MicrostoreLocationTemplateCreateOrUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  allowProductRotation: Scalars['Boolean']['input'];
  alternativeProductArrangementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productArrangementId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  reassortmentType?: InputMaybe<ProductArrangementReassortmentType>;
  shouldOrderProductIfNotInSite: Scalars['Boolean']['input'];
  shouldSmoothProductTransition: Scalars['Boolean']['input'];
  stockMax?: InputMaybe<Scalars['Int']['input']>;
  trayMaxCapacity: Scalars['Int']['input'];
};

export type MicrostoreLocationUpdateInput = {
  _id: Scalars['String']['input'];
  expiryDates: Array<MicrostoreLocationExpiryDateInput>;
  nayaxMDBCode?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  replacementProductId?: InputMaybe<Scalars['String']['input']>;
  stockToAdd: Scalars['Int']['input'];
};

export type MicrostoreShelfTemplateCreateOrUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  locationTemplateTable: Array<Array<MicrostoreLocationTemplateCreateOrUpdateInput>>;
};

export type MicrostoreShelfUpdateInput = {
  _id: Scalars['String']['input'];
  locationTable: Array<Array<MicrostoreLocationUpdateInput>>;
};

export type MinimumOrderAmountInfoInput = {
  minimumBakeryAmount: Scalars['Int']['input'];
  minimumCatererAmount: Scalars['Int']['input'];
  minimumDryAmount: Scalars['Int']['input'];
  minimumFreshAmount: Scalars['Int']['input'];
  minimumFruitAmount: Scalars['Int']['input'];
  minimumTotalAmount: Scalars['Int']['input'];
};

export type NayaxMdbTemplateAssociationInput = {
  nayaxMDBCode: Scalars['Int']['input'];
  positionInColumn: Scalars['Int']['input'];
  positionInShelf: PositionInShelfInput;
};

export enum NotificationCategory {
  CustomRitualActivity = 'customRitualActivity',
  DailyDelivery = 'dailyDelivery',
  Feedbacks = 'feedbacks',
  NewFeatures = 'newFeatures',
  Recommendations = 'recommendations',
  Reminders = 'reminders',
  RitualInvite = 'ritualInvite',
  SiteActivity = 'siteActivity',
  SpecialOffers = 'specialOffers',
  StartingRitual = 'startingRitual',
  WeeklySummary = 'weeklySummary'
}

export enum NotificationPreferenceChannel {
  Email = 'Email',
  InApp = 'InApp',
  Push = 'Push'
}

export enum NuBasketType {
  Digitiz = 'Digitiz',
  Nayax = 'Nayax',
  Nu = 'Nu',
  Odoo = 'Odoo',
  Vendon = 'Vendon'
}

export type NumberFilter = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdooCompany {
  Neocorner = 'Neocorner',
  Nseda = 'Nseda'
}

export enum OdooServiceType {
  ServiceAppro = 'ServiceAppro',
  ServiceSupervision = 'ServiceSupervision',
  ServiceTech = 'ServiceTech'
}

export type OdooTicketActionInput = {
  actionType: OdooTicketActionType;
  message: Scalars['String']['input'];
  photoUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum OdooTicketActionType {
  AddNote = 'AddNote',
  AddPhoto = 'AddPhoto',
  AssignToUser = 'AssignToUser',
  ReassignToManager = 'ReassignToManager',
  RequestValidation = 'RequestValidation'
}

export enum OdooTicketCriticality {
  Block = 'Block',
  High = 'High',
  Normal = 'Normal'
}

export type OdooTicketFilters = {
  microstoreColumnId?: InputMaybe<Scalars['ID']['input']>;
  serviceType?: InputMaybe<OdooServiceType>;
};

export type OdooTicketInput = {
  description: Scalars['String']['input'];
  microstoreColumnId: Scalars['ID']['input'];
  odooTicketId: Scalars['Int']['input'];
  priority: Scalars['Int']['input'];
  serviceType: OdooServiceType;
  siteSetupId?: InputMaybe<Scalars['ID']['input']>;
  source: Scalars['String']['input'];
  state: OdooTicketState;
  ticketType: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum OdooTicketState {
  Archived = 'Archived',
  Created = 'Created',
  InProgress = 'InProgress',
  PendingAssignment = 'PendingAssignment',
  ToReassign = 'ToReassign',
  Validated = 'Validated',
  WaitingValidation = 'WaitingValidation'
}

export type OpsParameterDataInput = {
  canUseKraftForFreefood: Scalars['Boolean']['input'];
  canUseKraftForStore: Scalars['Boolean']['input'];
  dryReassortMaxEmptyFacings: Scalars['Int']['input'];
  dryReassortMinProductCount: Scalars['Int']['input'];
  dryReassortMinReferenceCount: Scalars['Int']['input'];
  dynamicDelivery: DynamicDeliveryConfigInput;
  emptyWeightKraftBox: Scalars['Float']['input'];
  emptyWeightPaletteBox: Scalars['Float']['input'];
  externalVolumeKraftBox: Scalars['Float']['input'];
  externalVolumePaletteBox: Scalars['Float']['input'];
  flowParameters: Array<FlowParameterInput>;
  serviceTimePerBox: Scalars['Float']['input'];
  shouldAutoOrderMenuSupplyOrder: Scalars['Boolean']['input'];
  shouldProcessFreshReassortment: Scalars['Boolean']['input'];
  volumeKraftBox: Scalars['Float']['input'];
  volumePaletteBox: Scalars['Float']['input'];
  weightKraftBox: Scalars['Float']['input'];
  weightPaletteBox: Scalars['Float']['input'];
};

export type OrderDiscountInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrderDiscountType>;
};

export enum OrderDiscountType {
  Fixed = 'Fixed',
  Percentage = 'Percentage'
}

export enum OrderFrequency {
  BiAnnually = 'BiAnnually',
  BiWeekly = 'BiWeekly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Weekly = 'Weekly'
}

export enum OrderInvoicingStatus {
  Excluded = 'Excluded',
  Invoiced = 'Invoiced',
  Paid = 'Paid',
  Pending = 'Pending',
  ToBeInvoiced = 'ToBeInvoiced'
}

export enum OrderMode {
  Email = 'email',
  Platform = 'platform'
}

export enum OrderState {
  Archived = 'Archived',
  Created = 'Created',
  Deleted = 'Deleted',
  InProgress = 'InProgress',
  Paused = 'Paused',
  Ready = 'Ready',
  Validated = 'Validated'
}

export type OrderUpdateInput = {
  deliveryDate: Scalars['String']['input'];
  discount?: InputMaybe<OrderDiscountInput>;
  hasOnsiteSetup: Scalars['Boolean']['input'];
  pausedInfo?: InputMaybe<PausedInfoInput>;
  priceDelivery: Scalars['Float']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  state: OrderState;
};

export type OrderingMinRequirementInput = {
  unit?: InputMaybe<OrderingRequirementUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderingProductTermInput = {
  minQuantity: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
};

export enum OrderingRequirementUnit {
  Eur = 'EUR',
  Box = 'box',
  G = 'g',
  Ml = 'ml',
  Quantity = 'quantity'
}

export type OrderingTermInput = {
  deliveryPrice?: InputMaybe<Scalars['Float']['input']>;
  minRequirements: Array<Array<OrderingMinRequirementInput>>;
};

export type OrderingTimeForDayInput = {
  canBeOrdered: Scalars['Boolean']['input'];
  daysToDeliver: Scalars['Int']['input'];
  deliveryHours: DeliveryHoursInput;
  orderBefore: Scalars['String']['input'];
};

export type OrganizationBillingInfoInput = {
  invoiceAddress: Scalars['String']['input'];
  invoiceCity: Scalars['String']['input'];
  invoiceCountry: Scalars['String']['input'];
  invoiceEmail: Scalars['String']['input'];
  invoiceName: Scalars['String']['input'];
  invoicePO?: InputMaybe<Scalars['String']['input']>;
  invoiceSiret?: InputMaybe<Scalars['String']['input']>;
  invoiceVAT?: InputMaybe<Scalars['String']['input']>;
  invoiceZipcode: Scalars['String']['input'];
};

export enum OrganizationCardObject {
  Card = 'card',
  PaymentMethod = 'payment_method',
  Source = 'source'
}

export enum OrganizationCardState {
  Active = 'Active',
  Archived = 'Archived'
}

export enum OrganizationCardType {
  Card = 'card',
  SepaDebit = 'sepa_debit'
}

export type OrganizationCreateInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  siret?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationInvoiceSettingInput = {
  consumptionColumns: Array<ConsumptionColumnInput>;
  organizationId: Scalars['ID']['input'];
  rmeColumns: Array<RmeColumnInput>;
  state: OrganizationInvoiceSettingState;
};

export enum OrganizationInvoiceSettingState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum OrganizationPaymentTimeType {
  EndOfMonth = 'endOfMonth',
  NumberOfDay = 'numberOfDay'
}

export enum OrganizationPaymentType {
  CreditCard = 'CreditCard',
  NoPayment = 'NoPayment',
  Odoo = 'Odoo',
  SepaDirectDebit = 'SEPADirectDebit'
}

export enum OrganizationSource {
  Odoo = 'Odoo',
  Totadmin = 'Totadmin',
  Webapp = 'Webapp'
}

export enum OrganizationState {
  Archived = 'Archived',
  Rollout = 'Rollout'
}

export type OrganizationUpdateInput = {
  B2BPriceRange?: InputMaybe<Scalars['String']['input']>;
  attachUsersManually: Scalars['Boolean']['input'];
  avaClientId?: InputMaybe<Scalars['Int']['input']>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  domains: Array<Scalars['String']['input']>;
  hasDetailedOrderInvoicing: Scalars['Boolean']['input'];
  hasFreefoodIncluded: Scalars['Boolean']['input'];
  hasOdooOrganizationParentInvoicing: Scalars['Boolean']['input'];
  hasPrepaidOrganizationCards: Scalars['Boolean']['input'];
  hasPrepaidSubventions: Scalars['Boolean']['input'];
  hasSubscription: Scalars['Boolean']['input'];
  invoiceSettings?: InputMaybe<OrganizationInvoiceSettingInput>;
  maxUsers: Scalars['Int']['input'];
  odooInvoiceReference?: InputMaybe<Scalars['String']['input']>;
  odooOrganizationId?: InputMaybe<Scalars['Int']['input']>;
  paymentTimeType: OrganizationPaymentTimeType;
  paymentType: OrganizationPaymentType;
  restrictedProductArrangementId?: InputMaybe<Scalars['String']['input']>;
  salesId?: InputMaybe<Scalars['ID']['input']>;
  segregatedInvoicing: Scalars['Boolean']['input'];
  totalCoworkers?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationsFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Array<OrganizationPaymentType>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<OrganizationState>>;
};

export enum PatchOp {
  Add = 'add',
  Copy = 'copy',
  Move = 'move',
  Remove = 'remove',
  Replace = 'replace',
  Test = 'test'
}

export type PausedInfoInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  returnDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export enum PaygreenPaymentType {
  Amex = 'AMEX',
  Cb = 'CB',
  Ecv = 'ECV',
  Lunchr = 'LUNCHR',
  Restoflash = 'RESTOFLASH',
  Sepa = 'SEPA',
  Trd = 'TRD'
}

export enum PaymentIntentState {
  Canceled = 'Canceled',
  Captured = 'Captured',
  Failed = 'Failed',
  Processing = 'Processing',
  Refunded = 'Refunded',
  Waiting = 'Waiting'
}

export enum PaymentMethodName {
  CreditCardPaymentMethod = 'CreditCardPaymentMethod',
  CreditPaymentMethod = 'CreditPaymentMethod',
  MealPlanPaymentMethod = 'MealPlanPaymentMethod',
  MealVoucherPaymentMethod = 'MealVoucherPaymentMethod',
  OrganizationCardPaymentMethod = 'OrganizationCardPaymentMethod',
  RitualPaymentMethod = 'RitualPaymentMethod',
  SubventionPaymentMethod = 'SubventionPaymentMethod',
  ThirdPartyPaymentMethod = 'ThirdPartyPaymentMethod'
}

export enum PaymentMethodPaymentType {
  Amex = 'AMEX',
  Cb = 'CB',
  Credit = 'CREDIT',
  Digitiz = 'DIGITIZ',
  DigitizSubvention = 'DIGITIZ_SUBVENTION',
  Ecv = 'ECV',
  Edenred = 'EDENRED',
  Lunchr = 'LUNCHR',
  MealPlan = 'MEAL_PLAN',
  Nayax = 'NAYAX',
  Nu = 'NU',
  Odoo = 'ODOO',
  OrganizationCard = 'ORGANIZATION_CARD',
  Restoflash = 'RESTOFLASH',
  Ritual = 'RITUAL',
  Sepa = 'SEPA',
  Shift4 = 'SHIFT4',
  Subvention = 'SUBVENTION',
  Swile = 'SWILE',
  Trd = 'TRD',
  Vendon = 'VENDON'
}

export enum PaymentMethodProvider {
  Digitiz = 'digitiz',
  Edenred = 'edenred',
  Nayax = 'nayax',
  Nu = 'nu',
  Odoo = 'odoo',
  Paygreen = 'paygreen',
  PaygreenV3 = 'paygreenV3',
  Shift4 = 'shift4',
  Stripe = 'stripe',
  Swile = 'swile',
  Vendon = 'vendon'
}

export enum PaymentTimeType {
  EndOfMonth = 'endOfMonth',
  NumberOfDay = 'numberOfDay'
}

export enum PaymentType {
  Amex = 'AMEX',
  Cb = 'CB',
  Ecv = 'ECV',
  Edenred = 'EDENRED',
  Lunchr = 'LUNCHR',
  Restoflash = 'RESTOFLASH',
  Sepa = 'SEPA',
  Trd = 'TRD'
}

export type PermissionInput = {
  totemId?: InputMaybe<Scalars['String']['input']>;
  userGroup: UserPermission;
};

export type PhotoIssueTypeInput = {
  isBadQuality: Scalars['Boolean']['input'];
  isBadQuantity: Scalars['Boolean']['input'];
};

export enum PhotoIssueTypeKey {
  IsBadQuality = 'isBadQuality',
  IsBadQuantity = 'isBadQuantity'
}

export enum PhotoState {
  Pending = 'Pending',
  Refused = 'Refused',
  Validated = 'Validated'
}

export type PollAudienceInput = {
  organizationIds: Array<Scalars['ID']['input']>;
  siteIds: Array<Scalars['ID']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};

export type PollDateWindowInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type PollInput = {
  answerOptions: Array<Scalars['String']['input']>;
  audience: PollAudienceInput;
  dateWindow: PollDateWindowInput;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type PositionInShelfInput = {
  column: Scalars['Int']['input'];
  row: Scalars['Int']['input'];
};

export enum PredictionServiceStatus {
  Available = 'Available',
  Error = 'Error',
  Loading = 'Loading'
}

export enum PriceOptionType {
  CupPricing = 'CupPricing',
  DefaultPricing = 'DefaultPricing',
  MultiplePricing = 'MultiplePricing'
}

export enum PriceRangeType {
  Product = 'Product',
  ProductArrangement = 'ProductArrangement'
}

export type PriceTierInput = {
  thresholdMin?: InputMaybe<Scalars['Float']['input']>;
  unitPrice: Scalars['Float']['input'];
  unitPriceWithoutCup: Scalars['Float']['input'];
};

export type ProductAllergenInput = {
  canContain?: InputMaybe<Scalars['String']['input']>;
  celery: Scalars['Boolean']['input'];
  containsNoAllergens: Scalars['Boolean']['input'];
  crustaceans: Scalars['Boolean']['input'];
  eggs: Scalars['Boolean']['input'];
  fish: Scalars['Boolean']['input'];
  gluten: Scalars['Boolean']['input'];
  lupin: Scalars['Boolean']['input'];
  milk: Scalars['Boolean']['input'];
  molluscs: Scalars['Boolean']['input'];
  mustard: Scalars['Boolean']['input'];
  nuts: Scalars['Boolean']['input'];
  peanuts: Scalars['Boolean']['input'];
  sesame: Scalars['Boolean']['input'];
  soybeans: Scalars['Boolean']['input'];
  sulphites: Scalars['Boolean']['input'];
};

export type ProductArrangementPriceInput = {
  crossedPrice?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  productArrangementId: Scalars['ID']['input'];
};

export type ProductArrangementProductIdWithStockMaxUpdateInput = {
  productId: Scalars['String']['input'];
  stockMax: Scalars['Int']['input'];
};

export enum ProductArrangementReassortmentType {
  HotDrink = 'HotDrink',
  Manual = 'Manual',
  Target = 'Target',
  Tray = 'Tray'
}

export type ProductArrangementToUpdateInput = {
  currentProductId?: InputMaybe<Scalars['String']['input']>;
  newProductId?: InputMaybe<Scalars['String']['input']>;
  productArrangementId: Scalars['String']['input'];
  productArrangementIndex: Scalars['Int']['input'];
  rotationNumber: Scalars['Int']['input'];
};

export type ProductArrangementUpdateInput = {
  _id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productIdsWithStockMax: Array<ProductArrangementProductIdWithStockMaxUpdateInput>;
  reassortmentType: ProductArrangementReassortmentType;
};

export type ProductCreateCsvImport = {
  allergen?: InputMaybe<ProductAllergenInput>;
  allowNegativeStock?: InputMaybe<Scalars['Boolean']['input']>;
  badgeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  barcodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  conditionningTotem: Scalars['Int']['input'];
  deliveryDays?: InputMaybe<ProductDeliveryDaysInput>;
  description: Scalars['String']['input'];
  displayKg?: InputMaybe<Scalars['Boolean']['input']>;
  externalProductId?: InputMaybe<Scalars['String']['input']>;
  flow: Scalars['String']['input'];
  hasShortExpiryDate?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  indexDisplay?: InputMaybe<Scalars['Int']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  isBeingTested?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleCoil?: InputMaybe<Scalars['Boolean']['input']>;
  isFreefood?: InputMaybe<Scalars['Boolean']['input']>;
  isMicrostore?: InputMaybe<Scalars['Boolean']['input']>;
  isPunctual?: InputMaybe<Scalars['Boolean']['input']>;
  isScannable?: InputMaybe<Scalars['Boolean']['input']>;
  isTitreRestaurantAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isToBeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  minSupplierExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  minSupplierOrderQuantity?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nutriscore?: InputMaybe<Scalars['String']['input']>;
  nutrition?: InputMaybe<ProductNutritionInput>;
  portion: Scalars['Int']['input'];
  productPrices?: InputMaybe<Array<ProductRangePriceInput>>;
  scan: Scalars['Boolean']['input'];
  searchKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  shouldBeHiddenInStore?: InputMaybe<Scalars['Boolean']['input']>;
  stockThreshold?: InputMaybe<Scalars['Float']['input']>;
  stockThresholdMinimum?: InputMaybe<Scalars['Float']['input']>;
  subcategoryId?: InputMaybe<Scalars['ID']['input']>;
  suppliers: Array<ProductSupplierInput>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toleranceMax: Scalars['Int']['input'];
  toleranceMin: Scalars['Int']['input'];
  trackExpiryDate?: InputMaybe<Scalars['Boolean']['input']>;
  tva: Scalars['Float']['input'];
  volume: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightWithoutPackaging?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  zeroWasteProductTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductDeliveryDaysInput = {
  friday: Scalars['Boolean']['input'];
  monday: Scalars['Boolean']['input'];
  saturday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export enum ProductFlow {
  Bakery = 'bakery',
  Caterer = 'caterer',
  Dry = 'dry',
  Fresh = 'fresh',
  Fruit = 'fruit',
  Kumo = 'kumo'
}

export type ProductGroupCompositionEntryInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type ProductIdAndDeltaInput = {
  delta: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
};

export type ProductNutritionInput = {
  caloriesKCal?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates?: InputMaybe<Scalars['Float']['input']>;
  fibers?: InputMaybe<Scalars['Float']['input']>;
  protein?: InputMaybe<Scalars['Float']['input']>;
  sodium?: InputMaybe<Scalars['Float']['input']>;
  sturatedFat?: InputMaybe<Scalars['Float']['input']>;
  sugars?: InputMaybe<Scalars['Float']['input']>;
  totalFat?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductPriceInput = {
  crossedPrice?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  productId: Scalars['ID']['input'];
};

export type ProductQuantityInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type ProductRangePriceInput = {
  crossedPrice?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  rangeId: Scalars['ID']['input'];
  type: PriceRangeType;
};

export enum ProductReactionType {
  Blech = 'Blech',
  Like = 'Like',
  Love = 'Love',
  Meh = 'Meh'
}

export type ProductRecipeIngredientInput = {
  hotDrinksIngredientUnit: HotDrinksIngredientUnit;
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type ProductRecipeInput = {
  ingredients: Array<ProductRecipeIngredientInput>;
};

export enum ProductState {
  Archived = 'Archived',
  Created = 'Created',
  Regular = 'Regular'
}

export type ProductStockDetailInput = {
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type ProductSupplierInput = {
  _id: Scalars['ID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prices: Array<SupplierProductPriceInput>;
};

export type ProductSupplierUpdate = {
  _id: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  prices: Array<SupplierProductPriceInput>;
};

export type ProductSwitchCreateInput = {
  endDate: Scalars['String']['input'];
  productAId: Scalars['String']['input'];
  productBId: Scalars['String']['input'];
  ratioOfAToOrderForB: Scalars['Float']['input'];
  ratioToOrderOfA: Scalars['Float']['input'];
  startDate: Scalars['String']['input'];
  switchFreefood: Scalars['Boolean']['input'];
  switchStore: Scalars['Boolean']['input'];
};

export enum ProductSwitchState {
  Archived = 'Archived',
  Ongoing = 'Ongoing'
}

export type ProductSwitchUpdateInput = {
  _id: Scalars['ID']['input'];
  ratioOfAToOrderForB: Scalars['Float']['input'];
  ratioToOrderOfA: Scalars['Float']['input'];
  switchFreefood: Scalars['Boolean']['input'];
  switchStore: Scalars['Boolean']['input'];
};

export type ProductUpdateCsvAllergenInput = {
  celery: Scalars['Boolean']['input'];
  crustaceans: Scalars['Boolean']['input'];
  eggs: Scalars['Boolean']['input'];
  fish: Scalars['Boolean']['input'];
  gluten: Scalars['Boolean']['input'];
  lupin: Scalars['Boolean']['input'];
  milk: Scalars['Boolean']['input'];
  molluscs: Scalars['Boolean']['input'];
  mustard: Scalars['Boolean']['input'];
  nuts: Scalars['Boolean']['input'];
  peanuts: Scalars['Boolean']['input'];
  sesame: Scalars['Boolean']['input'];
  soybeans: Scalars['Boolean']['input'];
  sulphites: Scalars['Boolean']['input'];
};

export type ProductUpdateCsvImport = {
  _id: Scalars['ID']['input'];
  allergen?: InputMaybe<ProductUpdateCsvAllergenInput>;
  allergenCanContain?: InputMaybe<Scalars['String']['input']>;
  allowsNegativeStock?: InputMaybe<Scalars['Boolean']['input']>;
  badgeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  barcodes?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  conditionningTotem?: InputMaybe<Scalars['Int']['input']>;
  deliveryDays?: InputMaybe<ProductDeliveryDaysInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayKg?: InputMaybe<Scalars['Boolean']['input']>;
  externalProductId?: InputMaybe<Scalars['String']['input']>;
  flow?: InputMaybe<Scalars['String']['input']>;
  hasShortExpiryDate?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  indexDisplay?: InputMaybe<Scalars['Int']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  isBeingTested?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleCoil?: InputMaybe<Scalars['Boolean']['input']>;
  isFreefood?: InputMaybe<Scalars['Boolean']['input']>;
  isMicrostore?: InputMaybe<Scalars['Boolean']['input']>;
  isPunctual?: InputMaybe<Scalars['Boolean']['input']>;
  isScannable?: InputMaybe<Scalars['Boolean']['input']>;
  isTitreRestaurantAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isToBeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  minSupplierExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  minSupplierOrderQuantity?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nutriscore?: InputMaybe<Scalars['String']['input']>;
  nutrition?: InputMaybe<ProductNutritionInput>;
  onboardedForSensei?: InputMaybe<Scalars['Boolean']['input']>;
  portion?: InputMaybe<Scalars['Int']['input']>;
  productPrices?: InputMaybe<Array<ProductRangePriceInput>>;
  scan?: InputMaybe<Scalars['Boolean']['input']>;
  searchKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  shouldBeHiddenInStore?: InputMaybe<Scalars['Boolean']['input']>;
  stockThreshold?: InputMaybe<Scalars['Float']['input']>;
  stockThresholdMinimum?: InputMaybe<Scalars['Float']['input']>;
  subcategoryId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  supplierConditionning?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierPackagesPerBatch?: InputMaybe<Scalars['Int']['input']>;
  supplierPrice?: InputMaybe<Scalars['Float']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toleranceMax?: InputMaybe<Scalars['Float']['input']>;
  toleranceMin?: InputMaybe<Scalars['Float']['input']>;
  trackExpiryDate?: InputMaybe<Scalars['Boolean']['input']>;
  tva?: InputMaybe<Scalars['Float']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightWithoutPackaging?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  zeroWasteProductTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductUpdateInput = {
  access: Array<Scalars['String']['input']>;
  allergen: ProductAllergenInput;
  allowNegativeStock: Scalars['Boolean']['input'];
  barcodes: Array<BarcodeInput>;
  brand: Scalars['String']['input'];
  canExpire: Scalars['Boolean']['input'];
  categoryId: Scalars['String']['input'];
  checkSwollenLid: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  conditionningTotem: Scalars['Int']['input'];
  deliveryDays: ProductDeliveryDaysInput;
  description: Scalars['String']['input'];
  diets: Array<Scalars['ID']['input']>;
  displayKg: Scalars['Boolean']['input'];
  externalProductId?: InputMaybe<Scalars['String']['input']>;
  flow: ProductFlow;
  hasShortExpiryDate: Scalars['Boolean']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  indexDisplay: Scalars['Int']['input'];
  ingredients: Scalars['String']['input'];
  isBeingTested: Scalars['Boolean']['input'];
  isDoubleCoil: Scalars['Boolean']['input'];
  isFreefood: Scalars['Boolean']['input'];
  isFromNayax: Scalars['Boolean']['input'];
  isMicrostore: Scalars['Boolean']['input'];
  isPaused: Scalars['Boolean']['input'];
  isPunctual: Scalars['Boolean']['input'];
  isScannable: Scalars['Boolean']['input'];
  isTitreRestaurantAllowed: Scalars['Boolean']['input'];
  isToBeArchived: Scalars['Boolean']['input'];
  isWithoutStock: Scalars['Boolean']['input'];
  length?: InputMaybe<Scalars['Float']['input']>;
  minSupplierExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  minSupplierOrderQuantity?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  newUntil?: InputMaybe<Scalars['String']['input']>;
  nutriscore?: InputMaybe<Scalars['String']['input']>;
  nutrition: ProductNutritionInput;
  onboardedForSensei: Scalars['Boolean']['input'];
  packagingImage?: InputMaybe<Scalars['Upload']['input']>;
  portion: Scalars['Int']['input'];
  preferences: Array<Scalars['ID']['input']>;
  proportion?: InputMaybe<Scalars['Float']['input']>;
  proportionMax?: InputMaybe<Scalars['Float']['input']>;
  rangePrices: Array<ProductRangePriceInput>;
  recipe?: InputMaybe<ProductRecipeInput>;
  scan: Scalars['Boolean']['input'];
  searchKeywords: Array<Scalars['String']['input']>;
  shouldBeHiddenInStore: Scalars['Boolean']['input'];
  shouldOrderOnce: Scalars['Boolean']['input'];
  state: ProductState;
  stockThreshold?: InputMaybe<Scalars['Float']['input']>;
  stockThresholdMinimum?: InputMaybe<Scalars['Float']['input']>;
  subcategoryId?: InputMaybe<Scalars['ID']['input']>;
  supplierShortageInfo: ShortageTypeInput;
  suppliers: Array<ProductSupplierUpdate>;
  tagIds: Array<Scalars['String']['input']>;
  toleranceMax: Scalars['Int']['input'];
  toleranceMin: Scalars['Int']['input'];
  trackExpiryDate: Scalars['Boolean']['input'];
  tva: Scalars['Float']['input'];
  useInMenusFrom?: InputMaybe<Scalars['String']['input']>;
  volume: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightWithoutPackaging?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  zeroWasteProductTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductsStockInput = {
  availableStock: Scalars['Float']['input'];
  productId: Scalars['String']['input'];
};

export type QuantityHistoryInput = {
  createdAt: Scalars['GraphQLDate']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type QuantityVariationInput = {
  type: QuantityVariationType;
  value: Scalars['Int']['input'];
};

export enum QuantityVariationType {
  Percentage = 'Percentage',
  Unit = 'Unit'
}

export enum QuestRequirementType {
  Comment = 'Comment',
  CommentReaction = 'CommentReaction',
  NoPurchase = 'NoPurchase',
  ReactOnProduct = 'ReactOnProduct',
  TransactionMealPlan = 'TransactionMealPlan',
  TransactionMealPlanProductNeverBought = 'TransactionMealPlanProductNeverBought',
  TransactionMealPlanTagsAndBadges = 'TransactionMealPlanTagsAndBadges',
  TransactionProductDifferentCatalogSelectionsInARow = 'TransactionProductDifferentCatalogSelectionsInARow',
  TransactionProductDiscount = 'TransactionProductDiscount',
  TransactionProductDiscountInARow = 'TransactionProductDiscountInARow',
  TransactionProductDiscountStock1 = 'TransactionProductDiscountStock1',
  TransactionProductNeverBought = 'TransactionProductNeverBought',
  TransactionProductNew = 'TransactionProductNew',
  TransactionProductOnlyForYou = 'TransactionProductOnlyForYou',
  TransactionProductStock6 = 'TransactionProductStock6',
  TransactionProductStockBetween1And3 = 'TransactionProductStockBetween1And3',
  TransactionProductTagAndBadge = 'TransactionProductTagAndBadge',
  TransactionProductTagAndBadgeInARow = 'TransactionProductTagAndBadgeInARow',
  TransactionProductTagAndBadgeStock1 = 'TransactionProductTagAndBadgeStock1',
  TransactionSavedMoney = 'TransactionSavedMoney',
  VisitCatalog = 'VisitCatalog'
}

export enum QuestState {
  Completed = 'Completed',
  Ongoing = 'Ongoing'
}

export type QuizAnswerInput = {
  answerIndex?: InputMaybe<Scalars['Int']['input']>;
  questionIndex: Scalars['Int']['input'];
  score: Scalars['Int']['input'];
};

export type QuizAudienceInput = {
  organizationIds: Array<Scalars['ID']['input']>;
  siteIds: Array<Scalars['ID']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};

export type QuizInput = {
  audience: QuizAudienceInput;
  date: Scalars['String']['input'];
  description: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  questions: Array<QuizQuestionInput>;
  title: Scalars['String']['input'];
};

export type QuizQuestionInput = {
  answerOptions: Array<Scalars['String']['input']>;
  correctAnswerIndex: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export enum QuizState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type RangeCsvData = {
  price: Scalars['Float']['input'];
  productArrangementId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export enum ReassortmentFlow {
  DryAndFruit = 'DryAndFruit',
  Fresh = 'Fresh'
}

export type ReassortmentFreshFacingsByCategoriesInput = {
  dessert: Scalars['Int']['input'];
  main: Scalars['Int']['input'];
  smallBites: Scalars['Int']['input'];
  starter: Scalars['Int']['input'];
};

export type ReassortmentFreshFacingsByCategoriesInputOptionnal = {
  dessert?: InputMaybe<Scalars['Int']['input']>;
  main?: InputMaybe<Scalars['Int']['input']>;
  smallBites?: InputMaybe<Scalars['Int']['input']>;
  starter?: InputMaybe<Scalars['Int']['input']>;
};

export type ReassortmentStockByCategoriesInput = {
  dessert: Scalars['Int']['input'];
  main: Scalars['Int']['input'];
  smallBites: Scalars['Int']['input'];
  starter: Scalars['Int']['input'];
};

export type ReassortmentStockByCategoriesInputOptionnal = {
  dessert?: InputMaybe<Scalars['Int']['input']>;
  main?: InputMaybe<Scalars['Int']['input']>;
  smallBites?: InputMaybe<Scalars['Int']['input']>;
  starter?: InputMaybe<Scalars['Int']['input']>;
};

export type ReassortmentStockTargetRatiosInput = {
  friday: Scalars['Float']['input'];
  monday: Scalars['Float']['input'];
  thursday: Scalars['Float']['input'];
  tuesday: Scalars['Float']['input'];
  wednesday: Scalars['Float']['input'];
};

export type ReassortmentStockTargetRatiosInputOptionnal = {
  friday?: InputMaybe<Scalars['Float']['input']>;
  monday?: InputMaybe<Scalars['Float']['input']>;
  thursday?: InputMaybe<Scalars['Float']['input']>;
  tuesday?: InputMaybe<Scalars['Float']['input']>;
  wednesday?: InputMaybe<Scalars['Float']['input']>;
};

export type RemovedProductQuantityDetailInput = {
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type ReplaceMicrostoreColumnInput = {
  columnId: Scalars['ID']['input'];
  microstoreColumnTemplateId: Scalars['String']['input'];
  nayaxMDBTemplateId?: InputMaybe<Scalars['String']['input']>;
  replacementDate: Scalars['String']['input'];
};

export type ReplaceMicrostoreColumnTemplateInput = {
  columnId: Scalars['ID']['input'];
  newMicrostoreColumnTemplateId: Scalars['String']['input'];
};

export type ReplaceProductsInTemplatesInput = {
  itemToAdd: MicrostoreItemInput;
  itemToRemove: MicrostoreItemInput;
  microstoreColumnTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Equipment quote request from the authenticated freefood app (cf. Equipments). */
export type RequestEquipmentQuoteInput = {
  /** Equipment the customer wants a quote for. */
  equipmentId: Scalars['ID']['input'];
  /** Optional totem the request relates to, used to enrich the Slack notification. */
  totemId?: InputMaybe<Scalars['ID']['input']>;
};

export enum RitualGameType {
  Quiz = 'Quiz',
  Wanted = 'Wanted'
}

export type RitualParticipationInput = {
  messageIndex?: InputMaybe<Scalars['Int']['input']>;
  participationDate: Scalars['String']['input'];
  ritualId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum RitualRepetition {
  Punctual = 'Punctual',
  Weekly = 'Weekly'
}

export enum RitualState {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Created = 'Created',
  Regular = 'Regular'
}

export type RitualTimeWindowInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export enum RitualType {
  Custom = 'Custom',
  DiscountsPerProduct = 'DiscountsPerProduct',
  Game = 'Game',
  NewProducts = 'NewProducts',
  Regular = 'Regular'
}

export type RmeColumnInput = {
  microstoreColumnIds: Array<Scalars['ID']['input']>;
  minimumAmount: Scalars['Float']['input'];
  type: RmeColumnType;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export enum RmeColumnType {
  Revenue = 'revenue',
  Transactions = 'transactions'
}

export enum SetupInstructionState {
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export enum SetupInstructionType {
  CheckBoxTemperature = 'CheckBoxTemperature',
  CheckTemperature = 'CheckTemperature',
  HotDrinks = 'HotDrinks',
  InventoryComplete = 'InventoryComplete',
  InventoryCutlery = 'InventoryCutlery',
  InventoryDry = 'InventoryDry',
  InventorySmallExpiryDate = 'InventorySmallExpiryDate',
  InventoryZero = 'InventoryZero',
  ManualReassort = 'ManualReassort',
  Microwave = 'Microwave',
  MoveProducts = 'MoveProducts',
  Photos = 'Photos',
  PhotosStart = 'PhotosStart',
  RemoveProducts = 'RemoveProducts',
  StoreProducts = 'StoreProducts',
  TheftNotice = 'TheftNotice'
}

export enum SetupPhotoType {
  ColumnClosedDoorPhoto = 'ColumnClosedDoorPhoto',
  ColumnGroupPhoto = 'ColumnGroupPhoto',
  ColumnOpenDoorPhoto = 'ColumnOpenDoorPhoto',
  ColumnPhoto = 'ColumnPhoto',
  ColumnStartPhoto = 'ColumnStartPhoto',
  FreefoodBreakfast = 'FreefoodBreakfast',
  FreefoodCoffee = 'FreefoodCoffee',
  FreefoodColdDrink = 'FreefoodColdDrink',
  FreefoodDessert = 'FreefoodDessert',
  FreefoodFruit = 'FreefoodFruit',
  FreefoodGlobalPhoto = 'FreefoodGlobalPhoto',
  FreefoodIndividualSnacks = 'FreefoodIndividualSnacks',
  FreefoodMeal = 'FreefoodMeal',
  FreefoodSnacks = 'FreefoodSnacks',
  FreefoodStarter = 'FreefoodStarter',
  HotDrinksCleaning = 'HotDrinksCleaning',
  HotDrinksCleaningClosedDoor = 'HotDrinksCleaningClosedDoor',
  HotDrinksCleaningOpenDoor = 'HotDrinksCleaningOpenDoor',
  HotDrinksCleaningWasteWaterTray = 'HotDrinksCleaningWasteWaterTray',
  HotDrinksMachineWorking = 'HotDrinksMachineWorking',
  HotDrinksStartStocks = 'HotDrinksStartStocks',
  HotDrinksStartTanks = 'HotDrinksStartTanks',
  HotDrinksStocks = 'HotDrinksStocks',
  HotDrinksTanks = 'HotDrinksTanks',
  RemovedItemsPhoto = 'RemovedItemsPhoto'
}

export type SetupProductIssuesInput = {
  brokenDuringDeliveryQuantity: Scalars['Int']['input'];
  brokenOnSiteAfterInventoryQuantity: Scalars['Int']['input'];
  brokenOnSiteBeforeInventoryQuantity: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
  expiredDeliveredQuantity: Scalars['Int']['input'];
  expiredOnSiteAfterInventoryQuantity: Scalars['Int']['input'];
  expiredOnSiteBeforeInventoryQuantity: Scalars['Int']['input'];
  notEnoughPlaceQuantity: Scalars['Int']['input'];
  otherAfterInventoryOrDuringDeliveryQuantity: Scalars['Int']['input'];
  otherBeforeInventoryQuantity: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  unexpectedOnSiteQuantity: Scalars['Int']['input'];
  wrongQuantityDelivered: Scalars['Int']['input'];
};

export type SetupRemovedProductInput = {
  microstoreLocationIds: Array<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  quantityDetails: Array<RemovedProductQuantityDetailInput>;
};

export type ShortageTypeInput = {
  inShortage: Scalars['Boolean']['input'];
  returnDate?: InputMaybe<Scalars['String']['input']>;
};

export type SignupInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gclid?: InputMaybe<Scalars['String']['input']>;
  jobTitle: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  userReferrerId?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type SiteClosingDatesRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export enum SiteContractType {
  FreeDeposit = 'FreeDeposit',
  Subscription = 'Subscription'
}

export type SiteDeliveryTimeWindowInputOptionnal = {
  start?: InputMaybe<Scalars['String']['input']>;
  stop?: InputMaybe<Scalars['String']['input']>;
};

export enum SiteDeliveryType {
  MicrostoreDelivery = 'MicrostoreDelivery',
  PackageDelivery = 'PackageDelivery',
  RefrigeratedTruckDelivery = 'RefrigeratedTruckDelivery',
  WarehouseDelivery = 'WarehouseDelivery'
}

export type SiteExternalInventoryProduct = {
  productId: Scalars['String']['input'];
  stock: Scalars['Int']['input'];
};

export enum SiteInventoryState {
  Aborted = 'Aborted',
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export type SiteMetadataInput = {
  needsCleaningMachineNECTA: Array<EvenOddWeekMetadataInput>;
  needsInventoryBoissons: Array<EvenOddWeekMetadataInput>;
  needsInventoryNonAlimentaire: Array<EvenOddWeekMetadataInput>;
  needsInventorySnack: Array<EvenOddWeekMetadataInput>;
  needsPunctualExpiryDateInventory: Array<EvenOddWeekMetadataInput>;
  needsSmallExpiryDateInventory: Array<EvenOddWeekMetadataInput>;
  replaceCompleteInventoryByZeroInventory: Array<EvenOddWeekMetadataInput>;
};

export type SiteMetadataInputOptionnal = {
  needsCleaningMachineNECTA?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  needsInventoryBoissons?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  needsInventoryNonAlimentaire?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  needsInventorySnack?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  needsPunctualExpiryDateInventory?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  needsSmallExpiryDateInventory?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  replaceCompleteInventoryByZeroInventory?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
};

export type SiteProductsFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  flow?: InputMaybe<Array<ProductFlow>>;
  infos?: InputMaybe<Array<InfoType>>;
  isFreefood?: InputMaybe<Scalars['Boolean']['input']>;
  isMicrostore?: InputMaybe<Scalars['Boolean']['input']>;
  isToBeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutStock?: InputMaybe<Scalars['Boolean']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProductState>>;
  subcategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  suppliers?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SiteSetupState {
  Aborted = 'Aborted',
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export enum SiteState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum SiteType {
  BrokenProductsWarehouse = 'BrokenProductsWarehouse',
  ExpiredProductsWarehouse = 'ExpiredProductsWarehouse',
  Microstore = 'Microstore',
  Warehouse = 'Warehouse'
}

export type SiteUpdateCsvImport = {
  B2CPriceRange?: InputMaybe<Scalars['ID']['input']>;
  _id: Scalars['ID']['input'];
  accessTime?: InputMaybe<Scalars['Int']['input']>;
  deliveryDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  deliveryTimeWindow?: InputMaybe<SiteDeliveryTimeWindowInputOptionnal>;
  deliveryType?: InputMaybe<SiteDeliveryType>;
  dryReassortDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  estimatedUserCount?: InputMaybe<Scalars['Int']['input']>;
  freshReassortDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  hasCoffee?: InputMaybe<Scalars['Boolean']['input']>;
  hasExternalSetupProcess?: InputMaybe<Scalars['Boolean']['input']>;
  hasSensei?: InputMaybe<Scalars['Boolean']['input']>;
  isSecured?: InputMaybe<Scalars['Boolean']['input']>;
  launchDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reassortmentFreshFacings?: InputMaybe<ReassortmentFreshFacingsByCategoriesInputOptionnal>;
  reassortmentOnboardingStockTargets?: InputMaybe<ReassortmentStockByCategoriesInputOptionnal>;
  reassortmentStockTargetRatios?: InputMaybe<ReassortmentStockTargetRatiosInputOptionnal>;
  reassortmentStockTargets?: InputMaybe<ReassortmentStockByCategoriesInputOptionnal>;
  removalDate?: InputMaybe<Scalars['String']['input']>;
  shouldAutomaticallyCreateManualReassortment?: InputMaybe<Scalars['Boolean']['input']>;
  shouldAutomaticallyCreateTargetReassortment?: InputMaybe<Scalars['Boolean']['input']>;
  shouldAutomaticallyFinishSiteSetup?: InputMaybe<Scalars['Boolean']['input']>;
  shouldHaveTheftNotice?: InputMaybe<Scalars['Boolean']['input']>;
  shouldModulateForExpired?: InputMaybe<Scalars['Boolean']['input']>;
  shouldModulateForUnknownLosses?: InputMaybe<Scalars['Boolean']['input']>;
  shouldOperateOnTotops?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<SiteType>;
  unknownShrinkageBillingThreshold?: InputMaybe<Scalars['Int']['input']>;
  urbantzMetadata?: InputMaybe<SiteMetadataInputOptionnal>;
  useNayaxCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SitesFilterInput = {
  B2CPriceRange?: InputMaybe<Scalars['String']['input']>;
  avaClientId?: InputMaybe<Scalars['Int']['input']>;
  avaSiteId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  deliveryDayFriday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDayMonday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDaySaturday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDaySunday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDayThursday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDayTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDayWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryType?: InputMaybe<Array<SiteDeliveryType>>;
  estimatedUserCount?: InputMaybe<Scalars['Int']['input']>;
  hasCoffee?: InputMaybe<Scalars['Boolean']['input']>;
  hasExternalSetupProcess?: InputMaybe<Scalars['Boolean']['input']>;
  hasSensei?: InputMaybe<Scalars['Boolean']['input']>;
  isOpenOnWeekend?: InputMaybe<Scalars['Boolean']['input']>;
  isSecured?: InputMaybe<Scalars['Boolean']['input']>;
  launchDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  removalDate?: InputMaybe<Scalars['String']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  shouldAutomaticallyCreateManualReassortment?: InputMaybe<Scalars['Boolean']['input']>;
  shouldAutomaticallyCreateTargetReassortment?: InputMaybe<Scalars['Boolean']['input']>;
  shouldAutomaticallyFinishSiteSetup?: InputMaybe<Scalars['Boolean']['input']>;
  shouldModulateForExpired?: InputMaybe<Scalars['Boolean']['input']>;
  shouldModulateForUnknownLosses?: InputMaybe<Scalars['Boolean']['input']>;
  shouldOperateOnTotops?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Array<SiteState>>;
  type?: InputMaybe<Array<SiteType>>;
  unknownShrinkageBillingThreshold?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  useNayaxCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StockTransferExpiryDateInput = {
  date: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type StockTransferProductInput = {
  expiryDates: Array<StockTransferExpiryDateInput>;
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export enum StockTransferState {
  Aborted = 'Aborted',
  Created = 'Created',
  Validated = 'Validated'
}

export type StockTransfersFilterInput = {
  createdAt?: InputMaybe<DateFilter>;
  destinationColumnName?: InputMaybe<Scalars['String']['input']>;
  isForReassortment?: InputMaybe<Scalars['Boolean']['input']>;
  originColumnName?: InputMaybe<Scalars['String']['input']>;
  reassortmentFlow?: InputMaybe<Array<ReassortmentFlow>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  shouldUpdateStockImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<StockTransferState>>;
  transferDate?: InputMaybe<DateFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type StockVariationInput = {
  delta: Scalars['Int']['input'];
  explanation?: InputMaybe<Scalars['String']['input']>;
  type: StockVariationType;
};

export enum StockVariationType {
  Donated = 'Donated',
  KnownLossesBroken = 'KnownLossesBroken',
  KnownLossesDlc = 'KnownLossesDLC',
  KnownSales = 'KnownSales',
  MicrostoreReassort = 'MicrostoreReassort',
  MicrostoreWarehouseReturn = 'MicrostoreWarehouseReturn',
  NotDelivered = 'NotDelivered',
  NotPrepared = 'NotPrepared',
  Prepared = 'Prepared',
  PreparedProductReset = 'PreparedProductReset',
  Reappearing = 'Reappearing',
  Refund = 'Refund',
  StockTransfert = 'StockTransfert',
  SupplierRefund = 'SupplierRefund',
  Transaction = 'Transaction',
  TrayReassort = 'TrayReassort',
  UnknownLosses = 'UnknownLosses',
  UnknownLossesSolved = 'UnknownLossesSolved',
  UnknownSales = 'UnknownSales',
  UnknownSalesSolved = 'UnknownSalesSolved',
  WarehouseAdditionalDeliveryInRack = 'WarehouseAdditionalDeliveryInRack',
  WarehouseBundleAborted = 'WarehouseBundleAborted',
  WarehouseInBox = 'WarehouseInBox',
  WarehouseInRack = 'WarehouseInRack'
}

export type SubcategoryInput = {
  displayIndex: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  state: SubcategoryState;
};

export enum SubcategoryState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum SubventionReloadPeriod {
  Daily = 'daily',
  Monthly = 'monthly',
  PerPurchase = 'perPurchase',
  Weekly = 'weekly'
}

export type SupplierClosingDatesRangeInput = {
  closingDate: Scalars['String']['input'];
  openingDate: Scalars['String']['input'];
};

export type SupplierContactInput = {
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};

export enum SupplierDiscountState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type SupplierFormInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientCode?: InputMaybe<Scalars['String']['input']>;
  closingDatesRanges: Array<SupplierClosingDatesRangeInput>;
  contacts: Array<SupplierContactInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  frequency: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  nextOrderingDate?: InputMaybe<Scalars['String']['input']>;
  orderEmails: Array<Scalars['String']['input']>;
  orderMode: OrderMode;
  orderPlatformUrl?: InputMaybe<Scalars['String']['input']>;
  orderingProductTerms: Array<OrderingProductTermInput>;
  orderingTerms: Array<OrderingTermInput>;
  orderingTimes: SupplierOrderingTimesInput;
  paymentTimeDays?: InputMaybe<Scalars['Int']['input']>;
  paymentTimeType: PaymentTimeType;
  paymentType: SupplierPaymentType;
  phone?: InputMaybe<Scalars['String']['input']>;
  shouldCheckReceptionDayIsNotClosed: Scalars['Boolean']['input'];
  shouldOrderAutomatically: Scalars['Boolean']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierOrderingTimesInput = {
  friday: OrderingTimeForDayInput;
  monday: OrderingTimeForDayInput;
  saturday: OrderingTimeForDayInput;
  sunday: OrderingTimeForDayInput;
  thursday: OrderingTimeForDayInput;
  tuesday: OrderingTimeForDayInput;
  wednesday: OrderingTimeForDayInput;
};

export type SupplierPartnershipCreateInput = {
  budget: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type SupplierPartnershipUpdateInput = {
  _id: Scalars['ID']['input'];
  budget: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']>;
  startDate: Scalars['String']['input'];
};

export enum SupplierPaymentType {
  BankTransfer = 'BankTransfer',
  CreditCard = 'CreditCard',
  PrelevementLcrbnp = 'PrelevementLCRBNP',
  SepaDirectDebit = 'SEPADirectDebit'
}

export type SupplierProductPriceInput = {
  conditionning: Scalars['Float']['input'];
  packagesPerBatch: Scalars['Float']['input'];
  value: Scalars['Float']['input'];
};

export enum SupplierState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type SupplyOrderDeclareIssueInput = {
  barcode: Scalars['String']['input'];
  brokenQuantity: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  receivedPackaging: Scalars['Int']['input'];
  receivedParcels: Scalars['Int']['input'];
  type: SupplyOrderProductIssueType;
};

export type SupplyOrderIdWithReasonsForAborting = {
  stateChangeReasons: Array<Scalars['String']['input']>;
  supplyOrderId: Scalars['ID']['input'];
};

export type SupplyOrderProductDetailInput = {
  brokenItems: Scalars['Int']['input'];
  colis: Scalars['Int']['input'];
  conditionning: Scalars['Int']['input'];
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export enum SupplyOrderProductIssueType {
  BadExpiryDate = 'BadExpiryDate',
  BrokenQuantity = 'BrokenQuantity',
  DifferentPackaging = 'DifferentPackaging',
  DifferentQuantity = 'DifferentQuantity',
  NewBarcode = 'NewBarcode',
  NotReceived = 'NotReceived',
  UnknownProduct = 'UnknownProduct',
  WrongProduct = 'WrongProduct'
}

export type SupplyOrderProductUpdateInput = {
  _id: Scalars['ID']['input'];
  colis: Scalars['Float']['input'];
  conditionning: Scalars['Int']['input'];
  confirmedQuantity?: InputMaybe<Scalars['Int']['input']>;
  confirmedQuantityHistory: Array<QuantityHistoryInput>;
  fullname: Scalars['String']['input'];
  name: Scalars['String']['input'];
  packagesPerBatch: Scalars['Int']['input'];
  price: Scalars['Float']['input'];
  productReceivedDetails: Array<SupplyOrderProductDetailInput>;
  quantity: Scalars['Float']['input'];
  quantityGenerated: Scalars['Int']['input'];
  quantityGeneratedExtended: Scalars['Int']['input'];
  quantityGeneratedForMenus: Scalars['Int']['input'];
  storedAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  tva: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type SupplyOrderReceivedProductDetails = {
  productId: Scalars['String']['input'];
  productReceivedDetails: Array<SupplyOrderProductDetailInput>;
};

export enum SupplyOrderState {
  Aborted = 'Aborted',
  Checked = 'Checked',
  Confirmed = 'Confirmed',
  Created = 'Created',
  InRack = 'InRack',
  OnHold = 'OnHold',
  Ordered = 'Ordered',
  Ready = 'Ready',
  Received = 'Received'
}

export type SupplyOrderUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dateDelivery?: InputMaybe<Scalars['String']['input']>;
  dateDeliveryScheduled?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hourDelivery?: InputMaybe<Scalars['String']['input']>;
  nextOrderDate?: InputMaybe<Scalars['String']['input']>;
  orderDate?: InputMaybe<Scalars['String']['input']>;
  priceHTInvoice?: InputMaybe<Scalars['Float']['input']>;
  priceTTCInvoice?: InputMaybe<Scalars['Float']['input']>;
  products: Array<SupplyOrderProductUpdateInput>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  weeklyMenusStartDate?: InputMaybe<Scalars['String']['input']>;
};

export enum TagState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum TagType {
  Jow = 'jow',
  Principal = 'principal'
}

export enum TaskPhotoType {
  TaskPhoto = 'TaskPhoto',
  TaskStartPhoto = 'TaskStartPhoto'
}

export enum TaskState {
  Aborted = 'Aborted',
  Created = 'Created',
  Failed = 'Failed',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export enum TaskType {
  Audit = 'Audit',
  BoxPickup = 'BoxPickup',
  Other = 'Other',
  SpecificWork = 'SpecificWork',
  Ticket = 'Ticket'
}

export enum TemperatureMeasureType {
  Caterer = 'Caterer',
  Fresh = 'Fresh',
  Fruit = 'Fruit',
  Kumo = 'Kumo'
}

export type ThermometerCalibrationMeasureInput = {
  isOperationnal: Scalars['Boolean']['input'];
  temperature: Scalars['Float']['input'];
  thermometerId: Scalars['String']['input'];
};

export type ThermometerUpdateInput = {
  _id: Scalars['ID']['input'];
  associatedUserId?: InputMaybe<Scalars['ID']['input']>;
  isOperational: Scalars['Boolean']['input'];
};

export type ThermometersCalibrationCreateInput = {
  calibrationMeasures: Array<ThermometerCalibrationMeasureInput>;
  temperatureReference: Scalars['Float']['input'];
};

export enum TopUpOption {
  Fifty = 'Fifty',
  Ninety = 'Ninety',
  Ten = 'Ten',
  Twenty = 'Twenty'
}

export enum TotanimalFamily {
  Curious = 'Curious',
  Smart = 'Smart',
  Wise = 'Wise'
}

export enum TotanimalState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum TotanimalType {
  Bird = 'Bird',
  Chameleon = 'Chameleon',
  Flamingo = 'Flamingo',
  Fox = 'Fox',
  Frog = 'Frog',
  Giraffe = 'Giraffe',
  Lion = 'Lion',
  Monkey = 'Monkey',
  Moose = 'Moose',
  Panda = 'Panda',
  Penguin = 'Penguin',
  Raccoon = 'Raccoon',
  Rat = 'Rat',
  Toucan = 'Toucan',
  Turtle = 'Turtle'
}

export enum TotemClosedDayState {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum TotemClosedDayType {
  BankHoliday = 'BankHoliday',
  Other = 'Other'
}

export enum TotemClosedReceptionDayState {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Regular = 'Regular'
}

export type TotemEquipmentInput = {
  comment: Scalars['String']['input'];
  equipmentId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export enum TotemState {
  Archived = 'Archived',
  Rollout = 'Rollout'
}

export enum TotemType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type TotemUpdateInput = {
  accessTime: Scalars['Int']['input'];
  address: Scalars['String']['input'];
  address_details: Scalars['String']['input'];
  city: Scalars['String']['input'];
  consigneDelivery: Scalars['String']['input'];
  country: Scalars['String']['input'];
  equipments: Array<TotemEquipmentInput>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  mainUserId: Scalars['String']['input'];
  minimumOrderAmountInfo: MinimumOrderAmountInfoInput;
  name: Scalars['String']['input'];
  needSignature: Scalars['Boolean']['input'];
  zipcode: Scalars['String']['input'];
};

export type TotemsFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<TotemState>>;
};

export enum TourState {
  Archived = 'Archived',
  Created = 'Created',
  Finished = 'Finished',
  InDelivery = 'InDelivery',
  Ready = 'Ready'
}

export type TourStopInput = {
  stopId: Scalars['ID']['input'];
  type: TourStopType;
};

export enum TourStopType {
  Delivery = 'Delivery',
  Task = 'Task'
}

export enum TransactionState {
  Canceled = 'Canceled',
  Failed = 'Failed',
  Paid = 'Paid',
  Pending = 'Pending',
  Processing = 'Processing',
  Refunded = 'Refunded'
}

export enum TransactionType {
  Freefood = 'freefood',
  Microstore = 'microstore'
}

export type TransactionsFilterInput = {
  columnName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateFilter>;
  priceHT?: InputMaybe<NumberFilter>;
  provider?: InputMaybe<Array<PaymentMethodProvider>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<TransactionState>>;
  updatedAt?: InputMaybe<DateFilter>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type TransferCsvData = {
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBadgeInput = {
  _id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BadgeType>;
};

export type UpdateDeliveryZoneInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  referentDelivererId?: InputMaybe<Scalars['ID']['input']>;
  state: DeliveryZoneState;
};

export type UpdateMessagesSetInput = {
  messages: Array<MessageInput>;
  name: Scalars['String']['input'];
  state: MessagesSetState;
};

export type UpdateMicrostoreColumnGroupInput = {
  avaSalePlaceLocationId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  positionInSite: Scalars['Int']['input'];
};

export type UpdateMobilePopupInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startsAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyDeliveriesStateInput = {
  arrivedAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  deliveryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isForced?: InputMaybe<Scalars['Boolean']['input']>;
  state: DeliveryState;
};

export type UpdateNayaxMdbTemplateInput = {
  associations?: InputMaybe<Array<NayaxMdbTemplateAssociationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRitualInput = {
  activeDate?: InputMaybe<Scalars['String']['input']>;
  activeWeekdays?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  associatedDiscount?: InputMaybe<Scalars['Float']['input']>;
  billToOrganizationId?: InputMaybe<Scalars['String']['input']>;
  expiringProductsOnly: Scalars['Boolean']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  messagesSetId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  repetition: RitualRepetition;
  requiresParticipation: Scalars['Boolean']['input'];
  resetsBetweenPurchases: Scalars['Boolean']['input'];
  restrictedBadgeIds: Array<Scalars['String']['input']>;
  restrictedCategoryIds: Array<Scalars['String']['input']>;
  restrictedOrganizationIds: Array<Scalars['String']['input']>;
  restrictedProductIds: Array<Scalars['String']['input']>;
  restrictedSiteIds: Array<Scalars['String']['input']>;
  restrictedSubcategoryIds: Array<Scalars['ID']['input']>;
  restrictedTagIds: Array<Scalars['String']['input']>;
  restrictedUserIds: Array<Scalars['String']['input']>;
  supplierPartnershipId?: InputMaybe<Scalars['String']['input']>;
  timeWindow: RitualTimeWindowInput;
};

export type UpdateSubventionInput = {
  archivedAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  billToOrganizationId?: InputMaybe<Scalars['String']['input']>;
  categories: Array<InputMaybe<Scalars['ID']['input']>>;
  coverageRate?: InputMaybe<Scalars['Float']['input']>;
  cumulative?: InputMaybe<Scalars['Boolean']['input']>;
  currentAmount?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  hoursIntervalsAvailable: Array<Array<Scalars['String']['input']>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reload?: InputMaybe<SubventionReloadPeriod>;
};

export type UpdateSupplierDiscountInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseEndDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  purchaseStartDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  salesEndDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  salesStartDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type UpdateTagInput = {
  _id: Scalars['String']['input'];
  displayIndex: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  state: TagState;
  type: TagType;
};

export type UpdateTaskInput = {
  birthdayDate: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  description: Scalars['String']['input'];
  instructions: Array<Scalars['String']['input']>;
  state: TaskState;
  type: TaskType;
};

export type UpdateTourInput = {
  deliveryPersonUserId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  stops: Array<TourStopInput>;
};

export type UrbantzRoundPresetUpdateInput = {
  _id: Scalars['ID']['input'];
  totemIds: Array<Scalars['String']['input']>;
};

export type UserEmailInput = {
  address: Scalars['String']['input'];
};

export enum UserPermission {
  Admin = 'Admin',
  Analyst = 'Analyst',
  Deliverer = 'Deliverer',
  Editor = 'Editor',
  Employee = 'Employee',
  ExternalDeliverer = 'ExternalDeliverer',
  Preparer = 'Preparer',
  Toteam = 'Toteam',
  Totech = 'Totech',
  Totest = 'Totest'
}

export enum UserSource {
  Digitiz = 'Digitiz',
  Nayax = 'Nayax',
  Nu = 'Nu',
  Odoo = 'Odoo',
  Sensei = 'Sensei',
  Totem = 'Totem'
}

export enum UserState {
  AddedToTeam = 'AddedToTeam',
  Archived = 'Archived',
  Banned = 'Banned',
  Created = 'Created',
  Deleted = 'Deleted',
  OnBoarding = 'OnBoarding',
  Regular = 'Regular'
}

export type UserUpdateInput = {
  defaultTruckColumnId?: InputMaybe<Scalars['ID']['input']>;
  emails: Array<UserEmailInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  permissions: Array<PermissionInput>;
  state: UserState;
  userGroupIds: Array<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  visitedSites: Array<VisitedSiteInput>;
};

export type UsersFilterInput = {
  createdAt?: InputMaybe<DateFilter>;
  hasDevicePushToken?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaygreenCustomerId?: InputMaybe<Scalars['Boolean']['input']>;
  hasStripeCustomerId?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeenAt?: InputMaybe<DateFilter>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<UserPermission>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<UserSource>>;
  states?: InputMaybe<Array<UserState>>;
};

export type ValidateHotDrinksInput = {
  hasCleanedCollectingTray: Scalars['Boolean']['input'];
  hasCleanedMachine: Scalars['Boolean']['input'];
  hasRemovedCoffeeGround: Scalars['Boolean']['input'];
  hasReplenishedConsumables: Scalars['Boolean']['input'];
  hasReplenishedTanks: Scalars['Boolean']['input'];
  hasRinsedMachine: Scalars['Boolean']['input'];
  isMachineWorking: Scalars['Boolean']['input'];
  locations: Array<HotDrinksLocationInput>;
  setupInstructionId: Scalars['ID']['input'];
};

export type VisitedSiteInput = {
  _id: Scalars['ID']['input'];
  visitedAt: Scalars['GraphQLDate']['input'];
};

export type WarehouseDeliveryInput = {
  deliveryDate: Scalars['String']['input'];
};

export type WarehouseDeliveryProductInput = {
  packagesPicked: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
};

export enum WarehouseReturnState {
  Created = 'Created',
  Delivered = 'Delivered',
  InProgress = 'InProgress',
  Stored = 'Stored'
}

export type AdvertisementScreenConfigFragmentFragment = { __typename?: 'AdvertisementScreenConfig', _id: string, imageUrls: Array<string> };

export type AddPatchFragmentFragment = { __typename?: 'AddPatch', op: PatchOp, path: string, value?: any | null };

export type ReplacePatchFragmentFragment = { __typename?: 'ReplacePatch', op: PatchOp, path: string, value?: any | null, oldValue?: any | null };

export type RemovePatchFragmentFragment = { __typename?: 'RemovePatch', op: PatchOp, path: string, oldValue?: any | null };

export type MovePatchFragmentFragment = { __typename?: 'MovePatch', op: PatchOp, path: string, from: string };

export type CopyPatchFragmentFragment = { __typename?: 'CopyPatch', op: PatchOp, path: string, from: string };

export type TestPatchFragmentFragment = { __typename?: 'TestPatch', op: PatchOp, path: string, value?: any | null };

type AuditLogPatchFragmentAddPatchFragment = { __typename?: 'AddPatch', op: PatchOp, path: string, value?: any | null };

type AuditLogPatchFragmentCopyPatchFragment = { __typename?: 'CopyPatch', op: PatchOp, path: string, from: string };

type AuditLogPatchFragmentMovePatchFragment = { __typename?: 'MovePatch', op: PatchOp, path: string, from: string };

type AuditLogPatchFragmentRemovePatchFragment = { __typename?: 'RemovePatch', op: PatchOp, path: string, oldValue?: any | null };

type AuditLogPatchFragmentReplacePatchFragment = { __typename?: 'ReplacePatch', op: PatchOp, path: string, value?: any | null, oldValue?: any | null };

type AuditLogPatchFragmentTestPatchFragment = { __typename?: 'TestPatch', op: PatchOp, path: string, value?: any | null };

export type AuditLogPatchFragmentFragment = AuditLogPatchFragmentAddPatchFragment | AuditLogPatchFragmentCopyPatchFragment | AuditLogPatchFragmentMovePatchFragment | AuditLogPatchFragmentRemovePatchFragment | AuditLogPatchFragmentReplacePatchFragment | AuditLogPatchFragmentTestPatchFragment;

export type AuditLogFragmentFragment = { __typename?: 'AuditLog', _id: string, createdAt: number, updatedAt: number, createdBy: string, createdByName: string, collectionName: string, collectionDocumentId: string, patches: Array<{ __typename?: 'AddPatch', op: PatchOp, path: string, value?: any | null } | { __typename?: 'CopyPatch', op: PatchOp, path: string, from: string } | { __typename?: 'MovePatch', op: PatchOp, path: string, from: string } | { __typename?: 'RemovePatch', op: PatchOp, path: string, oldValue?: any | null } | { __typename?: 'ReplacePatch', op: PatchOp, path: string, value?: any | null, oldValue?: any | null } | { __typename?: 'TestPatch', op: PatchOp, path: string, value?: any | null }> };

export type BoxFragmentFragment = { __typename?: 'Box', _id: string, bundleId?: string | null, state: BoxState, label: string, number: number, code?: string | null, deliveryCode: string, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null, column?: { __typename?: 'Column', name: string, fullname: string, type: ColumnType } | null, products: Array<{ __typename?: 'BoxProduct', _id: string, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, boxId?: string | null, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }> };

export type BundleFragmentFragment = { __typename?: 'Bundle', _id: string, createdAt: number, scheduledPreparationDate: string, number: number, numberOfReferences: number, numberOfUnits: number, operatorName?: string | null, preparationDuration?: number | null, state: BundleState, type: ProductFlow, containerType: ContainerType, boxes: Array<{ __typename?: 'Box', _id: string, deliveryId: string, deliveryCode: string, siteName?: string | null, totemId?: string | null, hasOnsiteSetup: boolean, label: string, orderId?: string | null, position?: number | null, roundColor: string, roundName: string, code?: string | null, products: Array<{ __typename?: 'BoxProduct', _id: string, boxId?: string | null }>, column?: { __typename?: 'Column', fullname: string, name: string, type: ColumnType } | null }>, preparationDates: { __typename?: 'PreparationDates', start?: string | null, end?: string | null }, stateHistory: Array<{ __typename?: 'BundleStateHistory', state: BundleState, createdAt: number, createdByName?: string | null }>, warehouseColumn: { __typename?: 'Column', _id: string, name: string } };

export type BundleWithBoxesFragmentFragment = { __typename?: 'Bundle', _id: string, createdAt: number, scheduledPreparationDate: string, number: number, numberOfReferences: number, numberOfUnits: number, operatorName?: string | null, preparationDuration?: number | null, state: BundleState, type: ProductFlow, containerType: ContainerType, boxes: Array<{ __typename?: 'Box', _id: string, deliveryId: string, deliveryCode: string, siteName?: string | null, totemId?: string | null, hasOnsiteSetup: boolean, label: string, orderId?: string | null, position?: number | null, roundColor: string, roundName: string, code?: string | null, bundleId?: string | null, state: BoxState, number: number, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, products: Array<{ __typename?: 'BoxProduct', _id: string, boxId?: string | null, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }>, column?: { __typename?: 'Column', fullname: string, name: string, type: ColumnType } | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null }>, preparationDates: { __typename?: 'PreparationDates', start?: string | null, end?: string | null }, stateHistory: Array<{ __typename?: 'BundleStateHistory', state: BundleState, createdAt: number, createdByName?: string | null }>, warehouseColumn: { __typename?: 'Column', _id: string, name: string } };

export type CategoryFragmentFragment = { __typename?: 'Category', _id: string, createdAt: number, updatedAt: number, indexDisplay: number, isFreefood: boolean, isMicrostore: boolean, isPunctual: boolean, imageUrl?: string | null, shouldShowSubcategories: boolean, state: CategoryState, title: string, stateHistory: Array<{ __typename?: 'CategoryStateHistory', state: CategoryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }> };

export type ColumnFragmentFragment = { __typename?: 'Column', _id: string, name: string, fullname: string, siteId: string, type: ColumnType, state: MicrostoreElementState, createdAt: number, updatedAt: number, site: { __typename?: 'Site', _id: string, name: string }, stockSummary: { __typename?: 'ColumnStockSummary', productsCount: number, totalStock: number, merchantValuation: number } };

export type ColumnProductFragment = { __typename?: 'ColumnProduct', productId: string, targetStock: number, stock: number, product: { __typename?: 'Product', _id: string, fullname: string, state: ProductState, flow: ProductFlow }, lastColumnInventoryStock: { __typename?: 'ColumnInventoryStock', _id: string, value: number, createdAt: number, createdBy?: string | null, createdByName?: string | null }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number, details?: { __typename?: 'AvailableStockDetails', dailyStocks: Array<number>, orderedStocks: Array<number>, realRecurringOrders: Array<number>, predictionRecurringOrders: Array<number>, realPunctualOrders: Array<number>, predictionPunctualOrders: Array<number>, realStoreTargetNotPrepared: Array<number>, realStoreTargetPrepared: Array<number>, predictionStoreTarget: Array<number>, storeMenu: Array<number>, preparationDate: string, preparationDateUsedIndex: number, soonestRestockedDate?: string | null, soonestRestockedDateUsedIndex: number, usedRecurringOrders: Array<number>, usedPunctualOrders: Array<number>, usedStoreTarget: Array<number>, usedStoreMenu: Array<number> } | null }, variations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null, columnInventoryStockId: string }>, inventories: Array<{ __typename?: 'ColumnInventoryStock', _id: string, createdAt: number, createdBy?: string | null, createdByName?: string | null, type: ColumnInventoryStockType, value: number, previousColumnInventoryStockId?: string | null, modifierId?: string | null }> };

export type ColumnProductLightFragment = { __typename?: 'ColumnProduct', productId: string, targetStock: number, stock: number, merchantValuation: number, product: { __typename?: 'Product', _id: string, fullname: string, state: ProductState, flow: ProductFlow }, lastColumnInventoryStock: { __typename?: 'ColumnInventoryStock', _id: string, value: number, createdAt: number }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number }, latestStockVariations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null, columnInventoryStockId: string }> };

export type CommentFragmentFragment = { __typename?: 'Comment', _id: string, body: string, createdAt: number, updatedAt: number, user: { __typename?: 'PublicProfile', _id: string, label: string }, product?: { __typename?: 'Product', _id: string, name: string } | null };

export type ConsumptionVariationFragmentFragment = { __typename?: 'ConsumptionVariation', _id: string, createdAt: number, endDate: string, siteId: string, startDate: string, updatedAt: number, dessert: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, main: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, smallBites: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, starter: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number } };

export type ControlPhotoFragmentFragment = { __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null };

export type PreviewCreditFragmentFragment = { __typename?: 'Credit', _id: string, createdAt: number, updatedAt: number, name: string, initialAmount: number, currentAmount: number, expirationDate: number, startDate: number, type: CreditType, refundedAt?: number | null, createdBy?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null, organizationBatched?: { __typename?: 'Organization', name: string } | null, owner?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null };

export type DeliveryFragmentFragment = { __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null };

export type DeliveryWithBoxesFragmentFragment = { __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, boxes: Array<{ __typename?: 'Box', _id: string, bundleId?: string | null, state: BoxState, label: string, number: number, code?: string | null, deliveryCode: string, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null, column?: { __typename?: 'Column', name: string, fullname: string, type: ColumnType } | null, products: Array<{ __typename?: 'BoxProduct', _id: string, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, boxId?: string | null, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }> }>, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null };

export type UpdateStateResultFragmentFragment = { __typename?: 'DeliveriesStateUpdateResult', errors: Array<string>, updatedDeliveries: Array<{ __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdByName?: string | null }>, boxes: Array<{ __typename?: 'Box', _id: string, bundleId?: string | null, state: BoxState, label: string, number: number, code?: string | null, deliveryCode: string, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null, column?: { __typename?: 'Column', name: string, fullname: string, type: ColumnType } | null, products: Array<{ __typename?: 'BoxProduct', _id: string, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, boxId?: string | null, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }> }>, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null }> };

export type DeliveryPhotosFragmentFragment = { __typename?: 'Delivery', _id: string, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> };

export type SiteDeliveryPlanningFragmentFragment = { __typename?: 'SiteDeliveryPlanning', site: { __typename?: 'Site', _id: string, name: string, organizationName: string, deliveryDays: Array<boolean>, state: SiteState, shouldOperateOnTotops: boolean, launchDate?: string | null, removalDate?: string | null, isSecured: boolean, hasSensei: boolean, deliveryType: SiteDeliveryType, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }> }, deliveryPlanning: Array<{ __typename?: 'DeliveryPlanning', date: string, isManual: boolean, isActive: boolean }> };

export type DeliveryZoneFragmentFragment = { __typename?: 'DeliveryZone', _id: string, name: string, color: string, state: DeliveryZoneState, referentDelivererId?: string | null, sitesCount: number, createdAt: number, updatedAt: number, referentDeliverer?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null };

export type EquipmentFragment = { __typename?: 'Equipment', _id: string, createdAt: number, updatedAt: number, name: string, brand?: string | null, volume?: string | null, price?: number | null, imageUrl?: string | null, description?: string | null, hidden: boolean, height?: number | null, width?: number | null, length?: number | null, weight?: number | null, state: EquipmentState, suppliers?: Array<{ __typename?: 'EquipmentSupplier', _id: string, name?: string | null } | null> | null, stateHistory: Array<{ __typename?: 'EquipmentStateHistory', createdAt: number, createdBy?: string | null, state: EquipmentState }> };

export type ExpiryDateRecordFragmentFragment = { __typename?: 'ExpiryDateRecord', _id: string, createdAt: number, expiryDate: string, initialQuantity: number, quantityAtInventory: number, productId: string, siteId: string, state: ExpiryDateRecordState, updatedAt: number, product: { __typename?: 'Product', brand: string, name: string, volume: string } };

export type FreefoodSetupFragmentFragment = { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> };

export type FreefoodSetupControlPhotosFragmentFragment = { __typename?: 'FreefoodSetup', instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }> };

export type FutureStockVariationFragmentFragment = { __typename?: 'FutureStockVariation', _id: string, createdAt: number, delta: number, columnId: string, productId: string, ref: string, state: FutureStockVariationState, type: FutureStockVariationType, updatedAt?: number | null, useDate: string, processInfo?: { __typename?: 'FutureStockVariationProcessInfo', supplyOrderStockVariationRef?: string | null, boxInfo?: Array<{ __typename?: 'FutureStockVariationProcessInfoBoxInfo', boxId: string, isPrepared: boolean, stockVariationRef?: string | null }> | null } | null, issues: Array<{ __typename?: 'FutureStockVariationIssue', explanation: string, type: FutureStockVariationIssueType }> };

export type LocationPlanogramFragmentFragment = { __typename?: 'LocationPlanogram', _id: string, createdAt: number, locationId: string, productId?: string | null, startDate: string, updatedAt: number };

export type ManualSupplyOrderFragmentFragment = { __typename?: 'SupplyOrder', _id: string, orderDate?: string | null, dateDeliveryScheduled?: string | null, dateDelivery?: string | null, priceHT?: number | null, priceTTC?: number | null, supplier: { __typename?: 'Supplier', name: string }, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, fullname: string, quantity: number }> };

export type MenuInstructionFragmentFragment = { __typename?: 'MenuInstruction', _id: string, createdAt: number, updatedAt: number, date: string, microstoreColumnId: string, categoryId: string, type: MenuInstructionType, value: number };

export type SiteMenusFragmentFragment = { __typename?: 'SiteMenus', siteId: string, columns: Array<{ __typename?: 'ColumMenus', columnId: string, dailyMenus: Array<{ __typename?: 'DailyMenu', date: string, productLocations: Array<{ __typename?: 'MenuProductLocation', product?: { __typename?: 'Product', _id: string, fullname: string } | null, location: { __typename?: 'MicrostoreLocation', _id: string } }> }> }> };

export type MenuProductFragmentFragment = { __typename?: 'MenuProduct', quantity: number, nbLocations: number, isInProductArrangement: boolean, product: { __typename?: 'Product', _id: string, fullname: string, imageUrl?: string | null, state: ProductState, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, supplier?: { __typename?: 'Supplier', _id: string, name: string } | null } };

export type MenuProductArrangementFragmentFragment = { __typename?: 'MenuProductArrangement', productArrangementId: string, productArrangementName: string, productArrangementMainCategoryId: string, productArrangementIndexes: Array<{ __typename?: 'MenuProductArrangementIndex', productArrangementIndex: number, rotations: Array<{ __typename?: 'MenuRotation', rotationNumber: number, products: Array<{ __typename?: 'MenuProduct', quantity: number, nbLocations: number, isInProductArrangement: boolean, product: { __typename?: 'Product', _id: string, fullname: string, imageUrl?: string | null, state: ProductState, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, supplier?: { __typename?: 'Supplier', _id: string, name: string } | null } }> }> }> };

export type MessagesSetFragmentFragment = { __typename?: 'MessagesSet', _id: string, createdAt: number, name: string, state: MessagesSetState, updatedAt: number, messages: Array<{ __typename?: 'Message', body: string, redirectUrl?: string | null }> };

export type MicrostoreColumnFragmentFragment = { __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, microstoreColumnTemplateId: string, microstoreColumnTemplateName: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, removalDate?: string | null, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, type: MicrostoreColumnTemplateType, microstoreColumnType: MicrostoreColumnType, siteId: string, siteName: string, isRegular: boolean };

export type MicrostoreColumnWithShelvesFragmentFragment = { __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> };

export type MicrostoreColumnGroupFragmentFragment = { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, microstoreColumnTemplateId: string, microstoreColumnTemplateName: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, removalDate?: string | null, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, type: MicrostoreColumnTemplateType, microstoreColumnType: MicrostoreColumnType, siteId: string, siteName: string, isRegular: boolean }> };

export type MicrostoreColumnGroupWithColumnsFragmentFragment = { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> };

export type MicrostoreColumnGroupSetupFragmentFragment = { __typename?: 'MicrostoreColumnGroupSetup', _id: string, isFinishForced: boolean, isNeeded: boolean, microstoreColumnGroupId: string, positionInSiteSetup: number, siteSetupId: string, state: MicrostoreColumnGroupSetupState, updatedAt: number, instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> }>, stateHistory: Array<{ __typename?: 'MicrostoreColumnGroupSetupStateHistory', createdAt: number, state: MicrostoreColumnGroupSetupState }> };

export type MicrostoreColumnGroupSetupControlPhotosFragmentFragment = { __typename?: 'MicrostoreColumnGroupSetup', instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }> }> };

export type MicrostoreColumnInventoryFragmentFragment = { __typename?: 'MicrostoreColumnInventory', _id: string, createdAt: number, microstoreColumnId: string, siteInventoryId: string, state: MicrostoreColumnInventoryState, updatedAt: number, checkedLocations: Array<{ __typename?: 'InventoryCheckedLocation', microstoreLocationId: string, productId: string, quantityDetails: Array<{ __typename?: 'InventoryCheckedLocationQuantityDetail', expiryDate?: string | null, quantity: number }> }> };

export type MicrostoreColumnSetupFragmentFragment = { __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> };

export type MicrostoreColumnSetupControlPhotosFragmentFragment = { __typename?: 'MicrostoreColumnSetup', instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }> };

export type MicrostoreColumnTemplateFragmentFragment = { __typename?: 'MicrostoreColumnTemplate', _id: string, name: string, type: MicrostoreColumnTemplateType, state: MicrostoreColumnTemplateState };

export type MicrostoreColumnTemplateWithAllInfoFragment = { __typename?: 'MicrostoreColumnTemplate', _id: string, name: string, type: MicrostoreColumnTemplateType, state: MicrostoreColumnTemplateState, shelfTemplates: Array<{ __typename?: 'MicrostoreShelfTemplate', _id: string, columnTemplateId: string, positionInColumn: number, locationTemplateTable: Array<Array<{ __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, shelfTemplateId: string, shouldOrderProductIfNotInSite: boolean, shouldSmoothProductTransition: boolean, allowProductRotation: boolean, trayMaxCapacity: number, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number }, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, productsWithStockMax: Array<{ __typename?: 'ProductArrangementProductWithStockMax', stockMax: number, product: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }>> }> };

export type MicrostoreLocationFragmentFragment = { __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } };

export type MicrostoreLocationTemplateFragmentFragment = { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null };

export type MobilePopupFragmentFragment = { __typename?: 'MobilePopup', _id: string, startsAt: number, endsAt: number, imageUrl?: string | null, title?: string | null, body?: string | null, siteIds?: Array<string> | null, createdAt: number, sites?: Array<{ __typename?: 'Site', _id: string, name: string } | null> | null };

export type NuBasketFragmentFragment = { __typename?: 'NuBasket', _id: string, purchaseId: string, fridgeId: string, cardId?: string | null, createdAt: number, updatedAt: number, userId: string, siteId: string, type: NuBasketType };

export type FlowParameterFragmentFragment = { __typename?: 'FlowParameter', flow: ProductFlow, emptyWeightBox: number, externalVolumeBox: number, volumeBox: number, weightBox: number, bundleCapacity: number };

export type DynamicDeliveryThresholdEntryFragmentFragment = { __typename?: 'DynamicDeliveryThresholdEntry', templateType: MicrostoreColumnTemplateType, contractType: DynamicDeliveryContractType, qualityPassPercent: number, criticalPassPercent: number, requiredPassPercent: number, criticalGroupingPercent: number, requiredGroupingPercent: number, groupingRadiusKm: number, maxDaysWithoutDelivery: number };

export type OpsParameterFragmentFragment = { __typename?: 'OpsParameter', _id: string, createdAt: number, updatedAt: number, parameters: { __typename?: 'OpsParameterData', shouldAutoOrderMenuSupplyOrder: boolean, shouldProcessFreshReassortment: boolean, canUseKraftForStore: boolean, canUseKraftForFreefood: boolean, emptyWeightPaletteBox: number, emptyWeightKraftBox: number, externalVolumePaletteBox: number, externalVolumeKraftBox: number, volumePaletteBox: number, volumeKraftBox: number, weightPaletteBox: number, weightKraftBox: number, serviceTimePerBox: number, dryReassortMinProductCount: number, dryReassortMinReferenceCount: number, dryReassortMaxEmptyFacings: number, flowParameters: Array<{ __typename?: 'FlowParameter', flow: ProductFlow, emptyWeightBox: number, externalVolumeBox: number, volumeBox: number, weightBox: number, bundleCapacity: number }>, dynamicDelivery: { __typename?: 'DynamicDeliveryConfig', capacity: number, thresholds: Array<{ __typename?: 'DynamicDeliveryThresholdEntry', templateType: MicrostoreColumnTemplateType, contractType: DynamicDeliveryContractType, qualityPassPercent: number, criticalPassPercent: number, requiredPassPercent: number, criticalGroupingPercent: number, requiredGroupingPercent: number, groupingRadiusKm: number, maxDaysWithoutDelivery: number }>, estimatedTransactionCapacities: Array<{ __typename?: 'DynamicDeliveryTemplateCapacity', templateType: MicrostoreColumnTemplateType, estimatedTransactionCapacity: number }> } } };

export type DetailedOrderFragmentFragment = { __typename?: 'Order', _id: string, appreciation?: string | null, badService?: Array<string> | null, deliveryDate: string, feedback?: string | null, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, isPunctual: boolean, number?: number | null, previous_orderId?: string | null, reference?: string | null, state: OrderState, weekday?: string | null, delivery?: { __typename?: 'Delivery', _id: string, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState }> } | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, productsWithQuantityPicked: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, fullname: string, quantity?: number | null, quantityPicked?: number | null, unitPrice: number }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, organization: { __typename?: 'Organization', _id: string, hasSubscription: boolean, name: string, paymentType: OrganizationPaymentType }, pausedInfo?: { __typename?: 'PausedInfo', reason?: string | null, returnDate?: number | null } | null, invoicing: { __typename?: 'OrderInvoicing', status: OrderInvoicingStatus, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, paymentIntentId?: string | null, stripePaymentUrl?: string | null }, prices: { __typename?: 'OrderPrices', discount?: number | null, discount055?: number | null, discount10?: number | null, discount20?: number | null, price?: number | null, price055?: number | null, price10?: number | null, price20?: number | null, priceDelivery?: number | null, priceHT?: number | null, priceHT055?: number | null, priceHT10?: number | null, priceHT20?: number | null, priceTTC?: number | null, priceTTC055?: number | null, priceTTC10?: number | null, priceTTC20?: number | null, tva?: number | null, tva055?: number | null, tva10?: number | null, tva20?: number | null }, productsRequestedButNotFullyDelivered: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, fullname: string, unitPrice: number, quantityRequested?: number | null }>, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number }, user: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null } } };

export type PollFragmentFragment = { __typename?: 'Poll', _id: string, answerOptions: Array<string>, answersRepartition: Array<number>, createdAt: number, imageUrl: string, numberOfParticipants: number, question: string, sectionTitle?: string | null, title: string, audience: { __typename?: 'PollAudience', organizationIds: Array<string>, siteIds: Array<string>, userIds: Array<string> }, dateWindow: { __typename?: 'PollDateWindow', startDate: string, endDate: string } };

export type FormErrorFragmentFragment = { __typename?: 'FormError', sectionName: string, sectionErrors: Array<{ __typename?: 'SectionError', fieldName: string, fieldError: string }> };

export type ProductProductArrangementFragmentFragment = { __typename?: 'Product', _id: string, productArrangements: Array<{ __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> }> };

export type AdditionalProductInfoFragmentFragment = { __typename?: 'Product', description?: string | null, flow: ProductFlow, indexDisplay?: number | null, isFreefood: boolean, isMicrostore: boolean, shouldBeHiddenInStore: boolean, isPunctual: boolean, isFromNayax?: boolean | null, isWithoutStock: boolean, nbRatings: number, rating: number, scan: boolean, searchKeywords?: Array<string> | null, zeroWasteProductTemplateId?: string | null };

export type DimensionsProductInfoFragmentFragment = { __typename?: 'Product', height?: number | null, isDoubleCoil: boolean, length?: number | null, toleranceMin: number, toleranceMax: number, weight?: number | null, weightWithoutPackaging?: number | null, width?: number | null };

export type NutritionProductInfoFragmentFragment = { __typename?: 'Product', ingredients?: string | null, nutriscore?: string | null, allergen: { __typename?: 'ProductAllergen', gluten: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, peanuts: boolean, soybeans: boolean, milk: boolean, nuts: boolean, celery: boolean, mustard: boolean, sesame: boolean, sulphites: boolean, lupin: boolean, molluscs: boolean, containsNoAllergens: boolean, canContain?: string | null }, nutrition: { __typename?: 'ProductNutrition', caloriesKCal?: number | null, totalFat?: number | null, sturatedFat?: number | null, carbohydrates?: number | null, sugars?: number | null, fibers?: number | null, protein?: number | null, sodium?: number | null } };

export type GeneralProductInfoFragmentFragment = { __typename?: 'Product', externalProductId?: string | null, nayaxProductId?: string | null, odooProductId?: string | null, brand: string, createdAt: number, imageUrl?: string | null, name: string, fullname: string, packagingImageUrl?: string | null, state: ProductState, updatedAt: number, volume: string, barcodes: Array<{ __typename?: 'Barcode', barcode: string, type: BarcodeType }>, category: { __typename?: 'Category', _id: string, title: string }, odooProduct?: { __typename?: 'OdooProduct', _id: string, externalOdooProductId: number, externalOdooProductVariantId: number, externalOdooZeroWasteProductVariantId?: number | null } | null, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null };

export type SalesProductInfoFragmentFragment = { __typename?: 'Product', conditionningTotem: number, displayKg: boolean, isScannable: boolean, isTitreRestaurantAllowed: boolean, onboardedForSensei: boolean, portion: number, proportion?: number | null, proportionMax?: number | null, tva: number, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string, quantity: number, hotDrinksIngredientUnit: HotDrinksIngredientUnit, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null, weightWithoutPackaging?: number | null } }> } | null, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null }, supplierShortageHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null, code?: string | null, prices: Array<{ __typename?: 'SupplierProductPrice', value: number, conditionning: number, packagesPerBatch: number }> }> };

export type StateHistoryProductInfoFragmentFragment = { __typename?: 'Product', access: Array<string>, isBeingTested: boolean, isPaused: boolean, isToBeArchived: boolean, newUntil?: string | null, state: ProductState, useInMenusFrom?: string | null, toBeArchivedHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, stateHistory: Array<{ __typename?: 'ProductStateHistory', state: ProductState, createdAt: number, createdBy?: string | null, createdByName?: string | null }> };

export type StockAndSupplierProductInfoFragmentFragment = { __typename?: 'Product', allowNegativeStock: boolean, canExpire: boolean, checkSwollenLid: boolean, hasShortExpiryDate: boolean, minSupplierExpiryDays?: number | null, stockThreshold?: number | null, stockThresholdMinimum?: number | null, minSupplierOrderQuantity?: number | null, trackExpiryDate: boolean, deliveryDays: { __typename?: 'ProductDeliveryDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } };

export type TagsAndBadgesProductInfoFragmentFragment = { __typename?: 'Product', tagIds: Array<string>, preferences: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, diets: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }> };

export type ProductFragmentFragment = { __typename?: 'Product', _id: string, description?: string | null, flow: ProductFlow, indexDisplay?: number | null, isFreefood: boolean, isMicrostore: boolean, shouldBeHiddenInStore: boolean, isPunctual: boolean, isFromNayax?: boolean | null, isWithoutStock: boolean, nbRatings: number, rating: number, scan: boolean, searchKeywords?: Array<string> | null, zeroWasteProductTemplateId?: string | null, height?: number | null, isDoubleCoil: boolean, length?: number | null, toleranceMin: number, toleranceMax: number, weight?: number | null, weightWithoutPackaging?: number | null, width?: number | null, externalProductId?: string | null, nayaxProductId?: string | null, odooProductId?: string | null, brand: string, createdAt: number, imageUrl?: string | null, name: string, fullname: string, packagingImageUrl?: string | null, state: ProductState, updatedAt: number, volume: string, ingredients?: string | null, nutriscore?: string | null, conditionningTotem: number, displayKg: boolean, isScannable: boolean, isTitreRestaurantAllowed: boolean, onboardedForSensei: boolean, portion: number, proportion?: number | null, proportionMax?: number | null, tva: number, access: Array<string>, isBeingTested: boolean, isPaused: boolean, isToBeArchived: boolean, newUntil?: string | null, useInMenusFrom?: string | null, allowNegativeStock: boolean, canExpire: boolean, checkSwollenLid: boolean, hasShortExpiryDate: boolean, minSupplierExpiryDays?: number | null, stockThreshold?: number | null, stockThresholdMinimum?: number | null, minSupplierOrderQuantity?: number | null, trackExpiryDate: boolean, tagIds: Array<string>, barcodes: Array<{ __typename?: 'Barcode', barcode: string, type: BarcodeType }>, category: { __typename?: 'Category', _id: string, title: string }, odooProduct?: { __typename?: 'OdooProduct', _id: string, externalOdooProductId: number, externalOdooProductVariantId: number, externalOdooZeroWasteProductVariantId?: number | null } | null, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, allergen: { __typename?: 'ProductAllergen', gluten: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, peanuts: boolean, soybeans: boolean, milk: boolean, nuts: boolean, celery: boolean, mustard: boolean, sesame: boolean, sulphites: boolean, lupin: boolean, molluscs: boolean, containsNoAllergens: boolean, canContain?: string | null }, nutrition: { __typename?: 'ProductNutrition', caloriesKCal?: number | null, totalFat?: number | null, sturatedFat?: number | null, carbohydrates?: number | null, sugars?: number | null, fibers?: number | null, protein?: number | null, sodium?: number | null }, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string, quantity: number, hotDrinksIngredientUnit: HotDrinksIngredientUnit, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null, weightWithoutPackaging?: number | null } }> } | null, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null }, supplierShortageHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null, code?: string | null, prices: Array<{ __typename?: 'SupplierProductPrice', value: number, conditionning: number, packagesPerBatch: number }> }>, toBeArchivedHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, stateHistory: Array<{ __typename?: 'ProductStateHistory', state: ProductState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, deliveryDays: { __typename?: 'ProductDeliveryDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean }, preferences: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, diets: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, productArrangements: Array<{ __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> }> };

export type CatalogProductFragmentFragment = { __typename?: 'Product', _id: string, access: Array<string>, brand: string, externalProductId?: string | null, isBeingTested: boolean, imageUrl?: string | null, isDoubleCoil: boolean, isOutOfStock: boolean, isPaused: boolean, isToBeArchived: boolean, isWithoutStock: boolean, isMicrostore: boolean, name: string, fullname: string, newUntil?: string | null, state: ProductState, flow: ProductFlow, updatedAt: number, volume: string, height?: number | null, length?: number | null, width?: number | null, weight?: number | null, category: { __typename?: 'Category', title: string }, subcategory?: { __typename?: 'Subcategory', name: string } | null, suppliers: Array<{ __typename?: 'ProductSupplier', name?: string | null, prices: Array<{ __typename?: 'SupplierProductPrice', value: number, conditionning: number }> }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean }, tags: Array<{ __typename?: 'Tag', name: string }> };

export type ProductArrangementProductFragmentFragment = { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null };

export type ProductArrangementFragmentFragment = { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> };

export type ProductArrangementWithProductsFragmentFragment = { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, productsWithStockMax: Array<{ __typename?: 'ProductArrangementProductWithStockMax', stockMax: number, product: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } }> };

export type ProductGroupFragmentFragment = { __typename?: 'ProductGroup', _id: string, createdAt: number, productId: string, updatedAt: number, composition: Array<{ __typename?: 'ProductGroupCompositionEntry', productId: string, quantity: number }> };

export type ProductSwitchFragmentFragment = { __typename?: 'ProductSwitch', _id: string, createdAt: number, endDate: string, productAId: string, productBId: string, ratioToOrderOfA: number, ratioOfAToOrderForB: number, startDate: string, state: ProductSwitchState, switchFreefood: boolean, switchStore: boolean, updatedAt: number, productAVariation?: { __typename?: 'ProductStockVariation', computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } } | null, productBVariation?: { __typename?: 'ProductStockVariation', computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } } | null };

export type QuizFragmentFragment = { __typename?: 'Quiz', _id: string, createdAt: number, date: string, description: string, imageUrl: string, state: QuizState, title: string, updatedAt: number, audience: { __typename?: 'QuizAudience', organizationIds: Array<string>, siteIds: Array<string>, userIds: Array<string> }, questions: Array<{ __typename?: 'QuizQuestion', label: string, answerOptions: Array<string>, correctAnswerIndex: number, imageUrl: string }> };

export type DetailedRitualFragmentFragment = { __typename?: 'Ritual', _id: string, activeDate?: string | null, activeWeekdays?: Array<boolean> | null, associatedDiscount?: number | null, billToOrganizationId?: string | null, imageUrl: string, messagesSetId?: string | null, name: string, repetition: RitualRepetition, resetsBetweenPurchases: boolean, restrictedOrganizationIds: Array<string>, restrictedSiteIds: Array<string>, restrictedUserIds: Array<string>, state: RitualState, timeWindow: { __typename?: 'RitualTimeWindow', start: string, end: string } };

export type QuizRitualGameFragmentFragment = { __typename?: 'QuizRitualGame', _id: string, maxAttempts: number, ritualId: string, targetScore: number, totalScore: number, type: RitualGameType, questions: Array<{ __typename?: 'RitualQuizQuestion', answerChoices: Array<string>, correctAnswerIndex: number, description: string, explanation: string, imageUrl?: string | null, timeToAnswer: number, title: string }> };

export type WantedRitualGameFragmentFragment = { __typename?: 'WantedRitualGame', _id: string, maxAttempts: number, ritualId: string, targetScore: number, totalScore: number, type: RitualGameType };

type RitualGameFragmentQuizRitualGameFragment = { __typename?: 'QuizRitualGame', _id: string, maxAttempts: number, ritualId: string, targetScore: number, totalScore: number, type: RitualGameType, questions: Array<{ __typename?: 'RitualQuizQuestion', answerChoices: Array<string>, correctAnswerIndex: number, description: string, explanation: string, imageUrl?: string | null, timeToAnswer: number, title: string }> };

type RitualGameFragmentWantedRitualGameFragment = { __typename?: 'WantedRitualGame', _id: string, maxAttempts: number, ritualId: string, targetScore: number, totalScore: number, type: RitualGameType };

export type RitualGameFragmentFragment = RitualGameFragmentQuizRitualGameFragment | RitualGameFragmentWantedRitualGameFragment;

export type SenseiBasketFragmentFragment = { __typename?: 'SenseiBasket', _id: string, createdAt: number, senseiBasketId: number, senseiColumnId?: string | null, userId: string, basketCreationDate: number, storeEntryDate: number, storeExitDate: number, items: Array<{ __typename?: 'SenseiBasketItem', quantity?: number | null, sku?: string | null, lineAmount?: number | null, lineTax?: number | null }> };

type SetupInstructionFragmentCheckBoxTemperatureInstructionFragment = { __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

type SetupInstructionFragmentCheckTemperatureInstructionFragment = { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

type SetupInstructionFragmentHotDrinksInstructionFragment = { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

type SetupInstructionFragmentInventoryInstructionFragment = { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

type SetupInstructionFragmentManualReassortInstructionFragment = { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

type SetupInstructionFragmentMicrowaveInstructionFragment = { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

type SetupInstructionFragmentMoveProductsInstructionFragment = { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

type SetupInstructionFragmentPhotosInstructionFragment = { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

type SetupInstructionFragmentRemoveProductsInstructionFragment = { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

type SetupInstructionFragmentStoreProductsInstructionFragment = { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

type SetupInstructionFragmentTheftNoticeInstructionFragment = { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type SetupInstructionFragmentFragment = SetupInstructionFragmentCheckBoxTemperatureInstructionFragment | SetupInstructionFragmentCheckTemperatureInstructionFragment | SetupInstructionFragmentHotDrinksInstructionFragment | SetupInstructionFragmentInventoryInstructionFragment | SetupInstructionFragmentManualReassortInstructionFragment | SetupInstructionFragmentMicrowaveInstructionFragment | SetupInstructionFragmentMoveProductsInstructionFragment | SetupInstructionFragmentPhotosInstructionFragment | SetupInstructionFragmentRemoveProductsInstructionFragment | SetupInstructionFragmentStoreProductsInstructionFragment | SetupInstructionFragmentTheftNoticeInstructionFragment;

type SetupInstructionControlPhotosFragmentCheckBoxTemperatureInstructionFragment = { __typename?: 'CheckBoxTemperatureInstruction' };

type SetupInstructionControlPhotosFragmentCheckTemperatureInstructionFragment = { __typename?: 'CheckTemperatureInstruction' };

type SetupInstructionControlPhotosFragmentHotDrinksInstructionFragment = { __typename?: 'HotDrinksInstruction' };

type SetupInstructionControlPhotosFragmentInventoryInstructionFragment = { __typename?: 'InventoryInstruction' };

type SetupInstructionControlPhotosFragmentManualReassortInstructionFragment = { __typename?: 'ManualReassortInstruction' };

type SetupInstructionControlPhotosFragmentMicrowaveInstructionFragment = { __typename?: 'MicrowaveInstruction' };

type SetupInstructionControlPhotosFragmentMoveProductsInstructionFragment = { __typename?: 'MoveProductsInstruction' };

type SetupInstructionControlPhotosFragmentPhotosInstructionFragment = { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> };

type SetupInstructionControlPhotosFragmentRemoveProductsInstructionFragment = { __typename?: 'RemoveProductsInstruction' };

type SetupInstructionControlPhotosFragmentStoreProductsInstructionFragment = { __typename?: 'StoreProductsInstruction' };

type SetupInstructionControlPhotosFragmentTheftNoticeInstructionFragment = { __typename?: 'TheftNoticeInstruction' };

export type SetupInstructionControlPhotosFragmentFragment = SetupInstructionControlPhotosFragmentCheckBoxTemperatureInstructionFragment | SetupInstructionControlPhotosFragmentCheckTemperatureInstructionFragment | SetupInstructionControlPhotosFragmentHotDrinksInstructionFragment | SetupInstructionControlPhotosFragmentInventoryInstructionFragment | SetupInstructionControlPhotosFragmentManualReassortInstructionFragment | SetupInstructionControlPhotosFragmentMicrowaveInstructionFragment | SetupInstructionControlPhotosFragmentMoveProductsInstructionFragment | SetupInstructionControlPhotosFragmentPhotosInstructionFragment | SetupInstructionControlPhotosFragmentRemoveProductsInstructionFragment | SetupInstructionControlPhotosFragmentStoreProductsInstructionFragment | SetupInstructionControlPhotosFragmentTheftNoticeInstructionFragment;

export type CheckTemperatureInstructionFragmentFragment = { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type CheckBoxTemperatureInstructionFragmentFragment = { __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type HotDrinksInstructionFragmentFragment = { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type InventoryInstructionFragmentFragment = { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type MicrowaveInstructionFragmentFragment = { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type MoveProductsInstructionFragmentFragment = { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type PhotosInstructionFragmentFragment = { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type RemoveProductsInstructionFragmentFragment = { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type StoreProductsInstructionFragmentFragment = { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type ManualReassortInstructionFragmentFragment = { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type TheftNoticeInstructionFragmentFragment = { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> };

export type SiteFragmentFragment = { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null };

export type SiteFragmentFilterFragment = { __typename?: 'Site', _id: string, createdAt: number, updatedAt: number, deliveryDays: Array<boolean>, deliveryType: SiteDeliveryType, name: string, organizationName: string, organizationId: string, state: SiteState, totemId: string, type: SiteType, B2CPriceRange?: string | null, accessTime: number, launchDate?: string | null, removalDate?: string | null, hasExternalSetupProcess: boolean, estimatedUserCount: number, isSecured: boolean, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldModulateForExpired: boolean, shouldHaveTheftNotice: boolean, shouldModulateForUnknownLosses: boolean, useNayaxCard: boolean, hasSensei: boolean, unknownShrinkageBillingThreshold?: number | null, deliveryZoneId?: string | null, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null };

export type SiteWithLocationInfoFragmentFragment = { __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, earliestDLCDateToKeepForStockCalculation?: string | null, isOpenOnWeekend: boolean, isSecured: boolean, name: string, type: SiteType, state: SiteState, organizationName: string, nextDeliveryDate?: string | null, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }> };

export type SiteInventoryFragmentFragment = { __typename?: 'SiteInventory', _id: string, createdAt: number, date: string, siteId: string, state: SiteInventoryState, updatedAt: number, microstoreColumnInventories: Array<{ __typename?: 'MicrostoreColumnInventory', _id: string, createdAt: number, microstoreColumnId: string, siteInventoryId: string, state: MicrostoreColumnInventoryState, updatedAt: number, checkedLocations: Array<{ __typename?: 'InventoryCheckedLocation', microstoreLocationId: string, productId: string, quantityDetails: Array<{ __typename?: 'InventoryCheckedLocationQuantityDetail', expiryDate?: string | null, quantity: number }> }> }> };

export type SiteProductLightFragment = { __typename?: 'SiteProduct', productId: string, targetStock: number, stock: number, product: { __typename?: 'Product', _id: string, fullname: string, state: ProductState, flow: ProductFlow }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number }, latestStockVariations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null, columnInventoryStockId: string }> };

export type SiteProductFragment = { __typename?: 'SiteProduct', productId: string, targetStock: number, stock: number, product: { __typename?: 'Product', _id: string, fullname: string, state: ProductState, flow: ProductFlow }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number, details?: { __typename?: 'AvailableStockDetails', dailyStocks: Array<number>, orderedStocks: Array<number>, realRecurringOrders: Array<number>, predictionRecurringOrders: Array<number>, realPunctualOrders: Array<number>, predictionPunctualOrders: Array<number>, realStoreTargetNotPrepared: Array<number>, realStoreTargetPrepared: Array<number>, predictionStoreTarget: Array<number>, storeMenu: Array<number>, preparationDate: string, preparationDateUsedIndex: number, soonestRestockedDate?: string | null, soonestRestockedDateUsedIndex: number, usedRecurringOrders: Array<number>, usedPunctualOrders: Array<number>, usedStoreTarget: Array<number>, usedStoreMenu: Array<number> } | null }, latestStockVariations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null, columnInventoryStockId: string }> };

export type SiteSetupFragmentFragment = { __typename?: 'SiteSetup', _id: string, createdAt: number, date: string, deliveryId: string, isFinishForced: boolean, siteId: string, state: SiteSetupState, updatedAt: number, delivery?: { __typename?: 'Delivery', isDynamic: boolean } | null, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> } | null, issues: { __typename?: 'SiteSetupIssues', productsIssues: Array<{ __typename?: 'SetupProductIssues', comment: string, productId: string, brokenDuringDeliveryQuantity: number, brokenOnSiteAfterInventoryQuantity: number, brokenOnSiteBeforeInventoryQuantity: number, expiredDeliveredQuantity: number, expiredOnSiteAfterInventoryQuantity: number, expiredOnSiteBeforeInventoryQuantity: number, notEnoughPlaceQuantity: number, otherBeforeInventoryQuantity: number, otherAfterInventoryOrDuringDeliveryQuantity: number, unexpectedOnSiteQuantity: number, wrongQuantityDelivered: number }> }, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', _id: string, isFinishForced: boolean, isNeeded: boolean, microstoreColumnGroupId: string, positionInSiteSetup: number, siteSetupId: string, state: MicrostoreColumnGroupSetupState, updatedAt: number, instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> }>, stateHistory: Array<{ __typename?: 'MicrostoreColumnGroupSetupStateHistory', createdAt: number, state: MicrostoreColumnGroupSetupState }> }>, odooTickets: Array<{ __typename?: 'OdooTicket', _id: string, odooTicketId: number, microstoreColumnId: string, serviceType: OdooServiceType, ticketType: string, state: OdooTicketState, description: string, actions: Array<{ __typename?: 'OdooTicketAction', actionType: OdooTicketActionType, message: string, photoUrl?: string | null, createdAt: number }>, microstoreColumn: { __typename?: 'MicrostoreColumn', name: string } }>, site: { __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, earliestDLCDateToKeepForStockCalculation?: string | null, isOpenOnWeekend: boolean, isSecured: boolean, name: string, type: SiteType, state: SiteState, organizationName: string, nextDeliveryDate?: string | null, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }> }, stateHistory: Array<{ __typename?: 'SiteSetupStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: SiteSetupState }> };

export type SiteSetupControlPhotosFragmentFragment = { __typename?: 'SiteSetup', _id: string, date: string, freefoodSetup?: { __typename?: 'FreefoodSetup', instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }> } | null, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }> }> }> };

export type StockTransferFragmentFragment = { __typename?: 'StockTransfer', _id: string, createdAt: number, updatedAt: number, transferDate: string, destinationColumnId: string, originColumnId: string, deliveryId?: string | null, reassortmentFlow?: ReassortmentFlow | null, shouldUpdateStockImmediately: boolean, state: StockTransferState, destinationColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, originColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, products: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, conditionning: number, packagesPerBatch: number, originStockAvailable: number, destinationStockAvailable: number, quantity: number }>, delivery?: { __typename?: 'Delivery', state: DeliveryState } | null, stateHistory: Array<{ __typename?: 'StockTransferStateHistory', state: StockTransferState, createdAt: number, createdBy: string, createdByName?: string | null }> };

export type StockVariationFragmentFragment = { __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, explanation?: string | null, productId: string, ref?: string | null, columnInventoryStockId: string, columnId: string, type: StockVariationType };

export type SubcategoryFragment = { __typename?: 'Subcategory', _id: string, categoryId: string, displayIndex: number, name: string, state: SubcategoryState };

export type SubventionFragmentFragment = { __typename?: 'Subvention', _id: string, archivedAt?: number | null, billToOrganizationId?: string | null, categories: Array<string>, coverageRate?: number | null, createdAt: number, cumulative?: boolean | null, currentAmount?: number | null, description: string, hoursIntervalsAvailable: Array<Array<string>>, imageUrl?: string | null, name: string, organizationId: string, reload?: SubventionReloadPeriod | null, remainingAmount?: number | null, updatedAt: number, billToOrganization?: { __typename?: 'Organization', _id: string, name: string } | null, organization?: { __typename?: 'Organization', _id: string, name: string } | null };

export type OrderingTimeForDayFragmentFragment = { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } };

export type SupplierFragmentFragment = { __typename?: 'Supplier', _id: string, nextOrderingDate?: string | null, name: string, description?: string | null, phone?: string | null, address?: string | null, zipcode?: string | null, website?: string | null, createdAt?: number | null, updatedAt?: number | null, shouldCheckReceptionDayIsNotClosed: boolean, shouldOrderAutomatically: boolean, state: SupplierState, paymentTimeType: PaymentTimeType, paymentTimeDays?: number | null, paymentType: SupplierPaymentType, orderMode: OrderMode, orderEmails: Array<string>, orderPlatformUrl?: string | null, clientCode?: string | null, frequency: number, closingDatesRanges: Array<{ __typename?: 'SupplierClosingDatesRange', closingDate: string, openingDate: string }>, stateHistory: Array<{ __typename?: 'SupplierStateHistory', state: SupplierState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, contacts: Array<{ __typename?: 'SupplierContact', name: string, surname: string, phone: string, email: string, description: string }>, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } } };

export type SupplierDiscountFragmentFragment = { __typename?: 'SupplierDiscount', _id: string, name: string, createdAt: number, updatedAt: number, state: SupplierDiscountState, rate: number, productIds: Array<string>, purchaseStartDate: number, purchaseEndDate: number, salesStartDate: number, salesEndDate: number, imageUrl?: string | null, discountedProductPrices: Array<{ __typename?: 'DiscountedProductPrice', _id: string, purchasePrice: number, purchaseDiscountedPrice: number, purchaseDiscountAmount: number, purchaseDiscountRate: number, salesPrice: number, salesDiscountedPrice: number, salesDiscountAmount: number, salesDiscountRate: number, product: { __typename?: 'Product', _id: string, fullname: string, category: { __typename?: 'Category', _id: string, title: string }, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null }> } }> };

export type SupplierPartnershipFragmentFragment = { __typename?: 'SupplierPartnership', _id: string, budget: number, createdAt: number, endDate: string, name: string, productIds: Array<string>, startDate: string, updatedAt: number };

export type BadExpiryDateIssueFragmentFragment = { __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null };

export type BrokenQuantityIssueFragmentFragment = { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null };

export type DifferentPackagingIssueFragmentFragment = { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null };

export type DifferentQuantityIssueFragmentFragment = { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null };

export type NewBarcodeIssueFragmentFragment = { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null };

export type NotReceivedIssueFragmentFragment = { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null };

export type UnknownProductIssueFragmentFragment = { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null };

export type WrongProductIssueFragmentFragment = { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null };

type SupplyOrderProductIssueFragmentBadExpiryDateIssueFragment = { __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null };

type SupplyOrderProductIssueFragmentBrokenQuantityIssueFragment = { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null };

type SupplyOrderProductIssueFragmentDifferentPackagingIssueFragment = { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null };

type SupplyOrderProductIssueFragmentDifferentQuantityIssueFragment = { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null };

type SupplyOrderProductIssueFragmentNewBarcodeIssueFragment = { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null };

type SupplyOrderProductIssueFragmentNotReceivedIssueFragment = { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null };

type SupplyOrderProductIssueFragmentUnknownProductIssueFragment = { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null };

type SupplyOrderProductIssueFragmentWrongProductIssueFragment = { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null };

export type SupplyOrderProductIssueFragmentFragment = SupplyOrderProductIssueFragmentBadExpiryDateIssueFragment | SupplyOrderProductIssueFragmentBrokenQuantityIssueFragment | SupplyOrderProductIssueFragmentDifferentPackagingIssueFragment | SupplyOrderProductIssueFragmentDifferentQuantityIssueFragment | SupplyOrderProductIssueFragmentNewBarcodeIssueFragment | SupplyOrderProductIssueFragmentNotReceivedIssueFragment | SupplyOrderProductIssueFragmentUnknownProductIssueFragment | SupplyOrderProductIssueFragmentWrongProductIssueFragment;

export type SupplyOrderFragmentFragment = { __typename?: 'SupplyOrder', _id: string, state: SupplyOrderState, createdAt: number, orderDate?: string | null, nextOrderDate?: string | null, dateDeliveryScheduled?: string | null, dateDelivery?: string | null, scheduledDeliveryDateValidity: boolean, number?: number | null, priceHT?: number | null, priceTTC?: number | null, weeklyMenusStartDate?: string | null, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, supplier: { __typename?: 'Supplier', _id: string, name: string, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } };

export type SupplyOrderWithSupplierProductsInfoFragmentFragment = { __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } };

export type SupplyOrderProductStockVariationFragmentFragment = { __typename?: 'ProductStockVariation', computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } };

export type TagQueryFragmentFragment = { __typename?: 'Tag', _id: string, displayIndex: number, name: string, type: TagType, state: TagState };

export type TagMutationFragmentFragment = { __typename?: 'Tag', _id: string, createdAt: number, displayIndex: number, name: string, type: TagType, state: TagState, updatedAt: number, stateHistory: Array<{ __typename?: 'TagStateHistory', state: TagState, createdAt: number }> };

export type ThermometerFragmentFragment = { __typename?: 'Thermometer', _id: string, associatedUserId?: string | null, isOperational: boolean, number: number };

export type TotemFragmentFragment = { __typename?: 'Totem', _id: string, address?: string | null, address_details?: string | null, city?: string | null, consigneDelivery?: string | null, country?: string | null, hasValidatedOrders?: boolean | null, latitude?: number | null, longitude?: number | null, monthlyBudget?: number | null, name?: string | null, number: number, organizationId: string, primaryTotemId?: string | null, state: TotemState, type: TotemType, zipcode?: string | null, microstore?: { __typename?: 'Site', _id: string } | null, minimumOrderAmountInfo: { __typename?: 'MinimumOrderAmountInfo', minimumBakeryAmount: number, minimumDryAmount: number, minimumFreshAmount: number, minimumCatererAmount: number, minimumFruitAmount: number, minimumTotalAmount: number } };

export type TotemClosedDayFragmentFragment = { __typename?: 'TotemClosedDay', _id: string, createdAt: number, date: string, state: TotemClosedDayState, type: TotemClosedDayType, updatedAt: number };

export type TotemClosedReceptionDayFragmentFragment = { __typename?: 'TotemClosedReceptionDay', _id: string, createdAt: number, date: string, state: TotemClosedReceptionDayState, updatedAt: number };

export type DetailedTransactionFragmentFragment = { __typename?: 'Transaction', _id: string, basketId?: string | null, nuBasketId?: string | null, createdAt: number, priceHT: number, productId: string, productName: string, refundReason?: string | null, siteId: string, siteName: string, microstoreColumnId?: string | null, microstoreColumnName: string, newState: TransactionState, tva: number, userId: string, userFullName: string, nayaxMDBCode?: number | null, nuBasket?: { __typename?: 'NuBasket', type: NuBasketType } | null, paymentMethods?: Array<{ __typename?: 'TransactionPaymentMethod', amountUsed: number, explanation?: string | null, name?: string | null, paymentMethodName: PaymentMethodName, provider?: string | null, providerTransactionId?: string | null, status: PaymentIntentState, type?: PaymentMethodPaymentType | null }> | null, mealPlan?: { __typename?: 'MealPlan', discountRatio: number } | null, stateHistory: Array<{ __typename?: 'TransactionStateHistory', state: TransactionState, createdAt: number, createdBy: string }> };

export type PreviewTransactionFragmentFragment = { __typename?: 'Transaction', _id: string, basketId?: string | null, nuBasketId?: string | null, createdAt: number, priceHT: number, productName: string, siteId: string, siteName: string, microstoreColumnId?: string | null, microstoreColumnName: string, newState: TransactionState, tva: number, userFullName: string, nuBasket?: { __typename?: 'NuBasket', type: NuBasketType } | null, paymentMethods?: Array<{ __typename?: 'TransactionPaymentMethod', provider?: string | null }> | null };

export type UrbantzRoundPresetFragmentFragment = { __typename?: 'UrbantzRoundPreset', _id: string, createdAt: number, dayIndex: number, totemIds: Array<string>, updatedAt: number };

export type AdminUserFragmentFragment = { __typename?: 'User', _id: string, username: string, createdAt: number, lastSeenAt?: number | null, userGroupIds: Array<string>, stripeCustomerId?: string | null, defaultTruckColumnId?: string | null, emails: Array<{ __typename?: 'UserEmail', address: string, verified: boolean, bounced?: { __typename?: 'BouncedType', createdAt: number, reason: string } | null }>, getLastTransactions: Array<{ __typename?: 'Transaction', _id: string, basketId?: string | null, nuBasketId?: string | null, createdAt: number, priceHT: number, productName: string, siteId: string, siteName: string, microstoreColumnId?: string | null, microstoreColumnName: string, newState: TransactionState, tva: number, userFullName: string, nuBasket?: { __typename?: 'NuBasket', type: NuBasketType } | null, paymentMethods?: Array<{ __typename?: 'TransactionPaymentMethod', provider?: string | null }> | null }>, notificationPreferences: { __typename?: 'NotificationPreferences', customRitualActivity: Array<NotificationPreferenceChannel>, dailyDelivery: Array<NotificationPreferenceChannel>, feedbacks: Array<NotificationPreferenceChannel>, newFeatures: Array<NotificationPreferenceChannel>, recommendations: Array<NotificationPreferenceChannel>, reminders: Array<NotificationPreferenceChannel>, ritualInvite: Array<NotificationPreferenceChannel>, siteActivity: Array<NotificationPreferenceChannel>, specialOffers: Array<NotificationPreferenceChannel>, startingRitual: Array<NotificationPreferenceChannel>, weeklySummary: Array<NotificationPreferenceChannel> }, organization?: { __typename?: 'Organization', _id: string, name: string } | null, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, fullname?: string | null, state: UserState, phone?: string | null, imageUrl?: string | null }, permissions: Array<{ __typename?: 'UserPermissions', totemId?: string | null, userGroup: UserPermission, totem?: { __typename?: 'Totem', fullname: string } | null }>, visitedSites?: Array<{ __typename?: 'VisitedSite', _id: string, name: string, createdAt: number, visitedAt: number }> | null, defaultTruckColumn?: { __typename?: 'MicrostoreColumn', _id: string, name: string, siteId: string, siteName: string } | null, wallet: { __typename?: 'Wallet', credits: Array<{ __typename?: 'Credit', _id: string, createdAt: number, updatedAt: number, name: string, initialAmount: number, currentAmount: number, expirationDate: number, startDate: number, type: CreditType, refundedAt?: number | null, createdBy?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null, organizationBatched?: { __typename?: 'Organization', name: string } | null, owner?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null }>, subventions: Array<{ __typename?: 'Subvention', _id: string, name: string, description: string, categories: Array<string>, cumulative?: boolean | null, currentAmount?: number | null, remainingAmount?: number | null, hoursIntervalsAvailable: Array<Array<string>>, imageUrl?: string | null, reload?: SubventionReloadPeriod | null, organization?: { __typename?: 'Organization', _id: string, name: string } | null }>, organizationCard?: { __typename?: 'OrganizationCard', _id: string, state: OrganizationCardState } | null, creditCards: Array<{ __typename?: 'CreditCard', _id: string, default: boolean, expired?: boolean | null, paymentType: string, provider: CreditCardProvider, retries: number, details: { __typename?: 'CreditCardDetails', number?: string | null, expiration?: string | null, bank?: string | null, country?: string | null, expYear?: string | null, expMonth?: string | null } }>, mealVouchers: Array<{ __typename?: 'MealVoucher', _id: string, cardType: CardType, default: boolean, expired?: boolean | null, paymentType: string, provider: MealVoucherProvider, details: { __typename?: 'MealVoucherDetails', number?: string | null, username?: string | null, expiration?: string | null, bank?: string | null, country?: string | null } }> } };

export type LoggedInUserFragmentFragment = { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', firstname?: string | null, imageUrl?: string | null, lastname?: string | null }, permissions: Array<{ __typename?: 'UserPermissions', totemId?: string | null, userGroup: UserPermission }> };

export type NotificationPreferencesFragment = { __typename?: 'NotificationPreferences', customRitualActivity: Array<NotificationPreferenceChannel>, dailyDelivery: Array<NotificationPreferenceChannel>, feedbacks: Array<NotificationPreferenceChannel>, newFeatures: Array<NotificationPreferenceChannel>, recommendations: Array<NotificationPreferenceChannel>, reminders: Array<NotificationPreferenceChannel>, ritualInvite: Array<NotificationPreferenceChannel>, siteActivity: Array<NotificationPreferenceChannel>, specialOffers: Array<NotificationPreferenceChannel>, startingRitual: Array<NotificationPreferenceChannel>, weeklySummary: Array<NotificationPreferenceChannel> };

export type WalletFragmentFragment = { __typename?: 'Wallet', credits: Array<{ __typename?: 'Credit', _id: string, createdAt: number, updatedAt: number, name: string, initialAmount: number, currentAmount: number, expirationDate: number, startDate: number, type: CreditType, refundedAt?: number | null, createdBy?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null, organizationBatched?: { __typename?: 'Organization', name: string } | null, owner?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null }>, subventions: Array<{ __typename?: 'Subvention', _id: string, name: string, description: string, categories: Array<string>, cumulative?: boolean | null, currentAmount?: number | null, remainingAmount?: number | null, hoursIntervalsAvailable: Array<Array<string>>, imageUrl?: string | null, reload?: SubventionReloadPeriod | null, organization?: { __typename?: 'Organization', _id: string, name: string } | null }>, organizationCard?: { __typename?: 'OrganizationCard', _id: string, state: OrganizationCardState } | null, creditCards: Array<{ __typename?: 'CreditCard', _id: string, default: boolean, expired?: boolean | null, paymentType: string, provider: CreditCardProvider, retries: number, details: { __typename?: 'CreditCardDetails', number?: string | null, expiration?: string | null, bank?: string | null, country?: string | null, expYear?: string | null, expMonth?: string | null } }>, mealVouchers: Array<{ __typename?: 'MealVoucher', _id: string, cardType: CardType, default: boolean, expired?: boolean | null, paymentType: string, provider: MealVoucherProvider, details: { __typename?: 'MealVoucherDetails', number?: string | null, username?: string | null, expiration?: string | null, bank?: string | null, country?: string | null } }> };

export type WarehouseDeliveryProductFragmentFragment = { __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean };

export type UrbantzDeliveryFragmentFragment = { __typename?: 'WarehouseDelivery', label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> };

export type WarehouseDeliveryFragmentFragment = { __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> };

export type WarehouseReturnFragmentFragment = { __typename?: 'WarehouseReturn', _id: string, createdAt: number, date: string, originColumnId: string, warehouseColumnId: string, state: WarehouseReturnState, updatedAt: number, brokenProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, expiredProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, originColumn: { __typename?: 'Column', name: string }, warehouseColumn: { __typename?: 'Column', name: string }, returnedProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, returnedWithNoStockUpdateProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, stateHistory: Array<{ __typename?: 'WarehouseReturnStateHistory', createdAt: number, state: WarehouseReturnState }> };

export type UpdateAdvertisementScreenConfigMutationVariables = Exact<{
  advertisementScreenConfigUpdateInput: AdvertisementScreenConfigUpdateInput;
}>;


export type UpdateAdvertisementScreenConfigMutation = { __typename?: 'Mutation', updateAdvertisementScreenConfig: { __typename?: 'AdvertisementScreenConfig', _id: string, imageUrls: Array<string> } };

export type CreateBadgeMutationVariables = Exact<{
  badge: CreateBadgeInput;
}>;


export type CreateBadgeMutation = { __typename?: 'Mutation', createBadge: { __typename?: 'BadgeResult', success: boolean, error?: string | null, badge?: { __typename?: 'Badge', name: string, type: BadgeType, imageUrl: string } | null } };

export type UpdateBadgeMutationVariables = Exact<{
  badge: UpdateBadgeInput;
}>;


export type UpdateBadgeMutation = { __typename?: 'Mutation', updateBadge: { __typename?: 'BadgeResult', success: boolean, error?: string | null, badge?: { __typename?: 'Badge', name: string, type: BadgeType, imageUrl: string } | null } };

export type CreateBundlesMutationVariables = Exact<{
  flow: ProductFlow;
  deliveryType: DeliveryDestinationType;
  deliveryDate: Scalars['String']['input'];
  warehouseColumnId: Scalars['ID']['input'];
}>;


export type CreateBundlesMutation = { __typename?: 'Mutation', createBundles: { __typename?: 'CreateBundlesResult', success?: boolean | null, errors?: Array<string> | null } };

export type UpdateBundleStateMutationVariables = Exact<{
  bundleId: Scalars['String']['input'];
  state: BundleState;
}>;


export type UpdateBundleStateMutation = { __typename?: 'Mutation', updateBundleState: { __typename?: 'BundleReturn', success: boolean, error?: string | null, bundle?: { __typename?: 'Bundle', _id: string, state: BundleState } | null } };

export type UpdateBundleMutationVariables = Exact<{
  bundle: BundleInput;
  shouldUpdateStocks: Scalars['Boolean']['input'];
}>;


export type UpdateBundleMutation = { __typename?: 'Mutation', updateBundle: { __typename?: 'BundleReturn', success: boolean, error?: string | null, bundle?: { __typename?: 'Bundle', _id: string, createdAt: number, scheduledPreparationDate: string, number: number, numberOfReferences: number, numberOfUnits: number, operatorName?: string | null, preparationDuration?: number | null, state: BundleState, type: ProductFlow, containerType: ContainerType, boxes: Array<{ __typename?: 'Box', _id: string, deliveryId: string, deliveryCode: string, siteName?: string | null, totemId?: string | null, hasOnsiteSetup: boolean, label: string, orderId?: string | null, position?: number | null, roundColor: string, roundName: string, code?: string | null, bundleId?: string | null, state: BoxState, number: number, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, products: Array<{ __typename?: 'BoxProduct', _id: string, boxId?: string | null, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }>, column?: { __typename?: 'Column', fullname: string, name: string, type: ColumnType } | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null }>, preparationDates: { __typename?: 'PreparationDates', start?: string | null, end?: string | null }, stateHistory: Array<{ __typename?: 'BundleStateHistory', state: BundleState, createdAt: number, createdByName?: string | null }>, warehouseColumn: { __typename?: 'Column', _id: string, name: string } } | null } };

export type UpdateCategoryMutationVariables = Exact<{
  categoryId: Scalars['ID']['input'];
  fields: CategoryUpdateInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'CategoryUpdateResponse', success: boolean, error?: string | null, category?: { __typename?: 'Category', _id: string, createdAt: number, updatedAt: number, indexDisplay: number, isFreefood: boolean, isMicrostore: boolean, isPunctual: boolean, imageUrl?: string | null, shouldShowSubcategories: boolean, state: CategoryState, title: string, stateHistory: Array<{ __typename?: 'CategoryStateHistory', state: CategoryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }> } | null } };

export type UpdateCategoryStateMutationVariables = Exact<{
  categoryId: Scalars['ID']['input'];
  stateToSet: CategoryState;
}>;


export type UpdateCategoryStateMutation = { __typename?: 'Mutation', updateCategoryState: { __typename?: 'CategoryUpdateResponse', success: boolean, error?: string | null, category?: { __typename?: 'Category', _id: string, createdAt: number, updatedAt: number, indexDisplay: number, isFreefood: boolean, isMicrostore: boolean, isPunctual: boolean, imageUrl?: string | null, shouldShowSubcategories: boolean, state: CategoryState, title: string, stateHistory: Array<{ __typename?: 'CategoryStateHistory', state: CategoryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }> } | null } };

export type CreateCategoryMutationVariables = Exact<{
  fields: CategoryUpdateInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'CategoryCreateResponse', success: boolean, error?: string | null, categoryId?: string | null } };

export type CreateColumnInventoryStockMutationVariables = Exact<{
  columnId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  explanation: Scalars['String']['input'];
}>;


export type CreateColumnInventoryStockMutation = { __typename?: 'Mutation', createColumnInventoryStock: { __typename?: 'ErrorCheck', success: boolean, error?: string | null } };

export type CreateColumnInventoryStocksMutationVariables = Exact<{
  columnId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  explanation: Scalars['String']['input'];
}>;


export type CreateColumnInventoryStocksMutation = { __typename?: 'Mutation', createColumnInventoryStocks: { __typename?: 'ErrorCheck', success: boolean, error?: string | null } };

export type CreateZeroColumnInventoryStocksMutationVariables = Exact<{
  columnProducts: Array<ColumnProductRefInput> | ColumnProductRefInput;
}>;


export type CreateZeroColumnInventoryStocksMutation = { __typename?: 'Mutation', createZeroColumnInventoryStocks: { __typename?: 'ErrorCheck', success: boolean, error?: string | null } };

export type AnswerToCommentMutationVariables = Exact<{
  body: Scalars['String']['input'];
  answerToCommentId: Scalars['ID']['input'];
}>;


export type AnswerToCommentMutation = { __typename?: 'Mutation', answerToComment: { __typename?: 'Comment', _id: string } };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: boolean };

export type CreateConsumptionVariationMutationVariables = Exact<{
  consumptionVariationCreateInput: ConsumptionVariationCreateInput;
}>;


export type CreateConsumptionVariationMutation = { __typename?: 'Mutation', createConsumptionVariation: { __typename?: 'ConsumptionVariation', _id: string, createdAt: number, endDate: string, siteId: string, startDate: string, updatedAt: number, dessert: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, main: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, smallBites: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, starter: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number } } };

export type UpdateConsumptionVariationMutationVariables = Exact<{
  consumptionVariationUpdateInput: ConsumptionVariationUpdateInput;
}>;


export type UpdateConsumptionVariationMutation = { __typename?: 'Mutation', updateConsumptionVariation: { __typename?: 'ConsumptionVariation', _id: string, createdAt: number, endDate: string, siteId: string, startDate: string, updatedAt: number, dessert: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, main: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, smallBites: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, starter: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number } } };

export type UpdatePhotoIssuesMutationVariables = Exact<{
  controlPhoto: ControlPhotoInput;
}>;


export type UpdatePhotoIssuesMutation = { __typename?: 'Mutation', updatePhotoIssues: { __typename?: 'ControlPhotoMutationResult', success: boolean, error?: string | null, controlPhoto?: { __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null } | null } };

export type BatchCreditsMutationVariables = Exact<{
  credit: CreditInput;
  where: CreditsBatchFilter;
}>;


export type BatchCreditsMutation = { __typename?: 'Mutation', batchCredits: { __typename?: 'CreditsBatchResult', success: boolean, error?: string | null, credits?: Array<{ __typename?: 'Credit', _id: string }> | null } };

export type MarkDeliveriesAsDeliveredMutationVariables = Exact<{
  deliveryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkDeliveriesAsDeliveredMutation = { __typename?: 'Mutation', markDeliveriesAsDelivered: { __typename?: 'DeliveriesStateUpdateResult', errors: Array<string>, updatedDeliveries: Array<{ __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdByName?: string | null }>, boxes: Array<{ __typename?: 'Box', _id: string, bundleId?: string | null, state: BoxState, label: string, number: number, code?: string | null, deliveryCode: string, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null, column?: { __typename?: 'Column', name: string, fullname: string, type: ColumnType } | null, products: Array<{ __typename?: 'BoxProduct', _id: string, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, boxId?: string | null, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }> }>, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null }> } };

export type MarkDeliveriesAsAbortedMutationVariables = Exact<{
  deliveryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkDeliveriesAsAbortedMutation = { __typename?: 'Mutation', markDeliveriesAsAborted: { __typename?: 'DeliveriesStateUpdateResult', errors: Array<string>, updatedDeliveries: Array<{ __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdByName?: string | null }>, boxes: Array<{ __typename?: 'Box', _id: string, bundleId?: string | null, state: BoxState, label: string, number: number, code?: string | null, deliveryCode: string, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null, column?: { __typename?: 'Column', name: string, fullname: string, type: ColumnType } | null, products: Array<{ __typename?: 'BoxProduct', _id: string, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, boxId?: string | null, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }> }>, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null }> } };

export type MarkDeliveriesAsArchivedMutationVariables = Exact<{
  deliveryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkDeliveriesAsArchivedMutation = { __typename?: 'Mutation', markDeliveriesAsArchived: { __typename?: 'DeliveriesStateUpdateResult', errors: Array<string>, updatedDeliveries: Array<{ __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdByName?: string | null }>, boxes: Array<{ __typename?: 'Box', _id: string, bundleId?: string | null, state: BoxState, label: string, number: number, code?: string | null, deliveryCode: string, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null, column?: { __typename?: 'Column', name: string, fullname: string, type: ColumnType } | null, products: Array<{ __typename?: 'BoxProduct', _id: string, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, boxId?: string | null, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }> }>, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null }> } };

export type MarkDeliveriesAsInProgressMutationVariables = Exact<{
  deliveryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkDeliveriesAsInProgressMutation = { __typename?: 'Mutation', markDeliveriesAsInProgress: { __typename?: 'DeliveriesStateUpdateResult', errors: Array<string>, updatedDeliveries: Array<{ __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdByName?: string | null }>, boxes: Array<{ __typename?: 'Box', _id: string, bundleId?: string | null, state: BoxState, label: string, number: number, code?: string | null, deliveryCode: string, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null, column?: { __typename?: 'Column', name: string, fullname: string, type: ColumnType } | null, products: Array<{ __typename?: 'BoxProduct', _id: string, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, boxId?: string | null, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }> }>, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null }> } };

export type MarkDeliveriesAsPackagingMutationVariables = Exact<{
  deliveryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkDeliveriesAsPackagingMutation = { __typename?: 'Mutation', markDeliveriesAsPackaging: { __typename?: 'DeliveriesStateUpdateResult', errors: Array<string>, updatedDeliveries: Array<{ __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdByName?: string | null }>, boxes: Array<{ __typename?: 'Box', _id: string, bundleId?: string | null, state: BoxState, label: string, number: number, code?: string | null, deliveryCode: string, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null, column?: { __typename?: 'Column', name: string, fullname: string, type: ColumnType } | null, products: Array<{ __typename?: 'BoxProduct', _id: string, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, boxId?: string | null, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }> }>, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null }> } };

export type MarkDeliveriesAsReadyMutationVariables = Exact<{
  deliveryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkDeliveriesAsReadyMutation = { __typename?: 'Mutation', markDeliveriesAsReady: { __typename?: 'DeliveriesStateUpdateResult', errors: Array<string>, updatedDeliveries: Array<{ __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdByName?: string | null }>, boxes: Array<{ __typename?: 'Box', _id: string, bundleId?: string | null, state: BoxState, label: string, number: number, code?: string | null, deliveryCode: string, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null, column?: { __typename?: 'Column', name: string, fullname: string, type: ColumnType } | null, products: Array<{ __typename?: 'BoxProduct', _id: string, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, boxId?: string | null, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }> }>, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null }> } };

export type CreateDeliveryForOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type CreateDeliveryForOrderMutation = { __typename?: 'Mutation', createDeliveryForOrder: { __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null } };

export type CreateDeliveryForSiteMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  deliveryDate: Scalars['String']['input'];
}>;


export type CreateDeliveryForSiteMutation = { __typename?: 'Mutation', createDeliveryForSite: { __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null } };

export type UpdateDeliveryDateMutationVariables = Exact<{
  deliveryId: Scalars['ID']['input'];
  deliveryDate: Scalars['String']['input'];
}>;


export type UpdateDeliveryDateMutation = { __typename?: 'Mutation', updateDeliveryDate: { __typename?: 'DeliveryDateUpdateResult', errors: Array<string>, updatedDelivery?: { __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null } | null } };

export type UpdateDeliveryMutationVariables = Exact<{
  delivery: DeliveryInput;
  shouldUpdateStocks: Scalars['Boolean']['input'];
}>;


export type UpdateDeliveryMutation = { __typename?: 'Mutation', updateDelivery: { __typename?: 'DeliveryResult', success: boolean, error?: string | null, delivery?: { __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, boxes: Array<{ __typename?: 'Box', _id: string, bundleId?: string | null, state: BoxState, label: string, number: number, code?: string | null, deliveryCode: string, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null, column?: { __typename?: 'Column', name: string, fullname: string, type: ColumnType } | null, products: Array<{ __typename?: 'BoxProduct', _id: string, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, boxId?: string | null, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }> }>, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null } | null } };

export type UpdateDeliveryPlanningMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  date: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
}>;


export type UpdateDeliveryPlanningMutation = { __typename?: 'Mutation', updateDeliveryPlanning: { __typename?: 'DeliveryPlanningUpdateResult', success: boolean } };

export type UpdateDeliveryPlanningBatchMutationVariables = Exact<{
  deliveryPlanningBatchUpdate: Array<DeliveryPlanningBatchUpdateInput> | DeliveryPlanningBatchUpdateInput;
}>;


export type UpdateDeliveryPlanningBatchMutation = { __typename?: 'Mutation', updateDeliveryPlanningBatch: { __typename?: 'DeliveryPlanningUpdateResult', success: boolean } };

export type AddClosingDateRangeToSitesMutationVariables = Exact<{
  siteIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  range: SiteClosingDatesRangeInput;
}>;


export type AddClosingDateRangeToSitesMutation = { __typename?: 'Mutation', addClosingDateRangeToSites: { __typename?: 'BatchSiteClosingResult', success: boolean } };

export type CreateDeliveryZoneMutationVariables = Exact<{
  input: CreateDeliveryZoneInput;
}>;


export type CreateDeliveryZoneMutation = { __typename?: 'Mutation', createDeliveryZone: { __typename?: 'DeliveryZone', _id: string, name: string, color: string, state: DeliveryZoneState, referentDelivererId?: string | null, sitesCount: number, createdAt: number, updatedAt: number, referentDeliverer?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null } };

export type UpdateDeliveryZoneMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateDeliveryZoneInput;
}>;


export type UpdateDeliveryZoneMutation = { __typename?: 'Mutation', updateDeliveryZone: { __typename?: 'DeliveryZone', _id: string, name: string, color: string, state: DeliveryZoneState, referentDelivererId?: string | null, sitesCount: number, createdAt: number, updatedAt: number, referentDeliverer?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null } };

export type AssignSitesToDeliveryZoneMutationVariables = Exact<{
  deliveryZoneId?: InputMaybe<Scalars['ID']['input']>;
  siteIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AssignSitesToDeliveryZoneMutation = { __typename?: 'Mutation', assignSitesToDeliveryZone: { __typename?: 'DeliveryZoneAssignResult', success: boolean, modifiedCount: number } };

export type UpdateDynamicDeliveryPlanningBatchMutationVariables = Exact<{
  updates: Array<DynamicDeliveryPlanningBatchUpdateInput> | DynamicDeliveryPlanningBatchUpdateInput;
}>;


export type UpdateDynamicDeliveryPlanningBatchMutation = { __typename?: 'Mutation', updateDynamicDeliveryPlanningBatch: { __typename?: 'DynamicDeliveryPlanningUpdateResult', dynamicDeliveryPlannings: Array<{ __typename?: 'DynamicDeliveryPlanning', _id: string, isActive: boolean, isManual: boolean }> } };

export type UpdateDynamicDeliveryPlanningDelivererMutationVariables = Exact<{
  planningIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  delivererId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateDynamicDeliveryPlanningDelivererMutation = { __typename?: 'Mutation', updateDynamicDeliveryPlanningDeliverer: { __typename?: 'DynamicDeliveryPlanningUpdateResult', dynamicDeliveryPlannings: Array<{ __typename?: 'DynamicDeliveryPlanning', _id: string, tourOrder?: number | null, assignedDelivererId?: string | null, assignedDeliverer?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null }> } };

export type ReorderDynamicDeliveryPlanningTourMutationVariables = Exact<{
  planningIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderDynamicDeliveryPlanningTourMutation = { __typename?: 'Mutation', reorderDynamicDeliveryPlanningTour: { __typename?: 'DynamicDeliveryPlanningUpdateResult', dynamicDeliveryPlannings: Array<{ __typename?: 'DynamicDeliveryPlanning', _id: string, tourOrder?: number | null }> } };

export type RegenerateDynamicDeliveryPlanningsMutationVariables = Exact<{
  date: Scalars['String']['input'];
  overrideManualChanges?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RegenerateDynamicDeliveryPlanningsMutation = { __typename?: 'Mutation', regenerateDynamicDeliveryPlannings: { __typename?: 'RegenerateDynamicDeliveryPlanningsResult', success: boolean, error?: string | null } };

export type CreateEquipmentMutationVariables = Exact<{
  createFields: EquipmentUpdateFields;
}>;


export type CreateEquipmentMutation = { __typename?: 'Mutation', createEquipment: { __typename?: 'EquipmentResult', error?: string | null, success: boolean, equipment?: { __typename?: 'Equipment', _id: string, createdAt: number, updatedAt: number, name: string, brand?: string | null, volume?: string | null, price?: number | null, imageUrl?: string | null, description?: string | null, hidden: boolean, height?: number | null, width?: number | null, length?: number | null, weight?: number | null, state: EquipmentState, suppliers?: Array<{ __typename?: 'EquipmentSupplier', _id: string, name?: string | null } | null> | null, stateHistory: Array<{ __typename?: 'EquipmentStateHistory', createdAt: number, createdBy?: string | null, state: EquipmentState }> } | null } };

export type UpdateEquipmentMutationVariables = Exact<{
  equipmentId: Scalars['ID']['input'];
  updateFields: EquipmentUpdateFields;
}>;


export type UpdateEquipmentMutation = { __typename?: 'Mutation', updateEquipment: { __typename?: 'EquipmentResult', error?: string | null, success: boolean, equipment?: { __typename?: 'Equipment', _id: string, createdAt: number, updatedAt: number, name: string, brand?: string | null, volume?: string | null, price?: number | null, imageUrl?: string | null, description?: string | null, hidden: boolean, height?: number | null, width?: number | null, length?: number | null, weight?: number | null, state: EquipmentState, suppliers?: Array<{ __typename?: 'EquipmentSupplier', _id: string, name?: string | null } | null> | null, stateHistory: Array<{ __typename?: 'EquipmentStateHistory', createdAt: number, createdBy?: string | null, state: EquipmentState }> } | null } };

export type UpdateEquipmentStateMutationVariables = Exact<{
  equipmentId: Scalars['ID']['input'];
  stateToSet: EquipmentState;
}>;


export type UpdateEquipmentStateMutation = { __typename?: 'Mutation', updateEquipmentState: { __typename?: 'EquipmentResult', success: boolean, error?: string | null, equipment?: { __typename?: 'Equipment', _id: string, createdAt: number, updatedAt: number, name: string, brand?: string | null, volume?: string | null, price?: number | null, imageUrl?: string | null, description?: string | null, hidden: boolean, height?: number | null, width?: number | null, length?: number | null, weight?: number | null, state: EquipmentState, suppliers?: Array<{ __typename?: 'EquipmentSupplier', _id: string, name?: string | null } | null> | null, stateHistory: Array<{ __typename?: 'EquipmentStateHistory', createdAt: number, createdBy?: string | null, state: EquipmentState }> } | null } };

export type GetImpersonationTokenMutationVariables = Exact<{
  impersonatedUserId: Scalars['String']['input'];
  impersonatedOrganizationName: Scalars['String']['input'];
}>;


export type GetImpersonationTokenMutation = { __typename?: 'Mutation', getConnectionToken: { __typename?: 'ImpersonationResult', success: boolean, error?: string | null, connectionToken?: string | null } };

export type UpdateLocationsStateMutationVariables = Exact<{
  locationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  stateToSet: LocationState;
}>;


export type UpdateLocationsStateMutation = { __typename?: 'Mutation', updateLocationsState: { __typename?: 'LocationsUpdateResult', error?: string | null, warnings?: Array<string> | null, locations?: Array<{ __typename?: 'Location', _id: string, datamatrix: string, state: LocationState }> | null } };

export type AssignReserveLocationMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  datamatrix: Scalars['String']['input'];
  warehouseColumnId: Scalars['ID']['input'];
}>;


export type AssignReserveLocationMutation = { __typename?: 'Mutation', assignReserveLocation: { __typename?: 'LocationAssignResult', error?: string | null, location?: { __typename?: 'Location', _id: string, datamatrix: string, locationType: LocationType } | null } };

export type UpdateLocationTypeMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  locationType: LocationType;
}>;


export type UpdateLocationTypeMutation = { __typename?: 'Mutation', updateLocationType: { __typename?: 'Location', _id: string, locationType: LocationType } };

export type SwapProductLocationsMutationVariables = Exact<{
  locationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SwapProductLocationsMutation = { __typename?: 'Mutation', swapProductLocations: { __typename?: 'LocationsUpdateResult', error?: string | null, warnings?: Array<string> | null, locations?: Array<{ __typename?: 'Location', _id: string, productId?: string | null, product?: { __typename?: 'Product', name: string } | null }> | null } };

export type AssignLocationToProductMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  datamatrix: Scalars['String']['input'];
  warehouseColumnId: Scalars['ID']['input'];
  locationType: LocationType;
}>;


export type AssignLocationToProductMutation = { __typename?: 'Mutation', assignLocationToProduct: { __typename?: 'LocationAssignResult', error?: string | null, location?: { __typename?: 'Location', _id: string, datamatrix: string, locationType: LocationType } | null } };

export type UnassignLocationFromProductMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  datamatrix: Scalars['String']['input'];
  warehouseColumnId: Scalars['ID']['input'];
}>;


export type UnassignLocationFromProductMutation = { __typename?: 'Mutation', unassignLocationFromProduct: { __typename?: 'LocationAssignResult', error?: string | null, location?: { __typename?: 'Location', _id: string, datamatrix: string } | null } };

export type UpdateManualSupplyOrdersMutationVariables = Exact<{
  supplyOrders: Array<ManualSupplyOrderUpdateInput> | ManualSupplyOrderUpdateInput;
}>;


export type UpdateManualSupplyOrdersMutation = { __typename?: 'Mutation', updateManualSupplyOrders: { __typename?: 'ManualSupplyOrderUpdateResult', success: boolean, errors: Array<string>, warnings: Array<string>, formErrors: Array<{ __typename?: 'FormError', sectionName: string, sectionErrors: Array<{ __typename?: 'SectionError', fieldName: string, fieldError: string }> }>, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type UpdateManualSupplyOrderProductStockVariationsMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateManualSupplyOrderProductStockVariationsMutation = { __typename?: 'Mutation', updateManualSupplyOrderProductStockVariations: { __typename?: 'ManualSupplyOrderProductStockVariationsResult', success: boolean, supplyOrderProductStockVariations: { __typename?: 'SupplyOrderProductStockVariations', productGroupStockVariations: Array<{ __typename?: 'ProductStockVariation', isComputed: boolean, computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } }>, supplyOrderStockVariations: Array<{ __typename?: 'ProductStockVariation', isComputed: boolean, computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } }> } } };

export type UpdateManualSupplyOrderForecastsMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateManualSupplyOrderForecastsMutation = { __typename?: 'Mutation', updateManualSupplyOrderForecasts: { __typename?: 'ManualSupplyOrderForecastsResult', success: boolean, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type AddProductsToManualSupplyOrderMutationVariables = Exact<{
  supplyOrderId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddProductsToManualSupplyOrderMutation = { __typename?: 'Mutation', addProductsToManualSupplyOrder: { __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } } };

export type UpdateMenuInstructionsMutationVariables = Exact<{
  menuInstructionInputs: Array<MenuInstructionInput> | MenuInstructionInput;
}>;


export type UpdateMenuInstructionsMutation = { __typename?: 'Mutation', createOrUpdateMenuInstructions: Array<{ __typename?: 'MenuInstruction', _id: string, createdAt: number, updatedAt: number, date: string, microstoreColumnId: string, categoryId: string, type: MenuInstructionType, value: number }> };

export type DeleteMenuInstructionsMutationVariables = Exact<{
  menuInstructionDeleteInputs: Array<MenuInstructionDeleteInput> | MenuInstructionDeleteInput;
}>;


export type DeleteMenuInstructionsMutation = { __typename?: 'Mutation', deleteMenuInstructions: boolean };

export type UpdateSiteMenusMutationVariables = Exact<{
  columnId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  locationsToUpdate: Array<LocationToUpdateInput> | LocationToUpdateInput;
}>;


export type UpdateSiteMenusMutation = { __typename?: 'Mutation', updateSiteMenus: { __typename?: 'SiteMenus', siteId: string, columns: Array<{ __typename?: 'ColumMenus', columnId: string, dailyMenus: Array<{ __typename?: 'DailyMenu', date: string, productLocations: Array<{ __typename?: 'MenuProductLocation', product?: { __typename?: 'Product', _id: string, fullname: string } | null, location: { __typename?: 'MicrostoreLocation', _id: string } }> }> }> } };

export type UpdateMenuProductArrangementsMutationVariables = Exact<{
  date: Scalars['String']['input'];
  productArrangementsToUpdate: Array<ProductArrangementToUpdateInput> | ProductArrangementToUpdateInput;
}>;


export type UpdateMenuProductArrangementsMutation = { __typename?: 'Mutation', updateMenuProductArrangements: Array<{ __typename?: 'MenuProductArrangement', productArrangementId: string, productArrangementName: string, productArrangementMainCategoryId: string, productArrangementIndexes: Array<{ __typename?: 'MenuProductArrangementIndex', productArrangementIndex: number, rotations: Array<{ __typename?: 'MenuRotation', rotationNumber: number, products: Array<{ __typename?: 'MenuProduct', quantity: number, nbLocations: number, isInProductArrangement: boolean, product: { __typename?: 'Product', _id: string, fullname: string, imageUrl?: string | null, state: ProductState, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, supplier?: { __typename?: 'Supplier', _id: string, name: string } | null } }> }> }> }> };

export type GenerateMenusSupplyOrdersMutationVariables = Exact<{
  date: Scalars['String']['input'];
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  supplierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  updateOrderProductIfPossible?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GenerateMenusSupplyOrdersMutation = { __typename?: 'Mutation', generateMenusSupplyOrders: { __typename?: 'GenerateMenusSupplyOrders', success: boolean, error?: string | null } };

export type GenerateQuantitiesMutationVariables = Exact<{
  mondayDate: Scalars['String']['input'];
  dates?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  supplierIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  reGenerateMenuFromZero: Scalars['Boolean']['input'];
}>;


export type GenerateQuantitiesMutation = { __typename?: 'Mutation', generateQuantities: { __typename?: 'GenerateQuantities', success: boolean, error?: string | null } };

export type GenerateSiteMenusMutationVariables = Exact<{
  date: Scalars['String']['input'];
  stockMin?: InputMaybe<Scalars['Int']['input']>;
  consumptionRatioToApply?: InputMaybe<Scalars['Int']['input']>;
  unknownShrinkageRatioToApply?: InputMaybe<Scalars['Int']['input']>;
  withoutRotation: Scalars['Boolean']['input'];
}>;


export type GenerateSiteMenusMutation = { __typename?: 'Mutation', generateSiteMenus: { __typename?: 'GenerateSiteMenus', success: boolean, error?: string | null } };

export type UpdateMenuFromGsheetMutationVariables = Exact<{
  mondayDate: Scalars['String']['input'];
}>;


export type UpdateMenuFromGsheetMutation = { __typename?: 'Mutation', updateMenuFromGsheet: { __typename?: 'ErrorCheck', success: boolean, error?: string | null } };

export type CreateMessagesSetMutationVariables = Exact<{
  messagesSetInput: CreateMessagesSetInput;
}>;


export type CreateMessagesSetMutation = { __typename?: 'Mutation', createMessagesSet: { __typename?: 'CreateMessagesSetResult', success: boolean, errors?: Array<string> | null, createdMessagesSet?: { __typename?: 'MessagesSet', _id: string, createdAt: number, name: string, state: MessagesSetState, updatedAt: number, messages: Array<{ __typename?: 'Message', body: string, redirectUrl?: string | null }> } | null } };

export type UpdateMessagesSetMutationVariables = Exact<{
  messagesSetId: Scalars['ID']['input'];
  updateInput: UpdateMessagesSetInput;
}>;


export type UpdateMessagesSetMutation = { __typename?: 'Mutation', updateMessagesSet: { __typename?: 'UpdateMessagesSetResult', success: boolean, errors?: Array<string> | null, updatedMessagesSet?: { __typename?: 'MessagesSet', _id: string, createdAt: number, name: string, state: MessagesSetState, updatedAt: number, messages: Array<{ __typename?: 'Message', body: string, redirectUrl?: string | null }> } | null } };

export type UpdateMicrostoreColumnMutationVariables = Exact<{
  microstoreColumnUpdateInput: MicrostoreColumnUpdateInput;
}>;


export type UpdateMicrostoreColumnMutation = { __typename?: 'Mutation', updateMicrostoreColumnMutation: { __typename?: 'MicrostoreColumnUpdateResult', errors: Array<string>, newMicrostoreColumn?: { __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> } | null } };

export type CreateMicrostoreColumnMutationVariables = Exact<{
  createMicrostoreColumnInput: CreateMicrostoreColumnInput;
}>;


export type CreateMicrostoreColumnMutation = { __typename?: 'Mutation', createMicrostoreColumnMutation: { __typename?: 'MicrostoreColumnCreateResult', errors: Array<string>, newSite?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }>, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type ReplaceMicrostoreColumnMutationVariables = Exact<{
  replaceMicrostoreColumnInput: ReplaceMicrostoreColumnInput;
}>;


export type ReplaceMicrostoreColumnMutation = { __typename?: 'Mutation', replaceMicrostoreColumnMutation: { __typename?: 'SiteUpdateResult', errors: Array<string>, newSite?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }>, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type ReplaceMicrostoreColumnTemplateMutationVariables = Exact<{
  replaceMicrostoreColumnTemplateInput: ReplaceMicrostoreColumnTemplateInput;
}>;


export type ReplaceMicrostoreColumnTemplateMutation = { __typename?: 'Mutation', replaceMicrostoreColumnTemplateMutation: { __typename?: 'SiteUpdateResult', errors: Array<string>, newSite?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }>, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type MoveColumnMutationVariables = Exact<{
  columnId: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
  columnGroupId: Scalars['ID']['input'];
  positionInColumnGroup: Scalars['Int']['input'];
}>;


export type MoveColumnMutation = { __typename?: 'Mutation', moveColumnMutation: { __typename?: 'SiteUpdateResult', errors: Array<string>, newSite?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }>, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type UpdateColumnInfoMutationVariables = Exact<{
  columnId: Scalars['String']['input'];
  isPaused: Scalars['Boolean']['input'];
  removalDate?: InputMaybe<Scalars['String']['input']>;
  startingDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateColumnInfoMutation = { __typename?: 'Mutation', updateColumnInfoMutation: { __typename?: 'SiteUpdateResult', errors: Array<string>, newSite?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }>, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type DeleteMicrostoreColumnMutationVariables = Exact<{
  microstoreColumnId: Scalars['String']['input'];
}>;


export type DeleteMicrostoreColumnMutation = { __typename?: 'Mutation', deleteMicrostoreColumnMutation: { __typename?: 'SiteUpdateResult', errors: Array<string>, newSite?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }>, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type ValidateMicrostoresReassortmentMutationVariables = Exact<{
  reassortmentFlow: ReassortmentFlow;
  reassortmentDate?: InputMaybe<Scalars['String']['input']>;
  microstoreColumnIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  siteIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ValidateMicrostoresReassortmentMutation = { __typename?: 'Mutation', validateMicrostoresReassortmentMutation: { __typename?: 'MicrostoreColumnsUpdateResult', errors: Array<string>, warnings: Array<string>, microstoreColumns?: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, microstoreColumnTemplateId: string, microstoreColumnTemplateName: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, removalDate?: string | null, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, type: MicrostoreColumnTemplateType, microstoreColumnType: MicrostoreColumnType, siteId: string, siteName: string, isRegular: boolean, nextReassortmentStockTransfers: Array<{ __typename?: 'StockTransfer', _id: string, createdAt: number, updatedAt: number, transferDate: string, destinationColumnId: string, originColumnId: string, deliveryId?: string | null, reassortmentFlow?: ReassortmentFlow | null, shouldUpdateStockImmediately: boolean, state: StockTransferState, destinationColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, originColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, products: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, conditionning: number, packagesPerBatch: number, originStockAvailable: number, destinationStockAvailable: number, quantity: number }>, delivery?: { __typename?: 'Delivery', state: DeliveryState } | null, stateHistory: Array<{ __typename?: 'StockTransferStateHistory', state: StockTransferState, createdAt: number, createdBy: string, createdByName?: string | null }> }> }> | null } };

export type UpdateMicrostoresReassortmentForFreshFlowMutationVariables = Exact<{
  microstoreColumnIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  reassortmentDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMicrostoresReassortmentForFreshFlowMutation = { __typename?: 'Mutation', updateMicrostoresReassortmentForFreshFlowMutation: { __typename?: 'MicrostoreColumnsUpdateResult', errors: Array<string>, warnings: Array<string>, microstoreColumns?: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> | null } };

export type UpdateMicrostoresReassortmentForDryFlowMutationVariables = Exact<{
  microstoreColumnIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  reassortmentDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMicrostoresReassortmentForDryFlowMutation = { __typename?: 'Mutation', updateMicrostoresReassortmentForDryFlowMutation: { __typename?: 'MicrostoreColumnsUpdateResult', errors: Array<string>, microstoreColumns?: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> | null } };

export type LaunchFreshRestockingMutationVariables = Exact<{ [key: string]: never; }>;


export type LaunchFreshRestockingMutation = { __typename?: 'Mutation', launchFreshRestockingMutation: { __typename?: 'DefaultMutationMutipleErrorsResponse', success: boolean, errors: Array<string | null> } };

export type SyncPlanogramWithSenseiMutationVariables = Exact<{
  microstoreColumnId: Scalars['String']['input'];
  columnPhotoUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type SyncPlanogramWithSenseiMutation = { __typename?: 'Mutation', synchronizePlanogramWithSensei: { __typename?: 'DefaultMutationMutipleErrorsResponse', success: boolean, errors: Array<string | null> } };

export type SyncPlanogramWithNuMutationVariables = Exact<{
  microstoreColumnId: Scalars['String']['input'];
}>;


export type SyncPlanogramWithNuMutation = { __typename?: 'Mutation', synchronizePlanogramWithNu: { __typename?: 'DefaultMutationMutipleErrorsResponse', success: boolean, errors: Array<string | null> } };

export type SyncPlanogramWithNayaxMutationVariables = Exact<{
  microstoreColumnId: Scalars['String']['input'];
}>;


export type SyncPlanogramWithNayaxMutation = { __typename?: 'Mutation', synchronizePlanogramWithNayax: { __typename?: 'DefaultMutationMutipleErrorsResponse', success: boolean, errors: Array<string | null> } };

export type CreateMicrostoreColumnGroupMutationVariables = Exact<{
  createMicrostoreColumnGroupInput: CreateMicrostoreColumnGroupInput;
}>;


export type CreateMicrostoreColumnGroupMutation = { __typename?: 'Mutation', createMicrostoreColumnGroupMutation: { __typename?: 'MicrostoreColumnGroupUpdateResult', errors: Array<string>, newSite?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }>, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type UpdateMicrostoreColumnGroupMutationVariables = Exact<{
  microstoreColumnGroupId: Scalars['ID']['input'];
  updateMicrostoreColumnGroupInput: UpdateMicrostoreColumnGroupInput;
}>;


export type UpdateMicrostoreColumnGroupMutation = { __typename?: 'Mutation', updateMicrostoreColumnGroupMutation: { __typename?: 'MicrostoreColumnGroupUpdateResult', errors: Array<string>, newSite?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }>, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type DeleteMicrostoreColumnGroupMutationVariables = Exact<{
  microstoreColumnGroupId: Scalars['ID']['input'];
}>;


export type DeleteMicrostoreColumnGroupMutation = { __typename?: 'Mutation', deleteMicrostoreColumnGroupMutation: { __typename?: 'SiteUpdateResult', errors: Array<string>, newSite?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }>, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type AddPostSiteSetupZeroInventoryProductsMutationVariables = Exact<{
  microstoreColumnSetupId: Scalars['ID']['input'];
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddPostSiteSetupZeroInventoryProductsMutation = { __typename?: 'Mutation', addPostSiteSetupZeroInventoryProducts: { __typename?: 'MicrostoreColumnSetupResult', success: boolean, error?: string | null, microstoreColumnSetup?: { __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> } | null } };

export type CreateMicrostoreColumnTemplateMutationVariables = Exact<{
  microstoreColumnTemplate: MicrostoreColumnTemplateCreateInput;
}>;


export type CreateMicrostoreColumnTemplateMutation = { __typename?: 'Mutation', createMicrostoreColumnTemplateMutation: { __typename?: 'MicrostoreColumnTemplateCreateOrUpdateResult', errors: Array<string>, newMicrostoreColumnTemplate?: { __typename?: 'MicrostoreColumnTemplate', _id: string, name: string, type: MicrostoreColumnTemplateType, state: MicrostoreColumnTemplateState } | null } };

export type DuplicateMicrostoreColumnTemplateMutationVariables = Exact<{
  microstoreColumnTemplateId: Scalars['String']['input'];
}>;


export type DuplicateMicrostoreColumnTemplateMutation = { __typename?: 'Mutation', duplicateMicrostoreColumnTemplateMutation: { __typename?: 'MicrostoreColumnTemplateCreateOrUpdateResult', errors: Array<string>, newMicrostoreColumnTemplate?: { __typename?: 'MicrostoreColumnTemplate', _id: string, name: string, type: MicrostoreColumnTemplateType, state: MicrostoreColumnTemplateState } | null } };

export type DeleteMicrostoreColumnTemplatesMutationVariables = Exact<{
  microstoreColumnTemplateIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteMicrostoreColumnTemplatesMutation = { __typename?: 'Mutation', deleteMicrostoreColumnTemplatesMutation: { __typename?: 'MicrostoreColumnTemplateDeleteResult', deletedMicrostoreColumnTemplateIds: Array<string>, errors: Array<string> } };

export type UpdateMicrostoreColumnTemplateMutationVariables = Exact<{
  microstoreColumnTemplate: MicrostoreColumnTemplateUpdateInput;
}>;


export type UpdateMicrostoreColumnTemplateMutation = { __typename?: 'Mutation', updateMicrostoreColumnTemplateMutation: { __typename?: 'MicrostoreColumnTemplateCreateOrUpdateResult', errors: Array<string>, newMicrostoreColumnTemplate?: { __typename?: 'MicrostoreColumnTemplate', _id: string, name: string, type: MicrostoreColumnTemplateType, state: MicrostoreColumnTemplateState, shelfTemplates: Array<{ __typename?: 'MicrostoreShelfTemplate', _id: string, columnTemplateId: string, positionInColumn: number, locationTemplateTable: Array<Array<{ __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, shelfTemplateId: string, shouldOrderProductIfNotInSite: boolean, shouldSmoothProductTransition: boolean, allowProductRotation: boolean, trayMaxCapacity: number, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number }, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, productsWithStockMax: Array<{ __typename?: 'ProductArrangementProductWithStockMax', stockMax: number, product: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }>> }> } | null } };

export type UpdateMicrostoreColumnTemplateStateMutationVariables = Exact<{
  microstoreColumnTemplateId: Scalars['String']['input'];
  stateToSet: MicrostoreColumnTemplateState;
}>;


export type UpdateMicrostoreColumnTemplateStateMutation = { __typename?: 'Mutation', updateMicrostoreColumnTemplateStateMutation: { __typename?: 'MicrostoreColumnTemplateCreateOrUpdateResult', errors: Array<string>, newMicrostoreColumnTemplate?: { __typename?: 'MicrostoreColumnTemplate', _id: string, name: string, type: MicrostoreColumnTemplateType, state: MicrostoreColumnTemplateState } | null } };

export type ReplaceProductsInMicrostoreColumnTemplatesMutationVariables = Exact<{
  input: ReplaceProductsInTemplatesInput;
}>;


export type ReplaceProductsInMicrostoreColumnTemplatesMutation = { __typename?: 'Mutation', replaceProductsInMicrostoreColumnTemplatesMutation: { __typename?: 'DefaultMutationMutipleErrorsResponse', success: boolean, errors: Array<string | null> } };

export type UpdateLocationsWithTargetStockMutationVariables = Exact<{
  locationIdsWithTargetStock: Array<MicrostoreLocationIdWithTargetStockInput> | MicrostoreLocationIdWithTargetStockInput;
}>;


export type UpdateLocationsWithTargetStockMutation = { __typename?: 'Mutation', updateLocationsWithTargetStock: Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }> };

export type CreateMobilePopupMutationVariables = Exact<{
  input: CreateMobilePopupInput;
}>;


export type CreateMobilePopupMutation = { __typename?: 'Mutation', createMobilePopup: { __typename?: 'MobilePopup', _id: string, startsAt: number, endsAt: number, imageUrl?: string | null, title?: string | null, body?: string | null, siteIds?: Array<string> | null, createdAt: number, sites?: Array<{ __typename?: 'Site', _id: string, name: string } | null> | null } };

export type UpdateMobilePopupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateMobilePopupInput;
}>;


export type UpdateMobilePopupMutation = { __typename?: 'Mutation', updateMobilePopup: { __typename?: 'MobilePopup', _id: string, startsAt: number, endsAt: number, imageUrl?: string | null, title?: string | null, body?: string | null, siteIds?: Array<string> | null, createdAt: number, sites?: Array<{ __typename?: 'Site', _id: string, name: string } | null> | null } };

export type DeleteMobilePopupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMobilePopupMutation = { __typename?: 'Mutation', deleteMobilePopup: boolean };

export type UpdateNayaxMdbTemplateMutationVariables = Exact<{
  nayaxMDBTemplateId: Scalars['ID']['input'];
  input: UpdateNayaxMdbTemplateInput;
}>;


export type UpdateNayaxMdbTemplateMutation = { __typename?: 'Mutation', updateNayaxMDBTemplate: { __typename?: 'NayaxMDBTemplateMutationResult', success?: boolean | null, nayaxMDBTemplate?: { __typename?: 'NayaxMDBTemplate', _id: string, createdAt: number, updatedAt: number, name: string, associations: Array<{ __typename?: 'NayaxMDBTemplateAssociation', nayaxMDBCode: number, positionInColumn: number, positionInShelf: { __typename?: 'PositionInShelf', row: number, column: number } }> } | null } };

export type CreateNayaxMdbTemplateMutationVariables = Exact<{
  input: CreateNayaxMdbTemplateInput;
}>;


export type CreateNayaxMdbTemplateMutation = { __typename?: 'Mutation', createNayaxMDBTemplate: { __typename?: 'NayaxMDBTemplateMutationResult', success?: boolean | null, nayaxMDBTemplate?: { __typename?: 'NayaxMDBTemplate', _id: string, createdAt: number, updatedAt: number, name: string, associations: Array<{ __typename?: 'NayaxMDBTemplateAssociation', nayaxMDBCode: number, positionInColumn: number, positionInShelf: { __typename?: 'PositionInShelf', row: number, column: number } }> } | null } };

export type DeleteNayaxMdbTemplateMutationVariables = Exact<{
  nayaxMDBTemplateId: Scalars['ID']['input'];
}>;


export type DeleteNayaxMdbTemplateMutation = { __typename?: 'Mutation', deleteNayaxMDBTemplate: { __typename?: 'DeleteNayaxMDBTemplateMutationResult', success?: boolean | null } };

export type SendNotificationToOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  notificationCategory?: InputMaybe<NotificationCategory>;
  deeplink?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
}>;


export type SendNotificationToOrganizationMutation = { __typename?: 'Mutation', sendNotificationToOrganization: boolean };

export type SendNotificationToUsersMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  notificationCategory?: InputMaybe<NotificationCategory>;
  deeplink?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
}>;


export type SendNotificationToUsersMutation = { __typename?: 'Mutation', sendNotificationToUsers: boolean };

export type SendNotificationToSiteMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  notificationCategory?: InputMaybe<NotificationCategory>;
  deeplink?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
}>;


export type SendNotificationToSiteMutation = { __typename?: 'Mutation', sendNotificationToSite: boolean };

export type ProcessNotificationTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type ProcessNotificationTokenMutation = { __typename?: 'Mutation', processNotificationTickets?: boolean | null };

export type CreateOdooInvoiceDraftMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type CreateOdooInvoiceDraftMutation = { __typename?: 'Mutation', createOdooInvoiceDraft: { __typename?: 'OdooInvoiceDraftResult', invoiceId?: number | null, error?: string | null } };

export type UpdateOpsParameterMutationVariables = Exact<{
  parameters: OpsParameterDataInput;
}>;


export type UpdateOpsParameterMutation = { __typename?: 'Mutation', updateOpsParameter: { __typename?: 'OpsParameter', _id: string, createdAt: number, updatedAt: number, parameters: { __typename?: 'OpsParameterData', shouldAutoOrderMenuSupplyOrder: boolean, shouldProcessFreshReassortment: boolean, canUseKraftForStore: boolean, canUseKraftForFreefood: boolean, emptyWeightPaletteBox: number, emptyWeightKraftBox: number, externalVolumePaletteBox: number, externalVolumeKraftBox: number, volumePaletteBox: number, volumeKraftBox: number, weightPaletteBox: number, weightKraftBox: number, serviceTimePerBox: number, dryReassortMinProductCount: number, dryReassortMinReferenceCount: number, dryReassortMaxEmptyFacings: number, flowParameters: Array<{ __typename?: 'FlowParameter', flow: ProductFlow, emptyWeightBox: number, externalVolumeBox: number, volumeBox: number, weightBox: number, bundleCapacity: number }>, dynamicDelivery: { __typename?: 'DynamicDeliveryConfig', capacity: number, thresholds: Array<{ __typename?: 'DynamicDeliveryThresholdEntry', templateType: MicrostoreColumnTemplateType, contractType: DynamicDeliveryContractType, qualityPassPercent: number, criticalPassPercent: number, requiredPassPercent: number, criticalGroupingPercent: number, requiredGroupingPercent: number, groupingRadiusKm: number, maxDaysWithoutDelivery: number }>, estimatedTransactionCapacities: Array<{ __typename?: 'DynamicDeliveryTemplateCapacity', templateType: MicrostoreColumnTemplateType, estimatedTransactionCapacity: number }> } } } };

export type UpdateOrderInfoMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  fieldsToUpdate: OrderUpdateInput;
}>;


export type UpdateOrderInfoMutation = { __typename?: 'Mutation', updateOrderInfo: { __typename?: 'UpdateTotAdminOrderResult', success: boolean, errors: Array<string>, order?: { __typename?: 'Order', _id: string, appreciation?: string | null, badService?: Array<string> | null, deliveryDate: string, feedback?: string | null, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, isPunctual: boolean, number?: number | null, previous_orderId?: string | null, reference?: string | null, state: OrderState, weekday?: string | null, delivery?: { __typename?: 'Delivery', _id: string, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState }> } | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, productsWithQuantityPicked: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, fullname: string, quantity?: number | null, quantityPicked?: number | null, unitPrice: number }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, organization: { __typename?: 'Organization', _id: string, hasSubscription: boolean, name: string, paymentType: OrganizationPaymentType }, pausedInfo?: { __typename?: 'PausedInfo', reason?: string | null, returnDate?: number | null } | null, invoicing: { __typename?: 'OrderInvoicing', status: OrderInvoicingStatus, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, paymentIntentId?: string | null, stripePaymentUrl?: string | null }, prices: { __typename?: 'OrderPrices', discount?: number | null, discount055?: number | null, discount10?: number | null, discount20?: number | null, price?: number | null, price055?: number | null, price10?: number | null, price20?: number | null, priceDelivery?: number | null, priceHT?: number | null, priceHT055?: number | null, priceHT10?: number | null, priceHT20?: number | null, priceTTC?: number | null, priceTTC055?: number | null, priceTTC10?: number | null, priceTTC20?: number | null, tva?: number | null, tva055?: number | null, tva10?: number | null, tva20?: number | null }, productsRequestedButNotFullyDelivered: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, fullname: string, unitPrice: number, quantityRequested?: number | null }>, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number }, user: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null } } } | null } };

export type SoftDeleteOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type SoftDeleteOrderMutation = { __typename?: 'Mutation', softDeleteOrder: { __typename?: 'UpdateTotAdminOrderResult', success: boolean, errors: Array<string>, order?: { __typename?: 'Order', _id: string, state: OrderState } | null } };

export type ChargeOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type ChargeOrderMutation = { __typename?: 'Mutation', chargeOrder: { __typename?: 'Order', _id: string, invoicing: { __typename?: 'OrderInvoicing', status: OrderInvoicingStatus, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, paymentIntentId?: string | null, stripePaymentUrl?: string | null } } };

export type DuplicateOrderMutationVariables = Exact<{
  orderToDuplicateId: Scalars['ID']['input'];
  destinationTotemId: Scalars['ID']['input'];
  deliveryDate: Scalars['String']['input'];
  deliveryTimeWindow: DeliveryTimeWindowInput;
  isOrderPunctual: Scalars['Boolean']['input'];
}>;


export type DuplicateOrderMutation = { __typename?: 'Mutation', duplicateOrder: { __typename?: 'Order', _id: string } };

export type UpdateOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  fields: OrganizationUpdateInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'OrganizationUpdateResult', error?: string | null, formErrors?: Array<{ __typename?: 'FormError', sectionName: string, sectionErrors: Array<{ __typename?: 'SectionError', fieldName: string, fieldError: string }> }> | null, updatedOrganization?: { __typename?: 'Organization', _id: string, B2BPriceRange?: string | null, domains?: Array<string> | null, maxUsers: number, customerType?: string | null, totalCoworkers?: number | null, avaClientId?: number | null, restrictedProductArrangementId?: string | null, hasOdooOrganizationParentInvoicing: boolean, hasDetailedOrderInvoicing: boolean, odooOrganizationId?: number | null, odooInvoiceReference?: string | null, paymentTimeType: OrganizationPaymentTimeType, paymentType: OrganizationPaymentType, sales?: { __typename?: 'OrganizationSales', _id: string, fullName: string } | null, invoiceSettings: { __typename?: 'OrganizationInvoiceSetting', _id: string, organizationId: string, state: OrganizationInvoiceSettingState, createdAt: number, updatedAt: number, consumptionColumns: Array<{ __typename?: 'ConsumptionColumn', microstoreColumnIds: Array<string>, priceOptionType: PriceOptionType, tva?: number | null, priceTiers: Array<{ __typename?: 'PriceTier', thresholdMin?: number | null, unitPrice: number, unitPriceWithoutCup: number }> }>, rmeColumns: Array<{ __typename?: 'RmeColumn', microstoreColumnIds: Array<string>, type: RmeColumnType, minimumAmount: number, unitPrice?: number | null }> } } | null } };

export type CreateOrganizationMutationVariables = Exact<{
  input: OrganizationCreateInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'OrganizationCreateResult', error?: string | null, createdOrganization?: { __typename?: 'Organization', _id: string, name: string } | null } };

export type SyncOrganizationInvoiceBoostsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncOrganizationInvoiceBoostsMutation = { __typename?: 'Mutation', syncOrganizationInvoiceBoosts: { __typename?: 'OrganizationInvoiceBoostSyncResult', success: boolean, error?: string | null, spreadsheetUrl: string, columnCount: number, addedCount: number, updatedCount: number, obsoleteCount: number, duplicateCount: number } };

export type AttachLastStripePaymentMethodMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type AttachLastStripePaymentMethodMutation = { __typename?: 'Mutation', attachLastStripePaymentMethod: { __typename?: 'UserResult', error?: string | null, success: boolean, user?: { __typename?: 'User', _id: string, wallet: { __typename?: 'Wallet', ownerId: string, creditCards: Array<{ __typename?: 'CreditCard', _id: string, default: boolean, expired?: boolean | null, paymentType: string, provider: CreditCardProvider, retries: number, type: string, details: { __typename?: 'CreditCardDetails', number?: string | null, expiration?: string | null, bank?: string | null, country?: string | null, expYear?: string | null, expMonth?: string | null } }> } } | null } };

export type CreatePollMutationVariables = Exact<{
  input: PollInput;
}>;


export type CreatePollMutation = { __typename?: 'Mutation', createPoll: { __typename?: 'PollResult', success: boolean, errors?: Array<string> | null, poll?: { __typename?: 'Poll', _id: string, answerOptions: Array<string>, answersRepartition: Array<number>, createdAt: number, imageUrl: string, numberOfParticipants: number, question: string, sectionTitle?: string | null, title: string, audience: { __typename?: 'PollAudience', organizationIds: Array<string>, siteIds: Array<string>, userIds: Array<string> }, dateWindow: { __typename?: 'PollDateWindow', startDate: string, endDate: string } } | null } };

export type UpdatePollMutationVariables = Exact<{
  pollId: Scalars['ID']['input'];
  input: PollInput;
}>;


export type UpdatePollMutation = { __typename?: 'Mutation', updatePoll: { __typename?: 'PollResult', success: boolean, errors?: Array<string> | null, poll?: { __typename?: 'Poll', _id: string, answerOptions: Array<string>, answersRepartition: Array<number>, createdAt: number, imageUrl: string, numberOfParticipants: number, question: string, sectionTitle?: string | null, title: string, audience: { __typename?: 'PollAudience', organizationIds: Array<string>, siteIds: Array<string>, userIds: Array<string> }, dateWindow: { __typename?: 'PollDateWindow', startDate: string, endDate: string } } | null } };

export type CreatePriceRangeMutationVariables = Exact<{
  rangeName: Scalars['String']['input'];
  products: Array<ProductPriceInput> | ProductPriceInput;
  productArrangements: Array<ProductArrangementPriceInput> | ProductArrangementPriceInput;
}>;


export type CreatePriceRangeMutation = { __typename?: 'Mutation', createPriceRange: { __typename?: 'PriceInsertResult', rangeId?: string | null, success: boolean, error?: string | null } };

export type UpdatePriceRangeMutationVariables = Exact<{
  rangeName: Scalars['String']['input'];
  rangeId: Scalars['ID']['input'];
  products: Array<ProductPriceInput> | ProductPriceInput;
  productArrangements: Array<ProductArrangementPriceInput> | ProductArrangementPriceInput;
}>;


export type UpdatePriceRangeMutation = { __typename?: 'Mutation', updatePriceRange: { __typename?: 'PriceInsertResult', rangeId?: string | null, success: boolean, error?: string | null } };

export type UpdateProductMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  fields: ProductUpdateInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'ProductFormUpdateResult', success: boolean, errors: Array<string>, formErrors?: Array<{ __typename?: 'FormError', sectionName: string, sectionErrors: Array<{ __typename?: 'SectionError', fieldName: string, fieldError: string }> }> | null, updatedProduct?: { __typename?: 'Product', _id: string, description?: string | null, flow: ProductFlow, indexDisplay?: number | null, isFreefood: boolean, isMicrostore: boolean, shouldBeHiddenInStore: boolean, isPunctual: boolean, isFromNayax?: boolean | null, isWithoutStock: boolean, nbRatings: number, rating: number, scan: boolean, searchKeywords?: Array<string> | null, zeroWasteProductTemplateId?: string | null, height?: number | null, isDoubleCoil: boolean, length?: number | null, toleranceMin: number, toleranceMax: number, weight?: number | null, weightWithoutPackaging?: number | null, width?: number | null, externalProductId?: string | null, nayaxProductId?: string | null, odooProductId?: string | null, brand: string, createdAt: number, imageUrl?: string | null, name: string, fullname: string, packagingImageUrl?: string | null, state: ProductState, updatedAt: number, volume: string, ingredients?: string | null, nutriscore?: string | null, conditionningTotem: number, displayKg: boolean, isScannable: boolean, isTitreRestaurantAllowed: boolean, onboardedForSensei: boolean, portion: number, proportion?: number | null, proportionMax?: number | null, tva: number, access: Array<string>, isBeingTested: boolean, isPaused: boolean, isToBeArchived: boolean, newUntil?: string | null, useInMenusFrom?: string | null, allowNegativeStock: boolean, canExpire: boolean, checkSwollenLid: boolean, hasShortExpiryDate: boolean, minSupplierExpiryDays?: number | null, stockThreshold?: number | null, stockThresholdMinimum?: number | null, minSupplierOrderQuantity?: number | null, trackExpiryDate: boolean, tagIds: Array<string>, barcodes: Array<{ __typename?: 'Barcode', barcode: string, type: BarcodeType }>, category: { __typename?: 'Category', _id: string, title: string }, odooProduct?: { __typename?: 'OdooProduct', _id: string, externalOdooProductId: number, externalOdooProductVariantId: number, externalOdooZeroWasteProductVariantId?: number | null } | null, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, allergen: { __typename?: 'ProductAllergen', gluten: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, peanuts: boolean, soybeans: boolean, milk: boolean, nuts: boolean, celery: boolean, mustard: boolean, sesame: boolean, sulphites: boolean, lupin: boolean, molluscs: boolean, containsNoAllergens: boolean, canContain?: string | null }, nutrition: { __typename?: 'ProductNutrition', caloriesKCal?: number | null, totalFat?: number | null, sturatedFat?: number | null, carbohydrates?: number | null, sugars?: number | null, fibers?: number | null, protein?: number | null, sodium?: number | null }, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string, quantity: number, hotDrinksIngredientUnit: HotDrinksIngredientUnit, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null, weightWithoutPackaging?: number | null } }> } | null, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null }, supplierShortageHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null, code?: string | null, prices: Array<{ __typename?: 'SupplierProductPrice', value: number, conditionning: number, packagesPerBatch: number }> }>, toBeArchivedHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, stateHistory: Array<{ __typename?: 'ProductStateHistory', state: ProductState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, deliveryDays: { __typename?: 'ProductDeliveryDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean }, preferences: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, diets: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, productArrangements: Array<{ __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> }> } | null } };

export type CreateProductMutationVariables = Exact<{
  fields: ProductUpdateInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProductResolver: { __typename?: 'ProductCreateResult', success: boolean, createdProductId?: string | null, formErrors?: Array<{ __typename?: 'FormError', sectionName: string, sectionErrors: Array<{ __typename?: 'SectionError', fieldName: string, fieldError: string }> }> | null } };

export type CreateProductsFromImportMutationVariables = Exact<{
  productsToCreate: Array<ProductCreateCsvImport> | ProductCreateCsvImport;
}>;


export type CreateProductsFromImportMutation = { __typename?: 'Mutation', createProductsFromImport: { __typename?: 'ProductCsvImportResult', success: boolean, error?: string | null, products?: Array<{ __typename?: 'Product', _id: string, description?: string | null, flow: ProductFlow, indexDisplay?: number | null, isFreefood: boolean, isMicrostore: boolean, shouldBeHiddenInStore: boolean, isPunctual: boolean, isFromNayax?: boolean | null, isWithoutStock: boolean, nbRatings: number, rating: number, scan: boolean, searchKeywords?: Array<string> | null, zeroWasteProductTemplateId?: string | null, height?: number | null, isDoubleCoil: boolean, length?: number | null, toleranceMin: number, toleranceMax: number, weight?: number | null, weightWithoutPackaging?: number | null, width?: number | null, externalProductId?: string | null, nayaxProductId?: string | null, odooProductId?: string | null, brand: string, createdAt: number, imageUrl?: string | null, name: string, fullname: string, packagingImageUrl?: string | null, state: ProductState, updatedAt: number, volume: string, ingredients?: string | null, nutriscore?: string | null, conditionningTotem: number, displayKg: boolean, isScannable: boolean, isTitreRestaurantAllowed: boolean, onboardedForSensei: boolean, portion: number, proportion?: number | null, proportionMax?: number | null, tva: number, access: Array<string>, isBeingTested: boolean, isPaused: boolean, isToBeArchived: boolean, newUntil?: string | null, useInMenusFrom?: string | null, allowNegativeStock: boolean, canExpire: boolean, checkSwollenLid: boolean, hasShortExpiryDate: boolean, minSupplierExpiryDays?: number | null, stockThreshold?: number | null, stockThresholdMinimum?: number | null, minSupplierOrderQuantity?: number | null, trackExpiryDate: boolean, tagIds: Array<string>, barcodes: Array<{ __typename?: 'Barcode', barcode: string, type: BarcodeType }>, category: { __typename?: 'Category', _id: string, title: string }, odooProduct?: { __typename?: 'OdooProduct', _id: string, externalOdooProductId: number, externalOdooProductVariantId: number, externalOdooZeroWasteProductVariantId?: number | null } | null, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, allergen: { __typename?: 'ProductAllergen', gluten: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, peanuts: boolean, soybeans: boolean, milk: boolean, nuts: boolean, celery: boolean, mustard: boolean, sesame: boolean, sulphites: boolean, lupin: boolean, molluscs: boolean, containsNoAllergens: boolean, canContain?: string | null }, nutrition: { __typename?: 'ProductNutrition', caloriesKCal?: number | null, totalFat?: number | null, sturatedFat?: number | null, carbohydrates?: number | null, sugars?: number | null, fibers?: number | null, protein?: number | null, sodium?: number | null }, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string, quantity: number, hotDrinksIngredientUnit: HotDrinksIngredientUnit, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null, weightWithoutPackaging?: number | null } }> } | null, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null }, supplierShortageHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null, code?: string | null, prices: Array<{ __typename?: 'SupplierProductPrice', value: number, conditionning: number, packagesPerBatch: number }> }>, toBeArchivedHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, stateHistory: Array<{ __typename?: 'ProductStateHistory', state: ProductState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, deliveryDays: { __typename?: 'ProductDeliveryDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean }, preferences: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, diets: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, productArrangements: Array<{ __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> }> }> | null } };

export type UpdateProductsFromImportMutationVariables = Exact<{
  productsToUpdate: Array<ProductUpdateCsvImport> | ProductUpdateCsvImport;
}>;


export type UpdateProductsFromImportMutation = { __typename?: 'Mutation', updateProductsFromImport: { __typename?: 'ProductCsvImportResult', success: boolean, error?: string | null, products?: Array<{ __typename?: 'Product', _id: string, description?: string | null, flow: ProductFlow, indexDisplay?: number | null, isFreefood: boolean, isMicrostore: boolean, shouldBeHiddenInStore: boolean, isPunctual: boolean, isFromNayax?: boolean | null, isWithoutStock: boolean, nbRatings: number, rating: number, scan: boolean, searchKeywords?: Array<string> | null, zeroWasteProductTemplateId?: string | null, height?: number | null, isDoubleCoil: boolean, length?: number | null, toleranceMin: number, toleranceMax: number, weight?: number | null, weightWithoutPackaging?: number | null, width?: number | null, externalProductId?: string | null, nayaxProductId?: string | null, odooProductId?: string | null, brand: string, createdAt: number, imageUrl?: string | null, name: string, fullname: string, packagingImageUrl?: string | null, state: ProductState, updatedAt: number, volume: string, ingredients?: string | null, nutriscore?: string | null, conditionningTotem: number, displayKg: boolean, isScannable: boolean, isTitreRestaurantAllowed: boolean, onboardedForSensei: boolean, portion: number, proportion?: number | null, proportionMax?: number | null, tva: number, access: Array<string>, isBeingTested: boolean, isPaused: boolean, isToBeArchived: boolean, newUntil?: string | null, useInMenusFrom?: string | null, allowNegativeStock: boolean, canExpire: boolean, checkSwollenLid: boolean, hasShortExpiryDate: boolean, minSupplierExpiryDays?: number | null, stockThreshold?: number | null, stockThresholdMinimum?: number | null, minSupplierOrderQuantity?: number | null, trackExpiryDate: boolean, tagIds: Array<string>, barcodes: Array<{ __typename?: 'Barcode', barcode: string, type: BarcodeType }>, category: { __typename?: 'Category', _id: string, title: string }, odooProduct?: { __typename?: 'OdooProduct', _id: string, externalOdooProductId: number, externalOdooProductVariantId: number, externalOdooZeroWasteProductVariantId?: number | null } | null, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, allergen: { __typename?: 'ProductAllergen', gluten: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, peanuts: boolean, soybeans: boolean, milk: boolean, nuts: boolean, celery: boolean, mustard: boolean, sesame: boolean, sulphites: boolean, lupin: boolean, molluscs: boolean, containsNoAllergens: boolean, canContain?: string | null }, nutrition: { __typename?: 'ProductNutrition', caloriesKCal?: number | null, totalFat?: number | null, sturatedFat?: number | null, carbohydrates?: number | null, sugars?: number | null, fibers?: number | null, protein?: number | null, sodium?: number | null }, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string, quantity: number, hotDrinksIngredientUnit: HotDrinksIngredientUnit, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null, weightWithoutPackaging?: number | null } }> } | null, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null }, supplierShortageHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null, code?: string | null, prices: Array<{ __typename?: 'SupplierProductPrice', value: number, conditionning: number, packagesPerBatch: number }> }>, toBeArchivedHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, stateHistory: Array<{ __typename?: 'ProductStateHistory', state: ProductState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, deliveryDays: { __typename?: 'ProductDeliveryDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean }, preferences: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, diets: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, productArrangements: Array<{ __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> }> }> | null } };

export type UpdateProductStateMutationVariables = Exact<{
  stateToSet: ProductState;
  productId: Scalars['ID']['input'];
}>;


export type UpdateProductStateMutation = { __typename?: 'Mutation', updateProductStateResolver: { __typename?: 'ProductStateUpdateResult', success: boolean, error?: string | null, formErrors?: Array<{ __typename?: 'FormError', sectionName: string, sectionErrors: Array<{ __typename?: 'SectionError', fieldName: string, fieldError: string }> }> | null, product?: { __typename?: 'Product', _id: string, description?: string | null, flow: ProductFlow, indexDisplay?: number | null, isFreefood: boolean, isMicrostore: boolean, shouldBeHiddenInStore: boolean, isPunctual: boolean, isFromNayax?: boolean | null, isWithoutStock: boolean, nbRatings: number, rating: number, scan: boolean, searchKeywords?: Array<string> | null, zeroWasteProductTemplateId?: string | null, height?: number | null, isDoubleCoil: boolean, length?: number | null, toleranceMin: number, toleranceMax: number, weight?: number | null, weightWithoutPackaging?: number | null, width?: number | null, externalProductId?: string | null, nayaxProductId?: string | null, odooProductId?: string | null, brand: string, createdAt: number, imageUrl?: string | null, name: string, fullname: string, packagingImageUrl?: string | null, state: ProductState, updatedAt: number, volume: string, ingredients?: string | null, nutriscore?: string | null, conditionningTotem: number, displayKg: boolean, isScannable: boolean, isTitreRestaurantAllowed: boolean, onboardedForSensei: boolean, portion: number, proportion?: number | null, proportionMax?: number | null, tva: number, access: Array<string>, isBeingTested: boolean, isPaused: boolean, isToBeArchived: boolean, newUntil?: string | null, useInMenusFrom?: string | null, allowNegativeStock: boolean, canExpire: boolean, checkSwollenLid: boolean, hasShortExpiryDate: boolean, minSupplierExpiryDays?: number | null, stockThreshold?: number | null, stockThresholdMinimum?: number | null, minSupplierOrderQuantity?: number | null, trackExpiryDate: boolean, tagIds: Array<string>, barcodes: Array<{ __typename?: 'Barcode', barcode: string, type: BarcodeType }>, category: { __typename?: 'Category', _id: string, title: string }, odooProduct?: { __typename?: 'OdooProduct', _id: string, externalOdooProductId: number, externalOdooProductVariantId: number, externalOdooZeroWasteProductVariantId?: number | null } | null, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, allergen: { __typename?: 'ProductAllergen', gluten: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, peanuts: boolean, soybeans: boolean, milk: boolean, nuts: boolean, celery: boolean, mustard: boolean, sesame: boolean, sulphites: boolean, lupin: boolean, molluscs: boolean, containsNoAllergens: boolean, canContain?: string | null }, nutrition: { __typename?: 'ProductNutrition', caloriesKCal?: number | null, totalFat?: number | null, sturatedFat?: number | null, carbohydrates?: number | null, sugars?: number | null, fibers?: number | null, protein?: number | null, sodium?: number | null }, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string, quantity: number, hotDrinksIngredientUnit: HotDrinksIngredientUnit, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null, weightWithoutPackaging?: number | null } }> } | null, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null }, supplierShortageHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null, code?: string | null, prices: Array<{ __typename?: 'SupplierProductPrice', value: number, conditionning: number, packagesPerBatch: number }> }>, toBeArchivedHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, stateHistory: Array<{ __typename?: 'ProductStateHistory', state: ProductState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, deliveryDays: { __typename?: 'ProductDeliveryDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean }, preferences: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, diets: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, productArrangements: Array<{ __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> }> } | null } };

export type ReplaceProductInOrdersMutationVariables = Exact<{
  productToRemoveId: Scalars['ID']['input'];
  productToAddId: Scalars['ID']['input'];
  shouldSendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReplaceProductInOrdersMutation = { __typename?: 'Mutation', replaceProductInOrders: { __typename?: 'DefaultMutationMutipleErrorsResponse', success: boolean, errors: Array<string | null> } };

export type RemoveProductInOrdersMutationVariables = Exact<{
  productToRemoveId: Scalars['ID']['input'];
  shouldSendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RemoveProductInOrdersMutation = { __typename?: 'Mutation', removeProductInOrders: { __typename?: 'DefaultMutationMutipleErrorsResponse', success: boolean, errors: Array<string | null> } };

export type UpdateProductRecipeMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  recipe?: InputMaybe<ProductRecipeInput>;
}>;


export type UpdateProductRecipeMutation = { __typename?: 'Mutation', updateProductRecipe: { __typename?: 'UpdateProductRecipeResult', success: boolean, error?: string | null, product?: { __typename?: 'Product', _id: string, fullname: string, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string, quantity: number, hotDrinksIngredientUnit: HotDrinksIngredientUnit, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null, weightWithoutPackaging?: number | null } }> } | null } | null } };

export type CreateProductArrangementMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateProductArrangementMutation = { __typename?: 'Mutation', createProductArrangementMutation: { __typename?: 'ProductArrangementCreateOrUpdateResult', errors: Array<string>, newProductArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null } };

export type ArchiveProductArrangementsMutationVariables = Exact<{
  productArrangementIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ArchiveProductArrangementsMutation = { __typename?: 'Mutation', archiveProductArrangementsMutation: { __typename?: 'ArchiveProductArrangementResult', archivedProductArrangementIds: Array<string>, errors: Array<string> } };

export type UpdateProductArrangementMutationVariables = Exact<{
  productArrangement: ProductArrangementUpdateInput;
}>;


export type UpdateProductArrangementMutation = { __typename?: 'Mutation', updateProductArrangementMutation: { __typename?: 'ProductArrangementCreateOrUpdateResult', errors: Array<string>, newProductArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, productsWithStockMax: Array<{ __typename?: 'ProductArrangementProductWithStockMax', stockMax: number, product: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } }> } | null } };

export type CreateProductGroupMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type CreateProductGroupMutation = { __typename?: 'Mutation', createProductGroup: { __typename?: 'ProductGroup', _id: string, createdAt: number, productId: string, updatedAt: number, composition: Array<{ __typename?: 'ProductGroupCompositionEntry', productId: string, quantity: number }> } };

export type UpdateProductGroupMutationVariables = Exact<{
  composition: Array<ProductGroupCompositionEntryInput> | ProductGroupCompositionEntryInput;
  productGroupId: Scalars['ID']['input'];
}>;


export type UpdateProductGroupMutation = { __typename?: 'Mutation', updateProductGroup: { __typename?: 'ProductGroup', _id: string, createdAt: number, productId: string, updatedAt: number, composition: Array<{ __typename?: 'ProductGroupCompositionEntry', productId: string, quantity: number }> } };

export type CreateProductSwitchMutationVariables = Exact<{
  productSwitchCreateInput: ProductSwitchCreateInput;
}>;


export type CreateProductSwitchMutation = { __typename?: 'Mutation', createProductSwitch: { __typename?: 'ProductSwitch', _id: string, createdAt: number, endDate: string, productAId: string, productBId: string, ratioToOrderOfA: number, ratioOfAToOrderForB: number, startDate: string, state: ProductSwitchState, switchFreefood: boolean, switchStore: boolean, updatedAt: number, productAVariation?: { __typename?: 'ProductStockVariation', computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } } | null, productBVariation?: { __typename?: 'ProductStockVariation', computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } } | null } };

export type ArchiveProductSwitchMutationVariables = Exact<{
  productSwitchId: Scalars['ID']['input'];
}>;


export type ArchiveProductSwitchMutation = { __typename?: 'Mutation', archiveProductSwitch: { __typename?: 'ProductSwitch', _id: string, createdAt: number, endDate: string, productAId: string, productBId: string, ratioToOrderOfA: number, ratioOfAToOrderForB: number, startDate: string, state: ProductSwitchState, switchFreefood: boolean, switchStore: boolean, updatedAt: number, productAVariation?: { __typename?: 'ProductStockVariation', computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } } | null, productBVariation?: { __typename?: 'ProductStockVariation', computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } } | null } };

export type UpdateProductSwitchMutationVariables = Exact<{
  productSwitchUpdateInput: ProductSwitchUpdateInput;
}>;


export type UpdateProductSwitchMutation = { __typename?: 'Mutation', updateProductSwitch: { __typename?: 'ProductSwitch', _id: string, createdAt: number, endDate: string, productAId: string, productBId: string, ratioToOrderOfA: number, ratioOfAToOrderForB: number, startDate: string, state: ProductSwitchState, switchFreefood: boolean, switchStore: boolean, updatedAt: number, productAVariation?: { __typename?: 'ProductStockVariation', computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } } | null, productBVariation?: { __typename?: 'ProductStockVariation', computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } } | null } };

export type CreateQuizMutationVariables = Exact<{
  input: QuizInput;
}>;


export type CreateQuizMutation = { __typename?: 'Mutation', createQuiz: { __typename?: 'QuizResult', success: boolean, errors?: Array<string> | null, quiz?: { __typename?: 'Quiz', _id: string, createdAt: number, date: string, description: string, imageUrl: string, state: QuizState, title: string, updatedAt: number, audience: { __typename?: 'QuizAudience', organizationIds: Array<string>, siteIds: Array<string>, userIds: Array<string> }, questions: Array<{ __typename?: 'QuizQuestion', label: string, answerOptions: Array<string>, correctAnswerIndex: number, imageUrl: string }> } | null } };

export type UpdateQuizMutationVariables = Exact<{
  quizId: Scalars['ID']['input'];
  input: QuizInput;
}>;


export type UpdateQuizMutation = { __typename?: 'Mutation', updateQuiz: { __typename?: 'QuizResult', success: boolean, errors?: Array<string> | null, quiz?: { __typename?: 'Quiz', _id: string, createdAt: number, date: string, description: string, imageUrl: string, state: QuizState, title: string, updatedAt: number, audience: { __typename?: 'QuizAudience', organizationIds: Array<string>, siteIds: Array<string>, userIds: Array<string> }, questions: Array<{ __typename?: 'QuizQuestion', label: string, answerOptions: Array<string>, correctAnswerIndex: number, imageUrl: string }> } | null } };

export type CreateRitualMutationVariables = Exact<{
  createRitualInput: CreateRitualInput;
}>;


export type CreateRitualMutation = { __typename?: 'Mutation', createRitual: { __typename?: 'CreateRitualResult', success: boolean, errors?: Array<string> | null, createdRitual?: { __typename?: 'Ritual', _id: string, activeDate?: string | null, activeWeekdays?: Array<boolean> | null, associatedDiscount?: number | null, billToOrganizationId?: string | null, imageUrl: string, messagesSetId?: string | null, name: string, repetition: RitualRepetition, resetsBetweenPurchases: boolean, restrictedOrganizationIds: Array<string>, restrictedSiteIds: Array<string>, restrictedUserIds: Array<string>, state: RitualState, timeWindow: { __typename?: 'RitualTimeWindow', start: string, end: string } } | null } };

export type UpdateRitualMutationVariables = Exact<{
  ritualId: Scalars['ID']['input'];
  updateInput: UpdateRitualInput;
}>;


export type UpdateRitualMutation = { __typename?: 'Mutation', updateRitual: { __typename?: 'UpdateRitualResult', success: boolean, errors?: Array<string> | null, updatedRitual?: { __typename?: 'Ritual', _id: string, activeDate?: string | null, activeWeekdays?: Array<boolean> | null, associatedDiscount?: number | null, billToOrganizationId?: string | null, imageUrl: string, messagesSetId?: string | null, name: string, repetition: RitualRepetition, resetsBetweenPurchases: boolean, restrictedOrganizationIds: Array<string>, restrictedSiteIds: Array<string>, restrictedUserIds: Array<string>, state: RitualState, timeWindow: { __typename?: 'RitualTimeWindow', start: string, end: string } } | null } };

export type UpdateRitualStateMutationVariables = Exact<{
  ritualId: Scalars['ID']['input'];
  stateToSet: RitualState;
}>;


export type UpdateRitualStateMutation = { __typename?: 'Mutation', updateRitualState: { __typename?: 'UpdateRitualResult', success: boolean, errors?: Array<string> | null, updatedRitual?: { __typename?: 'Ritual', _id: string, activeDate?: string | null, activeWeekdays?: Array<boolean> | null, associatedDiscount?: number | null, billToOrganizationId?: string | null, imageUrl: string, messagesSetId?: string | null, name: string, repetition: RitualRepetition, resetsBetweenPurchases: boolean, restrictedOrganizationIds: Array<string>, restrictedSiteIds: Array<string>, restrictedUserIds: Array<string>, state: RitualState, timeWindow: { __typename?: 'RitualTimeWindow', start: string, end: string } } | null } };

export type CreateRitualTemplateMutationVariables = Exact<{
  image: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateRitualTemplateMutation = { __typename?: 'Mutation', createRitualTemplate: { __typename?: 'CreateRitualTemplateResult', success: boolean, errors?: Array<string> | null, ritualTemplate?: { __typename?: 'RitualTemplate', _id: string, name: string, imageUrl: string } | null } };

export type CreateSiteMutationVariables = Exact<{
  accessTime: Scalars['Int']['input'];
  deliveryDays: Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input'];
  deliveryWindowStart: Scalars['String']['input'];
  deliveryWindowStop: Scalars['String']['input'];
  estimatedUserCount: Scalars['Int']['input'];
  launchDate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  reassortmentFreshFacings: ReassortmentFreshFacingsByCategoriesInput;
  reassortmentStockTargetRatios: ReassortmentStockTargetRatiosInput;
  reassortmentStockTargets: ReassortmentStockByCategoriesInput;
  reassortmentOnboardingStockTargets: ReassortmentStockByCategoriesInput;
  totemId: Scalars['ID']['input'];
  type: SiteType;
  state: SiteState;
}>;


export type CreateSiteMutation = { __typename?: 'Mutation', createSite: { __typename?: 'SiteResult', success: boolean, error?: string | null, site?: { __typename?: 'Site', _id: string, name: string } | null } };

export type UpdateSiteMutationVariables = Exact<{
  accessTime: Scalars['Int']['input'];
  removalDate?: InputMaybe<Scalars['String']['input']>;
  B2CPriceRange?: InputMaybe<Scalars['ID']['input']>;
  unknownShrinkageBillingThreshold?: InputMaybe<Scalars['Int']['input']>;
  closingDatesRanges: Array<SiteClosingDatesRangeInput> | SiteClosingDatesRangeInput;
  deliveryDays: Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input'];
  freshReassortDays: Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input'];
  dryReassortDays: Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input'];
  deliveryWindowStart: Scalars['String']['input'];
  deliveryWindowStop: Scalars['String']['input'];
  deliveryType: SiteDeliveryType;
  contractType: SiteContractType;
  estimatedUserCount: Scalars['Int']['input'];
  hasExternalSetupProcess: Scalars['Boolean']['input'];
  isOpenOnWeekend: Scalars['Boolean']['input'];
  isSecured: Scalars['Boolean']['input'];
  hasSensei: Scalars['Boolean']['input'];
  hasCoffee: Scalars['Boolean']['input'];
  launchDate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  reassortmentFreshFacings: ReassortmentFreshFacingsByCategoriesInput;
  reassortmentStockTargetRatios: ReassortmentStockTargetRatiosInput;
  reassortmentStockTargets: ReassortmentStockByCategoriesInput;
  reassortmentOnboardingStockTargets: ReassortmentStockByCategoriesInput;
  shouldOperateOnTotops: Scalars['Boolean']['input'];
  shouldAutomaticallyCreateTargetReassortment: Scalars['Boolean']['input'];
  shouldAutomaticallyCreateManualReassortment: Scalars['Boolean']['input'];
  shouldAutomaticallyFinishSiteSetup: Scalars['Boolean']['input'];
  shouldHaveTheftNotice: Scalars['Boolean']['input'];
  shouldModulateForExpired: Scalars['Boolean']['input'];
  shouldModulateForUnknownLosses: Scalars['Boolean']['input'];
  siteId: Scalars['ID']['input'];
  state: SiteState;
  unwantedProductIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  urbantzMetadata: SiteMetadataInput;
  useNayaxCard: Scalars['Boolean']['input'];
  wantedProductIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  avaSiteId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateSiteMutation = { __typename?: 'Mutation', updateSite: { __typename?: 'SiteResult', success: boolean, error?: string | null, site?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type UpdateSiteReassortmentQuantityTargetsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  reassortmentStockTargets: ReassortmentStockByCategoriesInput;
  reassortmentOnboardingStockTargets: ReassortmentStockByCategoriesInput;
}>;


export type UpdateSiteReassortmentQuantityTargetsMutation = { __typename?: 'Mutation', updateSiteReassortmentStockTargets: { __typename?: 'SiteResult', success: boolean, error?: string | null, site?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type UpdateSiteReassortmentQuantityTargetRatiosMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  reassortmentStockTargetRatios: ReassortmentStockTargetRatiosInput;
}>;


export type UpdateSiteReassortmentQuantityTargetRatiosMutation = { __typename?: 'Mutation', updateSiteReassortmentStockTargetRatios: { __typename?: 'SiteResult', success: boolean, error?: string | null, site?: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } | null } };

export type DeclareSiteExternalInventoryMutationVariables = Exact<{
  productsInventoryInfo: Array<SiteExternalInventoryProduct> | SiteExternalInventoryProduct;
  columnId: Scalars['ID']['input'];
}>;


export type DeclareSiteExternalInventoryMutation = { __typename?: 'Mutation', declareSiteExternalInventory: Array<{ __typename?: 'Product', _id: string }> };

export type UpdateSitesFromImportMutationVariables = Exact<{
  sitesToUpdate: Array<SiteUpdateCsvImport> | SiteUpdateCsvImport;
}>;


export type UpdateSitesFromImportMutation = { __typename?: 'Mutation', updateSitesFromImport: { __typename?: 'SitesImportResult', success: boolean, error?: string | null, sites?: Array<{ __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null }> | null } };

export type ForceFinishSiteSetupMutationVariables = Exact<{
  siteSetupId: Scalars['ID']['input'];
}>;


export type ForceFinishSiteSetupMutation = { __typename?: 'Mutation', forceFinishSiteSetup: { __typename?: 'SiteSetup', _id: string, createdAt: number, date: string, deliveryId: string, isFinishForced: boolean, siteId: string, state: SiteSetupState, updatedAt: number, delivery?: { __typename?: 'Delivery', isDynamic: boolean } | null, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> } | null, issues: { __typename?: 'SiteSetupIssues', productsIssues: Array<{ __typename?: 'SetupProductIssues', comment: string, productId: string, brokenDuringDeliveryQuantity: number, brokenOnSiteAfterInventoryQuantity: number, brokenOnSiteBeforeInventoryQuantity: number, expiredDeliveredQuantity: number, expiredOnSiteAfterInventoryQuantity: number, expiredOnSiteBeforeInventoryQuantity: number, notEnoughPlaceQuantity: number, otherBeforeInventoryQuantity: number, otherAfterInventoryOrDuringDeliveryQuantity: number, unexpectedOnSiteQuantity: number, wrongQuantityDelivered: number }> }, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', _id: string, isFinishForced: boolean, isNeeded: boolean, microstoreColumnGroupId: string, positionInSiteSetup: number, siteSetupId: string, state: MicrostoreColumnGroupSetupState, updatedAt: number, instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> }>, stateHistory: Array<{ __typename?: 'MicrostoreColumnGroupSetupStateHistory', createdAt: number, state: MicrostoreColumnGroupSetupState }> }>, odooTickets: Array<{ __typename?: 'OdooTicket', _id: string, odooTicketId: number, microstoreColumnId: string, serviceType: OdooServiceType, ticketType: string, state: OdooTicketState, description: string, actions: Array<{ __typename?: 'OdooTicketAction', actionType: OdooTicketActionType, message: string, photoUrl?: string | null, createdAt: number }>, microstoreColumn: { __typename?: 'MicrostoreColumn', name: string } }>, site: { __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, earliestDLCDateToKeepForStockCalculation?: string | null, isOpenOnWeekend: boolean, isSecured: boolean, name: string, type: SiteType, state: SiteState, organizationName: string, nextDeliveryDate?: string | null, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }> }, stateHistory: Array<{ __typename?: 'SiteSetupStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: SiteSetupState }> } };

export type FinishSiteSetupWithManualGenerationMutationVariables = Exact<{
  siteSetupId: Scalars['ID']['input'];
}>;


export type FinishSiteSetupWithManualGenerationMutation = { __typename?: 'Mutation', finishSiteSetupWithManualGeneration: { __typename?: 'SiteSetup', _id: string, createdAt: number, date: string, deliveryId: string, isFinishForced: boolean, siteId: string, state: SiteSetupState, updatedAt: number, delivery?: { __typename?: 'Delivery', isDynamic: boolean } | null, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> } | null, issues: { __typename?: 'SiteSetupIssues', productsIssues: Array<{ __typename?: 'SetupProductIssues', comment: string, productId: string, brokenDuringDeliveryQuantity: number, brokenOnSiteAfterInventoryQuantity: number, brokenOnSiteBeforeInventoryQuantity: number, expiredDeliveredQuantity: number, expiredOnSiteAfterInventoryQuantity: number, expiredOnSiteBeforeInventoryQuantity: number, notEnoughPlaceQuantity: number, otherBeforeInventoryQuantity: number, otherAfterInventoryOrDuringDeliveryQuantity: number, unexpectedOnSiteQuantity: number, wrongQuantityDelivered: number }> }, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', _id: string, isFinishForced: boolean, isNeeded: boolean, microstoreColumnGroupId: string, positionInSiteSetup: number, siteSetupId: string, state: MicrostoreColumnGroupSetupState, updatedAt: number, instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> }>, stateHistory: Array<{ __typename?: 'MicrostoreColumnGroupSetupStateHistory', createdAt: number, state: MicrostoreColumnGroupSetupState }> }>, odooTickets: Array<{ __typename?: 'OdooTicket', _id: string, odooTicketId: number, microstoreColumnId: string, serviceType: OdooServiceType, ticketType: string, state: OdooTicketState, description: string, actions: Array<{ __typename?: 'OdooTicketAction', actionType: OdooTicketActionType, message: string, photoUrl?: string | null, createdAt: number }>, microstoreColumn: { __typename?: 'MicrostoreColumn', name: string } }>, site: { __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, earliestDLCDateToKeepForStockCalculation?: string | null, isOpenOnWeekend: boolean, isSecured: boolean, name: string, type: SiteType, state: SiteState, organizationName: string, nextDeliveryDate?: string | null, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }> }, stateHistory: Array<{ __typename?: 'SiteSetupStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: SiteSetupState }> } };

export type AbortSiteSetupMutationVariables = Exact<{
  siteSetupId: Scalars['ID']['input'];
}>;


export type AbortSiteSetupMutation = { __typename?: 'Mutation', abortSiteSetup: { __typename?: 'SiteSetup', _id: string, createdAt: number, date: string, deliveryId: string, isFinishForced: boolean, siteId: string, state: SiteSetupState, updatedAt: number, delivery?: { __typename?: 'Delivery', isDynamic: boolean } | null, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> } | null, issues: { __typename?: 'SiteSetupIssues', productsIssues: Array<{ __typename?: 'SetupProductIssues', comment: string, productId: string, brokenDuringDeliveryQuantity: number, brokenOnSiteAfterInventoryQuantity: number, brokenOnSiteBeforeInventoryQuantity: number, expiredDeliveredQuantity: number, expiredOnSiteAfterInventoryQuantity: number, expiredOnSiteBeforeInventoryQuantity: number, notEnoughPlaceQuantity: number, otherBeforeInventoryQuantity: number, otherAfterInventoryOrDuringDeliveryQuantity: number, unexpectedOnSiteQuantity: number, wrongQuantityDelivered: number }> }, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', _id: string, isFinishForced: boolean, isNeeded: boolean, microstoreColumnGroupId: string, positionInSiteSetup: number, siteSetupId: string, state: MicrostoreColumnGroupSetupState, updatedAt: number, instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> }>, stateHistory: Array<{ __typename?: 'MicrostoreColumnGroupSetupStateHistory', createdAt: number, state: MicrostoreColumnGroupSetupState }> }>, odooTickets: Array<{ __typename?: 'OdooTicket', _id: string, odooTicketId: number, microstoreColumnId: string, serviceType: OdooServiceType, ticketType: string, state: OdooTicketState, description: string, actions: Array<{ __typename?: 'OdooTicketAction', actionType: OdooTicketActionType, message: string, photoUrl?: string | null, createdAt: number }>, microstoreColumn: { __typename?: 'MicrostoreColumn', name: string } }>, site: { __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, earliestDLCDateToKeepForStockCalculation?: string | null, isOpenOnWeekend: boolean, isSecured: boolean, name: string, type: SiteType, state: SiteState, organizationName: string, nextDeliveryDate?: string | null, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }> }, stateHistory: Array<{ __typename?: 'SiteSetupStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: SiteSetupState }> } };

export type CreateStockTransferMutationVariables = Exact<{
  transferDate: Scalars['String']['input'];
  originColumnId: Scalars['ID']['input'];
  destinationColumnId: Scalars['ID']['input'];
  products: Array<StockTransferProductInput> | StockTransferProductInput;
}>;


export type CreateStockTransferMutation = { __typename?: 'Mutation', createStockTransfer: { __typename?: 'StockTransferResult', success: boolean, error?: string | null, stockTransfer?: { __typename?: 'StockTransfer', _id: string } | null } };

export type UpdateStockTransferMutationVariables = Exact<{
  stockTransferId: Scalars['ID']['input'];
  transferDate: Scalars['String']['input'];
  originColumnId: Scalars['ID']['input'];
  destinationColumnId: Scalars['ID']['input'];
  products: Array<StockTransferProductInput> | StockTransferProductInput;
  shouldUpdateStockImmediately: Scalars['Boolean']['input'];
}>;


export type UpdateStockTransferMutation = { __typename?: 'Mutation', updateStockTransfer: { __typename?: 'StockTransferResult', success: boolean, error?: string | null, stockTransfer?: { __typename?: 'StockTransfer', _id: string, createdAt: number, updatedAt: number, transferDate: string, destinationColumnId: string, originColumnId: string, deliveryId?: string | null, reassortmentFlow?: ReassortmentFlow | null, shouldUpdateStockImmediately: boolean, state: StockTransferState, destinationColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, originColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, products: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, conditionning: number, packagesPerBatch: number, originStockAvailable: number, destinationStockAvailable: number, quantity: number }>, delivery?: { __typename?: 'Delivery', state: DeliveryState } | null, stateHistory: Array<{ __typename?: 'StockTransferStateHistory', state: StockTransferState, createdAt: number, createdBy: string, createdByName?: string | null }> } | null } };

export type ValidateStockTransfersMutationVariables = Exact<{
  stockTransferIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ValidateStockTransfersMutation = { __typename?: 'Mutation', validateStockTransfers: { __typename?: 'StockTransfersResult', errors: Array<string>, stockTransfers: Array<{ __typename?: 'StockTransfer', _id: string, createdAt: number, updatedAt: number, transferDate: string, destinationColumnId: string, originColumnId: string, deliveryId?: string | null, reassortmentFlow?: ReassortmentFlow | null, shouldUpdateStockImmediately: boolean, state: StockTransferState, destinationColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, originColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, products: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, conditionning: number, packagesPerBatch: number, originStockAvailable: number, destinationStockAvailable: number, quantity: number }>, delivery?: { __typename?: 'Delivery', state: DeliveryState } | null, stateHistory: Array<{ __typename?: 'StockTransferStateHistory', state: StockTransferState, createdAt: number, createdBy: string, createdByName?: string | null }> }> } };

export type ValidateStockTransfersAtDateMutationVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type ValidateStockTransfersAtDateMutation = { __typename?: 'Mutation', validateStockTransfersAtDate: { __typename?: 'StockTransfersResult', errors: Array<string>, stockTransfers: Array<{ __typename?: 'StockTransfer', _id: string, createdAt: number, updatedAt: number, transferDate: string, destinationColumnId: string, originColumnId: string, deliveryId?: string | null, reassortmentFlow?: ReassortmentFlow | null, shouldUpdateStockImmediately: boolean, state: StockTransferState, destinationColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, originColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, products: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, conditionning: number, packagesPerBatch: number, originStockAvailable: number, destinationStockAvailable: number, quantity: number }>, delivery?: { __typename?: 'Delivery', state: DeliveryState } | null, stateHistory: Array<{ __typename?: 'StockTransferStateHistory', state: StockTransferState, createdAt: number, createdBy: string, createdByName?: string | null }> }> } };

export type AbortStockTransfersMutationVariables = Exact<{
  stockTransferIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AbortStockTransfersMutation = { __typename?: 'Mutation', abortStockTransfers: { __typename?: 'StockTransfersResult', errors: Array<string>, stockTransfers: Array<{ __typename?: 'StockTransfer', _id: string, createdAt: number, updatedAt: number, transferDate: string, destinationColumnId: string, originColumnId: string, deliveryId?: string | null, reassortmentFlow?: ReassortmentFlow | null, shouldUpdateStockImmediately: boolean, state: StockTransferState, destinationColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, originColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, products: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, conditionning: number, packagesPerBatch: number, originStockAvailable: number, destinationStockAvailable: number, quantity: number }>, delivery?: { __typename?: 'Delivery', state: DeliveryState } | null, stateHistory: Array<{ __typename?: 'StockTransferStateHistory', state: StockTransferState, createdAt: number, createdBy: string, createdByName?: string | null }> }> } };

export type AbortReassortmentStockTransfersForDateMutationVariables = Exact<{
  reassortmentDate: Scalars['String']['input'];
  reassortmentFlow: ReassortmentFlow;
  microstoreColumnIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AbortReassortmentStockTransfersForDateMutation = { __typename?: 'Mutation', abortReassortmentStockTransfersForDate: { __typename?: 'StockTransfersResult', errors: Array<string>, stockTransfers: Array<{ __typename?: 'StockTransfer', _id: string, createdAt: number, updatedAt: number, transferDate: string, destinationColumnId: string, originColumnId: string, deliveryId?: string | null, reassortmentFlow?: ReassortmentFlow | null, shouldUpdateStockImmediately: boolean, state: StockTransferState, destinationColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, originColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, products: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, conditionning: number, packagesPerBatch: number, originStockAvailable: number, destinationStockAvailable: number, quantity: number }>, delivery?: { __typename?: 'Delivery', state: DeliveryState } | null, stateHistory: Array<{ __typename?: 'StockTransferStateHistory', state: StockTransferState, createdAt: number, createdBy: string, createdByName?: string | null }> }> } };

export type CreateStockVariationMutationVariables = Exact<{
  columnId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  delta: Scalars['Int']['input'];
  type: StockVariationType;
  explanation: Scalars['String']['input'];
}>;


export type CreateStockVariationMutation = { __typename?: 'Mutation', createStockVariation: { __typename?: 'ProductUpdateResult', error?: string | null, product?: { __typename?: 'Product', _id: string } | null } };

export type CreateMultiStockVariationMutationVariables = Exact<{
  columnId: Scalars['ID']['input'];
  productIdsAndDeltas: Array<ProductIdAndDeltaInput> | ProductIdAndDeltaInput;
  type: StockVariationType;
  explanation: Scalars['String']['input'];
}>;


export type CreateMultiStockVariationMutation = { __typename?: 'Mutation', createMultiStockVariation: Array<{ __typename?: 'ProductUpdateResult', error?: string | null, product?: { __typename?: 'Product', _id: string } | null }> };

export type SplitStockVariationMutationVariables = Exact<{
  stockVariationId: Scalars['ID']['input'];
  newStockVariationInput: StockVariationInput;
}>;


export type SplitStockVariationMutation = { __typename?: 'Mutation', splitStockVariation: { __typename?: 'ColumnProductResult', error?: string | null, variations?: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, explanation?: string | null, productId: string, ref?: string | null, columnInventoryStockId: string, columnId: string, type: StockVariationType }> | null } };

export type CreateSubcategoryMutationVariables = Exact<{
  categoryId: Scalars['ID']['input'];
  createInput: SubcategoryInput;
}>;


export type CreateSubcategoryMutation = { __typename?: 'Mutation', createSubcategory: { __typename?: 'SubcategoryResult', errors?: Array<string> | null, subcategory?: { __typename?: 'Subcategory', _id: string, categoryId: string, displayIndex: number, name: string, state: SubcategoryState } | null } };

export type UpdateSubcategoryMutationVariables = Exact<{
  subcategoryId: Scalars['ID']['input'];
  updateInput: SubcategoryInput;
}>;


export type UpdateSubcategoryMutation = { __typename?: 'Mutation', updateSubcategory: { __typename?: 'SubcategoryResult', errors?: Array<string> | null, subcategory?: { __typename?: 'Subcategory', _id: string, categoryId: string, displayIndex: number, name: string, state: SubcategoryState } | null } };

export type CreateSubventionMutationVariables = Exact<{
  createSubventionInput: CreateSubventionInput;
}>;


export type CreateSubventionMutation = { __typename?: 'Mutation', createSubvention: { __typename?: 'SubventionResult', errors?: Array<string> | null, subvention?: { __typename?: 'Subvention', _id: string, archivedAt?: number | null, billToOrganizationId?: string | null, categories: Array<string>, coverageRate?: number | null, createdAt: number, cumulative?: boolean | null, currentAmount?: number | null, description: string, hoursIntervalsAvailable: Array<Array<string>>, imageUrl?: string | null, name: string, organizationId: string, reload?: SubventionReloadPeriod | null, remainingAmount?: number | null, updatedAt: number, billToOrganization?: { __typename?: 'Organization', _id: string, name: string } | null, organization?: { __typename?: 'Organization', _id: string, name: string } | null } | null } };

export type UpdateSubventionMutationVariables = Exact<{
  subventionId: Scalars['ID']['input'];
  updateInput: UpdateSubventionInput;
}>;


export type UpdateSubventionMutation = { __typename?: 'Mutation', updateSubvention: { __typename?: 'SubventionResult', errors?: Array<string> | null, subvention?: { __typename?: 'Subvention', _id: string, archivedAt?: number | null, billToOrganizationId?: string | null, categories: Array<string>, coverageRate?: number | null, createdAt: number, cumulative?: boolean | null, currentAmount?: number | null, description: string, hoursIntervalsAvailable: Array<Array<string>>, imageUrl?: string | null, name: string, organizationId: string, reload?: SubventionReloadPeriod | null, remainingAmount?: number | null, updatedAt: number, billToOrganization?: { __typename?: 'Organization', _id: string, name: string } | null, organization?: { __typename?: 'Organization', _id: string, name: string } | null } | null } };

export type CreateSupplierMutationVariables = Exact<{
  fields: SupplierFormInput;
}>;


export type CreateSupplierMutation = { __typename?: 'Mutation', createSupplier: { __typename?: 'SupplierCreateResult', errors?: Array<string> | null, formErrors?: Array<{ __typename?: 'FormError', sectionName: string, sectionErrors: Array<{ __typename?: 'SectionError', fieldName: string, fieldError: string }> }> | null, createdSupplier?: { __typename?: 'Supplier', _id: string, nextOrderingDate?: string | null, name: string, description?: string | null, phone?: string | null, address?: string | null, zipcode?: string | null, website?: string | null, createdAt?: number | null, updatedAt?: number | null, shouldCheckReceptionDayIsNotClosed: boolean, shouldOrderAutomatically: boolean, state: SupplierState, paymentTimeType: PaymentTimeType, paymentTimeDays?: number | null, paymentType: SupplierPaymentType, orderMode: OrderMode, orderEmails: Array<string>, orderPlatformUrl?: string | null, clientCode?: string | null, frequency: number, closingDatesRanges: Array<{ __typename?: 'SupplierClosingDatesRange', closingDate: string, openingDate: string }>, stateHistory: Array<{ __typename?: 'SupplierStateHistory', state: SupplierState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, contacts: Array<{ __typename?: 'SupplierContact', name: string, surname: string, phone: string, email: string, description: string }>, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } } } | null } };

export type ArchiveSupplierMutationVariables = Exact<{
  supplierId: Scalars['ID']['input'];
}>;


export type ArchiveSupplierMutation = { __typename?: 'Mutation', archiveSupplier: { __typename?: 'SupplierUpdateStateResult', error?: string | null, updatedSupplier?: { __typename?: 'Supplier', _id: string, state: SupplierState, stateHistory: Array<{ __typename?: 'SupplierStateHistory', createdAt: number, createdBy?: string | null, state: SupplierState }> } | null } };

export type RestoreSupplierMutationVariables = Exact<{
  supplierId: Scalars['ID']['input'];
}>;


export type RestoreSupplierMutation = { __typename?: 'Mutation', restoreSupplier: { __typename?: 'SupplierUpdateStateResult', error?: string | null, updatedSupplier?: { __typename?: 'Supplier', _id: string, state: SupplierState, stateHistory: Array<{ __typename?: 'SupplierStateHistory', createdAt: number, createdBy?: string | null, state: SupplierState }> } | null } };

export type UpdateSupplierMutationVariables = Exact<{
  supplierId: Scalars['ID']['input'];
  fields: SupplierFormInput;
}>;


export type UpdateSupplierMutation = { __typename?: 'Mutation', updateSupplier: { __typename?: 'SupplierUpdateResult', error?: string | null, formErrors?: Array<{ __typename?: 'FormError', sectionName: string, sectionErrors: Array<{ __typename?: 'SectionError', fieldName: string, fieldError: string }> }> | null, updatedSupplier?: { __typename?: 'Supplier', _id: string, nextOrderingDate?: string | null, name: string, description?: string | null, phone?: string | null, address?: string | null, zipcode?: string | null, website?: string | null, createdAt?: number | null, updatedAt?: number | null, shouldCheckReceptionDayIsNotClosed: boolean, shouldOrderAutomatically: boolean, state: SupplierState, paymentTimeType: PaymentTimeType, paymentTimeDays?: number | null, paymentType: SupplierPaymentType, orderMode: OrderMode, orderEmails: Array<string>, orderPlatformUrl?: string | null, clientCode?: string | null, frequency: number, closingDatesRanges: Array<{ __typename?: 'SupplierClosingDatesRange', closingDate: string, openingDate: string }>, stateHistory: Array<{ __typename?: 'SupplierStateHistory', state: SupplierState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, contacts: Array<{ __typename?: 'SupplierContact', name: string, surname: string, phone: string, email: string, description: string }>, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } } } | null } };

export type CreateSupplierDiscountMutationVariables = Exact<{
  input: CreateSupplierDiscountInput;
}>;


export type CreateSupplierDiscountMutation = { __typename?: 'Mutation', createSupplierDiscount: { __typename?: 'SupplierDiscount', _id: string, name: string, createdAt: number, updatedAt: number, state: SupplierDiscountState, rate: number, productIds: Array<string>, purchaseStartDate: number, purchaseEndDate: number, salesStartDate: number, salesEndDate: number, imageUrl?: string | null, discountedProductPrices: Array<{ __typename?: 'DiscountedProductPrice', _id: string, purchasePrice: number, purchaseDiscountedPrice: number, purchaseDiscountAmount: number, purchaseDiscountRate: number, salesPrice: number, salesDiscountedPrice: number, salesDiscountAmount: number, salesDiscountRate: number, product: { __typename?: 'Product', _id: string, fullname: string, category: { __typename?: 'Category', _id: string, title: string }, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null }> } }> } };

export type UpdateSupplierDiscountMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateSupplierDiscountInput;
}>;


export type UpdateSupplierDiscountMutation = { __typename?: 'Mutation', updateSupplierDiscount: { __typename?: 'SupplierDiscount', _id: string, name: string, createdAt: number, updatedAt: number, state: SupplierDiscountState, rate: number, productIds: Array<string>, purchaseStartDate: number, purchaseEndDate: number, salesStartDate: number, salesEndDate: number, imageUrl?: string | null, discountedProductPrices: Array<{ __typename?: 'DiscountedProductPrice', _id: string, purchasePrice: number, purchaseDiscountedPrice: number, purchaseDiscountAmount: number, purchaseDiscountRate: number, salesPrice: number, salesDiscountedPrice: number, salesDiscountAmount: number, salesDiscountRate: number, product: { __typename?: 'Product', _id: string, fullname: string, category: { __typename?: 'Category', _id: string, title: string }, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null }> } }> } };

export type UpdateSupplierDiscountStateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  state: SupplierDiscountState;
}>;


export type UpdateSupplierDiscountStateMutation = { __typename?: 'Mutation', updateSupplierDiscountState: { __typename?: 'SupplierDiscount', _id: string, name: string, createdAt: number, updatedAt: number, state: SupplierDiscountState, rate: number, productIds: Array<string>, purchaseStartDate: number, purchaseEndDate: number, salesStartDate: number, salesEndDate: number, imageUrl?: string | null, discountedProductPrices: Array<{ __typename?: 'DiscountedProductPrice', _id: string, purchasePrice: number, purchaseDiscountedPrice: number, purchaseDiscountAmount: number, purchaseDiscountRate: number, salesPrice: number, salesDiscountedPrice: number, salesDiscountAmount: number, salesDiscountRate: number, product: { __typename?: 'Product', _id: string, fullname: string, category: { __typename?: 'Category', _id: string, title: string }, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null }> } }> } };

export type DeleteSupplierDiscountMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteSupplierDiscountMutation = { __typename?: 'Mutation', deleteSupplierDiscount: boolean };

export type CreateSupplierPartnershipMutationVariables = Exact<{
  supplierPartnershipCreateInput: SupplierPartnershipCreateInput;
}>;


export type CreateSupplierPartnershipMutation = { __typename?: 'Mutation', createSupplierPartnership: { __typename?: 'SupplierPartnership', _id: string, budget: number, createdAt: number, endDate: string, name: string, productIds: Array<string>, startDate: string, updatedAt: number } };

export type UpdateSupplierPartnershipMutationVariables = Exact<{
  supplierPartnershipUpdateInput: SupplierPartnershipUpdateInput;
}>;


export type UpdateSupplierPartnershipMutation = { __typename?: 'Mutation', updateSupplierPartnership: { __typename?: 'SupplierPartnership', _id: string, budget: number, createdAt: number, endDate: string, name: string, productIds: Array<string>, startDate: string, updatedAt: number } };

export type UpdateSupplyOrderMutationVariables = Exact<{
  supplyOrderId: Scalars['ID']['input'];
  fields: SupplyOrderUpdateInput;
}>;


export type UpdateSupplyOrderMutation = { __typename?: 'Mutation', updateSupplyOrderMutation: { __typename?: 'SupplyOrderUpdateResult', success: boolean, errors: Array<string>, warnings: Array<string>, formErrors?: Array<{ __typename?: 'FormError', sectionName: string, sectionErrors: Array<{ __typename?: 'SectionError', fieldName: string, fieldError: string }> }> | null, updatedSupplyOrder?: { __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } } | null } };

export type CreateSupplyOrderMutationVariables = Exact<{
  supplierId: Scalars['ID']['input'];
  warehouseColumnId: Scalars['ID']['input'];
}>;


export type CreateSupplyOrderMutation = { __typename?: 'Mutation', createSupplyOrderMutation: { __typename?: 'SupplyOrderCreateResult', errors: Array<string>, warnings: Array<string>, createdSupplyOrder?: { __typename?: 'SupplyOrder', _id: string, state: SupplyOrderState, createdAt: number, orderDate?: string | null, nextOrderDate?: string | null, dateDeliveryScheduled?: string | null, dateDelivery?: string | null, scheduledDeliveryDateValidity: boolean, number?: number | null, priceHT?: number | null, priceTTC?: number | null, weeklyMenusStartDate?: string | null, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, supplier: { __typename?: 'Supplier', _id: string, name: string, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } } | null } };

export type GenerateSupplyOrdersNeededMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateSupplyOrdersNeededMutation = { __typename?: 'Mutation', generateSupplyOrdersNeededMutation: { __typename?: 'SupplyOrdersCreateResult', errors: Array<string>, createdSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, state: SupplyOrderState, createdAt: number, orderDate?: string | null, nextOrderDate?: string | null, dateDeliveryScheduled?: string | null, dateDelivery?: string | null, scheduledDeliveryDateValidity: boolean, number?: number | null, priceHT?: number | null, priceTTC?: number | null, weeklyMenusStartDate?: string | null, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, supplier: { __typename?: 'Supplier', _id: string, name: string, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }>, mergedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, state: SupplyOrderState, createdAt: number, orderDate?: string | null, nextOrderDate?: string | null, dateDeliveryScheduled?: string | null, dateDelivery?: string | null, scheduledDeliveryDateValidity: boolean, number?: number | null, priceHT?: number | null, priceTTC?: number | null, weeklyMenusStartDate?: string | null, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, supplier: { __typename?: 'Supplier', _id: string, name: string, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type RelaunchPassSupplyOrdersToOrderedMutationVariables = Exact<{ [key: string]: never; }>;


export type RelaunchPassSupplyOrdersToOrderedMutation = { __typename?: 'Mutation', relaunchPassSupplyOrdersToOrdered: { __typename?: 'SupplyOrdersUpdateResult', errors?: Array<string> | null, updatedSupplyOrders?: Array<{ __typename?: 'SupplyOrder', _id: string, state: SupplyOrderState, createdAt: number, orderDate?: string | null, nextOrderDate?: string | null, dateDeliveryScheduled?: string | null, dateDelivery?: string | null, scheduledDeliveryDateValidity: boolean, number?: number | null, priceHT?: number | null, priceTTC?: number | null, weeklyMenusStartDate?: string | null, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, supplier: { __typename?: 'Supplier', _id: string, name: string, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> | null } };

export type MarkSupplyOrdersAsAbortedMutationVariables = Exact<{
  supplyOrderIdsWithReasons: Array<SupplyOrderIdWithReasonsForAborting> | SupplyOrderIdWithReasonsForAborting;
}>;


export type MarkSupplyOrdersAsAbortedMutation = { __typename?: 'Mutation', markSupplyOrdersAsAborted: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type MarkSupplyOrderAsAbortedMutationVariables = Exact<{
  supplyOrderIdsWithReasons: Array<SupplyOrderIdWithReasonsForAborting> | SupplyOrderIdWithReasonsForAborting;
}>;


export type MarkSupplyOrderAsAbortedMutation = { __typename?: 'Mutation', markSupplyOrdersAsAborted: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type MarkSupplyOrderAsCheckedMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkSupplyOrderAsCheckedMutation = { __typename?: 'Mutation', markSupplyOrdersAsChecked: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type MarkSupplyOrderAsConfirmedMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkSupplyOrderAsConfirmedMutation = { __typename?: 'Mutation', markSupplyOrdersAsConfirmed: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type MarkSupplyOrdersAsConfirmedMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkSupplyOrdersAsConfirmedMutation = { __typename?: 'Mutation', markSupplyOrdersAsConfirmed: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, state: SupplyOrderState }> } };

export type MarkSupplyOrderAsInrackMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkSupplyOrderAsInrackMutation = { __typename?: 'Mutation', markSupplyOrdersAsInRack: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type MarkSupplyOrderAsOnHoldMutationVariables = Exact<{
  supplyOrderId: Scalars['ID']['input'];
}>;


export type MarkSupplyOrderAsOnHoldMutation = { __typename?: 'Mutation', markSupplyOrderAsOnHold: { __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } } };

export type MarkSupplyOrderAsOrderedMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  shouldSendMailToSupplier?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarkSupplyOrderAsOrderedMutation = { __typename?: 'Mutation', markSupplyOrdersAsOrdered: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type MarkSupplyOrdersAsOrderedMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  shouldSendMailToSupplier?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarkSupplyOrdersAsOrderedMutation = { __typename?: 'Mutation', markSupplyOrdersAsOrdered: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, state: SupplyOrderState }> } };

export type MarkSupplyOrderAsReadyMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkSupplyOrderAsReadyMutation = { __typename?: 'Mutation', markSupplyOrdersAsReady: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type MarkSupplyOrdersAsReadyMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkSupplyOrdersAsReadyMutation = { __typename?: 'Mutation', markSupplyOrdersAsReady: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, dateDeliveryScheduled?: string | null, orderDate?: string | null, state: SupplyOrderState }> } };

export type MarkSupplyOrderAsCreatedMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkSupplyOrderAsCreatedMutation = { __typename?: 'Mutation', markSupplyOrdersAsCreated: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type MarkSupplyOrdersAsCreatedMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkSupplyOrdersAsCreatedMutation = { __typename?: 'Mutation', markSupplyOrdersAsCreated: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, state: SupplyOrderState }> } };

export type MarkSupplyOrderAsReceivedMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  hourDeliveryReceivedAt: Scalars['String']['input'];
}>;


export type MarkSupplyOrderAsReceivedMutation = { __typename?: 'Mutation', markSupplyOrdersAsReceived: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type MarkSupplyOrdersAsReceivedMutationVariables = Exact<{
  supplyOrderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  hourDeliveryReceivedAt: Scalars['String']['input'];
}>;


export type MarkSupplyOrdersAsReceivedMutation = { __typename?: 'Mutation', markSupplyOrdersAsReceived: { __typename?: 'SupplyOrdersStateUpdateResult', errors: Array<string>, warnings?: Array<string> | null, updatedSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, state: SupplyOrderState }> } };

export type ExternalConfirmSupplyOrderMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ExternalConfirmSupplyOrderMutation = { __typename?: 'Mutation', externalConfirmSupplyOrder: { __typename?: 'ErrorCheck', success: boolean, error?: string | null } };

export type AddAdditionalSupplyOrderReceivedProductDetailsMutationVariables = Exact<{
  supplyOrderId: Scalars['String']['input'];
  productDetails: Array<SupplyOrderReceivedProductDetails> | SupplyOrderReceivedProductDetails;
}>;


export type AddAdditionalSupplyOrderReceivedProductDetailsMutation = { __typename?: 'Mutation', addAdditionalSupplyOrderReceivedProductDetails: { __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } } };

export type CreateTagMutationVariables = Exact<{
  tag: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'TagResult', success: boolean, error?: string | null, tag?: { __typename?: 'Tag', _id: string, createdAt: number, displayIndex: number, name: string, type: TagType, state: TagState, updatedAt: number, stateHistory: Array<{ __typename?: 'TagStateHistory', state: TagState, createdAt: number }> } | null } };

export type UpdateTagMutationVariables = Exact<{
  tag: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'TagResult', success: boolean, error?: string | null, tag?: { __typename?: 'Tag', _id: string, createdAt: number, displayIndex: number, name: string, type: TagType, state: TagState, updatedAt: number, stateHistory: Array<{ __typename?: 'TagStateHistory', state: TagState, createdAt: number }> } | null } };

export type CreateTermsRecordMutationVariables = Exact<{
  termsOfUse: Scalars['Upload']['input'];
}>;


export type CreateTermsRecordMutation = { __typename?: 'Mutation', createTermsRecord: { __typename?: 'TermsRecordResult', success: boolean, error?: string | null, termsRecord?: { __typename?: 'TermsRecord', _id: string, createdAt: number, termsOfUseUrl: string } | null } };

export type CreateThermometerMutationVariables = Exact<{
  number: Scalars['Int']['input'];
}>;


export type CreateThermometerMutation = { __typename?: 'Mutation', createThermometer: { __typename?: 'Thermometer', _id: string, associatedUserId?: string | null, isOperational: boolean, number: number } };

export type UpdateThermometerMutationVariables = Exact<{
  thermometerUpdateInput: ThermometerUpdateInput;
}>;


export type UpdateThermometerMutation = { __typename?: 'Mutation', updateThermometer: { __typename?: 'Thermometer', _id: string, associatedUserId?: string | null, isOperational: boolean, number: number } };

export type ArchiveTotemMutationVariables = Exact<{
  totemId: Scalars['ID']['input'];
}>;


export type ArchiveTotemMutation = { __typename?: 'Mutation', archiveTotem: { __typename?: 'UpdateTotemStateResult', errors?: Array<string> | null, organization?: { __typename?: 'Organization', _id: string, state: OrganizationState, stateHistory: Array<{ __typename?: 'OrganizationStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: OrganizationState }> } | null, totem?: { __typename?: 'Totem', _id: string, state: TotemState, stateHistory: Array<{ __typename?: 'TotemStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: TotemState }> } | null } };

export type ReactivateTotemMutationVariables = Exact<{
  totemId: Scalars['ID']['input'];
}>;


export type ReactivateTotemMutation = { __typename?: 'Mutation', reactivateTotem: { __typename?: 'UpdateTotemStateResult', errors?: Array<string> | null, organization?: { __typename?: 'Organization', _id: string, state: OrganizationState, stateHistory: Array<{ __typename?: 'OrganizationStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: OrganizationState }> } | null, totem?: { __typename?: 'Totem', _id: string, state: TotemState, stateHistory: Array<{ __typename?: 'TotemStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: TotemState }> } | null } };

export type UpdateTotemMutationVariables = Exact<{
  totemId: Scalars['ID']['input'];
  fields: TotemUpdateInput;
}>;


export type UpdateTotemMutation = { __typename?: 'Mutation', updateTotem: { __typename?: 'TotemUpdateResult', error?: string | null, formErrors?: Array<{ __typename?: 'FormError', sectionName: string, sectionErrors: Array<{ __typename?: 'SectionError', fieldName: string, fieldError: string }> }> | null, updatedTotem?: { __typename?: 'Totem', _id: string, name?: string | null, address?: string | null, address_details?: string | null, consigneDelivery?: string | null, zipcode?: string | null, city?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, needSignature: boolean, minimumOrderAmountInfo: { __typename?: 'MinimumOrderAmountInfo', minimumBakeryAmount: number, minimumDryAmount: number, minimumFreshAmount: number, minimumCatererAmount: number, minimumFruitAmount: number, minimumTotalAmount: number } } | null } };

export type CreateNewTotemFromOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type CreateNewTotemFromOrganizationMutation = { __typename?: 'Mutation', createNewTotemFromOrganization: { __typename?: 'Totem', _id: string, name?: string | null, number: number, state: TotemState, stateHistory: Array<{ __typename?: 'TotemStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: TotemState }> } };

export type CreateTotemClosedDayMutationVariables = Exact<{
  createTotemClosedDayInput: CreateTotemClosedDayInput;
}>;


export type CreateTotemClosedDayMutation = { __typename?: 'Mutation', createTotemClosedDay: { __typename?: 'TotemClosedDay', _id: string, createdAt: number, date: string, state: TotemClosedDayState, type: TotemClosedDayType, updatedAt: number } };

export type AbortTotemClosedDayMutationVariables = Exact<{
  totemClosedDayId: Scalars['ID']['input'];
}>;


export type AbortTotemClosedDayMutation = { __typename?: 'Mutation', abortTotemClosedDay: { __typename?: 'TotemClosedDay', _id: string, createdAt: number, date: string, state: TotemClosedDayState, type: TotemClosedDayType, updatedAt: number } };

export type ArchiveTotemClosedDayMutationVariables = Exact<{
  totemClosedDayId: Scalars['ID']['input'];
}>;


export type ArchiveTotemClosedDayMutation = { __typename?: 'Mutation', archiveTotemClosedDay: { __typename?: 'TotemClosedDay', _id: string, createdAt: number, date: string, state: TotemClosedDayState, type: TotemClosedDayType, updatedAt: number } };

export type CreateTotemClosedReceptionDayMutationVariables = Exact<{
  createTotemClosedReceptionDayInput: CreateTotemClosedReceptionDayInput;
}>;


export type CreateTotemClosedReceptionDayMutation = { __typename?: 'Mutation', createTotemClosedReceptionDay: { __typename?: 'TotemClosedReceptionDay', _id: string, createdAt: number, date: string, state: TotemClosedReceptionDayState, updatedAt: number } };

export type AbortTotemClosedReceptionDayMutationVariables = Exact<{
  totemClosedReceptionDayId: Scalars['ID']['input'];
}>;


export type AbortTotemClosedReceptionDayMutation = { __typename?: 'Mutation', abortTotemClosedReceptionDay: { __typename?: 'TotemClosedReceptionDay', _id: string, createdAt: number, date: string, state: TotemClosedReceptionDayState, updatedAt: number } };

export type ArchiveTotemClosedReceptionDayMutationVariables = Exact<{
  totemClosedReceptionDayId: Scalars['ID']['input'];
}>;


export type ArchiveTotemClosedReceptionDayMutation = { __typename?: 'Mutation', archiveTotemClosedReceptionDay: { __typename?: 'TotemClosedReceptionDay', _id: string, createdAt: number, date: string, state: TotemClosedReceptionDayState, updatedAt: number } };

export type BuildToursForDateMutationVariables = Exact<{
  birthdayDate: Scalars['String']['input'];
}>;


export type BuildToursForDateMutation = { __typename?: 'Mutation', buildToursForDate: { __typename?: 'TourBuildResult', toursCreated: number, toursAppended: number, deliveriesPlanned: number, deliveriesKept: number } };

export type CreateTourMutationVariables = Exact<{
  input: CreateTourInput;
}>;


export type CreateTourMutation = { __typename?: 'Mutation', createTour: { __typename?: 'Tour', _id: string, name: string, color: string, deliveryPersonUserId?: string | null, state: TourState, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, deliveries: Array<{ __typename?: 'Delivery', _id: string, siteName?: string | null, organizationName?: string | null, isDynamic: boolean, state: DeliveryState, type: DeliveryType, deliveredMicrostoreColumnIds: Array<string>, orderIds: Array<string>, theoricServiceTime?: number | null, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState }>, deliveredMicrostoreColumns: Array<{ __typename?: 'Column', _id: string, microstoreColumn?: { __typename?: 'MicrostoreColumn', _id: string, type: MicrostoreColumnTemplateType } | null }>, orders: Array<{ __typename?: 'Order', _id: string, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }> }>, totem?: { __typename?: 'Totem', _id: string, name?: string | null, number: number, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null, site?: { __typename?: 'Site', _id: string, contractType: SiteContractType, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string } | null } | null, boxes: Array<{ __typename?: 'Box', _id: string, type: ProductFlow, departureScannedAt?: number | null, loadedAt?: number | null, setupScannedAt?: number | null, returnedAt?: number | null }> }>, stops: Array<{ __typename: 'Delivery', _id: string } | { __typename: 'Task', _id: string, type: TaskType, description: string, driversComment?: string | null, state: TaskState, siteId: string, theoricServiceTime: number, instructions: Array<{ __typename?: 'TaskInstruction', _id: string, label: string, isDone: boolean, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }>, stateHistory: Array<{ __typename?: 'TaskStateHistory', state: TaskState, createdAt: number, createdByName?: string | null }>, site?: { __typename?: 'Site', _id: string, name: string, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string } } | null, totem?: { __typename?: 'Totem', _id: string, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null }> } };

export type UpdateTourMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateTourInput;
}>;


export type UpdateTourMutation = { __typename?: 'Mutation', updateTour: { __typename?: 'Tour', _id: string, name: string, color: string, deliveryPersonUserId?: string | null, state: TourState, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, deliveries: Array<{ __typename?: 'Delivery', _id: string, siteName?: string | null, organizationName?: string | null, isDynamic: boolean, state: DeliveryState, type: DeliveryType, deliveredMicrostoreColumnIds: Array<string>, orderIds: Array<string>, theoricServiceTime?: number | null, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState }>, deliveredMicrostoreColumns: Array<{ __typename?: 'Column', _id: string, microstoreColumn?: { __typename?: 'MicrostoreColumn', _id: string, type: MicrostoreColumnTemplateType } | null }>, orders: Array<{ __typename?: 'Order', _id: string, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }> }>, totem?: { __typename?: 'Totem', _id: string, name?: string | null, number: number, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null, site?: { __typename?: 'Site', _id: string, contractType: SiteContractType, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string } | null } | null, boxes: Array<{ __typename?: 'Box', _id: string, type: ProductFlow, departureScannedAt?: number | null, loadedAt?: number | null, setupScannedAt?: number | null, returnedAt?: number | null }> }>, stops: Array<{ __typename: 'Delivery', _id: string } | { __typename: 'Task', _id: string, type: TaskType, description: string, driversComment?: string | null, state: TaskState, siteId: string, theoricServiceTime: number, instructions: Array<{ __typename?: 'TaskInstruction', _id: string, label: string, isDone: boolean, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }>, stateHistory: Array<{ __typename?: 'TaskStateHistory', state: TaskState, createdAt: number, createdByName?: string | null }>, site?: { __typename?: 'Site', _id: string, name: string, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string } } | null, totem?: { __typename?: 'Totem', _id: string, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null }> } };

export type UpdateTourStateMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  state: TourState;
}>;


export type UpdateTourStateMutation = { __typename?: 'Mutation', updateTourState: { __typename?: 'Tour', _id: string, name: string, color: string, deliveryPersonUserId?: string | null, state: TourState, stateHistory: Array<{ __typename?: 'TourStateHistory', state: TourState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, deliveries: Array<{ __typename?: 'Delivery', _id: string, siteName?: string | null, organizationName?: string | null, isDynamic: boolean, state: DeliveryState, type: DeliveryType, deliveredMicrostoreColumnIds: Array<string>, orderIds: Array<string>, theoricServiceTime?: number | null, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState }>, deliveredMicrostoreColumns: Array<{ __typename?: 'Column', _id: string, microstoreColumn?: { __typename?: 'MicrostoreColumn', _id: string, type: MicrostoreColumnTemplateType } | null }>, orders: Array<{ __typename?: 'Order', _id: string, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }> }>, totem?: { __typename?: 'Totem', _id: string, name?: string | null, number: number, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null, site?: { __typename?: 'Site', _id: string, contractType: SiteContractType, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string } | null } | null, boxes: Array<{ __typename?: 'Box', _id: string, type: ProductFlow, departureScannedAt?: number | null, loadedAt?: number | null, setupScannedAt?: number | null, returnedAt?: number | null }> }>, stops: Array<{ __typename: 'Delivery', _id: string } | { __typename: 'Task', _id: string, type: TaskType, description: string, driversComment?: string | null, state: TaskState, siteId: string, theoricServiceTime: number, instructions: Array<{ __typename?: 'TaskInstruction', _id: string, label: string, isDone: boolean, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }>, stateHistory: Array<{ __typename?: 'TaskStateHistory', state: TaskState, createdAt: number, createdByName?: string | null }>, site?: { __typename?: 'Site', _id: string, name: string, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string } } | null, totem?: { __typename?: 'Totem', _id: string, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null }> } };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: { __typename?: 'TaskResult', success: boolean, error?: string | null, task?: { __typename?: 'Task', _id: string, type: TaskType, description: string, driversComment?: string | null, state: TaskState, siteId: string, theoricServiceTime: number, instructions: Array<{ __typename?: 'TaskInstruction', _id: string, label: string, isDone: boolean, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }>, stateHistory: Array<{ __typename?: 'TaskStateHistory', state: TaskState, createdAt: number, createdByName?: string | null }>, site?: { __typename?: 'Site', _id: string, name: string, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string } } | null, totem?: { __typename?: 'Totem', _id: string, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null } | null } };

export type UpdateTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskResult', success: boolean, error?: string | null, task?: { __typename?: 'Task', _id: string, type: TaskType, description: string, driversComment?: string | null, state: TaskState, siteId: string, theoricServiceTime: number, instructions: Array<{ __typename?: 'TaskInstruction', _id: string, label: string, isDone: boolean, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }>, stateHistory: Array<{ __typename?: 'TaskStateHistory', state: TaskState, createdAt: number, createdByName?: string | null }>, site?: { __typename?: 'Site', _id: string, name: string, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string } } | null, totem?: { __typename?: 'Totem', _id: string, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null } | null } };

export type RefundTransactionMutationVariables = Exact<{
  transactionId: Scalars['ID']['input'];
  refundReason?: InputMaybe<Scalars['String']['input']>;
  shouldUpdateProductStock: Scalars['Boolean']['input'];
}>;


export type RefundTransactionMutation = { __typename?: 'Mutation', refundTransaction: { __typename?: 'Transaction', _id: string, basketId?: string | null, nuBasketId?: string | null, createdAt: number, priceHT: number, productId: string, productName: string, refundReason?: string | null, siteId: string, siteName: string, microstoreColumnId?: string | null, microstoreColumnName: string, newState: TransactionState, tva: number, userId: string, userFullName: string, nayaxMDBCode?: number | null, nuBasket?: { __typename?: 'NuBasket', type: NuBasketType } | null, paymentMethods?: Array<{ __typename?: 'TransactionPaymentMethod', amountUsed: number, explanation?: string | null, name?: string | null, paymentMethodName: PaymentMethodName, provider?: string | null, providerTransactionId?: string | null, status: PaymentIntentState, type?: PaymentMethodPaymentType | null }> | null, mealPlan?: { __typename?: 'MealPlan', discountRatio: number } | null, stateHistory: Array<{ __typename?: 'TransactionStateHistory', state: TransactionState, createdAt: number, createdBy: string }> } };

export type TrayCapacityMutationFragmentFragment = { __typename?: 'TrayCapacity', _id: string, microstoreColumnId: string, locations: Array<{ __typename?: 'TrayCapacityLocation', microstoreLocationId: string, productId: string, currentLevel: number, unitPerPackage: number, microstoreLocation: { __typename?: 'MicrostoreLocation', microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', trayMaxCapacity: number } }, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null } }> };

export type UpdateTrayLocationLevelMutationVariables = Exact<{
  trayCapacityId: Scalars['ID']['input'];
  microstoreLocationId: Scalars['String']['input'];
  currentLevel: Scalars['Int']['input'];
}>;


export type UpdateTrayLocationLevelMutation = { __typename?: 'Mutation', updateTrayLocationLevel: { __typename?: 'TrayCapacityMutationResult', success?: boolean | null, error?: string | null, trayCapacity?: { __typename?: 'TrayCapacity', _id: string, microstoreColumnId: string, locations: Array<{ __typename?: 'TrayCapacityLocation', microstoreLocationId: string, productId: string, currentLevel: number, unitPerPackage: number, microstoreLocation: { __typename?: 'MicrostoreLocation', microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', trayMaxCapacity: number } }, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null } }> } | null } };

export type CreateUrbantzRoundPresetMutationVariables = Exact<{
  dayIndex: Scalars['Int']['input'];
}>;


export type CreateUrbantzRoundPresetMutation = { __typename?: 'Mutation', createUrbantzRoundPreset: { __typename?: 'UrbantzRoundPreset', _id: string, createdAt: number, dayIndex: number, totemIds: Array<string>, updatedAt: number } };

export type UpdateUrbantzRoundPresetMutationVariables = Exact<{
  urbantzRoundPresetUpdateInput: UrbantzRoundPresetUpdateInput;
}>;


export type UpdateUrbantzRoundPresetMutation = { __typename?: 'Mutation', updateUrbantzRoundPreset: { __typename?: 'UrbantzRoundPreset', _id: string, createdAt: number, dayIndex: number, totemIds: Array<string>, updatedAt: number } };

export type DeleteUrbantzRoundPresetMutationVariables = Exact<{
  urbantzRoundPresetId: Scalars['ID']['input'];
}>;


export type DeleteUrbantzRoundPresetMutation = { __typename?: 'Mutation', deleteUrbantzRoundPreset: boolean };

export type SigninTotemAdminMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type SigninTotemAdminMutation = { __typename?: 'Mutation', signinTotemAdmin: { __typename?: 'MobileSignInResult', success: boolean, error?: string | null, token?: string | null, refreshToken?: string | null, user?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', firstname?: string | null, imageUrl?: string | null, lastname?: string | null }, permissions: Array<{ __typename?: 'UserPermissions', totemId?: string | null, userGroup: UserPermission }> } | null } };

export type SigninTotemAdminSsoMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type SigninTotemAdminSsoMutation = { __typename?: 'Mutation', signinTotemAdminSSO: { __typename?: 'MobileSignInResult', success: boolean, error?: string | null, token?: string | null, refreshToken?: string | null, user?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', firstname?: string | null, imageUrl?: string | null, lastname?: string | null }, permissions: Array<{ __typename?: 'UserPermissions', totemId?: string | null, userGroup: UserPermission }> } | null } };

export type VerifyLoggedInMutationVariables = Exact<{ [key: string]: never; }>;


export type VerifyLoggedInMutation = { __typename?: 'Mutation', verifyLoggedIn: { __typename?: 'TokenResult', success: boolean, user?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', firstname?: string | null, imageUrl?: string | null, lastname?: string | null }, permissions: Array<{ __typename?: 'UserPermissions', totemId?: string | null, userGroup: UserPermission }> } | null } };

export type UpdateAdminUserMutationVariables = Exact<{
  fieldsToUpdate: UserUpdateInput;
  userId: Scalars['ID']['input'];
}>;


export type UpdateAdminUserMutation = { __typename?: 'Mutation', updateAdminUser: { __typename?: 'UserResult', success: boolean, error?: string | null, user?: { __typename?: 'User', _id: string, username: string, createdAt: number, lastSeenAt?: number | null, userGroupIds: Array<string>, stripeCustomerId?: string | null, defaultTruckColumnId?: string | null, emails: Array<{ __typename?: 'UserEmail', address: string, verified: boolean, bounced?: { __typename?: 'BouncedType', createdAt: number, reason: string } | null }>, getLastTransactions: Array<{ __typename?: 'Transaction', _id: string, basketId?: string | null, nuBasketId?: string | null, createdAt: number, priceHT: number, productName: string, siteId: string, siteName: string, microstoreColumnId?: string | null, microstoreColumnName: string, newState: TransactionState, tva: number, userFullName: string, nuBasket?: { __typename?: 'NuBasket', type: NuBasketType } | null, paymentMethods?: Array<{ __typename?: 'TransactionPaymentMethod', provider?: string | null }> | null }>, notificationPreferences: { __typename?: 'NotificationPreferences', customRitualActivity: Array<NotificationPreferenceChannel>, dailyDelivery: Array<NotificationPreferenceChannel>, feedbacks: Array<NotificationPreferenceChannel>, newFeatures: Array<NotificationPreferenceChannel>, recommendations: Array<NotificationPreferenceChannel>, reminders: Array<NotificationPreferenceChannel>, ritualInvite: Array<NotificationPreferenceChannel>, siteActivity: Array<NotificationPreferenceChannel>, specialOffers: Array<NotificationPreferenceChannel>, startingRitual: Array<NotificationPreferenceChannel>, weeklySummary: Array<NotificationPreferenceChannel> }, organization?: { __typename?: 'Organization', _id: string, name: string } | null, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, fullname?: string | null, state: UserState, phone?: string | null, imageUrl?: string | null }, permissions: Array<{ __typename?: 'UserPermissions', totemId?: string | null, userGroup: UserPermission, totem?: { __typename?: 'Totem', fullname: string } | null }>, visitedSites?: Array<{ __typename?: 'VisitedSite', _id: string, name: string, createdAt: number, visitedAt: number }> | null, defaultTruckColumn?: { __typename?: 'MicrostoreColumn', _id: string, name: string, siteId: string, siteName: string } | null, wallet: { __typename?: 'Wallet', credits: Array<{ __typename?: 'Credit', _id: string, createdAt: number, updatedAt: number, name: string, initialAmount: number, currentAmount: number, expirationDate: number, startDate: number, type: CreditType, refundedAt?: number | null, createdBy?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null, organizationBatched?: { __typename?: 'Organization', name: string } | null, owner?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null }>, subventions: Array<{ __typename?: 'Subvention', _id: string, name: string, description: string, categories: Array<string>, cumulative?: boolean | null, currentAmount?: number | null, remainingAmount?: number | null, hoursIntervalsAvailable: Array<Array<string>>, imageUrl?: string | null, reload?: SubventionReloadPeriod | null, organization?: { __typename?: 'Organization', _id: string, name: string } | null }>, organizationCard?: { __typename?: 'OrganizationCard', _id: string, state: OrganizationCardState } | null, creditCards: Array<{ __typename?: 'CreditCard', _id: string, default: boolean, expired?: boolean | null, paymentType: string, provider: CreditCardProvider, retries: number, details: { __typename?: 'CreditCardDetails', number?: string | null, expiration?: string | null, bank?: string | null, country?: string | null, expYear?: string | null, expMonth?: string | null } }>, mealVouchers: Array<{ __typename?: 'MealVoucher', _id: string, cardType: CardType, default: boolean, expired?: boolean | null, paymentType: string, provider: MealVoucherProvider, details: { __typename?: 'MealVoucherDetails', number?: string | null, username?: string | null, expiration?: string | null, bank?: string | null, country?: string | null } }> } } | null } };

export type ToggleUserNotificationPreferenceFromAdminMutationVariables = Exact<{
  notificationPreference: Scalars['String']['input'];
  channel: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
}>;


export type ToggleUserNotificationPreferenceFromAdminMutation = { __typename?: 'Mutation', toggleUserNotificationPreferenceFromAdmin: { __typename?: 'NotificationPreferences', customRitualActivity: Array<NotificationPreferenceChannel>, dailyDelivery: Array<NotificationPreferenceChannel>, feedbacks: Array<NotificationPreferenceChannel>, newFeatures: Array<NotificationPreferenceChannel>, recommendations: Array<NotificationPreferenceChannel>, reminders: Array<NotificationPreferenceChannel>, ritualInvite: Array<NotificationPreferenceChannel>, siteActivity: Array<NotificationPreferenceChannel>, specialOffers: Array<NotificationPreferenceChannel>, startingRitual: Array<NotificationPreferenceChannel>, weeklySummary: Array<NotificationPreferenceChannel> } };

export type CreateToteamUserMutationVariables = Exact<{
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  role: InternalUserRole;
}>;


export type CreateToteamUserMutation = { __typename?: 'Mutation', createToteamUserResolver: { __typename?: 'UserResult', success: boolean, error?: string | null, user?: { __typename?: 'User', _id: string } | null } };

export type SendResetPasswordMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  appName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendResetPasswordMutation = { __typename?: 'Mutation', sendResetPassword: { __typename?: 'ErrorEmailCheck', success: boolean, error?: string | null } };

export type AuthenticateUserResetMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AuthenticateUserResetMutation = { __typename?: 'Mutation', authenticateUserReset: { __typename?: 'ErrorCheck', success: boolean, error?: string | null } };

export type AuthenticateUserMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AuthenticateUserMutation = { __typename?: 'Mutation', authenticateUser: { __typename?: 'ErrorEmailCheck', success: boolean, error?: string | null } };

export type ChangePasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'ErrorCheck', success: boolean, error?: string | null } };

export type SetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setUserPassword: { __typename?: 'ErrorTokenCheck', success: boolean, error?: string | null, token?: string | null, refreshToken?: string | null, user?: { __typename?: 'User', _id: string, permissions: Array<{ __typename?: 'UserPermissions', totemId?: string | null, userGroup: UserPermission }> } | null } };

export type ResendEmailVerificationEmailMutationVariables = Exact<{
  emailToVerify: Scalars['String']['input'];
}>;


export type ResendEmailVerificationEmailMutation = { __typename?: 'Mutation', resendEmailVerificationEmail: { __typename?: 'SimpleResponse', success: boolean, error?: string | null } };

export type BeginWarehouseDeliveryPreparationMutationVariables = Exact<{
  warehouseDeliveryId: Scalars['String']['input'];
}>;


export type BeginWarehouseDeliveryPreparationMutation = { __typename?: 'Mutation', beginWarehouseDelivery: { __typename?: 'WarehouseDeliveryMutationResult', success: boolean, error?: string | null, warehouseDelivery?: { __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | null } };

export type FinishWarehouseDeliveryPreparationMutationVariables = Exact<{
  warehouseDeliveryId: Scalars['String']['input'];
}>;


export type FinishWarehouseDeliveryPreparationMutation = { __typename?: 'Mutation', finishWarehouseDelivery: { __typename?: 'WarehouseDeliveryMutationResult', success: boolean, error?: string | null, warehouseDelivery?: { __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | null } };

export type MarkWarehouseDeliveryAsInProgressMutationVariables = Exact<{
  warehouseDeliveryId: Scalars['String']['input'];
}>;


export type MarkWarehouseDeliveryAsInProgressMutation = { __typename?: 'Mutation', markWarehouseDeliveryAsInProgress: { __typename?: 'WarehouseDeliveryMutationResult', success: boolean, error?: string | null, warehouseDelivery?: { __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | null } };

export type MarkWarehouseDeliveryAsDeliveredMutationVariables = Exact<{
  warehouseDeliveryId: Scalars['String']['input'];
}>;


export type MarkWarehouseDeliveryAsDeliveredMutation = { __typename?: 'Mutation', markWarehouseDeliveryAsDelivered: { __typename?: 'WarehouseDeliveryMutationResult', success: boolean, error?: string | null, warehouseDelivery?: { __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | null } };

export type ArchiveWarehouseDeliveryMutationVariables = Exact<{
  warehouseDeliveryId: Scalars['String']['input'];
}>;


export type ArchiveWarehouseDeliveryMutation = { __typename?: 'Mutation', archiveWarehouseDelivery: { __typename?: 'WarehouseDeliveryMutationResult', success: boolean, error?: string | null, warehouseDelivery?: { __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | null } };

export type AbortWarehouseDeliveryMutationVariables = Exact<{
  warehouseDeliveryId: Scalars['String']['input'];
}>;


export type AbortWarehouseDeliveryMutation = { __typename?: 'Mutation', abortWarehouseDelivery: { __typename?: 'WarehouseDeliveryMutationResult', success: boolean, error?: string | null, warehouseDelivery?: { __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | null } };

export type UpdateWarehouseDeliveriesStateMutationVariables = Exact<{
  warehouseDeliveryIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  state: DeliveryState;
}>;


export type UpdateWarehouseDeliveriesStateMutation = { __typename?: 'Mutation', updateWarehouseDeliveriesState: { __typename?: 'WarehouseDeliveriesMutationResult', success: boolean, errors: Array<string>, warehouseDeliveries: Array<{ __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }> } };

export type UpdateWarehouseDeliveryMutationVariables = Exact<{
  warehouseDeliveryId: Scalars['String']['input'];
  warehouseDeliveryInput: WarehouseDeliveryInput;
}>;


export type UpdateWarehouseDeliveryMutation = { __typename?: 'Mutation', updateWarehouseDelivery: { __typename?: 'WarehouseDeliveryMutationResult', warehouseDelivery?: { __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | null } };

export type PassWarehouseReturnToInProgressMutationVariables = Exact<{
  warehouseReturnId: Scalars['ID']['input'];
}>;


export type PassWarehouseReturnToInProgressMutation = { __typename?: 'Mutation', passWarehouseReturnToInProgress: { __typename?: 'WarehouseReturn', _id: string, createdAt: number, date: string, originColumnId: string, warehouseColumnId: string, state: WarehouseReturnState, updatedAt: number, brokenProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, expiredProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, originColumn: { __typename?: 'Column', name: string }, warehouseColumn: { __typename?: 'Column', name: string }, returnedProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, returnedWithNoStockUpdateProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, stateHistory: Array<{ __typename?: 'WarehouseReturnStateHistory', createdAt: number, state: WarehouseReturnState }> } };

export type PassWarehouseReturnToDeliveredMutationVariables = Exact<{
  warehouseReturnId: Scalars['ID']['input'];
}>;


export type PassWarehouseReturnToDeliveredMutation = { __typename?: 'Mutation', passWarehouseReturnToDelivered: { __typename?: 'WarehouseReturn', _id: string, createdAt: number, date: string, originColumnId: string, warehouseColumnId: string, state: WarehouseReturnState, updatedAt: number, brokenProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, expiredProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, originColumn: { __typename?: 'Column', name: string }, warehouseColumn: { __typename?: 'Column', name: string }, returnedProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, returnedWithNoStockUpdateProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, stateHistory: Array<{ __typename?: 'WarehouseReturnStateHistory', createdAt: number, state: WarehouseReturnState }> } };

export type PassWarehouseReturnToStoredMutationVariables = Exact<{
  warehouseReturnId: Scalars['ID']['input'];
}>;


export type PassWarehouseReturnToStoredMutation = { __typename?: 'Mutation', passWarehouseReturnToStored: { __typename?: 'WarehouseReturn', _id: string, createdAt: number, date: string, originColumnId: string, warehouseColumnId: string, state: WarehouseReturnState, updatedAt: number, brokenProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, expiredProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, originColumn: { __typename?: 'Column', name: string }, warehouseColumn: { __typename?: 'Column', name: string }, returnedProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, returnedWithNoStockUpdateProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, stateHistory: Array<{ __typename?: 'WarehouseReturnStateHistory', createdAt: number, state: WarehouseReturnState }> } };

export type GetAdvertisementScreenConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdvertisementScreenConfigQuery = { __typename?: 'Query', getAdvertisementScreenConfig: { __typename?: 'AdvertisementScreenConfig', _id: string, imageUrls: Array<string> } };

export type GetAuditLogsQueryVariables = Exact<{
  collectionDocumentId: Scalars['String']['input'];
}>;


export type GetAuditLogsQuery = { __typename?: 'Query', auditLogs: Array<{ __typename?: 'AuditLog', _id: string, createdAt: number, updatedAt: number, createdBy: string, createdByName: string, collectionName: string, collectionDocumentId: string, patches: Array<{ __typename?: 'AddPatch', op: PatchOp, path: string, value?: any | null } | { __typename?: 'CopyPatch', op: PatchOp, path: string, from: string } | { __typename?: 'MovePatch', op: PatchOp, path: string, from: string } | { __typename?: 'RemovePatch', op: PatchOp, path: string, oldValue?: any | null } | { __typename?: 'ReplacePatch', op: PatchOp, path: string, value?: any | null, oldValue?: any | null } | { __typename?: 'TestPatch', op: PatchOp, path: string, value?: any | null }> }> };

export type GetBadgesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBadgesQuery = { __typename?: 'Query', badges: Array<{ __typename?: 'Badge', _id: string, type: BadgeType, name: string, imageUrl: string }> };

export type GetBadgeQueryVariables = Exact<{
  badgeId: Scalars['ID']['input'];
}>;


export type GetBadgeQuery = { __typename?: 'Query', badge: { __typename?: 'Badge', _id: string, type: BadgeType, name: string, imageUrl: string } };

export type GetBakeryRecordsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBakeryRecordsQuery = { __typename?: 'Query', bakeryRecords: Array<{ __typename?: 'BakeryRecord', _id: string, createdAt: number, createdBy: string, productId: string, fullname: string, quantityUsed: number, serialNumber: string, useDate: string, updatedAt: number }> };

export type GetBundlesFilterQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BundlesFilterInput>;
}>;


export type GetBundlesFilterQuery = { __typename?: 'Query', bundlesFilter: { __typename?: 'PaginatedBundles', hasMore: boolean, bundles: Array<{ __typename?: 'Bundle', _id: string, createdAt: number, scheduledPreparationDate: string, number: number, numberOfReferences: number, numberOfUnits: number, operatorName?: string | null, preparationDuration?: number | null, state: BundleState, type: ProductFlow, containerType: ContainerType, boxes: Array<{ __typename?: 'Box', _id: string, deliveryId: string, deliveryCode: string, siteName?: string | null, totemId?: string | null, hasOnsiteSetup: boolean, label: string, orderId?: string | null, position?: number | null, roundColor: string, roundName: string, code?: string | null, products: Array<{ __typename?: 'BoxProduct', _id: string, boxId?: string | null }>, column?: { __typename?: 'Column', fullname: string, name: string, type: ColumnType } | null }>, preparationDates: { __typename?: 'PreparationDates', start?: string | null, end?: string | null }, stateHistory: Array<{ __typename?: 'BundleStateHistory', state: BundleState, createdAt: number, createdByName?: string | null }>, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> } };

export type GetBundleQueryVariables = Exact<{
  bundleId: Scalars['ID']['input'];
}>;


export type GetBundleQuery = { __typename?: 'Query', bundle: { __typename?: 'Bundle', _id: string, createdAt: number, scheduledPreparationDate: string, number: number, numberOfReferences: number, numberOfUnits: number, operatorName?: string | null, preparationDuration?: number | null, state: BundleState, type: ProductFlow, containerType: ContainerType, boxes: Array<{ __typename?: 'Box', _id: string, deliveryId: string, deliveryCode: string, siteName?: string | null, totemId?: string | null, hasOnsiteSetup: boolean, label: string, orderId?: string | null, position?: number | null, roundColor: string, roundName: string, code?: string | null, bundleId?: string | null, state: BoxState, number: number, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, products: Array<{ __typename?: 'BoxProduct', _id: string, boxId?: string | null, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }>, column?: { __typename?: 'Column', fullname: string, name: string, type: ColumnType } | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null }>, preparationDates: { __typename?: 'PreparationDates', start?: string | null, end?: string | null }, stateHistory: Array<{ __typename?: 'BundleStateHistory', state: BundleState, createdAt: number, createdByName?: string | null }>, warehouseColumn: { __typename?: 'Column', _id: string, name: string } } };

export type GetActiveCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveCategoriesQuery = { __typename?: 'Query', activeCategories: Array<{ __typename?: 'Category', _id: string, title: string, shouldShowSubcategories: boolean }> };

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', _id: string, title: string, imageUrl?: string | null, state: CategoryState, indexDisplay: number, shouldShowSubcategories: boolean }> };

export type GetDetailedCategoryQueryVariables = Exact<{
  categoryId: Scalars['String']['input'];
}>;


export type GetDetailedCategoryQuery = { __typename?: 'Query', detailedCategory: { __typename?: 'Category', _id: string, createdAt: number, updatedAt: number, indexDisplay: number, isFreefood: boolean, isMicrostore: boolean, isPunctual: boolean, imageUrl?: string | null, shouldShowSubcategories: boolean, state: CategoryState, title: string, stateHistory: Array<{ __typename?: 'CategoryStateHistory', state: CategoryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }> } };

export type GetWarehouseColumnsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWarehouseColumnsQuery = { __typename?: 'Query', warehouseColumns: Array<{ __typename?: 'Column', _id: string, name: string, siteId: string, site: { __typename?: 'Site', _id: string, hasExternalSetupProcess: boolean, isSecured: boolean, name: string, type: SiteType, totemId: string } }> };

export type GetColumnsQueryVariables = Exact<{
  siteId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetColumnsQuery = { __typename?: 'Query', columns: Array<{ __typename?: 'Column', _id: string, name: string, fullname: string, siteId: string, type: ColumnType, state: MicrostoreElementState, createdAt: number, updatedAt: number, site: { __typename?: 'Site', _id: string, name: string }, stockSummary: { __typename?: 'ColumnStockSummary', productsCount: number, totalStock: number, merchantValuation: number } }> };

export type GetColumnQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetColumnQuery = { __typename?: 'Query', column?: { __typename?: 'Column', _id: string, name: string, fullname: string, siteId: string, type: ColumnType, state: MicrostoreElementState, createdAt: number, updatedAt: number, site: { __typename?: 'Site', _id: string, name: string, type: SiteType, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } }, microstoreColumn?: { __typename?: 'MicrostoreColumn', _id: string, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }> } } | null, stockSummary: { __typename?: 'ColumnStockSummary', productsCount: number, totalStock: number, merchantValuation: number } } | null };

export type GetColumnsPaginatedQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ColumnsFilterInput>;
}>;


export type GetColumnsPaginatedQuery = { __typename?: 'Query', columnsFilter: { __typename?: 'PaginatedColumns', hasMore: boolean, columns: Array<{ __typename?: 'Column', _id: string, name: string, fullname: string, type: ColumnType }> } };

export type CommentsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type CommentsQuery = { __typename?: 'Query', comments: { __typename?: 'PaginatedComments', hasMore: boolean, comments: Array<{ __typename?: 'Comment', _id: string, body: string, createdAt: number, updatedAt: number, answers: Array<{ __typename?: 'Comment', _id: string, body: string, createdAt: number, updatedAt: number, user: { __typename?: 'PublicProfile', _id: string, label: string }, product?: { __typename?: 'Product', _id: string, name: string } | null }>, user: { __typename?: 'PublicProfile', _id: string, label: string }, product?: { __typename?: 'Product', _id: string, name: string } | null }> } };

export type SearchCompaniesByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCompaniesByNameQuery = { __typename?: 'Query', searchCompaniesByName: Array<{ __typename?: 'CompanySuggestion', siret: string, siren: string, legalName: string, isActive: boolean, address?: string | null }> };

export type GetSiteConsumptionVariationsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetSiteConsumptionVariationsQuery = { __typename?: 'Query', siteConsumptionVariations: Array<{ __typename?: 'ConsumptionVariation', _id: string, createdAt: number, endDate: string, siteId: string, startDate: string, updatedAt: number, dessert: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, main: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, smallBites: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number }, starter: { __typename?: 'QuantityVariation', type: QuantityVariationType, value: number } }> };

export type GetCreditsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<CreditType> | CreditType>;
}>;


export type GetCreditsQuery = { __typename?: 'Query', credits: { __typename?: 'PaginatedCredits', hasMore: boolean, credits: Array<{ __typename?: 'Credit', _id: string, createdAt: number, updatedAt: number, name: string, initialAmount: number, currentAmount: number, expirationDate: number, startDate: number, type: CreditType, refundedAt?: number | null, createdBy?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null, organizationBatched?: { __typename?: 'Organization', name: string } | null, owner?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null }> } };

export type GetTotemCashHistoryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetTotemCashHistoryQuery = { __typename?: 'Query', totemCashHistory: { __typename?: 'PaginatedCredits', hasMore: boolean, credits: Array<{ __typename?: 'Credit', _id: string, createdAt: number, updatedAt: number, name: string, initialAmount: number, currentAmount: number, expirationDate: number, startDate: number, type: CreditType, refundedAt?: number | null, createdBy?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null, organizationBatched?: { __typename?: 'Organization', name: string } | null, owner?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null }> } };

export type GetDeliveriesQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDeliveriesQuery = { __typename?: 'Query', deliveries: Array<{ __typename?: 'Delivery', soldoutRefsCount: number, _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, contentSummary: { __typename?: 'DeliveryContentSummary', boxCount: number, productCount: number, totalWeight: number, totalVolume: number }, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null }> };

export type GetDailyDeliveriesWithPhotosQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DeliveriesFilterInput>;
}>;


export type GetDailyDeliveriesWithPhotosQuery = { __typename?: 'Query', deliveries: Array<{ __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string, date: string, freefoodSetup?: { __typename?: 'FreefoodSetup', instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }> } | null, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }> }> }> } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', _id: string, type: SetupInstructionType, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' }> } | null, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null }> };

export type GetDeliveryQueryVariables = Exact<{
  deliveryId: Scalars['ID']['input'];
}>;


export type GetDeliveryQuery = { __typename?: 'Query', delivery?: { __typename?: 'Delivery', _id: string, label: string, createdAt: number, deliveryDate: number, organizationName?: string | null, isDynamic: boolean, deliveryPersonUserId?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, siteId?: string | null, siteName?: string | null, state: DeliveryState, theoricServiceTime?: number | null, trackingUrl?: string | null, updatedAt: number, boxes: Array<{ __typename?: 'Box', _id: string, bundleId?: string | null, state: BoxState, label: string, number: number, code?: string | null, deliveryCode: string, type: ProductFlow, containerType: ContainerType, volumeTaken?: number | null, weightTaken?: number | null, createdAt: number, columnId?: string | null, bundle?: { __typename?: 'Bundle', _id: string, number: number, state: BundleState, closingDate?: number | null } | null, column?: { __typename?: 'Column', name: string, fullname: string, type: ColumnType } | null, products: Array<{ __typename?: 'BoxProduct', _id: string, productLabel: string, quantity: number, quantityPicked?: number | null, photoUrl: string, unit: string, boxId?: string | null, unitVolume?: number | null, unitWeight?: number | null, product: { __typename?: 'Product', externalProductId?: string | null } }> }>, orders: Array<{ __typename?: 'Order', _id: string, number?: number | null, state: OrderState, user: { __typename?: 'User', profile: { __typename?: 'UserProfile', fullname?: string | null } } }>, stockTransfers: Array<{ __typename?: 'StockTransfer', _id: string, transferDate: string, state: StockTransferState, numberOfRefs: number, quantityOfProducts: number, reassortmentFlow?: ReassortmentFlow | null, originColumn: { __typename?: 'Column', fullname: string }, destinationColumn: { __typename?: 'Column', fullname: string } }>, stockTransfersProductSummary: Array<{ __typename?: 'DeliveryProductSummary', productId: string, fullname: string, quantityRequested: number, quantityPositioned: number, quantityPicked: number, quantitySoldoutOnline: number, quantitySoldoutBundle?: number | null }>, ordersProductSummary: Array<{ __typename?: 'DeliveryProductSummary', productId: string, fullname: string, quantityRequested: number, quantityPositioned: number, quantityPicked: number, quantitySoldoutOnline: number, quantitySoldoutBundle?: number | null }>, deliveredMicrostoreColumns: Array<{ __typename?: 'Column', _id: string, name: string, type: ColumnType }>, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string, createdAt: number, date: string, deliveryId: string, isFinishForced: boolean, siteId: string, state: SiteSetupState, updatedAt: number, delivery?: { __typename?: 'Delivery', isDynamic: boolean } | null, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> } | null, issues: { __typename?: 'SiteSetupIssues', productsIssues: Array<{ __typename?: 'SetupProductIssues', comment: string, productId: string, brokenDuringDeliveryQuantity: number, brokenOnSiteAfterInventoryQuantity: number, brokenOnSiteBeforeInventoryQuantity: number, expiredDeliveredQuantity: number, expiredOnSiteAfterInventoryQuantity: number, expiredOnSiteBeforeInventoryQuantity: number, notEnoughPlaceQuantity: number, otherBeforeInventoryQuantity: number, otherAfterInventoryOrDuringDeliveryQuantity: number, unexpectedOnSiteQuantity: number, wrongQuantityDelivered: number }> }, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', _id: string, isFinishForced: boolean, isNeeded: boolean, microstoreColumnGroupId: string, positionInSiteSetup: number, siteSetupId: string, state: MicrostoreColumnGroupSetupState, updatedAt: number, instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> }>, stateHistory: Array<{ __typename?: 'MicrostoreColumnGroupSetupStateHistory', createdAt: number, state: MicrostoreColumnGroupSetupState }> }>, odooTickets: Array<{ __typename?: 'OdooTicket', _id: string, odooTicketId: number, microstoreColumnId: string, serviceType: OdooServiceType, ticketType: string, state: OdooTicketState, description: string, actions: Array<{ __typename?: 'OdooTicketAction', actionType: OdooTicketActionType, message: string, photoUrl?: string | null, createdAt: number }>, microstoreColumn: { __typename?: 'MicrostoreColumn', name: string } }>, site: { __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, earliestDLCDateToKeepForStockCalculation?: string | null, isOpenOnWeekend: boolean, isSecured: boolean, name: string, type: SiteType, state: SiteState, organizationName: string, nextDeliveryDate?: string | null, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }> }, stateHistory: Array<{ __typename?: 'SiteSetupStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: SiteSetupState }> } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> } | null, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', createdAt: number, createdByName?: string | null, state: DeliveryState }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, totem?: { __typename?: 'Totem', address?: string | null, name?: string | null, number: number } | null } | null };

export type GetDeliveryPlanningForThreeWeeksQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  mondayDate: Scalars['String']['input'];
}>;


export type GetDeliveryPlanningForThreeWeeksQuery = { __typename?: 'Query', getDeliveryPlanningForThreeWeeks: { __typename?: 'SiteDeliveryPlanning', site: { __typename?: 'Site', _id: string, name: string, organizationName: string, deliveryDays: Array<boolean>, state: SiteState, shouldOperateOnTotops: boolean, launchDate?: string | null, removalDate?: string | null, isSecured: boolean, hasSensei: boolean, deliveryType: SiteDeliveryType, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }> }, deliveryPlanning: Array<{ __typename?: 'DeliveryPlanning', date: string, isManual: boolean, isActive: boolean }> } };

export type GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables = Exact<{
  mondayDate: Scalars['String']['input'];
}>;


export type GetAllSitesDeliveryPlanningForThreeWeeksQuery = { __typename?: 'Query', getAllSitesDeliveryPlanningForThreeWeeks: Array<{ __typename?: 'SiteDeliveryPlanning', site: { __typename?: 'Site', _id: string, name: string, organizationName: string, deliveryDays: Array<boolean>, state: SiteState, shouldOperateOnTotops: boolean, launchDate?: string | null, removalDate?: string | null, isSecured: boolean, hasSensei: boolean, deliveryType: SiteDeliveryType, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }> }, deliveryPlanning: Array<{ __typename?: 'DeliveryPlanning', date: string, isManual: boolean, isActive: boolean }> }> };

export type GetDeliveryZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDeliveryZonesQuery = { __typename?: 'Query', deliveryZones: Array<{ __typename?: 'DeliveryZone', _id: string, name: string, color: string, state: DeliveryZoneState, referentDelivererId?: string | null, sitesCount: number, createdAt: number, updatedAt: number, referentDeliverer?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null }> };

export type GetDeliveryZoneQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetDeliveryZoneQuery = { __typename?: 'Query', deliveryZone: { __typename?: 'DeliveryZone', _id: string, name: string, color: string, state: DeliveryZoneState, referentDelivererId?: string | null, sitesCount: number, createdAt: number, updatedAt: number, sites: Array<{ __typename?: 'Site', _id: string, name: string, organizationName: string }>, referentDeliverer?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null } };

export type GetDynamicDeliveryPlanningRowsForDateQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type GetDynamicDeliveryPlanningRowsForDateQuery = { __typename?: 'Query', getDynamicDeliveryPlanningRowsForDate: Array<{ __typename?: 'DynamicDeliveryPlanning', _id: string, columnId: string, date: string, isManual: boolean, isActive: boolean, rank: number, secondaryRank: number, finalRank: string, tourOrder?: number | null, bucket?: DynamicDeliveryBucket | null, parentDynamicDeliveryPlanningId?: string | null, assignedDelivererId?: string | null, referentDelivererId?: string | null, totem?: { __typename?: 'Totem', latitude?: number | null, longitude?: number | null } | null, thresholds?: { __typename?: 'DynamicDeliveryThresholdEntry', templateType: MicrostoreColumnTemplateType, contractType: DynamicDeliveryContractType, qualityPassPercent: number, criticalPassPercent: number, requiredPassPercent: number, maxDaysWithoutDelivery: number } | null, parentColumn?: { __typename?: 'MicrostoreColumn', _id: string, name: string } | null, column: { __typename?: 'MicrostoreColumn', _id: string, name: string, machineCode?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean }, site: { __typename?: 'Site', _id: string, name: string, totemId: string, organizationName: string, contractType: SiteContractType }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null, referentDeliverer?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null, assignedDeliverer?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null, metrics: { __typename?: 'DynamicDeliveryPlanningMetrics', realFillRatePercent?: number | null, transactionalFillRatePercent?: number | null, trayFillRatePercent?: number | null, missingReferencesPercent: number, daysSinceLastDelivery?: number | null, kgToDeliver: number, volumeCm3ToDeliver: number } }> };

export type GetEquipmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEquipmentsQuery = { __typename?: 'Query', adminEquipments: Array<{ __typename?: 'Equipment', _id: string, fullname: string, imageUrl?: string | null, state: EquipmentState, suppliers?: Array<{ __typename?: 'EquipmentSupplier', _id: string, name?: string | null } | null> | null }> };

export type GetDetailedEquipmentQueryVariables = Exact<{
  equipmentId: Scalars['ID']['input'];
}>;


export type GetDetailedEquipmentQuery = { __typename?: 'Query', detailedEquipment?: { __typename?: 'Equipment', _id: string, createdAt: number, updatedAt: number, name: string, brand?: string | null, volume?: string | null, price?: number | null, imageUrl?: string | null, description?: string | null, hidden: boolean, height?: number | null, width?: number | null, length?: number | null, weight?: number | null, state: EquipmentState, suppliers?: Array<{ __typename?: 'EquipmentSupplier', _id: string, name?: string | null } | null> | null, stateHistory: Array<{ __typename?: 'EquipmentStateHistory', createdAt: number, createdBy?: string | null, state: EquipmentState }> } | null };

export type GetExpiryDateRecordsForSiteQueryVariables = Exact<{
  columnId: Scalars['ID']['input'];
}>;


export type GetExpiryDateRecordsForSiteQuery = { __typename?: 'Query', getExpiryDateRecordsForSiteQuery: Array<{ __typename?: 'ExpiryDateRecord', _id: string, createdAt: number, expiryDate: string, initialQuantity: number, quantityAtInventory: number, productId: string, siteId: string, state: ExpiryDateRecordState, updatedAt: number, product: { __typename?: 'Product', brand: string, name: string, volume: string } }> };

export type GetFutureStockVariationsByProductQueryVariables = Exact<{
  warehouseColumnId: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
}>;


export type GetFutureStockVariationsByProductQuery = { __typename?: 'Query', futureStockVariationsByProduct: Array<{ __typename?: 'FutureStockVariation', _id: string, createdAt: number, delta: number, columnId: string, productId: string, ref: string, state: FutureStockVariationState, type: FutureStockVariationType, updatedAt?: number | null, useDate: string, processInfo?: { __typename?: 'FutureStockVariationProcessInfo', supplyOrderStockVariationRef?: string | null, boxInfo?: Array<{ __typename?: 'FutureStockVariationProcessInfoBoxInfo', boxId: string, isPrepared: boolean, stockVariationRef?: string | null }> | null } | null, issues: Array<{ __typename?: 'FutureStockVariationIssue', explanation: string, type: FutureStockVariationIssueType }> }> };

export type GetExpiredFutureStockVariationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExpiredFutureStockVariationsQuery = { __typename?: 'Query', expiredFutureStockVariations: Array<{ __typename?: 'FutureStockVariation', productName: string, _id: string, createdAt: number, delta: number, columnId: string, productId: string, ref: string, state: FutureStockVariationState, type: FutureStockVariationType, updatedAt?: number | null, useDate: string, processInfo?: { __typename?: 'FutureStockVariationProcessInfo', supplyOrderStockVariationRef?: string | null, boxInfo?: Array<{ __typename?: 'FutureStockVariationProcessInfoBoxInfo', boxId: string, isPrepared: boolean, stockVariationRef?: string | null }> | null } | null, issues: Array<{ __typename?: 'FutureStockVariationIssue', explanation: string, type: FutureStockVariationIssueType }> }> };

export type ReplaceableProductOrdersAndFutureStockVariationsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type ReplaceableProductOrdersAndFutureStockVariationsQuery = { __typename?: 'Query', replaceableProductOrdersAndFutureStockVariations: { __typename?: 'FutureStockVariationsAndOrders', futureStockVariations: Array<{ __typename?: 'FutureStockVariation', _id: string, createdAt: number, delta: number, columnId: string, productId: string, ref: string, state: FutureStockVariationState, type: FutureStockVariationType, updatedAt?: number | null, useDate: string, processInfo?: { __typename?: 'FutureStockVariationProcessInfo', supplyOrderStockVariationRef?: string | null, boxInfo?: Array<{ __typename?: 'FutureStockVariationProcessInfoBoxInfo', boxId: string, isPrepared: boolean, stockVariationRef?: string | null }> | null } | null, issues: Array<{ __typename?: 'FutureStockVariationIssue', explanation: string, type: FutureStockVariationIssueType }> }>, orders: Array<{ __typename?: 'Order', _id: string, date_delivery?: string | null, number?: number | null, state: OrderState, organization: { __typename?: 'Organization', name: string }, products: Array<{ __typename?: 'OrderProduct', _id: string, orderId?: string | null, quantity?: number | null }>, totem: { __typename?: 'Totem', _id: string, number: number } }> } };

export type GetPlaceAutocompleteSuggestionsQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type GetPlaceAutocompleteSuggestionsQuery = { __typename?: 'Query', getPlaceAutocompleteSuggestions: Array<{ __typename?: 'PlaceAutocompleteSuggestion', placeId: string, description: string }> };

export type GetPlaceDetailsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;


export type GetPlaceDetailsQuery = { __typename?: 'Query', getPlaceDetails: { __typename?: 'PlaceDetails', placeId: string, name: string, formattedAddress: string, latitude: number, longitude: number, city?: string | null, zipcode?: string | null, country?: string | null, streetNumber?: string | null } };

export type GetSiteLocationPlanogramsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetSiteLocationPlanogramsQuery = { __typename?: 'Query', getSiteLocationPlanograms: Array<{ __typename?: 'LocationPlanogram', _id: string, createdAt: number, locationId: string, productId?: string | null, startDate: string, updatedAt: number }> };

export type GetLocationsByWarehouseColumnIdQueryVariables = Exact<{
  warehouseColumnId: Scalars['ID']['input'];
}>;


export type GetLocationsByWarehouseColumnIdQuery = { __typename?: 'Query', locationsByWarehouseColumnId: Array<{ __typename?: 'Location', _id: string, index: number, state: LocationState, datamatrix: string, locationType: LocationType, productId?: string | null, zone: LocationZone, product?: { __typename?: 'Product', name: string } | null }> };

export type GetManualSupplyOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManualSupplyOrdersQuery = { __typename?: 'Query', manualSupplyOrders: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> };

export type GetManualSupplyOrderSupplierProductsStockVariationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManualSupplyOrderSupplierProductsStockVariationQuery = { __typename?: 'Query', manualSupplyOrderSupplierProductsStockVariation: { __typename?: 'SupplyOrderProductStockVariations', productGroupStockVariations: Array<{ __typename?: 'ProductStockVariation', isComputed: boolean, computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } }>, supplyOrderStockVariations: Array<{ __typename?: 'ProductStockVariation', isComputed: boolean, computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } }> } };

export type GetMenuInstructionsQueryVariables = Exact<{
  dates: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetMenuInstructionsQuery = { __typename?: 'Query', menuInstructions: Array<{ __typename?: 'MenuInstruction', _id: string, createdAt: number, updatedAt: number, date: string, microstoreColumnId: string, categoryId: string, type: MenuInstructionType, value: number }> };

export type GetSiteMenusQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
  date: Scalars['String']['input'];
}>;


export type GetSiteMenusQuery = { __typename?: 'Query', siteMenus: { __typename?: 'SiteMenus', siteId: string, columns: Array<{ __typename?: 'ColumMenus', columnId: string, dailyMenus: Array<{ __typename?: 'DailyMenu', date: string, productLocations: Array<{ __typename?: 'MenuProductLocation', product?: { __typename?: 'Product', _id: string, fullname: string } | null, location: { __typename?: 'MicrostoreLocation', _id: string } }> }> }> } };

export type GetMenuProductArrangementsQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type GetMenuProductArrangementsQuery = { __typename?: 'Query', menuProductArrangements: Array<{ __typename?: 'MenuProductArrangement', productArrangementId: string, productArrangementName: string, productArrangementMainCategoryId: string, productArrangementIndexes: Array<{ __typename?: 'MenuProductArrangementIndex', productArrangementIndex: number, rotations: Array<{ __typename?: 'MenuRotation', rotationNumber: number, products: Array<{ __typename?: 'MenuProduct', quantity: number, nbLocations: number, isInProductArrangement: boolean, product: { __typename?: 'Product', _id: string, fullname: string, imageUrl?: string | null, state: ProductState, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, supplier?: { __typename?: 'Supplier', _id: string, name: string } | null } }> }> }> }> };

export type GetSiteColumnsQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;


export type GetSiteColumnsQuery = { __typename?: 'Query', siteWithLocationTemplates: { __typename?: 'Site', _id: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number }, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, productArrangementId?: string | null, productArrangement?: { __typename?: 'ProductArrangement', name: string } | null } }>> }> }> }> } };

export type GetMenuQuantitiesQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type GetMenuQuantitiesQuery = { __typename?: 'Query', menuQuantities: Array<{ __typename?: 'MenuQuantities', site: { __typename?: 'Site', _id: string, name: string }, columns: Array<{ __typename?: 'ColumMenuQuantities', column: { __typename?: 'MicrostoreColumn', _id: string, name: string }, categoryQuantities: Array<{ __typename?: 'CategoryMenuQuantities', category: { __typename?: 'Category', _id: string, title: string }, dateQuantities: Array<{ __typename?: 'DateMenuQuantities', date: string, quantity: number, quantityFacing: number, quantityInstruction?: number | null, quantityFacingInstruction?: number | null }> }> }> }> };

export type QuantitiesGenerationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type QuantitiesGenerationStatusQuery = { __typename?: 'Query', quantitiesGenerationStatus: PredictionServiceStatus };

export type SiteMenusGenerationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteMenusGenerationStatusQuery = { __typename?: 'Query', siteMenusGenerationStatus: PredictionServiceStatus };

export type GetMessagesSetsPaginatedQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetMessagesSetsPaginatedQuery = { __typename?: 'Query', messagesSetsPaginated: { __typename?: 'PaginatedMessagesSets', hasMore: boolean, messagesSets: Array<{ __typename?: 'MessagesSet', _id: string, createdAt: number, name: string, state: MessagesSetState, updatedAt: number, messages: Array<{ __typename?: 'Message', body: string, redirectUrl?: string | null }> }> } };

export type GetMessagesSetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMessagesSetsQuery = { __typename?: 'Query', messagesSets: Array<{ __typename?: 'MessagesSet', _id: string, createdAt: number, name: string, state: MessagesSetState, updatedAt: number, messages: Array<{ __typename?: 'Message', body: string, redirectUrl?: string | null }> }> };

export type GetMessagesSetQueryVariables = Exact<{
  messagesSetId: Scalars['ID']['input'];
}>;


export type GetMessagesSetQuery = { __typename?: 'Query', messagesSet?: { __typename?: 'MessagesSet', _id: string, createdAt: number, name: string, state: MessagesSetState, updatedAt: number, messages: Array<{ __typename?: 'Message', body: string, redirectUrl?: string | null }> } | null };

export type GetMicrostoreColumnsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMicrostoreColumnsQuery = { __typename?: 'Query', microstoreColumns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, microstoreColumnTemplateId: string, microstoreColumnTemplateName: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, removalDate?: string | null, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, type: MicrostoreColumnTemplateType, microstoreColumnType: MicrostoreColumnType, siteId: string, siteName: string, isRegular: boolean }> };

export type GetMicrostoreColumnsPaginatedQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MicrostoreColumnsFilterInput>;
}>;


export type GetMicrostoreColumnsPaginatedQuery = { __typename?: 'Query', microstoreColumnsFilter: { __typename?: 'PaginatedMicrostoreColumns', hasMore: boolean, microstoreColumns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, microstoreColumnTemplateId: string, microstoreColumnTemplateName: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, removalDate?: string | null, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, type: MicrostoreColumnTemplateType, microstoreColumnType: MicrostoreColumnType, siteId: string, siteName: string, isRegular: boolean }> } };

export type GetMicrostoreColumnQueryVariables = Exact<{
  columnId: Scalars['ID']['input'];
}>;


export type GetMicrostoreColumnQuery = { __typename?: 'Query', microstoreColumn: { __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> } };

export type GetColumnProductsStockInfoQueryVariables = Exact<{
  columnId: Scalars['ID']['input'];
}>;


export type GetColumnProductsStockInfoQuery = { __typename?: 'Query', column?: { __typename?: 'Column', _id: string, name: string, products: Array<{ __typename?: 'Product', _id: string, brand: string, categoryId: string, flow: ProductFlow, name: string, trackExpiryDate: boolean, volume: string, isDoubleCoil: boolean, isWithoutStock: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null, microstoreStockInfo?: { __typename?: 'MicrostoreStockInfo', stockOnSite: number, stockAvailableOnSite: number, stockWarehouse: number, stockAvailableWarehouse: number, stockToRemove: number, stockUsedInOtherMicrostores: number, stockExpectedInSupplyOrders: number, transactionsCountForToday: number, expiryDateRecordsWarehouse: Array<{ __typename?: 'ExpiryDateRecord', _id: string, expiryDate: string, initialQuantity: number, quantityAtInventory: number }> } | null }> } | null };

export type GetMicrostoreColumnPricesQueryVariables = Exact<{
  microstoreColumnId: Scalars['ID']['input'];
}>;


export type GetMicrostoreColumnPricesQuery = { __typename?: 'Query', microstoreColumnPrices: Array<{ __typename?: 'ProductPriceTTC', productId: string, priceTTC: number, crossedPriceTTC?: number | null }> };

export type GetMicrostoreColumnsOfOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetMicrostoreColumnsOfOrganizationQuery = { __typename?: 'Query', microstoreColumnsOfOrganization: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string }> };

export type GetTruckColumnsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTruckColumnsQuery = { __typename?: 'Query', truckColumns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, siteName: string }> };

export type GetMicrostoreColumnGroupsPaginatedQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MicrostoreColumnGroupFilterInput>;
}>;


export type GetMicrostoreColumnGroupsPaginatedQuery = { __typename?: 'Query', microstoreColumnGroupsFilter: { __typename?: 'PaginatedMicrostoreColumnGroups', hasMore: boolean, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, microstoreColumnTemplateId: string, microstoreColumnTemplateName: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, removalDate?: string | null, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, type: MicrostoreColumnTemplateType, microstoreColumnType: MicrostoreColumnType, siteId: string, siteName: string, isRegular: boolean }> }> } };

export type GetMicrostoreColumnGroupsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetMicrostoreColumnGroupsQuery = { __typename?: 'Query', microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, microstoreColumnTemplateId: string, microstoreColumnTemplateName: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, removalDate?: string | null, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, type: MicrostoreColumnTemplateType, microstoreColumnType: MicrostoreColumnType, siteId: string, siteName: string, isRegular: boolean }> }> };

export type GetMicrostoreColumnGroupQueryVariables = Exact<{
  columnGroupId: Scalars['ID']['input'];
}>;


export type GetMicrostoreColumnGroupQuery = { __typename?: 'Query', microstoreColumnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, odooMicrostoreColumnGroupId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, microstoreColumnTemplateName: string, isPaused: boolean }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string }> }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } } };

export type GetMicrostoreColumnTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMicrostoreColumnTemplatesQuery = { __typename?: 'Query', microstoreColumnTemplatesQuery: Array<{ __typename?: 'MicrostoreColumnTemplate', _id: string, name: string, type: MicrostoreColumnTemplateType, state: MicrostoreColumnTemplateState }> };

export type GetMicrostoreColumnTemplateQueryVariables = Exact<{
  microstoreColumnTemplateId: Scalars['String']['input'];
}>;


export type GetMicrostoreColumnTemplateQuery = { __typename?: 'Query', microstoreColumnTemplateQuery: { __typename?: 'MicrostoreColumnTemplate', _id: string, name: string, type: MicrostoreColumnTemplateType, state: MicrostoreColumnTemplateState, shelfTemplates: Array<{ __typename?: 'MicrostoreShelfTemplate', _id: string, columnTemplateId: string, positionInColumn: number, locationTemplateTable: Array<Array<{ __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, shelfTemplateId: string, shouldOrderProductIfNotInSite: boolean, shouldSmoothProductTransition: boolean, allowProductRotation: boolean, trayMaxCapacity: number, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number }, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, productsWithStockMax: Array<{ __typename?: 'ProductArrangementProductWithStockMax', stockMax: number, product: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }>> }> } };

export type GetMicrostoreColumnTemplatesWithItemQueryVariables = Exact<{
  itemId: Scalars['String']['input'];
  itemType: MicrostoreItemType;
}>;


export type GetMicrostoreColumnTemplatesWithItemQuery = { __typename?: 'Query', microstoreColumnTemplatesWithItem: Array<{ __typename?: 'MicrostoreColumnTemplate', _id: string, name: string, templateLocationCount: number, microstoreColumns: Array<{ __typename?: 'MicrostoreColumn', _id: string, siteId: string, name: string, site: { __typename?: 'Site', name: string } }> }> };

export type GetMicrostoreItemsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MicrostoreItemsFilterInput>;
}>;


export type GetMicrostoreItemsQuery = { __typename?: 'Query', microstoreItems: { __typename?: 'PaginatedMicrostoreItems', hasMore: boolean, items: Array<{ __typename?: 'MicrostoreItem', _id: string, name: string, type: MicrostoreItemType, locationCount: number }> } };

export type MobilePopupsQueryVariables = Exact<{ [key: string]: never; }>;


export type MobilePopupsQuery = { __typename?: 'Query', mobilePopups: Array<{ __typename?: 'MobilePopup', _id: string, startsAt: number, endsAt: number, imageUrl?: string | null, title?: string | null, body?: string | null, siteIds?: Array<string> | null, createdAt: number, sites?: Array<{ __typename?: 'Site', _id: string, name: string } | null> | null }> };

export type GetNayaxMdbTemplateQueryVariables = Exact<{
  nayaxMDBTemplateId: Scalars['ID']['input'];
}>;


export type GetNayaxMdbTemplateQuery = { __typename?: 'Query', nayaxMDBTemplate?: { __typename?: 'NayaxMDBTemplate', _id: string, name: string, createdAt: number, updatedAt: number, associations: Array<{ __typename?: 'NayaxMDBTemplateAssociation', nayaxMDBCode: number, positionInColumn: number, positionInShelf: { __typename?: 'PositionInShelf', row: number, column: number } }> } | null };

export type GetNayaxMdbTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNayaxMdbTemplatesQuery = { __typename?: 'Query', nayaxMDBTemplates: Array<{ __typename?: 'NayaxMDBTemplate', _id: string, name: string, createdAt: number, updatedAt: number, associations: Array<{ __typename?: 'NayaxMDBTemplateAssociation', nayaxMDBCode: number, positionInColumn: number, positionInShelf: { __typename?: 'PositionInShelf', row: number, column: number } }> }> };

export type GetNuBasketQueryVariables = Exact<{
  nuBasketId: Scalars['ID']['input'];
}>;


export type GetNuBasketQuery = { __typename?: 'Query', nuBasket?: { __typename?: 'NuBasket', _id: string, purchaseId: string, fridgeId: string, cardId?: string | null, createdAt: number, updatedAt: number, userId: string, siteId: string, type: NuBasketType, transactions: Array<{ __typename?: 'Transaction', _id: string, createdAt: number, priceHT: number, productName: string, siteName: string, newState: TransactionState, tva: number, userFullName: string }> } | null };

export type OpsParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type OpsParametersQuery = { __typename?: 'Query', opsParameters: { __typename?: 'OpsParameter', _id: string, createdAt: number, updatedAt: number, parameters: { __typename?: 'OpsParameterData', shouldAutoOrderMenuSupplyOrder: boolean, shouldProcessFreshReassortment: boolean, canUseKraftForStore: boolean, canUseKraftForFreefood: boolean, emptyWeightPaletteBox: number, emptyWeightKraftBox: number, externalVolumePaletteBox: number, externalVolumeKraftBox: number, volumePaletteBox: number, volumeKraftBox: number, weightPaletteBox: number, weightKraftBox: number, serviceTimePerBox: number, dryReassortMinProductCount: number, dryReassortMinReferenceCount: number, dryReassortMaxEmptyFacings: number, flowParameters: Array<{ __typename?: 'FlowParameter', flow: ProductFlow, emptyWeightBox: number, externalVolumeBox: number, volumeBox: number, weightBox: number, bundleCapacity: number }>, dynamicDelivery: { __typename?: 'DynamicDeliveryConfig', capacity: number, thresholds: Array<{ __typename?: 'DynamicDeliveryThresholdEntry', templateType: MicrostoreColumnTemplateType, contractType: DynamicDeliveryContractType, qualityPassPercent: number, criticalPassPercent: number, requiredPassPercent: number, criticalGroupingPercent: number, requiredGroupingPercent: number, groupingRadiusKm: number, maxDaysWithoutDelivery: number }>, estimatedTransactionCapacities: Array<{ __typename?: 'DynamicDeliveryTemplateCapacity', templateType: MicrostoreColumnTemplateType, estimatedTransactionCapacity: number }> } } } };

export type GetDetailedOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetDetailedOrderQuery = { __typename?: 'Query', detailedOrder: { __typename?: 'Order', _id: string, appreciation?: string | null, badService?: Array<string> | null, deliveryDate: string, feedback?: string | null, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, isPunctual: boolean, number?: number | null, previous_orderId?: string | null, reference?: string | null, state: OrderState, weekday?: string | null, delivery?: { __typename?: 'Delivery', _id: string, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState }> } | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, productsWithQuantityPicked: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, fullname: string, quantity?: number | null, quantityPicked?: number | null, unitPrice: number }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, organization: { __typename?: 'Organization', _id: string, hasSubscription: boolean, name: string, paymentType: OrganizationPaymentType }, pausedInfo?: { __typename?: 'PausedInfo', reason?: string | null, returnDate?: number | null } | null, invoicing: { __typename?: 'OrderInvoicing', status: OrderInvoicingStatus, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, paymentIntentId?: string | null, stripePaymentUrl?: string | null }, prices: { __typename?: 'OrderPrices', discount?: number | null, discount055?: number | null, discount10?: number | null, discount20?: number | null, price?: number | null, price055?: number | null, price10?: number | null, price20?: number | null, priceDelivery?: number | null, priceHT?: number | null, priceHT055?: number | null, priceHT10?: number | null, priceHT20?: number | null, priceTTC?: number | null, priceTTC055?: number | null, priceTTC10?: number | null, priceTTC20?: number | null, tva?: number | null, tva055?: number | null, tva10?: number | null, tva20?: number | null }, productsRequestedButNotFullyDelivered: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, fullname: string, unitPrice: number, quantityRequested?: number | null }>, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number }, user: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null } } } };

export type GetOrdersFromOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetOrdersFromOrganizationQuery = { __typename?: 'Query', activeOrdersFromOrganization: Array<{ __typename?: 'Order', _id: string, deliveryDate: string, isPunctual: boolean, number?: number | null, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number } }> };

export type GetOrdersOfOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  windowStart?: InputMaybe<Scalars['String']['input']>;
  windowEnd?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrdersOfOrganizationQuery = { __typename?: 'Query', ordersOfOrganization: Array<{ __typename?: 'Order', _id: string, deliveryDate: string, isPunctual: boolean, number?: number | null, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number } }> };

export type GetActiveOrForDateOrdersQueryVariables = Exact<{
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetActiveOrForDateOrdersQuery = { __typename?: 'Query', activeOrForDateOrders: Array<{ __typename?: 'Order', _id: string, date_delivery?: string | null, isPunctual: boolean, number?: number | null, state: OrderState, first_order?: boolean | null, weekday?: string | null, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, state: TotemState }, organization: { __typename?: 'Organization', name: string }, pausedInfo?: { __typename?: 'PausedInfo', returnDate?: number | null } | null, prices: { __typename?: 'OrderPrices', priceTTC?: number | null, priceHT?: number | null } }> };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', _id: string, hasSubscription: boolean, name: string, nbActiveSite: number, nbActiveTotem: number, paymentType: OrganizationPaymentType, state: OrganizationState }> };

export type GetActiveOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveOrganizationsQuery = { __typename?: 'Query', activeOrganizations: Array<{ __typename?: 'Organization', _id: string, name: string }> };

export type GetOrganizationsPaginatedQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<OrganizationsFilterInput>;
}>;


export type GetOrganizationsPaginatedQuery = { __typename?: 'Query', organizationsFilter: { __typename?: 'PaginatedOrganizations', hasMore: boolean, organizations: Array<{ __typename?: 'Organization', _id: string, name: string }> } };

export type GetOrganizationsEligibleToCreditsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsEligibleToCreditsQuery = { __typename?: 'Query', organizationsEligibleToCredits: Array<{ __typename?: 'Organization', _id: string, name: string }> };

export type GetOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', _id: string, attachUsersManually: boolean, B2BPriceRange?: string | null, createdAt: number, domains?: Array<string> | null, hasDetailedOrderInvoicing: boolean, hasFreefoodIncluded: boolean, hasSubscription: boolean, imageUrl?: string | null, mandateSEPA?: string | null, maxUsers: number, name: string, customerType?: string | null, paymentTimeType: OrganizationPaymentTimeType, paymentType: OrganizationPaymentType, hasOdooOrganizationParentInvoicing: boolean, hasPrepaidOrganizationCards: boolean, hasPrepaidSubventions: boolean, segregatedInvoicing: boolean, state: OrganizationState, stripeId?: string | null, termsAcceptanceDate?: number | null, totalCoworkers?: number | null, updatedAt: number, avaClientId?: number | null, restrictedProductArrangementId?: string | null, odooOrganizationId?: number | null, odooInvoiceReference?: string | null, odooCompany?: OdooCompany | null, admins: Array<{ __typename?: 'OrganizationAdmin', _id: string, fullname: string }>, sales?: { __typename?: 'OrganizationSales', _id: string, fullName: string } | null, stateHistory: Array<{ __typename?: 'OrganizationStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: OrganizationState }>, invoiceSettings: { __typename?: 'OrganizationInvoiceSetting', _id: string, organizationId: string, state: OrganizationInvoiceSettingState, createdAt: number, updatedAt: number, consumptionColumns: Array<{ __typename?: 'ConsumptionColumn', microstoreColumnIds: Array<string>, priceOptionType: PriceOptionType, tva?: number | null, priceTiers: Array<{ __typename?: 'PriceTier', thresholdMin?: number | null, unitPrice: number, unitPriceWithoutCup: number }> }>, rmeColumns: Array<{ __typename?: 'RmeColumn', microstoreColumnIds: Array<string>, type: RmeColumnType, minimumAmount: number, unitPrice?: number | null }> } } };

export type GetOrganizationConsumptionQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetOrganizationConsumptionQuery = { __typename?: 'Query', getOrganizationConsumption: { __typename?: 'OrganizationConsumption', organizationId: string, startDate: string, endDate: string, transactionCount: number, paidTransactionCount: number, freeTransactionCount: number, consumedValueHT: number, columns: Array<{ __typename?: 'OrganizationConsumptionColumn', microstoreColumnId: string, name: string, transactionCount: number, paidTransactionCount: number, freeTransactionCount: number, consumedValueHT: number }>, freefood: { __typename?: 'OrganizationConsumptionFreefood', orderCount: number, totalHT: number, orders: Array<{ __typename?: 'OrganizationConsumptionFreefoodOrder', orderId: string, number: number, deliveryDate: string, totalHT: number, invoicingStatus: string, odooInvoiceId?: number | null }> } } };

export type GetOrganizationInvoiceSimulationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetOrganizationInvoiceSimulationQuery = { __typename?: 'Query', getOrganizationInvoiceSimulation: { __typename?: 'InvoiceSimulation', organizationId: string, startDate: string, endDate: string, totalHT: number, totalVat: number, totalTTC: number, collector: string, totalsByVat: Array<{ __typename?: 'InvoiceSimulationVatTotal', taxRate: number, amountHT: number, amountVat: number }>, totalsByCategory: Array<{ __typename?: 'InvoiceSimulationCategoryTotal', category: string, amountHT: number }>, groups: Array<{ __typename?: 'InvoiceSimulationGroup', category: string, lines: Array<{ __typename?: 'InvoiceSimulationLine', type: string, name: string, quantity?: number | null, priceUnit?: number | null, taxRate?: number | null }> }> } };

export type GetPollsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
}>;


export type GetPollsQuery = { __typename?: 'Query', polls: { __typename?: 'PaginatedPolls', hasMore: boolean, polls: Array<{ __typename?: 'Poll', _id: string, createdAt: number, numberOfParticipants: number, question: string }> } };

export type GetPollQueryVariables = Exact<{
  pollId: Scalars['ID']['input'];
}>;


export type GetPollQuery = { __typename?: 'Query', poll?: { __typename?: 'Poll', _id: string, answerOptions: Array<string>, answersRepartition: Array<number>, createdAt: number, imageUrl: string, numberOfParticipants: number, question: string, sectionTitle?: string | null, title: string, audience: { __typename?: 'PollAudience', organizationIds: Array<string>, siteIds: Array<string>, userIds: Array<string> }, dateWindow: { __typename?: 'PollDateWindow', startDate: string, endDate: string } } | null };

export type GetProductPriceRangesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductPriceRangesQuery = { __typename?: 'Query', productPriceRanges: Array<{ __typename?: 'ProductPriceRange', _id: string, name: string }> };

export type GetProductPriceRangeQueryVariables = Exact<{
  rangeId: Scalars['ID']['input'];
}>;


export type GetProductPriceRangeQuery = { __typename?: 'Query', productPriceRange?: { __typename?: 'PriceRangeResult', name: string, products: Array<{ __typename?: 'ProductPricesDisplay', productId: string, price: number, crossedPrice?: number | null, name: string }>, productArrangements: Array<{ __typename?: 'ProductArrangementsPricesDisplay', productArrangementId: string, price: number, crossedPrice?: number | null, name: string }> } | null };

export type GetProductPricesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetProductPricesQuery = { __typename?: 'Query', productPrices: Array<{ __typename?: 'ProductPrice', rangeId: string, price: number, crossedPrice?: number | null, type: PriceRangeType }> };

export type GetProductsFromCsvQueryVariables = Exact<{
  rangeId?: InputMaybe<Scalars['ID']['input']>;
  csvData: Array<RangeCsvData> | RangeCsvData;
}>;


export type GetProductsFromCsvQuery = { __typename?: 'Query', productsFromCsv: { __typename?: 'RangeCsvResult', idsNotFound: Array<string>, idsNotActive: Array<string>, productArrangementsIdsNotFound: Array<string>, productArrangementsIdsNotActive: Array<string>, productsForRange: Array<{ __typename?: 'ProductPriceForCsv', _id: string, name: string, price?: number | null }>, productArrangementsForRange: Array<{ __typename?: 'ProductArrangementPriceForCsv', _id: string, name: string, price?: number | null }> } };

export type GetTransferableProductsQueryVariables = Exact<{
  originColumnId: Scalars['ID']['input'];
  destinationColumnId: Scalars['ID']['input'];
  transferDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTransferableProductsQuery = { __typename?: 'Query', transferableProducts: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, conditionning: number, packagesPerBatch: number, originStockAvailable: number, destinationStockAvailable: number, quantity: number }> };

export type GetTransferableProductsFromCsvQueryVariables = Exact<{
  originColumnId: Scalars['ID']['input'];
  destinationColumnId: Scalars['ID']['input'];
  csvData: Array<InputMaybe<TransferCsvData>> | InputMaybe<TransferCsvData>;
  isDestinationQuantity: Scalars['Boolean']['input'];
}>;


export type GetTransferableProductsFromCsvQuery = { __typename?: 'Query', transferableProductsFromCsv: { __typename?: 'TransferCsvResult', idsNotFound?: Array<string | null> | null, idsArchived?: Array<string | null> | null, transferableProducts: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, conditionning: number, packagesPerBatch: number, originStockAvailable: number, destinationStockAvailable: number, quantity: number }> } };

export type GetProductsWithStockByColumnsQueryVariables = Exact<{
  columnIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetProductsWithStockByColumnsQuery = { __typename?: 'Query', productsWithStockByColumns: Array<{ __typename?: 'Product', _id: string, brand: string, categoryId: string, flow: ProductFlow, name: string, trackExpiryDate: boolean, volume: string, isDoubleCoil: boolean, isWithoutStock: boolean, expiryDateRecordsWarehouse: Array<{ __typename?: 'ExpiryDateRecord', _id: string, expiryDate: string, initialQuantity: number, quantityAtInventory: number }>, stockByColumns: Array<{ __typename?: 'ProductStockByColumn', columnId: string, stock: number, stockAvailable: number }> }> };

export type GetCatalogProductsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatalogProductsFilterInput>;
}>;


export type GetCatalogProductsQuery = { __typename?: 'Query', catalogProducts: { __typename?: 'PaginatedProducts', hasMore: boolean, products: Array<{ __typename?: 'Product', _id: string, access: Array<string>, brand: string, externalProductId?: string | null, isBeingTested: boolean, imageUrl?: string | null, isDoubleCoil: boolean, isOutOfStock: boolean, isPaused: boolean, isToBeArchived: boolean, isWithoutStock: boolean, isMicrostore: boolean, name: string, fullname: string, newUntil?: string | null, state: ProductState, flow: ProductFlow, updatedAt: number, volume: string, height?: number | null, length?: number | null, width?: number | null, weight?: number | null, category: { __typename?: 'Category', title: string }, subcategory?: { __typename?: 'Subcategory', name: string } | null, suppliers: Array<{ __typename?: 'ProductSupplier', name?: string | null, prices: Array<{ __typename?: 'SupplierProductPrice', value: number, conditionning: number }> }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean }, tags: Array<{ __typename?: 'Tag', name: string }> }> } };

export type GetDetailedProductQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetDetailedProductQuery = { __typename?: 'Query', detailedProduct?: { __typename?: 'Product', _id: string, comment?: string | null, isOutOfStock: boolean, shouldOrderOnce: boolean, description?: string | null, flow: ProductFlow, indexDisplay?: number | null, isFreefood: boolean, isMicrostore: boolean, shouldBeHiddenInStore: boolean, isPunctual: boolean, isFromNayax?: boolean | null, isWithoutStock: boolean, nbRatings: number, rating: number, scan: boolean, searchKeywords?: Array<string> | null, zeroWasteProductTemplateId?: string | null, height?: number | null, isDoubleCoil: boolean, length?: number | null, toleranceMin: number, toleranceMax: number, weight?: number | null, weightWithoutPackaging?: number | null, width?: number | null, externalProductId?: string | null, nayaxProductId?: string | null, odooProductId?: string | null, brand: string, createdAt: number, imageUrl?: string | null, name: string, fullname: string, packagingImageUrl?: string | null, state: ProductState, updatedAt: number, volume: string, ingredients?: string | null, nutriscore?: string | null, conditionningTotem: number, displayKg: boolean, isScannable: boolean, isTitreRestaurantAllowed: boolean, onboardedForSensei: boolean, portion: number, proportion?: number | null, proportionMax?: number | null, tva: number, access: Array<string>, isBeingTested: boolean, isPaused: boolean, isToBeArchived: boolean, newUntil?: string | null, useInMenusFrom?: string | null, allowNegativeStock: boolean, canExpire: boolean, checkSwollenLid: boolean, hasShortExpiryDate: boolean, minSupplierExpiryDays?: number | null, stockThreshold?: number | null, stockThresholdMinimum?: number | null, minSupplierOrderQuantity?: number | null, trackExpiryDate: boolean, tagIds: Array<string>, locations: Array<{ __typename?: 'Location', _id: string, datamatrix: string, locationType: LocationType, warehouseColumnId?: string | null, warehouseColumn?: { __typename?: 'Column', name: string } | null }>, productGroup?: { __typename?: 'ProductGroup', _id: string, createdAt: number, productId: string, updatedAt: number, composition: Array<{ __typename?: 'ProductGroupCompositionEntry', productId: string, quantity: number }> } | null, productGroupsUsedIn: Array<{ __typename?: 'ProductGroup', _id: string, createdAt: number, productId: string, updatedAt: number, composition: Array<{ __typename?: 'ProductGroupCompositionEntry', productId: string, quantity: number }> }>, barcodes: Array<{ __typename?: 'Barcode', barcode: string, type: BarcodeType }>, category: { __typename?: 'Category', _id: string, title: string }, odooProduct?: { __typename?: 'OdooProduct', _id: string, externalOdooProductId: number, externalOdooProductVariantId: number, externalOdooZeroWasteProductVariantId?: number | null } | null, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, allergen: { __typename?: 'ProductAllergen', gluten: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, peanuts: boolean, soybeans: boolean, milk: boolean, nuts: boolean, celery: boolean, mustard: boolean, sesame: boolean, sulphites: boolean, lupin: boolean, molluscs: boolean, containsNoAllergens: boolean, canContain?: string | null }, nutrition: { __typename?: 'ProductNutrition', caloriesKCal?: number | null, totalFat?: number | null, sturatedFat?: number | null, carbohydrates?: number | null, sugars?: number | null, fibers?: number | null, protein?: number | null, sodium?: number | null }, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string, quantity: number, hotDrinksIngredientUnit: HotDrinksIngredientUnit, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null, weightWithoutPackaging?: number | null } }> } | null, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null }, supplierShortageHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null, code?: string | null, prices: Array<{ __typename?: 'SupplierProductPrice', value: number, conditionning: number, packagesPerBatch: number }> }>, toBeArchivedHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, stateHistory: Array<{ __typename?: 'ProductStateHistory', state: ProductState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, deliveryDays: { __typename?: 'ProductDeliveryDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean }, preferences: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, diets: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, productArrangements: Array<{ __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> }> } | null };

export type GetNonArchivedProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNonArchivedProductsQuery = { __typename?: 'Query', nonArchivedProducts: Array<{ __typename?: 'Product', _id: string, name: string, brand: string, volume: string }> };

export type GetAllProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProductsQuery = { __typename?: 'Query', getAllProducts: Array<{ __typename?: 'Product', _id: string, brand: string, categoryId: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, shouldBeHiddenInStore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null }> };

export type GetAvailableForMicrostoreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableForMicrostoreQuery = { __typename?: 'Query', availableForMicrostore: Array<{ __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isMicrostore: boolean, shouldBeHiddenInStore: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null }> };

export type GetOffDataQueryVariables = Exact<{
  barcodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetOffDataQuery = { __typename?: 'Query', OFFProductData?: { __typename?: 'OFFDataResult', success: boolean, error?: string | null, productNutritionData?: { __typename?: 'ProductNutritionData', allergens?: Array<string | null> | null, ingredients?: string | null, nutriscore?: string | null, traces?: Array<string | null> | null, nutrition?: { __typename?: 'NutritionData', carbohydrates?: number | null, energyKcal?: number | null, fat?: number | null, fiber?: number | null, proteins?: number | null, saturatedFat?: number | null, sodium?: number | null, sugars?: number | null } | null } | null } | null };

export type GetProductsByCategoryQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type GetProductsByCategoryQuery = { __typename?: 'Query', getProductsByCategory: Array<{ __typename?: 'Product', _id: string, availableStock: number, fullname: string, portion: number }> };

export type GetTagProductsQueryVariables = Exact<{
  tagId: Scalars['ID']['input'];
}>;


export type GetTagProductsQuery = { __typename?: 'Query', productsWithTagId: Array<{ __typename?: 'Product', _id: string, fullname: string }> };

export type GetColumnProductsQueryVariables = Exact<{
  columnId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ColumnProductsFilterInput>;
}>;


export type GetColumnProductsQuery = { __typename?: 'Query', columnProducts: { __typename?: 'PaginatedColumnProducts', hasMore: boolean, columnProducts: Array<{ __typename?: 'ColumnProduct', productId: string, targetStock: number, stock: number, merchantValuation: number, product: { __typename?: 'Product', _id: string, fullname: string, state: ProductState, flow: ProductFlow }, lastColumnInventoryStock: { __typename?: 'ColumnInventoryStock', _id: string, value: number, createdAt: number }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number }, latestStockVariations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null, columnInventoryStockId: string }> }> } };

export type GetSiteProductsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SiteProductsFilterInput>;
}>;


export type GetSiteProductsQuery = { __typename?: 'Query', siteProducts: { __typename?: 'PaginatedSiteProducts', hasMore: boolean, siteProducts: Array<{ __typename?: 'SiteProduct', productId: string, targetStock: number, stock: number, product: { __typename?: 'Product', _id: string, fullname: string, state: ProductState, flow: ProductFlow }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number }, latestStockVariations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null, columnInventoryStockId: string }> }> } };

export type GetColumnProductQueryVariables = Exact<{
  columnId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}>;


export type GetColumnProductQuery = { __typename?: 'Query', columnProduct: { __typename?: 'ColumnProduct', productId: string, targetStock: number, stock: number, product: { __typename?: 'Product', _id: string, fullname: string, state: ProductState, flow: ProductFlow }, lastColumnInventoryStock: { __typename?: 'ColumnInventoryStock', _id: string, value: number, createdAt: number, createdBy?: string | null, createdByName?: string | null }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number, details?: { __typename?: 'AvailableStockDetails', dailyStocks: Array<number>, orderedStocks: Array<number>, realRecurringOrders: Array<number>, predictionRecurringOrders: Array<number>, realPunctualOrders: Array<number>, predictionPunctualOrders: Array<number>, realStoreTargetNotPrepared: Array<number>, realStoreTargetPrepared: Array<number>, predictionStoreTarget: Array<number>, storeMenu: Array<number>, preparationDate: string, preparationDateUsedIndex: number, soonestRestockedDate?: string | null, soonestRestockedDateUsedIndex: number, usedRecurringOrders: Array<number>, usedPunctualOrders: Array<number>, usedStoreTarget: Array<number>, usedStoreMenu: Array<number> } | null }, variations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null, columnInventoryStockId: string }>, inventories: Array<{ __typename?: 'ColumnInventoryStock', _id: string, createdAt: number, createdBy?: string | null, createdByName?: string | null, type: ColumnInventoryStockType, value: number, previousColumnInventoryStockId?: string | null, modifierId?: string | null }> } };

export type GetColumnsProductQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetColumnsProductQuery = { __typename?: 'Query', columnsProduct: Array<{ __typename?: 'ColumnProduct', columnId: string, stock: number, column: { __typename?: 'Column', _id: string, fullname: string, type: ColumnType } }> };

export type GetMicrostoreProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMicrostoreProductsQuery = { __typename?: 'Query', getMicrostoreProducts: Array<{ __typename?: 'Product', _id: string, brand: string, flow: ProductFlow, imageUrl?: string | null, name: string, trackExpiryDate: boolean, volume: string }> };

export type GetProductPreparationDelayQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetProductPreparationDelayQuery = { __typename?: 'Query', productPreparationDelay: Array<number> };

export type GetProductsByIdQueryVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetProductsByIdQuery = { __typename?: 'Query', getProductsById: Array<{ __typename?: 'Product', _id: string, fullname: string }> };

export type GetSupplierProductsQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
}>;


export type GetSupplierProductsQuery = { __typename?: 'Query', getSupplierProducts: Array<{ __typename?: 'Product', _id: string, fullname: string }> };

export type GetProductsWithRecipesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductsWithRecipesQuery = { __typename?: 'Query', getAllProducts: Array<{ __typename?: 'Product', _id: string, categoryId: string, fullname: string, imageUrl?: string | null, state: ProductState, weightWithoutPackaging?: number | null, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string, quantity: number, hotDrinksIngredientUnit: HotDrinksIngredientUnit, product: { __typename?: 'Product', _id: string, categoryId: string, fullname: string, imageUrl?: string | null, weightWithoutPackaging?: number | null } }> } | null }> };

export type GetProductArrangementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductArrangementsQuery = { __typename?: 'Query', productArrangementsQuery: Array<{ __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> }> };

export type GetProductArrangementQueryVariables = Exact<{
  productArrangementId: Scalars['String']['input'];
}>;


export type GetProductArrangementQuery = { __typename?: 'Query', productArrangementQuery: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, productsWithStockMax: Array<{ __typename?: 'ProductArrangementProductWithStockMax', stockMax: number, product: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } }> } };

export type GetProductGroupQueryVariables = Exact<{
  productGroupId: Scalars['ID']['input'];
}>;


export type GetProductGroupQuery = { __typename?: 'Query', getProductGroup: { __typename?: 'ProductGroup', _id: string, createdAt: number, productId: string, updatedAt: number, composition: Array<{ __typename?: 'ProductGroupCompositionEntry', productId: string, quantity: number }> } };

export type GetProductGroupsContainingProductsQueryVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetProductGroupsContainingProductsQuery = { __typename?: 'Query', getProductGroupsContainingProducts: Array<{ __typename?: 'ProductGroup', _id: string, createdAt: number, productId: string, updatedAt: number, product: { __typename?: 'Product', _id: string, brand: string, isToBeArchived: boolean, name: string, stock: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }, composition: Array<{ __typename?: 'ProductGroupCompositionEntry', productId: string, quantity: number }> }> };

export type GetProductSwitchesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductSwitchesQuery = { __typename?: 'Query', getProductSwitches: Array<{ __typename?: 'ProductSwitch', _id: string, createdAt: number, endDate: string, productAId: string, productBId: string, ratioToOrderOfA: number, ratioOfAToOrderForB: number, startDate: string, state: ProductSwitchState, switchFreefood: boolean, switchStore: boolean, updatedAt: number, productAVariation?: { __typename?: 'ProductStockVariation', computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } } | null, productBVariation?: { __typename?: 'ProductStockVariation', computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } } | null }> };

export type GetQuizzesQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
}>;


export type GetQuizzesQuery = { __typename?: 'Query', quizzes: { __typename?: 'PaginatedQuizzes', hasMore: boolean, quizzes: Array<{ __typename?: 'Quiz', _id: string, createdAt: number, title: string }> } };

export type GetQuizQueryVariables = Exact<{
  quizId: Scalars['ID']['input'];
}>;


export type GetQuizQuery = { __typename?: 'Query', quiz?: { __typename?: 'Quiz', _id: string, createdAt: number, date: string, description: string, imageUrl: string, state: QuizState, title: string, updatedAt: number, audience: { __typename?: 'QuizAudience', organizationIds: Array<string>, siteIds: Array<string>, userIds: Array<string> }, questions: Array<{ __typename?: 'QuizQuestion', label: string, answerOptions: Array<string>, correctAnswerIndex: number, imageUrl: string }> } | null };

export type GetRitualsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRitualsQuery = { __typename?: 'Query', rituals: Array<{ __typename?: 'Ritual', _id: string, activeDate?: string | null, activeWeekdays?: Array<boolean> | null, expiringProductsOnly: boolean, imageUrl: string, name: string, state: RitualState, timeWindow: { __typename?: 'RitualTimeWindow', start: string, end: string } }> };

export type GetDetailedRitualQueryVariables = Exact<{
  ritualId: Scalars['ID']['input'];
}>;


export type GetDetailedRitualQuery = { __typename?: 'Query', detailedRitual?: { __typename?: 'Ritual', _id: string, activeDate?: string | null, activeWeekdays?: Array<boolean> | null, associatedDiscount?: number | null, billToOrganizationId?: string | null, expiringProductsOnly: boolean, imageUrl: string, messagesSetId?: string | null, name: string, repetition: RitualRepetition, requiresParticipation: boolean, resetsBetweenPurchases: boolean, restrictedBadgeIds: Array<string>, restrictedCategoryIds: Array<string>, restrictedOrganizationIds: Array<string>, restrictedProductIds: Array<string>, restrictedSiteIds: Array<string>, restrictedSubcategoryIds: Array<string>, restrictedTagIds: Array<string>, restrictedUserIds: Array<string>, state: RitualState, type: RitualType, supplierPartnershipId?: string | null, stateHistory: Array<{ __typename?: 'RitualStateHistoryItem', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: RitualState }>, timeWindow: { __typename?: 'RitualTimeWindow', start: string, end: string } } | null };

export type GetSiteRitualsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetSiteRitualsQuery = { __typename?: 'Query', siteRituals: Array<{ __typename?: 'Ritual', _id: string, activeWeekdays?: Array<boolean> | null, associatedDiscount?: number | null, imageUrl: string, name: string, timeWindow: { __typename?: 'RitualTimeWindow', start: string, end: string } }> };

export type GetRitualGameForRitualQueryVariables = Exact<{
  ritualId: Scalars['ID']['input'];
}>;


export type GetRitualGameForRitualQuery = { __typename?: 'Query', getRitualGameForRitual?: { __typename?: 'QuizRitualGame', _id: string, maxAttempts: number, ritualId: string, targetScore: number, totalScore: number, type: RitualGameType, questions: Array<{ __typename?: 'RitualQuizQuestion', answerChoices: Array<string>, correctAnswerIndex: number, description: string, explanation: string, imageUrl?: string | null, timeToAnswer: number, title: string }> } | { __typename?: 'WantedRitualGame', _id: string, maxAttempts: number, ritualId: string, targetScore: number, totalScore: number, type: RitualGameType } | null };

export type GetRitualTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRitualTemplatesQuery = { __typename?: 'Query', ritualTemplates: Array<{ __typename?: 'RitualTemplate', _id: string, imageUrl: string, name: string }> };

export type GetSenseiBasketQueryVariables = Exact<{
  basketId: Scalars['ID']['input'];
}>;


export type GetSenseiBasketQuery = { __typename?: 'Query', senseiBasket?: { __typename?: 'SenseiBasket', _id: string, createdAt: number, senseiBasketId: number, senseiColumnId?: string | null, userId: string, basketCreationDate: number, storeEntryDate: number, storeExitDate: number, transactions: Array<{ __typename?: 'Transaction', _id: string, basketId?: string | null, nuBasketId?: string | null, createdAt: number, priceHT: number, productId: string, productName: string, refundReason?: string | null, siteId: string, siteName: string, microstoreColumnId?: string | null, microstoreColumnName: string, newState: TransactionState, tva: number, userId: string, userFullName: string, nayaxMDBCode?: number | null, nuBasket?: { __typename?: 'NuBasket', type: NuBasketType } | null, paymentMethods?: Array<{ __typename?: 'TransactionPaymentMethod', amountUsed: number, explanation?: string | null, name?: string | null, paymentMethodName: PaymentMethodName, provider?: string | null, providerTransactionId?: string | null, status: PaymentIntentState, type?: PaymentMethodPaymentType | null }> | null, mealPlan?: { __typename?: 'MealPlan', discountRatio: number } | null, stateHistory: Array<{ __typename?: 'TransactionStateHistory', state: TransactionState, createdAt: number, createdBy: string }> }>, items: Array<{ __typename?: 'SenseiBasketItem', quantity?: number | null, sku?: string | null, lineAmount?: number | null, lineTax?: number | null }> } | null };

export type GetSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSitesQuery = { __typename?: 'Query', sites: Array<{ __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, launchDate?: string | null, name: string, organizationName: string, organizationId: string, state: SiteState, totemId: string, type: SiteType, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null }> };

export type GetSitesWithReassortmentStockTransfersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSitesWithReassortmentStockTransfersQuery = { __typename?: 'Query', sites: Array<{ __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, launchDate?: string | null, name: string, organizationName: string, shouldOperateOnTotops: boolean, state: SiteState, type: SiteType, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number, nextReassortmentStockTransfers: Array<{ __typename?: 'StockTransfer', _id: string, createdAt: number, updatedAt: number, transferDate: string, destinationColumnId: string, originColumnId: string, deliveryId?: string | null, reassortmentFlow?: ReassortmentFlow | null, shouldUpdateStockImmediately: boolean, state: StockTransferState, destinationColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, originColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, products: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, conditionning: number, packagesPerBatch: number, originStockAvailable: number, destinationStockAvailable: number, quantity: number }>, delivery?: { __typename?: 'Delivery', state: DeliveryState } | null, stateHistory: Array<{ __typename?: 'StockTransferStateHistory', state: StockTransferState, createdAt: number, createdBy: string, createdByName?: string | null }> }> }> }> }> };

export type GetSitesPaginatedQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SitesFilterInput>;
}>;


export type GetSitesPaginatedQuery = { __typename?: 'Query', sitesFilter: { __typename?: 'PaginatedSites', hasMore: boolean, sites: Array<{ __typename?: 'Site', _id: string, createdAt: number, updatedAt: number, deliveryDays: Array<boolean>, deliveryType: SiteDeliveryType, name: string, organizationName: string, organizationId: string, state: SiteState, totemId: string, type: SiteType, B2CPriceRange?: string | null, accessTime: number, launchDate?: string | null, removalDate?: string | null, hasExternalSetupProcess: boolean, estimatedUserCount: number, isSecured: boolean, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldModulateForExpired: boolean, shouldHaveTheftNotice: boolean, shouldModulateForUnknownLosses: boolean, useNayaxCard: boolean, hasSensei: boolean, unknownShrinkageBillingThreshold?: number | null, deliveryZoneId?: string | null, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null }> } };

export type GetSimpleMicrostoreSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSimpleMicrostoreSitesQuery = { __typename?: 'Query', microstoreSites: Array<{ __typename?: 'Site', _id: string, organizationName: string, deliveryDays: Array<boolean>, launchDate?: string | null, name: string, state: SiteState, type: SiteType, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string }> }> }> };

export type GetMicrostoreSitesPaginatedQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  filterString?: InputMaybe<Scalars['String']['input']>;
  stateFilter?: InputMaybe<SiteState>;
}>;


export type GetMicrostoreSitesPaginatedQuery = { __typename?: 'Query', microstoreSitesWithColumnGroupsFilter: { __typename?: 'PaginatedSites', hasMore: boolean, sites: Array<{ __typename?: 'Site', _id: string, organizationName: string, name: string, state: SiteState, type: SiteType, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string }> }> }> } };

export type GetMicrostoreSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMicrostoreSitesQuery = { __typename?: 'Query', microstoreSitesWithColumnGroups: Array<{ __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, siteId: string, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, microstoreColumnTemplateId: string, name: string, positionInColumnGroup: number, removalDate?: string | null, startingDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType }> }>, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null }> };

export type GetMicrostoreSitesWithReassortmentStockQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMicrostoreSitesWithReassortmentStockQuery = { __typename?: 'Query', microstoreSitesWithReassortmentInfo: Array<{ __typename?: 'Site', _id: string, name: string, nextDeliveryDate?: string | null, freshReassortmentInfos: { __typename?: 'FreshReassortmentInfos', filledLocationsRatio: number, hasStartedReassortment: boolean, stockByCategories: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number } }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number } }> };

export type GetSiteQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetSiteQuery = { __typename?: 'Query', site: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, microstoreColumnTemplateName: string, isPaused: boolean }> }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } }, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } };

export type GetSiteMetabaseDashboardUrlQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetSiteMetabaseDashboardUrlQuery = { __typename?: 'Query', siteMetabaseDashboardUrl: string };

export type GetMicrostoreSiteQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type GetMicrostoreSiteQuery = { __typename?: 'Query', siteWithLocationInfo: { __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, earliestDLCDateToKeepForStockCalculation?: string | null, isOpenOnWeekend: boolean, isSecured: boolean, name: string, type: SiteType, state: SiteState, organizationName: string, nextDeliveryDate?: string | null, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }> } };

export type GetMicrostoreSitesWithLocationsInfoQueryVariables = Exact<{
  siteIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetMicrostoreSitesWithLocationsInfoQuery = { __typename?: 'Query', sites: Array<{ __typename?: 'Site', _id: string, isSecured: boolean, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }> }> };

export type GetFreshProductsWarehouseStockInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFreshProductsWarehouseStockInfoQuery = { __typename?: 'Query', getFreshProductsWarehouseStockInfo: { __typename?: 'TargetInfoPageStockInfo', dessert: { __typename?: 'StockInfo', stockAvailableWithReassortment: number, stockExpectedInSupplyOrders: number, availableWarehouseStock: number }, main: { __typename?: 'StockInfo', stockAvailableWithReassortment: number, stockExpectedInSupplyOrders: number, availableWarehouseStock: number }, smallBites: { __typename?: 'StockInfo', stockAvailableWithReassortment: number, stockExpectedInSupplyOrders: number, availableWarehouseStock: number }, starter: { __typename?: 'StockInfo', stockAvailableWithReassortment: number, stockExpectedInSupplyOrders: number, availableWarehouseStock: number } } };

export type GetNextMsDeliveryDateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextMsDeliveryDateQuery = { __typename?: 'Query', getNextMSDeliveryDate: string };

export type GetSetupSiteInventoryQueryVariables = Exact<{
  siteSetupId: Scalars['ID']['input'];
}>;


export type GetSetupSiteInventoryQuery = { __typename?: 'Query', getSetupSiteInventory: { __typename?: 'SiteInventory', _id: string, createdAt: number, date: string, siteId: string, state: SiteInventoryState, updatedAt: number, microstoreColumnInventories: Array<{ __typename?: 'MicrostoreColumnInventory', _id: string, createdAt: number, microstoreColumnId: string, siteInventoryId: string, state: MicrostoreColumnInventoryState, updatedAt: number, checkedLocations: Array<{ __typename?: 'InventoryCheckedLocation', microstoreLocationId: string, productId: string, quantityDetails: Array<{ __typename?: 'InventoryCheckedLocationQuantityDetail', expiryDate?: string | null, quantity: number }> }> }> } };

export type GetSiteSetupsForDateQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type GetSiteSetupsForDateQuery = { __typename?: 'Query', getSiteSetupsForDate: Array<{ __typename?: 'SiteSetup', _id: string, createdAt: number, date: string, isFinishForced: boolean, siteId: string, state: SiteSetupState, updatedAt: number, delivery?: { __typename?: 'Delivery', isDynamic: boolean } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> } | null, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', _id: string, isFinishForced: boolean, isNeeded: boolean, microstoreColumnGroupId: string, positionInSiteSetup: number, siteSetupId: string, state: MicrostoreColumnGroupSetupState, updatedAt: number, instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> }>, stateHistory: Array<{ __typename?: 'MicrostoreColumnGroupSetupStateHistory', createdAt: number, state: MicrostoreColumnGroupSetupState }> }>, site: { __typename?: 'Site', _id: string, organizationName: string, name: string, state: SiteState, type: SiteType, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string }> }> }, stateHistory: Array<{ __typename?: 'SiteSetupStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: SiteSetupState }> }> };

export type GetSiteSetupQueryVariables = Exact<{
  siteSetupId: Scalars['ID']['input'];
}>;


export type GetSiteSetupQuery = { __typename?: 'Query', getSiteSetup: { __typename?: 'SiteSetup', _id: string, createdAt: number, date: string, deliveryId: string, isFinishForced: boolean, siteId: string, state: SiteSetupState, updatedAt: number, delivery?: { __typename?: 'Delivery', isDynamic: boolean } | null, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> } | null, issues: { __typename?: 'SiteSetupIssues', productsIssues: Array<{ __typename?: 'SetupProductIssues', comment: string, productId: string, brokenDuringDeliveryQuantity: number, brokenOnSiteAfterInventoryQuantity: number, brokenOnSiteBeforeInventoryQuantity: number, expiredDeliveredQuantity: number, expiredOnSiteAfterInventoryQuantity: number, expiredOnSiteBeforeInventoryQuantity: number, notEnoughPlaceQuantity: number, otherBeforeInventoryQuantity: number, otherAfterInventoryOrDuringDeliveryQuantity: number, unexpectedOnSiteQuantity: number, wrongQuantityDelivered: number }> }, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', _id: string, isFinishForced: boolean, isNeeded: boolean, microstoreColumnGroupId: string, positionInSiteSetup: number, siteSetupId: string, state: MicrostoreColumnGroupSetupState, updatedAt: number, instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> }>, stateHistory: Array<{ __typename?: 'MicrostoreColumnGroupSetupStateHistory', createdAt: number, state: MicrostoreColumnGroupSetupState }> }>, odooTickets: Array<{ __typename?: 'OdooTicket', _id: string, odooTicketId: number, microstoreColumnId: string, serviceType: OdooServiceType, ticketType: string, state: OdooTicketState, description: string, actions: Array<{ __typename?: 'OdooTicketAction', actionType: OdooTicketActionType, message: string, photoUrl?: string | null, createdAt: number }>, microstoreColumn: { __typename?: 'MicrostoreColumn', name: string } }>, site: { __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, earliestDLCDateToKeepForStockCalculation?: string | null, isOpenOnWeekend: boolean, isSecured: boolean, name: string, type: SiteType, state: SiteState, organizationName: string, nextDeliveryDate?: string | null, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }> }, stateHistory: Array<{ __typename?: 'SiteSetupStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: SiteSetupState }> } };

export type GetSiteSetupDeliveryQueryVariables = Exact<{
  siteSetupId: Scalars['ID']['input'];
}>;


export type GetSiteSetupDeliveryQuery = { __typename?: 'Query', getSiteSetup: { __typename?: 'SiteSetup', _id: string, delivery?: { __typename?: 'Delivery', _id: string, boxes: Array<{ __typename?: 'Box', _id: string, orderId?: string | null, siteId?: string | null, products: Array<{ __typename?: 'BoxProduct', _id: string, boxId?: string | null, quantity: number, quantityPicked?: number | null }> }> } | null } };

export type GetSiteSetupsBySiteIdQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
  date: Scalars['String']['input'];
}>;


export type GetSiteSetupsBySiteIdQuery = { __typename?: 'Query', getSiteSetupsBySiteId: Array<{ __typename?: 'SiteSetup', _id: string, createdAt: number, date: string, isFinishForced: boolean, siteId: string, state: SiteSetupState, updatedAt: number, delivery?: { __typename?: 'Delivery', isDynamic: boolean } | null, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> } | null, issues: { __typename?: 'SiteSetupIssues', productsIssues: Array<{ __typename?: 'SetupProductIssues', comment: string, productId: string, brokenDuringDeliveryQuantity: number, brokenOnSiteAfterInventoryQuantity: number, brokenOnSiteBeforeInventoryQuantity: number, expiredDeliveredQuantity: number, expiredOnSiteAfterInventoryQuantity: number, expiredOnSiteBeforeInventoryQuantity: number, notEnoughPlaceQuantity: number, otherBeforeInventoryQuantity: number, otherAfterInventoryOrDuringDeliveryQuantity: number, unexpectedOnSiteQuantity: number, wrongQuantityDelivered: number }> }, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', _id: string, isFinishForced: boolean, isNeeded: boolean, microstoreColumnGroupId: string, positionInSiteSetup: number, siteSetupId: string, state: MicrostoreColumnGroupSetupState, updatedAt: number, instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> }>, stateHistory: Array<{ __typename?: 'MicrostoreColumnGroupSetupStateHistory', createdAt: number, state: MicrostoreColumnGroupSetupState }> }>, site: { __typename?: 'Site', _id: string, organizationName: string, name: string, state: SiteState, type: SiteType, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string }> }> }, stateHistory: Array<{ __typename?: 'SiteSetupStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: SiteSetupState }> }> };

export type GetSnapshotMicrostoreForDateQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
  snapshotDate: Scalars['String']['input'];
}>;


export type GetSnapshotMicrostoreForDateQuery = { __typename?: 'Query', getSnapshotMicrostoreForDate?: { __typename?: 'SnapshotMicrostore', _id: string, createdAt: number, siteId: string, snapshotDate: string, columnGroups: Array<{ __typename?: 'SnapshotColumnGroup', columnGroupId: string, columns: Array<{ __typename?: 'SnapshotColumn', columnId: string, columnIdToReplace?: string | null, isPaused?: boolean | null, removalDate?: string | null, startingDate?: string | null, shelves: Array<{ __typename?: 'SnapshotShelf', shelfId: string, locationTable: Array<Array<{ __typename?: 'SnapshotLocation', locationId: string, productId?: string | null }>> }> }> }> } | null };

export type GetStockTransfersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<StockTransfersFilterInput>;
}>;


export type GetStockTransfersQuery = { __typename?: 'Query', stockTransfers: { __typename?: 'PaginatedStockTransfers', hasMore: boolean, stockTransfers: Array<{ __typename?: 'StockTransfer', _id: string, transferDate: string, state: StockTransferState, quantityOfProducts: number, numberOfRefs: number, reassortmentFlow?: ReassortmentFlow | null, isForReassortment: boolean, shouldUpdateStockImmediately: boolean, createdAt: number, updatedAt: number, destinationColumn: { __typename?: 'Column', fullname: string }, originColumn: { __typename?: 'Column', fullname: string } }> } };

export type GetReturnedStockTransfersQueryVariables = Exact<{
  transferDate: Scalars['String']['input'];
}>;


export type GetReturnedStockTransfersQuery = { __typename?: 'Query', returnedStockTransfers: Array<{ __typename?: 'StockTransfer', _id: string, state: StockTransferState, updatedAt: number, originColumn: { __typename?: 'Column', fullname: string }, products: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, originStockAvailable: number, destinationStockAvailable: number, quantity: number }> }> };

export type GetStockTransferQueryVariables = Exact<{
  stockTransferId: Scalars['ID']['input'];
}>;


export type GetStockTransferQuery = { __typename?: 'Query', stockTransfer: { __typename?: 'StockTransfer', _id: string, createdAt: number, updatedAt: number, transferDate: string, destinationColumnId: string, originColumnId: string, deliveryId?: string | null, reassortmentFlow?: ReassortmentFlow | null, shouldUpdateStockImmediately: boolean, state: StockTransferState, destinationColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, originColumn: { __typename?: 'Column', _id: string, name: string, fullname: string }, products: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, conditionning: number, packagesPerBatch: number, originStockAvailable: number, destinationStockAvailable: number, quantity: number }>, delivery?: { __typename?: 'Delivery', state: DeliveryState } | null, stateHistory: Array<{ __typename?: 'StockTransferStateHistory', state: StockTransferState, createdAt: number, createdBy: string, createdByName?: string | null }> } };

export type StockTreeColumnProductFragment = { __typename?: 'ColumnProduct', columnId: string, productId: string, stock: number, targetStock: number, merchantValuation: number, product: { __typename?: 'Product', _id: string, fullname: string }, column: { __typename?: 'Column', _id: string, name: string, type: ColumnType }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number }, latestStockVariations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null }> };

export type GetColumnProductStocksQueryVariables = Exact<{
  columnId: Scalars['ID']['input'];
}>;


export type GetColumnProductStocksQuery = { __typename?: 'Query', column?: { __typename?: 'Column', _id: string, productStocks: Array<{ __typename?: 'ColumnProduct', columnId: string, productId: string, stock: number, targetStock: number, merchantValuation: number, product: { __typename?: 'Product', _id: string, fullname: string }, column: { __typename?: 'Column', _id: string, name: string, type: ColumnType }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number }, latestStockVariations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null }> }> } | null };

export type GetSiteProductsTreeQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SiteProductsFilterInput>;
}>;


export type GetSiteProductsTreeQuery = { __typename?: 'Query', siteProducts: { __typename?: 'PaginatedSiteProducts', hasMore: boolean, siteProducts: Array<{ __typename?: 'SiteProduct', productId: string, stock: number, targetStock: number, merchantValuation: number, columnsCount: number, product: { __typename?: 'Product', _id: string, fullname: string }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number }, latestStockVariations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null }> }> } };

export type GetSiteProductsColumnStocksQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<SiteProductsFilterInput>;
}>;


export type GetSiteProductsColumnStocksQuery = { __typename?: 'Query', siteProducts: { __typename?: 'PaginatedSiteProducts', siteProducts: Array<{ __typename?: 'SiteProduct', productId: string, columnStocks: Array<{ __typename?: 'ColumnProduct', columnId: string, productId: string, stock: number, targetStock: number, merchantValuation: number, product: { __typename?: 'Product', _id: string, fullname: string }, column: { __typename?: 'Column', _id: string, name: string, type: ColumnType }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number }, latestStockVariations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null }> }> }> } };

export type GetSiteProductColumnStocksQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}>;


export type GetSiteProductColumnStocksQuery = { __typename?: 'Query', siteProduct: { __typename?: 'SiteProduct', productId: string, columnStocks: Array<{ __typename?: 'ColumnProduct', columnId: string, productId: string, stock: number, targetStock: number, merchantValuation: number, product: { __typename?: 'Product', _id: string, fullname: string }, column: { __typename?: 'Column', _id: string, name: string, type: ColumnType }, availableStock: { __typename?: 'AvailableStock', isUnlimited: boolean, value: number }, latestStockVariations: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, type: StockVariationType, ref?: string | null, explanation?: string | null }> }> } };

export type GetStockVariationsForDateQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type GetStockVariationsForDateQuery = { __typename?: 'Query', getStockVariationsForDate: Array<{ __typename?: 'StockVariation', _id: string, createdAt: number, delta: number, explanation?: string | null, productId: string, ref?: string | null, columnInventoryStockId: string, columnId: string, type: StockVariationType }> };

export type GetSubcategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubcategoriesQuery = { __typename?: 'Query', subcategories: Array<{ __typename?: 'Subcategory', _id: string, categoryId: string, displayIndex: number, name: string, state: SubcategoryState }> };

export type GetSubcategoriesOfCategoryQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type GetSubcategoriesOfCategoryQuery = { __typename?: 'Query', subcategoriesOfCategory: Array<{ __typename?: 'Subcategory', _id: string, categoryId: string, displayIndex: number, name: string, state: SubcategoryState }> };

export type GetSubventionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubventionsQuery = { __typename?: 'Query', subventions: Array<{ __typename?: 'Subvention', _id: string, archivedAt?: number | null, billToOrganizationId?: string | null, categories: Array<string>, coverageRate?: number | null, createdAt: number, cumulative?: boolean | null, currentAmount?: number | null, description: string, hoursIntervalsAvailable: Array<Array<string>>, imageUrl?: string | null, name: string, organizationId: string, reload?: SubventionReloadPeriod | null, remainingAmount?: number | null, updatedAt: number, billToOrganization?: { __typename?: 'Organization', _id: string, name: string } | null, organization?: { __typename?: 'Organization', _id: string, name: string } | null }> };

export type GetSubventionQueryVariables = Exact<{
  subventionId: Scalars['ID']['input'];
}>;


export type GetSubventionQuery = { __typename?: 'Query', subvention: { __typename?: 'Subvention', _id: string, archivedAt?: number | null, billToOrganizationId?: string | null, categories: Array<string>, coverageRate?: number | null, createdAt: number, cumulative?: boolean | null, currentAmount?: number | null, description: string, hoursIntervalsAvailable: Array<Array<string>>, imageUrl?: string | null, name: string, organizationId: string, reload?: SubventionReloadPeriod | null, remainingAmount?: number | null, updatedAt: number, billToOrganization?: { __typename?: 'Organization', _id: string, name: string } | null, organization?: { __typename?: 'Organization', _id: string, name: string } | null } };

export type GetSuppliersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuppliersQuery = { __typename?: 'Query', suppliers: Array<{ __typename?: 'Supplier', _id: string, name: string, state: SupplierState }> };

export type GetPaginatedFilteredSuppliersQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  filterString?: InputMaybe<Scalars['String']['input']>;
  shouldHideArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPaginatedFilteredSuppliersQuery = { __typename?: 'Query', paginatedFilteredSuppliers: { __typename?: 'PaginatedSuppliers', hasMore: boolean, suppliers: Array<{ __typename?: 'Supplier', _id: string, name: string, state: SupplierState }> } };

export type GetDetailedSupplierQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
}>;


export type GetDetailedSupplierQuery = { __typename?: 'Query', detailedSupplier: { __typename?: 'Supplier', _id: string, nextOrderingDate?: string | null, name: string, description?: string | null, phone?: string | null, address?: string | null, zipcode?: string | null, website?: string | null, createdAt?: number | null, updatedAt?: number | null, shouldCheckReceptionDayIsNotClosed: boolean, shouldOrderAutomatically: boolean, state: SupplierState, paymentTimeType: PaymentTimeType, paymentTimeDays?: number | null, paymentType: SupplierPaymentType, orderMode: OrderMode, orderEmails: Array<string>, orderPlatformUrl?: string | null, clientCode?: string | null, frequency: number, closingDatesRanges: Array<{ __typename?: 'SupplierClosingDatesRange', closingDate: string, openingDate: string }>, stateHistory: Array<{ __typename?: 'SupplierStateHistory', state: SupplierState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, contacts: Array<{ __typename?: 'SupplierContact', name: string, surname: string, phone: string, email: string, description: string }>, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } } } };

export type SupplierDiscountsQueryVariables = Exact<{ [key: string]: never; }>;


export type SupplierDiscountsQuery = { __typename?: 'Query', supplierDiscounts: Array<{ __typename?: 'SupplierDiscount', _id: string, name: string, createdAt: number, updatedAt: number, state: SupplierDiscountState, rate: number, productIds: Array<string>, purchaseStartDate: number, purchaseEndDate: number, salesStartDate: number, salesEndDate: number, imageUrl?: string | null, discountedProductPrices: Array<{ __typename?: 'DiscountedProductPrice', _id: string, purchasePrice: number, purchaseDiscountedPrice: number, purchaseDiscountAmount: number, purchaseDiscountRate: number, salesPrice: number, salesDiscountedPrice: number, salesDiscountAmount: number, salesDiscountRate: number, product: { __typename?: 'Product', _id: string, fullname: string, category: { __typename?: 'Category', _id: string, title: string }, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null }> } }> }> };

export type GetSupplierPartnershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupplierPartnershipsQuery = { __typename?: 'Query', supplierPartnerships: Array<{ __typename?: 'SupplierPartnership', _id: string, budget: number, createdAt: number, endDate: string, name: string, productIds: Array<string>, startDate: string, updatedAt: number }> };

export type GetSupplyOrdersQueryVariables = Exact<{
  displayLimitDateFormatted: Scalars['String']['input'];
}>;


export type GetSupplyOrdersQuery = { __typename?: 'Query', supplyOrders: Array<{ __typename?: 'SupplyOrder', description?: string | null, isAtSoldOutRisk?: boolean | null, isMerged: boolean, _id: string, state: SupplyOrderState, createdAt: number, orderDate?: string | null, nextOrderDate?: string | null, dateDeliveryScheduled?: string | null, dateDelivery?: string | null, scheduledDeliveryDateValidity: boolean, number?: number | null, priceHT?: number | null, priceTTC?: number | null, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, quantity: number, supplyOrderId: string }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, supplier: { __typename?: 'Supplier', _id: string, name: string, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> };

export type GetSupplyOrderWithSupplierProductsInfoQueryVariables = Exact<{
  supplyOrderId: Scalars['String']['input'];
}>;


export type GetSupplyOrderWithSupplierProductsInfoQuery = { __typename?: 'Query', supplyOrderWithSupplierProductsInfo: { __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } } };

export type GetSupplyOrderSupplierProductsStockVariationQueryVariables = Exact<{
  supplyOrderId: Scalars['String']['input'];
}>;


export type GetSupplyOrderSupplierProductsStockVariationQuery = { __typename?: 'Query', supplyOrderSupplierProductsStockVariation: { __typename?: 'SupplyOrderProductStockVariations', productGroupStockVariations: Array<{ __typename?: 'ProductStockVariation', isComputed: boolean, computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } }>, supplyOrderStockVariations: Array<{ __typename?: 'ProductStockVariation', isComputed: boolean, computedStockThreshold: number, createdAt: number, initialStock?: number | null, missingStockBetweenDeliveries: number, orderDate: string, outboundFreefoodFloatStockVariation: Array<number>, outboundStoreFloatStockVariation: Array<number>, outboundStockVariation: Array<number>, productId: string, stockUpdateDayIndexIfOrderedOnNextOrderingDay: number, stockUpdateDayIndexIfOrderedToday: number, stockVariation: Array<number>, stockVariationFromSupplyOrders: Array<number>, supplyOrderId?: string | null, forecasts: { __typename?: 'ProductForecastsStockVariationDetails', forecastsDaysToIgnoreForOrders: number, forecastsFreefoodPunctual: Array<number>, forecastsFreefoodRecurring: Array<number>, forecastsStoreDry: Array<number>, lastUpdateDateFreefoodPunctual: number, lastUpdateDateFreefoodRecurring: number, lastUpdateDateStoreDry: number }, microstoreDetails: { __typename?: 'ProductMicrostoreDetails', missingStockByDay: Array<number>, targetStockByDay: Array<number>, totalStock: number, targetStockDetails: Array<{ __typename?: 'ProductMicrostoreTargetStockDetails', locationTarget: number, planogramDate?: string | null, siteName: string, usedLocationTarget: number }> }, operations: { __typename?: 'ProductOperationsStockVariationDetails', punctualOrdersNotPrepared: Array<number>, recurrentOrdersNotPrepared: Array<number>, validatedStockTransferPrepared: Array<number>, validatedStockTransferNotPrepared: Array<number> }, productSwitchDetails: { __typename?: 'ProductSwitchDetails', variations: Array<number> } }> } };

export type GetProductsToOrderOnceForSupplyOrderQueryVariables = Exact<{
  supplyOrderId: Scalars['String']['input'];
}>;


export type GetProductsToOrderOnceForSupplyOrderQuery = { __typename?: 'Query', productsToOrderOnceForSupplyOrder: Array<{ __typename?: 'Product', _id: string, suppliers: Array<{ __typename?: 'ProductSupplier', prices: Array<{ __typename?: 'SupplierProductPrice', packagesPerBatch: number }> }> }> };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', _id: string, displayIndex: number, name: string, type: TagType, state: TagState }> };

export type GetTagQueryVariables = Exact<{
  tagId: Scalars['ID']['input'];
}>;


export type GetTagQuery = { __typename?: 'Query', tag: { __typename?: 'Tag', _id: string, displayIndex: number, name: string, type: TagType, state: TagState } };

export type GetTermsRecordsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTermsRecordsQuery = { __typename?: 'Query', termsRecords: Array<{ __typename?: 'TermsRecord', _id: string, createdAt: number, termsOfUseUrl: string }> };

export type GetThermometersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetThermometersQuery = { __typename?: 'Query', getThermometers: Array<{ __typename?: 'Thermometer', _id: string, associatedUserId?: string | null, isOperational: boolean, number: number }> };

export type GetTotemQueryVariables = Exact<{
  totemId: Scalars['ID']['input'];
}>;


export type GetTotemQuery = { __typename?: 'Query', totem: { __typename?: 'Totem', _id: string, fullname: string, accessTime: number, address?: string | null, address_details?: string | null, consigneDelivery?: string | null, city?: string | null, country?: string | null, deliveryInstructions?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, needSignature: boolean, number: number, organizationId: string, primaryTotemId?: string | null, state: TotemState, type: TotemType, zipcode?: string | null, equipments: Array<{ __typename?: 'TotemEquipment', equipmentId: string, quantity: number, comment?: string | null }>, mainUser?: { __typename?: 'TotemUser', _id: string, fullName: string } | null, microstore?: { __typename?: 'Site', _id: string, name: string } | null, minimumOrderAmountInfo: { __typename?: 'MinimumOrderAmountInfo', minimumBakeryAmount: number, minimumDryAmount: number, minimumFreshAmount: number, minimumCatererAmount: number, minimumFruitAmount: number, minimumTotalAmount: number }, organization: { __typename?: 'Organization', _id: string, name: string }, recentOrders: Array<{ __typename?: 'TotemOrder', _id: string, deliveryDate: string, deliveryState?: DeliveryState | null, state: OrderState }>, sites: Array<{ __typename?: 'Site', _id: string, name: string, state: SiteState, type: SiteType, deliveryType: SiteDeliveryType, createdAt: number }>, stateHistory: Array<{ __typename?: 'TotemStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: TotemState }> } };

export type GetTotemsOfOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetTotemsOfOrganizationQuery = { __typename?: 'Query', totemsOfOrganization: Array<{ __typename?: 'Totem', _id: string, name?: string | null, number: number }> };

export type GetDetailedTotemsOfOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetDetailedTotemsOfOrganizationQuery = { __typename?: 'Query', totemsOfOrganization: Array<{ __typename?: 'Totem', _id: string, fullname: string, accessTime: number, address?: string | null, address_details?: string | null, consigneDelivery?: string | null, city?: string | null, country?: string | null, deliveryInstructions?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, needSignature: boolean, number: number, organizationId: string, primaryTotemId?: string | null, state: TotemState, type: TotemType, zipcode?: string | null, equipments: Array<{ __typename?: 'TotemEquipment', equipmentId: string, quantity: number, comment?: string | null }>, mainUser?: { __typename?: 'TotemUser', _id: string, fullName: string } | null, microstore?: { __typename?: 'Site', _id: string, name: string } | null, minimumOrderAmountInfo: { __typename?: 'MinimumOrderAmountInfo', minimumBakeryAmount: number, minimumDryAmount: number, minimumFreshAmount: number, minimumCatererAmount: number, minimumFruitAmount: number, minimumTotalAmount: number }, recentOrders: Array<{ __typename?: 'TotemOrder', _id: string, deliveryDate: string, deliveryState?: DeliveryState | null, state: OrderState }>, sites: Array<{ __typename?: 'Site', _id: string, name: string, state: SiteState, type: SiteType, deliveryType: SiteDeliveryType, createdAt: number }>, stateHistory: Array<{ __typename?: 'TotemStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: TotemState }> }> };

export type GetTotemsWithEquipmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotemsWithEquipmentsQuery = { __typename?: 'Query', totemsWithEquipments: Array<{ __typename?: 'Totem', _id: string, number: number, equipments: Array<{ __typename?: 'TotemEquipment', equipmentId: string, quantity: number }>, organization: { __typename?: 'Organization', _id: string, name: string } }> };

export type GetActiveTotemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveTotemsQuery = { __typename?: 'Query', activeTotems: Array<{ __typename?: 'Totem', _id: string, address?: string | null, city?: string | null, country?: string | null, name?: string | null, number: number, organizationId: string, zipcode?: string | null }> };

export type GetTotemsFilterQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<TotemsFilterInput>;
}>;


export type GetTotemsFilterQuery = { __typename?: 'Query', totemsFilter: { __typename?: 'PaginatedTotems', hasMore: boolean, totems: Array<{ __typename?: 'Totem', _id: string, name?: string | null, fullname: string, number: number, state: TotemState, type: TotemType, organization: { __typename?: 'Organization', _id: string, name: string }, sites: Array<{ __typename?: 'Site', _id: string, name: string }> }> } };

export type GetAllRegularTotemClosedDayQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRegularTotemClosedDayQuery = { __typename?: 'Query', getAllRegularTotemClosedDay: Array<{ __typename?: 'TotemClosedDay', _id: string, createdAt: number, date: string, state: TotemClosedDayState, type: TotemClosedDayType, updatedAt: number }> };

export type GetAllRegularTotemClosedReceptionDayQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRegularTotemClosedReceptionDayQuery = { __typename?: 'Query', getAllRegularTotemClosedReceptionDay: Array<{ __typename?: 'TotemClosedReceptionDay', _id: string, createdAt: number, date: string, state: TotemClosedReceptionDayState, updatedAt: number }> };

export type TourDeliveryFragmentFragment = { __typename?: 'Delivery', _id: string, siteName?: string | null, organizationName?: string | null, isDynamic: boolean, state: DeliveryState, type: DeliveryType, deliveredMicrostoreColumnIds: Array<string>, orderIds: Array<string>, theoricServiceTime?: number | null, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState }>, deliveredMicrostoreColumns: Array<{ __typename?: 'Column', _id: string, microstoreColumn?: { __typename?: 'MicrostoreColumn', _id: string, type: MicrostoreColumnTemplateType } | null }>, orders: Array<{ __typename?: 'Order', _id: string, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }> }>, totem?: { __typename?: 'Totem', _id: string, name?: string | null, number: number, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null, site?: { __typename?: 'Site', _id: string, contractType: SiteContractType, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string } | null } | null, boxes: Array<{ __typename?: 'Box', _id: string, type: ProductFlow, departureScannedAt?: number | null, loadedAt?: number | null, setupScannedAt?: number | null, returnedAt?: number | null }> };

export type TourTaskFragmentFragment = { __typename?: 'Task', _id: string, type: TaskType, description: string, driversComment?: string | null, state: TaskState, siteId: string, theoricServiceTime: number, instructions: Array<{ __typename?: 'TaskInstruction', _id: string, label: string, isDone: boolean, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }>, stateHistory: Array<{ __typename?: 'TaskStateHistory', state: TaskState, createdAt: number, createdByName?: string | null }>, site?: { __typename?: 'Site', _id: string, name: string, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string } } | null, totem?: { __typename?: 'Totem', _id: string, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null };

export type TourFragmentFragment = { __typename?: 'Tour', _id: string, name: string, color: string, deliveryPersonUserId?: string | null, state: TourState, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, deliveries: Array<{ __typename?: 'Delivery', _id: string, siteName?: string | null, organizationName?: string | null, isDynamic: boolean, state: DeliveryState, type: DeliveryType, deliveredMicrostoreColumnIds: Array<string>, orderIds: Array<string>, theoricServiceTime?: number | null, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState }>, deliveredMicrostoreColumns: Array<{ __typename?: 'Column', _id: string, microstoreColumn?: { __typename?: 'MicrostoreColumn', _id: string, type: MicrostoreColumnTemplateType } | null }>, orders: Array<{ __typename?: 'Order', _id: string, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }> }>, totem?: { __typename?: 'Totem', _id: string, name?: string | null, number: number, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null, site?: { __typename?: 'Site', _id: string, contractType: SiteContractType, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string } | null } | null, boxes: Array<{ __typename?: 'Box', _id: string, type: ProductFlow, departureScannedAt?: number | null, loadedAt?: number | null, setupScannedAt?: number | null, returnedAt?: number | null }> }>, stops: Array<{ __typename: 'Delivery', _id: string } | { __typename: 'Task', _id: string, type: TaskType, description: string, driversComment?: string | null, state: TaskState, siteId: string, theoricServiceTime: number, instructions: Array<{ __typename?: 'TaskInstruction', _id: string, label: string, isDone: boolean, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }>, stateHistory: Array<{ __typename?: 'TaskStateHistory', state: TaskState, createdAt: number, createdByName?: string | null }>, site?: { __typename?: 'Site', _id: string, name: string, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string } } | null, totem?: { __typename?: 'Totem', _id: string, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null }> };

export type GetTourPlanningForDateQueryVariables = Exact<{
  birthdayDate: Scalars['String']['input'];
}>;


export type GetTourPlanningForDateQuery = { __typename?: 'Query', tourPlanningForDate: { __typename?: 'TourPlanning', tours: Array<{ __typename?: 'Tour', _id: string, name: string, color: string, deliveryPersonUserId?: string | null, state: TourState, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, deliveries: Array<{ __typename?: 'Delivery', _id: string, siteName?: string | null, organizationName?: string | null, isDynamic: boolean, state: DeliveryState, type: DeliveryType, deliveredMicrostoreColumnIds: Array<string>, orderIds: Array<string>, theoricServiceTime?: number | null, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState }>, deliveredMicrostoreColumns: Array<{ __typename?: 'Column', _id: string, microstoreColumn?: { __typename?: 'MicrostoreColumn', _id: string, type: MicrostoreColumnTemplateType } | null }>, orders: Array<{ __typename?: 'Order', _id: string, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }> }>, totem?: { __typename?: 'Totem', _id: string, name?: string | null, number: number, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null, site?: { __typename?: 'Site', _id: string, contractType: SiteContractType, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string } | null } | null, boxes: Array<{ __typename?: 'Box', _id: string, type: ProductFlow, departureScannedAt?: number | null, loadedAt?: number | null, setupScannedAt?: number | null, returnedAt?: number | null }> }>, stops: Array<{ __typename: 'Delivery', _id: string } | { __typename: 'Task', _id: string, type: TaskType, description: string, driversComment?: string | null, state: TaskState, siteId: string, theoricServiceTime: number, instructions: Array<{ __typename?: 'TaskInstruction', _id: string, label: string, isDone: boolean, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }>, stateHistory: Array<{ __typename?: 'TaskStateHistory', state: TaskState, createdAt: number, createdByName?: string | null }>, site?: { __typename?: 'Site', _id: string, name: string, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string } } | null, totem?: { __typename?: 'Totem', _id: string, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null }> }>, unassignedDeliveries: Array<{ __typename?: 'Delivery', _id: string, siteName?: string | null, organizationName?: string | null, isDynamic: boolean, state: DeliveryState, type: DeliveryType, deliveredMicrostoreColumnIds: Array<string>, orderIds: Array<string>, theoricServiceTime?: number | null, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState }>, deliveredMicrostoreColumns: Array<{ __typename?: 'Column', _id: string, microstoreColumn?: { __typename?: 'MicrostoreColumn', _id: string, type: MicrostoreColumnTemplateType } | null }>, orders: Array<{ __typename?: 'Order', _id: string, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }> }>, totem?: { __typename?: 'Totem', _id: string, name?: string | null, number: number, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null, site?: { __typename?: 'Site', _id: string, contractType: SiteContractType, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string } | null } | null, boxes: Array<{ __typename?: 'Box', _id: string, type: ProductFlow, departureScannedAt?: number | null, loadedAt?: number | null, setupScannedAt?: number | null, returnedAt?: number | null }> }>, unassignedTasks: Array<{ __typename?: 'Task', _id: string, type: TaskType, description: string, driversComment?: string | null, state: TaskState, siteId: string, theoricServiceTime: number, instructions: Array<{ __typename?: 'TaskInstruction', _id: string, label: string, isDone: boolean, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }>, stateHistory: Array<{ __typename?: 'TaskStateHistory', state: TaskState, createdAt: number, createdByName?: string | null }>, site?: { __typename?: 'Site', _id: string, name: string, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string } } | null, totem?: { __typename?: 'Totem', _id: string, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null }> } };

export type TourDetailsDeliveryFragmentFragment = { __typename?: 'Delivery', label: string, delay?: number | null, serviceTime?: number | null, driversComment?: string | null, _id: string, siteName?: string | null, organizationName?: string | null, isDynamic: boolean, state: DeliveryState, type: DeliveryType, deliveredMicrostoreColumnIds: Array<string>, orderIds: Array<string>, theoricServiceTime?: number | null, times: { __typename?: 'DeliveryTimes', actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', _id: string, deliveryId?: string | null, setupInstructionId?: string | null, photoIndex: number, type: string, url: string, createdAt: number }>, boxes: Array<{ __typename?: 'Box', number: number, deliveryCode: string, type: ProductFlow, containerType: ContainerType, _id: string, departureScannedAt?: number | null, loadedAt?: number | null, setupScannedAt?: number | null, returnedAt?: number | null, column?: { __typename?: 'Column', _id: string, name: string } | null, scanHistory: Array<{ __typename?: 'BoxScanHistory', state: BoxScanStep, createdByName?: string | null }> }>, deliveredMicrostoreColumns: Array<{ __typename?: 'Column', _id: string, microstoreColumn?: { __typename?: 'MicrostoreColumn', _id: string, type: MicrostoreColumnTemplateType } | null }>, orders: Array<{ __typename?: 'Order', _id: string, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }> }>, totem?: { __typename?: 'Totem', _id: string, name?: string | null, number: number, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null, site?: { __typename?: 'Site', _id: string, contractType: SiteContractType, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string } | null } | null };

export type GetTourQueryVariables = Exact<{
  tourId: Scalars['ID']['input'];
}>;


export type GetTourQuery = { __typename?: 'Query', tour: { __typename?: 'Tour', date: string, _id: string, name: string, color: string, deliveryPersonUserId?: string | null, state: TourState, stateHistory: Array<{ __typename?: 'TourStateHistory', state: TourState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, deliveries: Array<{ __typename?: 'Delivery', label: string, delay?: number | null, serviceTime?: number | null, driversComment?: string | null, _id: string, siteName?: string | null, organizationName?: string | null, isDynamic: boolean, state: DeliveryState, type: DeliveryType, deliveredMicrostoreColumnIds: Array<string>, orderIds: Array<string>, theoricServiceTime?: number | null, times: { __typename?: 'DeliveryTimes', actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', _id: string, deliveryId?: string | null, setupInstructionId?: string | null, photoIndex: number, type: string, url: string, createdAt: number }>, boxes: Array<{ __typename?: 'Box', number: number, deliveryCode: string, type: ProductFlow, containerType: ContainerType, _id: string, departureScannedAt?: number | null, loadedAt?: number | null, setupScannedAt?: number | null, returnedAt?: number | null, column?: { __typename?: 'Column', _id: string, name: string } | null, scanHistory: Array<{ __typename?: 'BoxScanHistory', state: BoxScanStep, createdByName?: string | null }> }>, deliveredMicrostoreColumns: Array<{ __typename?: 'Column', _id: string, microstoreColumn?: { __typename?: 'MicrostoreColumn', _id: string, type: MicrostoreColumnTemplateType } | null }>, orders: Array<{ __typename?: 'Order', _id: string, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }> }>, totem?: { __typename?: 'Totem', _id: string, name?: string | null, number: number, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null, site?: { __typename?: 'Site', _id: string, contractType: SiteContractType, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string } | null } | null }>, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, stops: Array<{ __typename: 'Delivery', _id: string } | { __typename: 'Task', _id: string, type: TaskType, description: string, driversComment?: string | null, state: TaskState, siteId: string, theoricServiceTime: number, instructions: Array<{ __typename?: 'TaskInstruction', _id: string, label: string, isDone: boolean, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }>, stateHistory: Array<{ __typename?: 'TaskStateHistory', state: TaskState, createdAt: number, createdByName?: string | null }>, site?: { __typename?: 'Site', _id: string, name: string, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string } } | null, totem?: { __typename?: 'Totem', _id: string, address?: string | null, zipcode?: string | null, latitude?: number | null, longitude?: number | null } | null }> } };

export type GetTasksWithPhotosQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetTasksWithPhotosQuery = { __typename?: 'Query', tasks: Array<{ __typename?: 'Task', _id: string, type: TaskType, date: string, site?: { __typename?: 'Site', _id: string, name: string, organizationName: string } | null, instructions: Array<{ __typename?: 'TaskInstruction', _id: string, label: string, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }> }> };

export type GetTransactionsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<TransactionsFilterInput>;
}>;


export type GetTransactionsQuery = { __typename?: 'Query', transactions: { __typename?: 'PaginatedTransactions', hasMore: boolean, transactions: Array<{ __typename?: 'Transaction', _id: string, basketId?: string | null, nuBasketId?: string | null, createdAt: number, priceHT: number, productName: string, siteId: string, siteName: string, microstoreColumnId?: string | null, microstoreColumnName: string, newState: TransactionState, tva: number, userFullName: string, nuBasket?: { __typename?: 'NuBasket', type: NuBasketType } | null, paymentMethods?: Array<{ __typename?: 'TransactionPaymentMethod', provider?: string | null }> | null }> } };

export type GetTransactionQueryVariables = Exact<{
  transactionId: Scalars['ID']['input'];
}>;


export type GetTransactionQuery = { __typename?: 'Query', transaction: { __typename?: 'Transaction', _id: string, basketId?: string | null, nuBasketId?: string | null, createdAt: number, priceHT: number, productId: string, productName: string, refundReason?: string | null, siteId: string, siteName: string, microstoreColumnId?: string | null, microstoreColumnName: string, newState: TransactionState, tva: number, userId: string, userFullName: string, nayaxMDBCode?: number | null, nuBasket?: { __typename?: 'NuBasket', type: NuBasketType } | null, paymentMethods?: Array<{ __typename?: 'TransactionPaymentMethod', amountUsed: number, explanation?: string | null, name?: string | null, paymentMethodName: PaymentMethodName, provider?: string | null, providerTransactionId?: string | null, status: PaymentIntentState, type?: PaymentMethodPaymentType | null }> | null, mealPlan?: { __typename?: 'MealPlan', discountRatio: number } | null, stateHistory: Array<{ __typename?: 'TransactionStateHistory', state: TransactionState, createdAt: number, createdBy: string }> } };

export type GetAllTrayCapacitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTrayCapacitiesQuery = { __typename?: 'Query', allTrayCapacities: Array<{ __typename?: 'TrayCapacity', _id: string, microstoreColumnId: string, microstoreColumn: { __typename?: 'MicrostoreColumn', _id: string, name: string, siteId: string, siteName: string, microstoreColumnTemplateName: string }, locations: Array<{ __typename?: 'TrayCapacityLocation', microstoreLocationId: string, productId: string, currentLevel: number, unitPerPackage: number, product: { __typename?: 'Product', _id: string, name: string, fullname: string }, microstoreLocation: { __typename?: 'MicrostoreLocation', microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', trayMaxCapacity: number } } }> }> };

export type GetTrayCapacityByColumnQueryVariables = Exact<{
  microstoreColumnId: Scalars['String']['input'];
}>;


export type GetTrayCapacityByColumnQuery = { __typename?: 'Query', trayCapacityByMicrostoreColumnId?: { __typename?: 'TrayCapacity', _id: string, microstoreColumnId: string, locations: Array<{ __typename?: 'TrayCapacityLocation', microstoreLocationId: string, productId: string, currentLevel: number, unitPerPackage: number, microstoreLocation: { __typename?: 'MicrostoreLocation', microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', trayMaxCapacity: number } }, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null } }> } | null };

export type GetUrbantzRoundPresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUrbantzRoundPresetsQuery = { __typename?: 'Query', getUrbantzRoundPresets: Array<{ __typename?: 'UrbantzRoundPreset', _id: string, createdAt: number, dayIndex: number, totemIds: Array<string>, updatedAt: number }> };

export type GetToteamMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetToteamMessagesQuery = { __typename?: 'Query', toteamMessages: Array<{ __typename?: 'ToteamMessage', message: string, userFullName: string }> };

export type GetToteamUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetToteamUsersQuery = { __typename?: 'Query', toteamUsers: Array<{ __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } }> };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', userFromAdmin?: { __typename?: 'User', _id: string, username: string, createdAt: number, lastSeenAt?: number | null, userGroupIds: Array<string>, stripeCustomerId?: string | null, defaultTruckColumnId?: string | null, emails: Array<{ __typename?: 'UserEmail', address: string, verified: boolean, bounced?: { __typename?: 'BouncedType', createdAt: number, reason: string } | null }>, getLastTransactions: Array<{ __typename?: 'Transaction', _id: string, basketId?: string | null, nuBasketId?: string | null, createdAt: number, priceHT: number, productName: string, siteId: string, siteName: string, microstoreColumnId?: string | null, microstoreColumnName: string, newState: TransactionState, tva: number, userFullName: string, nuBasket?: { __typename?: 'NuBasket', type: NuBasketType } | null, paymentMethods?: Array<{ __typename?: 'TransactionPaymentMethod', provider?: string | null }> | null }>, notificationPreferences: { __typename?: 'NotificationPreferences', customRitualActivity: Array<NotificationPreferenceChannel>, dailyDelivery: Array<NotificationPreferenceChannel>, feedbacks: Array<NotificationPreferenceChannel>, newFeatures: Array<NotificationPreferenceChannel>, recommendations: Array<NotificationPreferenceChannel>, reminders: Array<NotificationPreferenceChannel>, ritualInvite: Array<NotificationPreferenceChannel>, siteActivity: Array<NotificationPreferenceChannel>, specialOffers: Array<NotificationPreferenceChannel>, startingRitual: Array<NotificationPreferenceChannel>, weeklySummary: Array<NotificationPreferenceChannel> }, organization?: { __typename?: 'Organization', _id: string, name: string } | null, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, fullname?: string | null, state: UserState, phone?: string | null, imageUrl?: string | null }, permissions: Array<{ __typename?: 'UserPermissions', totemId?: string | null, userGroup: UserPermission, totem?: { __typename?: 'Totem', fullname: string } | null }>, visitedSites?: Array<{ __typename?: 'VisitedSite', _id: string, name: string, createdAt: number, visitedAt: number }> | null, defaultTruckColumn?: { __typename?: 'MicrostoreColumn', _id: string, name: string, siteId: string, siteName: string } | null, wallet: { __typename?: 'Wallet', credits: Array<{ __typename?: 'Credit', _id: string, createdAt: number, updatedAt: number, name: string, initialAmount: number, currentAmount: number, expirationDate: number, startDate: number, type: CreditType, refundedAt?: number | null, createdBy?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null, organizationBatched?: { __typename?: 'Organization', name: string } | null, owner?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', fullname?: string | null } } | null }>, subventions: Array<{ __typename?: 'Subvention', _id: string, name: string, description: string, categories: Array<string>, cumulative?: boolean | null, currentAmount?: number | null, remainingAmount?: number | null, hoursIntervalsAvailable: Array<Array<string>>, imageUrl?: string | null, reload?: SubventionReloadPeriod | null, organization?: { __typename?: 'Organization', _id: string, name: string } | null }>, organizationCard?: { __typename?: 'OrganizationCard', _id: string, state: OrganizationCardState } | null, creditCards: Array<{ __typename?: 'CreditCard', _id: string, default: boolean, expired?: boolean | null, paymentType: string, provider: CreditCardProvider, retries: number, details: { __typename?: 'CreditCardDetails', number?: string | null, expiration?: string | null, bank?: string | null, country?: string | null, expYear?: string | null, expMonth?: string | null } }>, mealVouchers: Array<{ __typename?: 'MealVoucher', _id: string, cardType: CardType, default: boolean, expired?: boolean | null, paymentType: string, provider: MealVoucherProvider, details: { __typename?: 'MealVoucherDetails', number?: string | null, username?: string | null, expiration?: string | null, bank?: string | null, country?: string | null } }> } } | null };

export type GetUsersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UsersFilterInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'PaginatedUsers', hasMore: boolean, users: Array<{ __typename?: 'User', _id: string, createdAt: number, lastSeenAt?: number | null, username: string, source: UserSource, lastSite?: { __typename?: 'Site', _id: string, name: string } | null, permissions: Array<{ __typename?: 'UserPermissions', userGroup: UserPermission }>, profile: { __typename?: 'UserProfile', fullname?: string | null, state: UserState, organizationId?: string | null, organizationName?: string | null }, organization?: { __typename?: 'Organization', _id: string, name: string } | null }> } };

export type GetOrganizationUsersQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetOrganizationUsersQuery = { __typename?: 'Query', organizationUsers: Array<{ __typename?: 'User', _id: string, createdAt: number, lastSeenAt?: number | null, username: string, source: UserSource, lastSite?: { __typename?: 'Site', _id: string, name: string } | null, permissions: Array<{ __typename?: 'UserPermissions', userGroup: UserPermission, totemId?: string | null }>, profile: { __typename?: 'UserProfile', fullname?: string | null, state: UserState } }> };

export type GetDeliveryPeopleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDeliveryPeopleQuery = { __typename?: 'Query', getDeliveryPeople: Array<{ __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null } }> };

export type GetUsersByGroupsQueryVariables = Exact<{
  userGroups: Array<UserPermission> | UserPermission;
}>;


export type GetUsersByGroupsQuery = { __typename?: 'Query', usersByGroups: Array<{ __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null } }> };

export type GetTestSenseiGateTokenQueryVariables = Exact<{
  senseiUserId: Scalars['ID']['input'];
  isStaff: Scalars['Boolean']['input'];
}>;


export type GetTestSenseiGateTokenQuery = { __typename?: 'Query', testSenseiGateToken: string };

export type GetWarehouseDeliveriesQueryVariables = Exact<{
  searchDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWarehouseDeliveriesQuery = { __typename?: 'Query', warehouseDeliveries: Array<{ __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> }> };

export type GetWarehouseDeliveryQueryVariables = Exact<{
  warehouseDeliveryId: Scalars['String']['input'];
}>;


export type GetWarehouseDeliveryQuery = { __typename?: 'Query', warehouseDelivery: { __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } };

export type GetWarehouseReturnForDateQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWarehouseReturnForDateQuery = { __typename?: 'Query', getWarehouseReturnsForDate: Array<{ __typename?: 'WarehouseReturn', _id: string, createdAt: number, date: string, originColumnId: string, warehouseColumnId: string, state: WarehouseReturnState, updatedAt: number, brokenProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, expiredProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, originColumn: { __typename?: 'Column', name: string }, warehouseColumn: { __typename?: 'Column', name: string }, returnedProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, returnedWithNoStockUpdateProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, stateHistory: Array<{ __typename?: 'WarehouseReturnStateHistory', createdAt: number, state: WarehouseReturnState }> }> };

export type GetWarehouseReturnQueryVariables = Exact<{
  warehouseReturnId: Scalars['ID']['input'];
}>;


export type GetWarehouseReturnQuery = { __typename?: 'Query', getWarehouseReturn: { __typename?: 'WarehouseReturn', _id: string, createdAt: number, date: string, originColumnId: string, warehouseColumnId: string, state: WarehouseReturnState, updatedAt: number, brokenProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, expiredProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, originColumn: { __typename?: 'Column', name: string }, warehouseColumn: { __typename?: 'Column', name: string }, returnedProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, returnedWithNoStockUpdateProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, stateHistory: Array<{ __typename?: 'WarehouseReturnStateHistory', createdAt: number, state: WarehouseReturnState }> } };

export type AuditLogCreatedSubscriptionVariables = Exact<{
  collectionDocumentId: Scalars['String']['input'];
}>;


export type AuditLogCreatedSubscription = { __typename?: 'Subscription', auditLogCreated: { __typename?: 'AuditLog', _id: string, createdAt: number, updatedAt: number, createdBy: string, createdByName: string, collectionName: string, collectionDocumentId: string, patches: Array<{ __typename?: 'AddPatch', op: PatchOp, path: string, value?: any | null } | { __typename?: 'CopyPatch', op: PatchOp, path: string, from: string } | { __typename?: 'MovePatch', op: PatchOp, path: string, from: string } | { __typename?: 'RemovePatch', op: PatchOp, path: string, oldValue?: any | null } | { __typename?: 'ReplacePatch', op: PatchOp, path: string, value?: any | null, oldValue?: any | null } | { __typename?: 'TestPatch', op: PatchOp, path: string, value?: any | null }> } };

export type BundleUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type BundleUpdatedSubscription = { __typename?: 'Subscription', bundleUpdated: { __typename?: 'Bundle', _id: string, createdAt: number, scheduledPreparationDate: string, number: number, numberOfReferences: number, numberOfUnits: number, operatorName?: string | null, preparationDuration?: number | null, state: BundleState, type: ProductFlow, containerType: ContainerType, boxes: Array<{ __typename?: 'Box', _id: string, deliveryId: string, deliveryCode: string, siteName?: string | null, totemId?: string | null, hasOnsiteSetup: boolean, label: string, orderId?: string | null, position?: number | null, roundColor: string, roundName: string, code?: string | null, products: Array<{ __typename?: 'BoxProduct', _id: string, boxId?: string | null }>, column?: { __typename?: 'Column', fullname: string, name: string, type: ColumnType } | null }>, preparationDates: { __typename?: 'PreparationDates', start?: string | null, end?: string | null }, stateHistory: Array<{ __typename?: 'BundleStateHistory', state: BundleState, createdAt: number, createdByName?: string | null }>, warehouseColumn: { __typename?: 'Column', _id: string, name: string } } };

export type DeliveriesUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type DeliveriesUpdatedSubscription = { __typename?: 'Subscription', deliveriesUpdated: Array<{ __typename?: 'Delivery', _id: string, deliveryDate: number, isDynamic: boolean, deliveryPersonUserId?: string | null, label: string, organizationId?: string | null, organizationName?: string | null, roundColor?: string | null, roundName?: string | null, siteName?: string | null, siteId?: string | null, state: DeliveryState, updatedAt: number, deliveryPerson?: { __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', fullname?: string | null, firstname?: string | null, lastname?: string | null } } | null, orders: Array<{ __typename?: 'Order', number?: number | null }>, siteSetup?: { __typename?: 'SiteSetup', _id: string } | null, totem?: { __typename?: 'Totem', address?: string | null, number: number } | null }> };

export type DeliveryPlanningUpdatedSubscriptionVariables = Exact<{
  siteIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type DeliveryPlanningUpdatedSubscription = { __typename?: 'Subscription', deliveryPlanningUpdated: Array<{ __typename?: 'DeliveryPlanning', _id: string, siteId: string, date: string, isManual: boolean, isActive: boolean }> };

export type UpdatedProductSubscriptionVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type UpdatedProductSubscription = { __typename?: 'Subscription', updatedProduct: { __typename?: 'Product', _id: string, description?: string | null, flow: ProductFlow, indexDisplay?: number | null, isFreefood: boolean, isMicrostore: boolean, shouldBeHiddenInStore: boolean, isPunctual: boolean, isFromNayax?: boolean | null, isWithoutStock: boolean, nbRatings: number, rating: number, scan: boolean, searchKeywords?: Array<string> | null, zeroWasteProductTemplateId?: string | null, height?: number | null, isDoubleCoil: boolean, length?: number | null, toleranceMin: number, toleranceMax: number, weight?: number | null, weightWithoutPackaging?: number | null, width?: number | null, externalProductId?: string | null, nayaxProductId?: string | null, odooProductId?: string | null, brand: string, createdAt: number, imageUrl?: string | null, name: string, fullname: string, packagingImageUrl?: string | null, state: ProductState, updatedAt: number, volume: string, ingredients?: string | null, nutriscore?: string | null, conditionningTotem: number, displayKg: boolean, isScannable: boolean, isTitreRestaurantAllowed: boolean, onboardedForSensei: boolean, portion: number, proportion?: number | null, proportionMax?: number | null, tva: number, access: Array<string>, isBeingTested: boolean, isPaused: boolean, isToBeArchived: boolean, newUntil?: string | null, useInMenusFrom?: string | null, allowNegativeStock: boolean, canExpire: boolean, checkSwollenLid: boolean, hasShortExpiryDate: boolean, minSupplierExpiryDays?: number | null, stockThreshold?: number | null, stockThresholdMinimum?: number | null, minSupplierOrderQuantity?: number | null, trackExpiryDate: boolean, tagIds: Array<string>, barcodes: Array<{ __typename?: 'Barcode', barcode: string, type: BarcodeType }>, category: { __typename?: 'Category', _id: string, title: string }, odooProduct?: { __typename?: 'OdooProduct', _id: string, externalOdooProductId: number, externalOdooProductVariantId: number, externalOdooZeroWasteProductVariantId?: number | null } | null, subcategory?: { __typename?: 'Subcategory', _id: string, name: string } | null, allergen: { __typename?: 'ProductAllergen', gluten: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, peanuts: boolean, soybeans: boolean, milk: boolean, nuts: boolean, celery: boolean, mustard: boolean, sesame: boolean, sulphites: boolean, lupin: boolean, molluscs: boolean, containsNoAllergens: boolean, canContain?: string | null }, nutrition: { __typename?: 'ProductNutrition', caloriesKCal?: number | null, totalFat?: number | null, sturatedFat?: number | null, carbohydrates?: number | null, sugars?: number | null, fibers?: number | null, protein?: number | null, sodium?: number | null }, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string, quantity: number, hotDrinksIngredientUnit: HotDrinksIngredientUnit, product: { __typename?: 'Product', _id: string, name: string, fullname: string, imageUrl?: string | null, weightWithoutPackaging?: number | null } }> } | null, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null }, supplierShortageHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, suppliers: Array<{ __typename?: 'ProductSupplier', _id: string, name?: string | null, code?: string | null, prices: Array<{ __typename?: 'SupplierProductPrice', value: number, conditionning: number, packagesPerBatch: number }> }>, toBeArchivedHistory: Array<{ __typename?: 'StatusHistoryEntry', createdAt: number, endedAt?: number | null }>, stateHistory: Array<{ __typename?: 'ProductStateHistory', state: ProductState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, deliveryDays: { __typename?: 'ProductDeliveryDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean }, preferences: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, diets: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType, imageUrl: string }>, productArrangements: Array<{ __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> }> } };

export type UpdatedProductsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UpdatedProductsSubscription = { __typename?: 'Subscription', updatedProducts: Array<{ __typename?: 'Product', _id: string, access: Array<string>, brand: string, externalProductId?: string | null, isBeingTested: boolean, imageUrl?: string | null, isDoubleCoil: boolean, isOutOfStock: boolean, isPaused: boolean, isToBeArchived: boolean, isWithoutStock: boolean, isMicrostore: boolean, name: string, fullname: string, newUntil?: string | null, state: ProductState, flow: ProductFlow, updatedAt: number, volume: string, height?: number | null, length?: number | null, width?: number | null, weight?: number | null, category: { __typename?: 'Category', title: string }, subcategory?: { __typename?: 'Subcategory', name: string } | null, suppliers: Array<{ __typename?: 'ProductSupplier', name?: string | null, prices: Array<{ __typename?: 'SupplierProductPrice', value: number, conditionning: number }> }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean }, tags: Array<{ __typename?: 'Tag', name: string }> }> };

export type ProductStockUpdatedSubscriptionVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ProductStockUpdatedSubscription = { __typename?: 'Subscription', productStockUpdated: { __typename?: 'Product', _id: string, stock: number } };

export type SitesUpdatedSubscriptionVariables = Exact<{
  siteId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SitesUpdatedSubscription = { __typename?: 'Subscription', siteUpdated: { __typename?: 'Site', _id: string, accessTime: number, unknownShrinkageBillingThreshold?: number | null, removalDate?: string | null, createdAt: number, deliveryDays: Array<boolean>, freshReassortDays: Array<boolean>, dryReassortDays: Array<boolean>, deliveryType: SiteDeliveryType, contractType: SiteContractType, estimatedUserCount: number, hasExternalSetupProcess: boolean, isOpenOnWeekend: boolean, isSecured: boolean, hasSensei: boolean, hasCoffee: boolean, launchDate?: string | null, name: string, organizationId: string, organizationName: string, shouldOperateOnTotops: boolean, shouldAutomaticallyCreateTargetReassortment: boolean, shouldAutomaticallyCreateManualReassortment: boolean, shouldAutomaticallyFinishSiteSetup: boolean, shouldHaveTheftNotice: boolean, shouldModulateForExpired: boolean, shouldModulateForUnknownLosses: boolean, state: SiteState, totemNumber: number, type: SiteType, unwantedProductIds: Array<string>, updatedAt: number, useNayaxCard: boolean, B2CPriceRange?: string | null, wantedProductIds: Array<string>, avaSiteId?: number | null, avaClientId?: number | null, deliveryZoneId?: string | null, closingDatesRanges: Array<{ __typename?: 'SiteClosingDatesRange', start: string, end: string }>, deliveryTimeWindow: { __typename?: 'SiteDeliveryTimeWindow', start: string, stop: string }, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargetRatios: { __typename?: 'ReassortmentStockTargetRatios', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, stateHistory: Array<{ __typename?: 'SiteStateHistory', createdAt: number, createdBy: string, createdByName?: string | null, state: SiteState }>, urbantzMetadata: { __typename?: 'UrbantzStoreMetadata', needsInventoryBoissons: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventorySnack: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsInventoryNonAlimentaire: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsCleaningMachineNECTA: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsSmallExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, replaceCompleteInventoryByZeroInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }>, needsPunctualExpiryDateInventory: Array<{ __typename?: 'EvenOddWeekMetadata', evenWeek: boolean, oddWeek: boolean }> }, deliveryZone?: { __typename?: 'DeliveryZone', _id: string, name: string, color: string } | null } };

export type SiteSetupCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SiteSetupCreatedSubscription = { __typename?: 'Subscription', siteSetupCreated: { __typename?: 'SiteSetup', _id: string, createdAt: number, date: string, deliveryId: string, isFinishForced: boolean, siteId: string, state: SiteSetupState, updatedAt: number, delivery?: { __typename?: 'Delivery', isDynamic: boolean } | null, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> } | null, issues: { __typename?: 'SiteSetupIssues', productsIssues: Array<{ __typename?: 'SetupProductIssues', comment: string, productId: string, brokenDuringDeliveryQuantity: number, brokenOnSiteAfterInventoryQuantity: number, brokenOnSiteBeforeInventoryQuantity: number, expiredDeliveredQuantity: number, expiredOnSiteAfterInventoryQuantity: number, expiredOnSiteBeforeInventoryQuantity: number, notEnoughPlaceQuantity: number, otherBeforeInventoryQuantity: number, otherAfterInventoryOrDuringDeliveryQuantity: number, unexpectedOnSiteQuantity: number, wrongQuantityDelivered: number }> }, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', _id: string, isFinishForced: boolean, isNeeded: boolean, microstoreColumnGroupId: string, positionInSiteSetup: number, siteSetupId: string, state: MicrostoreColumnGroupSetupState, updatedAt: number, instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> }>, stateHistory: Array<{ __typename?: 'MicrostoreColumnGroupSetupStateHistory', createdAt: number, state: MicrostoreColumnGroupSetupState }> }>, odooTickets: Array<{ __typename?: 'OdooTicket', _id: string, odooTicketId: number, microstoreColumnId: string, serviceType: OdooServiceType, ticketType: string, state: OdooTicketState, description: string, actions: Array<{ __typename?: 'OdooTicketAction', actionType: OdooTicketActionType, message: string, photoUrl?: string | null, createdAt: number }>, microstoreColumn: { __typename?: 'MicrostoreColumn', name: string } }>, site: { __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, earliestDLCDateToKeepForStockCalculation?: string | null, isOpenOnWeekend: boolean, isSecured: boolean, name: string, type: SiteType, state: SiteState, organizationName: string, nextDeliveryDate?: string | null, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }> }, stateHistory: Array<{ __typename?: 'SiteSetupStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: SiteSetupState }> } };

export type SiteSetupUpdatedSubscriptionVariables = Exact<{
  siteSetupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SiteSetupUpdatedSubscription = { __typename?: 'Subscription', siteSetupUpdated: { __typename?: 'SiteSetup', _id: string, createdAt: number, date: string, deliveryId: string, isFinishForced: boolean, siteId: string, state: SiteSetupState, updatedAt: number, delivery?: { __typename?: 'Delivery', isDynamic: boolean } | null, deliveryPerson?: { __typename?: 'User', _id: string, fullname: string } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', _id: string, createdAt: number, isNeeded: boolean, state: FreefoodSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }> } | null, issues: { __typename?: 'SiteSetupIssues', productsIssues: Array<{ __typename?: 'SetupProductIssues', comment: string, productId: string, brokenDuringDeliveryQuantity: number, brokenOnSiteAfterInventoryQuantity: number, brokenOnSiteBeforeInventoryQuantity: number, expiredDeliveredQuantity: number, expiredOnSiteAfterInventoryQuantity: number, expiredOnSiteBeforeInventoryQuantity: number, notEnoughPlaceQuantity: number, otherBeforeInventoryQuantity: number, otherAfterInventoryOrDuringDeliveryQuantity: number, unexpectedOnSiteQuantity: number, wrongQuantityDelivered: number }> }, microstoreColumnGroupSetups: Array<{ __typename?: 'MicrostoreColumnGroupSetup', _id: string, isFinishForced: boolean, isNeeded: boolean, microstoreColumnGroupId: string, positionInSiteSetup: number, siteSetupId: string, state: MicrostoreColumnGroupSetupState, updatedAt: number, instructionsAfterColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, instructionsBeforeColumns: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreColumnSetups: Array<{ __typename?: 'MicrostoreColumnSetup', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, microstoreColumnId: string, microstoreColumnInventoryId: string, microstoreColumnGroupSetupId: string, positionInColumnGroupSetup: number, postSiteSetupZeroInventoryProductIds?: Array<string> | null, state: MicrostoreColumnSetupState, updatedAt: number, instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, thermometerNumber?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'CheckTemperatureInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, noTemperatureComment?: string | null, state: SetupInstructionState, temperature?: number | null, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'HotDrinksInstruction', createdAt: number, hasCleanedCollectingTray: boolean, hasCleanedMachine: boolean, hasReplenishedConsumables: boolean, hasReplenishedTanks: boolean, hasRemovedCoffeeGround: boolean, hasRinsedMachine: boolean, isMachineWorking: boolean, isFinishForced: boolean, isNeeded: boolean, needsCleaningMachine: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, locations: Array<{ __typename?: 'HotDrinksLocation', productId: string, microstoreLocationId: string, initialTrayLevel: number, targetTrayLevel: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'InventoryInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'ManualReassortInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, entries: Array<{ __typename?: 'ManualReassortEntry', _id: string, productId: string, quantity: number, truckColumnId: string, columnId: string, createdAt: number }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MicrowaveInstruction', createdAt: number, hasCleanedMicrowaves: boolean, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'MoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'PhotosInstruction', _id: string, createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, photos: Array<{ __typename?: 'SetupPhoto', isMandatory: boolean, type: SetupPhotoType, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'RemoveProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, removedProducts: Array<{ __typename?: 'SetupRemovedProduct', microstoreLocationIds: Array<string>, productId: string, quantityDetails: Array<{ __typename?: 'RemovedProductQuantityDetail', expiryDate?: string | null, quantity: number }> }>, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'StoreProductsInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> } | { __typename?: 'TheftNoticeInstruction', createdAt: number, isFinishForced: boolean, isNeeded: boolean, needMoreNotices: boolean, state: SetupInstructionState, type: SetupInstructionType, updatedAt: number, stateHistory: Array<{ __typename?: 'SetupInstructionStateHistory', createdAt: number, state: SetupInstructionState }> }>, microstoreLocations?: Array<{ __typename?: 'microstoreSetupLocation', microstoreLocationId: string, productId?: string | null, replacementProductId?: string | null, stockToAdd: number, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number }> }> | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnSetupStateHistory', createdAt: number, state: MicrostoreColumnSetupState }> }>, stateHistory: Array<{ __typename?: 'MicrostoreColumnGroupSetupStateHistory', createdAt: number, state: MicrostoreColumnGroupSetupState }> }>, odooTickets: Array<{ __typename?: 'OdooTicket', _id: string, odooTicketId: number, microstoreColumnId: string, serviceType: OdooServiceType, ticketType: string, state: OdooTicketState, description: string, actions: Array<{ __typename?: 'OdooTicketAction', actionType: OdooTicketActionType, message: string, photoUrl?: string | null, createdAt: number }>, microstoreColumn: { __typename?: 'MicrostoreColumn', name: string } }>, site: { __typename?: 'Site', _id: string, deliveryDays: Array<boolean>, earliestDLCDateToKeepForStockCalculation?: string | null, isOpenOnWeekend: boolean, isSecured: boolean, name: string, type: SiteType, state: SiteState, organizationName: string, nextDeliveryDate?: string | null, reassortmentFreshFacings: { __typename?: 'ReassortmentFreshFacingsByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, reassortmentOnboardingStockTargets: { __typename?: 'ReassortmentStockByCategories', dessert: number, main: number, smallBites: number, starter: number }, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number, siteId: string, avaSalePlaceLocationId?: number | null, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, createdAt: number, updatedAt: number, siteId: string, siteName: string, isSiteSecured: boolean, canBeSecured: boolean, columnGroupId: string, columnIdToReplace?: string | null, isPaused: boolean, shouldUpdateStockOnTransaction: boolean, shouldSendNayaxPrices: boolean, shouldIgnoreReassortThresholds: boolean, microstoreColumnTemplateId: string, name: string, state: MicrostoreElementState, positionInColumnGroup: number, columnGroupName: string, externalColumnId?: string | null, externalColumnType: ExternalColumnType, avaSalePlaceId?: number | null, startingDate?: string | null, removalDate?: string | null, microstoreColumnTemplateName: string, type: MicrostoreColumnTemplateType, useDynamicDelivery: boolean, machineCode?: string | null, stateHistory: Array<{ __typename?: 'MicrostoreColumnStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: MicrostoreElementState }>, externalColumnConfig?: { __typename?: 'ExternalColumnConfig', nayaxMDBIntervals: Array<{ __typename?: 'ExternalColumnConfigNayaxMDBInterval', min: number, max: number }> } | null, columnGroup: { __typename?: 'MicrostoreColumnGroup', _id: string, name: string, columns: Array<{ __typename?: 'MicrostoreColumn', _id: string, name: string, positionInColumnGroup: number }>, site: { __typename?: 'Site', _id: string, name: string, microstoreColumnGroups: Array<{ __typename?: 'MicrostoreColumnGroup', _id: string, name: string, positionInSite: number }>, totem: { __typename?: 'Totem', _id: string, name?: string | null, number: number, sites: Array<{ __typename?: 'Site', _id: string, name: string }>, organization: { __typename?: 'Organization', _id: string, name: string } } } }, site: { __typename?: 'Site', organizationName: string, isSecured: boolean, nextDeliveryDate?: string | null, earliestDLCDateToKeepForStockCalculation?: string | null }, shelves: Array<{ __typename?: 'MicrostoreShelf', _id: string, positionInColumn: number, locationTable: Array<Array<{ __typename?: 'MicrostoreLocation', _id: string, locationTemplateId: string, productId?: string | null, replacementProductId?: string | null, nayaxMDBCode?: number | null, stockToAdd: number, targetStock?: number | null, expiryDates: Array<{ __typename?: 'MicrostoreLocationExpiryDate', expiryDate: string, quantity: number, shouldRemoveFromSite: boolean }>, microstoreLocationTemplate: { __typename?: 'MicrostoreLocationTemplate', _id: string, alternativeProductArrangementIds?: Array<string> | null, productId?: string | null, stockMax?: number | null, reassortmentType?: ProductArrangementReassortmentType | null, trayMaxCapacity: number, productArrangement?: { __typename?: 'ProductArrangement', _id: string, name: string, reassortmentType: ProductArrangementReassortmentType, defaultStockMax?: number | null, productIdsWithStockMax: Array<{ __typename?: 'ProductArrangementProductIdWithStockMax', productId: string, stockMax: number }> } | null, product?: { __typename?: 'Product', _id: string, brand: string, fullname: string, height?: number | null, imageUrl?: string | null, isDoubleCoil: boolean, isMicrostore: boolean, isToBeArchived: boolean, isWithoutStock: boolean, length?: number | null, name: string, state: ProductState, volume: string, weight?: number | null, width?: number | null } | null }, product?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, replacementProduct?: { __typename?: 'Product', _id: string, name: string, flow: ProductFlow, trackExpiryDate: boolean, isWithoutStock: boolean, isDoubleCoil: boolean, recipe?: { __typename?: 'ProductRecipe', ingredients: Array<{ __typename?: 'ProductRecipeIngredient', productId: string }> } | null } | null, positionInShelf: { __typename?: 'MicrostoreLocationPositionInShelf', column: number, row: number } }>> }> }> }> }, stateHistory: Array<{ __typename?: 'SiteSetupStateHistory', createdAt: number, createdBy?: string | null, createdByName?: string | null, state: SiteSetupState }> } };

export type StockTransfersUpdatedSubscriptionVariables = Exact<{
  stockTransferId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StockTransfersUpdatedSubscription = { __typename?: 'Subscription', stockTransferUpdated: { __typename?: 'StockTransfer', _id: string, createdAt: number, deliveryId?: string | null, destinationColumnId: string, numberOfRefs: number, originColumnId: string, quantityOfProducts: number, state: StockTransferState, transferDate: string, updatedAt: number, destinationColumn: { __typename?: 'Column', fullname: string }, originColumn: { __typename?: 'Column', fullname: string }, products: Array<{ __typename?: 'StockTransferProduct', productId: string, fullname: string, originStockAvailable: number, destinationStockAvailable: number, quantity: number }>, stateHistory: Array<{ __typename?: 'StockTransferStateHistory', state: StockTransferState, createdAt: number, createdBy: string }> } };

export type SupplierUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SupplierUpdatedSubscription = { __typename?: 'Subscription', supplierUpdated: { __typename?: 'Supplier', _id: string, nextOrderingDate?: string | null, name: string, description?: string | null, phone?: string | null, address?: string | null, zipcode?: string | null, website?: string | null, createdAt?: number | null, updatedAt?: number | null, shouldCheckReceptionDayIsNotClosed: boolean, shouldOrderAutomatically: boolean, state: SupplierState, paymentTimeType: PaymentTimeType, paymentTimeDays?: number | null, paymentType: SupplierPaymentType, orderMode: OrderMode, orderEmails: Array<string>, orderPlatformUrl?: string | null, clientCode?: string | null, frequency: number, closingDatesRanges: Array<{ __typename?: 'SupplierClosingDatesRange', closingDate: string, openingDate: string }>, stateHistory: Array<{ __typename?: 'SupplierStateHistory', state: SupplierState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, contacts: Array<{ __typename?: 'SupplierContact', name: string, surname: string, phone: string, email: string, description: string }>, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } } } };

export type SupplyOrdersUpdatedOrCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SupplyOrdersUpdatedOrCreatedSubscription = { __typename?: 'Subscription', supplyOrdersUpdatedOrCreated: Array<{ __typename?: 'SupplyOrder', _id: string, state: SupplyOrderState, createdAt: number, orderDate?: string | null, nextOrderDate?: string | null, dateDeliveryScheduled?: string | null, dateDelivery?: string | null, scheduledDeliveryDateValidity: boolean, number?: number | null, priceHT?: number | null, priceTTC?: number | null, weeklyMenusStartDate?: string | null, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, supplier: { __typename?: 'Supplier', _id: string, name: string, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> };

export type SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription = { __typename?: 'Subscription', supplyOrdersUpdatedOrCreated: Array<{ __typename?: 'SupplyOrder', _id: string, comment?: string | null, createdAt: number, dateDelivery?: string | null, dateDeliveryScheduled?: string | null, description?: string | null, hourDelivery?: string | null, issue?: boolean | null, justInTime?: boolean | null, number?: number | null, orderDate?: string | null, nextOrderDate?: string | null, scheduledDeliveryDateValidity: boolean, priceHT?: number | null, priceHTInvoice?: number | null, priceTTCInvoice?: number | null, soldOutRiskProductIds: Array<string>, spreadsheetId?: string | null, spreadsheetName?: string | null, state: SupplyOrderState, temperature?: number | null, totalQuantity?: number | null, totalQuantityReceived?: number | null, totalVolume: number, totalWeight: number, updatedAt: number, weeklyMenusStartDate?: string | null, issues: Array<{ __typename?: 'BadExpiryDateIssue', expiryDate: string, minSupplierExpiryDays: number, productId: string, quantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'BrokenQuantityIssue', brokenQuantity: number, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentPackagingIssue', expectedPackaging: number, productId: string, receivedPackaging: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'DifferentQuantityIssue', expectedQuantity: number, productId: string, receivedQuantity: number, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NewBarcodeIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'NotReceivedIssue', productId: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'UnknownProductIssue', barcode: string, description: string, type?: SupplyOrderProductIssueType | null } | { __typename?: 'WrongProductIssue', barcode: string, productId: string, type?: SupplyOrderProductIssueType | null }>, orderingTermsValidity: { __typename?: 'OrderingTermsValidity', isValid: boolean, deliveryPrice?: number | null }, scheduledDeliveryDateHistory: Array<{ __typename?: 'ScheduledDeliveryDateHistoryType', scheduledDeliveryDate: string, createdAt: number }>, products: Array<{ __typename?: 'SupplyOrderProduct', _id: string, brand: string, colis: number, confirmedQuantity?: number | null, conditionning: number, packagesPerBatch: number, isToBeArchived: boolean, name: string, fullname: string, price: number, quantity: number, quantityGenerated: number, quantityGeneratedExtended: number, quantityGeneratedForMenus: number, stock: number, storedAt?: number | null, supplyOrderId: string, availableStock: number, tva: number, unitPrice: number, volume: string, minSupplierOrderQuantity?: number | null, confirmedQuantityHistory: Array<{ __typename?: 'QuantityHistoryType', createdAt: number, quantity?: number | null }>, productReceivedDetails: Array<{ __typename?: 'SupplyOrderProductDetail', brokenItems: number, colis: number, conditionning: number, quantity: number, expiryDate?: string | null }>, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, stateHistory: Array<{ __typename?: 'SupplyOrderStateHistory', createdAt: number, state: SupplyOrderState, createdBy?: string | null, createdByName?: string | null }>, productsInfoWithStock: Array<{ __typename?: 'SupplierProductInfoWithStock', _id: string, availableStock: number, brand: string, conditionning: number, fullname: string, imageUrl?: string | null, isToBeArchived: boolean, name: string, packagesPerBatch: number, stock: number, tva: number, unitPrice: number, volume: string, supplierShortageInfo: { __typename?: 'ProductSupplierShortageInfo', inShortage: boolean, returnDate?: string | null } }>, supplier: { __typename?: 'Supplier', _id: string, clientCode?: string | null, frequency: number, nextOrderingDate?: string | null, name: string, orderMode: OrderMode, orderEmails: Array<string>, orderingTimes: { __typename?: 'SupplierOrderingTimes', monday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, tuesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, wednesday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, thursday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, friday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, saturday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } }, sunday: { __typename?: 'OrderingTimeForDay', orderBefore: string, daysToDeliver: number, canBeOrdered: boolean, deliveryHours: { __typename?: 'DeliveryHours', start: string, end: string } } }, orderingProductTerms: Array<{ __typename?: 'OrderingProductTerm', minQuantity: number, productId: string }>, orderingTerms: Array<{ __typename?: 'OrderingTerm', deliveryPrice?: number | null, minRequirements: Array<Array<{ __typename?: 'OrderingMinRequirement', unit?: OrderingRequirementUnit | null, value?: number | null }>> }> }, warehouseColumn: { __typename?: 'Column', _id: string, name: string } }> };

export type WarehouseDeliveryUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type WarehouseDeliveryUpdatedSubscription = { __typename?: 'Subscription', warehouseDeliveryUpdated: { __typename?: 'WarehouseDelivery', _id: string, createdAt: number, deliveryCode: string, deliveryDate: string, siteId: string, operatorName?: string | null, warehouseColumnId: string, state: DeliveryState, stockTransferId: string, updatedAt: number, label?: string | null, roundColor?: string | null, roundName?: string | null, serviceTime?: number | null, theoricServiceTime?: number | null, trackingUrl?: string | null, site: { __typename?: 'Site', name: string, organizationName: string }, warehouseColumn: { __typename?: 'Column', name: string }, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, products: Array<{ __typename?: 'WarehouseDeliveryProduct', conditionning: number, packagesPerBatch: number, location?: string | null, photoUrl: string, productId: string, productIndex: number, productLabel: string, packages: number, packagesPicked?: number | null, scan: boolean }>, times: { __typename?: 'DeliveryTimes', preferenceSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, actualSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } }, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, controlPhotos: Array<{ __typename?: 'ControlPhoto', deliveryId?: string | null, setupInstructionId?: string | null, taskInstructionId?: string | null, type: string, url: string, photoIndex: number, state: PhotoState, comment?: string | null, isMandatory: boolean, stateHistory: Array<{ __typename?: 'ControlPhotoStateHistory', state: PhotoState, createdAt: number, createdBy?: string | null, createdByName?: string | null }>, issueType: { __typename?: 'PhotoIssueType', isBadQuality: boolean, isBadQuantity: boolean }, microstoreColumn?: { __typename?: 'MicrostoreColumn', name: string } | null }> } };

export type WarehouseReturnCreatedOrUpdatedSubscriptionVariables = Exact<{
  warehouseReturnId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WarehouseReturnCreatedOrUpdatedSubscription = { __typename?: 'Subscription', warehouseReturnCreatedOrUpdated: { __typename?: 'WarehouseReturn', _id: string, createdAt: number, date: string, originColumnId: string, warehouseColumnId: string, state: WarehouseReturnState, updatedAt: number, brokenProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, expiredProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, originColumn: { __typename?: 'Column', name: string }, warehouseColumn: { __typename?: 'Column', name: string }, returnedProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, returnedWithNoStockUpdateProducts: Array<{ __typename?: 'WarehouseReturnProduct', productId: string, quantity: number, deliveredQuantity?: number | null, storedQuantity?: number | null }>, stateHistory: Array<{ __typename?: 'WarehouseReturnStateHistory', createdAt: number, state: WarehouseReturnState }> } };

export type SitePartialFragmentFragmentFragment = { __typename?: 'Site', name: string, state: SiteState };

export const AdvertisementScreenConfigFragmentFragmentDoc = gql`
    fragment AdvertisementScreenConfigFragment on AdvertisementScreenConfig {
  _id
  imageUrls
}
    `;
export const AddPatchFragmentFragmentDoc = gql`
    fragment AddPatchFragment on AddPatch {
  op
  path
  value
}
    `;
export const ReplacePatchFragmentFragmentDoc = gql`
    fragment ReplacePatchFragment on ReplacePatch {
  op
  path
  value
  oldValue
}
    `;
export const RemovePatchFragmentFragmentDoc = gql`
    fragment RemovePatchFragment on RemovePatch {
  op
  path
  oldValue
}
    `;
export const MovePatchFragmentFragmentDoc = gql`
    fragment MovePatchFragment on MovePatch {
  op
  path
  from
}
    `;
export const CopyPatchFragmentFragmentDoc = gql`
    fragment CopyPatchFragment on CopyPatch {
  op
  path
  from
}
    `;
export const TestPatchFragmentFragmentDoc = gql`
    fragment TestPatchFragment on TestPatch {
  op
  path
  value
}
    `;
export const AuditLogPatchFragmentFragmentDoc = gql`
    fragment AuditLogPatchFragment on AuditLogPatch {
  ... on AddPatch {
    ...AddPatchFragment
  }
  ... on ReplacePatch {
    ...ReplacePatchFragment
  }
  ... on RemovePatch {
    ...RemovePatchFragment
  }
  ... on MovePatch {
    ...MovePatchFragment
  }
  ... on CopyPatch {
    ...CopyPatchFragment
  }
  ... on TestPatch {
    ...TestPatchFragment
  }
}
    ${AddPatchFragmentFragmentDoc}
${ReplacePatchFragmentFragmentDoc}
${RemovePatchFragmentFragmentDoc}
${MovePatchFragmentFragmentDoc}
${CopyPatchFragmentFragmentDoc}
${TestPatchFragmentFragmentDoc}`;
export const AuditLogFragmentFragmentDoc = gql`
    fragment AuditLogFragment on AuditLog {
  _id
  createdAt
  updatedAt
  createdBy
  createdByName
  collectionName
  collectionDocumentId
  patches {
    ...AuditLogPatchFragment
  }
}
    ${AuditLogPatchFragmentFragmentDoc}`;
export const BundleFragmentFragmentDoc = gql`
    fragment BundleFragment on Bundle {
  _id
  boxes {
    _id
    deliveryId
    deliveryCode
    siteName
    totemId
    hasOnsiteSetup
    label
    orderId
    position
    roundColor
    roundName
    code
    products {
      _id
      boxId
    }
    column {
      fullname
      name
      type
    }
  }
  createdAt
  scheduledPreparationDate
  number
  numberOfReferences
  numberOfUnits
  operatorName
  preparationDates {
    start
    end
  }
  preparationDuration
  state
  stateHistory {
    state
    createdAt
    createdByName
  }
  type
  containerType
  warehouseColumn {
    _id
    name
  }
}
    `;
export const BoxFragmentFragmentDoc = gql`
    fragment BoxFragment on Box {
  _id
  bundleId
  state
  bundle {
    _id
    number
    state
    closingDate
  }
  label
  number
  code
  deliveryCode
  type
  containerType
  volumeTaken
  weightTaken
  createdAt
  columnId
  column {
    name
    fullname
    type
  }
  products {
    _id
    product {
      externalProductId
    }
    productLabel
    quantity
    quantityPicked
    photoUrl
    unit
    boxId
    unitVolume
    unitWeight
  }
}
    `;
export const BundleWithBoxesFragmentFragmentDoc = gql`
    fragment BundleWithBoxesFragment on Bundle {
  ...BundleFragment
  boxes {
    ...BoxFragment
  }
}
    ${BundleFragmentFragmentDoc}
${BoxFragmentFragmentDoc}`;
export const CategoryFragmentFragmentDoc = gql`
    fragment CategoryFragment on Category {
  _id
  createdAt
  updatedAt
  indexDisplay
  isFreefood
  isMicrostore
  isPunctual
  imageUrl
  shouldShowSubcategories
  state
  stateHistory {
    state
    createdAt
    createdBy
    createdByName
  }
  title
}
    `;
export const ColumnFragmentFragmentDoc = gql`
    fragment ColumnFragment on Column {
  _id
  name
  fullname
  siteId
  site {
    _id
    name
  }
  type
  state
  stockSummary {
    productsCount
    totalStock
    merchantValuation
  }
  createdAt
  updatedAt
}
    `;
export const ColumnProductFragmentDoc = gql`
    fragment ColumnProduct on ColumnProduct {
  productId
  product {
    _id
    fullname
    state
    flow
  }
  lastColumnInventoryStock {
    _id
    value
    createdAt
    createdBy
    createdByName
  }
  targetStock
  stock
  availableStock {
    isUnlimited
    value
    details {
      dailyStocks
      orderedStocks
      realRecurringOrders
      predictionRecurringOrders
      realPunctualOrders
      predictionPunctualOrders
      realStoreTargetNotPrepared
      realStoreTargetPrepared
      predictionStoreTarget
      storeMenu
      preparationDate
      preparationDateUsedIndex
      soonestRestockedDate
      soonestRestockedDateUsedIndex
      usedRecurringOrders
      usedPunctualOrders
      usedStoreTarget
      usedStoreMenu
    }
  }
  variations {
    _id
    createdAt
    delta
    type
    ref
    explanation
    columnInventoryStockId
  }
  inventories {
    _id
    createdAt
    createdBy
    createdByName
    type
    value
    previousColumnInventoryStockId
    modifierId
  }
}
    `;
export const ColumnProductLightFragmentDoc = gql`
    fragment ColumnProductLight on ColumnProduct {
  productId
  product {
    _id
    fullname
    state
    flow
  }
  lastColumnInventoryStock {
    _id
    value
    createdAt
  }
  targetStock
  stock
  merchantValuation
  availableStock {
    isUnlimited
    value
  }
  latestStockVariations {
    _id
    createdAt
    delta
    type
    ref
    explanation
    columnInventoryStockId
  }
}
    `;
export const CommentFragmentFragmentDoc = gql`
    fragment CommentFragment on Comment {
  _id
  body
  createdAt
  updatedAt
  user {
    _id
    label
  }
  product {
    _id
    name
  }
}
    `;
export const ConsumptionVariationFragmentFragmentDoc = gql`
    fragment ConsumptionVariationFragment on ConsumptionVariation {
  _id
  createdAt
  endDate
  siteId
  startDate
  updatedAt
  dessert {
    type
    value
  }
  main {
    type
    value
  }
  smallBites {
    type
    value
  }
  starter {
    type
    value
  }
}
    `;
export const DeliveryFragmentFragmentDoc = gql`
    fragment DeliveryFragment on Delivery {
  _id
  deliveryDate
  isDynamic
  deliveryPersonUserId
  deliveryPerson {
    _id
    username
    profile {
      fullname
      firstname
      lastname
    }
  }
  label
  orders {
    number
  }
  organizationId
  organizationName
  roundColor
  roundName
  siteName
  siteId
  siteSetup {
    _id
  }
  state
  totem {
    address
    number
  }
  updatedAt
}
    `;
export const DeliveryWithBoxesFragmentFragmentDoc = gql`
    fragment DeliveryWithBoxesFragment on Delivery {
  ...DeliveryFragment
  boxes {
    ...BoxFragment
  }
}
    ${DeliveryFragmentFragmentDoc}
${BoxFragmentFragmentDoc}`;
export const UpdateStateResultFragmentFragmentDoc = gql`
    fragment UpdateStateResultFragment on DeliveriesStateUpdateResult {
  updatedDeliveries {
    ...DeliveryFragment
    stateHistory {
      state
      createdAt
      createdByName
    }
    boxes {
      ...BoxFragment
    }
  }
  errors
}
    ${DeliveryFragmentFragmentDoc}
${BoxFragmentFragmentDoc}`;
export const ControlPhotoFragmentFragmentDoc = gql`
    fragment ControlPhotoFragment on ControlPhoto {
  deliveryId
  setupInstructionId
  taskInstructionId
  type
  url
  photoIndex
  state
  stateHistory {
    state
    createdAt
    createdBy
    createdByName
  }
  issueType {
    isBadQuality
    isBadQuantity
  }
  comment
  isMandatory
  microstoreColumn {
    name
  }
}
    `;
export const DeliveryPhotosFragmentFragmentDoc = gql`
    fragment DeliveryPhotosFragment on Delivery {
  _id
  photos {
    type
    urls
  }
  controlPhotos {
    ...ControlPhotoFragment
  }
}
    ${ControlPhotoFragmentFragmentDoc}`;
export const SiteDeliveryPlanningFragmentFragmentDoc = gql`
    fragment SiteDeliveryPlanningFragment on SiteDeliveryPlanning {
  site {
    _id
    name
    organizationName
    deliveryDays
    state
    shouldOperateOnTotops
    launchDate
    removalDate
    closingDatesRanges {
      start
      end
    }
    isSecured
    hasSensei
    deliveryType
  }
  deliveryPlanning {
    date
    isManual
    isActive
  }
}
    `;
export const DeliveryZoneFragmentFragmentDoc = gql`
    fragment DeliveryZoneFragment on DeliveryZone {
  _id
  name
  color
  state
  referentDelivererId
  referentDeliverer {
    _id
    username
    profile {
      fullname
    }
  }
  sitesCount
  createdAt
  updatedAt
}
    `;
export const EquipmentFragmentDoc = gql`
    fragment Equipment on Equipment {
  _id
  createdAt
  updatedAt
  name
  brand
  volume
  price
  imageUrl
  suppliers {
    _id
    name
  }
  description
  hidden
  height
  width
  length
  weight
  state
  stateHistory {
    createdAt
    createdBy
    state
  }
}
    `;
export const ExpiryDateRecordFragmentFragmentDoc = gql`
    fragment ExpiryDateRecordFragment on ExpiryDateRecord {
  _id
  createdAt
  expiryDate
  initialQuantity
  quantityAtInventory
  productId
  product {
    brand
    name
    volume
  }
  siteId
  state
  updatedAt
}
    `;
export const FutureStockVariationFragmentFragmentDoc = gql`
    fragment FutureStockVariationFragment on FutureStockVariation {
  _id
  createdAt
  delta
  columnId
  productId
  ref
  processInfo {
    boxInfo {
      boxId
      isPrepared
      stockVariationRef
    }
    supplyOrderStockVariationRef
  }
  issues {
    explanation
    type
  }
  state
  type
  updatedAt
  useDate
}
    `;
export const LocationPlanogramFragmentFragmentDoc = gql`
    fragment LocationPlanogramFragment on LocationPlanogram {
  _id
  createdAt
  locationId
  productId
  startDate
  updatedAt
}
    `;
export const ManualSupplyOrderFragmentFragmentDoc = gql`
    fragment ManualSupplyOrderFragment on SupplyOrder {
  _id
  supplier {
    name
  }
  orderDate
  orderingTermsValidity {
    isValid
    deliveryPrice
  }
  dateDeliveryScheduled
  dateDelivery
  priceHT
  priceTTC
  products {
    _id
    fullname
    quantity
  }
}
    `;
export const MenuInstructionFragmentFragmentDoc = gql`
    fragment MenuInstructionFragment on MenuInstruction {
  _id
  createdAt
  updatedAt
  date
  microstoreColumnId
  categoryId
  type
  value
}
    `;
export const SiteMenusFragmentFragmentDoc = gql`
    fragment SiteMenusFragment on SiteMenus {
  siteId
  columns {
    columnId
    dailyMenus {
      date
      productLocations {
        product {
          _id
          fullname
        }
        location {
          _id
        }
      }
    }
  }
}
    `;
export const MenuProductFragmentFragmentDoc = gql`
    fragment MenuProductFragment on MenuProduct {
  product {
    _id
    fullname
    imageUrl
    state
    isMicrostore
    isToBeArchived
    isWithoutStock
    supplier {
      _id
      name
    }
  }
  quantity
  nbLocations
  isInProductArrangement
}
    `;
export const MenuProductArrangementFragmentFragmentDoc = gql`
    fragment MenuProductArrangementFragment on MenuProductArrangement {
  productArrangementId
  productArrangementName
  productArrangementMainCategoryId
  productArrangementIndexes {
    productArrangementIndex
    rotations {
      rotationNumber
      products {
        ...MenuProductFragment
      }
    }
  }
}
    ${MenuProductFragmentFragmentDoc}`;
export const MessagesSetFragmentFragmentDoc = gql`
    fragment MessagesSetFragment on MessagesSet {
  _id
  createdAt
  name
  messages {
    body
    redirectUrl
  }
  state
  updatedAt
}
    `;
export const MicrostoreColumnFragmentFragmentDoc = gql`
    fragment MicrostoreColumnFragment on MicrostoreColumn {
  _id
  createdAt
  updatedAt
  columnGroupId
  columnIdToReplace
  isPaused
  microstoreColumnTemplateId
  microstoreColumnTemplateName
  name
  state
  positionInColumnGroup
  columnGroupName
  removalDate
  externalColumnId
  externalColumnType
  avaSalePlaceId
  startingDate
  type
  microstoreColumnType
  siteId
  siteName
  isRegular
}
    `;
export const MicrostoreColumnGroupFragmentFragmentDoc = gql`
    fragment MicrostoreColumnGroupFragment on MicrostoreColumnGroup {
  _id
  columns {
    ...MicrostoreColumnFragment
  }
  name
  positionInSite
  siteId
  avaSalePlaceLocationId
}
    ${MicrostoreColumnFragmentFragmentDoc}`;
export const MicrostoreColumnTemplateFragmentFragmentDoc = gql`
    fragment MicrostoreColumnTemplateFragment on MicrostoreColumnTemplate {
  _id
  name
  type
  state
}
    `;
export const ProductArrangementProductFragmentFragmentDoc = gql`
    fragment ProductArrangementProductFragment on Product {
  _id
  brand
  fullname
  height
  imageUrl
  isDoubleCoil
  isMicrostore
  isToBeArchived
  isWithoutStock
  length
  name
  state
  volume
  weight
  width
}
    `;
export const ProductArrangementWithProductsFragmentFragmentDoc = gql`
    fragment ProductArrangementWithProductsFragment on ProductArrangement {
  _id
  name
  productsWithStockMax {
    product {
      ...ProductArrangementProductFragment
    }
    stockMax
  }
  reassortmentType
}
    ${ProductArrangementProductFragmentFragmentDoc}`;
export const MicrostoreColumnTemplateWithAllInfoFragmentDoc = gql`
    fragment MicrostoreColumnTemplateWithAllInfo on MicrostoreColumnTemplate {
  _id
  name
  type
  state
  shelfTemplates {
    _id
    columnTemplateId
    locationTemplateTable {
      _id
      positionInShelf {
        column
        row
      }
      productArrangement {
        ...ProductArrangementWithProductsFragment
      }
      alternativeProductArrangementIds
      product {
        ...ProductArrangementProductFragment
      }
      stockMax
      reassortmentType
      shelfTemplateId
      shouldOrderProductIfNotInSite
      shouldSmoothProductTransition
      allowProductRotation
      trayMaxCapacity
    }
    positionInColumn
  }
}
    ${ProductArrangementWithProductsFragmentFragmentDoc}
${ProductArrangementProductFragmentFragmentDoc}`;
export const MobilePopupFragmentFragmentDoc = gql`
    fragment MobilePopupFragment on MobilePopup {
  _id
  startsAt
  endsAt
  imageUrl
  title
  body
  siteIds
  sites {
    _id
    name
  }
  createdAt
}
    `;
export const NuBasketFragmentFragmentDoc = gql`
    fragment NuBasketFragment on NuBasket {
  _id
  purchaseId
  fridgeId
  cardId
  createdAt
  updatedAt
  userId
  siteId
  type
}
    `;
export const FlowParameterFragmentFragmentDoc = gql`
    fragment FlowParameterFragment on FlowParameter {
  flow
  emptyWeightBox
  externalVolumeBox
  volumeBox
  weightBox
  bundleCapacity
}
    `;
export const DynamicDeliveryThresholdEntryFragmentFragmentDoc = gql`
    fragment DynamicDeliveryThresholdEntryFragment on DynamicDeliveryThresholdEntry {
  templateType
  contractType
  qualityPassPercent
  criticalPassPercent
  requiredPassPercent
  criticalGroupingPercent
  requiredGroupingPercent
  groupingRadiusKm
  maxDaysWithoutDelivery
}
    `;
export const OpsParameterFragmentFragmentDoc = gql`
    fragment OpsParameterFragment on OpsParameter {
  _id
  parameters {
    shouldAutoOrderMenuSupplyOrder
    shouldProcessFreshReassortment
    canUseKraftForStore
    canUseKraftForFreefood
    emptyWeightPaletteBox
    emptyWeightKraftBox
    externalVolumePaletteBox
    externalVolumeKraftBox
    volumePaletteBox
    volumeKraftBox
    weightPaletteBox
    weightKraftBox
    serviceTimePerBox
    dryReassortMinProductCount
    dryReassortMinReferenceCount
    dryReassortMaxEmptyFacings
    flowParameters {
      ...FlowParameterFragment
    }
    dynamicDelivery {
      capacity
      thresholds {
        ...DynamicDeliveryThresholdEntryFragment
      }
      estimatedTransactionCapacities {
        templateType
        estimatedTransactionCapacity
      }
    }
  }
  createdAt
  updatedAt
}
    ${FlowParameterFragmentFragmentDoc}
${DynamicDeliveryThresholdEntryFragmentFragmentDoc}`;
export const DetailedOrderFragmentFragmentDoc = gql`
    fragment DetailedOrderFragment on Order {
  _id
  appreciation
  badService
  delivery {
    _id
    stateHistory {
      state
    }
  }
  deliveryDate
  deliveryTimeWindows {
    start
    stop
  }
  productsWithQuantityPicked {
    _id
    name
    fullname
    quantity
    quantityPicked
    unitPrice
  }
  discount {
    amount
    description
    type
  }
  feedback
  frequency
  hasOnsiteSetup
  isPunctual
  number
  organization {
    _id
    hasSubscription
    name
    paymentType
  }
  pausedInfo {
    reason
    returnDate
  }
  invoicing {
    status
    odooInvoiceId
    odooInvoiceUrl
    paymentIntentId
    stripePaymentUrl
  }
  previous_orderId
  reference
  prices {
    discount
    discount055
    discount10
    discount20
    price
    price055
    price10
    price20
    priceDelivery
    priceHT
    priceHT055
    priceHT10
    priceHT20
    priceTTC
    priceTTC055
    priceTTC10
    priceTTC20
    tva
    tva055
    tva10
    tva20
  }
  productsRequestedButNotFullyDelivered {
    _id
    name
    fullname
    unitPrice
    quantityRequested
  }
  state
  stateHistory {
    state
    createdAt
    createdBy
    createdByName
  }
  totem {
    _id
    name
    number
  }
  user {
    _id
    profile {
      firstname
      lastname
    }
  }
  weekday
}
    `;
export const PollFragmentFragmentDoc = gql`
    fragment PollFragment on Poll {
  _id
  answerOptions
  answersRepartition
  audience {
    organizationIds
    siteIds
    userIds
  }
  createdAt
  dateWindow {
    startDate
    endDate
  }
  imageUrl
  numberOfParticipants
  question
  sectionTitle
  title
}
    `;
export const FormErrorFragmentFragmentDoc = gql`
    fragment FormErrorFragment on FormError {
  sectionName
  sectionErrors {
    fieldName
    fieldError
  }
}
    `;
export const AdditionalProductInfoFragmentFragmentDoc = gql`
    fragment AdditionalProductInfoFragment on Product {
  description
  flow
  indexDisplay
  isFreefood
  isMicrostore
  shouldBeHiddenInStore
  isPunctual
  isFromNayax
  isWithoutStock
  nbRatings
  rating
  scan
  searchKeywords
  zeroWasteProductTemplateId
}
    `;
export const DimensionsProductInfoFragmentFragmentDoc = gql`
    fragment DimensionsProductInfoFragment on Product {
  height
  isDoubleCoil
  length
  toleranceMin
  toleranceMax
  weight
  weightWithoutPackaging
  width
}
    `;
export const GeneralProductInfoFragmentFragmentDoc = gql`
    fragment GeneralProductInfoFragment on Product {
  externalProductId
  nayaxProductId
  odooProductId
  barcodes {
    barcode
    type
  }
  brand
  category {
    _id
    title
  }
  createdAt
  odooProduct {
    _id
    externalOdooProductId
    externalOdooProductVariantId
    externalOdooZeroWasteProductVariantId
  }
  imageUrl
  name
  fullname
  packagingImageUrl
  state
  subcategory {
    _id
    name
  }
  updatedAt
  volume
}
    `;
export const NutritionProductInfoFragmentFragmentDoc = gql`
    fragment NutritionProductInfoFragment on Product {
  allergen {
    gluten
    crustaceans
    eggs
    fish
    peanuts
    soybeans
    milk
    nuts
    celery
    mustard
    sesame
    sulphites
    lupin
    molluscs
    containsNoAllergens
    canContain
  }
  ingredients
  nutriscore
  nutrition {
    caloriesKCal
    totalFat
    sturatedFat
    carbohydrates
    sugars
    fibers
    protein
    sodium
  }
}
    `;
export const SalesProductInfoFragmentFragmentDoc = gql`
    fragment SalesProductInfoFragment on Product {
  conditionningTotem
  displayKg
  recipe {
    ingredients {
      productId
      quantity
      hotDrinksIngredientUnit
      product {
        _id
        name
        fullname
        imageUrl
        weightWithoutPackaging
      }
    }
  }
  isScannable
  isTitreRestaurantAllowed
  onboardedForSensei
  portion
  proportion
  proportionMax
  supplierShortageInfo {
    inShortage
    returnDate
  }
  supplierShortageHistory {
    createdAt
    endedAt
  }
  suppliers {
    _id
    name
    code
    prices {
      value
      conditionning
      packagesPerBatch
    }
  }
  tva
}
    `;
export const StateHistoryProductInfoFragmentFragmentDoc = gql`
    fragment StateHistoryProductInfoFragment on Product {
  access
  isBeingTested
  isPaused
  isToBeArchived
  toBeArchivedHistory {
    createdAt
    endedAt
  }
  newUntil
  state
  stateHistory {
    state
    createdAt
    createdBy
    createdByName
  }
  useInMenusFrom
}
    `;
export const StockAndSupplierProductInfoFragmentFragmentDoc = gql`
    fragment StockAndSupplierProductInfoFragment on Product {
  allowNegativeStock
  canExpire
  checkSwollenLid
  deliveryDays {
    monday
    tuesday
    wednesday
    thursday
    friday
    saturday
  }
  hasShortExpiryDate
  minSupplierExpiryDays
  stockThreshold
  stockThresholdMinimum
  minSupplierOrderQuantity
  trackExpiryDate
}
    `;
export const TagsAndBadgesProductInfoFragmentFragmentDoc = gql`
    fragment TagsAndBadgesProductInfoFragment on Product {
  tagIds
  preferences {
    _id
    name
    type
    imageUrl
  }
  diets {
    _id
    name
    type
    imageUrl
  }
}
    `;
export const ProductArrangementFragmentFragmentDoc = gql`
    fragment ProductArrangementFragment on ProductArrangement {
  _id
  name
  productIdsWithStockMax {
    productId
    stockMax
  }
  reassortmentType
  defaultStockMax
}
    `;
export const ProductProductArrangementFragmentFragmentDoc = gql`
    fragment ProductProductArrangementFragment on Product {
  _id
  productArrangements {
    ...ProductArrangementFragment
  }
}
    ${ProductArrangementFragmentFragmentDoc}`;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on Product {
  _id
  ...AdditionalProductInfoFragment
  ...DimensionsProductInfoFragment
  ...GeneralProductInfoFragment
  ...NutritionProductInfoFragment
  ...SalesProductInfoFragment
  ...StateHistoryProductInfoFragment
  ...StockAndSupplierProductInfoFragment
  ...TagsAndBadgesProductInfoFragment
  ...ProductProductArrangementFragment
}
    ${AdditionalProductInfoFragmentFragmentDoc}
${DimensionsProductInfoFragmentFragmentDoc}
${GeneralProductInfoFragmentFragmentDoc}
${NutritionProductInfoFragmentFragmentDoc}
${SalesProductInfoFragmentFragmentDoc}
${StateHistoryProductInfoFragmentFragmentDoc}
${StockAndSupplierProductInfoFragmentFragmentDoc}
${TagsAndBadgesProductInfoFragmentFragmentDoc}
${ProductProductArrangementFragmentFragmentDoc}`;
export const CatalogProductFragmentFragmentDoc = gql`
    fragment CatalogProductFragment on Product {
  _id
  access
  brand
  category {
    title
  }
  externalProductId
  isBeingTested
  imageUrl
  isDoubleCoil
  isOutOfStock
  isPaused
  isToBeArchived
  isWithoutStock
  isMicrostore
  name
  fullname
  newUntil
  state
  flow
  subcategory {
    name
  }
  suppliers {
    name
    prices {
      value
      conditionning
    }
  }
  supplierShortageInfo {
    inShortage
  }
  tags {
    name
  }
  updatedAt
  volume
  height
  length
  width
  weight
}
    `;
export const ProductGroupFragmentFragmentDoc = gql`
    fragment ProductGroupFragment on ProductGroup {
  _id
  composition {
    productId
    quantity
  }
  createdAt
  productId
  updatedAt
}
    `;
export const SupplyOrderProductStockVariationFragmentFragmentDoc = gql`
    fragment SupplyOrderProductStockVariationFragment on ProductStockVariation {
  computedStockThreshold
  createdAt
  forecasts {
    forecastsDaysToIgnoreForOrders
    forecastsFreefoodPunctual
    forecastsFreefoodRecurring
    forecastsStoreDry
    lastUpdateDateFreefoodPunctual
    lastUpdateDateFreefoodRecurring
    lastUpdateDateStoreDry
  }
  initialStock
  microstoreDetails {
    missingStockByDay
    targetStockByDay
    targetStockDetails {
      locationTarget
      planogramDate
      siteName
      usedLocationTarget
    }
    totalStock
  }
  missingStockBetweenDeliveries
  orderDate
  operations {
    punctualOrdersNotPrepared
    recurrentOrdersNotPrepared
    validatedStockTransferPrepared
    validatedStockTransferNotPrepared
  }
  outboundFreefoodFloatStockVariation
  outboundStoreFloatStockVariation
  outboundStockVariation
  productId
  productSwitchDetails {
    variations
  }
  stockUpdateDayIndexIfOrderedOnNextOrderingDay
  stockUpdateDayIndexIfOrderedToday
  stockVariation
  stockVariationFromSupplyOrders
  supplyOrderId
}
    `;
export const ProductSwitchFragmentFragmentDoc = gql`
    fragment ProductSwitchFragment on ProductSwitch {
  _id
  createdAt
  endDate
  productAId
  productAVariation {
    ...SupplyOrderProductStockVariationFragment
  }
  productBId
  productBVariation {
    ...SupplyOrderProductStockVariationFragment
  }
  ratioToOrderOfA
  ratioOfAToOrderForB
  startDate
  state
  switchFreefood
  switchStore
  updatedAt
}
    ${SupplyOrderProductStockVariationFragmentFragmentDoc}`;
export const QuizFragmentFragmentDoc = gql`
    fragment QuizFragment on Quiz {
  _id
  audience {
    organizationIds
    siteIds
    userIds
  }
  createdAt
  date
  description
  imageUrl
  questions {
    label
    answerOptions
    correctAnswerIndex
    imageUrl
  }
  state
  title
  updatedAt
}
    `;
export const DetailedRitualFragmentFragmentDoc = gql`
    fragment DetailedRitualFragment on Ritual {
  _id
  activeDate
  activeWeekdays
  associatedDiscount
  billToOrganizationId
  imageUrl
  messagesSetId
  name
  repetition
  resetsBetweenPurchases
  restrictedOrganizationIds
  restrictedSiteIds
  restrictedUserIds
  state
  timeWindow {
    start
    end
  }
}
    `;
export const QuizRitualGameFragmentFragmentDoc = gql`
    fragment QuizRitualGameFragment on QuizRitualGame {
  _id
  maxAttempts
  questions {
    answerChoices
    correctAnswerIndex
    description
    explanation
    imageUrl
    timeToAnswer
    title
  }
  ritualId
  targetScore
  totalScore
  type
}
    `;
export const WantedRitualGameFragmentFragmentDoc = gql`
    fragment WantedRitualGameFragment on WantedRitualGame {
  _id
  maxAttempts
  ritualId
  targetScore
  totalScore
  type
}
    `;
export const RitualGameFragmentFragmentDoc = gql`
    fragment RitualGameFragment on RitualGame {
  ... on QuizRitualGame {
    ...QuizRitualGameFragment
  }
  ... on WantedRitualGame {
    ...WantedRitualGameFragment
  }
}
    ${QuizRitualGameFragmentFragmentDoc}
${WantedRitualGameFragmentFragmentDoc}`;
export const SenseiBasketFragmentFragmentDoc = gql`
    fragment SenseiBasketFragment on SenseiBasket {
  _id
  createdAt
  items {
    quantity
    sku
    lineAmount
    lineTax
  }
  senseiBasketId
  senseiColumnId
  userId
  basketCreationDate
  storeEntryDate
  storeExitDate
}
    `;
export const CheckTemperatureInstructionFragmentFragmentDoc = gql`
    fragment CheckTemperatureInstructionFragment on CheckTemperatureInstruction {
  createdAt
  isFinishForced
  isNeeded
  noTemperatureComment
  state
  stateHistory {
    createdAt
    state
  }
  temperature
  type
  updatedAt
}
    `;
export const CheckBoxTemperatureInstructionFragmentFragmentDoc = gql`
    fragment CheckBoxTemperatureInstructionFragment on CheckBoxTemperatureInstruction {
  createdAt
  isFinishForced
  isNeeded
  noTemperatureComment
  state
  stateHistory {
    createdAt
    state
  }
  temperature
  thermometerNumber
  type
  updatedAt
}
    `;
export const HotDrinksInstructionFragmentFragmentDoc = gql`
    fragment HotDrinksInstructionFragment on HotDrinksInstruction {
  createdAt
  hasCleanedCollectingTray
  hasCleanedMachine
  hasReplenishedConsumables
  hasReplenishedTanks
  hasRemovedCoffeeGround
  hasRinsedMachine
  isMachineWorking
  isFinishForced
  isNeeded
  locations {
    productId
    microstoreLocationId
    initialTrayLevel
    targetTrayLevel
  }
  needsCleaningMachine
  state
  stateHistory {
    createdAt
    state
  }
  type
  updatedAt
}
    `;
export const InventoryInstructionFragmentFragmentDoc = gql`
    fragment InventoryInstructionFragment on InventoryInstruction {
  createdAt
  isFinishForced
  isNeeded
  state
  stateHistory {
    createdAt
    state
  }
  type
  updatedAt
}
    `;
export const MicrowaveInstructionFragmentFragmentDoc = gql`
    fragment MicrowaveInstructionFragment on MicrowaveInstruction {
  createdAt
  hasCleanedMicrowaves
  isFinishForced
  isNeeded
  state
  stateHistory {
    createdAt
    state
  }
  type
  updatedAt
}
    `;
export const MoveProductsInstructionFragmentFragmentDoc = gql`
    fragment MoveProductsInstructionFragment on MoveProductsInstruction {
  createdAt
  isFinishForced
  isNeeded
  state
  stateHistory {
    createdAt
    state
  }
  type
  updatedAt
}
    `;
export const PhotosInstructionFragmentFragmentDoc = gql`
    fragment PhotosInstructionFragment on PhotosInstruction {
  _id
  createdAt
  isFinishForced
  isNeeded
  photos {
    isMandatory
    type
    urls
  }
  controlPhotos {
    ...ControlPhotoFragment
  }
  state
  stateHistory {
    createdAt
    state
  }
  type
  updatedAt
}
    ${ControlPhotoFragmentFragmentDoc}`;
export const RemoveProductsInstructionFragmentFragmentDoc = gql`
    fragment RemoveProductsInstructionFragment on RemoveProductsInstruction {
  createdAt
  isFinishForced
  isNeeded
  removedProducts {
    microstoreLocationIds
    productId
    quantityDetails {
      expiryDate
      quantity
    }
  }
  state
  stateHistory {
    createdAt
    state
  }
  type
  updatedAt
}
    `;
export const StoreProductsInstructionFragmentFragmentDoc = gql`
    fragment StoreProductsInstructionFragment on StoreProductsInstruction {
  createdAt
  isFinishForced
  isNeeded
  state
  stateHistory {
    createdAt
    state
  }
  type
  updatedAt
}
    `;
export const ManualReassortInstructionFragmentFragmentDoc = gql`
    fragment ManualReassortInstructionFragment on ManualReassortInstruction {
  createdAt
  isFinishForced
  isNeeded
  entries {
    _id
    productId
    quantity
    truckColumnId
    columnId
    createdAt
  }
  state
  stateHistory {
    createdAt
    state
  }
  type
  updatedAt
}
    `;
export const TheftNoticeInstructionFragmentFragmentDoc = gql`
    fragment TheftNoticeInstructionFragment on TheftNoticeInstruction {
  createdAt
  isFinishForced
  isNeeded
  needMoreNotices
  state
  stateHistory {
    createdAt
    state
  }
  type
  updatedAt
}
    `;
export const SiteFragmentFragmentDoc = gql`
    fragment SiteFragment on Site {
  _id
  accessTime
  unknownShrinkageBillingThreshold
  removalDate
  closingDatesRanges {
    start
    end
  }
  createdAt
  deliveryDays
  freshReassortDays
  dryReassortDays
  deliveryTimeWindow {
    start
    stop
  }
  deliveryType
  contractType
  estimatedUserCount
  hasExternalSetupProcess
  isOpenOnWeekend
  isSecured
  hasSensei
  hasCoffee
  launchDate
  name
  organizationId
  organizationName
  reassortmentFreshFacings {
    dessert
    main
    smallBites
    starter
  }
  reassortmentStockTargetRatios {
    monday
    tuesday
    wednesday
    thursday
    friday
  }
  reassortmentStockTargets {
    dessert
    main
    smallBites
    starter
  }
  reassortmentOnboardingStockTargets {
    dessert
    main
    smallBites
    starter
  }
  shouldOperateOnTotops
  shouldAutomaticallyCreateTargetReassortment
  shouldAutomaticallyCreateManualReassortment
  shouldAutomaticallyFinishSiteSetup
  shouldHaveTheftNotice
  shouldModulateForExpired
  shouldModulateForUnknownLosses
  state
  stateHistory {
    createdAt
    createdBy
    createdByName
    state
  }
  totemNumber
  type
  unwantedProductIds
  updatedAt
  urbantzMetadata {
    needsInventoryBoissons {
      evenWeek
      oddWeek
    }
    needsInventorySnack {
      evenWeek
      oddWeek
    }
    needsInventoryNonAlimentaire {
      evenWeek
      oddWeek
    }
    needsCleaningMachineNECTA {
      evenWeek
      oddWeek
    }
    needsSmallExpiryDateInventory {
      evenWeek
      oddWeek
    }
    replaceCompleteInventoryByZeroInventory {
      evenWeek
      oddWeek
    }
    needsPunctualExpiryDateInventory {
      evenWeek
      oddWeek
    }
  }
  useNayaxCard
  B2CPriceRange
  wantedProductIds
  avaSiteId
  avaClientId
  deliveryZoneId
  deliveryZone {
    _id
    name
    color
  }
}
    `;
export const SiteFragmentFilterFragmentDoc = gql`
    fragment SiteFragmentFilter on Site {
  _id
  createdAt
  updatedAt
  deliveryDays
  deliveryType
  name
  organizationName
  organizationId
  state
  totemId
  type
  B2CPriceRange
  accessTime
  launchDate
  removalDate
  hasExternalSetupProcess
  estimatedUserCount
  isSecured
  shouldOperateOnTotops
  shouldAutomaticallyCreateTargetReassortment
  shouldAutomaticallyCreateManualReassortment
  shouldAutomaticallyFinishSiteSetup
  shouldModulateForExpired
  shouldHaveTheftNotice
  shouldModulateForUnknownLosses
  useNayaxCard
  hasSensei
  unknownShrinkageBillingThreshold
  deliveryZoneId
  deliveryZone {
    _id
    name
    color
  }
}
    `;
export const MicrostoreColumnInventoryFragmentFragmentDoc = gql`
    fragment MicrostoreColumnInventoryFragment on MicrostoreColumnInventory {
  _id
  checkedLocations {
    microstoreLocationId
    productId
    quantityDetails {
      expiryDate
      quantity
    }
  }
  createdAt
  microstoreColumnId
  siteInventoryId
  state
  updatedAt
}
    `;
export const SiteInventoryFragmentFragmentDoc = gql`
    fragment SiteInventoryFragment on SiteInventory {
  _id
  createdAt
  date
  microstoreColumnInventories {
    ...MicrostoreColumnInventoryFragment
  }
  siteId
  state
  updatedAt
}
    ${MicrostoreColumnInventoryFragmentFragmentDoc}`;
export const SiteProductLightFragmentDoc = gql`
    fragment SiteProductLight on SiteProduct {
  productId
  product {
    _id
    fullname
    state
    flow
  }
  targetStock
  stock
  availableStock {
    isUnlimited
    value
  }
  latestStockVariations {
    _id
    createdAt
    delta
    type
    ref
    explanation
    columnInventoryStockId
  }
}
    `;
export const SiteProductFragmentDoc = gql`
    fragment SiteProduct on SiteProduct {
  productId
  product {
    _id
    fullname
    state
    flow
  }
  targetStock
  stock
  availableStock {
    isUnlimited
    value
    details {
      dailyStocks
      orderedStocks
      realRecurringOrders
      predictionRecurringOrders
      realPunctualOrders
      predictionPunctualOrders
      realStoreTargetNotPrepared
      realStoreTargetPrepared
      predictionStoreTarget
      storeMenu
      preparationDate
      preparationDateUsedIndex
      soonestRestockedDate
      soonestRestockedDateUsedIndex
      usedRecurringOrders
      usedPunctualOrders
      usedStoreTarget
      usedStoreMenu
    }
  }
  latestStockVariations {
    _id
    createdAt
    delta
    type
    ref
    explanation
    columnInventoryStockId
  }
}
    `;
export const SetupInstructionFragmentFragmentDoc = gql`
    fragment SetupInstructionFragment on SetupInstruction {
  ... on CheckTemperatureInstruction {
    createdAt
    isFinishForced
    isNeeded
    noTemperatureComment
    state
    stateHistory {
      createdAt
      state
    }
    temperature
    type
    updatedAt
  }
  ... on CheckBoxTemperatureInstruction {
    createdAt
    isFinishForced
    isNeeded
    noTemperatureComment
    state
    stateHistory {
      createdAt
      state
    }
    temperature
    thermometerNumber
    type
    updatedAt
  }
  ... on HotDrinksInstruction {
    createdAt
    hasCleanedCollectingTray
    hasCleanedMachine
    hasReplenishedConsumables
    hasReplenishedTanks
    hasRemovedCoffeeGround
    hasRinsedMachine
    isMachineWorking
    isFinishForced
    isNeeded
    locations {
      productId
      microstoreLocationId
      initialTrayLevel
      targetTrayLevel
    }
    needsCleaningMachine
    state
    stateHistory {
      createdAt
      state
    }
    type
    updatedAt
  }
  ... on InventoryInstruction {
    createdAt
    isFinishForced
    isNeeded
    state
    stateHistory {
      createdAt
      state
    }
    type
    updatedAt
  }
  ... on MicrowaveInstruction {
    createdAt
    hasCleanedMicrowaves
    isFinishForced
    isNeeded
    state
    stateHistory {
      createdAt
      state
    }
    type
    updatedAt
  }
  ... on MoveProductsInstruction {
    createdAt
    isFinishForced
    isNeeded
    state
    stateHistory {
      createdAt
      state
    }
    type
    updatedAt
  }
  ... on PhotosInstruction {
    _id
    createdAt
    isFinishForced
    isNeeded
    photos {
      isMandatory
      type
      urls
    }
    controlPhotos {
      ...ControlPhotoFragment
    }
    state
    stateHistory {
      createdAt
      state
    }
    type
    updatedAt
  }
  ... on RemoveProductsInstruction {
    createdAt
    isFinishForced
    isNeeded
    removedProducts {
      microstoreLocationIds
      productId
      quantityDetails {
        expiryDate
        quantity
      }
    }
    state
    stateHistory {
      createdAt
      state
    }
    type
    updatedAt
  }
  ... on StoreProductsInstruction {
    createdAt
    isFinishForced
    isNeeded
    state
    stateHistory {
      createdAt
      state
    }
    type
    updatedAt
  }
  ... on ManualReassortInstruction {
    createdAt
    isFinishForced
    isNeeded
    entries {
      _id
      productId
      quantity
      truckColumnId
      columnId
      createdAt
    }
    state
    stateHistory {
      createdAt
      state
    }
    type
    updatedAt
  }
  ... on TheftNoticeInstruction {
    createdAt
    isFinishForced
    isNeeded
    needMoreNotices
    state
    stateHistory {
      createdAt
      state
    }
    type
    updatedAt
  }
}
    ${ControlPhotoFragmentFragmentDoc}`;
export const FreefoodSetupFragmentFragmentDoc = gql`
    fragment FreefoodSetupFragment on FreefoodSetup {
  _id
  createdAt
  isNeeded
  instructions {
    ...SetupInstructionFragment
  }
  state
  updatedAt
}
    ${SetupInstructionFragmentFragmentDoc}`;
export const MicrostoreColumnSetupFragmentFragmentDoc = gql`
    fragment MicrostoreColumnSetupFragment on MicrostoreColumnSetup {
  _id
  createdAt
  instructions {
    ...SetupInstructionFragment
  }
  isFinishForced
  isNeeded
  microstoreColumnId
  microstoreColumnInventoryId
  microstoreColumnGroupSetupId
  microstoreLocations {
    microstoreLocationId
    productId
    replacementProductId
    stockToAdd
    expiryDates {
      expiryDate
      quantity
    }
  }
  positionInColumnGroupSetup
  postSiteSetupZeroInventoryProductIds
  state
  stateHistory {
    createdAt
    state
  }
  updatedAt
}
    ${SetupInstructionFragmentFragmentDoc}`;
export const MicrostoreColumnGroupSetupFragmentFragmentDoc = gql`
    fragment MicrostoreColumnGroupSetupFragment on MicrostoreColumnGroupSetup {
  _id
  instructionsAfterColumns {
    ...SetupInstructionFragment
  }
  instructionsBeforeColumns {
    ...SetupInstructionFragment
  }
  isFinishForced
  isNeeded
  microstoreColumnGroupId
  microstoreColumnSetups {
    ...MicrostoreColumnSetupFragment
  }
  positionInSiteSetup
  siteSetupId
  state
  stateHistory {
    createdAt
    state
  }
  updatedAt
}
    ${SetupInstructionFragmentFragmentDoc}
${MicrostoreColumnSetupFragmentFragmentDoc}`;
export const MicrostoreLocationTemplateFragmentFragmentDoc = gql`
    fragment MicrostoreLocationTemplateFragment on MicrostoreLocationTemplate {
  _id
  productArrangement {
    ...ProductArrangementFragment
  }
  alternativeProductArrangementIds
  productId
  product {
    ...ProductArrangementProductFragment
  }
  stockMax
  reassortmentType
  trayMaxCapacity
}
    ${ProductArrangementFragmentFragmentDoc}
${ProductArrangementProductFragmentFragmentDoc}`;
export const MicrostoreLocationFragmentFragmentDoc = gql`
    fragment MicrostoreLocationFragment on MicrostoreLocation {
  _id
  expiryDates {
    expiryDate
    quantity
    shouldRemoveFromSite
  }
  locationTemplateId
  microstoreLocationTemplate {
    ...MicrostoreLocationTemplateFragment
  }
  productId
  product {
    _id
    name
    flow
    trackExpiryDate
    isWithoutStock
    isDoubleCoil
    recipe {
      ingredients {
        productId
      }
    }
  }
  replacementProductId
  replacementProduct {
    _id
    name
    flow
    trackExpiryDate
    isWithoutStock
    isDoubleCoil
    recipe {
      ingredients {
        productId
      }
    }
  }
  positionInShelf {
    column
    row
  }
  nayaxMDBCode
  stockToAdd
  targetStock
}
    ${MicrostoreLocationTemplateFragmentFragmentDoc}`;
export const MicrostoreColumnWithShelvesFragmentFragmentDoc = gql`
    fragment MicrostoreColumnWithShelvesFragment on MicrostoreColumn {
  _id
  createdAt
  updatedAt
  siteId
  siteName
  isSiteSecured
  canBeSecured
  columnGroupId
  columnIdToReplace
  isPaused
  shouldUpdateStockOnTransaction
  shouldSendNayaxPrices
  shouldIgnoreReassortThresholds
  microstoreColumnTemplateId
  name
  state
  stateHistory {
    createdAt
    createdBy
    createdByName
    state
  }
  positionInColumnGroup
  columnGroupName
  externalColumnId
  externalColumnType
  externalColumnConfig {
    nayaxMDBIntervals {
      min
      max
    }
  }
  avaSalePlaceId
  columnGroup {
    _id
    name
    columns {
      _id
      name
      positionInColumnGroup
    }
    site {
      _id
      name
      microstoreColumnGroups {
        _id
        name
        positionInSite
      }
      totem {
        _id
        name
        number
        sites {
          _id
          name
        }
        organization {
          _id
          name
        }
      }
    }
  }
  site {
    organizationName
    isSecured
    nextDeliveryDate
    earliestDLCDateToKeepForStockCalculation
  }
  shelves {
    _id
    locationTable {
      ...MicrostoreLocationFragment
    }
    positionInColumn
  }
  startingDate
  removalDate
  microstoreColumnTemplateName
  type
  useDynamicDelivery
  machineCode
}
    ${MicrostoreLocationFragmentFragmentDoc}`;
export const MicrostoreColumnGroupWithColumnsFragmentFragmentDoc = gql`
    fragment MicrostoreColumnGroupWithColumnsFragment on MicrostoreColumnGroup {
  _id
  columns {
    ...MicrostoreColumnWithShelvesFragment
  }
  name
  positionInSite
  siteId
  avaSalePlaceLocationId
}
    ${MicrostoreColumnWithShelvesFragmentFragmentDoc}`;
export const SiteWithLocationInfoFragmentFragmentDoc = gql`
    fragment SiteWithLocationInfoFragment on Site {
  _id
  deliveryDays
  earliestDLCDateToKeepForStockCalculation
  isOpenOnWeekend
  isSecured
  name
  type
  state
  organizationName
  nextDeliveryDate
  reassortmentFreshFacings {
    dessert
    main
    smallBites
    starter
  }
  reassortmentStockTargets {
    dessert
    main
    smallBites
    starter
  }
  reassortmentOnboardingStockTargets {
    dessert
    main
    smallBites
    starter
  }
  microstoreColumnGroups {
    ...MicrostoreColumnGroupWithColumnsFragment
  }
}
    ${MicrostoreColumnGroupWithColumnsFragmentFragmentDoc}`;
export const SiteSetupFragmentFragmentDoc = gql`
    fragment SiteSetupFragment on SiteSetup {
  _id
  createdAt
  date
  delivery {
    isDynamic
  }
  deliveryPerson {
    _id
    fullname
  }
  deliveryId
  freefoodSetup {
    ...FreefoodSetupFragment
  }
  isFinishForced
  issues {
    productsIssues {
      comment
      productId
      brokenDuringDeliveryQuantity
      brokenOnSiteAfterInventoryQuantity
      brokenOnSiteBeforeInventoryQuantity
      expiredDeliveredQuantity
      expiredOnSiteAfterInventoryQuantity
      expiredOnSiteBeforeInventoryQuantity
      notEnoughPlaceQuantity
      otherBeforeInventoryQuantity
      otherAfterInventoryOrDuringDeliveryQuantity
      unexpectedOnSiteQuantity
      wrongQuantityDelivered
    }
  }
  microstoreColumnGroupSetups {
    ...MicrostoreColumnGroupSetupFragment
  }
  odooTickets {
    _id
    odooTicketId
    microstoreColumnId
    serviceType
    ticketType
    state
    description
    actions {
      actionType
      message
      photoUrl
      createdAt
    }
    microstoreColumn {
      name
    }
  }
  siteId
  site {
    ...SiteWithLocationInfoFragment
  }
  state
  stateHistory {
    createdAt
    createdBy
    createdByName
    state
  }
  updatedAt
}
    ${FreefoodSetupFragmentFragmentDoc}
${MicrostoreColumnGroupSetupFragmentFragmentDoc}
${SiteWithLocationInfoFragmentFragmentDoc}`;
export const SetupInstructionControlPhotosFragmentFragmentDoc = gql`
    fragment SetupInstructionControlPhotosFragment on SetupInstruction {
  ... on PhotosInstruction {
    _id
    type
    photos {
      isMandatory
      type
      urls
    }
    controlPhotos {
      ...ControlPhotoFragment
    }
  }
}
    ${ControlPhotoFragmentFragmentDoc}`;
export const FreefoodSetupControlPhotosFragmentFragmentDoc = gql`
    fragment FreefoodSetupControlPhotosFragment on FreefoodSetup {
  instructions {
    ...SetupInstructionControlPhotosFragment
  }
}
    ${SetupInstructionControlPhotosFragmentFragmentDoc}`;
export const MicrostoreColumnSetupControlPhotosFragmentFragmentDoc = gql`
    fragment MicrostoreColumnSetupControlPhotosFragment on MicrostoreColumnSetup {
  instructions {
    ...SetupInstructionControlPhotosFragment
  }
}
    ${SetupInstructionControlPhotosFragmentFragmentDoc}`;
export const MicrostoreColumnGroupSetupControlPhotosFragmentFragmentDoc = gql`
    fragment MicrostoreColumnGroupSetupControlPhotosFragment on MicrostoreColumnGroupSetup {
  instructionsAfterColumns {
    ...SetupInstructionControlPhotosFragment
  }
  instructionsBeforeColumns {
    ...SetupInstructionControlPhotosFragment
  }
  microstoreColumnSetups {
    ...MicrostoreColumnSetupControlPhotosFragment
  }
}
    ${SetupInstructionControlPhotosFragmentFragmentDoc}
${MicrostoreColumnSetupControlPhotosFragmentFragmentDoc}`;
export const SiteSetupControlPhotosFragmentFragmentDoc = gql`
    fragment SiteSetupControlPhotosFragment on SiteSetup {
  _id
  date
  freefoodSetup {
    ...FreefoodSetupControlPhotosFragment
  }
  microstoreColumnGroupSetups {
    ...MicrostoreColumnGroupSetupControlPhotosFragment
  }
}
    ${FreefoodSetupControlPhotosFragmentFragmentDoc}
${MicrostoreColumnGroupSetupControlPhotosFragmentFragmentDoc}`;
export const StockTransferFragmentFragmentDoc = gql`
    fragment StockTransferFragment on StockTransfer {
  _id
  createdAt
  updatedAt
  transferDate
  destinationColumnId
  destinationColumn {
    _id
    name
    fullname
  }
  originColumnId
  originColumn {
    _id
    name
    fullname
  }
  products {
    productId
    fullname
    conditionning
    packagesPerBatch
    originStockAvailable
    destinationStockAvailable
    quantity
  }
  deliveryId
  delivery {
    state
  }
  reassortmentFlow
  shouldUpdateStockImmediately
  state
  stateHistory {
    state
    createdAt
    createdBy
    createdByName
  }
}
    `;
export const StockVariationFragmentFragmentDoc = gql`
    fragment StockVariationFragment on StockVariation {
  _id
  createdAt
  delta
  explanation
  productId
  ref
  columnInventoryStockId
  columnId
  type
}
    `;
export const SubcategoryFragmentDoc = gql`
    fragment Subcategory on Subcategory {
  _id
  categoryId
  displayIndex
  name
  state
}
    `;
export const SubventionFragmentFragmentDoc = gql`
    fragment SubventionFragment on Subvention {
  _id
  archivedAt
  billToOrganizationId
  billToOrganization {
    _id
    name
  }
  categories
  coverageRate
  createdAt
  cumulative
  currentAmount
  description
  hoursIntervalsAvailable
  imageUrl
  name
  organizationId
  organization {
    _id
    name
  }
  reload
  remainingAmount
  updatedAt
}
    `;
export const OrderingTimeForDayFragmentFragmentDoc = gql`
    fragment OrderingTimeForDayFragment on OrderingTimeForDay {
  orderBefore
  daysToDeliver
  deliveryHours {
    start
    end
  }
  canBeOrdered
}
    `;
export const SupplierFragmentFragmentDoc = gql`
    fragment SupplierFragment on Supplier {
  _id
  nextOrderingDate
  name
  closingDatesRanges {
    closingDate
    openingDate
  }
  description
  phone
  address
  zipcode
  website
  createdAt
  updatedAt
  shouldCheckReceptionDayIsNotClosed
  shouldOrderAutomatically
  state
  stateHistory {
    state
    createdAt
    createdBy
    createdByName
  }
  contacts {
    name
    surname
    phone
    email
    description
  }
  paymentTimeType
  paymentTimeDays
  paymentType
  orderingProductTerms {
    minQuantity
    productId
  }
  orderingTerms {
    deliveryPrice
    minRequirements {
      unit
      value
    }
  }
  orderingTimes {
    monday {
      ...OrderingTimeForDayFragment
    }
    tuesday {
      ...OrderingTimeForDayFragment
    }
    wednesday {
      ...OrderingTimeForDayFragment
    }
    thursday {
      ...OrderingTimeForDayFragment
    }
    friday {
      ...OrderingTimeForDayFragment
    }
    saturday {
      ...OrderingTimeForDayFragment
    }
    sunday {
      ...OrderingTimeForDayFragment
    }
  }
  orderMode
  orderEmails
  orderPlatformUrl
  clientCode
  frequency
  updatedAt
}
    ${OrderingTimeForDayFragmentFragmentDoc}`;
export const SupplierDiscountFragmentFragmentDoc = gql`
    fragment SupplierDiscountFragment on SupplierDiscount {
  _id
  name
  createdAt
  updatedAt
  state
  rate
  productIds
  purchaseStartDate
  purchaseEndDate
  salesStartDate
  salesEndDate
  imageUrl
  discountedProductPrices {
    _id
    purchasePrice
    purchaseDiscountedPrice
    purchaseDiscountAmount
    purchaseDiscountRate
    salesPrice
    salesDiscountedPrice
    salesDiscountAmount
    salesDiscountRate
    product {
      _id
      fullname
      category {
        _id
        title
      }
      subcategory {
        _id
        name
      }
      suppliers {
        _id
        name
      }
    }
  }
}
    `;
export const SupplierPartnershipFragmentFragmentDoc = gql`
    fragment SupplierPartnershipFragment on SupplierPartnership {
  _id
  budget
  createdAt
  endDate
  name
  productIds
  startDate
  updatedAt
}
    `;
export const SupplyOrderFragmentFragmentDoc = gql`
    fragment SupplyOrderFragment on SupplyOrder {
  _id
  state
  createdAt
  orderDate
  nextOrderDate
  orderingTermsValidity {
    isValid
    deliveryPrice
  }
  dateDeliveryScheduled
  dateDelivery
  scheduledDeliveryDateValidity
  number
  priceHT
  priceTTC
  supplier {
    _id
    name
    orderingTimes {
      monday {
        ...OrderingTimeForDayFragment
      }
      tuesday {
        ...OrderingTimeForDayFragment
      }
      wednesday {
        ...OrderingTimeForDayFragment
      }
      thursday {
        ...OrderingTimeForDayFragment
      }
      friday {
        ...OrderingTimeForDayFragment
      }
      saturday {
        ...OrderingTimeForDayFragment
      }
      sunday {
        ...OrderingTimeForDayFragment
      }
    }
    orderingProductTerms {
      minQuantity
      productId
    }
    orderingTerms {
      deliveryPrice
      minRequirements {
        unit
        value
      }
    }
  }
  warehouseColumn {
    _id
    name
  }
  weeklyMenusStartDate
}
    ${OrderingTimeForDayFragmentFragmentDoc}`;
export const BadExpiryDateIssueFragmentFragmentDoc = gql`
    fragment BadExpiryDateIssueFragment on BadExpiryDateIssue {
  expiryDate
  minSupplierExpiryDays
  productId
  quantity
  type
}
    `;
export const BrokenQuantityIssueFragmentFragmentDoc = gql`
    fragment BrokenQuantityIssueFragment on BrokenQuantityIssue {
  brokenQuantity
  productId
  type
}
    `;
export const DifferentPackagingIssueFragmentFragmentDoc = gql`
    fragment DifferentPackagingIssueFragment on DifferentPackagingIssue {
  expectedPackaging
  productId
  receivedPackaging
  type
}
    `;
export const DifferentQuantityIssueFragmentFragmentDoc = gql`
    fragment DifferentQuantityIssueFragment on DifferentQuantityIssue {
  expectedQuantity
  productId
  receivedQuantity
  type
}
    `;
export const NewBarcodeIssueFragmentFragmentDoc = gql`
    fragment NewBarcodeIssueFragment on NewBarcodeIssue {
  barcode
  productId
  type
}
    `;
export const NotReceivedIssueFragmentFragmentDoc = gql`
    fragment NotReceivedIssueFragment on NotReceivedIssue {
  productId
  type
}
    `;
export const UnknownProductIssueFragmentFragmentDoc = gql`
    fragment UnknownProductIssueFragment on UnknownProductIssue {
  barcode
  description
  type
}
    `;
export const WrongProductIssueFragmentFragmentDoc = gql`
    fragment WrongProductIssueFragment on WrongProductIssue {
  barcode
  productId
  type
}
    `;
export const SupplyOrderProductIssueFragmentFragmentDoc = gql`
    fragment SupplyOrderProductIssueFragment on SupplyOrderProductIssue {
  ... on BadExpiryDateIssue {
    ...BadExpiryDateIssueFragment
  }
  ... on BrokenQuantityIssue {
    ...BrokenQuantityIssueFragment
  }
  ... on DifferentPackagingIssue {
    ...DifferentPackagingIssueFragment
  }
  ... on DifferentQuantityIssue {
    ...DifferentQuantityIssueFragment
  }
  ... on NewBarcodeIssue {
    ...NewBarcodeIssueFragment
  }
  ... on NotReceivedIssue {
    ...NotReceivedIssueFragment
  }
  ... on UnknownProductIssue {
    ...UnknownProductIssueFragment
  }
  ... on WrongProductIssue {
    ...WrongProductIssueFragment
  }
}
    ${BadExpiryDateIssueFragmentFragmentDoc}
${BrokenQuantityIssueFragmentFragmentDoc}
${DifferentPackagingIssueFragmentFragmentDoc}
${DifferentQuantityIssueFragmentFragmentDoc}
${NewBarcodeIssueFragmentFragmentDoc}
${NotReceivedIssueFragmentFragmentDoc}
${UnknownProductIssueFragmentFragmentDoc}
${WrongProductIssueFragmentFragmentDoc}`;
export const SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc = gql`
    fragment SupplyOrderWithSupplierProductsInfoFragment on SupplyOrder {
  _id
  comment
  createdAt
  dateDelivery
  dateDeliveryScheduled
  description
  hourDelivery
  issue
  issues {
    ...SupplyOrderProductIssueFragment
  }
  justInTime
  number
  orderDate
  nextOrderDate
  orderingTermsValidity {
    isValid
    deliveryPrice
  }
  scheduledDeliveryDateHistory {
    scheduledDeliveryDate
    createdAt
  }
  scheduledDeliveryDateValidity
  priceHT
  priceHTInvoice
  priceTTCInvoice
  products {
    _id
    brand
    colis
    confirmedQuantity
    confirmedQuantityHistory {
      createdAt
      quantity
    }
    conditionning
    packagesPerBatch
    isToBeArchived
    name
    fullname
    price
    productReceivedDetails {
      brokenItems
      colis
      conditionning
      quantity
      expiryDate
    }
    quantity
    quantityGenerated
    quantityGeneratedExtended
    quantityGeneratedForMenus
    supplierShortageInfo {
      inShortage
      returnDate
    }
    stock
    storedAt
    supplyOrderId
    availableStock
    tva
    unitPrice
    volume
    minSupplierOrderQuantity
  }
  soldOutRiskProductIds
  spreadsheetId
  spreadsheetName
  state
  stateHistory {
    createdAt
    state
    createdBy
    createdByName
  }
  productsInfoWithStock {
    _id
    availableStock
    brand
    conditionning
    fullname
    imageUrl
    isToBeArchived
    name
    packagesPerBatch
    stock
    supplierShortageInfo {
      inShortage
      returnDate
    }
    tva
    unitPrice
    volume
  }
  supplier {
    _id
    clientCode
    frequency
    nextOrderingDate
    name
    orderMode
    orderEmails
    orderingTimes {
      monday {
        ...OrderingTimeForDayFragment
      }
      tuesday {
        ...OrderingTimeForDayFragment
      }
      wednesday {
        ...OrderingTimeForDayFragment
      }
      thursday {
        ...OrderingTimeForDayFragment
      }
      friday {
        ...OrderingTimeForDayFragment
      }
      saturday {
        ...OrderingTimeForDayFragment
      }
      sunday {
        ...OrderingTimeForDayFragment
      }
    }
    orderingProductTerms {
      minQuantity
      productId
    }
    orderingTerms {
      deliveryPrice
      minRequirements {
        unit
        value
      }
    }
  }
  temperature
  totalQuantity
  totalQuantityReceived
  totalVolume
  totalWeight
  updatedAt
  warehouseColumn {
    _id
    name
  }
  weeklyMenusStartDate
}
    ${SupplyOrderProductIssueFragmentFragmentDoc}
${OrderingTimeForDayFragmentFragmentDoc}`;
export const TagQueryFragmentFragmentDoc = gql`
    fragment TagQueryFragment on Tag {
  _id
  displayIndex
  name
  type
  state
}
    `;
export const TagMutationFragmentFragmentDoc = gql`
    fragment TagMutationFragment on Tag {
  _id
  createdAt
  displayIndex
  name
  type
  state
  stateHistory {
    state
    createdAt
  }
  updatedAt
}
    `;
export const ThermometerFragmentFragmentDoc = gql`
    fragment ThermometerFragment on Thermometer {
  _id
  associatedUserId
  isOperational
  number
}
    `;
export const TotemFragmentFragmentDoc = gql`
    fragment TotemFragment on Totem {
  _id
  address
  address_details
  city
  consigneDelivery
  country
  hasValidatedOrders
  latitude
  longitude
  microstore {
    _id
  }
  minimumOrderAmountInfo {
    minimumBakeryAmount
    minimumDryAmount
    minimumFreshAmount
    minimumCatererAmount
    minimumFruitAmount
    minimumTotalAmount
  }
  monthlyBudget
  name
  number
  organizationId
  primaryTotemId
  state
  type
  zipcode
}
    `;
export const TotemClosedDayFragmentFragmentDoc = gql`
    fragment TotemClosedDayFragment on TotemClosedDay {
  _id
  createdAt
  date
  state
  type
  updatedAt
}
    `;
export const TotemClosedReceptionDayFragmentFragmentDoc = gql`
    fragment TotemClosedReceptionDayFragment on TotemClosedReceptionDay {
  _id
  createdAt
  date
  state
  updatedAt
}
    `;
export const DetailedTransactionFragmentFragmentDoc = gql`
    fragment DetailedTransactionFragment on Transaction {
  _id
  basketId
  nuBasketId
  nuBasket {
    type
  }
  createdAt
  paymentMethods {
    amountUsed
    explanation
    name
    paymentMethodName
    provider
    providerTransactionId
    status
    type
  }
  priceHT
  productId
  productName
  refundReason
  siteId
  siteName
  microstoreColumnId
  microstoreColumnName
  newState
  mealPlan {
    discountRatio
  }
  stateHistory {
    state
    createdAt
    createdBy
  }
  tva
  userId
  userFullName
  nayaxMDBCode
}
    `;
export const UrbantzRoundPresetFragmentFragmentDoc = gql`
    fragment UrbantzRoundPresetFragment on UrbantzRoundPreset {
  _id
  createdAt
  dayIndex
  totemIds
  updatedAt
}
    `;
export const PreviewTransactionFragmentFragmentDoc = gql`
    fragment PreviewTransactionFragment on Transaction {
  _id
  basketId
  nuBasketId
  nuBasket {
    type
  }
  createdAt
  paymentMethods {
    provider
  }
  priceHT
  productName
  siteId
  siteName
  microstoreColumnId
  microstoreColumnName
  newState
  tva
  userFullName
}
    `;
export const PreviewCreditFragmentFragmentDoc = gql`
    fragment PreviewCreditFragment on Credit {
  _id
  createdAt
  createdBy {
    _id
    profile {
      fullname
    }
  }
  updatedAt
  name
  initialAmount
  currentAmount
  organizationBatched {
    name
  }
  expirationDate
  owner {
    _id
    profile {
      fullname
    }
  }
  startDate
  type
  refundedAt
}
    `;
export const WalletFragmentFragmentDoc = gql`
    fragment WalletFragment on Wallet {
  credits {
    ...PreviewCreditFragment
  }
  subventions {
    _id
    name
    description
    categories
    cumulative
    currentAmount
    remainingAmount
    hoursIntervalsAvailable
    imageUrl
    reload
    organization {
      _id
      name
    }
  }
  organizationCard {
    _id
    state
  }
  creditCards {
    _id
    default
    expired
    paymentType
    provider
    retries
    details {
      number
      expiration
      bank
      country
      expYear
      expMonth
    }
  }
  mealVouchers {
    _id
    cardType
    default
    expired
    paymentType
    provider
    details {
      number
      username
      expiration
      bank
      country
    }
  }
}
    ${PreviewCreditFragmentFragmentDoc}`;
export const AdminUserFragmentFragmentDoc = gql`
    fragment AdminUserFragment on User {
  _id
  username
  createdAt
  emails {
    address
    verified
    bounced {
      createdAt
      reason
    }
  }
  getLastTransactions {
    ...PreviewTransactionFragment
  }
  lastSeenAt
  notificationPreferences {
    customRitualActivity
    dailyDelivery
    feedbacks
    newFeatures
    recommendations
    reminders
    ritualInvite
    siteActivity
    specialOffers
    startingRitual
    weeklySummary
  }
  organization {
    _id
    name
  }
  userGroupIds
  profile {
    firstname
    lastname
    fullname
    state
    phone
    imageUrl
  }
  permissions {
    totemId
    totem {
      fullname
    }
    userGroup
  }
  stripeCustomerId
  visitedSites {
    _id
    name
    createdAt
    visitedAt
  }
  defaultTruckColumnId
  defaultTruckColumn {
    _id
    name
    siteId
    siteName
  }
  wallet {
    ...WalletFragment
  }
}
    ${PreviewTransactionFragmentFragmentDoc}
${WalletFragmentFragmentDoc}`;
export const LoggedInUserFragmentFragmentDoc = gql`
    fragment LoggedInUserFragment on User {
  _id
  username
  profile {
    firstname
    imageUrl
    lastname
  }
  permissions {
    totemId
    userGroup
  }
}
    `;
export const NotificationPreferencesFragmentDoc = gql`
    fragment NotificationPreferences on NotificationPreferences {
  customRitualActivity
  dailyDelivery
  feedbacks
  newFeatures
  recommendations
  reminders
  ritualInvite
  siteActivity
  specialOffers
  startingRitual
  weeklySummary
}
    `;
export const WarehouseDeliveryProductFragmentFragmentDoc = gql`
    fragment WarehouseDeliveryProductFragment on WarehouseDeliveryProduct {
  conditionning
  packagesPerBatch
  location
  photoUrl
  productId
  productIndex
  productLabel
  packages
  packagesPicked
  scan
}
    `;
export const UrbantzDeliveryFragmentFragmentDoc = gql`
    fragment URBANTZ_DELIVERY_FRAGMENT on WarehouseDelivery {
  label
  roundColor
  roundName
  serviceTime
  theoricServiceTime
  times {
    preferenceSlot {
      start
      end
    }
    actualSlot {
      start
      end
    }
  }
  trackingUrl
  photos {
    type
    urls
  }
  controlPhotos {
    ...ControlPhotoFragment
  }
}
    ${ControlPhotoFragmentFragmentDoc}`;
export const WarehouseDeliveryFragmentFragmentDoc = gql`
    fragment WarehouseDeliveryFragment on WarehouseDelivery {
  _id
  createdAt
  deliveryCode
  deliveryDate
  siteId
  site {
    name
    organizationName
  }
  operatorName
  warehouseColumnId
  warehouseColumn {
    name
  }
  state
  stateHistory {
    state
    createdAt
    createdBy
    createdByName
  }
  stockTransferId
  products {
    ...WarehouseDeliveryProductFragment
  }
  updatedAt
  ...URBANTZ_DELIVERY_FRAGMENT
}
    ${WarehouseDeliveryProductFragmentFragmentDoc}
${UrbantzDeliveryFragmentFragmentDoc}`;
export const WarehouseReturnFragmentFragmentDoc = gql`
    fragment WarehouseReturnFragment on WarehouseReturn {
  _id
  brokenProducts {
    productId
    quantity
    deliveredQuantity
    storedQuantity
  }
  createdAt
  date
  expiredProducts {
    productId
    quantity
    deliveredQuantity
    storedQuantity
  }
  originColumnId
  originColumn {
    name
  }
  warehouseColumnId
  warehouseColumn {
    name
  }
  returnedProducts {
    productId
    quantity
    deliveredQuantity
    storedQuantity
  }
  returnedWithNoStockUpdateProducts {
    productId
    quantity
    deliveredQuantity
    storedQuantity
  }
  state
  stateHistory {
    createdAt
    state
  }
  updatedAt
}
    `;
export const TrayCapacityMutationFragmentFragmentDoc = gql`
    fragment TrayCapacityMutationFragment on TrayCapacity {
  _id
  microstoreColumnId
  locations {
    microstoreLocationId
    microstoreLocation {
      microstoreLocationTemplate {
        trayMaxCapacity
      }
    }
    productId
    product {
      _id
      name
      fullname
      imageUrl
    }
    currentLevel
    unitPerPackage
  }
}
    `;
export const StockTreeColumnProductFragmentDoc = gql`
    fragment StockTreeColumnProduct on ColumnProduct {
  columnId
  productId
  product {
    _id
    fullname
  }
  column {
    _id
    name
    type
  }
  stock
  targetStock
  availableStock {
    isUnlimited
    value
  }
  merchantValuation
  latestStockVariations {
    _id
    createdAt
    delta
    type
    ref
    explanation
  }
}
    `;
export const TourDeliveryFragmentFragmentDoc = gql`
    fragment TourDeliveryFragment on Delivery {
  _id
  siteName
  organizationName
  isDynamic
  state
  stateHistory {
    state
  }
  type
  deliveredMicrostoreColumnIds
  deliveredMicrostoreColumns {
    _id
    microstoreColumn {
      _id
      type
    }
  }
  orderIds
  orders {
    _id
    deliveryTimeWindows {
      start
      stop
    }
  }
  totem {
    _id
    name
    number
    address
    zipcode
    latitude
    longitude
  }
  site {
    _id
    contractType
    deliveryTimeWindow {
      start
      stop
    }
    deliveryZone {
      _id
      name
    }
  }
  theoricServiceTime
  boxes {
    _id
    type
    departureScannedAt
    loadedAt
    setupScannedAt
    returnedAt
  }
}
    `;
export const TourTaskFragmentFragmentDoc = gql`
    fragment TourTaskFragment on Task {
  _id
  type
  description
  instructions {
    _id
    label
    isDone
    controlPhotos {
      ...ControlPhotoFragment
    }
  }
  driversComment
  state
  stateHistory {
    state
    createdAt
    createdByName
  }
  siteId
  site {
    _id
    name
    deliveryTimeWindow {
      start
      stop
    }
  }
  totem {
    _id
    address
    zipcode
    latitude
    longitude
  }
  theoricServiceTime
}
    ${ControlPhotoFragmentFragmentDoc}`;
export const TourFragmentFragmentDoc = gql`
    fragment TourFragment on Tour {
  _id
  name
  color
  deliveryPersonUserId
  state
  deliveryPerson {
    _id
    fullname
  }
  deliveries {
    ...TourDeliveryFragment
  }
  stops {
    __typename
    ... on Delivery {
      _id
    }
    ... on Task {
      ...TourTaskFragment
    }
  }
}
    ${TourDeliveryFragmentFragmentDoc}
${TourTaskFragmentFragmentDoc}`;
export const TourDetailsDeliveryFragmentFragmentDoc = gql`
    fragment TourDetailsDeliveryFragment on Delivery {
  ...TourDeliveryFragment
  label
  delay
  serviceTime
  driversComment
  times {
    actualSlot {
      start
      end
    }
  }
  stateHistory {
    state
    createdAt
    createdBy
    createdByName
  }
  controlPhotos {
    _id
    deliveryId
    setupInstructionId
    photoIndex
    type
    url
    createdAt
  }
  boxes {
    number
    deliveryCode
    type
    containerType
    column {
      _id
      name
    }
    scanHistory {
      state
      createdByName
    }
  }
}
    ${TourDeliveryFragmentFragmentDoc}`;
export const SitePartialFragmentFragmentFragmentDoc = gql`
    fragment SitePartialFragmentFragment on Site {
  name
  state
}
    `;
export const UpdateAdvertisementScreenConfigDocument = gql`
    mutation UPDATE_ADVERTISEMENT_SCREEN_CONFIG($advertisementScreenConfigUpdateInput: AdvertisementScreenConfigUpdateInput!) {
  updateAdvertisementScreenConfig(
    advertisementScreenConfigUpdateInput: $advertisementScreenConfigUpdateInput
  ) {
    ...AdvertisementScreenConfigFragment
  }
}
    ${AdvertisementScreenConfigFragmentFragmentDoc}`;
export type UpdateAdvertisementScreenConfigMutationFn = Apollo.MutationFunction<UpdateAdvertisementScreenConfigMutation, UpdateAdvertisementScreenConfigMutationVariables>;

/**
 * __useUpdateAdvertisementScreenConfigMutation__
 *
 * To run a mutation, you first call `useUpdateAdvertisementScreenConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdvertisementScreenConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdvertisementScreenConfigMutation, { data, loading, error }] = useUpdateAdvertisementScreenConfigMutation({
 *   variables: {
 *      advertisementScreenConfigUpdateInput: // value for 'advertisementScreenConfigUpdateInput'
 *   },
 * });
 */
export function useUpdateAdvertisementScreenConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdvertisementScreenConfigMutation, UpdateAdvertisementScreenConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdvertisementScreenConfigMutation, UpdateAdvertisementScreenConfigMutationVariables>(UpdateAdvertisementScreenConfigDocument, options);
      }
export type UpdateAdvertisementScreenConfigMutationHookResult = ReturnType<typeof useUpdateAdvertisementScreenConfigMutation>;
export type UpdateAdvertisementScreenConfigMutationResult = Apollo.MutationResult<UpdateAdvertisementScreenConfigMutation>;
export type UpdateAdvertisementScreenConfigMutationOptions = Apollo.BaseMutationOptions<UpdateAdvertisementScreenConfigMutation, UpdateAdvertisementScreenConfigMutationVariables>;
export const CreateBadgeDocument = gql`
    mutation CREATE_BADGE($badge: CreateBadgeInput!) {
  createBadge(badge: $badge) {
    badge {
      name
      type
      imageUrl
    }
    success
    error
  }
}
    `;
export type CreateBadgeMutationFn = Apollo.MutationFunction<CreateBadgeMutation, CreateBadgeMutationVariables>;

/**
 * __useCreateBadgeMutation__
 *
 * To run a mutation, you first call `useCreateBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBadgeMutation, { data, loading, error }] = useCreateBadgeMutation({
 *   variables: {
 *      badge: // value for 'badge'
 *   },
 * });
 */
export function useCreateBadgeMutation(baseOptions?: Apollo.MutationHookOptions<CreateBadgeMutation, CreateBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBadgeMutation, CreateBadgeMutationVariables>(CreateBadgeDocument, options);
      }
export type CreateBadgeMutationHookResult = ReturnType<typeof useCreateBadgeMutation>;
export type CreateBadgeMutationResult = Apollo.MutationResult<CreateBadgeMutation>;
export type CreateBadgeMutationOptions = Apollo.BaseMutationOptions<CreateBadgeMutation, CreateBadgeMutationVariables>;
export const UpdateBadgeDocument = gql`
    mutation UPDATE_BADGE($badge: UpdateBadgeInput!) {
  updateBadge(badge: $badge) {
    badge {
      name
      type
      imageUrl
    }
    success
    error
  }
}
    `;
export type UpdateBadgeMutationFn = Apollo.MutationFunction<UpdateBadgeMutation, UpdateBadgeMutationVariables>;

/**
 * __useUpdateBadgeMutation__
 *
 * To run a mutation, you first call `useUpdateBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBadgeMutation, { data, loading, error }] = useUpdateBadgeMutation({
 *   variables: {
 *      badge: // value for 'badge'
 *   },
 * });
 */
export function useUpdateBadgeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBadgeMutation, UpdateBadgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBadgeMutation, UpdateBadgeMutationVariables>(UpdateBadgeDocument, options);
      }
export type UpdateBadgeMutationHookResult = ReturnType<typeof useUpdateBadgeMutation>;
export type UpdateBadgeMutationResult = Apollo.MutationResult<UpdateBadgeMutation>;
export type UpdateBadgeMutationOptions = Apollo.BaseMutationOptions<UpdateBadgeMutation, UpdateBadgeMutationVariables>;
export const CreateBundlesDocument = gql`
    mutation CREATE_BUNDLES($flow: ProductFlow!, $deliveryType: DeliveryDestinationType!, $deliveryDate: String!, $warehouseColumnId: ID!) {
  createBundles(
    flow: $flow
    deliveryType: $deliveryType
    deliveryDate: $deliveryDate
    warehouseColumnId: $warehouseColumnId
  ) {
    success
    errors
  }
}
    `;
export type CreateBundlesMutationFn = Apollo.MutationFunction<CreateBundlesMutation, CreateBundlesMutationVariables>;

/**
 * __useCreateBundlesMutation__
 *
 * To run a mutation, you first call `useCreateBundlesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBundlesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBundlesMutation, { data, loading, error }] = useCreateBundlesMutation({
 *   variables: {
 *      flow: // value for 'flow'
 *      deliveryType: // value for 'deliveryType'
 *      deliveryDate: // value for 'deliveryDate'
 *      warehouseColumnId: // value for 'warehouseColumnId'
 *   },
 * });
 */
export function useCreateBundlesMutation(baseOptions?: Apollo.MutationHookOptions<CreateBundlesMutation, CreateBundlesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBundlesMutation, CreateBundlesMutationVariables>(CreateBundlesDocument, options);
      }
export type CreateBundlesMutationHookResult = ReturnType<typeof useCreateBundlesMutation>;
export type CreateBundlesMutationResult = Apollo.MutationResult<CreateBundlesMutation>;
export type CreateBundlesMutationOptions = Apollo.BaseMutationOptions<CreateBundlesMutation, CreateBundlesMutationVariables>;
export const UpdateBundleStateDocument = gql`
    mutation UPDATE_BUNDLE_STATE($bundleId: String!, $state: BundleState!) {
  updateBundleState(bundleId: $bundleId, state: $state) {
    success
    error
    bundle {
      _id
      state
    }
  }
}
    `;
export type UpdateBundleStateMutationFn = Apollo.MutationFunction<UpdateBundleStateMutation, UpdateBundleStateMutationVariables>;

/**
 * __useUpdateBundleStateMutation__
 *
 * To run a mutation, you first call `useUpdateBundleStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBundleStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBundleStateMutation, { data, loading, error }] = useUpdateBundleStateMutation({
 *   variables: {
 *      bundleId: // value for 'bundleId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateBundleStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBundleStateMutation, UpdateBundleStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBundleStateMutation, UpdateBundleStateMutationVariables>(UpdateBundleStateDocument, options);
      }
export type UpdateBundleStateMutationHookResult = ReturnType<typeof useUpdateBundleStateMutation>;
export type UpdateBundleStateMutationResult = Apollo.MutationResult<UpdateBundleStateMutation>;
export type UpdateBundleStateMutationOptions = Apollo.BaseMutationOptions<UpdateBundleStateMutation, UpdateBundleStateMutationVariables>;
export const UpdateBundleDocument = gql`
    mutation updateBundle($bundle: BundleInput!, $shouldUpdateStocks: Boolean!) {
  updateBundle(bundle: $bundle, shouldUpdateStocks: $shouldUpdateStocks) {
    success
    error
    bundle {
      ...BundleWithBoxesFragment
    }
  }
}
    ${BundleWithBoxesFragmentFragmentDoc}`;
export type UpdateBundleMutationFn = Apollo.MutationFunction<UpdateBundleMutation, UpdateBundleMutationVariables>;

/**
 * __useUpdateBundleMutation__
 *
 * To run a mutation, you first call `useUpdateBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBundleMutation, { data, loading, error }] = useUpdateBundleMutation({
 *   variables: {
 *      bundle: // value for 'bundle'
 *      shouldUpdateStocks: // value for 'shouldUpdateStocks'
 *   },
 * });
 */
export function useUpdateBundleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBundleMutation, UpdateBundleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBundleMutation, UpdateBundleMutationVariables>(UpdateBundleDocument, options);
      }
export type UpdateBundleMutationHookResult = ReturnType<typeof useUpdateBundleMutation>;
export type UpdateBundleMutationResult = Apollo.MutationResult<UpdateBundleMutation>;
export type UpdateBundleMutationOptions = Apollo.BaseMutationOptions<UpdateBundleMutation, UpdateBundleMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UPDATE_CATEGORY($categoryId: ID!, $fields: CategoryUpdateInput!) {
  updateCategory(categoryId: $categoryId, fields: $fields) {
    success
    error
    category {
      ...CategoryFragment
    }
  }
}
    ${CategoryFragmentFragmentDoc}`;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const UpdateCategoryStateDocument = gql`
    mutation UPDATE_CATEGORY_STATE($categoryId: ID!, $stateToSet: CategoryState!) {
  updateCategoryState(categoryId: $categoryId, stateToSet: $stateToSet) {
    success
    error
    category {
      ...CategoryFragment
    }
  }
}
    ${CategoryFragmentFragmentDoc}`;
export type UpdateCategoryStateMutationFn = Apollo.MutationFunction<UpdateCategoryStateMutation, UpdateCategoryStateMutationVariables>;

/**
 * __useUpdateCategoryStateMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryStateMutation, { data, loading, error }] = useUpdateCategoryStateMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      stateToSet: // value for 'stateToSet'
 *   },
 * });
 */
export function useUpdateCategoryStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryStateMutation, UpdateCategoryStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryStateMutation, UpdateCategoryStateMutationVariables>(UpdateCategoryStateDocument, options);
      }
export type UpdateCategoryStateMutationHookResult = ReturnType<typeof useUpdateCategoryStateMutation>;
export type UpdateCategoryStateMutationResult = Apollo.MutationResult<UpdateCategoryStateMutation>;
export type UpdateCategoryStateMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryStateMutation, UpdateCategoryStateMutationVariables>;
export const CreateCategoryDocument = gql`
    mutation CREATE_CATEGORY($fields: CategoryUpdateInput!) {
  createCategory(fields: $fields) {
    success
    error
    categoryId
  }
}
    `;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const CreateColumnInventoryStockDocument = gql`
    mutation CREATE_COLUMN_INVENTORY_STOCK($columnId: ID!, $productId: ID!, $quantity: Int!, $explanation: String!) {
  createColumnInventoryStock(
    columnId: $columnId
    productId: $productId
    quantity: $quantity
    explanation: $explanation
  ) {
    success
    error
  }
}
    `;
export type CreateColumnInventoryStockMutationFn = Apollo.MutationFunction<CreateColumnInventoryStockMutation, CreateColumnInventoryStockMutationVariables>;

/**
 * __useCreateColumnInventoryStockMutation__
 *
 * To run a mutation, you first call `useCreateColumnInventoryStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateColumnInventoryStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createColumnInventoryStockMutation, { data, loading, error }] = useCreateColumnInventoryStockMutation({
 *   variables: {
 *      columnId: // value for 'columnId'
 *      productId: // value for 'productId'
 *      quantity: // value for 'quantity'
 *      explanation: // value for 'explanation'
 *   },
 * });
 */
export function useCreateColumnInventoryStockMutation(baseOptions?: Apollo.MutationHookOptions<CreateColumnInventoryStockMutation, CreateColumnInventoryStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateColumnInventoryStockMutation, CreateColumnInventoryStockMutationVariables>(CreateColumnInventoryStockDocument, options);
      }
export type CreateColumnInventoryStockMutationHookResult = ReturnType<typeof useCreateColumnInventoryStockMutation>;
export type CreateColumnInventoryStockMutationResult = Apollo.MutationResult<CreateColumnInventoryStockMutation>;
export type CreateColumnInventoryStockMutationOptions = Apollo.BaseMutationOptions<CreateColumnInventoryStockMutation, CreateColumnInventoryStockMutationVariables>;
export const CreateColumnInventoryStocksDocument = gql`
    mutation CREATE_COLUMN_INVENTORY_STOCKS($columnId: ID!, $productIds: [ID!]!, $quantity: Int!, $explanation: String!) {
  createColumnInventoryStocks(
    columnId: $columnId
    productIds: $productIds
    quantity: $quantity
    explanation: $explanation
  ) {
    success
    error
  }
}
    `;
export type CreateColumnInventoryStocksMutationFn = Apollo.MutationFunction<CreateColumnInventoryStocksMutation, CreateColumnInventoryStocksMutationVariables>;

/**
 * __useCreateColumnInventoryStocksMutation__
 *
 * To run a mutation, you first call `useCreateColumnInventoryStocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateColumnInventoryStocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createColumnInventoryStocksMutation, { data, loading, error }] = useCreateColumnInventoryStocksMutation({
 *   variables: {
 *      columnId: // value for 'columnId'
 *      productIds: // value for 'productIds'
 *      quantity: // value for 'quantity'
 *      explanation: // value for 'explanation'
 *   },
 * });
 */
export function useCreateColumnInventoryStocksMutation(baseOptions?: Apollo.MutationHookOptions<CreateColumnInventoryStocksMutation, CreateColumnInventoryStocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateColumnInventoryStocksMutation, CreateColumnInventoryStocksMutationVariables>(CreateColumnInventoryStocksDocument, options);
      }
export type CreateColumnInventoryStocksMutationHookResult = ReturnType<typeof useCreateColumnInventoryStocksMutation>;
export type CreateColumnInventoryStocksMutationResult = Apollo.MutationResult<CreateColumnInventoryStocksMutation>;
export type CreateColumnInventoryStocksMutationOptions = Apollo.BaseMutationOptions<CreateColumnInventoryStocksMutation, CreateColumnInventoryStocksMutationVariables>;
export const CreateZeroColumnInventoryStocksDocument = gql`
    mutation CREATE_ZERO_COLUMN_INVENTORY_STOCKS($columnProducts: [ColumnProductRefInput!]!) {
  createZeroColumnInventoryStocks(columnProducts: $columnProducts) {
    success
    error
  }
}
    `;
export type CreateZeroColumnInventoryStocksMutationFn = Apollo.MutationFunction<CreateZeroColumnInventoryStocksMutation, CreateZeroColumnInventoryStocksMutationVariables>;

/**
 * __useCreateZeroColumnInventoryStocksMutation__
 *
 * To run a mutation, you first call `useCreateZeroColumnInventoryStocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZeroColumnInventoryStocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZeroColumnInventoryStocksMutation, { data, loading, error }] = useCreateZeroColumnInventoryStocksMutation({
 *   variables: {
 *      columnProducts: // value for 'columnProducts'
 *   },
 * });
 */
export function useCreateZeroColumnInventoryStocksMutation(baseOptions?: Apollo.MutationHookOptions<CreateZeroColumnInventoryStocksMutation, CreateZeroColumnInventoryStocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateZeroColumnInventoryStocksMutation, CreateZeroColumnInventoryStocksMutationVariables>(CreateZeroColumnInventoryStocksDocument, options);
      }
export type CreateZeroColumnInventoryStocksMutationHookResult = ReturnType<typeof useCreateZeroColumnInventoryStocksMutation>;
export type CreateZeroColumnInventoryStocksMutationResult = Apollo.MutationResult<CreateZeroColumnInventoryStocksMutation>;
export type CreateZeroColumnInventoryStocksMutationOptions = Apollo.BaseMutationOptions<CreateZeroColumnInventoryStocksMutation, CreateZeroColumnInventoryStocksMutationVariables>;
export const AnswerToCommentDocument = gql`
    mutation AnswerToComment($body: String!, $answerToCommentId: ID!) {
  answerToComment(body: $body, answerToCommentId: $answerToCommentId) {
    _id
  }
}
    `;
export type AnswerToCommentMutationFn = Apollo.MutationFunction<AnswerToCommentMutation, AnswerToCommentMutationVariables>;

/**
 * __useAnswerToCommentMutation__
 *
 * To run a mutation, you first call `useAnswerToCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerToCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerToCommentMutation, { data, loading, error }] = useAnswerToCommentMutation({
 *   variables: {
 *      body: // value for 'body'
 *      answerToCommentId: // value for 'answerToCommentId'
 *   },
 * });
 */
export function useAnswerToCommentMutation(baseOptions?: Apollo.MutationHookOptions<AnswerToCommentMutation, AnswerToCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerToCommentMutation, AnswerToCommentMutationVariables>(AnswerToCommentDocument, options);
      }
export type AnswerToCommentMutationHookResult = ReturnType<typeof useAnswerToCommentMutation>;
export type AnswerToCommentMutationResult = Apollo.MutationResult<AnswerToCommentMutation>;
export type AnswerToCommentMutationOptions = Apollo.BaseMutationOptions<AnswerToCommentMutation, AnswerToCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($id: ID!) {
  deleteComment(id: $id)
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const CreateConsumptionVariationDocument = gql`
    mutation CREATE_CONSUMPTION_VARIATION($consumptionVariationCreateInput: ConsumptionVariationCreateInput!) {
  createConsumptionVariation(
    consumptionVariationCreateInput: $consumptionVariationCreateInput
  ) {
    ...ConsumptionVariationFragment
  }
}
    ${ConsumptionVariationFragmentFragmentDoc}`;
export type CreateConsumptionVariationMutationFn = Apollo.MutationFunction<CreateConsumptionVariationMutation, CreateConsumptionVariationMutationVariables>;

/**
 * __useCreateConsumptionVariationMutation__
 *
 * To run a mutation, you first call `useCreateConsumptionVariationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsumptionVariationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsumptionVariationMutation, { data, loading, error }] = useCreateConsumptionVariationMutation({
 *   variables: {
 *      consumptionVariationCreateInput: // value for 'consumptionVariationCreateInput'
 *   },
 * });
 */
export function useCreateConsumptionVariationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConsumptionVariationMutation, CreateConsumptionVariationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConsumptionVariationMutation, CreateConsumptionVariationMutationVariables>(CreateConsumptionVariationDocument, options);
      }
export type CreateConsumptionVariationMutationHookResult = ReturnType<typeof useCreateConsumptionVariationMutation>;
export type CreateConsumptionVariationMutationResult = Apollo.MutationResult<CreateConsumptionVariationMutation>;
export type CreateConsumptionVariationMutationOptions = Apollo.BaseMutationOptions<CreateConsumptionVariationMutation, CreateConsumptionVariationMutationVariables>;
export const UpdateConsumptionVariationDocument = gql`
    mutation UPDATE_CONSUMPTION_VARIATION($consumptionVariationUpdateInput: ConsumptionVariationUpdateInput!) {
  updateConsumptionVariation(
    consumptionVariationUpdateInput: $consumptionVariationUpdateInput
  ) {
    ...ConsumptionVariationFragment
  }
}
    ${ConsumptionVariationFragmentFragmentDoc}`;
export type UpdateConsumptionVariationMutationFn = Apollo.MutationFunction<UpdateConsumptionVariationMutation, UpdateConsumptionVariationMutationVariables>;

/**
 * __useUpdateConsumptionVariationMutation__
 *
 * To run a mutation, you first call `useUpdateConsumptionVariationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConsumptionVariationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConsumptionVariationMutation, { data, loading, error }] = useUpdateConsumptionVariationMutation({
 *   variables: {
 *      consumptionVariationUpdateInput: // value for 'consumptionVariationUpdateInput'
 *   },
 * });
 */
export function useUpdateConsumptionVariationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConsumptionVariationMutation, UpdateConsumptionVariationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConsumptionVariationMutation, UpdateConsumptionVariationMutationVariables>(UpdateConsumptionVariationDocument, options);
      }
export type UpdateConsumptionVariationMutationHookResult = ReturnType<typeof useUpdateConsumptionVariationMutation>;
export type UpdateConsumptionVariationMutationResult = Apollo.MutationResult<UpdateConsumptionVariationMutation>;
export type UpdateConsumptionVariationMutationOptions = Apollo.BaseMutationOptions<UpdateConsumptionVariationMutation, UpdateConsumptionVariationMutationVariables>;
export const UpdatePhotoIssuesDocument = gql`
    mutation updatePhotoIssues($controlPhoto: ControlPhotoInput!) {
  updatePhotoIssues(controlPhoto: $controlPhoto) {
    success
    error
    controlPhoto {
      ...ControlPhotoFragment
    }
  }
}
    ${ControlPhotoFragmentFragmentDoc}`;
export type UpdatePhotoIssuesMutationFn = Apollo.MutationFunction<UpdatePhotoIssuesMutation, UpdatePhotoIssuesMutationVariables>;

/**
 * __useUpdatePhotoIssuesMutation__
 *
 * To run a mutation, you first call `useUpdatePhotoIssuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhotoIssuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhotoIssuesMutation, { data, loading, error }] = useUpdatePhotoIssuesMutation({
 *   variables: {
 *      controlPhoto: // value for 'controlPhoto'
 *   },
 * });
 */
export function useUpdatePhotoIssuesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhotoIssuesMutation, UpdatePhotoIssuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhotoIssuesMutation, UpdatePhotoIssuesMutationVariables>(UpdatePhotoIssuesDocument, options);
      }
export type UpdatePhotoIssuesMutationHookResult = ReturnType<typeof useUpdatePhotoIssuesMutation>;
export type UpdatePhotoIssuesMutationResult = Apollo.MutationResult<UpdatePhotoIssuesMutation>;
export type UpdatePhotoIssuesMutationOptions = Apollo.BaseMutationOptions<UpdatePhotoIssuesMutation, UpdatePhotoIssuesMutationVariables>;
export const BatchCreditsDocument = gql`
    mutation BATCH_CREDITS($credit: CreditInput!, $where: CreditsBatchFilter!) {
  batchCredits(credit: $credit, where: $where) {
    success
    error
    credits {
      _id
    }
  }
}
    `;
export type BatchCreditsMutationFn = Apollo.MutationFunction<BatchCreditsMutation, BatchCreditsMutationVariables>;

/**
 * __useBatchCreditsMutation__
 *
 * To run a mutation, you first call `useBatchCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreditsMutation, { data, loading, error }] = useBatchCreditsMutation({
 *   variables: {
 *      credit: // value for 'credit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBatchCreditsMutation(baseOptions?: Apollo.MutationHookOptions<BatchCreditsMutation, BatchCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchCreditsMutation, BatchCreditsMutationVariables>(BatchCreditsDocument, options);
      }
export type BatchCreditsMutationHookResult = ReturnType<typeof useBatchCreditsMutation>;
export type BatchCreditsMutationResult = Apollo.MutationResult<BatchCreditsMutation>;
export type BatchCreditsMutationOptions = Apollo.BaseMutationOptions<BatchCreditsMutation, BatchCreditsMutationVariables>;
export const MarkDeliveriesAsDeliveredDocument = gql`
    mutation MARK_DELIVERIES_AS_DELIVERED($deliveryIds: [ID!]!) {
  markDeliveriesAsDelivered(deliveryIds: $deliveryIds) {
    ...UpdateStateResultFragment
  }
}
    ${UpdateStateResultFragmentFragmentDoc}`;
export type MarkDeliveriesAsDeliveredMutationFn = Apollo.MutationFunction<MarkDeliveriesAsDeliveredMutation, MarkDeliveriesAsDeliveredMutationVariables>;

/**
 * __useMarkDeliveriesAsDeliveredMutation__
 *
 * To run a mutation, you first call `useMarkDeliveriesAsDeliveredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDeliveriesAsDeliveredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDeliveriesAsDeliveredMutation, { data, loading, error }] = useMarkDeliveriesAsDeliveredMutation({
 *   variables: {
 *      deliveryIds: // value for 'deliveryIds'
 *   },
 * });
 */
export function useMarkDeliveriesAsDeliveredMutation(baseOptions?: Apollo.MutationHookOptions<MarkDeliveriesAsDeliveredMutation, MarkDeliveriesAsDeliveredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDeliveriesAsDeliveredMutation, MarkDeliveriesAsDeliveredMutationVariables>(MarkDeliveriesAsDeliveredDocument, options);
      }
export type MarkDeliveriesAsDeliveredMutationHookResult = ReturnType<typeof useMarkDeliveriesAsDeliveredMutation>;
export type MarkDeliveriesAsDeliveredMutationResult = Apollo.MutationResult<MarkDeliveriesAsDeliveredMutation>;
export type MarkDeliveriesAsDeliveredMutationOptions = Apollo.BaseMutationOptions<MarkDeliveriesAsDeliveredMutation, MarkDeliveriesAsDeliveredMutationVariables>;
export const MarkDeliveriesAsAbortedDocument = gql`
    mutation MARK_DELIVERIES_AS_ABORTED($deliveryIds: [ID!]!) {
  markDeliveriesAsAborted(deliveryIds: $deliveryIds) {
    ...UpdateStateResultFragment
  }
}
    ${UpdateStateResultFragmentFragmentDoc}`;
export type MarkDeliveriesAsAbortedMutationFn = Apollo.MutationFunction<MarkDeliveriesAsAbortedMutation, MarkDeliveriesAsAbortedMutationVariables>;

/**
 * __useMarkDeliveriesAsAbortedMutation__
 *
 * To run a mutation, you first call `useMarkDeliveriesAsAbortedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDeliveriesAsAbortedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDeliveriesAsAbortedMutation, { data, loading, error }] = useMarkDeliveriesAsAbortedMutation({
 *   variables: {
 *      deliveryIds: // value for 'deliveryIds'
 *   },
 * });
 */
export function useMarkDeliveriesAsAbortedMutation(baseOptions?: Apollo.MutationHookOptions<MarkDeliveriesAsAbortedMutation, MarkDeliveriesAsAbortedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDeliveriesAsAbortedMutation, MarkDeliveriesAsAbortedMutationVariables>(MarkDeliveriesAsAbortedDocument, options);
      }
export type MarkDeliveriesAsAbortedMutationHookResult = ReturnType<typeof useMarkDeliveriesAsAbortedMutation>;
export type MarkDeliveriesAsAbortedMutationResult = Apollo.MutationResult<MarkDeliveriesAsAbortedMutation>;
export type MarkDeliveriesAsAbortedMutationOptions = Apollo.BaseMutationOptions<MarkDeliveriesAsAbortedMutation, MarkDeliveriesAsAbortedMutationVariables>;
export const MarkDeliveriesAsArchivedDocument = gql`
    mutation MARK_DELIVERIES_AS_ARCHIVED($deliveryIds: [ID!]!) {
  markDeliveriesAsArchived(deliveryIds: $deliveryIds) {
    ...UpdateStateResultFragment
  }
}
    ${UpdateStateResultFragmentFragmentDoc}`;
export type MarkDeliveriesAsArchivedMutationFn = Apollo.MutationFunction<MarkDeliveriesAsArchivedMutation, MarkDeliveriesAsArchivedMutationVariables>;

/**
 * __useMarkDeliveriesAsArchivedMutation__
 *
 * To run a mutation, you first call `useMarkDeliveriesAsArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDeliveriesAsArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDeliveriesAsArchivedMutation, { data, loading, error }] = useMarkDeliveriesAsArchivedMutation({
 *   variables: {
 *      deliveryIds: // value for 'deliveryIds'
 *   },
 * });
 */
export function useMarkDeliveriesAsArchivedMutation(baseOptions?: Apollo.MutationHookOptions<MarkDeliveriesAsArchivedMutation, MarkDeliveriesAsArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDeliveriesAsArchivedMutation, MarkDeliveriesAsArchivedMutationVariables>(MarkDeliveriesAsArchivedDocument, options);
      }
export type MarkDeliveriesAsArchivedMutationHookResult = ReturnType<typeof useMarkDeliveriesAsArchivedMutation>;
export type MarkDeliveriesAsArchivedMutationResult = Apollo.MutationResult<MarkDeliveriesAsArchivedMutation>;
export type MarkDeliveriesAsArchivedMutationOptions = Apollo.BaseMutationOptions<MarkDeliveriesAsArchivedMutation, MarkDeliveriesAsArchivedMutationVariables>;
export const MarkDeliveriesAsInProgressDocument = gql`
    mutation MARK_DELIVERIES_AS_IN_PROGRESS($deliveryIds: [ID!]!) {
  markDeliveriesAsInProgress(deliveryIds: $deliveryIds) {
    ...UpdateStateResultFragment
  }
}
    ${UpdateStateResultFragmentFragmentDoc}`;
export type MarkDeliveriesAsInProgressMutationFn = Apollo.MutationFunction<MarkDeliveriesAsInProgressMutation, MarkDeliveriesAsInProgressMutationVariables>;

/**
 * __useMarkDeliveriesAsInProgressMutation__
 *
 * To run a mutation, you first call `useMarkDeliveriesAsInProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDeliveriesAsInProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDeliveriesAsInProgressMutation, { data, loading, error }] = useMarkDeliveriesAsInProgressMutation({
 *   variables: {
 *      deliveryIds: // value for 'deliveryIds'
 *   },
 * });
 */
export function useMarkDeliveriesAsInProgressMutation(baseOptions?: Apollo.MutationHookOptions<MarkDeliveriesAsInProgressMutation, MarkDeliveriesAsInProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDeliveriesAsInProgressMutation, MarkDeliveriesAsInProgressMutationVariables>(MarkDeliveriesAsInProgressDocument, options);
      }
export type MarkDeliveriesAsInProgressMutationHookResult = ReturnType<typeof useMarkDeliveriesAsInProgressMutation>;
export type MarkDeliveriesAsInProgressMutationResult = Apollo.MutationResult<MarkDeliveriesAsInProgressMutation>;
export type MarkDeliveriesAsInProgressMutationOptions = Apollo.BaseMutationOptions<MarkDeliveriesAsInProgressMutation, MarkDeliveriesAsInProgressMutationVariables>;
export const MarkDeliveriesAsPackagingDocument = gql`
    mutation MARK_DELIVERIES_AS_PACKAGING($deliveryIds: [ID!]!) {
  markDeliveriesAsPackaging(deliveryIds: $deliveryIds) {
    ...UpdateStateResultFragment
  }
}
    ${UpdateStateResultFragmentFragmentDoc}`;
export type MarkDeliveriesAsPackagingMutationFn = Apollo.MutationFunction<MarkDeliveriesAsPackagingMutation, MarkDeliveriesAsPackagingMutationVariables>;

/**
 * __useMarkDeliveriesAsPackagingMutation__
 *
 * To run a mutation, you first call `useMarkDeliveriesAsPackagingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDeliveriesAsPackagingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDeliveriesAsPackagingMutation, { data, loading, error }] = useMarkDeliveriesAsPackagingMutation({
 *   variables: {
 *      deliveryIds: // value for 'deliveryIds'
 *   },
 * });
 */
export function useMarkDeliveriesAsPackagingMutation(baseOptions?: Apollo.MutationHookOptions<MarkDeliveriesAsPackagingMutation, MarkDeliveriesAsPackagingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDeliveriesAsPackagingMutation, MarkDeliveriesAsPackagingMutationVariables>(MarkDeliveriesAsPackagingDocument, options);
      }
export type MarkDeliveriesAsPackagingMutationHookResult = ReturnType<typeof useMarkDeliveriesAsPackagingMutation>;
export type MarkDeliveriesAsPackagingMutationResult = Apollo.MutationResult<MarkDeliveriesAsPackagingMutation>;
export type MarkDeliveriesAsPackagingMutationOptions = Apollo.BaseMutationOptions<MarkDeliveriesAsPackagingMutation, MarkDeliveriesAsPackagingMutationVariables>;
export const MarkDeliveriesAsReadyDocument = gql`
    mutation MARK_DELIVERIES_AS_READY($deliveryIds: [ID!]!) {
  markDeliveriesAsReady(deliveryIds: $deliveryIds) {
    ...UpdateStateResultFragment
  }
}
    ${UpdateStateResultFragmentFragmentDoc}`;
export type MarkDeliveriesAsReadyMutationFn = Apollo.MutationFunction<MarkDeliveriesAsReadyMutation, MarkDeliveriesAsReadyMutationVariables>;

/**
 * __useMarkDeliveriesAsReadyMutation__
 *
 * To run a mutation, you first call `useMarkDeliveriesAsReadyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDeliveriesAsReadyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDeliveriesAsReadyMutation, { data, loading, error }] = useMarkDeliveriesAsReadyMutation({
 *   variables: {
 *      deliveryIds: // value for 'deliveryIds'
 *   },
 * });
 */
export function useMarkDeliveriesAsReadyMutation(baseOptions?: Apollo.MutationHookOptions<MarkDeliveriesAsReadyMutation, MarkDeliveriesAsReadyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDeliveriesAsReadyMutation, MarkDeliveriesAsReadyMutationVariables>(MarkDeliveriesAsReadyDocument, options);
      }
export type MarkDeliveriesAsReadyMutationHookResult = ReturnType<typeof useMarkDeliveriesAsReadyMutation>;
export type MarkDeliveriesAsReadyMutationResult = Apollo.MutationResult<MarkDeliveriesAsReadyMutation>;
export type MarkDeliveriesAsReadyMutationOptions = Apollo.BaseMutationOptions<MarkDeliveriesAsReadyMutation, MarkDeliveriesAsReadyMutationVariables>;
export const CreateDeliveryForOrderDocument = gql`
    mutation CREATE_DELIVERY_FOR_ORDER($orderId: ID!) {
  createDeliveryForOrder(orderId: $orderId) {
    ...DeliveryFragment
  }
}
    ${DeliveryFragmentFragmentDoc}`;
export type CreateDeliveryForOrderMutationFn = Apollo.MutationFunction<CreateDeliveryForOrderMutation, CreateDeliveryForOrderMutationVariables>;

/**
 * __useCreateDeliveryForOrderMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryForOrderMutation, { data, loading, error }] = useCreateDeliveryForOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCreateDeliveryForOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliveryForOrderMutation, CreateDeliveryForOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliveryForOrderMutation, CreateDeliveryForOrderMutationVariables>(CreateDeliveryForOrderDocument, options);
      }
export type CreateDeliveryForOrderMutationHookResult = ReturnType<typeof useCreateDeliveryForOrderMutation>;
export type CreateDeliveryForOrderMutationResult = Apollo.MutationResult<CreateDeliveryForOrderMutation>;
export type CreateDeliveryForOrderMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryForOrderMutation, CreateDeliveryForOrderMutationVariables>;
export const CreateDeliveryForSiteDocument = gql`
    mutation CREATE_DELIVERY_FOR_SITE($siteId: ID!, $deliveryDate: String!) {
  createDeliveryForSite(siteId: $siteId, deliveryDate: $deliveryDate) {
    ...DeliveryFragment
  }
}
    ${DeliveryFragmentFragmentDoc}`;
export type CreateDeliveryForSiteMutationFn = Apollo.MutationFunction<CreateDeliveryForSiteMutation, CreateDeliveryForSiteMutationVariables>;

/**
 * __useCreateDeliveryForSiteMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryForSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryForSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryForSiteMutation, { data, loading, error }] = useCreateDeliveryForSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function useCreateDeliveryForSiteMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliveryForSiteMutation, CreateDeliveryForSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliveryForSiteMutation, CreateDeliveryForSiteMutationVariables>(CreateDeliveryForSiteDocument, options);
      }
export type CreateDeliveryForSiteMutationHookResult = ReturnType<typeof useCreateDeliveryForSiteMutation>;
export type CreateDeliveryForSiteMutationResult = Apollo.MutationResult<CreateDeliveryForSiteMutation>;
export type CreateDeliveryForSiteMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryForSiteMutation, CreateDeliveryForSiteMutationVariables>;
export const UpdateDeliveryDateDocument = gql`
    mutation UPDATE_DELIVERY_DATE($deliveryId: ID!, $deliveryDate: String!) {
  updateDeliveryDate(deliveryId: $deliveryId, deliveryDate: $deliveryDate) {
    updatedDelivery {
      ...DeliveryFragment
    }
    errors
  }
}
    ${DeliveryFragmentFragmentDoc}`;
export type UpdateDeliveryDateMutationFn = Apollo.MutationFunction<UpdateDeliveryDateMutation, UpdateDeliveryDateMutationVariables>;

/**
 * __useUpdateDeliveryDateMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryDateMutation, { data, loading, error }] = useUpdateDeliveryDateMutation({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function useUpdateDeliveryDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryDateMutation, UpdateDeliveryDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryDateMutation, UpdateDeliveryDateMutationVariables>(UpdateDeliveryDateDocument, options);
      }
export type UpdateDeliveryDateMutationHookResult = ReturnType<typeof useUpdateDeliveryDateMutation>;
export type UpdateDeliveryDateMutationResult = Apollo.MutationResult<UpdateDeliveryDateMutation>;
export type UpdateDeliveryDateMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryDateMutation, UpdateDeliveryDateMutationVariables>;
export const UpdateDeliveryDocument = gql`
    mutation UPDATE_DELIVERY($delivery: DeliveryInput!, $shouldUpdateStocks: Boolean!) {
  updateDelivery(delivery: $delivery, shouldUpdateStocks: $shouldUpdateStocks) {
    success
    error
    delivery {
      ...DeliveryWithBoxesFragment
    }
  }
}
    ${DeliveryWithBoxesFragmentFragmentDoc}`;
export type UpdateDeliveryMutationFn = Apollo.MutationFunction<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>;

/**
 * __useUpdateDeliveryMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryMutation, { data, loading, error }] = useUpdateDeliveryMutation({
 *   variables: {
 *      delivery: // value for 'delivery'
 *      shouldUpdateStocks: // value for 'shouldUpdateStocks'
 *   },
 * });
 */
export function useUpdateDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>(UpdateDeliveryDocument, options);
      }
export type UpdateDeliveryMutationHookResult = ReturnType<typeof useUpdateDeliveryMutation>;
export type UpdateDeliveryMutationResult = Apollo.MutationResult<UpdateDeliveryMutation>;
export type UpdateDeliveryMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>;
export const UpdateDeliveryPlanningDocument = gql`
    mutation UPDATE_DELIVERY_PLANNING($siteId: ID!, $date: String!, $isActive: Boolean!) {
  updateDeliveryPlanning(siteId: $siteId, date: $date, isActive: $isActive) {
    success
  }
}
    `;
export type UpdateDeliveryPlanningMutationFn = Apollo.MutationFunction<UpdateDeliveryPlanningMutation, UpdateDeliveryPlanningMutationVariables>;

/**
 * __useUpdateDeliveryPlanningMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryPlanningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryPlanningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryPlanningMutation, { data, loading, error }] = useUpdateDeliveryPlanningMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      date: // value for 'date'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useUpdateDeliveryPlanningMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryPlanningMutation, UpdateDeliveryPlanningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryPlanningMutation, UpdateDeliveryPlanningMutationVariables>(UpdateDeliveryPlanningDocument, options);
      }
export type UpdateDeliveryPlanningMutationHookResult = ReturnType<typeof useUpdateDeliveryPlanningMutation>;
export type UpdateDeliveryPlanningMutationResult = Apollo.MutationResult<UpdateDeliveryPlanningMutation>;
export type UpdateDeliveryPlanningMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryPlanningMutation, UpdateDeliveryPlanningMutationVariables>;
export const UpdateDeliveryPlanningBatchDocument = gql`
    mutation UPDATE_DELIVERY_PLANNING_BATCH($deliveryPlanningBatchUpdate: [DeliveryPlanningBatchUpdateInput!]!) {
  updateDeliveryPlanningBatch(
    deliveryPlanningBatchUpdate: $deliveryPlanningBatchUpdate
  ) {
    success
  }
}
    `;
export type UpdateDeliveryPlanningBatchMutationFn = Apollo.MutationFunction<UpdateDeliveryPlanningBatchMutation, UpdateDeliveryPlanningBatchMutationVariables>;

/**
 * __useUpdateDeliveryPlanningBatchMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryPlanningBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryPlanningBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryPlanningBatchMutation, { data, loading, error }] = useUpdateDeliveryPlanningBatchMutation({
 *   variables: {
 *      deliveryPlanningBatchUpdate: // value for 'deliveryPlanningBatchUpdate'
 *   },
 * });
 */
export function useUpdateDeliveryPlanningBatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryPlanningBatchMutation, UpdateDeliveryPlanningBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryPlanningBatchMutation, UpdateDeliveryPlanningBatchMutationVariables>(UpdateDeliveryPlanningBatchDocument, options);
      }
export type UpdateDeliveryPlanningBatchMutationHookResult = ReturnType<typeof useUpdateDeliveryPlanningBatchMutation>;
export type UpdateDeliveryPlanningBatchMutationResult = Apollo.MutationResult<UpdateDeliveryPlanningBatchMutation>;
export type UpdateDeliveryPlanningBatchMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryPlanningBatchMutation, UpdateDeliveryPlanningBatchMutationVariables>;
export const AddClosingDateRangeToSitesDocument = gql`
    mutation ADD_CLOSING_DATE_RANGE_TO_SITES($siteIds: [ID!]!, $range: SiteClosingDatesRangeInput!) {
  addClosingDateRangeToSites(siteIds: $siteIds, range: $range) {
    success
  }
}
    `;
export type AddClosingDateRangeToSitesMutationFn = Apollo.MutationFunction<AddClosingDateRangeToSitesMutation, AddClosingDateRangeToSitesMutationVariables>;

/**
 * __useAddClosingDateRangeToSitesMutation__
 *
 * To run a mutation, you first call `useAddClosingDateRangeToSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClosingDateRangeToSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClosingDateRangeToSitesMutation, { data, loading, error }] = useAddClosingDateRangeToSitesMutation({
 *   variables: {
 *      siteIds: // value for 'siteIds'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useAddClosingDateRangeToSitesMutation(baseOptions?: Apollo.MutationHookOptions<AddClosingDateRangeToSitesMutation, AddClosingDateRangeToSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClosingDateRangeToSitesMutation, AddClosingDateRangeToSitesMutationVariables>(AddClosingDateRangeToSitesDocument, options);
      }
export type AddClosingDateRangeToSitesMutationHookResult = ReturnType<typeof useAddClosingDateRangeToSitesMutation>;
export type AddClosingDateRangeToSitesMutationResult = Apollo.MutationResult<AddClosingDateRangeToSitesMutation>;
export type AddClosingDateRangeToSitesMutationOptions = Apollo.BaseMutationOptions<AddClosingDateRangeToSitesMutation, AddClosingDateRangeToSitesMutationVariables>;
export const CreateDeliveryZoneDocument = gql`
    mutation CREATE_DELIVERY_ZONE($input: CreateDeliveryZoneInput!) {
  createDeliveryZone(input: $input) {
    ...DeliveryZoneFragment
  }
}
    ${DeliveryZoneFragmentFragmentDoc}`;
export type CreateDeliveryZoneMutationFn = Apollo.MutationFunction<CreateDeliveryZoneMutation, CreateDeliveryZoneMutationVariables>;

/**
 * __useCreateDeliveryZoneMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryZoneMutation, { data, loading, error }] = useCreateDeliveryZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeliveryZoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliveryZoneMutation, CreateDeliveryZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliveryZoneMutation, CreateDeliveryZoneMutationVariables>(CreateDeliveryZoneDocument, options);
      }
export type CreateDeliveryZoneMutationHookResult = ReturnType<typeof useCreateDeliveryZoneMutation>;
export type CreateDeliveryZoneMutationResult = Apollo.MutationResult<CreateDeliveryZoneMutation>;
export type CreateDeliveryZoneMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryZoneMutation, CreateDeliveryZoneMutationVariables>;
export const UpdateDeliveryZoneDocument = gql`
    mutation UPDATE_DELIVERY_ZONE($_id: ID!, $input: UpdateDeliveryZoneInput!) {
  updateDeliveryZone(_id: $_id, input: $input) {
    ...DeliveryZoneFragment
  }
}
    ${DeliveryZoneFragmentFragmentDoc}`;
export type UpdateDeliveryZoneMutationFn = Apollo.MutationFunction<UpdateDeliveryZoneMutation, UpdateDeliveryZoneMutationVariables>;

/**
 * __useUpdateDeliveryZoneMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryZoneMutation, { data, loading, error }] = useUpdateDeliveryZoneMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeliveryZoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryZoneMutation, UpdateDeliveryZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryZoneMutation, UpdateDeliveryZoneMutationVariables>(UpdateDeliveryZoneDocument, options);
      }
export type UpdateDeliveryZoneMutationHookResult = ReturnType<typeof useUpdateDeliveryZoneMutation>;
export type UpdateDeliveryZoneMutationResult = Apollo.MutationResult<UpdateDeliveryZoneMutation>;
export type UpdateDeliveryZoneMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryZoneMutation, UpdateDeliveryZoneMutationVariables>;
export const AssignSitesToDeliveryZoneDocument = gql`
    mutation ASSIGN_SITES_TO_DELIVERY_ZONE($deliveryZoneId: ID, $siteIds: [ID!]!) {
  assignSitesToDeliveryZone(deliveryZoneId: $deliveryZoneId, siteIds: $siteIds) {
    success
    modifiedCount
  }
}
    `;
export type AssignSitesToDeliveryZoneMutationFn = Apollo.MutationFunction<AssignSitesToDeliveryZoneMutation, AssignSitesToDeliveryZoneMutationVariables>;

/**
 * __useAssignSitesToDeliveryZoneMutation__
 *
 * To run a mutation, you first call `useAssignSitesToDeliveryZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignSitesToDeliveryZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignSitesToDeliveryZoneMutation, { data, loading, error }] = useAssignSitesToDeliveryZoneMutation({
 *   variables: {
 *      deliveryZoneId: // value for 'deliveryZoneId'
 *      siteIds: // value for 'siteIds'
 *   },
 * });
 */
export function useAssignSitesToDeliveryZoneMutation(baseOptions?: Apollo.MutationHookOptions<AssignSitesToDeliveryZoneMutation, AssignSitesToDeliveryZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignSitesToDeliveryZoneMutation, AssignSitesToDeliveryZoneMutationVariables>(AssignSitesToDeliveryZoneDocument, options);
      }
export type AssignSitesToDeliveryZoneMutationHookResult = ReturnType<typeof useAssignSitesToDeliveryZoneMutation>;
export type AssignSitesToDeliveryZoneMutationResult = Apollo.MutationResult<AssignSitesToDeliveryZoneMutation>;
export type AssignSitesToDeliveryZoneMutationOptions = Apollo.BaseMutationOptions<AssignSitesToDeliveryZoneMutation, AssignSitesToDeliveryZoneMutationVariables>;
export const UpdateDynamicDeliveryPlanningBatchDocument = gql`
    mutation UPDATE_DYNAMIC_DELIVERY_PLANNING_BATCH($updates: [DynamicDeliveryPlanningBatchUpdateInput!]!) {
  updateDynamicDeliveryPlanningBatch(updates: $updates) {
    dynamicDeliveryPlannings {
      _id
      isActive
      isManual
    }
  }
}
    `;
export type UpdateDynamicDeliveryPlanningBatchMutationFn = Apollo.MutationFunction<UpdateDynamicDeliveryPlanningBatchMutation, UpdateDynamicDeliveryPlanningBatchMutationVariables>;

/**
 * __useUpdateDynamicDeliveryPlanningBatchMutation__
 *
 * To run a mutation, you first call `useUpdateDynamicDeliveryPlanningBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDynamicDeliveryPlanningBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDynamicDeliveryPlanningBatchMutation, { data, loading, error }] = useUpdateDynamicDeliveryPlanningBatchMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateDynamicDeliveryPlanningBatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDynamicDeliveryPlanningBatchMutation, UpdateDynamicDeliveryPlanningBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDynamicDeliveryPlanningBatchMutation, UpdateDynamicDeliveryPlanningBatchMutationVariables>(UpdateDynamicDeliveryPlanningBatchDocument, options);
      }
export type UpdateDynamicDeliveryPlanningBatchMutationHookResult = ReturnType<typeof useUpdateDynamicDeliveryPlanningBatchMutation>;
export type UpdateDynamicDeliveryPlanningBatchMutationResult = Apollo.MutationResult<UpdateDynamicDeliveryPlanningBatchMutation>;
export type UpdateDynamicDeliveryPlanningBatchMutationOptions = Apollo.BaseMutationOptions<UpdateDynamicDeliveryPlanningBatchMutation, UpdateDynamicDeliveryPlanningBatchMutationVariables>;
export const UpdateDynamicDeliveryPlanningDelivererDocument = gql`
    mutation UPDATE_DYNAMIC_DELIVERY_PLANNING_DELIVERER($planningIds: [ID!]!, $delivererId: ID) {
  updateDynamicDeliveryPlanningDeliverer(
    planningIds: $planningIds
    delivererId: $delivererId
  ) {
    dynamicDeliveryPlannings {
      _id
      tourOrder
      assignedDelivererId
      assignedDeliverer {
        _id
        profile {
          fullname
        }
      }
    }
  }
}
    `;
export type UpdateDynamicDeliveryPlanningDelivererMutationFn = Apollo.MutationFunction<UpdateDynamicDeliveryPlanningDelivererMutation, UpdateDynamicDeliveryPlanningDelivererMutationVariables>;

/**
 * __useUpdateDynamicDeliveryPlanningDelivererMutation__
 *
 * To run a mutation, you first call `useUpdateDynamicDeliveryPlanningDelivererMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDynamicDeliveryPlanningDelivererMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDynamicDeliveryPlanningDelivererMutation, { data, loading, error }] = useUpdateDynamicDeliveryPlanningDelivererMutation({
 *   variables: {
 *      planningIds: // value for 'planningIds'
 *      delivererId: // value for 'delivererId'
 *   },
 * });
 */
export function useUpdateDynamicDeliveryPlanningDelivererMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDynamicDeliveryPlanningDelivererMutation, UpdateDynamicDeliveryPlanningDelivererMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDynamicDeliveryPlanningDelivererMutation, UpdateDynamicDeliveryPlanningDelivererMutationVariables>(UpdateDynamicDeliveryPlanningDelivererDocument, options);
      }
export type UpdateDynamicDeliveryPlanningDelivererMutationHookResult = ReturnType<typeof useUpdateDynamicDeliveryPlanningDelivererMutation>;
export type UpdateDynamicDeliveryPlanningDelivererMutationResult = Apollo.MutationResult<UpdateDynamicDeliveryPlanningDelivererMutation>;
export type UpdateDynamicDeliveryPlanningDelivererMutationOptions = Apollo.BaseMutationOptions<UpdateDynamicDeliveryPlanningDelivererMutation, UpdateDynamicDeliveryPlanningDelivererMutationVariables>;
export const ReorderDynamicDeliveryPlanningTourDocument = gql`
    mutation REORDER_DYNAMIC_DELIVERY_PLANNING_TOUR($planningIds: [ID!]!) {
  reorderDynamicDeliveryPlanningTour(planningIds: $planningIds) {
    dynamicDeliveryPlannings {
      _id
      tourOrder
    }
  }
}
    `;
export type ReorderDynamicDeliveryPlanningTourMutationFn = Apollo.MutationFunction<ReorderDynamicDeliveryPlanningTourMutation, ReorderDynamicDeliveryPlanningTourMutationVariables>;

/**
 * __useReorderDynamicDeliveryPlanningTourMutation__
 *
 * To run a mutation, you first call `useReorderDynamicDeliveryPlanningTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderDynamicDeliveryPlanningTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderDynamicDeliveryPlanningTourMutation, { data, loading, error }] = useReorderDynamicDeliveryPlanningTourMutation({
 *   variables: {
 *      planningIds: // value for 'planningIds'
 *   },
 * });
 */
export function useReorderDynamicDeliveryPlanningTourMutation(baseOptions?: Apollo.MutationHookOptions<ReorderDynamicDeliveryPlanningTourMutation, ReorderDynamicDeliveryPlanningTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderDynamicDeliveryPlanningTourMutation, ReorderDynamicDeliveryPlanningTourMutationVariables>(ReorderDynamicDeliveryPlanningTourDocument, options);
      }
export type ReorderDynamicDeliveryPlanningTourMutationHookResult = ReturnType<typeof useReorderDynamicDeliveryPlanningTourMutation>;
export type ReorderDynamicDeliveryPlanningTourMutationResult = Apollo.MutationResult<ReorderDynamicDeliveryPlanningTourMutation>;
export type ReorderDynamicDeliveryPlanningTourMutationOptions = Apollo.BaseMutationOptions<ReorderDynamicDeliveryPlanningTourMutation, ReorderDynamicDeliveryPlanningTourMutationVariables>;
export const RegenerateDynamicDeliveryPlanningsDocument = gql`
    mutation REGENERATE_DYNAMIC_DELIVERY_PLANNINGS($date: String!, $overrideManualChanges: Boolean) {
  regenerateDynamicDeliveryPlannings(
    date: $date
    overrideManualChanges: $overrideManualChanges
  ) {
    success
    error
  }
}
    `;
export type RegenerateDynamicDeliveryPlanningsMutationFn = Apollo.MutationFunction<RegenerateDynamicDeliveryPlanningsMutation, RegenerateDynamicDeliveryPlanningsMutationVariables>;

/**
 * __useRegenerateDynamicDeliveryPlanningsMutation__
 *
 * To run a mutation, you first call `useRegenerateDynamicDeliveryPlanningsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateDynamicDeliveryPlanningsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateDynamicDeliveryPlanningsMutation, { data, loading, error }] = useRegenerateDynamicDeliveryPlanningsMutation({
 *   variables: {
 *      date: // value for 'date'
 *      overrideManualChanges: // value for 'overrideManualChanges'
 *   },
 * });
 */
export function useRegenerateDynamicDeliveryPlanningsMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateDynamicDeliveryPlanningsMutation, RegenerateDynamicDeliveryPlanningsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateDynamicDeliveryPlanningsMutation, RegenerateDynamicDeliveryPlanningsMutationVariables>(RegenerateDynamicDeliveryPlanningsDocument, options);
      }
export type RegenerateDynamicDeliveryPlanningsMutationHookResult = ReturnType<typeof useRegenerateDynamicDeliveryPlanningsMutation>;
export type RegenerateDynamicDeliveryPlanningsMutationResult = Apollo.MutationResult<RegenerateDynamicDeliveryPlanningsMutation>;
export type RegenerateDynamicDeliveryPlanningsMutationOptions = Apollo.BaseMutationOptions<RegenerateDynamicDeliveryPlanningsMutation, RegenerateDynamicDeliveryPlanningsMutationVariables>;
export const CreateEquipmentDocument = gql`
    mutation CREATE_EQUIPMENT($createFields: EquipmentUpdateFields!) {
  createEquipment(createFields: $createFields) {
    equipment {
      ...Equipment
    }
    error
    success
  }
}
    ${EquipmentFragmentDoc}`;
export type CreateEquipmentMutationFn = Apollo.MutationFunction<CreateEquipmentMutation, CreateEquipmentMutationVariables>;

/**
 * __useCreateEquipmentMutation__
 *
 * To run a mutation, you first call `useCreateEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEquipmentMutation, { data, loading, error }] = useCreateEquipmentMutation({
 *   variables: {
 *      createFields: // value for 'createFields'
 *   },
 * });
 */
export function useCreateEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateEquipmentMutation, CreateEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEquipmentMutation, CreateEquipmentMutationVariables>(CreateEquipmentDocument, options);
      }
export type CreateEquipmentMutationHookResult = ReturnType<typeof useCreateEquipmentMutation>;
export type CreateEquipmentMutationResult = Apollo.MutationResult<CreateEquipmentMutation>;
export type CreateEquipmentMutationOptions = Apollo.BaseMutationOptions<CreateEquipmentMutation, CreateEquipmentMutationVariables>;
export const UpdateEquipmentDocument = gql`
    mutation UPDATE_EQUIPMENT($equipmentId: ID!, $updateFields: EquipmentUpdateFields!) {
  updateEquipment(equipmentId: $equipmentId, updateFields: $updateFields) {
    equipment {
      ...Equipment
    }
    error
    success
  }
}
    ${EquipmentFragmentDoc}`;
export type UpdateEquipmentMutationFn = Apollo.MutationFunction<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>;

/**
 * __useUpdateEquipmentMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentMutation, { data, loading, error }] = useUpdateEquipmentMutation({
 *   variables: {
 *      equipmentId: // value for 'equipmentId'
 *      updateFields: // value for 'updateFields'
 *   },
 * });
 */
export function useUpdateEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>(UpdateEquipmentDocument, options);
      }
export type UpdateEquipmentMutationHookResult = ReturnType<typeof useUpdateEquipmentMutation>;
export type UpdateEquipmentMutationResult = Apollo.MutationResult<UpdateEquipmentMutation>;
export type UpdateEquipmentMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>;
export const UpdateEquipmentStateDocument = gql`
    mutation UPDATE_EQUIPMENT_STATE($equipmentId: ID!, $stateToSet: EquipmentState!) {
  updateEquipmentState(equipmentId: $equipmentId, stateToSet: $stateToSet) {
    success
    error
    equipment {
      ...Equipment
    }
  }
}
    ${EquipmentFragmentDoc}`;
export type UpdateEquipmentStateMutationFn = Apollo.MutationFunction<UpdateEquipmentStateMutation, UpdateEquipmentStateMutationVariables>;

/**
 * __useUpdateEquipmentStateMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentStateMutation, { data, loading, error }] = useUpdateEquipmentStateMutation({
 *   variables: {
 *      equipmentId: // value for 'equipmentId'
 *      stateToSet: // value for 'stateToSet'
 *   },
 * });
 */
export function useUpdateEquipmentStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentStateMutation, UpdateEquipmentStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentStateMutation, UpdateEquipmentStateMutationVariables>(UpdateEquipmentStateDocument, options);
      }
export type UpdateEquipmentStateMutationHookResult = ReturnType<typeof useUpdateEquipmentStateMutation>;
export type UpdateEquipmentStateMutationResult = Apollo.MutationResult<UpdateEquipmentStateMutation>;
export type UpdateEquipmentStateMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentStateMutation, UpdateEquipmentStateMutationVariables>;
export const GetImpersonationTokenDocument = gql`
    mutation GET_IMPERSONATION_TOKEN($impersonatedUserId: String!, $impersonatedOrganizationName: String!) {
  getConnectionToken(
    impersonatedUserId: $impersonatedUserId
    impersonatedOrganizationName: $impersonatedOrganizationName
  ) {
    success
    error
    connectionToken
  }
}
    `;
export type GetImpersonationTokenMutationFn = Apollo.MutationFunction<GetImpersonationTokenMutation, GetImpersonationTokenMutationVariables>;

/**
 * __useGetImpersonationTokenMutation__
 *
 * To run a mutation, you first call `useGetImpersonationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetImpersonationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getImpersonationTokenMutation, { data, loading, error }] = useGetImpersonationTokenMutation({
 *   variables: {
 *      impersonatedUserId: // value for 'impersonatedUserId'
 *      impersonatedOrganizationName: // value for 'impersonatedOrganizationName'
 *   },
 * });
 */
export function useGetImpersonationTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetImpersonationTokenMutation, GetImpersonationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetImpersonationTokenMutation, GetImpersonationTokenMutationVariables>(GetImpersonationTokenDocument, options);
      }
export type GetImpersonationTokenMutationHookResult = ReturnType<typeof useGetImpersonationTokenMutation>;
export type GetImpersonationTokenMutationResult = Apollo.MutationResult<GetImpersonationTokenMutation>;
export type GetImpersonationTokenMutationOptions = Apollo.BaseMutationOptions<GetImpersonationTokenMutation, GetImpersonationTokenMutationVariables>;
export const UpdateLocationsStateDocument = gql`
    mutation UPDATE_LOCATIONS_STATE($locationIds: [String!]!, $stateToSet: LocationState!) {
  updateLocationsState(locationIds: $locationIds, stateToSet: $stateToSet) {
    locations {
      _id
      datamatrix
      state
    }
    error
    warnings
  }
}
    `;
export type UpdateLocationsStateMutationFn = Apollo.MutationFunction<UpdateLocationsStateMutation, UpdateLocationsStateMutationVariables>;

/**
 * __useUpdateLocationsStateMutation__
 *
 * To run a mutation, you first call `useUpdateLocationsStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationsStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationsStateMutation, { data, loading, error }] = useUpdateLocationsStateMutation({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *      stateToSet: // value for 'stateToSet'
 *   },
 * });
 */
export function useUpdateLocationsStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationsStateMutation, UpdateLocationsStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationsStateMutation, UpdateLocationsStateMutationVariables>(UpdateLocationsStateDocument, options);
      }
export type UpdateLocationsStateMutationHookResult = ReturnType<typeof useUpdateLocationsStateMutation>;
export type UpdateLocationsStateMutationResult = Apollo.MutationResult<UpdateLocationsStateMutation>;
export type UpdateLocationsStateMutationOptions = Apollo.BaseMutationOptions<UpdateLocationsStateMutation, UpdateLocationsStateMutationVariables>;
export const AssignReserveLocationDocument = gql`
    mutation ASSIGN_RESERVE_LOCATION($productId: ID!, $datamatrix: String!, $warehouseColumnId: ID!) {
  assignReserveLocation(
    productId: $productId
    datamatrix: $datamatrix
    warehouseColumnId: $warehouseColumnId
  ) {
    location {
      _id
      datamatrix
      locationType
    }
    error
  }
}
    `;
export type AssignReserveLocationMutationFn = Apollo.MutationFunction<AssignReserveLocationMutation, AssignReserveLocationMutationVariables>;

/**
 * __useAssignReserveLocationMutation__
 *
 * To run a mutation, you first call `useAssignReserveLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignReserveLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignReserveLocationMutation, { data, loading, error }] = useAssignReserveLocationMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      datamatrix: // value for 'datamatrix'
 *      warehouseColumnId: // value for 'warehouseColumnId'
 *   },
 * });
 */
export function useAssignReserveLocationMutation(baseOptions?: Apollo.MutationHookOptions<AssignReserveLocationMutation, AssignReserveLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignReserveLocationMutation, AssignReserveLocationMutationVariables>(AssignReserveLocationDocument, options);
      }
export type AssignReserveLocationMutationHookResult = ReturnType<typeof useAssignReserveLocationMutation>;
export type AssignReserveLocationMutationResult = Apollo.MutationResult<AssignReserveLocationMutation>;
export type AssignReserveLocationMutationOptions = Apollo.BaseMutationOptions<AssignReserveLocationMutation, AssignReserveLocationMutationVariables>;
export const UpdateLocationTypeDocument = gql`
    mutation UPDATE_LOCATION_TYPE($locationId: ID!, $locationType: LocationType!) {
  updateLocationType(locationId: $locationId, locationType: $locationType) {
    _id
    locationType
  }
}
    `;
export type UpdateLocationTypeMutationFn = Apollo.MutationFunction<UpdateLocationTypeMutation, UpdateLocationTypeMutationVariables>;

/**
 * __useUpdateLocationTypeMutation__
 *
 * To run a mutation, you first call `useUpdateLocationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationTypeMutation, { data, loading, error }] = useUpdateLocationTypeMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      locationType: // value for 'locationType'
 *   },
 * });
 */
export function useUpdateLocationTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationTypeMutation, UpdateLocationTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationTypeMutation, UpdateLocationTypeMutationVariables>(UpdateLocationTypeDocument, options);
      }
export type UpdateLocationTypeMutationHookResult = ReturnType<typeof useUpdateLocationTypeMutation>;
export type UpdateLocationTypeMutationResult = Apollo.MutationResult<UpdateLocationTypeMutation>;
export type UpdateLocationTypeMutationOptions = Apollo.BaseMutationOptions<UpdateLocationTypeMutation, UpdateLocationTypeMutationVariables>;
export const SwapProductLocationsDocument = gql`
    mutation SWAP_PRODUCT_LOCATIONS($locationIds: [String!]!) {
  swapProductLocations(locationIds: $locationIds) {
    locations {
      _id
      productId
      product {
        name
      }
    }
    error
    warnings
  }
}
    `;
export type SwapProductLocationsMutationFn = Apollo.MutationFunction<SwapProductLocationsMutation, SwapProductLocationsMutationVariables>;

/**
 * __useSwapProductLocationsMutation__
 *
 * To run a mutation, you first call `useSwapProductLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapProductLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapProductLocationsMutation, { data, loading, error }] = useSwapProductLocationsMutation({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useSwapProductLocationsMutation(baseOptions?: Apollo.MutationHookOptions<SwapProductLocationsMutation, SwapProductLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwapProductLocationsMutation, SwapProductLocationsMutationVariables>(SwapProductLocationsDocument, options);
      }
export type SwapProductLocationsMutationHookResult = ReturnType<typeof useSwapProductLocationsMutation>;
export type SwapProductLocationsMutationResult = Apollo.MutationResult<SwapProductLocationsMutation>;
export type SwapProductLocationsMutationOptions = Apollo.BaseMutationOptions<SwapProductLocationsMutation, SwapProductLocationsMutationVariables>;
export const AssignLocationToProductDocument = gql`
    mutation ASSIGN_LOCATION_TO_PRODUCT($productId: ID!, $datamatrix: String!, $warehouseColumnId: ID!, $locationType: LocationType!) {
  assignLocationToProduct(
    productId: $productId
    datamatrix: $datamatrix
    warehouseColumnId: $warehouseColumnId
    locationType: $locationType
  ) {
    location {
      _id
      datamatrix
      locationType
    }
    error
  }
}
    `;
export type AssignLocationToProductMutationFn = Apollo.MutationFunction<AssignLocationToProductMutation, AssignLocationToProductMutationVariables>;

/**
 * __useAssignLocationToProductMutation__
 *
 * To run a mutation, you first call `useAssignLocationToProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignLocationToProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignLocationToProductMutation, { data, loading, error }] = useAssignLocationToProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      datamatrix: // value for 'datamatrix'
 *      warehouseColumnId: // value for 'warehouseColumnId'
 *      locationType: // value for 'locationType'
 *   },
 * });
 */
export function useAssignLocationToProductMutation(baseOptions?: Apollo.MutationHookOptions<AssignLocationToProductMutation, AssignLocationToProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignLocationToProductMutation, AssignLocationToProductMutationVariables>(AssignLocationToProductDocument, options);
      }
export type AssignLocationToProductMutationHookResult = ReturnType<typeof useAssignLocationToProductMutation>;
export type AssignLocationToProductMutationResult = Apollo.MutationResult<AssignLocationToProductMutation>;
export type AssignLocationToProductMutationOptions = Apollo.BaseMutationOptions<AssignLocationToProductMutation, AssignLocationToProductMutationVariables>;
export const UnassignLocationFromProductDocument = gql`
    mutation UNASSIGN_LOCATION_FROM_PRODUCT($productId: ID!, $datamatrix: String!, $warehouseColumnId: ID!) {
  unassignLocationFromProduct(
    productId: $productId
    datamatrix: $datamatrix
    warehouseColumnId: $warehouseColumnId
  ) {
    location {
      _id
      datamatrix
    }
    error
  }
}
    `;
export type UnassignLocationFromProductMutationFn = Apollo.MutationFunction<UnassignLocationFromProductMutation, UnassignLocationFromProductMutationVariables>;

/**
 * __useUnassignLocationFromProductMutation__
 *
 * To run a mutation, you first call `useUnassignLocationFromProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignLocationFromProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignLocationFromProductMutation, { data, loading, error }] = useUnassignLocationFromProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      datamatrix: // value for 'datamatrix'
 *      warehouseColumnId: // value for 'warehouseColumnId'
 *   },
 * });
 */
export function useUnassignLocationFromProductMutation(baseOptions?: Apollo.MutationHookOptions<UnassignLocationFromProductMutation, UnassignLocationFromProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignLocationFromProductMutation, UnassignLocationFromProductMutationVariables>(UnassignLocationFromProductDocument, options);
      }
export type UnassignLocationFromProductMutationHookResult = ReturnType<typeof useUnassignLocationFromProductMutation>;
export type UnassignLocationFromProductMutationResult = Apollo.MutationResult<UnassignLocationFromProductMutation>;
export type UnassignLocationFromProductMutationOptions = Apollo.BaseMutationOptions<UnassignLocationFromProductMutation, UnassignLocationFromProductMutationVariables>;
export const UpdateManualSupplyOrdersDocument = gql`
    mutation UPDATE_MANUAL_SUPPLY_ORDERS($supplyOrders: [ManualSupplyOrderUpdateInput!]!) {
  updateManualSupplyOrders(supplyOrders: $supplyOrders) {
    success
    errors
    formErrors {
      sectionName
      sectionErrors {
        fieldName
        fieldError
      }
    }
    warnings
    updatedSupplyOrders {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type UpdateManualSupplyOrdersMutationFn = Apollo.MutationFunction<UpdateManualSupplyOrdersMutation, UpdateManualSupplyOrdersMutationVariables>;

/**
 * __useUpdateManualSupplyOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateManualSupplyOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManualSupplyOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManualSupplyOrdersMutation, { data, loading, error }] = useUpdateManualSupplyOrdersMutation({
 *   variables: {
 *      supplyOrders: // value for 'supplyOrders'
 *   },
 * });
 */
export function useUpdateManualSupplyOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManualSupplyOrdersMutation, UpdateManualSupplyOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManualSupplyOrdersMutation, UpdateManualSupplyOrdersMutationVariables>(UpdateManualSupplyOrdersDocument, options);
      }
export type UpdateManualSupplyOrdersMutationHookResult = ReturnType<typeof useUpdateManualSupplyOrdersMutation>;
export type UpdateManualSupplyOrdersMutationResult = Apollo.MutationResult<UpdateManualSupplyOrdersMutation>;
export type UpdateManualSupplyOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateManualSupplyOrdersMutation, UpdateManualSupplyOrdersMutationVariables>;
export const UpdateManualSupplyOrderProductStockVariationsDocument = gql`
    mutation UPDATE_MANUAL_SUPPLY_ORDER_PRODUCT_STOCK_VARIATIONS($supplyOrderIds: [ID!]!) {
  updateManualSupplyOrderProductStockVariations(supplyOrderIds: $supplyOrderIds) {
    success
    supplyOrderProductStockVariations {
      productGroupStockVariations {
        ...SupplyOrderProductStockVariationFragment
        isComputed
      }
      supplyOrderStockVariations {
        ...SupplyOrderProductStockVariationFragment
        isComputed
      }
    }
  }
}
    ${SupplyOrderProductStockVariationFragmentFragmentDoc}`;
export type UpdateManualSupplyOrderProductStockVariationsMutationFn = Apollo.MutationFunction<UpdateManualSupplyOrderProductStockVariationsMutation, UpdateManualSupplyOrderProductStockVariationsMutationVariables>;

/**
 * __useUpdateManualSupplyOrderProductStockVariationsMutation__
 *
 * To run a mutation, you first call `useUpdateManualSupplyOrderProductStockVariationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManualSupplyOrderProductStockVariationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManualSupplyOrderProductStockVariationsMutation, { data, loading, error }] = useUpdateManualSupplyOrderProductStockVariationsMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *   },
 * });
 */
export function useUpdateManualSupplyOrderProductStockVariationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManualSupplyOrderProductStockVariationsMutation, UpdateManualSupplyOrderProductStockVariationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManualSupplyOrderProductStockVariationsMutation, UpdateManualSupplyOrderProductStockVariationsMutationVariables>(UpdateManualSupplyOrderProductStockVariationsDocument, options);
      }
export type UpdateManualSupplyOrderProductStockVariationsMutationHookResult = ReturnType<typeof useUpdateManualSupplyOrderProductStockVariationsMutation>;
export type UpdateManualSupplyOrderProductStockVariationsMutationResult = Apollo.MutationResult<UpdateManualSupplyOrderProductStockVariationsMutation>;
export type UpdateManualSupplyOrderProductStockVariationsMutationOptions = Apollo.BaseMutationOptions<UpdateManualSupplyOrderProductStockVariationsMutation, UpdateManualSupplyOrderProductStockVariationsMutationVariables>;
export const UpdateManualSupplyOrderForecastsDocument = gql`
    mutation UPDATE_MANUAL_SUPPLY_ORDER_FORECASTS($supplyOrderIds: [ID!]!) {
  updateManualSupplyOrderForecasts(supplyOrderIds: $supplyOrderIds) {
    success
    updatedSupplyOrders {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type UpdateManualSupplyOrderForecastsMutationFn = Apollo.MutationFunction<UpdateManualSupplyOrderForecastsMutation, UpdateManualSupplyOrderForecastsMutationVariables>;

/**
 * __useUpdateManualSupplyOrderForecastsMutation__
 *
 * To run a mutation, you first call `useUpdateManualSupplyOrderForecastsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManualSupplyOrderForecastsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManualSupplyOrderForecastsMutation, { data, loading, error }] = useUpdateManualSupplyOrderForecastsMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *   },
 * });
 */
export function useUpdateManualSupplyOrderForecastsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManualSupplyOrderForecastsMutation, UpdateManualSupplyOrderForecastsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManualSupplyOrderForecastsMutation, UpdateManualSupplyOrderForecastsMutationVariables>(UpdateManualSupplyOrderForecastsDocument, options);
      }
export type UpdateManualSupplyOrderForecastsMutationHookResult = ReturnType<typeof useUpdateManualSupplyOrderForecastsMutation>;
export type UpdateManualSupplyOrderForecastsMutationResult = Apollo.MutationResult<UpdateManualSupplyOrderForecastsMutation>;
export type UpdateManualSupplyOrderForecastsMutationOptions = Apollo.BaseMutationOptions<UpdateManualSupplyOrderForecastsMutation, UpdateManualSupplyOrderForecastsMutationVariables>;
export const AddProductsToManualSupplyOrderDocument = gql`
    mutation ADD_PRODUCTS_TO_MANUAL_SUPPLY_ORDER($supplyOrderId: ID!, $productIds: [ID!]!) {
  addProductsToManualSupplyOrder(
    supplyOrderId: $supplyOrderId
    productIds: $productIds
  ) {
    ...SupplyOrderWithSupplierProductsInfoFragment
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type AddProductsToManualSupplyOrderMutationFn = Apollo.MutationFunction<AddProductsToManualSupplyOrderMutation, AddProductsToManualSupplyOrderMutationVariables>;

/**
 * __useAddProductsToManualSupplyOrderMutation__
 *
 * To run a mutation, you first call `useAddProductsToManualSupplyOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductsToManualSupplyOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductsToManualSupplyOrderMutation, { data, loading, error }] = useAddProductsToManualSupplyOrderMutation({
 *   variables: {
 *      supplyOrderId: // value for 'supplyOrderId'
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useAddProductsToManualSupplyOrderMutation(baseOptions?: Apollo.MutationHookOptions<AddProductsToManualSupplyOrderMutation, AddProductsToManualSupplyOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductsToManualSupplyOrderMutation, AddProductsToManualSupplyOrderMutationVariables>(AddProductsToManualSupplyOrderDocument, options);
      }
export type AddProductsToManualSupplyOrderMutationHookResult = ReturnType<typeof useAddProductsToManualSupplyOrderMutation>;
export type AddProductsToManualSupplyOrderMutationResult = Apollo.MutationResult<AddProductsToManualSupplyOrderMutation>;
export type AddProductsToManualSupplyOrderMutationOptions = Apollo.BaseMutationOptions<AddProductsToManualSupplyOrderMutation, AddProductsToManualSupplyOrderMutationVariables>;
export const UpdateMenuInstructionsDocument = gql`
    mutation UPDATE_MENU_INSTRUCTIONS($menuInstructionInputs: [MenuInstructionInput!]!) {
  createOrUpdateMenuInstructions(menuInstructionInputs: $menuInstructionInputs) {
    ...MenuInstructionFragment
  }
}
    ${MenuInstructionFragmentFragmentDoc}`;
export type UpdateMenuInstructionsMutationFn = Apollo.MutationFunction<UpdateMenuInstructionsMutation, UpdateMenuInstructionsMutationVariables>;

/**
 * __useUpdateMenuInstructionsMutation__
 *
 * To run a mutation, you first call `useUpdateMenuInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuInstructionsMutation, { data, loading, error }] = useUpdateMenuInstructionsMutation({
 *   variables: {
 *      menuInstructionInputs: // value for 'menuInstructionInputs'
 *   },
 * });
 */
export function useUpdateMenuInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuInstructionsMutation, UpdateMenuInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuInstructionsMutation, UpdateMenuInstructionsMutationVariables>(UpdateMenuInstructionsDocument, options);
      }
export type UpdateMenuInstructionsMutationHookResult = ReturnType<typeof useUpdateMenuInstructionsMutation>;
export type UpdateMenuInstructionsMutationResult = Apollo.MutationResult<UpdateMenuInstructionsMutation>;
export type UpdateMenuInstructionsMutationOptions = Apollo.BaseMutationOptions<UpdateMenuInstructionsMutation, UpdateMenuInstructionsMutationVariables>;
export const DeleteMenuInstructionsDocument = gql`
    mutation DELETE_MENU_INSTRUCTIONS($menuInstructionDeleteInputs: [MenuInstructionDeleteInput!]!) {
  deleteMenuInstructions(
    menuInstructionDeleteInputs: $menuInstructionDeleteInputs
  )
}
    `;
export type DeleteMenuInstructionsMutationFn = Apollo.MutationFunction<DeleteMenuInstructionsMutation, DeleteMenuInstructionsMutationVariables>;

/**
 * __useDeleteMenuInstructionsMutation__
 *
 * To run a mutation, you first call `useDeleteMenuInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuInstructionsMutation, { data, loading, error }] = useDeleteMenuInstructionsMutation({
 *   variables: {
 *      menuInstructionDeleteInputs: // value for 'menuInstructionDeleteInputs'
 *   },
 * });
 */
export function useDeleteMenuInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuInstructionsMutation, DeleteMenuInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuInstructionsMutation, DeleteMenuInstructionsMutationVariables>(DeleteMenuInstructionsDocument, options);
      }
export type DeleteMenuInstructionsMutationHookResult = ReturnType<typeof useDeleteMenuInstructionsMutation>;
export type DeleteMenuInstructionsMutationResult = Apollo.MutationResult<DeleteMenuInstructionsMutation>;
export type DeleteMenuInstructionsMutationOptions = Apollo.BaseMutationOptions<DeleteMenuInstructionsMutation, DeleteMenuInstructionsMutationVariables>;
export const UpdateSiteMenusDocument = gql`
    mutation UPDATE_SITE_MENUS($columnId: String!, $date: String!, $locationsToUpdate: [LocationToUpdateInput!]!) {
  updateSiteMenus(
    columnId: $columnId
    date: $date
    locationsToUpdate: $locationsToUpdate
  ) {
    ...SiteMenusFragment
  }
}
    ${SiteMenusFragmentFragmentDoc}`;
export type UpdateSiteMenusMutationFn = Apollo.MutationFunction<UpdateSiteMenusMutation, UpdateSiteMenusMutationVariables>;

/**
 * __useUpdateSiteMenusMutation__
 *
 * To run a mutation, you first call `useUpdateSiteMenusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteMenusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteMenusMutation, { data, loading, error }] = useUpdateSiteMenusMutation({
 *   variables: {
 *      columnId: // value for 'columnId'
 *      date: // value for 'date'
 *      locationsToUpdate: // value for 'locationsToUpdate'
 *   },
 * });
 */
export function useUpdateSiteMenusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteMenusMutation, UpdateSiteMenusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteMenusMutation, UpdateSiteMenusMutationVariables>(UpdateSiteMenusDocument, options);
      }
export type UpdateSiteMenusMutationHookResult = ReturnType<typeof useUpdateSiteMenusMutation>;
export type UpdateSiteMenusMutationResult = Apollo.MutationResult<UpdateSiteMenusMutation>;
export type UpdateSiteMenusMutationOptions = Apollo.BaseMutationOptions<UpdateSiteMenusMutation, UpdateSiteMenusMutationVariables>;
export const UpdateMenuProductArrangementsDocument = gql`
    mutation UPDATE_MENU_PRODUCT_ARRANGEMENTS($date: String!, $productArrangementsToUpdate: [ProductArrangementToUpdateInput!]!) {
  updateMenuProductArrangements(
    date: $date
    productArrangementsToUpdate: $productArrangementsToUpdate
  ) {
    ...MenuProductArrangementFragment
  }
}
    ${MenuProductArrangementFragmentFragmentDoc}`;
export type UpdateMenuProductArrangementsMutationFn = Apollo.MutationFunction<UpdateMenuProductArrangementsMutation, UpdateMenuProductArrangementsMutationVariables>;

/**
 * __useUpdateMenuProductArrangementsMutation__
 *
 * To run a mutation, you first call `useUpdateMenuProductArrangementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuProductArrangementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuProductArrangementsMutation, { data, loading, error }] = useUpdateMenuProductArrangementsMutation({
 *   variables: {
 *      date: // value for 'date'
 *      productArrangementsToUpdate: // value for 'productArrangementsToUpdate'
 *   },
 * });
 */
export function useUpdateMenuProductArrangementsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuProductArrangementsMutation, UpdateMenuProductArrangementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuProductArrangementsMutation, UpdateMenuProductArrangementsMutationVariables>(UpdateMenuProductArrangementsDocument, options);
      }
export type UpdateMenuProductArrangementsMutationHookResult = ReturnType<typeof useUpdateMenuProductArrangementsMutation>;
export type UpdateMenuProductArrangementsMutationResult = Apollo.MutationResult<UpdateMenuProductArrangementsMutation>;
export type UpdateMenuProductArrangementsMutationOptions = Apollo.BaseMutationOptions<UpdateMenuProductArrangementsMutation, UpdateMenuProductArrangementsMutationVariables>;
export const GenerateMenusSupplyOrdersDocument = gql`
    mutation GENERATE_MENUS_SUPPLY_ORDERS($date: String!, $siteIds: [String!], $supplierIds: [String!], $updateOrderProductIfPossible: Boolean) {
  generateMenusSupplyOrders(
    date: $date
    siteIds: $siteIds
    supplierIds: $supplierIds
    updateOrderProductIfPossible: $updateOrderProductIfPossible
  ) {
    success
    error
  }
}
    `;
export type GenerateMenusSupplyOrdersMutationFn = Apollo.MutationFunction<GenerateMenusSupplyOrdersMutation, GenerateMenusSupplyOrdersMutationVariables>;

/**
 * __useGenerateMenusSupplyOrdersMutation__
 *
 * To run a mutation, you first call `useGenerateMenusSupplyOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMenusSupplyOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMenusSupplyOrdersMutation, { data, loading, error }] = useGenerateMenusSupplyOrdersMutation({
 *   variables: {
 *      date: // value for 'date'
 *      siteIds: // value for 'siteIds'
 *      supplierIds: // value for 'supplierIds'
 *      updateOrderProductIfPossible: // value for 'updateOrderProductIfPossible'
 *   },
 * });
 */
export function useGenerateMenusSupplyOrdersMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMenusSupplyOrdersMutation, GenerateMenusSupplyOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMenusSupplyOrdersMutation, GenerateMenusSupplyOrdersMutationVariables>(GenerateMenusSupplyOrdersDocument, options);
      }
export type GenerateMenusSupplyOrdersMutationHookResult = ReturnType<typeof useGenerateMenusSupplyOrdersMutation>;
export type GenerateMenusSupplyOrdersMutationResult = Apollo.MutationResult<GenerateMenusSupplyOrdersMutation>;
export type GenerateMenusSupplyOrdersMutationOptions = Apollo.BaseMutationOptions<GenerateMenusSupplyOrdersMutation, GenerateMenusSupplyOrdersMutationVariables>;
export const GenerateQuantitiesDocument = gql`
    mutation GENERATE_QUANTITIES($mondayDate: String!, $dates: [String!], $locationIds: [String!], $siteIds: [String!], $supplierIds: [String!], $reGenerateMenuFromZero: Boolean!) {
  generateQuantities(
    mondayDate: $mondayDate
    dates: $dates
    locationIds: $locationIds
    siteIds: $siteIds
    supplierIds: $supplierIds
    reGenerateMenuFromZero: $reGenerateMenuFromZero
  ) {
    success
    error
  }
}
    `;
export type GenerateQuantitiesMutationFn = Apollo.MutationFunction<GenerateQuantitiesMutation, GenerateQuantitiesMutationVariables>;

/**
 * __useGenerateQuantitiesMutation__
 *
 * To run a mutation, you first call `useGenerateQuantitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuantitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateQuantitiesMutation, { data, loading, error }] = useGenerateQuantitiesMutation({
 *   variables: {
 *      mondayDate: // value for 'mondayDate'
 *      dates: // value for 'dates'
 *      locationIds: // value for 'locationIds'
 *      siteIds: // value for 'siteIds'
 *      supplierIds: // value for 'supplierIds'
 *      reGenerateMenuFromZero: // value for 'reGenerateMenuFromZero'
 *   },
 * });
 */
export function useGenerateQuantitiesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateQuantitiesMutation, GenerateQuantitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateQuantitiesMutation, GenerateQuantitiesMutationVariables>(GenerateQuantitiesDocument, options);
      }
export type GenerateQuantitiesMutationHookResult = ReturnType<typeof useGenerateQuantitiesMutation>;
export type GenerateQuantitiesMutationResult = Apollo.MutationResult<GenerateQuantitiesMutation>;
export type GenerateQuantitiesMutationOptions = Apollo.BaseMutationOptions<GenerateQuantitiesMutation, GenerateQuantitiesMutationVariables>;
export const GenerateSiteMenusDocument = gql`
    mutation GENERATE_SITE_MENUS($date: String!, $stockMin: Int, $consumptionRatioToApply: Int, $unknownShrinkageRatioToApply: Int, $withoutRotation: Boolean!) {
  generateSiteMenus(
    date: $date
    stockMin: $stockMin
    consumptionRatioToApply: $consumptionRatioToApply
    unknownShrinkageRatioToApply: $unknownShrinkageRatioToApply
    withoutRotation: $withoutRotation
  ) {
    success
    error
  }
}
    `;
export type GenerateSiteMenusMutationFn = Apollo.MutationFunction<GenerateSiteMenusMutation, GenerateSiteMenusMutationVariables>;

/**
 * __useGenerateSiteMenusMutation__
 *
 * To run a mutation, you first call `useGenerateSiteMenusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSiteMenusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSiteMenusMutation, { data, loading, error }] = useGenerateSiteMenusMutation({
 *   variables: {
 *      date: // value for 'date'
 *      stockMin: // value for 'stockMin'
 *      consumptionRatioToApply: // value for 'consumptionRatioToApply'
 *      unknownShrinkageRatioToApply: // value for 'unknownShrinkageRatioToApply'
 *      withoutRotation: // value for 'withoutRotation'
 *   },
 * });
 */
export function useGenerateSiteMenusMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSiteMenusMutation, GenerateSiteMenusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSiteMenusMutation, GenerateSiteMenusMutationVariables>(GenerateSiteMenusDocument, options);
      }
export type GenerateSiteMenusMutationHookResult = ReturnType<typeof useGenerateSiteMenusMutation>;
export type GenerateSiteMenusMutationResult = Apollo.MutationResult<GenerateSiteMenusMutation>;
export type GenerateSiteMenusMutationOptions = Apollo.BaseMutationOptions<GenerateSiteMenusMutation, GenerateSiteMenusMutationVariables>;
export const UpdateMenuFromGsheetDocument = gql`
    mutation UPDATE_MENU_FROM_GSHEET($mondayDate: String!) {
  updateMenuFromGsheet(mondayDate: $mondayDate) {
    success
    error
  }
}
    `;
export type UpdateMenuFromGsheetMutationFn = Apollo.MutationFunction<UpdateMenuFromGsheetMutation, UpdateMenuFromGsheetMutationVariables>;

/**
 * __useUpdateMenuFromGsheetMutation__
 *
 * To run a mutation, you first call `useUpdateMenuFromGsheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuFromGsheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuFromGsheetMutation, { data, loading, error }] = useUpdateMenuFromGsheetMutation({
 *   variables: {
 *      mondayDate: // value for 'mondayDate'
 *   },
 * });
 */
export function useUpdateMenuFromGsheetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuFromGsheetMutation, UpdateMenuFromGsheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuFromGsheetMutation, UpdateMenuFromGsheetMutationVariables>(UpdateMenuFromGsheetDocument, options);
      }
export type UpdateMenuFromGsheetMutationHookResult = ReturnType<typeof useUpdateMenuFromGsheetMutation>;
export type UpdateMenuFromGsheetMutationResult = Apollo.MutationResult<UpdateMenuFromGsheetMutation>;
export type UpdateMenuFromGsheetMutationOptions = Apollo.BaseMutationOptions<UpdateMenuFromGsheetMutation, UpdateMenuFromGsheetMutationVariables>;
export const CreateMessagesSetDocument = gql`
    mutation CREATE_MESSAGES_SET($messagesSetInput: CreateMessagesSetInput!) {
  createMessagesSet(messagesSetInput: $messagesSetInput) {
    success
    errors
    createdMessagesSet {
      ...MessagesSetFragment
    }
  }
}
    ${MessagesSetFragmentFragmentDoc}`;
export type CreateMessagesSetMutationFn = Apollo.MutationFunction<CreateMessagesSetMutation, CreateMessagesSetMutationVariables>;

/**
 * __useCreateMessagesSetMutation__
 *
 * To run a mutation, you first call `useCreateMessagesSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessagesSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessagesSetMutation, { data, loading, error }] = useCreateMessagesSetMutation({
 *   variables: {
 *      messagesSetInput: // value for 'messagesSetInput'
 *   },
 * });
 */
export function useCreateMessagesSetMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessagesSetMutation, CreateMessagesSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessagesSetMutation, CreateMessagesSetMutationVariables>(CreateMessagesSetDocument, options);
      }
export type CreateMessagesSetMutationHookResult = ReturnType<typeof useCreateMessagesSetMutation>;
export type CreateMessagesSetMutationResult = Apollo.MutationResult<CreateMessagesSetMutation>;
export type CreateMessagesSetMutationOptions = Apollo.BaseMutationOptions<CreateMessagesSetMutation, CreateMessagesSetMutationVariables>;
export const UpdateMessagesSetDocument = gql`
    mutation UPDATE_MESSAGES_SET($messagesSetId: ID!, $updateInput: UpdateMessagesSetInput!) {
  updateMessagesSet(messagesSetId: $messagesSetId, updateInput: $updateInput) {
    success
    errors
    updatedMessagesSet {
      ...MessagesSetFragment
    }
  }
}
    ${MessagesSetFragmentFragmentDoc}`;
export type UpdateMessagesSetMutationFn = Apollo.MutationFunction<UpdateMessagesSetMutation, UpdateMessagesSetMutationVariables>;

/**
 * __useUpdateMessagesSetMutation__
 *
 * To run a mutation, you first call `useUpdateMessagesSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessagesSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessagesSetMutation, { data, loading, error }] = useUpdateMessagesSetMutation({
 *   variables: {
 *      messagesSetId: // value for 'messagesSetId'
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateMessagesSetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessagesSetMutation, UpdateMessagesSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessagesSetMutation, UpdateMessagesSetMutationVariables>(UpdateMessagesSetDocument, options);
      }
export type UpdateMessagesSetMutationHookResult = ReturnType<typeof useUpdateMessagesSetMutation>;
export type UpdateMessagesSetMutationResult = Apollo.MutationResult<UpdateMessagesSetMutation>;
export type UpdateMessagesSetMutationOptions = Apollo.BaseMutationOptions<UpdateMessagesSetMutation, UpdateMessagesSetMutationVariables>;
export const UpdateMicrostoreColumnDocument = gql`
    mutation UPDATE_MICROSTORE_COLUMN($microstoreColumnUpdateInput: MicrostoreColumnUpdateInput!) {
  updateMicrostoreColumnMutation(
    microstoreColumnUpdateInput: $microstoreColumnUpdateInput
  ) {
    newMicrostoreColumn {
      ...MicrostoreColumnWithShelvesFragment
    }
    errors
  }
}
    ${MicrostoreColumnWithShelvesFragmentFragmentDoc}`;
export type UpdateMicrostoreColumnMutationFn = Apollo.MutationFunction<UpdateMicrostoreColumnMutation, UpdateMicrostoreColumnMutationVariables>;

/**
 * __useUpdateMicrostoreColumnMutation__
 *
 * To run a mutation, you first call `useUpdateMicrostoreColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMicrostoreColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMicrostoreColumnMutation, { data, loading, error }] = useUpdateMicrostoreColumnMutation({
 *   variables: {
 *      microstoreColumnUpdateInput: // value for 'microstoreColumnUpdateInput'
 *   },
 * });
 */
export function useUpdateMicrostoreColumnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMicrostoreColumnMutation, UpdateMicrostoreColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMicrostoreColumnMutation, UpdateMicrostoreColumnMutationVariables>(UpdateMicrostoreColumnDocument, options);
      }
export type UpdateMicrostoreColumnMutationHookResult = ReturnType<typeof useUpdateMicrostoreColumnMutation>;
export type UpdateMicrostoreColumnMutationResult = Apollo.MutationResult<UpdateMicrostoreColumnMutation>;
export type UpdateMicrostoreColumnMutationOptions = Apollo.BaseMutationOptions<UpdateMicrostoreColumnMutation, UpdateMicrostoreColumnMutationVariables>;
export const CreateMicrostoreColumnDocument = gql`
    mutation CREATE_MICROSTORE_COLUMN($createMicrostoreColumnInput: CreateMicrostoreColumnInput!) {
  createMicrostoreColumnMutation(
    createMicrostoreColumnInput: $createMicrostoreColumnInput
  ) {
    errors
    newSite {
      ...SiteFragment
      microstoreColumnGroups {
        ...MicrostoreColumnGroupWithColumnsFragment
      }
    }
  }
}
    ${SiteFragmentFragmentDoc}
${MicrostoreColumnGroupWithColumnsFragmentFragmentDoc}`;
export type CreateMicrostoreColumnMutationFn = Apollo.MutationFunction<CreateMicrostoreColumnMutation, CreateMicrostoreColumnMutationVariables>;

/**
 * __useCreateMicrostoreColumnMutation__
 *
 * To run a mutation, you first call `useCreateMicrostoreColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMicrostoreColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMicrostoreColumnMutation, { data, loading, error }] = useCreateMicrostoreColumnMutation({
 *   variables: {
 *      createMicrostoreColumnInput: // value for 'createMicrostoreColumnInput'
 *   },
 * });
 */
export function useCreateMicrostoreColumnMutation(baseOptions?: Apollo.MutationHookOptions<CreateMicrostoreColumnMutation, CreateMicrostoreColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMicrostoreColumnMutation, CreateMicrostoreColumnMutationVariables>(CreateMicrostoreColumnDocument, options);
      }
export type CreateMicrostoreColumnMutationHookResult = ReturnType<typeof useCreateMicrostoreColumnMutation>;
export type CreateMicrostoreColumnMutationResult = Apollo.MutationResult<CreateMicrostoreColumnMutation>;
export type CreateMicrostoreColumnMutationOptions = Apollo.BaseMutationOptions<CreateMicrostoreColumnMutation, CreateMicrostoreColumnMutationVariables>;
export const ReplaceMicrostoreColumnDocument = gql`
    mutation REPLACE_MICROSTORE_COLUMN($replaceMicrostoreColumnInput: ReplaceMicrostoreColumnInput!) {
  replaceMicrostoreColumnMutation(
    replaceMicrostoreColumnInput: $replaceMicrostoreColumnInput
  ) {
    errors
    newSite {
      ...SiteFragment
      microstoreColumnGroups {
        ...MicrostoreColumnGroupWithColumnsFragment
      }
    }
  }
}
    ${SiteFragmentFragmentDoc}
${MicrostoreColumnGroupWithColumnsFragmentFragmentDoc}`;
export type ReplaceMicrostoreColumnMutationFn = Apollo.MutationFunction<ReplaceMicrostoreColumnMutation, ReplaceMicrostoreColumnMutationVariables>;

/**
 * __useReplaceMicrostoreColumnMutation__
 *
 * To run a mutation, you first call `useReplaceMicrostoreColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceMicrostoreColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceMicrostoreColumnMutation, { data, loading, error }] = useReplaceMicrostoreColumnMutation({
 *   variables: {
 *      replaceMicrostoreColumnInput: // value for 'replaceMicrostoreColumnInput'
 *   },
 * });
 */
export function useReplaceMicrostoreColumnMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceMicrostoreColumnMutation, ReplaceMicrostoreColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceMicrostoreColumnMutation, ReplaceMicrostoreColumnMutationVariables>(ReplaceMicrostoreColumnDocument, options);
      }
export type ReplaceMicrostoreColumnMutationHookResult = ReturnType<typeof useReplaceMicrostoreColumnMutation>;
export type ReplaceMicrostoreColumnMutationResult = Apollo.MutationResult<ReplaceMicrostoreColumnMutation>;
export type ReplaceMicrostoreColumnMutationOptions = Apollo.BaseMutationOptions<ReplaceMicrostoreColumnMutation, ReplaceMicrostoreColumnMutationVariables>;
export const ReplaceMicrostoreColumnTemplateDocument = gql`
    mutation REPLACE_MICROSTORE_COLUMN_TEMPLATE($replaceMicrostoreColumnTemplateInput: ReplaceMicrostoreColumnTemplateInput!) {
  replaceMicrostoreColumnTemplateMutation(
    replaceMicrostoreColumnTemplateInput: $replaceMicrostoreColumnTemplateInput
  ) {
    errors
    newSite {
      ...SiteFragment
      microstoreColumnGroups {
        ...MicrostoreColumnGroupWithColumnsFragment
      }
    }
  }
}
    ${SiteFragmentFragmentDoc}
${MicrostoreColumnGroupWithColumnsFragmentFragmentDoc}`;
export type ReplaceMicrostoreColumnTemplateMutationFn = Apollo.MutationFunction<ReplaceMicrostoreColumnTemplateMutation, ReplaceMicrostoreColumnTemplateMutationVariables>;

/**
 * __useReplaceMicrostoreColumnTemplateMutation__
 *
 * To run a mutation, you first call `useReplaceMicrostoreColumnTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceMicrostoreColumnTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceMicrostoreColumnTemplateMutation, { data, loading, error }] = useReplaceMicrostoreColumnTemplateMutation({
 *   variables: {
 *      replaceMicrostoreColumnTemplateInput: // value for 'replaceMicrostoreColumnTemplateInput'
 *   },
 * });
 */
export function useReplaceMicrostoreColumnTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceMicrostoreColumnTemplateMutation, ReplaceMicrostoreColumnTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceMicrostoreColumnTemplateMutation, ReplaceMicrostoreColumnTemplateMutationVariables>(ReplaceMicrostoreColumnTemplateDocument, options);
      }
export type ReplaceMicrostoreColumnTemplateMutationHookResult = ReturnType<typeof useReplaceMicrostoreColumnTemplateMutation>;
export type ReplaceMicrostoreColumnTemplateMutationResult = Apollo.MutationResult<ReplaceMicrostoreColumnTemplateMutation>;
export type ReplaceMicrostoreColumnTemplateMutationOptions = Apollo.BaseMutationOptions<ReplaceMicrostoreColumnTemplateMutation, ReplaceMicrostoreColumnTemplateMutationVariables>;
export const MoveColumnDocument = gql`
    mutation MOVE_COLUMN($columnId: String!, $siteId: ID!, $columnGroupId: ID!, $positionInColumnGroup: Int!) {
  moveColumnMutation(
    columnId: $columnId
    siteId: $siteId
    columnGroupId: $columnGroupId
    positionInColumnGroup: $positionInColumnGroup
  ) {
    errors
    newSite {
      ...SiteFragment
      microstoreColumnGroups {
        ...MicrostoreColumnGroupWithColumnsFragment
      }
    }
  }
}
    ${SiteFragmentFragmentDoc}
${MicrostoreColumnGroupWithColumnsFragmentFragmentDoc}`;
export type MoveColumnMutationFn = Apollo.MutationFunction<MoveColumnMutation, MoveColumnMutationVariables>;

/**
 * __useMoveColumnMutation__
 *
 * To run a mutation, you first call `useMoveColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveColumnMutation, { data, loading, error }] = useMoveColumnMutation({
 *   variables: {
 *      columnId: // value for 'columnId'
 *      siteId: // value for 'siteId'
 *      columnGroupId: // value for 'columnGroupId'
 *      positionInColumnGroup: // value for 'positionInColumnGroup'
 *   },
 * });
 */
export function useMoveColumnMutation(baseOptions?: Apollo.MutationHookOptions<MoveColumnMutation, MoveColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveColumnMutation, MoveColumnMutationVariables>(MoveColumnDocument, options);
      }
export type MoveColumnMutationHookResult = ReturnType<typeof useMoveColumnMutation>;
export type MoveColumnMutationResult = Apollo.MutationResult<MoveColumnMutation>;
export type MoveColumnMutationOptions = Apollo.BaseMutationOptions<MoveColumnMutation, MoveColumnMutationVariables>;
export const UpdateColumnInfoDocument = gql`
    mutation UPDATE_COLUMN_INFO($columnId: String!, $isPaused: Boolean!, $removalDate: String, $startingDate: String) {
  updateColumnInfoMutation(
    columnId: $columnId
    isPaused: $isPaused
    removalDate: $removalDate
    startingDate: $startingDate
  ) {
    errors
    newSite {
      ...SiteFragment
      microstoreColumnGroups {
        ...MicrostoreColumnGroupWithColumnsFragment
      }
    }
  }
}
    ${SiteFragmentFragmentDoc}
${MicrostoreColumnGroupWithColumnsFragmentFragmentDoc}`;
export type UpdateColumnInfoMutationFn = Apollo.MutationFunction<UpdateColumnInfoMutation, UpdateColumnInfoMutationVariables>;

/**
 * __useUpdateColumnInfoMutation__
 *
 * To run a mutation, you first call `useUpdateColumnInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateColumnInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateColumnInfoMutation, { data, loading, error }] = useUpdateColumnInfoMutation({
 *   variables: {
 *      columnId: // value for 'columnId'
 *      isPaused: // value for 'isPaused'
 *      removalDate: // value for 'removalDate'
 *      startingDate: // value for 'startingDate'
 *   },
 * });
 */
export function useUpdateColumnInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateColumnInfoMutation, UpdateColumnInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateColumnInfoMutation, UpdateColumnInfoMutationVariables>(UpdateColumnInfoDocument, options);
      }
export type UpdateColumnInfoMutationHookResult = ReturnType<typeof useUpdateColumnInfoMutation>;
export type UpdateColumnInfoMutationResult = Apollo.MutationResult<UpdateColumnInfoMutation>;
export type UpdateColumnInfoMutationOptions = Apollo.BaseMutationOptions<UpdateColumnInfoMutation, UpdateColumnInfoMutationVariables>;
export const DeleteMicrostoreColumnDocument = gql`
    mutation DELETE_MICROSTORE_COLUMN($microstoreColumnId: String!) {
  deleteMicrostoreColumnMutation(microstoreColumnId: $microstoreColumnId) {
    errors
    newSite {
      ...SiteFragment
      microstoreColumnGroups {
        ...MicrostoreColumnGroupWithColumnsFragment
      }
    }
  }
}
    ${SiteFragmentFragmentDoc}
${MicrostoreColumnGroupWithColumnsFragmentFragmentDoc}`;
export type DeleteMicrostoreColumnMutationFn = Apollo.MutationFunction<DeleteMicrostoreColumnMutation, DeleteMicrostoreColumnMutationVariables>;

/**
 * __useDeleteMicrostoreColumnMutation__
 *
 * To run a mutation, you first call `useDeleteMicrostoreColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMicrostoreColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMicrostoreColumnMutation, { data, loading, error }] = useDeleteMicrostoreColumnMutation({
 *   variables: {
 *      microstoreColumnId: // value for 'microstoreColumnId'
 *   },
 * });
 */
export function useDeleteMicrostoreColumnMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMicrostoreColumnMutation, DeleteMicrostoreColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMicrostoreColumnMutation, DeleteMicrostoreColumnMutationVariables>(DeleteMicrostoreColumnDocument, options);
      }
export type DeleteMicrostoreColumnMutationHookResult = ReturnType<typeof useDeleteMicrostoreColumnMutation>;
export type DeleteMicrostoreColumnMutationResult = Apollo.MutationResult<DeleteMicrostoreColumnMutation>;
export type DeleteMicrostoreColumnMutationOptions = Apollo.BaseMutationOptions<DeleteMicrostoreColumnMutation, DeleteMicrostoreColumnMutationVariables>;
export const ValidateMicrostoresReassortmentDocument = gql`
    mutation VALIDATE_MICROSTORES_REASSORTMENT($reassortmentFlow: ReassortmentFlow!, $reassortmentDate: String, $microstoreColumnIds: [ID!]!, $siteIds: [ID!]!) {
  validateMicrostoresReassortmentMutation(
    reassortmentFlow: $reassortmentFlow
    reassortmentDate: $reassortmentDate
    microstoreColumnIds: $microstoreColumnIds
    siteIds: $siteIds
  ) {
    errors
    warnings
    microstoreColumns {
      ...MicrostoreColumnFragment
      nextReassortmentStockTransfers {
        ...StockTransferFragment
      }
    }
  }
}
    ${MicrostoreColumnFragmentFragmentDoc}
${StockTransferFragmentFragmentDoc}`;
export type ValidateMicrostoresReassortmentMutationFn = Apollo.MutationFunction<ValidateMicrostoresReassortmentMutation, ValidateMicrostoresReassortmentMutationVariables>;

/**
 * __useValidateMicrostoresReassortmentMutation__
 *
 * To run a mutation, you first call `useValidateMicrostoresReassortmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateMicrostoresReassortmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateMicrostoresReassortmentMutation, { data, loading, error }] = useValidateMicrostoresReassortmentMutation({
 *   variables: {
 *      reassortmentFlow: // value for 'reassortmentFlow'
 *      reassortmentDate: // value for 'reassortmentDate'
 *      microstoreColumnIds: // value for 'microstoreColumnIds'
 *      siteIds: // value for 'siteIds'
 *   },
 * });
 */
export function useValidateMicrostoresReassortmentMutation(baseOptions?: Apollo.MutationHookOptions<ValidateMicrostoresReassortmentMutation, ValidateMicrostoresReassortmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateMicrostoresReassortmentMutation, ValidateMicrostoresReassortmentMutationVariables>(ValidateMicrostoresReassortmentDocument, options);
      }
export type ValidateMicrostoresReassortmentMutationHookResult = ReturnType<typeof useValidateMicrostoresReassortmentMutation>;
export type ValidateMicrostoresReassortmentMutationResult = Apollo.MutationResult<ValidateMicrostoresReassortmentMutation>;
export type ValidateMicrostoresReassortmentMutationOptions = Apollo.BaseMutationOptions<ValidateMicrostoresReassortmentMutation, ValidateMicrostoresReassortmentMutationVariables>;
export const UpdateMicrostoresReassortmentForFreshFlowDocument = gql`
    mutation UPDATE_MICROSTORES_REASSORTMENT_FOR_FRESH_FLOW($microstoreColumnIds: [ID!]!, $reassortmentDate: String) {
  updateMicrostoresReassortmentForFreshFlowMutation(
    microstoreColumnIds: $microstoreColumnIds
    reassortmentDate: $reassortmentDate
  ) {
    errors
    warnings
    microstoreColumns {
      ...MicrostoreColumnWithShelvesFragment
    }
  }
}
    ${MicrostoreColumnWithShelvesFragmentFragmentDoc}`;
export type UpdateMicrostoresReassortmentForFreshFlowMutationFn = Apollo.MutationFunction<UpdateMicrostoresReassortmentForFreshFlowMutation, UpdateMicrostoresReassortmentForFreshFlowMutationVariables>;

/**
 * __useUpdateMicrostoresReassortmentForFreshFlowMutation__
 *
 * To run a mutation, you first call `useUpdateMicrostoresReassortmentForFreshFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMicrostoresReassortmentForFreshFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMicrostoresReassortmentForFreshFlowMutation, { data, loading, error }] = useUpdateMicrostoresReassortmentForFreshFlowMutation({
 *   variables: {
 *      microstoreColumnIds: // value for 'microstoreColumnIds'
 *      reassortmentDate: // value for 'reassortmentDate'
 *   },
 * });
 */
export function useUpdateMicrostoresReassortmentForFreshFlowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMicrostoresReassortmentForFreshFlowMutation, UpdateMicrostoresReassortmentForFreshFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMicrostoresReassortmentForFreshFlowMutation, UpdateMicrostoresReassortmentForFreshFlowMutationVariables>(UpdateMicrostoresReassortmentForFreshFlowDocument, options);
      }
export type UpdateMicrostoresReassortmentForFreshFlowMutationHookResult = ReturnType<typeof useUpdateMicrostoresReassortmentForFreshFlowMutation>;
export type UpdateMicrostoresReassortmentForFreshFlowMutationResult = Apollo.MutationResult<UpdateMicrostoresReassortmentForFreshFlowMutation>;
export type UpdateMicrostoresReassortmentForFreshFlowMutationOptions = Apollo.BaseMutationOptions<UpdateMicrostoresReassortmentForFreshFlowMutation, UpdateMicrostoresReassortmentForFreshFlowMutationVariables>;
export const UpdateMicrostoresReassortmentForDryFlowDocument = gql`
    mutation UPDATE_MICROSTORES_REASSORTMENT_FOR_DRY_FLOW($microstoreColumnIds: [ID!]!, $reassortmentDate: String) {
  updateMicrostoresReassortmentForDryFlowMutation(
    microstoreColumnIds: $microstoreColumnIds
    reassortmentDate: $reassortmentDate
  ) {
    errors
    microstoreColumns {
      ...MicrostoreColumnWithShelvesFragment
    }
  }
}
    ${MicrostoreColumnWithShelvesFragmentFragmentDoc}`;
export type UpdateMicrostoresReassortmentForDryFlowMutationFn = Apollo.MutationFunction<UpdateMicrostoresReassortmentForDryFlowMutation, UpdateMicrostoresReassortmentForDryFlowMutationVariables>;

/**
 * __useUpdateMicrostoresReassortmentForDryFlowMutation__
 *
 * To run a mutation, you first call `useUpdateMicrostoresReassortmentForDryFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMicrostoresReassortmentForDryFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMicrostoresReassortmentForDryFlowMutation, { data, loading, error }] = useUpdateMicrostoresReassortmentForDryFlowMutation({
 *   variables: {
 *      microstoreColumnIds: // value for 'microstoreColumnIds'
 *      reassortmentDate: // value for 'reassortmentDate'
 *   },
 * });
 */
export function useUpdateMicrostoresReassortmentForDryFlowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMicrostoresReassortmentForDryFlowMutation, UpdateMicrostoresReassortmentForDryFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMicrostoresReassortmentForDryFlowMutation, UpdateMicrostoresReassortmentForDryFlowMutationVariables>(UpdateMicrostoresReassortmentForDryFlowDocument, options);
      }
export type UpdateMicrostoresReassortmentForDryFlowMutationHookResult = ReturnType<typeof useUpdateMicrostoresReassortmentForDryFlowMutation>;
export type UpdateMicrostoresReassortmentForDryFlowMutationResult = Apollo.MutationResult<UpdateMicrostoresReassortmentForDryFlowMutation>;
export type UpdateMicrostoresReassortmentForDryFlowMutationOptions = Apollo.BaseMutationOptions<UpdateMicrostoresReassortmentForDryFlowMutation, UpdateMicrostoresReassortmentForDryFlowMutationVariables>;
export const LaunchFreshRestockingDocument = gql`
    mutation LAUNCH_FRESH_RESTOCKING {
  launchFreshRestockingMutation {
    success
    errors
  }
}
    `;
export type LaunchFreshRestockingMutationFn = Apollo.MutationFunction<LaunchFreshRestockingMutation, LaunchFreshRestockingMutationVariables>;

/**
 * __useLaunchFreshRestockingMutation__
 *
 * To run a mutation, you first call `useLaunchFreshRestockingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchFreshRestockingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchFreshRestockingMutation, { data, loading, error }] = useLaunchFreshRestockingMutation({
 *   variables: {
 *   },
 * });
 */
export function useLaunchFreshRestockingMutation(baseOptions?: Apollo.MutationHookOptions<LaunchFreshRestockingMutation, LaunchFreshRestockingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LaunchFreshRestockingMutation, LaunchFreshRestockingMutationVariables>(LaunchFreshRestockingDocument, options);
      }
export type LaunchFreshRestockingMutationHookResult = ReturnType<typeof useLaunchFreshRestockingMutation>;
export type LaunchFreshRestockingMutationResult = Apollo.MutationResult<LaunchFreshRestockingMutation>;
export type LaunchFreshRestockingMutationOptions = Apollo.BaseMutationOptions<LaunchFreshRestockingMutation, LaunchFreshRestockingMutationVariables>;
export const SyncPlanogramWithSenseiDocument = gql`
    mutation SYNC_PLANOGRAM_WITH_SENSEI($microstoreColumnId: String!, $columnPhotoUrl: String) {
  synchronizePlanogramWithSensei(
    microstoreColumnId: $microstoreColumnId
    columnPhotoUrl: $columnPhotoUrl
  ) {
    success
    errors
  }
}
    `;
export type SyncPlanogramWithSenseiMutationFn = Apollo.MutationFunction<SyncPlanogramWithSenseiMutation, SyncPlanogramWithSenseiMutationVariables>;

/**
 * __useSyncPlanogramWithSenseiMutation__
 *
 * To run a mutation, you first call `useSyncPlanogramWithSenseiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPlanogramWithSenseiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPlanogramWithSenseiMutation, { data, loading, error }] = useSyncPlanogramWithSenseiMutation({
 *   variables: {
 *      microstoreColumnId: // value for 'microstoreColumnId'
 *      columnPhotoUrl: // value for 'columnPhotoUrl'
 *   },
 * });
 */
export function useSyncPlanogramWithSenseiMutation(baseOptions?: Apollo.MutationHookOptions<SyncPlanogramWithSenseiMutation, SyncPlanogramWithSenseiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPlanogramWithSenseiMutation, SyncPlanogramWithSenseiMutationVariables>(SyncPlanogramWithSenseiDocument, options);
      }
export type SyncPlanogramWithSenseiMutationHookResult = ReturnType<typeof useSyncPlanogramWithSenseiMutation>;
export type SyncPlanogramWithSenseiMutationResult = Apollo.MutationResult<SyncPlanogramWithSenseiMutation>;
export type SyncPlanogramWithSenseiMutationOptions = Apollo.BaseMutationOptions<SyncPlanogramWithSenseiMutation, SyncPlanogramWithSenseiMutationVariables>;
export const SyncPlanogramWithNuDocument = gql`
    mutation SYNC_PLANOGRAM_WITH_NU($microstoreColumnId: String!) {
  synchronizePlanogramWithNu(microstoreColumnId: $microstoreColumnId) {
    success
    errors
  }
}
    `;
export type SyncPlanogramWithNuMutationFn = Apollo.MutationFunction<SyncPlanogramWithNuMutation, SyncPlanogramWithNuMutationVariables>;

/**
 * __useSyncPlanogramWithNuMutation__
 *
 * To run a mutation, you first call `useSyncPlanogramWithNuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPlanogramWithNuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPlanogramWithNuMutation, { data, loading, error }] = useSyncPlanogramWithNuMutation({
 *   variables: {
 *      microstoreColumnId: // value for 'microstoreColumnId'
 *   },
 * });
 */
export function useSyncPlanogramWithNuMutation(baseOptions?: Apollo.MutationHookOptions<SyncPlanogramWithNuMutation, SyncPlanogramWithNuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPlanogramWithNuMutation, SyncPlanogramWithNuMutationVariables>(SyncPlanogramWithNuDocument, options);
      }
export type SyncPlanogramWithNuMutationHookResult = ReturnType<typeof useSyncPlanogramWithNuMutation>;
export type SyncPlanogramWithNuMutationResult = Apollo.MutationResult<SyncPlanogramWithNuMutation>;
export type SyncPlanogramWithNuMutationOptions = Apollo.BaseMutationOptions<SyncPlanogramWithNuMutation, SyncPlanogramWithNuMutationVariables>;
export const SyncPlanogramWithNayaxDocument = gql`
    mutation SYNC_PLANOGRAM_WITH_NAYAX($microstoreColumnId: String!) {
  synchronizePlanogramWithNayax(microstoreColumnId: $microstoreColumnId) {
    success
    errors
  }
}
    `;
export type SyncPlanogramWithNayaxMutationFn = Apollo.MutationFunction<SyncPlanogramWithNayaxMutation, SyncPlanogramWithNayaxMutationVariables>;

/**
 * __useSyncPlanogramWithNayaxMutation__
 *
 * To run a mutation, you first call `useSyncPlanogramWithNayaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPlanogramWithNayaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPlanogramWithNayaxMutation, { data, loading, error }] = useSyncPlanogramWithNayaxMutation({
 *   variables: {
 *      microstoreColumnId: // value for 'microstoreColumnId'
 *   },
 * });
 */
export function useSyncPlanogramWithNayaxMutation(baseOptions?: Apollo.MutationHookOptions<SyncPlanogramWithNayaxMutation, SyncPlanogramWithNayaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPlanogramWithNayaxMutation, SyncPlanogramWithNayaxMutationVariables>(SyncPlanogramWithNayaxDocument, options);
      }
export type SyncPlanogramWithNayaxMutationHookResult = ReturnType<typeof useSyncPlanogramWithNayaxMutation>;
export type SyncPlanogramWithNayaxMutationResult = Apollo.MutationResult<SyncPlanogramWithNayaxMutation>;
export type SyncPlanogramWithNayaxMutationOptions = Apollo.BaseMutationOptions<SyncPlanogramWithNayaxMutation, SyncPlanogramWithNayaxMutationVariables>;
export const CreateMicrostoreColumnGroupDocument = gql`
    mutation CREATE_MICROSTORE_COLUMN_GROUP($createMicrostoreColumnGroupInput: CreateMicrostoreColumnGroupInput!) {
  createMicrostoreColumnGroupMutation(
    createMicrostoreColumnGroupInput: $createMicrostoreColumnGroupInput
  ) {
    errors
    newSite {
      ...SiteFragment
      microstoreColumnGroups {
        ...MicrostoreColumnGroupWithColumnsFragment
      }
    }
  }
}
    ${SiteFragmentFragmentDoc}
${MicrostoreColumnGroupWithColumnsFragmentFragmentDoc}`;
export type CreateMicrostoreColumnGroupMutationFn = Apollo.MutationFunction<CreateMicrostoreColumnGroupMutation, CreateMicrostoreColumnGroupMutationVariables>;

/**
 * __useCreateMicrostoreColumnGroupMutation__
 *
 * To run a mutation, you first call `useCreateMicrostoreColumnGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMicrostoreColumnGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMicrostoreColumnGroupMutation, { data, loading, error }] = useCreateMicrostoreColumnGroupMutation({
 *   variables: {
 *      createMicrostoreColumnGroupInput: // value for 'createMicrostoreColumnGroupInput'
 *   },
 * });
 */
export function useCreateMicrostoreColumnGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateMicrostoreColumnGroupMutation, CreateMicrostoreColumnGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMicrostoreColumnGroupMutation, CreateMicrostoreColumnGroupMutationVariables>(CreateMicrostoreColumnGroupDocument, options);
      }
export type CreateMicrostoreColumnGroupMutationHookResult = ReturnType<typeof useCreateMicrostoreColumnGroupMutation>;
export type CreateMicrostoreColumnGroupMutationResult = Apollo.MutationResult<CreateMicrostoreColumnGroupMutation>;
export type CreateMicrostoreColumnGroupMutationOptions = Apollo.BaseMutationOptions<CreateMicrostoreColumnGroupMutation, CreateMicrostoreColumnGroupMutationVariables>;
export const UpdateMicrostoreColumnGroupDocument = gql`
    mutation UPDATE_MICROSTORE_COLUMN_GROUP($microstoreColumnGroupId: ID!, $updateMicrostoreColumnGroupInput: UpdateMicrostoreColumnGroupInput!) {
  updateMicrostoreColumnGroupMutation(
    microstoreColumnGroupId: $microstoreColumnGroupId
    updateMicrostoreColumnGroupInput: $updateMicrostoreColumnGroupInput
  ) {
    errors
    newSite {
      ...SiteFragment
      microstoreColumnGroups {
        ...MicrostoreColumnGroupWithColumnsFragment
      }
    }
  }
}
    ${SiteFragmentFragmentDoc}
${MicrostoreColumnGroupWithColumnsFragmentFragmentDoc}`;
export type UpdateMicrostoreColumnGroupMutationFn = Apollo.MutationFunction<UpdateMicrostoreColumnGroupMutation, UpdateMicrostoreColumnGroupMutationVariables>;

/**
 * __useUpdateMicrostoreColumnGroupMutation__
 *
 * To run a mutation, you first call `useUpdateMicrostoreColumnGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMicrostoreColumnGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMicrostoreColumnGroupMutation, { data, loading, error }] = useUpdateMicrostoreColumnGroupMutation({
 *   variables: {
 *      microstoreColumnGroupId: // value for 'microstoreColumnGroupId'
 *      updateMicrostoreColumnGroupInput: // value for 'updateMicrostoreColumnGroupInput'
 *   },
 * });
 */
export function useUpdateMicrostoreColumnGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMicrostoreColumnGroupMutation, UpdateMicrostoreColumnGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMicrostoreColumnGroupMutation, UpdateMicrostoreColumnGroupMutationVariables>(UpdateMicrostoreColumnGroupDocument, options);
      }
export type UpdateMicrostoreColumnGroupMutationHookResult = ReturnType<typeof useUpdateMicrostoreColumnGroupMutation>;
export type UpdateMicrostoreColumnGroupMutationResult = Apollo.MutationResult<UpdateMicrostoreColumnGroupMutation>;
export type UpdateMicrostoreColumnGroupMutationOptions = Apollo.BaseMutationOptions<UpdateMicrostoreColumnGroupMutation, UpdateMicrostoreColumnGroupMutationVariables>;
export const DeleteMicrostoreColumnGroupDocument = gql`
    mutation DELETE_MICROSTORE_COLUMN_GROUP($microstoreColumnGroupId: ID!) {
  deleteMicrostoreColumnGroupMutation(
    microstoreColumnGroupId: $microstoreColumnGroupId
  ) {
    errors
    newSite {
      ...SiteFragment
      microstoreColumnGroups {
        ...MicrostoreColumnGroupWithColumnsFragment
      }
    }
  }
}
    ${SiteFragmentFragmentDoc}
${MicrostoreColumnGroupWithColumnsFragmentFragmentDoc}`;
export type DeleteMicrostoreColumnGroupMutationFn = Apollo.MutationFunction<DeleteMicrostoreColumnGroupMutation, DeleteMicrostoreColumnGroupMutationVariables>;

/**
 * __useDeleteMicrostoreColumnGroupMutation__
 *
 * To run a mutation, you first call `useDeleteMicrostoreColumnGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMicrostoreColumnGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMicrostoreColumnGroupMutation, { data, loading, error }] = useDeleteMicrostoreColumnGroupMutation({
 *   variables: {
 *      microstoreColumnGroupId: // value for 'microstoreColumnGroupId'
 *   },
 * });
 */
export function useDeleteMicrostoreColumnGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMicrostoreColumnGroupMutation, DeleteMicrostoreColumnGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMicrostoreColumnGroupMutation, DeleteMicrostoreColumnGroupMutationVariables>(DeleteMicrostoreColumnGroupDocument, options);
      }
export type DeleteMicrostoreColumnGroupMutationHookResult = ReturnType<typeof useDeleteMicrostoreColumnGroupMutation>;
export type DeleteMicrostoreColumnGroupMutationResult = Apollo.MutationResult<DeleteMicrostoreColumnGroupMutation>;
export type DeleteMicrostoreColumnGroupMutationOptions = Apollo.BaseMutationOptions<DeleteMicrostoreColumnGroupMutation, DeleteMicrostoreColumnGroupMutationVariables>;
export const AddPostSiteSetupZeroInventoryProductsDocument = gql`
    mutation ADD_POST_SITE_SETUP_ZERO_INVENTORY_PRODUCTS($microstoreColumnSetupId: ID!, $productIds: [String!]!) {
  addPostSiteSetupZeroInventoryProducts(
    microstoreColumnSetupId: $microstoreColumnSetupId
    productIds: $productIds
  ) {
    success
    error
    microstoreColumnSetup {
      ...MicrostoreColumnSetupFragment
    }
  }
}
    ${MicrostoreColumnSetupFragmentFragmentDoc}`;
export type AddPostSiteSetupZeroInventoryProductsMutationFn = Apollo.MutationFunction<AddPostSiteSetupZeroInventoryProductsMutation, AddPostSiteSetupZeroInventoryProductsMutationVariables>;

/**
 * __useAddPostSiteSetupZeroInventoryProductsMutation__
 *
 * To run a mutation, you first call `useAddPostSiteSetupZeroInventoryProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPostSiteSetupZeroInventoryProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPostSiteSetupZeroInventoryProductsMutation, { data, loading, error }] = useAddPostSiteSetupZeroInventoryProductsMutation({
 *   variables: {
 *      microstoreColumnSetupId: // value for 'microstoreColumnSetupId'
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useAddPostSiteSetupZeroInventoryProductsMutation(baseOptions?: Apollo.MutationHookOptions<AddPostSiteSetupZeroInventoryProductsMutation, AddPostSiteSetupZeroInventoryProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPostSiteSetupZeroInventoryProductsMutation, AddPostSiteSetupZeroInventoryProductsMutationVariables>(AddPostSiteSetupZeroInventoryProductsDocument, options);
      }
export type AddPostSiteSetupZeroInventoryProductsMutationHookResult = ReturnType<typeof useAddPostSiteSetupZeroInventoryProductsMutation>;
export type AddPostSiteSetupZeroInventoryProductsMutationResult = Apollo.MutationResult<AddPostSiteSetupZeroInventoryProductsMutation>;
export type AddPostSiteSetupZeroInventoryProductsMutationOptions = Apollo.BaseMutationOptions<AddPostSiteSetupZeroInventoryProductsMutation, AddPostSiteSetupZeroInventoryProductsMutationVariables>;
export const CreateMicrostoreColumnTemplateDocument = gql`
    mutation CREATE_MICROSTORE_COLUMN_TEMPLATE($microstoreColumnTemplate: MicrostoreColumnTemplateCreateInput!) {
  createMicrostoreColumnTemplateMutation(
    microstoreColumnTemplate: $microstoreColumnTemplate
  ) {
    newMicrostoreColumnTemplate {
      ...MicrostoreColumnTemplateFragment
    }
    errors
  }
}
    ${MicrostoreColumnTemplateFragmentFragmentDoc}`;
export type CreateMicrostoreColumnTemplateMutationFn = Apollo.MutationFunction<CreateMicrostoreColumnTemplateMutation, CreateMicrostoreColumnTemplateMutationVariables>;

/**
 * __useCreateMicrostoreColumnTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMicrostoreColumnTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMicrostoreColumnTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMicrostoreColumnTemplateMutation, { data, loading, error }] = useCreateMicrostoreColumnTemplateMutation({
 *   variables: {
 *      microstoreColumnTemplate: // value for 'microstoreColumnTemplate'
 *   },
 * });
 */
export function useCreateMicrostoreColumnTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMicrostoreColumnTemplateMutation, CreateMicrostoreColumnTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMicrostoreColumnTemplateMutation, CreateMicrostoreColumnTemplateMutationVariables>(CreateMicrostoreColumnTemplateDocument, options);
      }
export type CreateMicrostoreColumnTemplateMutationHookResult = ReturnType<typeof useCreateMicrostoreColumnTemplateMutation>;
export type CreateMicrostoreColumnTemplateMutationResult = Apollo.MutationResult<CreateMicrostoreColumnTemplateMutation>;
export type CreateMicrostoreColumnTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMicrostoreColumnTemplateMutation, CreateMicrostoreColumnTemplateMutationVariables>;
export const DuplicateMicrostoreColumnTemplateDocument = gql`
    mutation DUPLICATE_MICROSTORE_COLUMN_TEMPLATE($microstoreColumnTemplateId: String!) {
  duplicateMicrostoreColumnTemplateMutation(
    microstoreColumnTemplateId: $microstoreColumnTemplateId
  ) {
    newMicrostoreColumnTemplate {
      ...MicrostoreColumnTemplateFragment
    }
    errors
  }
}
    ${MicrostoreColumnTemplateFragmentFragmentDoc}`;
export type DuplicateMicrostoreColumnTemplateMutationFn = Apollo.MutationFunction<DuplicateMicrostoreColumnTemplateMutation, DuplicateMicrostoreColumnTemplateMutationVariables>;

/**
 * __useDuplicateMicrostoreColumnTemplateMutation__
 *
 * To run a mutation, you first call `useDuplicateMicrostoreColumnTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateMicrostoreColumnTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateMicrostoreColumnTemplateMutation, { data, loading, error }] = useDuplicateMicrostoreColumnTemplateMutation({
 *   variables: {
 *      microstoreColumnTemplateId: // value for 'microstoreColumnTemplateId'
 *   },
 * });
 */
export function useDuplicateMicrostoreColumnTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateMicrostoreColumnTemplateMutation, DuplicateMicrostoreColumnTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateMicrostoreColumnTemplateMutation, DuplicateMicrostoreColumnTemplateMutationVariables>(DuplicateMicrostoreColumnTemplateDocument, options);
      }
export type DuplicateMicrostoreColumnTemplateMutationHookResult = ReturnType<typeof useDuplicateMicrostoreColumnTemplateMutation>;
export type DuplicateMicrostoreColumnTemplateMutationResult = Apollo.MutationResult<DuplicateMicrostoreColumnTemplateMutation>;
export type DuplicateMicrostoreColumnTemplateMutationOptions = Apollo.BaseMutationOptions<DuplicateMicrostoreColumnTemplateMutation, DuplicateMicrostoreColumnTemplateMutationVariables>;
export const DeleteMicrostoreColumnTemplatesDocument = gql`
    mutation DELETE_MICROSTORE_COLUMN_TEMPLATES($microstoreColumnTemplateIds: [String!]!) {
  deleteMicrostoreColumnTemplatesMutation(
    microstoreColumnTemplateIds: $microstoreColumnTemplateIds
  ) {
    deletedMicrostoreColumnTemplateIds
    errors
  }
}
    `;
export type DeleteMicrostoreColumnTemplatesMutationFn = Apollo.MutationFunction<DeleteMicrostoreColumnTemplatesMutation, DeleteMicrostoreColumnTemplatesMutationVariables>;

/**
 * __useDeleteMicrostoreColumnTemplatesMutation__
 *
 * To run a mutation, you first call `useDeleteMicrostoreColumnTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMicrostoreColumnTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMicrostoreColumnTemplatesMutation, { data, loading, error }] = useDeleteMicrostoreColumnTemplatesMutation({
 *   variables: {
 *      microstoreColumnTemplateIds: // value for 'microstoreColumnTemplateIds'
 *   },
 * });
 */
export function useDeleteMicrostoreColumnTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMicrostoreColumnTemplatesMutation, DeleteMicrostoreColumnTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMicrostoreColumnTemplatesMutation, DeleteMicrostoreColumnTemplatesMutationVariables>(DeleteMicrostoreColumnTemplatesDocument, options);
      }
export type DeleteMicrostoreColumnTemplatesMutationHookResult = ReturnType<typeof useDeleteMicrostoreColumnTemplatesMutation>;
export type DeleteMicrostoreColumnTemplatesMutationResult = Apollo.MutationResult<DeleteMicrostoreColumnTemplatesMutation>;
export type DeleteMicrostoreColumnTemplatesMutationOptions = Apollo.BaseMutationOptions<DeleteMicrostoreColumnTemplatesMutation, DeleteMicrostoreColumnTemplatesMutationVariables>;
export const UpdateMicrostoreColumnTemplateDocument = gql`
    mutation UPDATE_MICROSTORE_COLUMN_TEMPLATE($microstoreColumnTemplate: MicrostoreColumnTemplateUpdateInput!) {
  updateMicrostoreColumnTemplateMutation(
    microstoreColumnTemplate: $microstoreColumnTemplate
  ) {
    newMicrostoreColumnTemplate {
      ...MicrostoreColumnTemplateWithAllInfo
    }
    errors
  }
}
    ${MicrostoreColumnTemplateWithAllInfoFragmentDoc}`;
export type UpdateMicrostoreColumnTemplateMutationFn = Apollo.MutationFunction<UpdateMicrostoreColumnTemplateMutation, UpdateMicrostoreColumnTemplateMutationVariables>;

/**
 * __useUpdateMicrostoreColumnTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMicrostoreColumnTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMicrostoreColumnTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMicrostoreColumnTemplateMutation, { data, loading, error }] = useUpdateMicrostoreColumnTemplateMutation({
 *   variables: {
 *      microstoreColumnTemplate: // value for 'microstoreColumnTemplate'
 *   },
 * });
 */
export function useUpdateMicrostoreColumnTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMicrostoreColumnTemplateMutation, UpdateMicrostoreColumnTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMicrostoreColumnTemplateMutation, UpdateMicrostoreColumnTemplateMutationVariables>(UpdateMicrostoreColumnTemplateDocument, options);
      }
export type UpdateMicrostoreColumnTemplateMutationHookResult = ReturnType<typeof useUpdateMicrostoreColumnTemplateMutation>;
export type UpdateMicrostoreColumnTemplateMutationResult = Apollo.MutationResult<UpdateMicrostoreColumnTemplateMutation>;
export type UpdateMicrostoreColumnTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateMicrostoreColumnTemplateMutation, UpdateMicrostoreColumnTemplateMutationVariables>;
export const UpdateMicrostoreColumnTemplateStateDocument = gql`
    mutation UPDATE_MICROSTORE_COLUMN_TEMPLATE_STATE($microstoreColumnTemplateId: String!, $stateToSet: MicrostoreColumnTemplateState!) {
  updateMicrostoreColumnTemplateStateMutation(
    microstoreColumnTemplateId: $microstoreColumnTemplateId
    stateToSet: $stateToSet
  ) {
    errors
    newMicrostoreColumnTemplate {
      ...MicrostoreColumnTemplateFragment
    }
  }
}
    ${MicrostoreColumnTemplateFragmentFragmentDoc}`;
export type UpdateMicrostoreColumnTemplateStateMutationFn = Apollo.MutationFunction<UpdateMicrostoreColumnTemplateStateMutation, UpdateMicrostoreColumnTemplateStateMutationVariables>;

/**
 * __useUpdateMicrostoreColumnTemplateStateMutation__
 *
 * To run a mutation, you first call `useUpdateMicrostoreColumnTemplateStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMicrostoreColumnTemplateStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMicrostoreColumnTemplateStateMutation, { data, loading, error }] = useUpdateMicrostoreColumnTemplateStateMutation({
 *   variables: {
 *      microstoreColumnTemplateId: // value for 'microstoreColumnTemplateId'
 *      stateToSet: // value for 'stateToSet'
 *   },
 * });
 */
export function useUpdateMicrostoreColumnTemplateStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMicrostoreColumnTemplateStateMutation, UpdateMicrostoreColumnTemplateStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMicrostoreColumnTemplateStateMutation, UpdateMicrostoreColumnTemplateStateMutationVariables>(UpdateMicrostoreColumnTemplateStateDocument, options);
      }
export type UpdateMicrostoreColumnTemplateStateMutationHookResult = ReturnType<typeof useUpdateMicrostoreColumnTemplateStateMutation>;
export type UpdateMicrostoreColumnTemplateStateMutationResult = Apollo.MutationResult<UpdateMicrostoreColumnTemplateStateMutation>;
export type UpdateMicrostoreColumnTemplateStateMutationOptions = Apollo.BaseMutationOptions<UpdateMicrostoreColumnTemplateStateMutation, UpdateMicrostoreColumnTemplateStateMutationVariables>;
export const ReplaceProductsInMicrostoreColumnTemplatesDocument = gql`
    mutation ReplaceProductsInMicrostoreColumnTemplates($input: ReplaceProductsInTemplatesInput!) {
  replaceProductsInMicrostoreColumnTemplatesMutation(input: $input) {
    success
    errors
  }
}
    `;
export type ReplaceProductsInMicrostoreColumnTemplatesMutationFn = Apollo.MutationFunction<ReplaceProductsInMicrostoreColumnTemplatesMutation, ReplaceProductsInMicrostoreColumnTemplatesMutationVariables>;

/**
 * __useReplaceProductsInMicrostoreColumnTemplatesMutation__
 *
 * To run a mutation, you first call `useReplaceProductsInMicrostoreColumnTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceProductsInMicrostoreColumnTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceProductsInMicrostoreColumnTemplatesMutation, { data, loading, error }] = useReplaceProductsInMicrostoreColumnTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceProductsInMicrostoreColumnTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceProductsInMicrostoreColumnTemplatesMutation, ReplaceProductsInMicrostoreColumnTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceProductsInMicrostoreColumnTemplatesMutation, ReplaceProductsInMicrostoreColumnTemplatesMutationVariables>(ReplaceProductsInMicrostoreColumnTemplatesDocument, options);
      }
export type ReplaceProductsInMicrostoreColumnTemplatesMutationHookResult = ReturnType<typeof useReplaceProductsInMicrostoreColumnTemplatesMutation>;
export type ReplaceProductsInMicrostoreColumnTemplatesMutationResult = Apollo.MutationResult<ReplaceProductsInMicrostoreColumnTemplatesMutation>;
export type ReplaceProductsInMicrostoreColumnTemplatesMutationOptions = Apollo.BaseMutationOptions<ReplaceProductsInMicrostoreColumnTemplatesMutation, ReplaceProductsInMicrostoreColumnTemplatesMutationVariables>;
export const UpdateLocationsWithTargetStockDocument = gql`
    mutation UPDATE_LOCATIONS_WITH_TARGET_STOCK($locationIdsWithTargetStock: [MicrostoreLocationIdWithTargetStockInput!]!) {
  updateLocationsWithTargetStock(
    locationIdsWithTargetStock: $locationIdsWithTargetStock
  ) {
    ...MicrostoreLocationFragment
  }
}
    ${MicrostoreLocationFragmentFragmentDoc}`;
export type UpdateLocationsWithTargetStockMutationFn = Apollo.MutationFunction<UpdateLocationsWithTargetStockMutation, UpdateLocationsWithTargetStockMutationVariables>;

/**
 * __useUpdateLocationsWithTargetStockMutation__
 *
 * To run a mutation, you first call `useUpdateLocationsWithTargetStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationsWithTargetStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationsWithTargetStockMutation, { data, loading, error }] = useUpdateLocationsWithTargetStockMutation({
 *   variables: {
 *      locationIdsWithTargetStock: // value for 'locationIdsWithTargetStock'
 *   },
 * });
 */
export function useUpdateLocationsWithTargetStockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationsWithTargetStockMutation, UpdateLocationsWithTargetStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationsWithTargetStockMutation, UpdateLocationsWithTargetStockMutationVariables>(UpdateLocationsWithTargetStockDocument, options);
      }
export type UpdateLocationsWithTargetStockMutationHookResult = ReturnType<typeof useUpdateLocationsWithTargetStockMutation>;
export type UpdateLocationsWithTargetStockMutationResult = Apollo.MutationResult<UpdateLocationsWithTargetStockMutation>;
export type UpdateLocationsWithTargetStockMutationOptions = Apollo.BaseMutationOptions<UpdateLocationsWithTargetStockMutation, UpdateLocationsWithTargetStockMutationVariables>;
export const CreateMobilePopupDocument = gql`
    mutation CreateMobilePopup($input: CreateMobilePopupInput!) {
  createMobilePopup(input: $input) {
    ...MobilePopupFragment
  }
}
    ${MobilePopupFragmentFragmentDoc}`;
export type CreateMobilePopupMutationFn = Apollo.MutationFunction<CreateMobilePopupMutation, CreateMobilePopupMutationVariables>;

/**
 * __useCreateMobilePopupMutation__
 *
 * To run a mutation, you first call `useCreateMobilePopupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMobilePopupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMobilePopupMutation, { data, loading, error }] = useCreateMobilePopupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMobilePopupMutation(baseOptions?: Apollo.MutationHookOptions<CreateMobilePopupMutation, CreateMobilePopupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMobilePopupMutation, CreateMobilePopupMutationVariables>(CreateMobilePopupDocument, options);
      }
export type CreateMobilePopupMutationHookResult = ReturnType<typeof useCreateMobilePopupMutation>;
export type CreateMobilePopupMutationResult = Apollo.MutationResult<CreateMobilePopupMutation>;
export type CreateMobilePopupMutationOptions = Apollo.BaseMutationOptions<CreateMobilePopupMutation, CreateMobilePopupMutationVariables>;
export const UpdateMobilePopupDocument = gql`
    mutation UpdateMobilePopup($id: ID!, $input: UpdateMobilePopupInput!) {
  updateMobilePopup(_id: $id, input: $input) {
    ...MobilePopupFragment
  }
}
    ${MobilePopupFragmentFragmentDoc}`;
export type UpdateMobilePopupMutationFn = Apollo.MutationFunction<UpdateMobilePopupMutation, UpdateMobilePopupMutationVariables>;

/**
 * __useUpdateMobilePopupMutation__
 *
 * To run a mutation, you first call `useUpdateMobilePopupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMobilePopupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMobilePopupMutation, { data, loading, error }] = useUpdateMobilePopupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMobilePopupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMobilePopupMutation, UpdateMobilePopupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMobilePopupMutation, UpdateMobilePopupMutationVariables>(UpdateMobilePopupDocument, options);
      }
export type UpdateMobilePopupMutationHookResult = ReturnType<typeof useUpdateMobilePopupMutation>;
export type UpdateMobilePopupMutationResult = Apollo.MutationResult<UpdateMobilePopupMutation>;
export type UpdateMobilePopupMutationOptions = Apollo.BaseMutationOptions<UpdateMobilePopupMutation, UpdateMobilePopupMutationVariables>;
export const DeleteMobilePopupDocument = gql`
    mutation DeleteMobilePopup($id: ID!) {
  deleteMobilePopup(_id: $id)
}
    `;
export type DeleteMobilePopupMutationFn = Apollo.MutationFunction<DeleteMobilePopupMutation, DeleteMobilePopupMutationVariables>;

/**
 * __useDeleteMobilePopupMutation__
 *
 * To run a mutation, you first call `useDeleteMobilePopupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMobilePopupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMobilePopupMutation, { data, loading, error }] = useDeleteMobilePopupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMobilePopupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMobilePopupMutation, DeleteMobilePopupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMobilePopupMutation, DeleteMobilePopupMutationVariables>(DeleteMobilePopupDocument, options);
      }
export type DeleteMobilePopupMutationHookResult = ReturnType<typeof useDeleteMobilePopupMutation>;
export type DeleteMobilePopupMutationResult = Apollo.MutationResult<DeleteMobilePopupMutation>;
export type DeleteMobilePopupMutationOptions = Apollo.BaseMutationOptions<DeleteMobilePopupMutation, DeleteMobilePopupMutationVariables>;
export const UpdateNayaxMdbTemplateDocument = gql`
    mutation UpdateNayaxMDBTemplate($nayaxMDBTemplateId: ID!, $input: UpdateNayaxMDBTemplateInput!) {
  updateNayaxMDBTemplate(nayaxMDBTemplateId: $nayaxMDBTemplateId, input: $input) {
    success
    nayaxMDBTemplate {
      _id
      createdAt
      updatedAt
      name
      associations {
        nayaxMDBCode
        positionInShelf {
          row
          column
        }
        positionInColumn
      }
    }
  }
}
    `;
export type UpdateNayaxMdbTemplateMutationFn = Apollo.MutationFunction<UpdateNayaxMdbTemplateMutation, UpdateNayaxMdbTemplateMutationVariables>;

/**
 * __useUpdateNayaxMdbTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateNayaxMdbTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNayaxMdbTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNayaxMdbTemplateMutation, { data, loading, error }] = useUpdateNayaxMdbTemplateMutation({
 *   variables: {
 *      nayaxMDBTemplateId: // value for 'nayaxMDBTemplateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNayaxMdbTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNayaxMdbTemplateMutation, UpdateNayaxMdbTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNayaxMdbTemplateMutation, UpdateNayaxMdbTemplateMutationVariables>(UpdateNayaxMdbTemplateDocument, options);
      }
export type UpdateNayaxMdbTemplateMutationHookResult = ReturnType<typeof useUpdateNayaxMdbTemplateMutation>;
export type UpdateNayaxMdbTemplateMutationResult = Apollo.MutationResult<UpdateNayaxMdbTemplateMutation>;
export type UpdateNayaxMdbTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateNayaxMdbTemplateMutation, UpdateNayaxMdbTemplateMutationVariables>;
export const CreateNayaxMdbTemplateDocument = gql`
    mutation CreateNayaxMDBTemplate($input: CreateNayaxMDBTemplateInput!) {
  createNayaxMDBTemplate(input: $input) {
    success
    nayaxMDBTemplate {
      _id
      createdAt
      updatedAt
      name
      associations {
        nayaxMDBCode
        positionInShelf {
          row
          column
        }
        positionInColumn
      }
    }
  }
}
    `;
export type CreateNayaxMdbTemplateMutationFn = Apollo.MutationFunction<CreateNayaxMdbTemplateMutation, CreateNayaxMdbTemplateMutationVariables>;

/**
 * __useCreateNayaxMdbTemplateMutation__
 *
 * To run a mutation, you first call `useCreateNayaxMdbTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNayaxMdbTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNayaxMdbTemplateMutation, { data, loading, error }] = useCreateNayaxMdbTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNayaxMdbTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateNayaxMdbTemplateMutation, CreateNayaxMdbTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNayaxMdbTemplateMutation, CreateNayaxMdbTemplateMutationVariables>(CreateNayaxMdbTemplateDocument, options);
      }
export type CreateNayaxMdbTemplateMutationHookResult = ReturnType<typeof useCreateNayaxMdbTemplateMutation>;
export type CreateNayaxMdbTemplateMutationResult = Apollo.MutationResult<CreateNayaxMdbTemplateMutation>;
export type CreateNayaxMdbTemplateMutationOptions = Apollo.BaseMutationOptions<CreateNayaxMdbTemplateMutation, CreateNayaxMdbTemplateMutationVariables>;
export const DeleteNayaxMdbTemplateDocument = gql`
    mutation DeleteNayaxMDBTemplate($nayaxMDBTemplateId: ID!) {
  deleteNayaxMDBTemplate(nayaxMDBTemplateId: $nayaxMDBTemplateId) {
    success
  }
}
    `;
export type DeleteNayaxMdbTemplateMutationFn = Apollo.MutationFunction<DeleteNayaxMdbTemplateMutation, DeleteNayaxMdbTemplateMutationVariables>;

/**
 * __useDeleteNayaxMdbTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteNayaxMdbTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNayaxMdbTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNayaxMdbTemplateMutation, { data, loading, error }] = useDeleteNayaxMdbTemplateMutation({
 *   variables: {
 *      nayaxMDBTemplateId: // value for 'nayaxMDBTemplateId'
 *   },
 * });
 */
export function useDeleteNayaxMdbTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNayaxMdbTemplateMutation, DeleteNayaxMdbTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNayaxMdbTemplateMutation, DeleteNayaxMdbTemplateMutationVariables>(DeleteNayaxMdbTemplateDocument, options);
      }
export type DeleteNayaxMdbTemplateMutationHookResult = ReturnType<typeof useDeleteNayaxMdbTemplateMutation>;
export type DeleteNayaxMdbTemplateMutationResult = Apollo.MutationResult<DeleteNayaxMdbTemplateMutation>;
export type DeleteNayaxMdbTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteNayaxMdbTemplateMutation, DeleteNayaxMdbTemplateMutationVariables>;
export const SendNotificationToOrganizationDocument = gql`
    mutation SEND_NOTIFICATION_TO_ORGANIZATION($organizationId: ID!, $title: String, $body: String, $notificationCategory: NotificationCategory, $deeplink: String, $slug: String!) {
  sendNotificationToOrganization(
    organizationId: $organizationId
    title: $title
    body: $body
    notificationCategory: $notificationCategory
    deeplink: $deeplink
    slug: $slug
  )
}
    `;
export type SendNotificationToOrganizationMutationFn = Apollo.MutationFunction<SendNotificationToOrganizationMutation, SendNotificationToOrganizationMutationVariables>;

/**
 * __useSendNotificationToOrganizationMutation__
 *
 * To run a mutation, you first call `useSendNotificationToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNotificationToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNotificationToOrganizationMutation, { data, loading, error }] = useSendNotificationToOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      notificationCategory: // value for 'notificationCategory'
 *      deeplink: // value for 'deeplink'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSendNotificationToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SendNotificationToOrganizationMutation, SendNotificationToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendNotificationToOrganizationMutation, SendNotificationToOrganizationMutationVariables>(SendNotificationToOrganizationDocument, options);
      }
export type SendNotificationToOrganizationMutationHookResult = ReturnType<typeof useSendNotificationToOrganizationMutation>;
export type SendNotificationToOrganizationMutationResult = Apollo.MutationResult<SendNotificationToOrganizationMutation>;
export type SendNotificationToOrganizationMutationOptions = Apollo.BaseMutationOptions<SendNotificationToOrganizationMutation, SendNotificationToOrganizationMutationVariables>;
export const SendNotificationToUsersDocument = gql`
    mutation SEND_NOTIFICATION_TO_USERS($userIds: [ID!]!, $title: String, $body: String, $notificationCategory: NotificationCategory, $deeplink: String, $slug: String!) {
  sendNotificationToUsers(
    userIds: $userIds
    title: $title
    body: $body
    notificationCategory: $notificationCategory
    deeplink: $deeplink
    slug: $slug
  )
}
    `;
export type SendNotificationToUsersMutationFn = Apollo.MutationFunction<SendNotificationToUsersMutation, SendNotificationToUsersMutationVariables>;

/**
 * __useSendNotificationToUsersMutation__
 *
 * To run a mutation, you first call `useSendNotificationToUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNotificationToUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNotificationToUsersMutation, { data, loading, error }] = useSendNotificationToUsersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      notificationCategory: // value for 'notificationCategory'
 *      deeplink: // value for 'deeplink'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSendNotificationToUsersMutation(baseOptions?: Apollo.MutationHookOptions<SendNotificationToUsersMutation, SendNotificationToUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendNotificationToUsersMutation, SendNotificationToUsersMutationVariables>(SendNotificationToUsersDocument, options);
      }
export type SendNotificationToUsersMutationHookResult = ReturnType<typeof useSendNotificationToUsersMutation>;
export type SendNotificationToUsersMutationResult = Apollo.MutationResult<SendNotificationToUsersMutation>;
export type SendNotificationToUsersMutationOptions = Apollo.BaseMutationOptions<SendNotificationToUsersMutation, SendNotificationToUsersMutationVariables>;
export const SendNotificationToSiteDocument = gql`
    mutation SEND_NOTIFICATION_TO_SITE($siteId: ID!, $title: String, $body: String, $notificationCategory: NotificationCategory, $deeplink: String, $slug: String!) {
  sendNotificationToSite(
    siteId: $siteId
    title: $title
    body: $body
    notificationCategory: $notificationCategory
    deeplink: $deeplink
    slug: $slug
  )
}
    `;
export type SendNotificationToSiteMutationFn = Apollo.MutationFunction<SendNotificationToSiteMutation, SendNotificationToSiteMutationVariables>;

/**
 * __useSendNotificationToSiteMutation__
 *
 * To run a mutation, you first call `useSendNotificationToSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNotificationToSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNotificationToSiteMutation, { data, loading, error }] = useSendNotificationToSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      notificationCategory: // value for 'notificationCategory'
 *      deeplink: // value for 'deeplink'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSendNotificationToSiteMutation(baseOptions?: Apollo.MutationHookOptions<SendNotificationToSiteMutation, SendNotificationToSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendNotificationToSiteMutation, SendNotificationToSiteMutationVariables>(SendNotificationToSiteDocument, options);
      }
export type SendNotificationToSiteMutationHookResult = ReturnType<typeof useSendNotificationToSiteMutation>;
export type SendNotificationToSiteMutationResult = Apollo.MutationResult<SendNotificationToSiteMutation>;
export type SendNotificationToSiteMutationOptions = Apollo.BaseMutationOptions<SendNotificationToSiteMutation, SendNotificationToSiteMutationVariables>;
export const ProcessNotificationTokenDocument = gql`
    mutation PROCESS_NOTIFICATION_TOKEN {
  processNotificationTickets
}
    `;
export type ProcessNotificationTokenMutationFn = Apollo.MutationFunction<ProcessNotificationTokenMutation, ProcessNotificationTokenMutationVariables>;

/**
 * __useProcessNotificationTokenMutation__
 *
 * To run a mutation, you first call `useProcessNotificationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessNotificationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processNotificationTokenMutation, { data, loading, error }] = useProcessNotificationTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useProcessNotificationTokenMutation(baseOptions?: Apollo.MutationHookOptions<ProcessNotificationTokenMutation, ProcessNotificationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessNotificationTokenMutation, ProcessNotificationTokenMutationVariables>(ProcessNotificationTokenDocument, options);
      }
export type ProcessNotificationTokenMutationHookResult = ReturnType<typeof useProcessNotificationTokenMutation>;
export type ProcessNotificationTokenMutationResult = Apollo.MutationResult<ProcessNotificationTokenMutation>;
export type ProcessNotificationTokenMutationOptions = Apollo.BaseMutationOptions<ProcessNotificationTokenMutation, ProcessNotificationTokenMutationVariables>;
export const CreateOdooInvoiceDraftDocument = gql`
    mutation CREATE_ODOO_INVOICE_DRAFT($organizationId: ID!, $startDate: String!, $endDate: String!) {
  createOdooInvoiceDraft(
    organizationId: $organizationId
    startDate: $startDate
    endDate: $endDate
  ) {
    invoiceId
    error
  }
}
    `;
export type CreateOdooInvoiceDraftMutationFn = Apollo.MutationFunction<CreateOdooInvoiceDraftMutation, CreateOdooInvoiceDraftMutationVariables>;

/**
 * __useCreateOdooInvoiceDraftMutation__
 *
 * To run a mutation, you first call `useCreateOdooInvoiceDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOdooInvoiceDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOdooInvoiceDraftMutation, { data, loading, error }] = useCreateOdooInvoiceDraftMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreateOdooInvoiceDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateOdooInvoiceDraftMutation, CreateOdooInvoiceDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOdooInvoiceDraftMutation, CreateOdooInvoiceDraftMutationVariables>(CreateOdooInvoiceDraftDocument, options);
      }
export type CreateOdooInvoiceDraftMutationHookResult = ReturnType<typeof useCreateOdooInvoiceDraftMutation>;
export type CreateOdooInvoiceDraftMutationResult = Apollo.MutationResult<CreateOdooInvoiceDraftMutation>;
export type CreateOdooInvoiceDraftMutationOptions = Apollo.BaseMutationOptions<CreateOdooInvoiceDraftMutation, CreateOdooInvoiceDraftMutationVariables>;
export const UpdateOpsParameterDocument = gql`
    mutation UPDATE_OPS_PARAMETER($parameters: OpsParameterDataInput!) {
  updateOpsParameter(parameters: $parameters) {
    ...OpsParameterFragment
  }
}
    ${OpsParameterFragmentFragmentDoc}`;
export type UpdateOpsParameterMutationFn = Apollo.MutationFunction<UpdateOpsParameterMutation, UpdateOpsParameterMutationVariables>;

/**
 * __useUpdateOpsParameterMutation__
 *
 * To run a mutation, you first call `useUpdateOpsParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpsParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpsParameterMutation, { data, loading, error }] = useUpdateOpsParameterMutation({
 *   variables: {
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useUpdateOpsParameterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpsParameterMutation, UpdateOpsParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpsParameterMutation, UpdateOpsParameterMutationVariables>(UpdateOpsParameterDocument, options);
      }
export type UpdateOpsParameterMutationHookResult = ReturnType<typeof useUpdateOpsParameterMutation>;
export type UpdateOpsParameterMutationResult = Apollo.MutationResult<UpdateOpsParameterMutation>;
export type UpdateOpsParameterMutationOptions = Apollo.BaseMutationOptions<UpdateOpsParameterMutation, UpdateOpsParameterMutationVariables>;
export const UpdateOrderInfoDocument = gql`
    mutation UPDATE_ORDER_INFO($orderId: ID!, $fieldsToUpdate: OrderUpdateInput!) {
  updateOrderInfo(orderId: $orderId, fieldsToUpdate: $fieldsToUpdate) {
    success
    errors
    order {
      ...DetailedOrderFragment
    }
  }
}
    ${DetailedOrderFragmentFragmentDoc}`;
export type UpdateOrderInfoMutationFn = Apollo.MutationFunction<UpdateOrderInfoMutation, UpdateOrderInfoMutationVariables>;

/**
 * __useUpdateOrderInfoMutation__
 *
 * To run a mutation, you first call `useUpdateOrderInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderInfoMutation, { data, loading, error }] = useUpdateOrderInfoMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      fieldsToUpdate: // value for 'fieldsToUpdate'
 *   },
 * });
 */
export function useUpdateOrderInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderInfoMutation, UpdateOrderInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderInfoMutation, UpdateOrderInfoMutationVariables>(UpdateOrderInfoDocument, options);
      }
export type UpdateOrderInfoMutationHookResult = ReturnType<typeof useUpdateOrderInfoMutation>;
export type UpdateOrderInfoMutationResult = Apollo.MutationResult<UpdateOrderInfoMutation>;
export type UpdateOrderInfoMutationOptions = Apollo.BaseMutationOptions<UpdateOrderInfoMutation, UpdateOrderInfoMutationVariables>;
export const SoftDeleteOrderDocument = gql`
    mutation SOFT_DELETE_ORDER($orderId: ID!) {
  softDeleteOrder(orderId: $orderId) {
    success
    errors
    order {
      _id
      state
    }
  }
}
    `;
export type SoftDeleteOrderMutationFn = Apollo.MutationFunction<SoftDeleteOrderMutation, SoftDeleteOrderMutationVariables>;

/**
 * __useSoftDeleteOrderMutation__
 *
 * To run a mutation, you first call `useSoftDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteOrderMutation, { data, loading, error }] = useSoftDeleteOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSoftDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteOrderMutation, SoftDeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteOrderMutation, SoftDeleteOrderMutationVariables>(SoftDeleteOrderDocument, options);
      }
export type SoftDeleteOrderMutationHookResult = ReturnType<typeof useSoftDeleteOrderMutation>;
export type SoftDeleteOrderMutationResult = Apollo.MutationResult<SoftDeleteOrderMutation>;
export type SoftDeleteOrderMutationOptions = Apollo.BaseMutationOptions<SoftDeleteOrderMutation, SoftDeleteOrderMutationVariables>;
export const ChargeOrderDocument = gql`
    mutation CHARGE_ORDER($orderId: ID!) {
  chargeOrder(orderId: $orderId) {
    _id
    invoicing {
      status
      odooInvoiceId
      odooInvoiceUrl
      paymentIntentId
      stripePaymentUrl
    }
  }
}
    `;
export type ChargeOrderMutationFn = Apollo.MutationFunction<ChargeOrderMutation, ChargeOrderMutationVariables>;

/**
 * __useChargeOrderMutation__
 *
 * To run a mutation, you first call `useChargeOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChargeOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chargeOrderMutation, { data, loading, error }] = useChargeOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useChargeOrderMutation(baseOptions?: Apollo.MutationHookOptions<ChargeOrderMutation, ChargeOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChargeOrderMutation, ChargeOrderMutationVariables>(ChargeOrderDocument, options);
      }
export type ChargeOrderMutationHookResult = ReturnType<typeof useChargeOrderMutation>;
export type ChargeOrderMutationResult = Apollo.MutationResult<ChargeOrderMutation>;
export type ChargeOrderMutationOptions = Apollo.BaseMutationOptions<ChargeOrderMutation, ChargeOrderMutationVariables>;
export const DuplicateOrderDocument = gql`
    mutation DUPLICATE_ORDER($orderToDuplicateId: ID!, $destinationTotemId: ID!, $deliveryDate: String!, $deliveryTimeWindow: DeliveryTimeWindowInput!, $isOrderPunctual: Boolean!) {
  duplicateOrder(
    orderToDuplicateId: $orderToDuplicateId
    destinationTotemId: $destinationTotemId
    deliveryDate: $deliveryDate
    deliveryTimeWindow: $deliveryTimeWindow
    isOrderPunctual: $isOrderPunctual
  ) {
    _id
  }
}
    `;
export type DuplicateOrderMutationFn = Apollo.MutationFunction<DuplicateOrderMutation, DuplicateOrderMutationVariables>;

/**
 * __useDuplicateOrderMutation__
 *
 * To run a mutation, you first call `useDuplicateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOrderMutation, { data, loading, error }] = useDuplicateOrderMutation({
 *   variables: {
 *      orderToDuplicateId: // value for 'orderToDuplicateId'
 *      destinationTotemId: // value for 'destinationTotemId'
 *      deliveryDate: // value for 'deliveryDate'
 *      deliveryTimeWindow: // value for 'deliveryTimeWindow'
 *      isOrderPunctual: // value for 'isOrderPunctual'
 *   },
 * });
 */
export function useDuplicateOrderMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateOrderMutation, DuplicateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateOrderMutation, DuplicateOrderMutationVariables>(DuplicateOrderDocument, options);
      }
export type DuplicateOrderMutationHookResult = ReturnType<typeof useDuplicateOrderMutation>;
export type DuplicateOrderMutationResult = Apollo.MutationResult<DuplicateOrderMutation>;
export type DuplicateOrderMutationOptions = Apollo.BaseMutationOptions<DuplicateOrderMutation, DuplicateOrderMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UPDATE_ORGANIZATION($organizationId: ID!, $fields: OrganizationUpdateInput!) {
  updateOrganization(organizationId: $organizationId, fields: $fields) {
    error
    formErrors {
      ...FormErrorFragment
    }
    updatedOrganization {
      _id
      B2BPriceRange
      domains
      maxUsers
      customerType
      sales {
        _id
        fullName
      }
      totalCoworkers
      avaClientId
      restrictedProductArrangementId
      hasOdooOrganizationParentInvoicing
      hasDetailedOrderInvoicing
      odooOrganizationId
      odooInvoiceReference
      paymentTimeType
      paymentType
      invoiceSettings {
        _id
        organizationId
        consumptionColumns {
          microstoreColumnIds
          priceOptionType
          tva
          priceTiers {
            thresholdMin
            unitPrice
            unitPriceWithoutCup
          }
        }
        rmeColumns {
          microstoreColumnIds
          type
          minimumAmount
          unitPrice
        }
        state
        createdAt
        updatedAt
      }
    }
  }
}
    ${FormErrorFragmentFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CREATE_ORGANIZATION($input: OrganizationCreateInput!) {
  createOrganization(input: $input) {
    error
    createdOrganization {
      _id
      name
    }
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const SyncOrganizationInvoiceBoostsDocument = gql`
    mutation SYNC_ORGANIZATION_INVOICE_BOOSTS {
  syncOrganizationInvoiceBoosts {
    success
    error
    spreadsheetUrl
    columnCount
    addedCount
    updatedCount
    obsoleteCount
    duplicateCount
  }
}
    `;
export type SyncOrganizationInvoiceBoostsMutationFn = Apollo.MutationFunction<SyncOrganizationInvoiceBoostsMutation, SyncOrganizationInvoiceBoostsMutationVariables>;

/**
 * __useSyncOrganizationInvoiceBoostsMutation__
 *
 * To run a mutation, you first call `useSyncOrganizationInvoiceBoostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncOrganizationInvoiceBoostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncOrganizationInvoiceBoostsMutation, { data, loading, error }] = useSyncOrganizationInvoiceBoostsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncOrganizationInvoiceBoostsMutation(baseOptions?: Apollo.MutationHookOptions<SyncOrganizationInvoiceBoostsMutation, SyncOrganizationInvoiceBoostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncOrganizationInvoiceBoostsMutation, SyncOrganizationInvoiceBoostsMutationVariables>(SyncOrganizationInvoiceBoostsDocument, options);
      }
export type SyncOrganizationInvoiceBoostsMutationHookResult = ReturnType<typeof useSyncOrganizationInvoiceBoostsMutation>;
export type SyncOrganizationInvoiceBoostsMutationResult = Apollo.MutationResult<SyncOrganizationInvoiceBoostsMutation>;
export type SyncOrganizationInvoiceBoostsMutationOptions = Apollo.BaseMutationOptions<SyncOrganizationInvoiceBoostsMutation, SyncOrganizationInvoiceBoostsMutationVariables>;
export const AttachLastStripePaymentMethodDocument = gql`
    mutation ATTACH_LAST_STRIPE_PAYMENT_METHOD($userId: ID!) {
  attachLastStripePaymentMethod(userId: $userId) {
    error
    success
    user {
      _id
      wallet {
        ownerId
        creditCards {
          _id
          default
          details {
            number
            expiration
            bank
            country
            expYear
            expMonth
          }
          expired
          paymentType
          provider
          retries
          type
        }
      }
    }
  }
}
    `;
export type AttachLastStripePaymentMethodMutationFn = Apollo.MutationFunction<AttachLastStripePaymentMethodMutation, AttachLastStripePaymentMethodMutationVariables>;

/**
 * __useAttachLastStripePaymentMethodMutation__
 *
 * To run a mutation, you first call `useAttachLastStripePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachLastStripePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachLastStripePaymentMethodMutation, { data, loading, error }] = useAttachLastStripePaymentMethodMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAttachLastStripePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<AttachLastStripePaymentMethodMutation, AttachLastStripePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachLastStripePaymentMethodMutation, AttachLastStripePaymentMethodMutationVariables>(AttachLastStripePaymentMethodDocument, options);
      }
export type AttachLastStripePaymentMethodMutationHookResult = ReturnType<typeof useAttachLastStripePaymentMethodMutation>;
export type AttachLastStripePaymentMethodMutationResult = Apollo.MutationResult<AttachLastStripePaymentMethodMutation>;
export type AttachLastStripePaymentMethodMutationOptions = Apollo.BaseMutationOptions<AttachLastStripePaymentMethodMutation, AttachLastStripePaymentMethodMutationVariables>;
export const CreatePollDocument = gql`
    mutation CreatePoll($input: PollInput!) {
  createPoll(input: $input) {
    success
    errors
    poll {
      ...PollFragment
    }
  }
}
    ${PollFragmentFragmentDoc}`;
export type CreatePollMutationFn = Apollo.MutationFunction<CreatePollMutation, CreatePollMutationVariables>;

/**
 * __useCreatePollMutation__
 *
 * To run a mutation, you first call `useCreatePollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPollMutation, { data, loading, error }] = useCreatePollMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePollMutation(baseOptions?: Apollo.MutationHookOptions<CreatePollMutation, CreatePollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePollMutation, CreatePollMutationVariables>(CreatePollDocument, options);
      }
export type CreatePollMutationHookResult = ReturnType<typeof useCreatePollMutation>;
export type CreatePollMutationResult = Apollo.MutationResult<CreatePollMutation>;
export type CreatePollMutationOptions = Apollo.BaseMutationOptions<CreatePollMutation, CreatePollMutationVariables>;
export const UpdatePollDocument = gql`
    mutation UpdatePoll($pollId: ID!, $input: PollInput!) {
  updatePoll(pollId: $pollId, input: $input) {
    success
    errors
    poll {
      ...PollFragment
    }
  }
}
    ${PollFragmentFragmentDoc}`;
export type UpdatePollMutationFn = Apollo.MutationFunction<UpdatePollMutation, UpdatePollMutationVariables>;

/**
 * __useUpdatePollMutation__
 *
 * To run a mutation, you first call `useUpdatePollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePollMutation, { data, loading, error }] = useUpdatePollMutation({
 *   variables: {
 *      pollId: // value for 'pollId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePollMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePollMutation, UpdatePollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePollMutation, UpdatePollMutationVariables>(UpdatePollDocument, options);
      }
export type UpdatePollMutationHookResult = ReturnType<typeof useUpdatePollMutation>;
export type UpdatePollMutationResult = Apollo.MutationResult<UpdatePollMutation>;
export type UpdatePollMutationOptions = Apollo.BaseMutationOptions<UpdatePollMutation, UpdatePollMutationVariables>;
export const CreatePriceRangeDocument = gql`
    mutation CREATE_PRICE_RANGE($rangeName: String!, $products: [ProductPriceInput!]!, $productArrangements: [ProductArrangementPriceInput!]!) {
  createPriceRange(
    rangeName: $rangeName
    products: $products
    productArrangements: $productArrangements
  ) {
    rangeId
    success
    error
  }
}
    `;
export type CreatePriceRangeMutationFn = Apollo.MutationFunction<CreatePriceRangeMutation, CreatePriceRangeMutationVariables>;

/**
 * __useCreatePriceRangeMutation__
 *
 * To run a mutation, you first call `useCreatePriceRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePriceRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPriceRangeMutation, { data, loading, error }] = useCreatePriceRangeMutation({
 *   variables: {
 *      rangeName: // value for 'rangeName'
 *      products: // value for 'products'
 *      productArrangements: // value for 'productArrangements'
 *   },
 * });
 */
export function useCreatePriceRangeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePriceRangeMutation, CreatePriceRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePriceRangeMutation, CreatePriceRangeMutationVariables>(CreatePriceRangeDocument, options);
      }
export type CreatePriceRangeMutationHookResult = ReturnType<typeof useCreatePriceRangeMutation>;
export type CreatePriceRangeMutationResult = Apollo.MutationResult<CreatePriceRangeMutation>;
export type CreatePriceRangeMutationOptions = Apollo.BaseMutationOptions<CreatePriceRangeMutation, CreatePriceRangeMutationVariables>;
export const UpdatePriceRangeDocument = gql`
    mutation UPDATE_PRICE_RANGE($rangeName: String!, $rangeId: ID!, $products: [ProductPriceInput!]!, $productArrangements: [ProductArrangementPriceInput!]!) {
  updatePriceRange(
    rangeName: $rangeName
    rangeId: $rangeId
    products: $products
    productArrangements: $productArrangements
  ) {
    rangeId
    success
    error
  }
}
    `;
export type UpdatePriceRangeMutationFn = Apollo.MutationFunction<UpdatePriceRangeMutation, UpdatePriceRangeMutationVariables>;

/**
 * __useUpdatePriceRangeMutation__
 *
 * To run a mutation, you first call `useUpdatePriceRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriceRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriceRangeMutation, { data, loading, error }] = useUpdatePriceRangeMutation({
 *   variables: {
 *      rangeName: // value for 'rangeName'
 *      rangeId: // value for 'rangeId'
 *      products: // value for 'products'
 *      productArrangements: // value for 'productArrangements'
 *   },
 * });
 */
export function useUpdatePriceRangeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePriceRangeMutation, UpdatePriceRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePriceRangeMutation, UpdatePriceRangeMutationVariables>(UpdatePriceRangeDocument, options);
      }
export type UpdatePriceRangeMutationHookResult = ReturnType<typeof useUpdatePriceRangeMutation>;
export type UpdatePriceRangeMutationResult = Apollo.MutationResult<UpdatePriceRangeMutation>;
export type UpdatePriceRangeMutationOptions = Apollo.BaseMutationOptions<UpdatePriceRangeMutation, UpdatePriceRangeMutationVariables>;
export const UpdateProductDocument = gql`
    mutation UPDATE_PRODUCT($productId: ID!, $fields: ProductUpdateInput!) {
  updateProduct(productId: $productId, fields: $fields) {
    success
    formErrors {
      ...FormErrorFragment
    }
    updatedProduct {
      ...ProductFragment
    }
    errors
  }
}
    ${FormErrorFragmentFragmentDoc}
${ProductFragmentFragmentDoc}`;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const CreateProductDocument = gql`
    mutation CREATE_PRODUCT($fields: ProductUpdateInput!) {
  createProductResolver(fields: $fields) {
    success
    formErrors {
      ...FormErrorFragment
    }
    createdProductId
  }
}
    ${FormErrorFragmentFragmentDoc}`;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const CreateProductsFromImportDocument = gql`
    mutation CREATE_PRODUCTS_FROM_IMPORT($productsToCreate: [ProductCreateCsvImport!]!) {
  createProductsFromImport(productsToCreate: $productsToCreate) {
    success
    error
    products {
      ...ProductFragment
    }
  }
}
    ${ProductFragmentFragmentDoc}`;
export type CreateProductsFromImportMutationFn = Apollo.MutationFunction<CreateProductsFromImportMutation, CreateProductsFromImportMutationVariables>;

/**
 * __useCreateProductsFromImportMutation__
 *
 * To run a mutation, you first call `useCreateProductsFromImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductsFromImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductsFromImportMutation, { data, loading, error }] = useCreateProductsFromImportMutation({
 *   variables: {
 *      productsToCreate: // value for 'productsToCreate'
 *   },
 * });
 */
export function useCreateProductsFromImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductsFromImportMutation, CreateProductsFromImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductsFromImportMutation, CreateProductsFromImportMutationVariables>(CreateProductsFromImportDocument, options);
      }
export type CreateProductsFromImportMutationHookResult = ReturnType<typeof useCreateProductsFromImportMutation>;
export type CreateProductsFromImportMutationResult = Apollo.MutationResult<CreateProductsFromImportMutation>;
export type CreateProductsFromImportMutationOptions = Apollo.BaseMutationOptions<CreateProductsFromImportMutation, CreateProductsFromImportMutationVariables>;
export const UpdateProductsFromImportDocument = gql`
    mutation UPDATE_PRODUCTS_FROM_IMPORT($productsToUpdate: [ProductUpdateCsvImport!]!) {
  updateProductsFromImport(productsToUpdate: $productsToUpdate) {
    success
    error
    products {
      ...ProductFragment
    }
  }
}
    ${ProductFragmentFragmentDoc}`;
export type UpdateProductsFromImportMutationFn = Apollo.MutationFunction<UpdateProductsFromImportMutation, UpdateProductsFromImportMutationVariables>;

/**
 * __useUpdateProductsFromImportMutation__
 *
 * To run a mutation, you first call `useUpdateProductsFromImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductsFromImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductsFromImportMutation, { data, loading, error }] = useUpdateProductsFromImportMutation({
 *   variables: {
 *      productsToUpdate: // value for 'productsToUpdate'
 *   },
 * });
 */
export function useUpdateProductsFromImportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductsFromImportMutation, UpdateProductsFromImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductsFromImportMutation, UpdateProductsFromImportMutationVariables>(UpdateProductsFromImportDocument, options);
      }
export type UpdateProductsFromImportMutationHookResult = ReturnType<typeof useUpdateProductsFromImportMutation>;
export type UpdateProductsFromImportMutationResult = Apollo.MutationResult<UpdateProductsFromImportMutation>;
export type UpdateProductsFromImportMutationOptions = Apollo.BaseMutationOptions<UpdateProductsFromImportMutation, UpdateProductsFromImportMutationVariables>;
export const UpdateProductStateDocument = gql`
    mutation UPDATE_PRODUCT_STATE($stateToSet: ProductState!, $productId: ID!) {
  updateProductStateResolver(stateToSet: $stateToSet, productId: $productId) {
    success
    error
    formErrors {
      ...FormErrorFragment
    }
    product {
      ...ProductFragment
    }
  }
}
    ${FormErrorFragmentFragmentDoc}
${ProductFragmentFragmentDoc}`;
export type UpdateProductStateMutationFn = Apollo.MutationFunction<UpdateProductStateMutation, UpdateProductStateMutationVariables>;

/**
 * __useUpdateProductStateMutation__
 *
 * To run a mutation, you first call `useUpdateProductStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductStateMutation, { data, loading, error }] = useUpdateProductStateMutation({
 *   variables: {
 *      stateToSet: // value for 'stateToSet'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useUpdateProductStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductStateMutation, UpdateProductStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductStateMutation, UpdateProductStateMutationVariables>(UpdateProductStateDocument, options);
      }
export type UpdateProductStateMutationHookResult = ReturnType<typeof useUpdateProductStateMutation>;
export type UpdateProductStateMutationResult = Apollo.MutationResult<UpdateProductStateMutation>;
export type UpdateProductStateMutationOptions = Apollo.BaseMutationOptions<UpdateProductStateMutation, UpdateProductStateMutationVariables>;
export const ReplaceProductInOrdersDocument = gql`
    mutation REPLACE_PRODUCT_IN_ORDERS($productToRemoveId: ID!, $productToAddId: ID!, $shouldSendEmail: Boolean) {
  replaceProductInOrders(
    productToRemoveId: $productToRemoveId
    productToAddId: $productToAddId
    shouldSendEmail: $shouldSendEmail
  ) {
    success
    errors
  }
}
    `;
export type ReplaceProductInOrdersMutationFn = Apollo.MutationFunction<ReplaceProductInOrdersMutation, ReplaceProductInOrdersMutationVariables>;

/**
 * __useReplaceProductInOrdersMutation__
 *
 * To run a mutation, you first call `useReplaceProductInOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceProductInOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceProductInOrdersMutation, { data, loading, error }] = useReplaceProductInOrdersMutation({
 *   variables: {
 *      productToRemoveId: // value for 'productToRemoveId'
 *      productToAddId: // value for 'productToAddId'
 *      shouldSendEmail: // value for 'shouldSendEmail'
 *   },
 * });
 */
export function useReplaceProductInOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceProductInOrdersMutation, ReplaceProductInOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceProductInOrdersMutation, ReplaceProductInOrdersMutationVariables>(ReplaceProductInOrdersDocument, options);
      }
export type ReplaceProductInOrdersMutationHookResult = ReturnType<typeof useReplaceProductInOrdersMutation>;
export type ReplaceProductInOrdersMutationResult = Apollo.MutationResult<ReplaceProductInOrdersMutation>;
export type ReplaceProductInOrdersMutationOptions = Apollo.BaseMutationOptions<ReplaceProductInOrdersMutation, ReplaceProductInOrdersMutationVariables>;
export const RemoveProductInOrdersDocument = gql`
    mutation REMOVE_PRODUCT_IN_ORDERS($productToRemoveId: ID!, $shouldSendEmail: Boolean) {
  removeProductInOrders(
    productToRemoveId: $productToRemoveId
    shouldSendEmail: $shouldSendEmail
  ) {
    success
    errors
  }
}
    `;
export type RemoveProductInOrdersMutationFn = Apollo.MutationFunction<RemoveProductInOrdersMutation, RemoveProductInOrdersMutationVariables>;

/**
 * __useRemoveProductInOrdersMutation__
 *
 * To run a mutation, you first call `useRemoveProductInOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductInOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductInOrdersMutation, { data, loading, error }] = useRemoveProductInOrdersMutation({
 *   variables: {
 *      productToRemoveId: // value for 'productToRemoveId'
 *      shouldSendEmail: // value for 'shouldSendEmail'
 *   },
 * });
 */
export function useRemoveProductInOrdersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductInOrdersMutation, RemoveProductInOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductInOrdersMutation, RemoveProductInOrdersMutationVariables>(RemoveProductInOrdersDocument, options);
      }
export type RemoveProductInOrdersMutationHookResult = ReturnType<typeof useRemoveProductInOrdersMutation>;
export type RemoveProductInOrdersMutationResult = Apollo.MutationResult<RemoveProductInOrdersMutation>;
export type RemoveProductInOrdersMutationOptions = Apollo.BaseMutationOptions<RemoveProductInOrdersMutation, RemoveProductInOrdersMutationVariables>;
export const UpdateProductRecipeDocument = gql`
    mutation UPDATE_PRODUCT_RECIPE($productId: ID!, $recipe: ProductRecipeInput) {
  updateProductRecipe(productId: $productId, recipe: $recipe) {
    success
    error
    product {
      _id
      fullname
      recipe {
        ingredients {
          productId
          quantity
          hotDrinksIngredientUnit
          product {
            _id
            name
            fullname
            imageUrl
            weightWithoutPackaging
          }
        }
      }
    }
  }
}
    `;
export type UpdateProductRecipeMutationFn = Apollo.MutationFunction<UpdateProductRecipeMutation, UpdateProductRecipeMutationVariables>;

/**
 * __useUpdateProductRecipeMutation__
 *
 * To run a mutation, you first call `useUpdateProductRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductRecipeMutation, { data, loading, error }] = useUpdateProductRecipeMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      recipe: // value for 'recipe'
 *   },
 * });
 */
export function useUpdateProductRecipeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductRecipeMutation, UpdateProductRecipeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductRecipeMutation, UpdateProductRecipeMutationVariables>(UpdateProductRecipeDocument, options);
      }
export type UpdateProductRecipeMutationHookResult = ReturnType<typeof useUpdateProductRecipeMutation>;
export type UpdateProductRecipeMutationResult = Apollo.MutationResult<UpdateProductRecipeMutation>;
export type UpdateProductRecipeMutationOptions = Apollo.BaseMutationOptions<UpdateProductRecipeMutation, UpdateProductRecipeMutationVariables>;
export const CreateProductArrangementDocument = gql`
    mutation CREATE_PRODUCT_ARRANGEMENT($name: String!) {
  createProductArrangementMutation(name: $name) {
    newProductArrangement {
      ...ProductArrangementFragment
    }
    errors
  }
}
    ${ProductArrangementFragmentFragmentDoc}`;
export type CreateProductArrangementMutationFn = Apollo.MutationFunction<CreateProductArrangementMutation, CreateProductArrangementMutationVariables>;

/**
 * __useCreateProductArrangementMutation__
 *
 * To run a mutation, you first call `useCreateProductArrangementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductArrangementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductArrangementMutation, { data, loading, error }] = useCreateProductArrangementMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateProductArrangementMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductArrangementMutation, CreateProductArrangementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductArrangementMutation, CreateProductArrangementMutationVariables>(CreateProductArrangementDocument, options);
      }
export type CreateProductArrangementMutationHookResult = ReturnType<typeof useCreateProductArrangementMutation>;
export type CreateProductArrangementMutationResult = Apollo.MutationResult<CreateProductArrangementMutation>;
export type CreateProductArrangementMutationOptions = Apollo.BaseMutationOptions<CreateProductArrangementMutation, CreateProductArrangementMutationVariables>;
export const ArchiveProductArrangementsDocument = gql`
    mutation ARCHIVE_PRODUCT_ARRANGEMENTS($productArrangementIds: [String!]!) {
  archiveProductArrangementsMutation(
    productArrangementIds: $productArrangementIds
  ) {
    archivedProductArrangementIds
    errors
  }
}
    `;
export type ArchiveProductArrangementsMutationFn = Apollo.MutationFunction<ArchiveProductArrangementsMutation, ArchiveProductArrangementsMutationVariables>;

/**
 * __useArchiveProductArrangementsMutation__
 *
 * To run a mutation, you first call `useArchiveProductArrangementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProductArrangementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProductArrangementsMutation, { data, loading, error }] = useArchiveProductArrangementsMutation({
 *   variables: {
 *      productArrangementIds: // value for 'productArrangementIds'
 *   },
 * });
 */
export function useArchiveProductArrangementsMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProductArrangementsMutation, ArchiveProductArrangementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveProductArrangementsMutation, ArchiveProductArrangementsMutationVariables>(ArchiveProductArrangementsDocument, options);
      }
export type ArchiveProductArrangementsMutationHookResult = ReturnType<typeof useArchiveProductArrangementsMutation>;
export type ArchiveProductArrangementsMutationResult = Apollo.MutationResult<ArchiveProductArrangementsMutation>;
export type ArchiveProductArrangementsMutationOptions = Apollo.BaseMutationOptions<ArchiveProductArrangementsMutation, ArchiveProductArrangementsMutationVariables>;
export const UpdateProductArrangementDocument = gql`
    mutation UPDATE_PRODUCT_ARRANGEMENT($productArrangement: ProductArrangementUpdateInput!) {
  updateProductArrangementMutation(productArrangement: $productArrangement) {
    newProductArrangement {
      ...ProductArrangementWithProductsFragment
    }
    errors
  }
}
    ${ProductArrangementWithProductsFragmentFragmentDoc}`;
export type UpdateProductArrangementMutationFn = Apollo.MutationFunction<UpdateProductArrangementMutation, UpdateProductArrangementMutationVariables>;

/**
 * __useUpdateProductArrangementMutation__
 *
 * To run a mutation, you first call `useUpdateProductArrangementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductArrangementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductArrangementMutation, { data, loading, error }] = useUpdateProductArrangementMutation({
 *   variables: {
 *      productArrangement: // value for 'productArrangement'
 *   },
 * });
 */
export function useUpdateProductArrangementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductArrangementMutation, UpdateProductArrangementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductArrangementMutation, UpdateProductArrangementMutationVariables>(UpdateProductArrangementDocument, options);
      }
export type UpdateProductArrangementMutationHookResult = ReturnType<typeof useUpdateProductArrangementMutation>;
export type UpdateProductArrangementMutationResult = Apollo.MutationResult<UpdateProductArrangementMutation>;
export type UpdateProductArrangementMutationOptions = Apollo.BaseMutationOptions<UpdateProductArrangementMutation, UpdateProductArrangementMutationVariables>;
export const CreateProductGroupDocument = gql`
    mutation CREATE_PRODUCT_GROUP($productId: ID!) {
  createProductGroup(productId: $productId) {
    ...ProductGroupFragment
  }
}
    ${ProductGroupFragmentFragmentDoc}`;
export type CreateProductGroupMutationFn = Apollo.MutationFunction<CreateProductGroupMutation, CreateProductGroupMutationVariables>;

/**
 * __useCreateProductGroupMutation__
 *
 * To run a mutation, you first call `useCreateProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductGroupMutation, { data, loading, error }] = useCreateProductGroupMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useCreateProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductGroupMutation, CreateProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductGroupMutation, CreateProductGroupMutationVariables>(CreateProductGroupDocument, options);
      }
export type CreateProductGroupMutationHookResult = ReturnType<typeof useCreateProductGroupMutation>;
export type CreateProductGroupMutationResult = Apollo.MutationResult<CreateProductGroupMutation>;
export type CreateProductGroupMutationOptions = Apollo.BaseMutationOptions<CreateProductGroupMutation, CreateProductGroupMutationVariables>;
export const UpdateProductGroupDocument = gql`
    mutation UPDATE_PRODUCT_GROUP($composition: [ProductGroupCompositionEntryInput!]!, $productGroupId: ID!) {
  updateProductGroup(composition: $composition, productGroupId: $productGroupId) {
    ...ProductGroupFragment
  }
}
    ${ProductGroupFragmentFragmentDoc}`;
export type UpdateProductGroupMutationFn = Apollo.MutationFunction<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>;

/**
 * __useUpdateProductGroupMutation__
 *
 * To run a mutation, you first call `useUpdateProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductGroupMutation, { data, loading, error }] = useUpdateProductGroupMutation({
 *   variables: {
 *      composition: // value for 'composition'
 *      productGroupId: // value for 'productGroupId'
 *   },
 * });
 */
export function useUpdateProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>(UpdateProductGroupDocument, options);
      }
export type UpdateProductGroupMutationHookResult = ReturnType<typeof useUpdateProductGroupMutation>;
export type UpdateProductGroupMutationResult = Apollo.MutationResult<UpdateProductGroupMutation>;
export type UpdateProductGroupMutationOptions = Apollo.BaseMutationOptions<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>;
export const CreateProductSwitchDocument = gql`
    mutation CREATE_PRODUCT_SWITCH($productSwitchCreateInput: ProductSwitchCreateInput!) {
  createProductSwitch(productSwitchCreateInput: $productSwitchCreateInput) {
    ...ProductSwitchFragment
  }
}
    ${ProductSwitchFragmentFragmentDoc}`;
export type CreateProductSwitchMutationFn = Apollo.MutationFunction<CreateProductSwitchMutation, CreateProductSwitchMutationVariables>;

/**
 * __useCreateProductSwitchMutation__
 *
 * To run a mutation, you first call `useCreateProductSwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductSwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductSwitchMutation, { data, loading, error }] = useCreateProductSwitchMutation({
 *   variables: {
 *      productSwitchCreateInput: // value for 'productSwitchCreateInput'
 *   },
 * });
 */
export function useCreateProductSwitchMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductSwitchMutation, CreateProductSwitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductSwitchMutation, CreateProductSwitchMutationVariables>(CreateProductSwitchDocument, options);
      }
export type CreateProductSwitchMutationHookResult = ReturnType<typeof useCreateProductSwitchMutation>;
export type CreateProductSwitchMutationResult = Apollo.MutationResult<CreateProductSwitchMutation>;
export type CreateProductSwitchMutationOptions = Apollo.BaseMutationOptions<CreateProductSwitchMutation, CreateProductSwitchMutationVariables>;
export const ArchiveProductSwitchDocument = gql`
    mutation ARCHIVE_PRODUCT_SWITCH($productSwitchId: ID!) {
  archiveProductSwitch(productSwitchId: $productSwitchId) {
    ...ProductSwitchFragment
  }
}
    ${ProductSwitchFragmentFragmentDoc}`;
export type ArchiveProductSwitchMutationFn = Apollo.MutationFunction<ArchiveProductSwitchMutation, ArchiveProductSwitchMutationVariables>;

/**
 * __useArchiveProductSwitchMutation__
 *
 * To run a mutation, you first call `useArchiveProductSwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProductSwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProductSwitchMutation, { data, loading, error }] = useArchiveProductSwitchMutation({
 *   variables: {
 *      productSwitchId: // value for 'productSwitchId'
 *   },
 * });
 */
export function useArchiveProductSwitchMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProductSwitchMutation, ArchiveProductSwitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveProductSwitchMutation, ArchiveProductSwitchMutationVariables>(ArchiveProductSwitchDocument, options);
      }
export type ArchiveProductSwitchMutationHookResult = ReturnType<typeof useArchiveProductSwitchMutation>;
export type ArchiveProductSwitchMutationResult = Apollo.MutationResult<ArchiveProductSwitchMutation>;
export type ArchiveProductSwitchMutationOptions = Apollo.BaseMutationOptions<ArchiveProductSwitchMutation, ArchiveProductSwitchMutationVariables>;
export const UpdateProductSwitchDocument = gql`
    mutation UPDATE_PRODUCT_SWITCH($productSwitchUpdateInput: ProductSwitchUpdateInput!) {
  updateProductSwitch(productSwitchUpdateInput: $productSwitchUpdateInput) {
    ...ProductSwitchFragment
  }
}
    ${ProductSwitchFragmentFragmentDoc}`;
export type UpdateProductSwitchMutationFn = Apollo.MutationFunction<UpdateProductSwitchMutation, UpdateProductSwitchMutationVariables>;

/**
 * __useUpdateProductSwitchMutation__
 *
 * To run a mutation, you first call `useUpdateProductSwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductSwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductSwitchMutation, { data, loading, error }] = useUpdateProductSwitchMutation({
 *   variables: {
 *      productSwitchUpdateInput: // value for 'productSwitchUpdateInput'
 *   },
 * });
 */
export function useUpdateProductSwitchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductSwitchMutation, UpdateProductSwitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductSwitchMutation, UpdateProductSwitchMutationVariables>(UpdateProductSwitchDocument, options);
      }
export type UpdateProductSwitchMutationHookResult = ReturnType<typeof useUpdateProductSwitchMutation>;
export type UpdateProductSwitchMutationResult = Apollo.MutationResult<UpdateProductSwitchMutation>;
export type UpdateProductSwitchMutationOptions = Apollo.BaseMutationOptions<UpdateProductSwitchMutation, UpdateProductSwitchMutationVariables>;
export const CreateQuizDocument = gql`
    mutation CreateQuiz($input: QuizInput!) {
  createQuiz(input: $input) {
    success
    errors
    quiz {
      ...QuizFragment
    }
  }
}
    ${QuizFragmentFragmentDoc}`;
export type CreateQuizMutationFn = Apollo.MutationFunction<CreateQuizMutation, CreateQuizMutationVariables>;

/**
 * __useCreateQuizMutation__
 *
 * To run a mutation, you first call `useCreateQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuizMutation, { data, loading, error }] = useCreateQuizMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuizMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuizMutation, CreateQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuizMutation, CreateQuizMutationVariables>(CreateQuizDocument, options);
      }
export type CreateQuizMutationHookResult = ReturnType<typeof useCreateQuizMutation>;
export type CreateQuizMutationResult = Apollo.MutationResult<CreateQuizMutation>;
export type CreateQuizMutationOptions = Apollo.BaseMutationOptions<CreateQuizMutation, CreateQuizMutationVariables>;
export const UpdateQuizDocument = gql`
    mutation UpdateQuiz($quizId: ID!, $input: QuizInput!) {
  updateQuiz(quizId: $quizId, input: $input) {
    success
    errors
    quiz {
      ...QuizFragment
    }
  }
}
    ${QuizFragmentFragmentDoc}`;
export type UpdateQuizMutationFn = Apollo.MutationFunction<UpdateQuizMutation, UpdateQuizMutationVariables>;

/**
 * __useUpdateQuizMutation__
 *
 * To run a mutation, you first call `useUpdateQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuizMutation, { data, loading, error }] = useUpdateQuizMutation({
 *   variables: {
 *      quizId: // value for 'quizId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuizMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuizMutation, UpdateQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuizMutation, UpdateQuizMutationVariables>(UpdateQuizDocument, options);
      }
export type UpdateQuizMutationHookResult = ReturnType<typeof useUpdateQuizMutation>;
export type UpdateQuizMutationResult = Apollo.MutationResult<UpdateQuizMutation>;
export type UpdateQuizMutationOptions = Apollo.BaseMutationOptions<UpdateQuizMutation, UpdateQuizMutationVariables>;
export const CreateRitualDocument = gql`
    mutation CREATE_RITUAL($createRitualInput: CreateRitualInput!) {
  createRitual(createRitualInput: $createRitualInput) {
    success
    errors
    createdRitual {
      ...DetailedRitualFragment
    }
  }
}
    ${DetailedRitualFragmentFragmentDoc}`;
export type CreateRitualMutationFn = Apollo.MutationFunction<CreateRitualMutation, CreateRitualMutationVariables>;

/**
 * __useCreateRitualMutation__
 *
 * To run a mutation, you first call `useCreateRitualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRitualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRitualMutation, { data, loading, error }] = useCreateRitualMutation({
 *   variables: {
 *      createRitualInput: // value for 'createRitualInput'
 *   },
 * });
 */
export function useCreateRitualMutation(baseOptions?: Apollo.MutationHookOptions<CreateRitualMutation, CreateRitualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRitualMutation, CreateRitualMutationVariables>(CreateRitualDocument, options);
      }
export type CreateRitualMutationHookResult = ReturnType<typeof useCreateRitualMutation>;
export type CreateRitualMutationResult = Apollo.MutationResult<CreateRitualMutation>;
export type CreateRitualMutationOptions = Apollo.BaseMutationOptions<CreateRitualMutation, CreateRitualMutationVariables>;
export const UpdateRitualDocument = gql`
    mutation UPDATE_RITUAL($ritualId: ID!, $updateInput: UpdateRitualInput!) {
  updateRitual(ritualId: $ritualId, updateInput: $updateInput) {
    success
    errors
    updatedRitual {
      ...DetailedRitualFragment
    }
  }
}
    ${DetailedRitualFragmentFragmentDoc}`;
export type UpdateRitualMutationFn = Apollo.MutationFunction<UpdateRitualMutation, UpdateRitualMutationVariables>;

/**
 * __useUpdateRitualMutation__
 *
 * To run a mutation, you first call `useUpdateRitualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRitualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRitualMutation, { data, loading, error }] = useUpdateRitualMutation({
 *   variables: {
 *      ritualId: // value for 'ritualId'
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateRitualMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRitualMutation, UpdateRitualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRitualMutation, UpdateRitualMutationVariables>(UpdateRitualDocument, options);
      }
export type UpdateRitualMutationHookResult = ReturnType<typeof useUpdateRitualMutation>;
export type UpdateRitualMutationResult = Apollo.MutationResult<UpdateRitualMutation>;
export type UpdateRitualMutationOptions = Apollo.BaseMutationOptions<UpdateRitualMutation, UpdateRitualMutationVariables>;
export const UpdateRitualStateDocument = gql`
    mutation UPDATE_RITUAL_STATE($ritualId: ID!, $stateToSet: RitualState!) {
  updateRitualState(ritualId: $ritualId, stateToSet: $stateToSet) {
    success
    errors
    updatedRitual {
      ...DetailedRitualFragment
    }
  }
}
    ${DetailedRitualFragmentFragmentDoc}`;
export type UpdateRitualStateMutationFn = Apollo.MutationFunction<UpdateRitualStateMutation, UpdateRitualStateMutationVariables>;

/**
 * __useUpdateRitualStateMutation__
 *
 * To run a mutation, you first call `useUpdateRitualStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRitualStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRitualStateMutation, { data, loading, error }] = useUpdateRitualStateMutation({
 *   variables: {
 *      ritualId: // value for 'ritualId'
 *      stateToSet: // value for 'stateToSet'
 *   },
 * });
 */
export function useUpdateRitualStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRitualStateMutation, UpdateRitualStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRitualStateMutation, UpdateRitualStateMutationVariables>(UpdateRitualStateDocument, options);
      }
export type UpdateRitualStateMutationHookResult = ReturnType<typeof useUpdateRitualStateMutation>;
export type UpdateRitualStateMutationResult = Apollo.MutationResult<UpdateRitualStateMutation>;
export type UpdateRitualStateMutationOptions = Apollo.BaseMutationOptions<UpdateRitualStateMutation, UpdateRitualStateMutationVariables>;
export const CreateRitualTemplateDocument = gql`
    mutation CREATE_RITUAL_TEMPLATE($image: Upload!, $name: String!) {
  createRitualTemplate(image: $image, name: $name) {
    success
    errors
    ritualTemplate {
      _id
      name
      imageUrl
    }
  }
}
    `;
export type CreateRitualTemplateMutationFn = Apollo.MutationFunction<CreateRitualTemplateMutation, CreateRitualTemplateMutationVariables>;

/**
 * __useCreateRitualTemplateMutation__
 *
 * To run a mutation, you first call `useCreateRitualTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRitualTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRitualTemplateMutation, { data, loading, error }] = useCreateRitualTemplateMutation({
 *   variables: {
 *      image: // value for 'image'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateRitualTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateRitualTemplateMutation, CreateRitualTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRitualTemplateMutation, CreateRitualTemplateMutationVariables>(CreateRitualTemplateDocument, options);
      }
export type CreateRitualTemplateMutationHookResult = ReturnType<typeof useCreateRitualTemplateMutation>;
export type CreateRitualTemplateMutationResult = Apollo.MutationResult<CreateRitualTemplateMutation>;
export type CreateRitualTemplateMutationOptions = Apollo.BaseMutationOptions<CreateRitualTemplateMutation, CreateRitualTemplateMutationVariables>;
export const CreateSiteDocument = gql`
    mutation CREATE_SITE($accessTime: Int!, $deliveryDays: [Boolean!]!, $deliveryWindowStart: String!, $deliveryWindowStop: String!, $estimatedUserCount: Int!, $launchDate: String, $name: String!, $organizationId: ID!, $reassortmentFreshFacings: ReassortmentFreshFacingsByCategoriesInput!, $reassortmentStockTargetRatios: ReassortmentStockTargetRatiosInput!, $reassortmentStockTargets: ReassortmentStockByCategoriesInput!, $reassortmentOnboardingStockTargets: ReassortmentStockByCategoriesInput!, $totemId: ID!, $type: SiteType!, $state: SiteState!) {
  createSite(
    accessTime: $accessTime
    deliveryDays: $deliveryDays
    deliveryWindowStart: $deliveryWindowStart
    deliveryWindowStop: $deliveryWindowStop
    estimatedUserCount: $estimatedUserCount
    launchDate: $launchDate
    name: $name
    organizationId: $organizationId
    reassortmentFreshFacings: $reassortmentFreshFacings
    reassortmentStockTargetRatios: $reassortmentStockTargetRatios
    reassortmentStockTargets: $reassortmentStockTargets
    reassortmentOnboardingStockTargets: $reassortmentOnboardingStockTargets
    totemId: $totemId
    type: $type
    state: $state
  ) {
    success
    error
    site {
      _id
      name
    }
  }
}
    `;
export type CreateSiteMutationFn = Apollo.MutationFunction<CreateSiteMutation, CreateSiteMutationVariables>;

/**
 * __useCreateSiteMutation__
 *
 * To run a mutation, you first call `useCreateSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiteMutation, { data, loading, error }] = useCreateSiteMutation({
 *   variables: {
 *      accessTime: // value for 'accessTime'
 *      deliveryDays: // value for 'deliveryDays'
 *      deliveryWindowStart: // value for 'deliveryWindowStart'
 *      deliveryWindowStop: // value for 'deliveryWindowStop'
 *      estimatedUserCount: // value for 'estimatedUserCount'
 *      launchDate: // value for 'launchDate'
 *      name: // value for 'name'
 *      organizationId: // value for 'organizationId'
 *      reassortmentFreshFacings: // value for 'reassortmentFreshFacings'
 *      reassortmentStockTargetRatios: // value for 'reassortmentStockTargetRatios'
 *      reassortmentStockTargets: // value for 'reassortmentStockTargets'
 *      reassortmentOnboardingStockTargets: // value for 'reassortmentOnboardingStockTargets'
 *      totemId: // value for 'totemId'
 *      type: // value for 'type'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useCreateSiteMutation(baseOptions?: Apollo.MutationHookOptions<CreateSiteMutation, CreateSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSiteMutation, CreateSiteMutationVariables>(CreateSiteDocument, options);
      }
export type CreateSiteMutationHookResult = ReturnType<typeof useCreateSiteMutation>;
export type CreateSiteMutationResult = Apollo.MutationResult<CreateSiteMutation>;
export type CreateSiteMutationOptions = Apollo.BaseMutationOptions<CreateSiteMutation, CreateSiteMutationVariables>;
export const UpdateSiteDocument = gql`
    mutation UPDATE_SITE($accessTime: Int!, $removalDate: String, $B2CPriceRange: ID, $unknownShrinkageBillingThreshold: Int, $closingDatesRanges: [SiteClosingDatesRangeInput!]!, $deliveryDays: [Boolean!]!, $freshReassortDays: [Boolean!]!, $dryReassortDays: [Boolean!]!, $deliveryWindowStart: String!, $deliveryWindowStop: String!, $deliveryType: SiteDeliveryType!, $contractType: SiteContractType!, $estimatedUserCount: Int!, $hasExternalSetupProcess: Boolean!, $isOpenOnWeekend: Boolean!, $isSecured: Boolean!, $hasSensei: Boolean!, $hasCoffee: Boolean!, $launchDate: String, $name: String!, $organizationId: ID!, $reassortmentFreshFacings: ReassortmentFreshFacingsByCategoriesInput!, $reassortmentStockTargetRatios: ReassortmentStockTargetRatiosInput!, $reassortmentStockTargets: ReassortmentStockByCategoriesInput!, $reassortmentOnboardingStockTargets: ReassortmentStockByCategoriesInput!, $shouldOperateOnTotops: Boolean!, $shouldAutomaticallyCreateTargetReassortment: Boolean!, $shouldAutomaticallyCreateManualReassortment: Boolean!, $shouldAutomaticallyFinishSiteSetup: Boolean!, $shouldHaveTheftNotice: Boolean!, $shouldModulateForExpired: Boolean!, $shouldModulateForUnknownLosses: Boolean!, $siteId: ID!, $state: SiteState!, $unwantedProductIds: [String!]!, $urbantzMetadata: SiteMetadataInput!, $useNayaxCard: Boolean!, $wantedProductIds: [String!]!, $avaSiteId: Int) {
  updateSite(
    accessTime: $accessTime
    removalDate: $removalDate
    B2CPriceRange: $B2CPriceRange
    unknownShrinkageBillingThreshold: $unknownShrinkageBillingThreshold
    closingDatesRanges: $closingDatesRanges
    deliveryDays: $deliveryDays
    freshReassortDays: $freshReassortDays
    dryReassortDays: $dryReassortDays
    deliveryWindowStart: $deliveryWindowStart
    deliveryWindowStop: $deliveryWindowStop
    deliveryType: $deliveryType
    contractType: $contractType
    estimatedUserCount: $estimatedUserCount
    hasExternalSetupProcess: $hasExternalSetupProcess
    isOpenOnWeekend: $isOpenOnWeekend
    isSecured: $isSecured
    hasSensei: $hasSensei
    hasCoffee: $hasCoffee
    launchDate: $launchDate
    name: $name
    organizationId: $organizationId
    reassortmentFreshFacings: $reassortmentFreshFacings
    reassortmentStockTargetRatios: $reassortmentStockTargetRatios
    reassortmentStockTargets: $reassortmentStockTargets
    reassortmentOnboardingStockTargets: $reassortmentOnboardingStockTargets
    shouldOperateOnTotops: $shouldOperateOnTotops
    shouldAutomaticallyCreateTargetReassortment: $shouldAutomaticallyCreateTargetReassortment
    shouldAutomaticallyCreateManualReassortment: $shouldAutomaticallyCreateManualReassortment
    shouldAutomaticallyFinishSiteSetup: $shouldAutomaticallyFinishSiteSetup
    shouldHaveTheftNotice: $shouldHaveTheftNotice
    shouldModulateForExpired: $shouldModulateForExpired
    shouldModulateForUnknownLosses: $shouldModulateForUnknownLosses
    siteId: $siteId
    state: $state
    unwantedProductIds: $unwantedProductIds
    urbantzMetadata: $urbantzMetadata
    useNayaxCard: $useNayaxCard
    wantedProductIds: $wantedProductIds
    avaSiteId: $avaSiteId
  ) {
    success
    error
    site {
      ...SiteFragment
    }
  }
}
    ${SiteFragmentFragmentDoc}`;
export type UpdateSiteMutationFn = Apollo.MutationFunction<UpdateSiteMutation, UpdateSiteMutationVariables>;

/**
 * __useUpdateSiteMutation__
 *
 * To run a mutation, you first call `useUpdateSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteMutation, { data, loading, error }] = useUpdateSiteMutation({
 *   variables: {
 *      accessTime: // value for 'accessTime'
 *      removalDate: // value for 'removalDate'
 *      B2CPriceRange: // value for 'B2CPriceRange'
 *      unknownShrinkageBillingThreshold: // value for 'unknownShrinkageBillingThreshold'
 *      closingDatesRanges: // value for 'closingDatesRanges'
 *      deliveryDays: // value for 'deliveryDays'
 *      freshReassortDays: // value for 'freshReassortDays'
 *      dryReassortDays: // value for 'dryReassortDays'
 *      deliveryWindowStart: // value for 'deliveryWindowStart'
 *      deliveryWindowStop: // value for 'deliveryWindowStop'
 *      deliveryType: // value for 'deliveryType'
 *      contractType: // value for 'contractType'
 *      estimatedUserCount: // value for 'estimatedUserCount'
 *      hasExternalSetupProcess: // value for 'hasExternalSetupProcess'
 *      isOpenOnWeekend: // value for 'isOpenOnWeekend'
 *      isSecured: // value for 'isSecured'
 *      hasSensei: // value for 'hasSensei'
 *      hasCoffee: // value for 'hasCoffee'
 *      launchDate: // value for 'launchDate'
 *      name: // value for 'name'
 *      organizationId: // value for 'organizationId'
 *      reassortmentFreshFacings: // value for 'reassortmentFreshFacings'
 *      reassortmentStockTargetRatios: // value for 'reassortmentStockTargetRatios'
 *      reassortmentStockTargets: // value for 'reassortmentStockTargets'
 *      reassortmentOnboardingStockTargets: // value for 'reassortmentOnboardingStockTargets'
 *      shouldOperateOnTotops: // value for 'shouldOperateOnTotops'
 *      shouldAutomaticallyCreateTargetReassortment: // value for 'shouldAutomaticallyCreateTargetReassortment'
 *      shouldAutomaticallyCreateManualReassortment: // value for 'shouldAutomaticallyCreateManualReassortment'
 *      shouldAutomaticallyFinishSiteSetup: // value for 'shouldAutomaticallyFinishSiteSetup'
 *      shouldHaveTheftNotice: // value for 'shouldHaveTheftNotice'
 *      shouldModulateForExpired: // value for 'shouldModulateForExpired'
 *      shouldModulateForUnknownLosses: // value for 'shouldModulateForUnknownLosses'
 *      siteId: // value for 'siteId'
 *      state: // value for 'state'
 *      unwantedProductIds: // value for 'unwantedProductIds'
 *      urbantzMetadata: // value for 'urbantzMetadata'
 *      useNayaxCard: // value for 'useNayaxCard'
 *      wantedProductIds: // value for 'wantedProductIds'
 *      avaSiteId: // value for 'avaSiteId'
 *   },
 * });
 */
export function useUpdateSiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteMutation, UpdateSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteMutation, UpdateSiteMutationVariables>(UpdateSiteDocument, options);
      }
export type UpdateSiteMutationHookResult = ReturnType<typeof useUpdateSiteMutation>;
export type UpdateSiteMutationResult = Apollo.MutationResult<UpdateSiteMutation>;
export type UpdateSiteMutationOptions = Apollo.BaseMutationOptions<UpdateSiteMutation, UpdateSiteMutationVariables>;
export const UpdateSiteReassortmentQuantityTargetsDocument = gql`
    mutation UPDATE_SITE_REASSORTMENT_QUANTITY_TARGETS($siteId: ID!, $reassortmentStockTargets: ReassortmentStockByCategoriesInput!, $reassortmentOnboardingStockTargets: ReassortmentStockByCategoriesInput!) {
  updateSiteReassortmentStockTargets(
    siteId: $siteId
    reassortmentStockTargets: $reassortmentStockTargets
    reassortmentOnboardingStockTargets: $reassortmentOnboardingStockTargets
  ) {
    success
    error
    site {
      ...SiteFragment
    }
  }
}
    ${SiteFragmentFragmentDoc}`;
export type UpdateSiteReassortmentQuantityTargetsMutationFn = Apollo.MutationFunction<UpdateSiteReassortmentQuantityTargetsMutation, UpdateSiteReassortmentQuantityTargetsMutationVariables>;

/**
 * __useUpdateSiteReassortmentQuantityTargetsMutation__
 *
 * To run a mutation, you first call `useUpdateSiteReassortmentQuantityTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteReassortmentQuantityTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteReassortmentQuantityTargetsMutation, { data, loading, error }] = useUpdateSiteReassortmentQuantityTargetsMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      reassortmentStockTargets: // value for 'reassortmentStockTargets'
 *      reassortmentOnboardingStockTargets: // value for 'reassortmentOnboardingStockTargets'
 *   },
 * });
 */
export function useUpdateSiteReassortmentQuantityTargetsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteReassortmentQuantityTargetsMutation, UpdateSiteReassortmentQuantityTargetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteReassortmentQuantityTargetsMutation, UpdateSiteReassortmentQuantityTargetsMutationVariables>(UpdateSiteReassortmentQuantityTargetsDocument, options);
      }
export type UpdateSiteReassortmentQuantityTargetsMutationHookResult = ReturnType<typeof useUpdateSiteReassortmentQuantityTargetsMutation>;
export type UpdateSiteReassortmentQuantityTargetsMutationResult = Apollo.MutationResult<UpdateSiteReassortmentQuantityTargetsMutation>;
export type UpdateSiteReassortmentQuantityTargetsMutationOptions = Apollo.BaseMutationOptions<UpdateSiteReassortmentQuantityTargetsMutation, UpdateSiteReassortmentQuantityTargetsMutationVariables>;
export const UpdateSiteReassortmentQuantityTargetRatiosDocument = gql`
    mutation UPDATE_SITE_REASSORTMENT_QUANTITY_TARGET_RATIOS($siteId: ID!, $reassortmentStockTargetRatios: ReassortmentStockTargetRatiosInput!) {
  updateSiteReassortmentStockTargetRatios(
    siteId: $siteId
    reassortmentStockTargetRatios: $reassortmentStockTargetRatios
  ) {
    success
    error
    site {
      ...SiteFragment
    }
  }
}
    ${SiteFragmentFragmentDoc}`;
export type UpdateSiteReassortmentQuantityTargetRatiosMutationFn = Apollo.MutationFunction<UpdateSiteReassortmentQuantityTargetRatiosMutation, UpdateSiteReassortmentQuantityTargetRatiosMutationVariables>;

/**
 * __useUpdateSiteReassortmentQuantityTargetRatiosMutation__
 *
 * To run a mutation, you first call `useUpdateSiteReassortmentQuantityTargetRatiosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteReassortmentQuantityTargetRatiosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteReassortmentQuantityTargetRatiosMutation, { data, loading, error }] = useUpdateSiteReassortmentQuantityTargetRatiosMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      reassortmentStockTargetRatios: // value for 'reassortmentStockTargetRatios'
 *   },
 * });
 */
export function useUpdateSiteReassortmentQuantityTargetRatiosMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteReassortmentQuantityTargetRatiosMutation, UpdateSiteReassortmentQuantityTargetRatiosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteReassortmentQuantityTargetRatiosMutation, UpdateSiteReassortmentQuantityTargetRatiosMutationVariables>(UpdateSiteReassortmentQuantityTargetRatiosDocument, options);
      }
export type UpdateSiteReassortmentQuantityTargetRatiosMutationHookResult = ReturnType<typeof useUpdateSiteReassortmentQuantityTargetRatiosMutation>;
export type UpdateSiteReassortmentQuantityTargetRatiosMutationResult = Apollo.MutationResult<UpdateSiteReassortmentQuantityTargetRatiosMutation>;
export type UpdateSiteReassortmentQuantityTargetRatiosMutationOptions = Apollo.BaseMutationOptions<UpdateSiteReassortmentQuantityTargetRatiosMutation, UpdateSiteReassortmentQuantityTargetRatiosMutationVariables>;
export const DeclareSiteExternalInventoryDocument = gql`
    mutation DECLARE_SITE_EXTERNAL_INVENTORY($productsInventoryInfo: [SiteExternalInventoryProduct!]!, $columnId: ID!) {
  declareSiteExternalInventory(
    productsInventoryInfo: $productsInventoryInfo
    columnId: $columnId
  ) {
    _id
  }
}
    `;
export type DeclareSiteExternalInventoryMutationFn = Apollo.MutationFunction<DeclareSiteExternalInventoryMutation, DeclareSiteExternalInventoryMutationVariables>;

/**
 * __useDeclareSiteExternalInventoryMutation__
 *
 * To run a mutation, you first call `useDeclareSiteExternalInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclareSiteExternalInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declareSiteExternalInventoryMutation, { data, loading, error }] = useDeclareSiteExternalInventoryMutation({
 *   variables: {
 *      productsInventoryInfo: // value for 'productsInventoryInfo'
 *      columnId: // value for 'columnId'
 *   },
 * });
 */
export function useDeclareSiteExternalInventoryMutation(baseOptions?: Apollo.MutationHookOptions<DeclareSiteExternalInventoryMutation, DeclareSiteExternalInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclareSiteExternalInventoryMutation, DeclareSiteExternalInventoryMutationVariables>(DeclareSiteExternalInventoryDocument, options);
      }
export type DeclareSiteExternalInventoryMutationHookResult = ReturnType<typeof useDeclareSiteExternalInventoryMutation>;
export type DeclareSiteExternalInventoryMutationResult = Apollo.MutationResult<DeclareSiteExternalInventoryMutation>;
export type DeclareSiteExternalInventoryMutationOptions = Apollo.BaseMutationOptions<DeclareSiteExternalInventoryMutation, DeclareSiteExternalInventoryMutationVariables>;
export const UpdateSitesFromImportDocument = gql`
    mutation UPDATE_SITES_FROM_IMPORT($sitesToUpdate: [SiteUpdateCsvImport!]!) {
  updateSitesFromImport(sitesToUpdate: $sitesToUpdate) {
    success
    error
    sites {
      ...SiteFragment
    }
  }
}
    ${SiteFragmentFragmentDoc}`;
export type UpdateSitesFromImportMutationFn = Apollo.MutationFunction<UpdateSitesFromImportMutation, UpdateSitesFromImportMutationVariables>;

/**
 * __useUpdateSitesFromImportMutation__
 *
 * To run a mutation, you first call `useUpdateSitesFromImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSitesFromImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSitesFromImportMutation, { data, loading, error }] = useUpdateSitesFromImportMutation({
 *   variables: {
 *      sitesToUpdate: // value for 'sitesToUpdate'
 *   },
 * });
 */
export function useUpdateSitesFromImportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSitesFromImportMutation, UpdateSitesFromImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSitesFromImportMutation, UpdateSitesFromImportMutationVariables>(UpdateSitesFromImportDocument, options);
      }
export type UpdateSitesFromImportMutationHookResult = ReturnType<typeof useUpdateSitesFromImportMutation>;
export type UpdateSitesFromImportMutationResult = Apollo.MutationResult<UpdateSitesFromImportMutation>;
export type UpdateSitesFromImportMutationOptions = Apollo.BaseMutationOptions<UpdateSitesFromImportMutation, UpdateSitesFromImportMutationVariables>;
export const ForceFinishSiteSetupDocument = gql`
    mutation FORCE_FINISH_SITE_SETUP($siteSetupId: ID!) {
  forceFinishSiteSetup(siteSetupId: $siteSetupId) {
    ...SiteSetupFragment
  }
}
    ${SiteSetupFragmentFragmentDoc}`;
export type ForceFinishSiteSetupMutationFn = Apollo.MutationFunction<ForceFinishSiteSetupMutation, ForceFinishSiteSetupMutationVariables>;

/**
 * __useForceFinishSiteSetupMutation__
 *
 * To run a mutation, you first call `useForceFinishSiteSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceFinishSiteSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceFinishSiteSetupMutation, { data, loading, error }] = useForceFinishSiteSetupMutation({
 *   variables: {
 *      siteSetupId: // value for 'siteSetupId'
 *   },
 * });
 */
export function useForceFinishSiteSetupMutation(baseOptions?: Apollo.MutationHookOptions<ForceFinishSiteSetupMutation, ForceFinishSiteSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceFinishSiteSetupMutation, ForceFinishSiteSetupMutationVariables>(ForceFinishSiteSetupDocument, options);
      }
export type ForceFinishSiteSetupMutationHookResult = ReturnType<typeof useForceFinishSiteSetupMutation>;
export type ForceFinishSiteSetupMutationResult = Apollo.MutationResult<ForceFinishSiteSetupMutation>;
export type ForceFinishSiteSetupMutationOptions = Apollo.BaseMutationOptions<ForceFinishSiteSetupMutation, ForceFinishSiteSetupMutationVariables>;
export const FinishSiteSetupWithManualGenerationDocument = gql`
    mutation FINISH_SITE_SETUP_WITH_MANUAL_GENERATION($siteSetupId: ID!) {
  finishSiteSetupWithManualGeneration(siteSetupId: $siteSetupId) {
    ...SiteSetupFragment
  }
}
    ${SiteSetupFragmentFragmentDoc}`;
export type FinishSiteSetupWithManualGenerationMutationFn = Apollo.MutationFunction<FinishSiteSetupWithManualGenerationMutation, FinishSiteSetupWithManualGenerationMutationVariables>;

/**
 * __useFinishSiteSetupWithManualGenerationMutation__
 *
 * To run a mutation, you first call `useFinishSiteSetupWithManualGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishSiteSetupWithManualGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishSiteSetupWithManualGenerationMutation, { data, loading, error }] = useFinishSiteSetupWithManualGenerationMutation({
 *   variables: {
 *      siteSetupId: // value for 'siteSetupId'
 *   },
 * });
 */
export function useFinishSiteSetupWithManualGenerationMutation(baseOptions?: Apollo.MutationHookOptions<FinishSiteSetupWithManualGenerationMutation, FinishSiteSetupWithManualGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishSiteSetupWithManualGenerationMutation, FinishSiteSetupWithManualGenerationMutationVariables>(FinishSiteSetupWithManualGenerationDocument, options);
      }
export type FinishSiteSetupWithManualGenerationMutationHookResult = ReturnType<typeof useFinishSiteSetupWithManualGenerationMutation>;
export type FinishSiteSetupWithManualGenerationMutationResult = Apollo.MutationResult<FinishSiteSetupWithManualGenerationMutation>;
export type FinishSiteSetupWithManualGenerationMutationOptions = Apollo.BaseMutationOptions<FinishSiteSetupWithManualGenerationMutation, FinishSiteSetupWithManualGenerationMutationVariables>;
export const AbortSiteSetupDocument = gql`
    mutation ABORT_SITE_SETUP($siteSetupId: ID!) {
  abortSiteSetup(siteSetupId: $siteSetupId) {
    ...SiteSetupFragment
  }
}
    ${SiteSetupFragmentFragmentDoc}`;
export type AbortSiteSetupMutationFn = Apollo.MutationFunction<AbortSiteSetupMutation, AbortSiteSetupMutationVariables>;

/**
 * __useAbortSiteSetupMutation__
 *
 * To run a mutation, you first call `useAbortSiteSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortSiteSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortSiteSetupMutation, { data, loading, error }] = useAbortSiteSetupMutation({
 *   variables: {
 *      siteSetupId: // value for 'siteSetupId'
 *   },
 * });
 */
export function useAbortSiteSetupMutation(baseOptions?: Apollo.MutationHookOptions<AbortSiteSetupMutation, AbortSiteSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortSiteSetupMutation, AbortSiteSetupMutationVariables>(AbortSiteSetupDocument, options);
      }
export type AbortSiteSetupMutationHookResult = ReturnType<typeof useAbortSiteSetupMutation>;
export type AbortSiteSetupMutationResult = Apollo.MutationResult<AbortSiteSetupMutation>;
export type AbortSiteSetupMutationOptions = Apollo.BaseMutationOptions<AbortSiteSetupMutation, AbortSiteSetupMutationVariables>;
export const CreateStockTransferDocument = gql`
    mutation CREATE_STOCK_TRANSFER($transferDate: String!, $originColumnId: ID!, $destinationColumnId: ID!, $products: [StockTransferProductInput!]!) {
  createStockTransfer(
    transferDate: $transferDate
    originColumnId: $originColumnId
    destinationColumnId: $destinationColumnId
    products: $products
  ) {
    success
    error
    stockTransfer {
      _id
    }
  }
}
    `;
export type CreateStockTransferMutationFn = Apollo.MutationFunction<CreateStockTransferMutation, CreateStockTransferMutationVariables>;

/**
 * __useCreateStockTransferMutation__
 *
 * To run a mutation, you first call `useCreateStockTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockTransferMutation, { data, loading, error }] = useCreateStockTransferMutation({
 *   variables: {
 *      transferDate: // value for 'transferDate'
 *      originColumnId: // value for 'originColumnId'
 *      destinationColumnId: // value for 'destinationColumnId'
 *      products: // value for 'products'
 *   },
 * });
 */
export function useCreateStockTransferMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockTransferMutation, CreateStockTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStockTransferMutation, CreateStockTransferMutationVariables>(CreateStockTransferDocument, options);
      }
export type CreateStockTransferMutationHookResult = ReturnType<typeof useCreateStockTransferMutation>;
export type CreateStockTransferMutationResult = Apollo.MutationResult<CreateStockTransferMutation>;
export type CreateStockTransferMutationOptions = Apollo.BaseMutationOptions<CreateStockTransferMutation, CreateStockTransferMutationVariables>;
export const UpdateStockTransferDocument = gql`
    mutation UPDATE_STOCK_TRANSFER($stockTransferId: ID!, $transferDate: String!, $originColumnId: ID!, $destinationColumnId: ID!, $products: [StockTransferProductInput!]!, $shouldUpdateStockImmediately: Boolean!) {
  updateStockTransfer(
    stockTransferId: $stockTransferId
    transferDate: $transferDate
    originColumnId: $originColumnId
    destinationColumnId: $destinationColumnId
    products: $products
    shouldUpdateStockImmediately: $shouldUpdateStockImmediately
  ) {
    success
    error
    stockTransfer {
      ...StockTransferFragment
    }
  }
}
    ${StockTransferFragmentFragmentDoc}`;
export type UpdateStockTransferMutationFn = Apollo.MutationFunction<UpdateStockTransferMutation, UpdateStockTransferMutationVariables>;

/**
 * __useUpdateStockTransferMutation__
 *
 * To run a mutation, you first call `useUpdateStockTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockTransferMutation, { data, loading, error }] = useUpdateStockTransferMutation({
 *   variables: {
 *      stockTransferId: // value for 'stockTransferId'
 *      transferDate: // value for 'transferDate'
 *      originColumnId: // value for 'originColumnId'
 *      destinationColumnId: // value for 'destinationColumnId'
 *      products: // value for 'products'
 *      shouldUpdateStockImmediately: // value for 'shouldUpdateStockImmediately'
 *   },
 * });
 */
export function useUpdateStockTransferMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStockTransferMutation, UpdateStockTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStockTransferMutation, UpdateStockTransferMutationVariables>(UpdateStockTransferDocument, options);
      }
export type UpdateStockTransferMutationHookResult = ReturnType<typeof useUpdateStockTransferMutation>;
export type UpdateStockTransferMutationResult = Apollo.MutationResult<UpdateStockTransferMutation>;
export type UpdateStockTransferMutationOptions = Apollo.BaseMutationOptions<UpdateStockTransferMutation, UpdateStockTransferMutationVariables>;
export const ValidateStockTransfersDocument = gql`
    mutation VALIDATE_STOCK_TRANSFERS($stockTransferIds: [ID!]!) {
  validateStockTransfers(stockTransferIds: $stockTransferIds) {
    errors
    stockTransfers {
      ...StockTransferFragment
    }
  }
}
    ${StockTransferFragmentFragmentDoc}`;
export type ValidateStockTransfersMutationFn = Apollo.MutationFunction<ValidateStockTransfersMutation, ValidateStockTransfersMutationVariables>;

/**
 * __useValidateStockTransfersMutation__
 *
 * To run a mutation, you first call `useValidateStockTransfersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateStockTransfersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateStockTransfersMutation, { data, loading, error }] = useValidateStockTransfersMutation({
 *   variables: {
 *      stockTransferIds: // value for 'stockTransferIds'
 *   },
 * });
 */
export function useValidateStockTransfersMutation(baseOptions?: Apollo.MutationHookOptions<ValidateStockTransfersMutation, ValidateStockTransfersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateStockTransfersMutation, ValidateStockTransfersMutationVariables>(ValidateStockTransfersDocument, options);
      }
export type ValidateStockTransfersMutationHookResult = ReturnType<typeof useValidateStockTransfersMutation>;
export type ValidateStockTransfersMutationResult = Apollo.MutationResult<ValidateStockTransfersMutation>;
export type ValidateStockTransfersMutationOptions = Apollo.BaseMutationOptions<ValidateStockTransfersMutation, ValidateStockTransfersMutationVariables>;
export const ValidateStockTransfersAtDateDocument = gql`
    mutation VALIDATE_STOCK_TRANSFERS_AT_DATE($date: String!) {
  validateStockTransfersAtDate(date: $date) {
    errors
    stockTransfers {
      ...StockTransferFragment
    }
  }
}
    ${StockTransferFragmentFragmentDoc}`;
export type ValidateStockTransfersAtDateMutationFn = Apollo.MutationFunction<ValidateStockTransfersAtDateMutation, ValidateStockTransfersAtDateMutationVariables>;

/**
 * __useValidateStockTransfersAtDateMutation__
 *
 * To run a mutation, you first call `useValidateStockTransfersAtDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateStockTransfersAtDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateStockTransfersAtDateMutation, { data, loading, error }] = useValidateStockTransfersAtDateMutation({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useValidateStockTransfersAtDateMutation(baseOptions?: Apollo.MutationHookOptions<ValidateStockTransfersAtDateMutation, ValidateStockTransfersAtDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateStockTransfersAtDateMutation, ValidateStockTransfersAtDateMutationVariables>(ValidateStockTransfersAtDateDocument, options);
      }
export type ValidateStockTransfersAtDateMutationHookResult = ReturnType<typeof useValidateStockTransfersAtDateMutation>;
export type ValidateStockTransfersAtDateMutationResult = Apollo.MutationResult<ValidateStockTransfersAtDateMutation>;
export type ValidateStockTransfersAtDateMutationOptions = Apollo.BaseMutationOptions<ValidateStockTransfersAtDateMutation, ValidateStockTransfersAtDateMutationVariables>;
export const AbortStockTransfersDocument = gql`
    mutation ABORT_STOCK_TRANSFERS($stockTransferIds: [ID!]!) {
  abortStockTransfers(stockTransferIds: $stockTransferIds) {
    errors
    stockTransfers {
      ...StockTransferFragment
    }
  }
}
    ${StockTransferFragmentFragmentDoc}`;
export type AbortStockTransfersMutationFn = Apollo.MutationFunction<AbortStockTransfersMutation, AbortStockTransfersMutationVariables>;

/**
 * __useAbortStockTransfersMutation__
 *
 * To run a mutation, you first call `useAbortStockTransfersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortStockTransfersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortStockTransfersMutation, { data, loading, error }] = useAbortStockTransfersMutation({
 *   variables: {
 *      stockTransferIds: // value for 'stockTransferIds'
 *   },
 * });
 */
export function useAbortStockTransfersMutation(baseOptions?: Apollo.MutationHookOptions<AbortStockTransfersMutation, AbortStockTransfersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortStockTransfersMutation, AbortStockTransfersMutationVariables>(AbortStockTransfersDocument, options);
      }
export type AbortStockTransfersMutationHookResult = ReturnType<typeof useAbortStockTransfersMutation>;
export type AbortStockTransfersMutationResult = Apollo.MutationResult<AbortStockTransfersMutation>;
export type AbortStockTransfersMutationOptions = Apollo.BaseMutationOptions<AbortStockTransfersMutation, AbortStockTransfersMutationVariables>;
export const AbortReassortmentStockTransfersForDateDocument = gql`
    mutation ABORT_REASSORTMENT_STOCK_TRANSFERS_FOR_DATE($reassortmentDate: String!, $reassortmentFlow: ReassortmentFlow!, $microstoreColumnIds: [ID!]!) {
  abortReassortmentStockTransfersForDate(
    reassortmentDate: $reassortmentDate
    reassortmentFlow: $reassortmentFlow
    microstoreColumnIds: $microstoreColumnIds
  ) {
    errors
    stockTransfers {
      ...StockTransferFragment
    }
  }
}
    ${StockTransferFragmentFragmentDoc}`;
export type AbortReassortmentStockTransfersForDateMutationFn = Apollo.MutationFunction<AbortReassortmentStockTransfersForDateMutation, AbortReassortmentStockTransfersForDateMutationVariables>;

/**
 * __useAbortReassortmentStockTransfersForDateMutation__
 *
 * To run a mutation, you first call `useAbortReassortmentStockTransfersForDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortReassortmentStockTransfersForDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortReassortmentStockTransfersForDateMutation, { data, loading, error }] = useAbortReassortmentStockTransfersForDateMutation({
 *   variables: {
 *      reassortmentDate: // value for 'reassortmentDate'
 *      reassortmentFlow: // value for 'reassortmentFlow'
 *      microstoreColumnIds: // value for 'microstoreColumnIds'
 *   },
 * });
 */
export function useAbortReassortmentStockTransfersForDateMutation(baseOptions?: Apollo.MutationHookOptions<AbortReassortmentStockTransfersForDateMutation, AbortReassortmentStockTransfersForDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortReassortmentStockTransfersForDateMutation, AbortReassortmentStockTransfersForDateMutationVariables>(AbortReassortmentStockTransfersForDateDocument, options);
      }
export type AbortReassortmentStockTransfersForDateMutationHookResult = ReturnType<typeof useAbortReassortmentStockTransfersForDateMutation>;
export type AbortReassortmentStockTransfersForDateMutationResult = Apollo.MutationResult<AbortReassortmentStockTransfersForDateMutation>;
export type AbortReassortmentStockTransfersForDateMutationOptions = Apollo.BaseMutationOptions<AbortReassortmentStockTransfersForDateMutation, AbortReassortmentStockTransfersForDateMutationVariables>;
export const CreateStockVariationDocument = gql`
    mutation CREATE_STOCK_VARIATION($columnId: ID!, $productId: ID!, $delta: Int!, $type: StockVariationType!, $explanation: String!) {
  createStockVariation(
    columnId: $columnId
    productId: $productId
    delta: $delta
    type: $type
    explanation: $explanation
  ) {
    error
    product {
      _id
    }
  }
}
    `;
export type CreateStockVariationMutationFn = Apollo.MutationFunction<CreateStockVariationMutation, CreateStockVariationMutationVariables>;

/**
 * __useCreateStockVariationMutation__
 *
 * To run a mutation, you first call `useCreateStockVariationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockVariationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockVariationMutation, { data, loading, error }] = useCreateStockVariationMutation({
 *   variables: {
 *      columnId: // value for 'columnId'
 *      productId: // value for 'productId'
 *      delta: // value for 'delta'
 *      type: // value for 'type'
 *      explanation: // value for 'explanation'
 *   },
 * });
 */
export function useCreateStockVariationMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockVariationMutation, CreateStockVariationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStockVariationMutation, CreateStockVariationMutationVariables>(CreateStockVariationDocument, options);
      }
export type CreateStockVariationMutationHookResult = ReturnType<typeof useCreateStockVariationMutation>;
export type CreateStockVariationMutationResult = Apollo.MutationResult<CreateStockVariationMutation>;
export type CreateStockVariationMutationOptions = Apollo.BaseMutationOptions<CreateStockVariationMutation, CreateStockVariationMutationVariables>;
export const CreateMultiStockVariationDocument = gql`
    mutation CREATE_MULTI_STOCK_VARIATION($columnId: ID!, $productIdsAndDeltas: [ProductIdAndDeltaInput!]!, $type: StockVariationType!, $explanation: String!) {
  createMultiStockVariation(
    columnId: $columnId
    productIdsAndDeltas: $productIdsAndDeltas
    type: $type
    explanation: $explanation
  ) {
    error
    product {
      _id
    }
  }
}
    `;
export type CreateMultiStockVariationMutationFn = Apollo.MutationFunction<CreateMultiStockVariationMutation, CreateMultiStockVariationMutationVariables>;

/**
 * __useCreateMultiStockVariationMutation__
 *
 * To run a mutation, you first call `useCreateMultiStockVariationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultiStockVariationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultiStockVariationMutation, { data, loading, error }] = useCreateMultiStockVariationMutation({
 *   variables: {
 *      columnId: // value for 'columnId'
 *      productIdsAndDeltas: // value for 'productIdsAndDeltas'
 *      type: // value for 'type'
 *      explanation: // value for 'explanation'
 *   },
 * });
 */
export function useCreateMultiStockVariationMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultiStockVariationMutation, CreateMultiStockVariationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultiStockVariationMutation, CreateMultiStockVariationMutationVariables>(CreateMultiStockVariationDocument, options);
      }
export type CreateMultiStockVariationMutationHookResult = ReturnType<typeof useCreateMultiStockVariationMutation>;
export type CreateMultiStockVariationMutationResult = Apollo.MutationResult<CreateMultiStockVariationMutation>;
export type CreateMultiStockVariationMutationOptions = Apollo.BaseMutationOptions<CreateMultiStockVariationMutation, CreateMultiStockVariationMutationVariables>;
export const SplitStockVariationDocument = gql`
    mutation SPLIT_STOCK_VARIATION($stockVariationId: ID!, $newStockVariationInput: StockVariationInput!) {
  splitStockVariation(
    stockVariationId: $stockVariationId
    newStockVariationInput: $newStockVariationInput
  ) {
    error
    variations {
      ...StockVariationFragment
    }
  }
}
    ${StockVariationFragmentFragmentDoc}`;
export type SplitStockVariationMutationFn = Apollo.MutationFunction<SplitStockVariationMutation, SplitStockVariationMutationVariables>;

/**
 * __useSplitStockVariationMutation__
 *
 * To run a mutation, you first call `useSplitStockVariationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitStockVariationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitStockVariationMutation, { data, loading, error }] = useSplitStockVariationMutation({
 *   variables: {
 *      stockVariationId: // value for 'stockVariationId'
 *      newStockVariationInput: // value for 'newStockVariationInput'
 *   },
 * });
 */
export function useSplitStockVariationMutation(baseOptions?: Apollo.MutationHookOptions<SplitStockVariationMutation, SplitStockVariationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitStockVariationMutation, SplitStockVariationMutationVariables>(SplitStockVariationDocument, options);
      }
export type SplitStockVariationMutationHookResult = ReturnType<typeof useSplitStockVariationMutation>;
export type SplitStockVariationMutationResult = Apollo.MutationResult<SplitStockVariationMutation>;
export type SplitStockVariationMutationOptions = Apollo.BaseMutationOptions<SplitStockVariationMutation, SplitStockVariationMutationVariables>;
export const CreateSubcategoryDocument = gql`
    mutation CreateSubcategory($categoryId: ID!, $createInput: SubcategoryInput!) {
  createSubcategory(categoryId: $categoryId, createInput: $createInput) {
    subcategory {
      ...Subcategory
    }
    errors
  }
}
    ${SubcategoryFragmentDoc}`;
export type CreateSubcategoryMutationFn = Apollo.MutationFunction<CreateSubcategoryMutation, CreateSubcategoryMutationVariables>;

/**
 * __useCreateSubcategoryMutation__
 *
 * To run a mutation, you first call `useCreateSubcategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubcategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubcategoryMutation, { data, loading, error }] = useCreateSubcategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateSubcategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubcategoryMutation, CreateSubcategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubcategoryMutation, CreateSubcategoryMutationVariables>(CreateSubcategoryDocument, options);
      }
export type CreateSubcategoryMutationHookResult = ReturnType<typeof useCreateSubcategoryMutation>;
export type CreateSubcategoryMutationResult = Apollo.MutationResult<CreateSubcategoryMutation>;
export type CreateSubcategoryMutationOptions = Apollo.BaseMutationOptions<CreateSubcategoryMutation, CreateSubcategoryMutationVariables>;
export const UpdateSubcategoryDocument = gql`
    mutation UpdateSubcategory($subcategoryId: ID!, $updateInput: SubcategoryInput!) {
  updateSubcategory(subcategoryId: $subcategoryId, updateInput: $updateInput) {
    subcategory {
      ...Subcategory
    }
    errors
  }
}
    ${SubcategoryFragmentDoc}`;
export type UpdateSubcategoryMutationFn = Apollo.MutationFunction<UpdateSubcategoryMutation, UpdateSubcategoryMutationVariables>;

/**
 * __useUpdateSubcategoryMutation__
 *
 * To run a mutation, you first call `useUpdateSubcategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubcategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubcategoryMutation, { data, loading, error }] = useUpdateSubcategoryMutation({
 *   variables: {
 *      subcategoryId: // value for 'subcategoryId'
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateSubcategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubcategoryMutation, UpdateSubcategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubcategoryMutation, UpdateSubcategoryMutationVariables>(UpdateSubcategoryDocument, options);
      }
export type UpdateSubcategoryMutationHookResult = ReturnType<typeof useUpdateSubcategoryMutation>;
export type UpdateSubcategoryMutationResult = Apollo.MutationResult<UpdateSubcategoryMutation>;
export type UpdateSubcategoryMutationOptions = Apollo.BaseMutationOptions<UpdateSubcategoryMutation, UpdateSubcategoryMutationVariables>;
export const CreateSubventionDocument = gql`
    mutation CREATE_SUBVENTION($createSubventionInput: CreateSubventionInput!) {
  createSubvention(createSubventionInput: $createSubventionInput) {
    errors
    subvention {
      ...SubventionFragment
    }
  }
}
    ${SubventionFragmentFragmentDoc}`;
export type CreateSubventionMutationFn = Apollo.MutationFunction<CreateSubventionMutation, CreateSubventionMutationVariables>;

/**
 * __useCreateSubventionMutation__
 *
 * To run a mutation, you first call `useCreateSubventionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubventionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubventionMutation, { data, loading, error }] = useCreateSubventionMutation({
 *   variables: {
 *      createSubventionInput: // value for 'createSubventionInput'
 *   },
 * });
 */
export function useCreateSubventionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubventionMutation, CreateSubventionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubventionMutation, CreateSubventionMutationVariables>(CreateSubventionDocument, options);
      }
export type CreateSubventionMutationHookResult = ReturnType<typeof useCreateSubventionMutation>;
export type CreateSubventionMutationResult = Apollo.MutationResult<CreateSubventionMutation>;
export type CreateSubventionMutationOptions = Apollo.BaseMutationOptions<CreateSubventionMutation, CreateSubventionMutationVariables>;
export const UpdateSubventionDocument = gql`
    mutation UPDATE_SUBVENTION($subventionId: ID!, $updateInput: UpdateSubventionInput!) {
  updateSubvention(subventionId: $subventionId, updateInput: $updateInput) {
    errors
    subvention {
      ...SubventionFragment
    }
  }
}
    ${SubventionFragmentFragmentDoc}`;
export type UpdateSubventionMutationFn = Apollo.MutationFunction<UpdateSubventionMutation, UpdateSubventionMutationVariables>;

/**
 * __useUpdateSubventionMutation__
 *
 * To run a mutation, you first call `useUpdateSubventionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubventionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubventionMutation, { data, loading, error }] = useUpdateSubventionMutation({
 *   variables: {
 *      subventionId: // value for 'subventionId'
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateSubventionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubventionMutation, UpdateSubventionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubventionMutation, UpdateSubventionMutationVariables>(UpdateSubventionDocument, options);
      }
export type UpdateSubventionMutationHookResult = ReturnType<typeof useUpdateSubventionMutation>;
export type UpdateSubventionMutationResult = Apollo.MutationResult<UpdateSubventionMutation>;
export type UpdateSubventionMutationOptions = Apollo.BaseMutationOptions<UpdateSubventionMutation, UpdateSubventionMutationVariables>;
export const CreateSupplierDocument = gql`
    mutation CREATE_SUPPLIER($fields: SupplierFormInput!) {
  createSupplier(fields: $fields) {
    formErrors {
      ...FormErrorFragment
    }
    createdSupplier {
      ...SupplierFragment
    }
    errors
  }
}
    ${FormErrorFragmentFragmentDoc}
${SupplierFragmentFragmentDoc}`;
export type CreateSupplierMutationFn = Apollo.MutationFunction<CreateSupplierMutation, CreateSupplierMutationVariables>;

/**
 * __useCreateSupplierMutation__
 *
 * To run a mutation, you first call `useCreateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierMutation, { data, loading, error }] = useCreateSupplierMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierMutation, CreateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierMutation, CreateSupplierMutationVariables>(CreateSupplierDocument, options);
      }
export type CreateSupplierMutationHookResult = ReturnType<typeof useCreateSupplierMutation>;
export type CreateSupplierMutationResult = Apollo.MutationResult<CreateSupplierMutation>;
export type CreateSupplierMutationOptions = Apollo.BaseMutationOptions<CreateSupplierMutation, CreateSupplierMutationVariables>;
export const ArchiveSupplierDocument = gql`
    mutation ARCHIVE_SUPPLIER($supplierId: ID!) {
  archiveSupplier(supplierId: $supplierId) {
    updatedSupplier {
      _id
      state
      stateHistory {
        createdAt
        createdBy
        state
      }
    }
    error
  }
}
    `;
export type ArchiveSupplierMutationFn = Apollo.MutationFunction<ArchiveSupplierMutation, ArchiveSupplierMutationVariables>;

/**
 * __useArchiveSupplierMutation__
 *
 * To run a mutation, you first call `useArchiveSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSupplierMutation, { data, loading, error }] = useArchiveSupplierMutation({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useArchiveSupplierMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveSupplierMutation, ArchiveSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveSupplierMutation, ArchiveSupplierMutationVariables>(ArchiveSupplierDocument, options);
      }
export type ArchiveSupplierMutationHookResult = ReturnType<typeof useArchiveSupplierMutation>;
export type ArchiveSupplierMutationResult = Apollo.MutationResult<ArchiveSupplierMutation>;
export type ArchiveSupplierMutationOptions = Apollo.BaseMutationOptions<ArchiveSupplierMutation, ArchiveSupplierMutationVariables>;
export const RestoreSupplierDocument = gql`
    mutation RESTORE_SUPPLIER($supplierId: ID!) {
  restoreSupplier(supplierId: $supplierId) {
    updatedSupplier {
      _id
      state
      stateHistory {
        createdAt
        createdBy
        state
      }
    }
    error
  }
}
    `;
export type RestoreSupplierMutationFn = Apollo.MutationFunction<RestoreSupplierMutation, RestoreSupplierMutationVariables>;

/**
 * __useRestoreSupplierMutation__
 *
 * To run a mutation, you first call `useRestoreSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreSupplierMutation, { data, loading, error }] = useRestoreSupplierMutation({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useRestoreSupplierMutation(baseOptions?: Apollo.MutationHookOptions<RestoreSupplierMutation, RestoreSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreSupplierMutation, RestoreSupplierMutationVariables>(RestoreSupplierDocument, options);
      }
export type RestoreSupplierMutationHookResult = ReturnType<typeof useRestoreSupplierMutation>;
export type RestoreSupplierMutationResult = Apollo.MutationResult<RestoreSupplierMutation>;
export type RestoreSupplierMutationOptions = Apollo.BaseMutationOptions<RestoreSupplierMutation, RestoreSupplierMutationVariables>;
export const UpdateSupplierDocument = gql`
    mutation UPDATE_SUPPLIER($supplierId: ID!, $fields: SupplierFormInput!) {
  updateSupplier(supplierId: $supplierId, fields: $fields) {
    formErrors {
      ...FormErrorFragment
    }
    updatedSupplier {
      ...SupplierFragment
    }
    error
  }
}
    ${FormErrorFragmentFragmentDoc}
${SupplierFragmentFragmentDoc}`;
export type UpdateSupplierMutationFn = Apollo.MutationFunction<UpdateSupplierMutation, UpdateSupplierMutationVariables>;

/**
 * __useUpdateSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierMutation, { data, loading, error }] = useUpdateSupplierMutation({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierMutation, UpdateSupplierMutationVariables>(UpdateSupplierDocument, options);
      }
export type UpdateSupplierMutationHookResult = ReturnType<typeof useUpdateSupplierMutation>;
export type UpdateSupplierMutationResult = Apollo.MutationResult<UpdateSupplierMutation>;
export type UpdateSupplierMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>;
export const CreateSupplierDiscountDocument = gql`
    mutation CREATE_SUPPLIER_DISCOUNT($input: CreateSupplierDiscountInput!) {
  createSupplierDiscount(input: $input) {
    ...SupplierDiscountFragment
  }
}
    ${SupplierDiscountFragmentFragmentDoc}`;
export type CreateSupplierDiscountMutationFn = Apollo.MutationFunction<CreateSupplierDiscountMutation, CreateSupplierDiscountMutationVariables>;

/**
 * __useCreateSupplierDiscountMutation__
 *
 * To run a mutation, you first call `useCreateSupplierDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierDiscountMutation, { data, loading, error }] = useCreateSupplierDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupplierDiscountMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierDiscountMutation, CreateSupplierDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierDiscountMutation, CreateSupplierDiscountMutationVariables>(CreateSupplierDiscountDocument, options);
      }
export type CreateSupplierDiscountMutationHookResult = ReturnType<typeof useCreateSupplierDiscountMutation>;
export type CreateSupplierDiscountMutationResult = Apollo.MutationResult<CreateSupplierDiscountMutation>;
export type CreateSupplierDiscountMutationOptions = Apollo.BaseMutationOptions<CreateSupplierDiscountMutation, CreateSupplierDiscountMutationVariables>;
export const UpdateSupplierDiscountDocument = gql`
    mutation UPDATE_SUPPLIER_DISCOUNT($id: String!, $input: UpdateSupplierDiscountInput!) {
  updateSupplierDiscount(_id: $id, input: $input) {
    ...SupplierDiscountFragment
  }
}
    ${SupplierDiscountFragmentFragmentDoc}`;
export type UpdateSupplierDiscountMutationFn = Apollo.MutationFunction<UpdateSupplierDiscountMutation, UpdateSupplierDiscountMutationVariables>;

/**
 * __useUpdateSupplierDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierDiscountMutation, { data, loading, error }] = useUpdateSupplierDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplierDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierDiscountMutation, UpdateSupplierDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierDiscountMutation, UpdateSupplierDiscountMutationVariables>(UpdateSupplierDiscountDocument, options);
      }
export type UpdateSupplierDiscountMutationHookResult = ReturnType<typeof useUpdateSupplierDiscountMutation>;
export type UpdateSupplierDiscountMutationResult = Apollo.MutationResult<UpdateSupplierDiscountMutation>;
export type UpdateSupplierDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierDiscountMutation, UpdateSupplierDiscountMutationVariables>;
export const UpdateSupplierDiscountStateDocument = gql`
    mutation UPDATE_SUPPLIER_DISCOUNT_STATE($id: String!, $state: SupplierDiscountState!) {
  updateSupplierDiscountState(_id: $id, state: $state) {
    ...SupplierDiscountFragment
  }
}
    ${SupplierDiscountFragmentFragmentDoc}`;
export type UpdateSupplierDiscountStateMutationFn = Apollo.MutationFunction<UpdateSupplierDiscountStateMutation, UpdateSupplierDiscountStateMutationVariables>;

/**
 * __useUpdateSupplierDiscountStateMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierDiscountStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierDiscountStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierDiscountStateMutation, { data, loading, error }] = useUpdateSupplierDiscountStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateSupplierDiscountStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierDiscountStateMutation, UpdateSupplierDiscountStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierDiscountStateMutation, UpdateSupplierDiscountStateMutationVariables>(UpdateSupplierDiscountStateDocument, options);
      }
export type UpdateSupplierDiscountStateMutationHookResult = ReturnType<typeof useUpdateSupplierDiscountStateMutation>;
export type UpdateSupplierDiscountStateMutationResult = Apollo.MutationResult<UpdateSupplierDiscountStateMutation>;
export type UpdateSupplierDiscountStateMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierDiscountStateMutation, UpdateSupplierDiscountStateMutationVariables>;
export const DeleteSupplierDiscountDocument = gql`
    mutation DELETE_SUPPLIER_DISCOUNT($id: String!) {
  deleteSupplierDiscount(_id: $id)
}
    `;
export type DeleteSupplierDiscountMutationFn = Apollo.MutationFunction<DeleteSupplierDiscountMutation, DeleteSupplierDiscountMutationVariables>;

/**
 * __useDeleteSupplierDiscountMutation__
 *
 * To run a mutation, you first call `useDeleteSupplierDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupplierDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupplierDiscountMutation, { data, loading, error }] = useDeleteSupplierDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSupplierDiscountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSupplierDiscountMutation, DeleteSupplierDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSupplierDiscountMutation, DeleteSupplierDiscountMutationVariables>(DeleteSupplierDiscountDocument, options);
      }
export type DeleteSupplierDiscountMutationHookResult = ReturnType<typeof useDeleteSupplierDiscountMutation>;
export type DeleteSupplierDiscountMutationResult = Apollo.MutationResult<DeleteSupplierDiscountMutation>;
export type DeleteSupplierDiscountMutationOptions = Apollo.BaseMutationOptions<DeleteSupplierDiscountMutation, DeleteSupplierDiscountMutationVariables>;
export const CreateSupplierPartnershipDocument = gql`
    mutation CREATE_SUPPLIER_PARTNERSHIP($supplierPartnershipCreateInput: SupplierPartnershipCreateInput!) {
  createSupplierPartnership(
    supplierPartnershipCreateInput: $supplierPartnershipCreateInput
  ) {
    ...SupplierPartnershipFragment
  }
}
    ${SupplierPartnershipFragmentFragmentDoc}`;
export type CreateSupplierPartnershipMutationFn = Apollo.MutationFunction<CreateSupplierPartnershipMutation, CreateSupplierPartnershipMutationVariables>;

/**
 * __useCreateSupplierPartnershipMutation__
 *
 * To run a mutation, you first call `useCreateSupplierPartnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierPartnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierPartnershipMutation, { data, loading, error }] = useCreateSupplierPartnershipMutation({
 *   variables: {
 *      supplierPartnershipCreateInput: // value for 'supplierPartnershipCreateInput'
 *   },
 * });
 */
export function useCreateSupplierPartnershipMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierPartnershipMutation, CreateSupplierPartnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierPartnershipMutation, CreateSupplierPartnershipMutationVariables>(CreateSupplierPartnershipDocument, options);
      }
export type CreateSupplierPartnershipMutationHookResult = ReturnType<typeof useCreateSupplierPartnershipMutation>;
export type CreateSupplierPartnershipMutationResult = Apollo.MutationResult<CreateSupplierPartnershipMutation>;
export type CreateSupplierPartnershipMutationOptions = Apollo.BaseMutationOptions<CreateSupplierPartnershipMutation, CreateSupplierPartnershipMutationVariables>;
export const UpdateSupplierPartnershipDocument = gql`
    mutation UPDATE_SUPPLIER_PARTNERSHIP($supplierPartnershipUpdateInput: SupplierPartnershipUpdateInput!) {
  updateSupplierPartnership(
    supplierPartnershipUpdateInput: $supplierPartnershipUpdateInput
  ) {
    ...SupplierPartnershipFragment
  }
}
    ${SupplierPartnershipFragmentFragmentDoc}`;
export type UpdateSupplierPartnershipMutationFn = Apollo.MutationFunction<UpdateSupplierPartnershipMutation, UpdateSupplierPartnershipMutationVariables>;

/**
 * __useUpdateSupplierPartnershipMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierPartnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierPartnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierPartnershipMutation, { data, loading, error }] = useUpdateSupplierPartnershipMutation({
 *   variables: {
 *      supplierPartnershipUpdateInput: // value for 'supplierPartnershipUpdateInput'
 *   },
 * });
 */
export function useUpdateSupplierPartnershipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierPartnershipMutation, UpdateSupplierPartnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierPartnershipMutation, UpdateSupplierPartnershipMutationVariables>(UpdateSupplierPartnershipDocument, options);
      }
export type UpdateSupplierPartnershipMutationHookResult = ReturnType<typeof useUpdateSupplierPartnershipMutation>;
export type UpdateSupplierPartnershipMutationResult = Apollo.MutationResult<UpdateSupplierPartnershipMutation>;
export type UpdateSupplierPartnershipMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierPartnershipMutation, UpdateSupplierPartnershipMutationVariables>;
export const UpdateSupplyOrderDocument = gql`
    mutation UPDATE_SUPPLY_ORDER($supplyOrderId: ID!, $fields: SupplyOrderUpdateInput!) {
  updateSupplyOrderMutation(supplyOrderId: $supplyOrderId, fields: $fields) {
    success
    formErrors {
      sectionName
      sectionErrors {
        fieldName
        fieldError
      }
    }
    errors
    warnings
    updatedSupplyOrder {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type UpdateSupplyOrderMutationFn = Apollo.MutationFunction<UpdateSupplyOrderMutation, UpdateSupplyOrderMutationVariables>;

/**
 * __useUpdateSupplyOrderMutation__
 *
 * To run a mutation, you first call `useUpdateSupplyOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplyOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplyOrderMutation, { data, loading, error }] = useUpdateSupplyOrderMutation({
 *   variables: {
 *      supplyOrderId: // value for 'supplyOrderId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateSupplyOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplyOrderMutation, UpdateSupplyOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplyOrderMutation, UpdateSupplyOrderMutationVariables>(UpdateSupplyOrderDocument, options);
      }
export type UpdateSupplyOrderMutationHookResult = ReturnType<typeof useUpdateSupplyOrderMutation>;
export type UpdateSupplyOrderMutationResult = Apollo.MutationResult<UpdateSupplyOrderMutation>;
export type UpdateSupplyOrderMutationOptions = Apollo.BaseMutationOptions<UpdateSupplyOrderMutation, UpdateSupplyOrderMutationVariables>;
export const CreateSupplyOrderDocument = gql`
    mutation CREATE_SUPPLY_ORDER($supplierId: ID!, $warehouseColumnId: ID!) {
  createSupplyOrderMutation(
    supplierId: $supplierId
    warehouseColumnId: $warehouseColumnId
  ) {
    createdSupplyOrder {
      ...SupplyOrderFragment
    }
    errors
    warnings
  }
}
    ${SupplyOrderFragmentFragmentDoc}`;
export type CreateSupplyOrderMutationFn = Apollo.MutationFunction<CreateSupplyOrderMutation, CreateSupplyOrderMutationVariables>;

/**
 * __useCreateSupplyOrderMutation__
 *
 * To run a mutation, you first call `useCreateSupplyOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplyOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplyOrderMutation, { data, loading, error }] = useCreateSupplyOrderMutation({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *      warehouseColumnId: // value for 'warehouseColumnId'
 *   },
 * });
 */
export function useCreateSupplyOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplyOrderMutation, CreateSupplyOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplyOrderMutation, CreateSupplyOrderMutationVariables>(CreateSupplyOrderDocument, options);
      }
export type CreateSupplyOrderMutationHookResult = ReturnType<typeof useCreateSupplyOrderMutation>;
export type CreateSupplyOrderMutationResult = Apollo.MutationResult<CreateSupplyOrderMutation>;
export type CreateSupplyOrderMutationOptions = Apollo.BaseMutationOptions<CreateSupplyOrderMutation, CreateSupplyOrderMutationVariables>;
export const GenerateSupplyOrdersNeededDocument = gql`
    mutation GENERATE_SUPPLY_ORDERS_NEEDED {
  generateSupplyOrdersNeededMutation {
    createdSupplyOrders {
      ...SupplyOrderFragment
    }
    mergedSupplyOrders {
      ...SupplyOrderFragment
    }
    errors
  }
}
    ${SupplyOrderFragmentFragmentDoc}`;
export type GenerateSupplyOrdersNeededMutationFn = Apollo.MutationFunction<GenerateSupplyOrdersNeededMutation, GenerateSupplyOrdersNeededMutationVariables>;

/**
 * __useGenerateSupplyOrdersNeededMutation__
 *
 * To run a mutation, you first call `useGenerateSupplyOrdersNeededMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSupplyOrdersNeededMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSupplyOrdersNeededMutation, { data, loading, error }] = useGenerateSupplyOrdersNeededMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateSupplyOrdersNeededMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSupplyOrdersNeededMutation, GenerateSupplyOrdersNeededMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSupplyOrdersNeededMutation, GenerateSupplyOrdersNeededMutationVariables>(GenerateSupplyOrdersNeededDocument, options);
      }
export type GenerateSupplyOrdersNeededMutationHookResult = ReturnType<typeof useGenerateSupplyOrdersNeededMutation>;
export type GenerateSupplyOrdersNeededMutationResult = Apollo.MutationResult<GenerateSupplyOrdersNeededMutation>;
export type GenerateSupplyOrdersNeededMutationOptions = Apollo.BaseMutationOptions<GenerateSupplyOrdersNeededMutation, GenerateSupplyOrdersNeededMutationVariables>;
export const RelaunchPassSupplyOrdersToOrderedDocument = gql`
    mutation RELAUNCH_PASS_SUPPLY_ORDERS_TO_ORDERED {
  relaunchPassSupplyOrdersToOrdered {
    updatedSupplyOrders {
      ...SupplyOrderFragment
    }
    errors
  }
}
    ${SupplyOrderFragmentFragmentDoc}`;
export type RelaunchPassSupplyOrdersToOrderedMutationFn = Apollo.MutationFunction<RelaunchPassSupplyOrdersToOrderedMutation, RelaunchPassSupplyOrdersToOrderedMutationVariables>;

/**
 * __useRelaunchPassSupplyOrdersToOrderedMutation__
 *
 * To run a mutation, you first call `useRelaunchPassSupplyOrdersToOrderedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRelaunchPassSupplyOrdersToOrderedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [relaunchPassSupplyOrdersToOrderedMutation, { data, loading, error }] = useRelaunchPassSupplyOrdersToOrderedMutation({
 *   variables: {
 *   },
 * });
 */
export function useRelaunchPassSupplyOrdersToOrderedMutation(baseOptions?: Apollo.MutationHookOptions<RelaunchPassSupplyOrdersToOrderedMutation, RelaunchPassSupplyOrdersToOrderedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RelaunchPassSupplyOrdersToOrderedMutation, RelaunchPassSupplyOrdersToOrderedMutationVariables>(RelaunchPassSupplyOrdersToOrderedDocument, options);
      }
export type RelaunchPassSupplyOrdersToOrderedMutationHookResult = ReturnType<typeof useRelaunchPassSupplyOrdersToOrderedMutation>;
export type RelaunchPassSupplyOrdersToOrderedMutationResult = Apollo.MutationResult<RelaunchPassSupplyOrdersToOrderedMutation>;
export type RelaunchPassSupplyOrdersToOrderedMutationOptions = Apollo.BaseMutationOptions<RelaunchPassSupplyOrdersToOrderedMutation, RelaunchPassSupplyOrdersToOrderedMutationVariables>;
export const MarkSupplyOrdersAsAbortedDocument = gql`
    mutation MARK_SUPPLY_ORDERS_AS_ABORTED($supplyOrderIdsWithReasons: [SupplyOrderIDWithReasonsForAborting!]!) {
  markSupplyOrdersAsAborted(supplyOrderIdsWithReasons: $supplyOrderIdsWithReasons) {
    updatedSupplyOrders {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
    errors
    warnings
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type MarkSupplyOrdersAsAbortedMutationFn = Apollo.MutationFunction<MarkSupplyOrdersAsAbortedMutation, MarkSupplyOrdersAsAbortedMutationVariables>;

/**
 * __useMarkSupplyOrdersAsAbortedMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrdersAsAbortedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrdersAsAbortedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrdersAsAbortedMutation, { data, loading, error }] = useMarkSupplyOrdersAsAbortedMutation({
 *   variables: {
 *      supplyOrderIdsWithReasons: // value for 'supplyOrderIdsWithReasons'
 *   },
 * });
 */
export function useMarkSupplyOrdersAsAbortedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrdersAsAbortedMutation, MarkSupplyOrdersAsAbortedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrdersAsAbortedMutation, MarkSupplyOrdersAsAbortedMutationVariables>(MarkSupplyOrdersAsAbortedDocument, options);
      }
export type MarkSupplyOrdersAsAbortedMutationHookResult = ReturnType<typeof useMarkSupplyOrdersAsAbortedMutation>;
export type MarkSupplyOrdersAsAbortedMutationResult = Apollo.MutationResult<MarkSupplyOrdersAsAbortedMutation>;
export type MarkSupplyOrdersAsAbortedMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrdersAsAbortedMutation, MarkSupplyOrdersAsAbortedMutationVariables>;
export const MarkSupplyOrderAsAbortedDocument = gql`
    mutation MARK_SUPPLY_ORDER_AS_ABORTED($supplyOrderIdsWithReasons: [SupplyOrderIDWithReasonsForAborting!]!) {
  markSupplyOrdersAsAborted(supplyOrderIdsWithReasons: $supplyOrderIdsWithReasons) {
    updatedSupplyOrders {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
    errors
    warnings
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type MarkSupplyOrderAsAbortedMutationFn = Apollo.MutationFunction<MarkSupplyOrderAsAbortedMutation, MarkSupplyOrderAsAbortedMutationVariables>;

/**
 * __useMarkSupplyOrderAsAbortedMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrderAsAbortedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrderAsAbortedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrderAsAbortedMutation, { data, loading, error }] = useMarkSupplyOrderAsAbortedMutation({
 *   variables: {
 *      supplyOrderIdsWithReasons: // value for 'supplyOrderIdsWithReasons'
 *   },
 * });
 */
export function useMarkSupplyOrderAsAbortedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrderAsAbortedMutation, MarkSupplyOrderAsAbortedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrderAsAbortedMutation, MarkSupplyOrderAsAbortedMutationVariables>(MarkSupplyOrderAsAbortedDocument, options);
      }
export type MarkSupplyOrderAsAbortedMutationHookResult = ReturnType<typeof useMarkSupplyOrderAsAbortedMutation>;
export type MarkSupplyOrderAsAbortedMutationResult = Apollo.MutationResult<MarkSupplyOrderAsAbortedMutation>;
export type MarkSupplyOrderAsAbortedMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrderAsAbortedMutation, MarkSupplyOrderAsAbortedMutationVariables>;
export const MarkSupplyOrderAsCheckedDocument = gql`
    mutation MARK_SUPPLY_ORDER_AS_CHECKED($supplyOrderIds: [ID!]!) {
  markSupplyOrdersAsChecked(supplyOrderIds: $supplyOrderIds) {
    updatedSupplyOrders {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
    errors
    warnings
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type MarkSupplyOrderAsCheckedMutationFn = Apollo.MutationFunction<MarkSupplyOrderAsCheckedMutation, MarkSupplyOrderAsCheckedMutationVariables>;

/**
 * __useMarkSupplyOrderAsCheckedMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrderAsCheckedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrderAsCheckedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrderAsCheckedMutation, { data, loading, error }] = useMarkSupplyOrderAsCheckedMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *   },
 * });
 */
export function useMarkSupplyOrderAsCheckedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrderAsCheckedMutation, MarkSupplyOrderAsCheckedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrderAsCheckedMutation, MarkSupplyOrderAsCheckedMutationVariables>(MarkSupplyOrderAsCheckedDocument, options);
      }
export type MarkSupplyOrderAsCheckedMutationHookResult = ReturnType<typeof useMarkSupplyOrderAsCheckedMutation>;
export type MarkSupplyOrderAsCheckedMutationResult = Apollo.MutationResult<MarkSupplyOrderAsCheckedMutation>;
export type MarkSupplyOrderAsCheckedMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrderAsCheckedMutation, MarkSupplyOrderAsCheckedMutationVariables>;
export const MarkSupplyOrderAsConfirmedDocument = gql`
    mutation MARK_SUPPLY_ORDER_AS_CONFIRMED($supplyOrderIds: [ID!]!) {
  markSupplyOrdersAsConfirmed(supplyOrderIds: $supplyOrderIds) {
    updatedSupplyOrders {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
    errors
    warnings
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type MarkSupplyOrderAsConfirmedMutationFn = Apollo.MutationFunction<MarkSupplyOrderAsConfirmedMutation, MarkSupplyOrderAsConfirmedMutationVariables>;

/**
 * __useMarkSupplyOrderAsConfirmedMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrderAsConfirmedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrderAsConfirmedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrderAsConfirmedMutation, { data, loading, error }] = useMarkSupplyOrderAsConfirmedMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *   },
 * });
 */
export function useMarkSupplyOrderAsConfirmedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrderAsConfirmedMutation, MarkSupplyOrderAsConfirmedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrderAsConfirmedMutation, MarkSupplyOrderAsConfirmedMutationVariables>(MarkSupplyOrderAsConfirmedDocument, options);
      }
export type MarkSupplyOrderAsConfirmedMutationHookResult = ReturnType<typeof useMarkSupplyOrderAsConfirmedMutation>;
export type MarkSupplyOrderAsConfirmedMutationResult = Apollo.MutationResult<MarkSupplyOrderAsConfirmedMutation>;
export type MarkSupplyOrderAsConfirmedMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrderAsConfirmedMutation, MarkSupplyOrderAsConfirmedMutationVariables>;
export const MarkSupplyOrdersAsConfirmedDocument = gql`
    mutation MARK_SUPPLY_ORDERS_AS_CONFIRMED($supplyOrderIds: [ID!]!) {
  markSupplyOrdersAsConfirmed(supplyOrderIds: $supplyOrderIds) {
    updatedSupplyOrders {
      _id
      state
    }
    errors
    warnings
  }
}
    `;
export type MarkSupplyOrdersAsConfirmedMutationFn = Apollo.MutationFunction<MarkSupplyOrdersAsConfirmedMutation, MarkSupplyOrdersAsConfirmedMutationVariables>;

/**
 * __useMarkSupplyOrdersAsConfirmedMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrdersAsConfirmedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrdersAsConfirmedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrdersAsConfirmedMutation, { data, loading, error }] = useMarkSupplyOrdersAsConfirmedMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *   },
 * });
 */
export function useMarkSupplyOrdersAsConfirmedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrdersAsConfirmedMutation, MarkSupplyOrdersAsConfirmedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrdersAsConfirmedMutation, MarkSupplyOrdersAsConfirmedMutationVariables>(MarkSupplyOrdersAsConfirmedDocument, options);
      }
export type MarkSupplyOrdersAsConfirmedMutationHookResult = ReturnType<typeof useMarkSupplyOrdersAsConfirmedMutation>;
export type MarkSupplyOrdersAsConfirmedMutationResult = Apollo.MutationResult<MarkSupplyOrdersAsConfirmedMutation>;
export type MarkSupplyOrdersAsConfirmedMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrdersAsConfirmedMutation, MarkSupplyOrdersAsConfirmedMutationVariables>;
export const MarkSupplyOrderAsInrackDocument = gql`
    mutation MARK_SUPPLY_ORDER_AS_INRACK($supplyOrderIds: [ID!]!) {
  markSupplyOrdersAsInRack(supplyOrderIds: $supplyOrderIds) {
    updatedSupplyOrders {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
    errors
    warnings
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type MarkSupplyOrderAsInrackMutationFn = Apollo.MutationFunction<MarkSupplyOrderAsInrackMutation, MarkSupplyOrderAsInrackMutationVariables>;

/**
 * __useMarkSupplyOrderAsInrackMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrderAsInrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrderAsInrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrderAsInrackMutation, { data, loading, error }] = useMarkSupplyOrderAsInrackMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *   },
 * });
 */
export function useMarkSupplyOrderAsInrackMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrderAsInrackMutation, MarkSupplyOrderAsInrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrderAsInrackMutation, MarkSupplyOrderAsInrackMutationVariables>(MarkSupplyOrderAsInrackDocument, options);
      }
export type MarkSupplyOrderAsInrackMutationHookResult = ReturnType<typeof useMarkSupplyOrderAsInrackMutation>;
export type MarkSupplyOrderAsInrackMutationResult = Apollo.MutationResult<MarkSupplyOrderAsInrackMutation>;
export type MarkSupplyOrderAsInrackMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrderAsInrackMutation, MarkSupplyOrderAsInrackMutationVariables>;
export const MarkSupplyOrderAsOnHoldDocument = gql`
    mutation MARK_SUPPLY_ORDER_AS_ON_HOLD($supplyOrderId: ID!) {
  markSupplyOrderAsOnHold(supplyOrderId: $supplyOrderId) {
    ...SupplyOrderWithSupplierProductsInfoFragment
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type MarkSupplyOrderAsOnHoldMutationFn = Apollo.MutationFunction<MarkSupplyOrderAsOnHoldMutation, MarkSupplyOrderAsOnHoldMutationVariables>;

/**
 * __useMarkSupplyOrderAsOnHoldMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrderAsOnHoldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrderAsOnHoldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrderAsOnHoldMutation, { data, loading, error }] = useMarkSupplyOrderAsOnHoldMutation({
 *   variables: {
 *      supplyOrderId: // value for 'supplyOrderId'
 *   },
 * });
 */
export function useMarkSupplyOrderAsOnHoldMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrderAsOnHoldMutation, MarkSupplyOrderAsOnHoldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrderAsOnHoldMutation, MarkSupplyOrderAsOnHoldMutationVariables>(MarkSupplyOrderAsOnHoldDocument, options);
      }
export type MarkSupplyOrderAsOnHoldMutationHookResult = ReturnType<typeof useMarkSupplyOrderAsOnHoldMutation>;
export type MarkSupplyOrderAsOnHoldMutationResult = Apollo.MutationResult<MarkSupplyOrderAsOnHoldMutation>;
export type MarkSupplyOrderAsOnHoldMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrderAsOnHoldMutation, MarkSupplyOrderAsOnHoldMutationVariables>;
export const MarkSupplyOrderAsOrderedDocument = gql`
    mutation MARK_SUPPLY_ORDER_AS_ORDERED($supplyOrderIds: [ID!]!, $shouldSendMailToSupplier: Boolean) {
  markSupplyOrdersAsOrdered(
    supplyOrderIds: $supplyOrderIds
    shouldSendMailToSupplier: $shouldSendMailToSupplier
  ) {
    updatedSupplyOrders {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
    errors
    warnings
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type MarkSupplyOrderAsOrderedMutationFn = Apollo.MutationFunction<MarkSupplyOrderAsOrderedMutation, MarkSupplyOrderAsOrderedMutationVariables>;

/**
 * __useMarkSupplyOrderAsOrderedMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrderAsOrderedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrderAsOrderedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrderAsOrderedMutation, { data, loading, error }] = useMarkSupplyOrderAsOrderedMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *      shouldSendMailToSupplier: // value for 'shouldSendMailToSupplier'
 *   },
 * });
 */
export function useMarkSupplyOrderAsOrderedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrderAsOrderedMutation, MarkSupplyOrderAsOrderedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrderAsOrderedMutation, MarkSupplyOrderAsOrderedMutationVariables>(MarkSupplyOrderAsOrderedDocument, options);
      }
export type MarkSupplyOrderAsOrderedMutationHookResult = ReturnType<typeof useMarkSupplyOrderAsOrderedMutation>;
export type MarkSupplyOrderAsOrderedMutationResult = Apollo.MutationResult<MarkSupplyOrderAsOrderedMutation>;
export type MarkSupplyOrderAsOrderedMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrderAsOrderedMutation, MarkSupplyOrderAsOrderedMutationVariables>;
export const MarkSupplyOrdersAsOrderedDocument = gql`
    mutation MARK_SUPPLY_ORDERS_AS_ORDERED($supplyOrderIds: [ID!]!, $shouldSendMailToSupplier: Boolean) {
  markSupplyOrdersAsOrdered(
    supplyOrderIds: $supplyOrderIds
    shouldSendMailToSupplier: $shouldSendMailToSupplier
  ) {
    updatedSupplyOrders {
      _id
      state
    }
    errors
    warnings
  }
}
    `;
export type MarkSupplyOrdersAsOrderedMutationFn = Apollo.MutationFunction<MarkSupplyOrdersAsOrderedMutation, MarkSupplyOrdersAsOrderedMutationVariables>;

/**
 * __useMarkSupplyOrdersAsOrderedMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrdersAsOrderedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrdersAsOrderedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrdersAsOrderedMutation, { data, loading, error }] = useMarkSupplyOrdersAsOrderedMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *      shouldSendMailToSupplier: // value for 'shouldSendMailToSupplier'
 *   },
 * });
 */
export function useMarkSupplyOrdersAsOrderedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrdersAsOrderedMutation, MarkSupplyOrdersAsOrderedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrdersAsOrderedMutation, MarkSupplyOrdersAsOrderedMutationVariables>(MarkSupplyOrdersAsOrderedDocument, options);
      }
export type MarkSupplyOrdersAsOrderedMutationHookResult = ReturnType<typeof useMarkSupplyOrdersAsOrderedMutation>;
export type MarkSupplyOrdersAsOrderedMutationResult = Apollo.MutationResult<MarkSupplyOrdersAsOrderedMutation>;
export type MarkSupplyOrdersAsOrderedMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrdersAsOrderedMutation, MarkSupplyOrdersAsOrderedMutationVariables>;
export const MarkSupplyOrderAsReadyDocument = gql`
    mutation MARK_SUPPLY_ORDER_AS_READY($supplyOrderIds: [ID!]!) {
  markSupplyOrdersAsReady(supplyOrderIds: $supplyOrderIds) {
    updatedSupplyOrders {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
    errors
    warnings
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type MarkSupplyOrderAsReadyMutationFn = Apollo.MutationFunction<MarkSupplyOrderAsReadyMutation, MarkSupplyOrderAsReadyMutationVariables>;

/**
 * __useMarkSupplyOrderAsReadyMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrderAsReadyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrderAsReadyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrderAsReadyMutation, { data, loading, error }] = useMarkSupplyOrderAsReadyMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *   },
 * });
 */
export function useMarkSupplyOrderAsReadyMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrderAsReadyMutation, MarkSupplyOrderAsReadyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrderAsReadyMutation, MarkSupplyOrderAsReadyMutationVariables>(MarkSupplyOrderAsReadyDocument, options);
      }
export type MarkSupplyOrderAsReadyMutationHookResult = ReturnType<typeof useMarkSupplyOrderAsReadyMutation>;
export type MarkSupplyOrderAsReadyMutationResult = Apollo.MutationResult<MarkSupplyOrderAsReadyMutation>;
export type MarkSupplyOrderAsReadyMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrderAsReadyMutation, MarkSupplyOrderAsReadyMutationVariables>;
export const MarkSupplyOrdersAsReadyDocument = gql`
    mutation MARK_SUPPLY_ORDERS_AS_READY($supplyOrderIds: [ID!]!) {
  markSupplyOrdersAsReady(supplyOrderIds: $supplyOrderIds) {
    updatedSupplyOrders {
      _id
      dateDeliveryScheduled
      orderDate
      state
    }
    errors
    warnings
  }
}
    `;
export type MarkSupplyOrdersAsReadyMutationFn = Apollo.MutationFunction<MarkSupplyOrdersAsReadyMutation, MarkSupplyOrdersAsReadyMutationVariables>;

/**
 * __useMarkSupplyOrdersAsReadyMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrdersAsReadyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrdersAsReadyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrdersAsReadyMutation, { data, loading, error }] = useMarkSupplyOrdersAsReadyMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *   },
 * });
 */
export function useMarkSupplyOrdersAsReadyMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrdersAsReadyMutation, MarkSupplyOrdersAsReadyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrdersAsReadyMutation, MarkSupplyOrdersAsReadyMutationVariables>(MarkSupplyOrdersAsReadyDocument, options);
      }
export type MarkSupplyOrdersAsReadyMutationHookResult = ReturnType<typeof useMarkSupplyOrdersAsReadyMutation>;
export type MarkSupplyOrdersAsReadyMutationResult = Apollo.MutationResult<MarkSupplyOrdersAsReadyMutation>;
export type MarkSupplyOrdersAsReadyMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrdersAsReadyMutation, MarkSupplyOrdersAsReadyMutationVariables>;
export const MarkSupplyOrderAsCreatedDocument = gql`
    mutation MARK_SUPPLY_ORDER_AS_CREATED($supplyOrderIds: [ID!]!) {
  markSupplyOrdersAsCreated(supplyOrderIds: $supplyOrderIds) {
    updatedSupplyOrders {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
    errors
    warnings
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type MarkSupplyOrderAsCreatedMutationFn = Apollo.MutationFunction<MarkSupplyOrderAsCreatedMutation, MarkSupplyOrderAsCreatedMutationVariables>;

/**
 * __useMarkSupplyOrderAsCreatedMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrderAsCreatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrderAsCreatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrderAsCreatedMutation, { data, loading, error }] = useMarkSupplyOrderAsCreatedMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *   },
 * });
 */
export function useMarkSupplyOrderAsCreatedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrderAsCreatedMutation, MarkSupplyOrderAsCreatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrderAsCreatedMutation, MarkSupplyOrderAsCreatedMutationVariables>(MarkSupplyOrderAsCreatedDocument, options);
      }
export type MarkSupplyOrderAsCreatedMutationHookResult = ReturnType<typeof useMarkSupplyOrderAsCreatedMutation>;
export type MarkSupplyOrderAsCreatedMutationResult = Apollo.MutationResult<MarkSupplyOrderAsCreatedMutation>;
export type MarkSupplyOrderAsCreatedMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrderAsCreatedMutation, MarkSupplyOrderAsCreatedMutationVariables>;
export const MarkSupplyOrdersAsCreatedDocument = gql`
    mutation MARK_SUPPLY_ORDERS_AS_CREATED($supplyOrderIds: [ID!]!) {
  markSupplyOrdersAsCreated(supplyOrderIds: $supplyOrderIds) {
    updatedSupplyOrders {
      _id
      state
    }
    errors
    warnings
  }
}
    `;
export type MarkSupplyOrdersAsCreatedMutationFn = Apollo.MutationFunction<MarkSupplyOrdersAsCreatedMutation, MarkSupplyOrdersAsCreatedMutationVariables>;

/**
 * __useMarkSupplyOrdersAsCreatedMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrdersAsCreatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrdersAsCreatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrdersAsCreatedMutation, { data, loading, error }] = useMarkSupplyOrdersAsCreatedMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *   },
 * });
 */
export function useMarkSupplyOrdersAsCreatedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrdersAsCreatedMutation, MarkSupplyOrdersAsCreatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrdersAsCreatedMutation, MarkSupplyOrdersAsCreatedMutationVariables>(MarkSupplyOrdersAsCreatedDocument, options);
      }
export type MarkSupplyOrdersAsCreatedMutationHookResult = ReturnType<typeof useMarkSupplyOrdersAsCreatedMutation>;
export type MarkSupplyOrdersAsCreatedMutationResult = Apollo.MutationResult<MarkSupplyOrdersAsCreatedMutation>;
export type MarkSupplyOrdersAsCreatedMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrdersAsCreatedMutation, MarkSupplyOrdersAsCreatedMutationVariables>;
export const MarkSupplyOrderAsReceivedDocument = gql`
    mutation MARK_SUPPLY_ORDER_AS_RECEIVED($supplyOrderIds: [ID!]!, $hourDeliveryReceivedAt: String!) {
  markSupplyOrdersAsReceived(
    supplyOrderIds: $supplyOrderIds
    hourDeliveryReceivedAt: $hourDeliveryReceivedAt
  ) {
    updatedSupplyOrders {
      ...SupplyOrderWithSupplierProductsInfoFragment
    }
    errors
    warnings
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type MarkSupplyOrderAsReceivedMutationFn = Apollo.MutationFunction<MarkSupplyOrderAsReceivedMutation, MarkSupplyOrderAsReceivedMutationVariables>;

/**
 * __useMarkSupplyOrderAsReceivedMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrderAsReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrderAsReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrderAsReceivedMutation, { data, loading, error }] = useMarkSupplyOrderAsReceivedMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *      hourDeliveryReceivedAt: // value for 'hourDeliveryReceivedAt'
 *   },
 * });
 */
export function useMarkSupplyOrderAsReceivedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrderAsReceivedMutation, MarkSupplyOrderAsReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrderAsReceivedMutation, MarkSupplyOrderAsReceivedMutationVariables>(MarkSupplyOrderAsReceivedDocument, options);
      }
export type MarkSupplyOrderAsReceivedMutationHookResult = ReturnType<typeof useMarkSupplyOrderAsReceivedMutation>;
export type MarkSupplyOrderAsReceivedMutationResult = Apollo.MutationResult<MarkSupplyOrderAsReceivedMutation>;
export type MarkSupplyOrderAsReceivedMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrderAsReceivedMutation, MarkSupplyOrderAsReceivedMutationVariables>;
export const MarkSupplyOrdersAsReceivedDocument = gql`
    mutation MARK_SUPPLY_ORDERS_AS_RECEIVED($supplyOrderIds: [ID!]!, $hourDeliveryReceivedAt: String!) {
  markSupplyOrdersAsReceived(
    supplyOrderIds: $supplyOrderIds
    hourDeliveryReceivedAt: $hourDeliveryReceivedAt
  ) {
    updatedSupplyOrders {
      _id
      state
    }
    errors
    warnings
  }
}
    `;
export type MarkSupplyOrdersAsReceivedMutationFn = Apollo.MutationFunction<MarkSupplyOrdersAsReceivedMutation, MarkSupplyOrdersAsReceivedMutationVariables>;

/**
 * __useMarkSupplyOrdersAsReceivedMutation__
 *
 * To run a mutation, you first call `useMarkSupplyOrdersAsReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSupplyOrdersAsReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSupplyOrdersAsReceivedMutation, { data, loading, error }] = useMarkSupplyOrdersAsReceivedMutation({
 *   variables: {
 *      supplyOrderIds: // value for 'supplyOrderIds'
 *      hourDeliveryReceivedAt: // value for 'hourDeliveryReceivedAt'
 *   },
 * });
 */
export function useMarkSupplyOrdersAsReceivedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSupplyOrdersAsReceivedMutation, MarkSupplyOrdersAsReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSupplyOrdersAsReceivedMutation, MarkSupplyOrdersAsReceivedMutationVariables>(MarkSupplyOrdersAsReceivedDocument, options);
      }
export type MarkSupplyOrdersAsReceivedMutationHookResult = ReturnType<typeof useMarkSupplyOrdersAsReceivedMutation>;
export type MarkSupplyOrdersAsReceivedMutationResult = Apollo.MutationResult<MarkSupplyOrdersAsReceivedMutation>;
export type MarkSupplyOrdersAsReceivedMutationOptions = Apollo.BaseMutationOptions<MarkSupplyOrdersAsReceivedMutation, MarkSupplyOrdersAsReceivedMutationVariables>;
export const ExternalConfirmSupplyOrderDocument = gql`
    mutation EXTERNAL_CONFIRM_SUPPLY_ORDER($token: String!) {
  externalConfirmSupplyOrder(token: $token) {
    success
    error
  }
}
    `;
export type ExternalConfirmSupplyOrderMutationFn = Apollo.MutationFunction<ExternalConfirmSupplyOrderMutation, ExternalConfirmSupplyOrderMutationVariables>;

/**
 * __useExternalConfirmSupplyOrderMutation__
 *
 * To run a mutation, you first call `useExternalConfirmSupplyOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalConfirmSupplyOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalConfirmSupplyOrderMutation, { data, loading, error }] = useExternalConfirmSupplyOrderMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useExternalConfirmSupplyOrderMutation(baseOptions?: Apollo.MutationHookOptions<ExternalConfirmSupplyOrderMutation, ExternalConfirmSupplyOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExternalConfirmSupplyOrderMutation, ExternalConfirmSupplyOrderMutationVariables>(ExternalConfirmSupplyOrderDocument, options);
      }
export type ExternalConfirmSupplyOrderMutationHookResult = ReturnType<typeof useExternalConfirmSupplyOrderMutation>;
export type ExternalConfirmSupplyOrderMutationResult = Apollo.MutationResult<ExternalConfirmSupplyOrderMutation>;
export type ExternalConfirmSupplyOrderMutationOptions = Apollo.BaseMutationOptions<ExternalConfirmSupplyOrderMutation, ExternalConfirmSupplyOrderMutationVariables>;
export const AddAdditionalSupplyOrderReceivedProductDetailsDocument = gql`
    mutation ADD_ADDITIONAL_SUPPLY_ORDER_RECEIVED_PRODUCT_DETAILS($supplyOrderId: String!, $productDetails: [SupplyOrderReceivedProductDetails!]!) {
  addAdditionalSupplyOrderReceivedProductDetails(
    supplyOrderId: $supplyOrderId
    productDetails: $productDetails
  ) {
    ...SupplyOrderWithSupplierProductsInfoFragment
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;
export type AddAdditionalSupplyOrderReceivedProductDetailsMutationFn = Apollo.MutationFunction<AddAdditionalSupplyOrderReceivedProductDetailsMutation, AddAdditionalSupplyOrderReceivedProductDetailsMutationVariables>;

/**
 * __useAddAdditionalSupplyOrderReceivedProductDetailsMutation__
 *
 * To run a mutation, you first call `useAddAdditionalSupplyOrderReceivedProductDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdditionalSupplyOrderReceivedProductDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdditionalSupplyOrderReceivedProductDetailsMutation, { data, loading, error }] = useAddAdditionalSupplyOrderReceivedProductDetailsMutation({
 *   variables: {
 *      supplyOrderId: // value for 'supplyOrderId'
 *      productDetails: // value for 'productDetails'
 *   },
 * });
 */
export function useAddAdditionalSupplyOrderReceivedProductDetailsMutation(baseOptions?: Apollo.MutationHookOptions<AddAdditionalSupplyOrderReceivedProductDetailsMutation, AddAdditionalSupplyOrderReceivedProductDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAdditionalSupplyOrderReceivedProductDetailsMutation, AddAdditionalSupplyOrderReceivedProductDetailsMutationVariables>(AddAdditionalSupplyOrderReceivedProductDetailsDocument, options);
      }
export type AddAdditionalSupplyOrderReceivedProductDetailsMutationHookResult = ReturnType<typeof useAddAdditionalSupplyOrderReceivedProductDetailsMutation>;
export type AddAdditionalSupplyOrderReceivedProductDetailsMutationResult = Apollo.MutationResult<AddAdditionalSupplyOrderReceivedProductDetailsMutation>;
export type AddAdditionalSupplyOrderReceivedProductDetailsMutationOptions = Apollo.BaseMutationOptions<AddAdditionalSupplyOrderReceivedProductDetailsMutation, AddAdditionalSupplyOrderReceivedProductDetailsMutationVariables>;
export const CreateTagDocument = gql`
    mutation CREATE_TAG($tag: CreateTagInput!) {
  createTag(tag: $tag) {
    tag {
      ...TagMutationFragment
    }
    success
    error
  }
}
    ${TagMutationFragmentFragmentDoc}`;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UPDATE_TAG($tag: UpdateTagInput!) {
  updateTag(tag: $tag) {
    tag {
      ...TagMutationFragment
    }
    success
    error
  }
}
    ${TagMutationFragmentFragmentDoc}`;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const CreateTermsRecordDocument = gql`
    mutation CREATE_TERMS_RECORD($termsOfUse: Upload!) {
  createTermsRecord(termsOfUse: $termsOfUse) {
    success
    error
    termsRecord {
      _id
      createdAt
      termsOfUseUrl
    }
  }
}
    `;
export type CreateTermsRecordMutationFn = Apollo.MutationFunction<CreateTermsRecordMutation, CreateTermsRecordMutationVariables>;

/**
 * __useCreateTermsRecordMutation__
 *
 * To run a mutation, you first call `useCreateTermsRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTermsRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTermsRecordMutation, { data, loading, error }] = useCreateTermsRecordMutation({
 *   variables: {
 *      termsOfUse: // value for 'termsOfUse'
 *   },
 * });
 */
export function useCreateTermsRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateTermsRecordMutation, CreateTermsRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTermsRecordMutation, CreateTermsRecordMutationVariables>(CreateTermsRecordDocument, options);
      }
export type CreateTermsRecordMutationHookResult = ReturnType<typeof useCreateTermsRecordMutation>;
export type CreateTermsRecordMutationResult = Apollo.MutationResult<CreateTermsRecordMutation>;
export type CreateTermsRecordMutationOptions = Apollo.BaseMutationOptions<CreateTermsRecordMutation, CreateTermsRecordMutationVariables>;
export const CreateThermometerDocument = gql`
    mutation CREATE_THERMOMETER($number: Int!) {
  createThermometer(number: $number) {
    ...ThermometerFragment
  }
}
    ${ThermometerFragmentFragmentDoc}`;
export type CreateThermometerMutationFn = Apollo.MutationFunction<CreateThermometerMutation, CreateThermometerMutationVariables>;

/**
 * __useCreateThermometerMutation__
 *
 * To run a mutation, you first call `useCreateThermometerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThermometerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThermometerMutation, { data, loading, error }] = useCreateThermometerMutation({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useCreateThermometerMutation(baseOptions?: Apollo.MutationHookOptions<CreateThermometerMutation, CreateThermometerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThermometerMutation, CreateThermometerMutationVariables>(CreateThermometerDocument, options);
      }
export type CreateThermometerMutationHookResult = ReturnType<typeof useCreateThermometerMutation>;
export type CreateThermometerMutationResult = Apollo.MutationResult<CreateThermometerMutation>;
export type CreateThermometerMutationOptions = Apollo.BaseMutationOptions<CreateThermometerMutation, CreateThermometerMutationVariables>;
export const UpdateThermometerDocument = gql`
    mutation UPDATE_THERMOMETER($thermometerUpdateInput: ThermometerUpdateInput!) {
  updateThermometer(thermometerUpdateInput: $thermometerUpdateInput) {
    ...ThermometerFragment
  }
}
    ${ThermometerFragmentFragmentDoc}`;
export type UpdateThermometerMutationFn = Apollo.MutationFunction<UpdateThermometerMutation, UpdateThermometerMutationVariables>;

/**
 * __useUpdateThermometerMutation__
 *
 * To run a mutation, you first call `useUpdateThermometerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThermometerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThermometerMutation, { data, loading, error }] = useUpdateThermometerMutation({
 *   variables: {
 *      thermometerUpdateInput: // value for 'thermometerUpdateInput'
 *   },
 * });
 */
export function useUpdateThermometerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThermometerMutation, UpdateThermometerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThermometerMutation, UpdateThermometerMutationVariables>(UpdateThermometerDocument, options);
      }
export type UpdateThermometerMutationHookResult = ReturnType<typeof useUpdateThermometerMutation>;
export type UpdateThermometerMutationResult = Apollo.MutationResult<UpdateThermometerMutation>;
export type UpdateThermometerMutationOptions = Apollo.BaseMutationOptions<UpdateThermometerMutation, UpdateThermometerMutationVariables>;
export const ArchiveTotemDocument = gql`
    mutation ARCHIVE_TOTEM($totemId: ID!) {
  archiveTotem(totemId: $totemId) {
    errors
    organization {
      _id
      state
      stateHistory {
        createdAt
        createdBy
        createdByName
        state
      }
    }
    totem {
      _id
      state
      stateHistory {
        createdAt
        createdBy
        createdByName
        state
      }
    }
  }
}
    `;
export type ArchiveTotemMutationFn = Apollo.MutationFunction<ArchiveTotemMutation, ArchiveTotemMutationVariables>;

/**
 * __useArchiveTotemMutation__
 *
 * To run a mutation, you first call `useArchiveTotemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTotemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTotemMutation, { data, loading, error }] = useArchiveTotemMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *   },
 * });
 */
export function useArchiveTotemMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTotemMutation, ArchiveTotemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTotemMutation, ArchiveTotemMutationVariables>(ArchiveTotemDocument, options);
      }
export type ArchiveTotemMutationHookResult = ReturnType<typeof useArchiveTotemMutation>;
export type ArchiveTotemMutationResult = Apollo.MutationResult<ArchiveTotemMutation>;
export type ArchiveTotemMutationOptions = Apollo.BaseMutationOptions<ArchiveTotemMutation, ArchiveTotemMutationVariables>;
export const ReactivateTotemDocument = gql`
    mutation REACTIVATE_TOTEM($totemId: ID!) {
  reactivateTotem(totemId: $totemId) {
    errors
    organization {
      _id
      state
      stateHistory {
        createdAt
        createdBy
        createdByName
        state
      }
    }
    totem {
      _id
      state
      stateHistory {
        createdAt
        createdBy
        createdByName
        state
      }
    }
  }
}
    `;
export type ReactivateTotemMutationFn = Apollo.MutationFunction<ReactivateTotemMutation, ReactivateTotemMutationVariables>;

/**
 * __useReactivateTotemMutation__
 *
 * To run a mutation, you first call `useReactivateTotemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateTotemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateTotemMutation, { data, loading, error }] = useReactivateTotemMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *   },
 * });
 */
export function useReactivateTotemMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateTotemMutation, ReactivateTotemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateTotemMutation, ReactivateTotemMutationVariables>(ReactivateTotemDocument, options);
      }
export type ReactivateTotemMutationHookResult = ReturnType<typeof useReactivateTotemMutation>;
export type ReactivateTotemMutationResult = Apollo.MutationResult<ReactivateTotemMutation>;
export type ReactivateTotemMutationOptions = Apollo.BaseMutationOptions<ReactivateTotemMutation, ReactivateTotemMutationVariables>;
export const UpdateTotemDocument = gql`
    mutation UPDATE_TOTEM($totemId: ID!, $fields: TotemUpdateInput!) {
  updateTotem(totemId: $totemId, fields: $fields) {
    error
    formErrors {
      ...FormErrorFragment
    }
    updatedTotem {
      _id
      name
      address
      address_details
      consigneDelivery
      zipcode
      city
      country
      latitude
      longitude
      minimumOrderAmountInfo {
        minimumBakeryAmount
        minimumDryAmount
        minimumFreshAmount
        minimumCatererAmount
        minimumFruitAmount
        minimumTotalAmount
      }
      needSignature
    }
  }
}
    ${FormErrorFragmentFragmentDoc}`;
export type UpdateTotemMutationFn = Apollo.MutationFunction<UpdateTotemMutation, UpdateTotemMutationVariables>;

/**
 * __useUpdateTotemMutation__
 *
 * To run a mutation, you first call `useUpdateTotemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTotemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTotemMutation, { data, loading, error }] = useUpdateTotemMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateTotemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTotemMutation, UpdateTotemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTotemMutation, UpdateTotemMutationVariables>(UpdateTotemDocument, options);
      }
export type UpdateTotemMutationHookResult = ReturnType<typeof useUpdateTotemMutation>;
export type UpdateTotemMutationResult = Apollo.MutationResult<UpdateTotemMutation>;
export type UpdateTotemMutationOptions = Apollo.BaseMutationOptions<UpdateTotemMutation, UpdateTotemMutationVariables>;
export const CreateNewTotemFromOrganizationDocument = gql`
    mutation CREATE_NEW_TOTEM_FROM_ORGANIZATION($organizationId: ID!) {
  createNewTotemFromOrganization(organizationId: $organizationId) {
    _id
    name
    number
    state
    stateHistory {
      createdAt
      createdBy
      createdByName
      state
    }
  }
}
    `;
export type CreateNewTotemFromOrganizationMutationFn = Apollo.MutationFunction<CreateNewTotemFromOrganizationMutation, CreateNewTotemFromOrganizationMutationVariables>;

/**
 * __useCreateNewTotemFromOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateNewTotemFromOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewTotemFromOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewTotemFromOrganizationMutation, { data, loading, error }] = useCreateNewTotemFromOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateNewTotemFromOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewTotemFromOrganizationMutation, CreateNewTotemFromOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewTotemFromOrganizationMutation, CreateNewTotemFromOrganizationMutationVariables>(CreateNewTotemFromOrganizationDocument, options);
      }
export type CreateNewTotemFromOrganizationMutationHookResult = ReturnType<typeof useCreateNewTotemFromOrganizationMutation>;
export type CreateNewTotemFromOrganizationMutationResult = Apollo.MutationResult<CreateNewTotemFromOrganizationMutation>;
export type CreateNewTotemFromOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateNewTotemFromOrganizationMutation, CreateNewTotemFromOrganizationMutationVariables>;
export const CreateTotemClosedDayDocument = gql`
    mutation CREATE_TOTEM_CLOSED_DAY($createTotemClosedDayInput: CreateTotemClosedDayInput!) {
  createTotemClosedDay(createTotemClosedDayInput: $createTotemClosedDayInput) {
    ...TotemClosedDayFragment
  }
}
    ${TotemClosedDayFragmentFragmentDoc}`;
export type CreateTotemClosedDayMutationFn = Apollo.MutationFunction<CreateTotemClosedDayMutation, CreateTotemClosedDayMutationVariables>;

/**
 * __useCreateTotemClosedDayMutation__
 *
 * To run a mutation, you first call `useCreateTotemClosedDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTotemClosedDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTotemClosedDayMutation, { data, loading, error }] = useCreateTotemClosedDayMutation({
 *   variables: {
 *      createTotemClosedDayInput: // value for 'createTotemClosedDayInput'
 *   },
 * });
 */
export function useCreateTotemClosedDayMutation(baseOptions?: Apollo.MutationHookOptions<CreateTotemClosedDayMutation, CreateTotemClosedDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTotemClosedDayMutation, CreateTotemClosedDayMutationVariables>(CreateTotemClosedDayDocument, options);
      }
export type CreateTotemClosedDayMutationHookResult = ReturnType<typeof useCreateTotemClosedDayMutation>;
export type CreateTotemClosedDayMutationResult = Apollo.MutationResult<CreateTotemClosedDayMutation>;
export type CreateTotemClosedDayMutationOptions = Apollo.BaseMutationOptions<CreateTotemClosedDayMutation, CreateTotemClosedDayMutationVariables>;
export const AbortTotemClosedDayDocument = gql`
    mutation ABORT_TOTEM_CLOSED_DAY($totemClosedDayId: ID!) {
  abortTotemClosedDay(totemClosedDayId: $totemClosedDayId) {
    ...TotemClosedDayFragment
  }
}
    ${TotemClosedDayFragmentFragmentDoc}`;
export type AbortTotemClosedDayMutationFn = Apollo.MutationFunction<AbortTotemClosedDayMutation, AbortTotemClosedDayMutationVariables>;

/**
 * __useAbortTotemClosedDayMutation__
 *
 * To run a mutation, you first call `useAbortTotemClosedDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortTotemClosedDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortTotemClosedDayMutation, { data, loading, error }] = useAbortTotemClosedDayMutation({
 *   variables: {
 *      totemClosedDayId: // value for 'totemClosedDayId'
 *   },
 * });
 */
export function useAbortTotemClosedDayMutation(baseOptions?: Apollo.MutationHookOptions<AbortTotemClosedDayMutation, AbortTotemClosedDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortTotemClosedDayMutation, AbortTotemClosedDayMutationVariables>(AbortTotemClosedDayDocument, options);
      }
export type AbortTotemClosedDayMutationHookResult = ReturnType<typeof useAbortTotemClosedDayMutation>;
export type AbortTotemClosedDayMutationResult = Apollo.MutationResult<AbortTotemClosedDayMutation>;
export type AbortTotemClosedDayMutationOptions = Apollo.BaseMutationOptions<AbortTotemClosedDayMutation, AbortTotemClosedDayMutationVariables>;
export const ArchiveTotemClosedDayDocument = gql`
    mutation ARCHIVE_TOTEM_CLOSED_DAY($totemClosedDayId: ID!) {
  archiveTotemClosedDay(totemClosedDayId: $totemClosedDayId) {
    ...TotemClosedDayFragment
  }
}
    ${TotemClosedDayFragmentFragmentDoc}`;
export type ArchiveTotemClosedDayMutationFn = Apollo.MutationFunction<ArchiveTotemClosedDayMutation, ArchiveTotemClosedDayMutationVariables>;

/**
 * __useArchiveTotemClosedDayMutation__
 *
 * To run a mutation, you first call `useArchiveTotemClosedDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTotemClosedDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTotemClosedDayMutation, { data, loading, error }] = useArchiveTotemClosedDayMutation({
 *   variables: {
 *      totemClosedDayId: // value for 'totemClosedDayId'
 *   },
 * });
 */
export function useArchiveTotemClosedDayMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTotemClosedDayMutation, ArchiveTotemClosedDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTotemClosedDayMutation, ArchiveTotemClosedDayMutationVariables>(ArchiveTotemClosedDayDocument, options);
      }
export type ArchiveTotemClosedDayMutationHookResult = ReturnType<typeof useArchiveTotemClosedDayMutation>;
export type ArchiveTotemClosedDayMutationResult = Apollo.MutationResult<ArchiveTotemClosedDayMutation>;
export type ArchiveTotemClosedDayMutationOptions = Apollo.BaseMutationOptions<ArchiveTotemClosedDayMutation, ArchiveTotemClosedDayMutationVariables>;
export const CreateTotemClosedReceptionDayDocument = gql`
    mutation CREATE_TOTEM_CLOSED_RECEPTION_DAY($createTotemClosedReceptionDayInput: CreateTotemClosedReceptionDayInput!) {
  createTotemClosedReceptionDay(
    createTotemClosedReceptionDayInput: $createTotemClosedReceptionDayInput
  ) {
    ...TotemClosedReceptionDayFragment
  }
}
    ${TotemClosedReceptionDayFragmentFragmentDoc}`;
export type CreateTotemClosedReceptionDayMutationFn = Apollo.MutationFunction<CreateTotemClosedReceptionDayMutation, CreateTotemClosedReceptionDayMutationVariables>;

/**
 * __useCreateTotemClosedReceptionDayMutation__
 *
 * To run a mutation, you first call `useCreateTotemClosedReceptionDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTotemClosedReceptionDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTotemClosedReceptionDayMutation, { data, loading, error }] = useCreateTotemClosedReceptionDayMutation({
 *   variables: {
 *      createTotemClosedReceptionDayInput: // value for 'createTotemClosedReceptionDayInput'
 *   },
 * });
 */
export function useCreateTotemClosedReceptionDayMutation(baseOptions?: Apollo.MutationHookOptions<CreateTotemClosedReceptionDayMutation, CreateTotemClosedReceptionDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTotemClosedReceptionDayMutation, CreateTotemClosedReceptionDayMutationVariables>(CreateTotemClosedReceptionDayDocument, options);
      }
export type CreateTotemClosedReceptionDayMutationHookResult = ReturnType<typeof useCreateTotemClosedReceptionDayMutation>;
export type CreateTotemClosedReceptionDayMutationResult = Apollo.MutationResult<CreateTotemClosedReceptionDayMutation>;
export type CreateTotemClosedReceptionDayMutationOptions = Apollo.BaseMutationOptions<CreateTotemClosedReceptionDayMutation, CreateTotemClosedReceptionDayMutationVariables>;
export const AbortTotemClosedReceptionDayDocument = gql`
    mutation ABORT_TOTEM_CLOSED_RECEPTION_DAY($totemClosedReceptionDayId: ID!) {
  abortTotemClosedReceptionDay(
    totemClosedReceptionDayId: $totemClosedReceptionDayId
  ) {
    ...TotemClosedReceptionDayFragment
  }
}
    ${TotemClosedReceptionDayFragmentFragmentDoc}`;
export type AbortTotemClosedReceptionDayMutationFn = Apollo.MutationFunction<AbortTotemClosedReceptionDayMutation, AbortTotemClosedReceptionDayMutationVariables>;

/**
 * __useAbortTotemClosedReceptionDayMutation__
 *
 * To run a mutation, you first call `useAbortTotemClosedReceptionDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortTotemClosedReceptionDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortTotemClosedReceptionDayMutation, { data, loading, error }] = useAbortTotemClosedReceptionDayMutation({
 *   variables: {
 *      totemClosedReceptionDayId: // value for 'totemClosedReceptionDayId'
 *   },
 * });
 */
export function useAbortTotemClosedReceptionDayMutation(baseOptions?: Apollo.MutationHookOptions<AbortTotemClosedReceptionDayMutation, AbortTotemClosedReceptionDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortTotemClosedReceptionDayMutation, AbortTotemClosedReceptionDayMutationVariables>(AbortTotemClosedReceptionDayDocument, options);
      }
export type AbortTotemClosedReceptionDayMutationHookResult = ReturnType<typeof useAbortTotemClosedReceptionDayMutation>;
export type AbortTotemClosedReceptionDayMutationResult = Apollo.MutationResult<AbortTotemClosedReceptionDayMutation>;
export type AbortTotemClosedReceptionDayMutationOptions = Apollo.BaseMutationOptions<AbortTotemClosedReceptionDayMutation, AbortTotemClosedReceptionDayMutationVariables>;
export const ArchiveTotemClosedReceptionDayDocument = gql`
    mutation ARCHIVE_TOTEM_CLOSED_RECEPTION_DAY($totemClosedReceptionDayId: ID!) {
  archiveTotemClosedReceptionDay(
    totemClosedReceptionDayId: $totemClosedReceptionDayId
  ) {
    ...TotemClosedReceptionDayFragment
  }
}
    ${TotemClosedReceptionDayFragmentFragmentDoc}`;
export type ArchiveTotemClosedReceptionDayMutationFn = Apollo.MutationFunction<ArchiveTotemClosedReceptionDayMutation, ArchiveTotemClosedReceptionDayMutationVariables>;

/**
 * __useArchiveTotemClosedReceptionDayMutation__
 *
 * To run a mutation, you first call `useArchiveTotemClosedReceptionDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTotemClosedReceptionDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTotemClosedReceptionDayMutation, { data, loading, error }] = useArchiveTotemClosedReceptionDayMutation({
 *   variables: {
 *      totemClosedReceptionDayId: // value for 'totemClosedReceptionDayId'
 *   },
 * });
 */
export function useArchiveTotemClosedReceptionDayMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTotemClosedReceptionDayMutation, ArchiveTotemClosedReceptionDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTotemClosedReceptionDayMutation, ArchiveTotemClosedReceptionDayMutationVariables>(ArchiveTotemClosedReceptionDayDocument, options);
      }
export type ArchiveTotemClosedReceptionDayMutationHookResult = ReturnType<typeof useArchiveTotemClosedReceptionDayMutation>;
export type ArchiveTotemClosedReceptionDayMutationResult = Apollo.MutationResult<ArchiveTotemClosedReceptionDayMutation>;
export type ArchiveTotemClosedReceptionDayMutationOptions = Apollo.BaseMutationOptions<ArchiveTotemClosedReceptionDayMutation, ArchiveTotemClosedReceptionDayMutationVariables>;
export const BuildToursForDateDocument = gql`
    mutation BUILD_TOURS_FOR_DATE($birthdayDate: String!) {
  buildToursForDate(birthdayDate: $birthdayDate) {
    toursCreated
    toursAppended
    deliveriesPlanned
    deliveriesKept
  }
}
    `;
export type BuildToursForDateMutationFn = Apollo.MutationFunction<BuildToursForDateMutation, BuildToursForDateMutationVariables>;

/**
 * __useBuildToursForDateMutation__
 *
 * To run a mutation, you first call `useBuildToursForDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildToursForDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildToursForDateMutation, { data, loading, error }] = useBuildToursForDateMutation({
 *   variables: {
 *      birthdayDate: // value for 'birthdayDate'
 *   },
 * });
 */
export function useBuildToursForDateMutation(baseOptions?: Apollo.MutationHookOptions<BuildToursForDateMutation, BuildToursForDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildToursForDateMutation, BuildToursForDateMutationVariables>(BuildToursForDateDocument, options);
      }
export type BuildToursForDateMutationHookResult = ReturnType<typeof useBuildToursForDateMutation>;
export type BuildToursForDateMutationResult = Apollo.MutationResult<BuildToursForDateMutation>;
export type BuildToursForDateMutationOptions = Apollo.BaseMutationOptions<BuildToursForDateMutation, BuildToursForDateMutationVariables>;
export const CreateTourDocument = gql`
    mutation CREATE_TOUR($input: CreateTourInput!) {
  createTour(input: $input) {
    ...TourFragment
  }
}
    ${TourFragmentFragmentDoc}`;
export type CreateTourMutationFn = Apollo.MutationFunction<CreateTourMutation, CreateTourMutationVariables>;

/**
 * __useCreateTourMutation__
 *
 * To run a mutation, you first call `useCreateTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTourMutation, { data, loading, error }] = useCreateTourMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTourMutation(baseOptions?: Apollo.MutationHookOptions<CreateTourMutation, CreateTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTourMutation, CreateTourMutationVariables>(CreateTourDocument, options);
      }
export type CreateTourMutationHookResult = ReturnType<typeof useCreateTourMutation>;
export type CreateTourMutationResult = Apollo.MutationResult<CreateTourMutation>;
export type CreateTourMutationOptions = Apollo.BaseMutationOptions<CreateTourMutation, CreateTourMutationVariables>;
export const UpdateTourDocument = gql`
    mutation UPDATE_TOUR($_id: ID!, $input: UpdateTourInput!) {
  updateTour(_id: $_id, input: $input) {
    ...TourFragment
  }
}
    ${TourFragmentFragmentDoc}`;
export type UpdateTourMutationFn = Apollo.MutationFunction<UpdateTourMutation, UpdateTourMutationVariables>;

/**
 * __useUpdateTourMutation__
 *
 * To run a mutation, you first call `useUpdateTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTourMutation, { data, loading, error }] = useUpdateTourMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTourMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTourMutation, UpdateTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTourMutation, UpdateTourMutationVariables>(UpdateTourDocument, options);
      }
export type UpdateTourMutationHookResult = ReturnType<typeof useUpdateTourMutation>;
export type UpdateTourMutationResult = Apollo.MutationResult<UpdateTourMutation>;
export type UpdateTourMutationOptions = Apollo.BaseMutationOptions<UpdateTourMutation, UpdateTourMutationVariables>;
export const UpdateTourStateDocument = gql`
    mutation UPDATE_TOUR_STATE($_id: ID!, $state: TourState!) {
  updateTourState(_id: $_id, state: $state) {
    ...TourFragment
    stateHistory {
      state
      createdAt
      createdBy
      createdByName
    }
  }
}
    ${TourFragmentFragmentDoc}`;
export type UpdateTourStateMutationFn = Apollo.MutationFunction<UpdateTourStateMutation, UpdateTourStateMutationVariables>;

/**
 * __useUpdateTourStateMutation__
 *
 * To run a mutation, you first call `useUpdateTourStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTourStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTourStateMutation, { data, loading, error }] = useUpdateTourStateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateTourStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTourStateMutation, UpdateTourStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTourStateMutation, UpdateTourStateMutationVariables>(UpdateTourStateDocument, options);
      }
export type UpdateTourStateMutationHookResult = ReturnType<typeof useUpdateTourStateMutation>;
export type UpdateTourStateMutationResult = Apollo.MutationResult<UpdateTourStateMutation>;
export type UpdateTourStateMutationOptions = Apollo.BaseMutationOptions<UpdateTourStateMutation, UpdateTourStateMutationVariables>;
export const CreateTaskDocument = gql`
    mutation CREATE_TASK($input: CreateTaskInput!) {
  createTask(input: $input) {
    success
    error
    task {
      ...TourTaskFragment
    }
  }
}
    ${TourTaskFragmentFragmentDoc}`;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UPDATE_TASK($taskId: ID!, $input: UpdateTaskInput!) {
  updateTask(taskId: $taskId, input: $input) {
    success
    error
    task {
      ...TourTaskFragment
    }
  }
}
    ${TourTaskFragmentFragmentDoc}`;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const RefundTransactionDocument = gql`
    mutation REFUND_TRANSACTION($transactionId: ID!, $refundReason: String, $shouldUpdateProductStock: Boolean!) {
  refundTransaction(
    transactionId: $transactionId
    refundReason: $refundReason
    shouldUpdateProductStock: $shouldUpdateProductStock
  ) {
    ...DetailedTransactionFragment
  }
}
    ${DetailedTransactionFragmentFragmentDoc}`;
export type RefundTransactionMutationFn = Apollo.MutationFunction<RefundTransactionMutation, RefundTransactionMutationVariables>;

/**
 * __useRefundTransactionMutation__
 *
 * To run a mutation, you first call `useRefundTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundTransactionMutation, { data, loading, error }] = useRefundTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      refundReason: // value for 'refundReason'
 *      shouldUpdateProductStock: // value for 'shouldUpdateProductStock'
 *   },
 * });
 */
export function useRefundTransactionMutation(baseOptions?: Apollo.MutationHookOptions<RefundTransactionMutation, RefundTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundTransactionMutation, RefundTransactionMutationVariables>(RefundTransactionDocument, options);
      }
export type RefundTransactionMutationHookResult = ReturnType<typeof useRefundTransactionMutation>;
export type RefundTransactionMutationResult = Apollo.MutationResult<RefundTransactionMutation>;
export type RefundTransactionMutationOptions = Apollo.BaseMutationOptions<RefundTransactionMutation, RefundTransactionMutationVariables>;
export const UpdateTrayLocationLevelDocument = gql`
    mutation UPDATE_TRAY_LOCATION_LEVEL($trayCapacityId: ID!, $microstoreLocationId: String!, $currentLevel: Int!) {
  updateTrayLocationLevel(
    trayCapacityId: $trayCapacityId
    microstoreLocationId: $microstoreLocationId
    currentLevel: $currentLevel
  ) {
    success
    error
    trayCapacity {
      ...TrayCapacityMutationFragment
    }
  }
}
    ${TrayCapacityMutationFragmentFragmentDoc}`;
export type UpdateTrayLocationLevelMutationFn = Apollo.MutationFunction<UpdateTrayLocationLevelMutation, UpdateTrayLocationLevelMutationVariables>;

/**
 * __useUpdateTrayLocationLevelMutation__
 *
 * To run a mutation, you first call `useUpdateTrayLocationLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrayLocationLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrayLocationLevelMutation, { data, loading, error }] = useUpdateTrayLocationLevelMutation({
 *   variables: {
 *      trayCapacityId: // value for 'trayCapacityId'
 *      microstoreLocationId: // value for 'microstoreLocationId'
 *      currentLevel: // value for 'currentLevel'
 *   },
 * });
 */
export function useUpdateTrayLocationLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrayLocationLevelMutation, UpdateTrayLocationLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrayLocationLevelMutation, UpdateTrayLocationLevelMutationVariables>(UpdateTrayLocationLevelDocument, options);
      }
export type UpdateTrayLocationLevelMutationHookResult = ReturnType<typeof useUpdateTrayLocationLevelMutation>;
export type UpdateTrayLocationLevelMutationResult = Apollo.MutationResult<UpdateTrayLocationLevelMutation>;
export type UpdateTrayLocationLevelMutationOptions = Apollo.BaseMutationOptions<UpdateTrayLocationLevelMutation, UpdateTrayLocationLevelMutationVariables>;
export const CreateUrbantzRoundPresetDocument = gql`
    mutation CREATE_URBANTZ_ROUND_PRESET($dayIndex: Int!) {
  createUrbantzRoundPreset(dayIndex: $dayIndex) {
    ...UrbantzRoundPresetFragment
  }
}
    ${UrbantzRoundPresetFragmentFragmentDoc}`;
export type CreateUrbantzRoundPresetMutationFn = Apollo.MutationFunction<CreateUrbantzRoundPresetMutation, CreateUrbantzRoundPresetMutationVariables>;

/**
 * __useCreateUrbantzRoundPresetMutation__
 *
 * To run a mutation, you first call `useCreateUrbantzRoundPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUrbantzRoundPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUrbantzRoundPresetMutation, { data, loading, error }] = useCreateUrbantzRoundPresetMutation({
 *   variables: {
 *      dayIndex: // value for 'dayIndex'
 *   },
 * });
 */
export function useCreateUrbantzRoundPresetMutation(baseOptions?: Apollo.MutationHookOptions<CreateUrbantzRoundPresetMutation, CreateUrbantzRoundPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUrbantzRoundPresetMutation, CreateUrbantzRoundPresetMutationVariables>(CreateUrbantzRoundPresetDocument, options);
      }
export type CreateUrbantzRoundPresetMutationHookResult = ReturnType<typeof useCreateUrbantzRoundPresetMutation>;
export type CreateUrbantzRoundPresetMutationResult = Apollo.MutationResult<CreateUrbantzRoundPresetMutation>;
export type CreateUrbantzRoundPresetMutationOptions = Apollo.BaseMutationOptions<CreateUrbantzRoundPresetMutation, CreateUrbantzRoundPresetMutationVariables>;
export const UpdateUrbantzRoundPresetDocument = gql`
    mutation UPDATE_URBANTZ_ROUND_PRESET($urbantzRoundPresetUpdateInput: UrbantzRoundPresetUpdateInput!) {
  updateUrbantzRoundPreset(
    urbantzRoundPresetUpdateInput: $urbantzRoundPresetUpdateInput
  ) {
    ...UrbantzRoundPresetFragment
  }
}
    ${UrbantzRoundPresetFragmentFragmentDoc}`;
export type UpdateUrbantzRoundPresetMutationFn = Apollo.MutationFunction<UpdateUrbantzRoundPresetMutation, UpdateUrbantzRoundPresetMutationVariables>;

/**
 * __useUpdateUrbantzRoundPresetMutation__
 *
 * To run a mutation, you first call `useUpdateUrbantzRoundPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUrbantzRoundPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUrbantzRoundPresetMutation, { data, loading, error }] = useUpdateUrbantzRoundPresetMutation({
 *   variables: {
 *      urbantzRoundPresetUpdateInput: // value for 'urbantzRoundPresetUpdateInput'
 *   },
 * });
 */
export function useUpdateUrbantzRoundPresetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUrbantzRoundPresetMutation, UpdateUrbantzRoundPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUrbantzRoundPresetMutation, UpdateUrbantzRoundPresetMutationVariables>(UpdateUrbantzRoundPresetDocument, options);
      }
export type UpdateUrbantzRoundPresetMutationHookResult = ReturnType<typeof useUpdateUrbantzRoundPresetMutation>;
export type UpdateUrbantzRoundPresetMutationResult = Apollo.MutationResult<UpdateUrbantzRoundPresetMutation>;
export type UpdateUrbantzRoundPresetMutationOptions = Apollo.BaseMutationOptions<UpdateUrbantzRoundPresetMutation, UpdateUrbantzRoundPresetMutationVariables>;
export const DeleteUrbantzRoundPresetDocument = gql`
    mutation DELETE_URBANTZ_ROUND_PRESET($urbantzRoundPresetId: ID!) {
  deleteUrbantzRoundPreset(urbantzRoundPresetId: $urbantzRoundPresetId)
}
    `;
export type DeleteUrbantzRoundPresetMutationFn = Apollo.MutationFunction<DeleteUrbantzRoundPresetMutation, DeleteUrbantzRoundPresetMutationVariables>;

/**
 * __useDeleteUrbantzRoundPresetMutation__
 *
 * To run a mutation, you first call `useDeleteUrbantzRoundPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUrbantzRoundPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUrbantzRoundPresetMutation, { data, loading, error }] = useDeleteUrbantzRoundPresetMutation({
 *   variables: {
 *      urbantzRoundPresetId: // value for 'urbantzRoundPresetId'
 *   },
 * });
 */
export function useDeleteUrbantzRoundPresetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUrbantzRoundPresetMutation, DeleteUrbantzRoundPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUrbantzRoundPresetMutation, DeleteUrbantzRoundPresetMutationVariables>(DeleteUrbantzRoundPresetDocument, options);
      }
export type DeleteUrbantzRoundPresetMutationHookResult = ReturnType<typeof useDeleteUrbantzRoundPresetMutation>;
export type DeleteUrbantzRoundPresetMutationResult = Apollo.MutationResult<DeleteUrbantzRoundPresetMutation>;
export type DeleteUrbantzRoundPresetMutationOptions = Apollo.BaseMutationOptions<DeleteUrbantzRoundPresetMutation, DeleteUrbantzRoundPresetMutationVariables>;
export const SigninTotemAdminDocument = gql`
    mutation SIGNIN_TOTEM_ADMIN($username: String!, $password: String!) {
  signinTotemAdmin(username: $username, password: $password) {
    success
    error
    token
    refreshToken
    user {
      ...LoggedInUserFragment
    }
  }
}
    ${LoggedInUserFragmentFragmentDoc}`;
export type SigninTotemAdminMutationFn = Apollo.MutationFunction<SigninTotemAdminMutation, SigninTotemAdminMutationVariables>;

/**
 * __useSigninTotemAdminMutation__
 *
 * To run a mutation, you first call `useSigninTotemAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninTotemAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinTotemAdminMutation, { data, loading, error }] = useSigninTotemAdminMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSigninTotemAdminMutation(baseOptions?: Apollo.MutationHookOptions<SigninTotemAdminMutation, SigninTotemAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SigninTotemAdminMutation, SigninTotemAdminMutationVariables>(SigninTotemAdminDocument, options);
      }
export type SigninTotemAdminMutationHookResult = ReturnType<typeof useSigninTotemAdminMutation>;
export type SigninTotemAdminMutationResult = Apollo.MutationResult<SigninTotemAdminMutation>;
export type SigninTotemAdminMutationOptions = Apollo.BaseMutationOptions<SigninTotemAdminMutation, SigninTotemAdminMutationVariables>;
export const SigninTotemAdminSsoDocument = gql`
    mutation SIGNIN_TOTEM_ADMIN_SSO($code: String!) {
  signinTotemAdminSSO(code: $code) {
    success
    error
    token
    refreshToken
    user {
      ...LoggedInUserFragment
    }
  }
}
    ${LoggedInUserFragmentFragmentDoc}`;
export type SigninTotemAdminSsoMutationFn = Apollo.MutationFunction<SigninTotemAdminSsoMutation, SigninTotemAdminSsoMutationVariables>;

/**
 * __useSigninTotemAdminSsoMutation__
 *
 * To run a mutation, you first call `useSigninTotemAdminSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninTotemAdminSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinTotemAdminSsoMutation, { data, loading, error }] = useSigninTotemAdminSsoMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSigninTotemAdminSsoMutation(baseOptions?: Apollo.MutationHookOptions<SigninTotemAdminSsoMutation, SigninTotemAdminSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SigninTotemAdminSsoMutation, SigninTotemAdminSsoMutationVariables>(SigninTotemAdminSsoDocument, options);
      }
export type SigninTotemAdminSsoMutationHookResult = ReturnType<typeof useSigninTotemAdminSsoMutation>;
export type SigninTotemAdminSsoMutationResult = Apollo.MutationResult<SigninTotemAdminSsoMutation>;
export type SigninTotemAdminSsoMutationOptions = Apollo.BaseMutationOptions<SigninTotemAdminSsoMutation, SigninTotemAdminSsoMutationVariables>;
export const VerifyLoggedInDocument = gql`
    mutation VERIFY_LOGGED_IN {
  verifyLoggedIn {
    success
    user {
      ...LoggedInUserFragment
    }
  }
}
    ${LoggedInUserFragmentFragmentDoc}`;
export type VerifyLoggedInMutationFn = Apollo.MutationFunction<VerifyLoggedInMutation, VerifyLoggedInMutationVariables>;

/**
 * __useVerifyLoggedInMutation__
 *
 * To run a mutation, you first call `useVerifyLoggedInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyLoggedInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyLoggedInMutation, { data, loading, error }] = useVerifyLoggedInMutation({
 *   variables: {
 *   },
 * });
 */
export function useVerifyLoggedInMutation(baseOptions?: Apollo.MutationHookOptions<VerifyLoggedInMutation, VerifyLoggedInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyLoggedInMutation, VerifyLoggedInMutationVariables>(VerifyLoggedInDocument, options);
      }
export type VerifyLoggedInMutationHookResult = ReturnType<typeof useVerifyLoggedInMutation>;
export type VerifyLoggedInMutationResult = Apollo.MutationResult<VerifyLoggedInMutation>;
export type VerifyLoggedInMutationOptions = Apollo.BaseMutationOptions<VerifyLoggedInMutation, VerifyLoggedInMutationVariables>;
export const UpdateAdminUserDocument = gql`
    mutation UPDATE_ADMIN_USER($fieldsToUpdate: UserUpdateInput!, $userId: ID!) {
  updateAdminUser(fieldsToUpdate: $fieldsToUpdate, userId: $userId) {
    success
    error
    user {
      ...AdminUserFragment
    }
  }
}
    ${AdminUserFragmentFragmentDoc}`;
export type UpdateAdminUserMutationFn = Apollo.MutationFunction<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>;

/**
 * __useUpdateAdminUserMutation__
 *
 * To run a mutation, you first call `useUpdateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminUserMutation, { data, loading, error }] = useUpdateAdminUserMutation({
 *   variables: {
 *      fieldsToUpdate: // value for 'fieldsToUpdate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>(UpdateAdminUserDocument, options);
      }
export type UpdateAdminUserMutationHookResult = ReturnType<typeof useUpdateAdminUserMutation>;
export type UpdateAdminUserMutationResult = Apollo.MutationResult<UpdateAdminUserMutation>;
export type UpdateAdminUserMutationOptions = Apollo.BaseMutationOptions<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>;
export const ToggleUserNotificationPreferenceFromAdminDocument = gql`
    mutation TOGGLE_USER_NOTIFICATION_PREFERENCE_FROM_ADMIN($notificationPreference: String!, $channel: String!, $userId: ID!) {
  toggleUserNotificationPreferenceFromAdmin(
    notificationPreference: $notificationPreference
    channel: $channel
    userId: $userId
  ) {
    ...NotificationPreferences
  }
}
    ${NotificationPreferencesFragmentDoc}`;
export type ToggleUserNotificationPreferenceFromAdminMutationFn = Apollo.MutationFunction<ToggleUserNotificationPreferenceFromAdminMutation, ToggleUserNotificationPreferenceFromAdminMutationVariables>;

/**
 * __useToggleUserNotificationPreferenceFromAdminMutation__
 *
 * To run a mutation, you first call `useToggleUserNotificationPreferenceFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserNotificationPreferenceFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserNotificationPreferenceFromAdminMutation, { data, loading, error }] = useToggleUserNotificationPreferenceFromAdminMutation({
 *   variables: {
 *      notificationPreference: // value for 'notificationPreference'
 *      channel: // value for 'channel'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useToggleUserNotificationPreferenceFromAdminMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserNotificationPreferenceFromAdminMutation, ToggleUserNotificationPreferenceFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserNotificationPreferenceFromAdminMutation, ToggleUserNotificationPreferenceFromAdminMutationVariables>(ToggleUserNotificationPreferenceFromAdminDocument, options);
      }
export type ToggleUserNotificationPreferenceFromAdminMutationHookResult = ReturnType<typeof useToggleUserNotificationPreferenceFromAdminMutation>;
export type ToggleUserNotificationPreferenceFromAdminMutationResult = Apollo.MutationResult<ToggleUserNotificationPreferenceFromAdminMutation>;
export type ToggleUserNotificationPreferenceFromAdminMutationOptions = Apollo.BaseMutationOptions<ToggleUserNotificationPreferenceFromAdminMutation, ToggleUserNotificationPreferenceFromAdminMutationVariables>;
export const CreateToteamUserDocument = gql`
    mutation CREATE_TOTEAM_USER($firstname: String!, $lastname: String!, $emailAddress: String!, $role: InternalUserRole!) {
  createToteamUserResolver(
    firstname: $firstname
    lastname: $lastname
    emailAddress: $emailAddress
    role: $role
  ) {
    user {
      _id
    }
    success
    error
  }
}
    `;
export type CreateToteamUserMutationFn = Apollo.MutationFunction<CreateToteamUserMutation, CreateToteamUserMutationVariables>;

/**
 * __useCreateToteamUserMutation__
 *
 * To run a mutation, you first call `useCreateToteamUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateToteamUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createToteamUserMutation, { data, loading, error }] = useCreateToteamUserMutation({
 *   variables: {
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      emailAddress: // value for 'emailAddress'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreateToteamUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateToteamUserMutation, CreateToteamUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateToteamUserMutation, CreateToteamUserMutationVariables>(CreateToteamUserDocument, options);
      }
export type CreateToteamUserMutationHookResult = ReturnType<typeof useCreateToteamUserMutation>;
export type CreateToteamUserMutationResult = Apollo.MutationResult<CreateToteamUserMutation>;
export type CreateToteamUserMutationOptions = Apollo.BaseMutationOptions<CreateToteamUserMutation, CreateToteamUserMutationVariables>;
export const SendResetPasswordDocument = gql`
    mutation SEND_RESET_PASSWORD($emailAddress: String!, $appName: String) {
  sendResetPassword(emailAddress: $emailAddress, appName: $appName) {
    success
    error
  }
}
    `;
export type SendResetPasswordMutationFn = Apollo.MutationFunction<SendResetPasswordMutation, SendResetPasswordMutationVariables>;

/**
 * __useSendResetPasswordMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordMutation, { data, loading, error }] = useSendResetPasswordMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      appName: // value for 'appName'
 *   },
 * });
 */
export function useSendResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordMutation, SendResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordMutation, SendResetPasswordMutationVariables>(SendResetPasswordDocument, options);
      }
export type SendResetPasswordMutationHookResult = ReturnType<typeof useSendResetPasswordMutation>;
export type SendResetPasswordMutationResult = Apollo.MutationResult<SendResetPasswordMutation>;
export type SendResetPasswordMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordMutation, SendResetPasswordMutationVariables>;
export const AuthenticateUserResetDocument = gql`
    mutation AUTHENTICATE_USER_RESET($token: String!) {
  authenticateUserReset(token: $token) {
    success
    error
  }
}
    `;
export type AuthenticateUserResetMutationFn = Apollo.MutationFunction<AuthenticateUserResetMutation, AuthenticateUserResetMutationVariables>;

/**
 * __useAuthenticateUserResetMutation__
 *
 * To run a mutation, you first call `useAuthenticateUserResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateUserResetMutation, { data, loading, error }] = useAuthenticateUserResetMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAuthenticateUserResetMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateUserResetMutation, AuthenticateUserResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateUserResetMutation, AuthenticateUserResetMutationVariables>(AuthenticateUserResetDocument, options);
      }
export type AuthenticateUserResetMutationHookResult = ReturnType<typeof useAuthenticateUserResetMutation>;
export type AuthenticateUserResetMutationResult = Apollo.MutationResult<AuthenticateUserResetMutation>;
export type AuthenticateUserResetMutationOptions = Apollo.BaseMutationOptions<AuthenticateUserResetMutation, AuthenticateUserResetMutationVariables>;
export const AuthenticateUserDocument = gql`
    mutation AUTHENTICATE_USER($token: String!) {
  authenticateUser(token: $token) {
    success
    error
  }
}
    `;
export type AuthenticateUserMutationFn = Apollo.MutationFunction<AuthenticateUserMutation, AuthenticateUserMutationVariables>;

/**
 * __useAuthenticateUserMutation__
 *
 * To run a mutation, you first call `useAuthenticateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateUserMutation, { data, loading, error }] = useAuthenticateUserMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAuthenticateUserMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateUserMutation, AuthenticateUserMutationVariables>(AuthenticateUserDocument, options);
      }
export type AuthenticateUserMutationHookResult = ReturnType<typeof useAuthenticateUserMutation>;
export type AuthenticateUserMutationResult = Apollo.MutationResult<AuthenticateUserMutation>;
export type AuthenticateUserMutationOptions = Apollo.BaseMutationOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation CHANGE_PASSWORD($password: String!) {
  changePassword(password: $password) {
    success
    error
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const SetPasswordDocument = gql`
    mutation SET_PASSWORD($password: String!, $token: String!) {
  setUserPassword(password: $password, token: $token) {
    success
    error
    token
    refreshToken
    user {
      _id
      permissions {
        totemId
        userGroup
      }
    }
  }
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const ResendEmailVerificationEmailDocument = gql`
    mutation RESEND_EMAIL_VERIFICATION_EMAIL($emailToVerify: String!) {
  resendEmailVerificationEmail(emailToVerify: $emailToVerify) {
    success
    error
  }
}
    `;
export type ResendEmailVerificationEmailMutationFn = Apollo.MutationFunction<ResendEmailVerificationEmailMutation, ResendEmailVerificationEmailMutationVariables>;

/**
 * __useResendEmailVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationEmailMutation, { data, loading, error }] = useResendEmailVerificationEmailMutation({
 *   variables: {
 *      emailToVerify: // value for 'emailToVerify'
 *   },
 * });
 */
export function useResendEmailVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmailVerificationEmailMutation, ResendEmailVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmailVerificationEmailMutation, ResendEmailVerificationEmailMutationVariables>(ResendEmailVerificationEmailDocument, options);
      }
export type ResendEmailVerificationEmailMutationHookResult = ReturnType<typeof useResendEmailVerificationEmailMutation>;
export type ResendEmailVerificationEmailMutationResult = Apollo.MutationResult<ResendEmailVerificationEmailMutation>;
export type ResendEmailVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendEmailVerificationEmailMutation, ResendEmailVerificationEmailMutationVariables>;
export const BeginWarehouseDeliveryPreparationDocument = gql`
    mutation BEGIN_WAREHOUSE_DELIVERY_PREPARATION($warehouseDeliveryId: String!) {
  beginWarehouseDelivery(warehouseDeliveryId: $warehouseDeliveryId) {
    warehouseDelivery {
      ...WarehouseDeliveryFragment
    }
    success
    error
  }
}
    ${WarehouseDeliveryFragmentFragmentDoc}`;
export type BeginWarehouseDeliveryPreparationMutationFn = Apollo.MutationFunction<BeginWarehouseDeliveryPreparationMutation, BeginWarehouseDeliveryPreparationMutationVariables>;

/**
 * __useBeginWarehouseDeliveryPreparationMutation__
 *
 * To run a mutation, you first call `useBeginWarehouseDeliveryPreparationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBeginWarehouseDeliveryPreparationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [beginWarehouseDeliveryPreparationMutation, { data, loading, error }] = useBeginWarehouseDeliveryPreparationMutation({
 *   variables: {
 *      warehouseDeliveryId: // value for 'warehouseDeliveryId'
 *   },
 * });
 */
export function useBeginWarehouseDeliveryPreparationMutation(baseOptions?: Apollo.MutationHookOptions<BeginWarehouseDeliveryPreparationMutation, BeginWarehouseDeliveryPreparationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BeginWarehouseDeliveryPreparationMutation, BeginWarehouseDeliveryPreparationMutationVariables>(BeginWarehouseDeliveryPreparationDocument, options);
      }
export type BeginWarehouseDeliveryPreparationMutationHookResult = ReturnType<typeof useBeginWarehouseDeliveryPreparationMutation>;
export type BeginWarehouseDeliveryPreparationMutationResult = Apollo.MutationResult<BeginWarehouseDeliveryPreparationMutation>;
export type BeginWarehouseDeliveryPreparationMutationOptions = Apollo.BaseMutationOptions<BeginWarehouseDeliveryPreparationMutation, BeginWarehouseDeliveryPreparationMutationVariables>;
export const FinishWarehouseDeliveryPreparationDocument = gql`
    mutation FINISH_WAREHOUSE_DELIVERY_PREPARATION($warehouseDeliveryId: String!) {
  finishWarehouseDelivery(warehouseDeliveryId: $warehouseDeliveryId) {
    warehouseDelivery {
      ...WarehouseDeliveryFragment
    }
    success
    error
  }
}
    ${WarehouseDeliveryFragmentFragmentDoc}`;
export type FinishWarehouseDeliveryPreparationMutationFn = Apollo.MutationFunction<FinishWarehouseDeliveryPreparationMutation, FinishWarehouseDeliveryPreparationMutationVariables>;

/**
 * __useFinishWarehouseDeliveryPreparationMutation__
 *
 * To run a mutation, you first call `useFinishWarehouseDeliveryPreparationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishWarehouseDeliveryPreparationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishWarehouseDeliveryPreparationMutation, { data, loading, error }] = useFinishWarehouseDeliveryPreparationMutation({
 *   variables: {
 *      warehouseDeliveryId: // value for 'warehouseDeliveryId'
 *   },
 * });
 */
export function useFinishWarehouseDeliveryPreparationMutation(baseOptions?: Apollo.MutationHookOptions<FinishWarehouseDeliveryPreparationMutation, FinishWarehouseDeliveryPreparationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishWarehouseDeliveryPreparationMutation, FinishWarehouseDeliveryPreparationMutationVariables>(FinishWarehouseDeliveryPreparationDocument, options);
      }
export type FinishWarehouseDeliveryPreparationMutationHookResult = ReturnType<typeof useFinishWarehouseDeliveryPreparationMutation>;
export type FinishWarehouseDeliveryPreparationMutationResult = Apollo.MutationResult<FinishWarehouseDeliveryPreparationMutation>;
export type FinishWarehouseDeliveryPreparationMutationOptions = Apollo.BaseMutationOptions<FinishWarehouseDeliveryPreparationMutation, FinishWarehouseDeliveryPreparationMutationVariables>;
export const MarkWarehouseDeliveryAsInProgressDocument = gql`
    mutation MARK_WAREHOUSE_DELIVERY_AS_IN_PROGRESS($warehouseDeliveryId: String!) {
  markWarehouseDeliveryAsInProgress(warehouseDeliveryId: $warehouseDeliveryId) {
    warehouseDelivery {
      ...WarehouseDeliveryFragment
    }
    success
    error
  }
}
    ${WarehouseDeliveryFragmentFragmentDoc}`;
export type MarkWarehouseDeliveryAsInProgressMutationFn = Apollo.MutationFunction<MarkWarehouseDeliveryAsInProgressMutation, MarkWarehouseDeliveryAsInProgressMutationVariables>;

/**
 * __useMarkWarehouseDeliveryAsInProgressMutation__
 *
 * To run a mutation, you first call `useMarkWarehouseDeliveryAsInProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkWarehouseDeliveryAsInProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markWarehouseDeliveryAsInProgressMutation, { data, loading, error }] = useMarkWarehouseDeliveryAsInProgressMutation({
 *   variables: {
 *      warehouseDeliveryId: // value for 'warehouseDeliveryId'
 *   },
 * });
 */
export function useMarkWarehouseDeliveryAsInProgressMutation(baseOptions?: Apollo.MutationHookOptions<MarkWarehouseDeliveryAsInProgressMutation, MarkWarehouseDeliveryAsInProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkWarehouseDeliveryAsInProgressMutation, MarkWarehouseDeliveryAsInProgressMutationVariables>(MarkWarehouseDeliveryAsInProgressDocument, options);
      }
export type MarkWarehouseDeliveryAsInProgressMutationHookResult = ReturnType<typeof useMarkWarehouseDeliveryAsInProgressMutation>;
export type MarkWarehouseDeliveryAsInProgressMutationResult = Apollo.MutationResult<MarkWarehouseDeliveryAsInProgressMutation>;
export type MarkWarehouseDeliveryAsInProgressMutationOptions = Apollo.BaseMutationOptions<MarkWarehouseDeliveryAsInProgressMutation, MarkWarehouseDeliveryAsInProgressMutationVariables>;
export const MarkWarehouseDeliveryAsDeliveredDocument = gql`
    mutation MARK_WAREHOUSE_DELIVERY_AS_DELIVERED($warehouseDeliveryId: String!) {
  markWarehouseDeliveryAsDelivered(warehouseDeliveryId: $warehouseDeliveryId) {
    warehouseDelivery {
      ...WarehouseDeliveryFragment
    }
    success
    error
  }
}
    ${WarehouseDeliveryFragmentFragmentDoc}`;
export type MarkWarehouseDeliveryAsDeliveredMutationFn = Apollo.MutationFunction<MarkWarehouseDeliveryAsDeliveredMutation, MarkWarehouseDeliveryAsDeliveredMutationVariables>;

/**
 * __useMarkWarehouseDeliveryAsDeliveredMutation__
 *
 * To run a mutation, you first call `useMarkWarehouseDeliveryAsDeliveredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkWarehouseDeliveryAsDeliveredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markWarehouseDeliveryAsDeliveredMutation, { data, loading, error }] = useMarkWarehouseDeliveryAsDeliveredMutation({
 *   variables: {
 *      warehouseDeliveryId: // value for 'warehouseDeliveryId'
 *   },
 * });
 */
export function useMarkWarehouseDeliveryAsDeliveredMutation(baseOptions?: Apollo.MutationHookOptions<MarkWarehouseDeliveryAsDeliveredMutation, MarkWarehouseDeliveryAsDeliveredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkWarehouseDeliveryAsDeliveredMutation, MarkWarehouseDeliveryAsDeliveredMutationVariables>(MarkWarehouseDeliveryAsDeliveredDocument, options);
      }
export type MarkWarehouseDeliveryAsDeliveredMutationHookResult = ReturnType<typeof useMarkWarehouseDeliveryAsDeliveredMutation>;
export type MarkWarehouseDeliveryAsDeliveredMutationResult = Apollo.MutationResult<MarkWarehouseDeliveryAsDeliveredMutation>;
export type MarkWarehouseDeliveryAsDeliveredMutationOptions = Apollo.BaseMutationOptions<MarkWarehouseDeliveryAsDeliveredMutation, MarkWarehouseDeliveryAsDeliveredMutationVariables>;
export const ArchiveWarehouseDeliveryDocument = gql`
    mutation ARCHIVE_WAREHOUSE_DELIVERY($warehouseDeliveryId: String!) {
  archiveWarehouseDelivery(warehouseDeliveryId: $warehouseDeliveryId) {
    warehouseDelivery {
      ...WarehouseDeliveryFragment
    }
    success
    error
  }
}
    ${WarehouseDeliveryFragmentFragmentDoc}`;
export type ArchiveWarehouseDeliveryMutationFn = Apollo.MutationFunction<ArchiveWarehouseDeliveryMutation, ArchiveWarehouseDeliveryMutationVariables>;

/**
 * __useArchiveWarehouseDeliveryMutation__
 *
 * To run a mutation, you first call `useArchiveWarehouseDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWarehouseDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWarehouseDeliveryMutation, { data, loading, error }] = useArchiveWarehouseDeliveryMutation({
 *   variables: {
 *      warehouseDeliveryId: // value for 'warehouseDeliveryId'
 *   },
 * });
 */
export function useArchiveWarehouseDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveWarehouseDeliveryMutation, ArchiveWarehouseDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveWarehouseDeliveryMutation, ArchiveWarehouseDeliveryMutationVariables>(ArchiveWarehouseDeliveryDocument, options);
      }
export type ArchiveWarehouseDeliveryMutationHookResult = ReturnType<typeof useArchiveWarehouseDeliveryMutation>;
export type ArchiveWarehouseDeliveryMutationResult = Apollo.MutationResult<ArchiveWarehouseDeliveryMutation>;
export type ArchiveWarehouseDeliveryMutationOptions = Apollo.BaseMutationOptions<ArchiveWarehouseDeliveryMutation, ArchiveWarehouseDeliveryMutationVariables>;
export const AbortWarehouseDeliveryDocument = gql`
    mutation ABORT_WAREHOUSE_DELIVERY($warehouseDeliveryId: String!) {
  abortWarehouseDelivery(warehouseDeliveryId: $warehouseDeliveryId) {
    warehouseDelivery {
      ...WarehouseDeliveryFragment
    }
    success
    error
  }
}
    ${WarehouseDeliveryFragmentFragmentDoc}`;
export type AbortWarehouseDeliveryMutationFn = Apollo.MutationFunction<AbortWarehouseDeliveryMutation, AbortWarehouseDeliveryMutationVariables>;

/**
 * __useAbortWarehouseDeliveryMutation__
 *
 * To run a mutation, you first call `useAbortWarehouseDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortWarehouseDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortWarehouseDeliveryMutation, { data, loading, error }] = useAbortWarehouseDeliveryMutation({
 *   variables: {
 *      warehouseDeliveryId: // value for 'warehouseDeliveryId'
 *   },
 * });
 */
export function useAbortWarehouseDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<AbortWarehouseDeliveryMutation, AbortWarehouseDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortWarehouseDeliveryMutation, AbortWarehouseDeliveryMutationVariables>(AbortWarehouseDeliveryDocument, options);
      }
export type AbortWarehouseDeliveryMutationHookResult = ReturnType<typeof useAbortWarehouseDeliveryMutation>;
export type AbortWarehouseDeliveryMutationResult = Apollo.MutationResult<AbortWarehouseDeliveryMutation>;
export type AbortWarehouseDeliveryMutationOptions = Apollo.BaseMutationOptions<AbortWarehouseDeliveryMutation, AbortWarehouseDeliveryMutationVariables>;
export const UpdateWarehouseDeliveriesStateDocument = gql`
    mutation UPDATE_WAREHOUSE_DELIVERIES_STATE($warehouseDeliveryIds: [String!]!, $state: DeliveryState!) {
  updateWarehouseDeliveriesState(
    warehouseDeliveryIds: $warehouseDeliveryIds
    state: $state
  ) {
    warehouseDeliveries {
      ...WarehouseDeliveryFragment
    }
    success
    errors
  }
}
    ${WarehouseDeliveryFragmentFragmentDoc}`;
export type UpdateWarehouseDeliveriesStateMutationFn = Apollo.MutationFunction<UpdateWarehouseDeliveriesStateMutation, UpdateWarehouseDeliveriesStateMutationVariables>;

/**
 * __useUpdateWarehouseDeliveriesStateMutation__
 *
 * To run a mutation, you first call `useUpdateWarehouseDeliveriesStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarehouseDeliveriesStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWarehouseDeliveriesStateMutation, { data, loading, error }] = useUpdateWarehouseDeliveriesStateMutation({
 *   variables: {
 *      warehouseDeliveryIds: // value for 'warehouseDeliveryIds'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateWarehouseDeliveriesStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWarehouseDeliveriesStateMutation, UpdateWarehouseDeliveriesStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWarehouseDeliveriesStateMutation, UpdateWarehouseDeliveriesStateMutationVariables>(UpdateWarehouseDeliveriesStateDocument, options);
      }
export type UpdateWarehouseDeliveriesStateMutationHookResult = ReturnType<typeof useUpdateWarehouseDeliveriesStateMutation>;
export type UpdateWarehouseDeliveriesStateMutationResult = Apollo.MutationResult<UpdateWarehouseDeliveriesStateMutation>;
export type UpdateWarehouseDeliveriesStateMutationOptions = Apollo.BaseMutationOptions<UpdateWarehouseDeliveriesStateMutation, UpdateWarehouseDeliveriesStateMutationVariables>;
export const UpdateWarehouseDeliveryDocument = gql`
    mutation UPDATE_WAREHOUSE_DELIVERY($warehouseDeliveryId: String!, $warehouseDeliveryInput: WarehouseDeliveryInput!) {
  updateWarehouseDelivery(
    warehouseDeliveryId: $warehouseDeliveryId
    warehouseDeliveryInput: $warehouseDeliveryInput
  ) {
    warehouseDelivery {
      ...WarehouseDeliveryFragment
    }
  }
}
    ${WarehouseDeliveryFragmentFragmentDoc}`;
export type UpdateWarehouseDeliveryMutationFn = Apollo.MutationFunction<UpdateWarehouseDeliveryMutation, UpdateWarehouseDeliveryMutationVariables>;

/**
 * __useUpdateWarehouseDeliveryMutation__
 *
 * To run a mutation, you first call `useUpdateWarehouseDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarehouseDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWarehouseDeliveryMutation, { data, loading, error }] = useUpdateWarehouseDeliveryMutation({
 *   variables: {
 *      warehouseDeliveryId: // value for 'warehouseDeliveryId'
 *      warehouseDeliveryInput: // value for 'warehouseDeliveryInput'
 *   },
 * });
 */
export function useUpdateWarehouseDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWarehouseDeliveryMutation, UpdateWarehouseDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWarehouseDeliveryMutation, UpdateWarehouseDeliveryMutationVariables>(UpdateWarehouseDeliveryDocument, options);
      }
export type UpdateWarehouseDeliveryMutationHookResult = ReturnType<typeof useUpdateWarehouseDeliveryMutation>;
export type UpdateWarehouseDeliveryMutationResult = Apollo.MutationResult<UpdateWarehouseDeliveryMutation>;
export type UpdateWarehouseDeliveryMutationOptions = Apollo.BaseMutationOptions<UpdateWarehouseDeliveryMutation, UpdateWarehouseDeliveryMutationVariables>;
export const PassWarehouseReturnToInProgressDocument = gql`
    mutation PASS_WAREHOUSE_RETURN_TO_IN_PROGRESS($warehouseReturnId: ID!) {
  passWarehouseReturnToInProgress(warehouseReturnId: $warehouseReturnId) {
    ...WarehouseReturnFragment
  }
}
    ${WarehouseReturnFragmentFragmentDoc}`;
export type PassWarehouseReturnToInProgressMutationFn = Apollo.MutationFunction<PassWarehouseReturnToInProgressMutation, PassWarehouseReturnToInProgressMutationVariables>;

/**
 * __usePassWarehouseReturnToInProgressMutation__
 *
 * To run a mutation, you first call `usePassWarehouseReturnToInProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePassWarehouseReturnToInProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passWarehouseReturnToInProgressMutation, { data, loading, error }] = usePassWarehouseReturnToInProgressMutation({
 *   variables: {
 *      warehouseReturnId: // value for 'warehouseReturnId'
 *   },
 * });
 */
export function usePassWarehouseReturnToInProgressMutation(baseOptions?: Apollo.MutationHookOptions<PassWarehouseReturnToInProgressMutation, PassWarehouseReturnToInProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PassWarehouseReturnToInProgressMutation, PassWarehouseReturnToInProgressMutationVariables>(PassWarehouseReturnToInProgressDocument, options);
      }
export type PassWarehouseReturnToInProgressMutationHookResult = ReturnType<typeof usePassWarehouseReturnToInProgressMutation>;
export type PassWarehouseReturnToInProgressMutationResult = Apollo.MutationResult<PassWarehouseReturnToInProgressMutation>;
export type PassWarehouseReturnToInProgressMutationOptions = Apollo.BaseMutationOptions<PassWarehouseReturnToInProgressMutation, PassWarehouseReturnToInProgressMutationVariables>;
export const PassWarehouseReturnToDeliveredDocument = gql`
    mutation PASS_WAREHOUSE_RETURN_TO_DELIVERED($warehouseReturnId: ID!) {
  passWarehouseReturnToDelivered(warehouseReturnId: $warehouseReturnId) {
    ...WarehouseReturnFragment
  }
}
    ${WarehouseReturnFragmentFragmentDoc}`;
export type PassWarehouseReturnToDeliveredMutationFn = Apollo.MutationFunction<PassWarehouseReturnToDeliveredMutation, PassWarehouseReturnToDeliveredMutationVariables>;

/**
 * __usePassWarehouseReturnToDeliveredMutation__
 *
 * To run a mutation, you first call `usePassWarehouseReturnToDeliveredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePassWarehouseReturnToDeliveredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passWarehouseReturnToDeliveredMutation, { data, loading, error }] = usePassWarehouseReturnToDeliveredMutation({
 *   variables: {
 *      warehouseReturnId: // value for 'warehouseReturnId'
 *   },
 * });
 */
export function usePassWarehouseReturnToDeliveredMutation(baseOptions?: Apollo.MutationHookOptions<PassWarehouseReturnToDeliveredMutation, PassWarehouseReturnToDeliveredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PassWarehouseReturnToDeliveredMutation, PassWarehouseReturnToDeliveredMutationVariables>(PassWarehouseReturnToDeliveredDocument, options);
      }
export type PassWarehouseReturnToDeliveredMutationHookResult = ReturnType<typeof usePassWarehouseReturnToDeliveredMutation>;
export type PassWarehouseReturnToDeliveredMutationResult = Apollo.MutationResult<PassWarehouseReturnToDeliveredMutation>;
export type PassWarehouseReturnToDeliveredMutationOptions = Apollo.BaseMutationOptions<PassWarehouseReturnToDeliveredMutation, PassWarehouseReturnToDeliveredMutationVariables>;
export const PassWarehouseReturnToStoredDocument = gql`
    mutation PASS_WAREHOUSE_RETURN_TO_STORED($warehouseReturnId: ID!) {
  passWarehouseReturnToStored(warehouseReturnId: $warehouseReturnId) {
    ...WarehouseReturnFragment
  }
}
    ${WarehouseReturnFragmentFragmentDoc}`;
export type PassWarehouseReturnToStoredMutationFn = Apollo.MutationFunction<PassWarehouseReturnToStoredMutation, PassWarehouseReturnToStoredMutationVariables>;

/**
 * __usePassWarehouseReturnToStoredMutation__
 *
 * To run a mutation, you first call `usePassWarehouseReturnToStoredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePassWarehouseReturnToStoredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passWarehouseReturnToStoredMutation, { data, loading, error }] = usePassWarehouseReturnToStoredMutation({
 *   variables: {
 *      warehouseReturnId: // value for 'warehouseReturnId'
 *   },
 * });
 */
export function usePassWarehouseReturnToStoredMutation(baseOptions?: Apollo.MutationHookOptions<PassWarehouseReturnToStoredMutation, PassWarehouseReturnToStoredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PassWarehouseReturnToStoredMutation, PassWarehouseReturnToStoredMutationVariables>(PassWarehouseReturnToStoredDocument, options);
      }
export type PassWarehouseReturnToStoredMutationHookResult = ReturnType<typeof usePassWarehouseReturnToStoredMutation>;
export type PassWarehouseReturnToStoredMutationResult = Apollo.MutationResult<PassWarehouseReturnToStoredMutation>;
export type PassWarehouseReturnToStoredMutationOptions = Apollo.BaseMutationOptions<PassWarehouseReturnToStoredMutation, PassWarehouseReturnToStoredMutationVariables>;
export const GetAdvertisementScreenConfigDocument = gql`
    query GET_ADVERTISEMENT_SCREEN_CONFIG {
  getAdvertisementScreenConfig {
    ...AdvertisementScreenConfigFragment
  }
}
    ${AdvertisementScreenConfigFragmentFragmentDoc}`;

/**
 * __useGetAdvertisementScreenConfigQuery__
 *
 * To run a query within a React component, call `useGetAdvertisementScreenConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvertisementScreenConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvertisementScreenConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdvertisementScreenConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetAdvertisementScreenConfigQuery, GetAdvertisementScreenConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvertisementScreenConfigQuery, GetAdvertisementScreenConfigQueryVariables>(GetAdvertisementScreenConfigDocument, options);
      }
export function useGetAdvertisementScreenConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvertisementScreenConfigQuery, GetAdvertisementScreenConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvertisementScreenConfigQuery, GetAdvertisementScreenConfigQueryVariables>(GetAdvertisementScreenConfigDocument, options);
        }
// @ts-ignore
export function useGetAdvertisementScreenConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdvertisementScreenConfigQuery, GetAdvertisementScreenConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdvertisementScreenConfigQuery, GetAdvertisementScreenConfigQueryVariables>;
export function useGetAdvertisementScreenConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdvertisementScreenConfigQuery, GetAdvertisementScreenConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdvertisementScreenConfigQuery | undefined, GetAdvertisementScreenConfigQueryVariables>;
export function useGetAdvertisementScreenConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdvertisementScreenConfigQuery, GetAdvertisementScreenConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdvertisementScreenConfigQuery, GetAdvertisementScreenConfigQueryVariables>(GetAdvertisementScreenConfigDocument, options);
        }
export type GetAdvertisementScreenConfigQueryHookResult = ReturnType<typeof useGetAdvertisementScreenConfigQuery>;
export type GetAdvertisementScreenConfigLazyQueryHookResult = ReturnType<typeof useGetAdvertisementScreenConfigLazyQuery>;
export type GetAdvertisementScreenConfigSuspenseQueryHookResult = ReturnType<typeof useGetAdvertisementScreenConfigSuspenseQuery>;
export type GetAdvertisementScreenConfigQueryResult = Apollo.QueryResult<GetAdvertisementScreenConfigQuery, GetAdvertisementScreenConfigQueryVariables>;
export const GetAuditLogsDocument = gql`
    query GET_AUDIT_LOGS($collectionDocumentId: String!) {
  auditLogs(collectionDocumentId: $collectionDocumentId) {
    ...AuditLogFragment
  }
}
    ${AuditLogFragmentFragmentDoc}`;

/**
 * __useGetAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogsQuery({
 *   variables: {
 *      collectionDocumentId: // value for 'collectionDocumentId'
 *   },
 * });
 */
export function useGetAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables> & ({ variables: GetAuditLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
      }
export function useGetAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
        }
// @ts-ignore
export function useGetAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export function useGetAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuditLogsQuery | undefined, GetAuditLogsQueryVariables>;
export function useGetAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
        }
export type GetAuditLogsQueryHookResult = ReturnType<typeof useGetAuditLogsQuery>;
export type GetAuditLogsLazyQueryHookResult = ReturnType<typeof useGetAuditLogsLazyQuery>;
export type GetAuditLogsSuspenseQueryHookResult = ReturnType<typeof useGetAuditLogsSuspenseQuery>;
export type GetAuditLogsQueryResult = Apollo.QueryResult<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export const GetBadgesDocument = gql`
    query GET_BADGES {
  badges {
    _id
    type
    name
    imageUrl
  }
}
    `;

/**
 * __useGetBadgesQuery__
 *
 * To run a query within a React component, call `useGetBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBadgesQuery(baseOptions?: Apollo.QueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBadgesQuery, GetBadgesQueryVariables>(GetBadgesDocument, options);
      }
export function useGetBadgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBadgesQuery, GetBadgesQueryVariables>(GetBadgesDocument, options);
        }
// @ts-ignore
export function useGetBadgesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBadgesQuery, GetBadgesQueryVariables>;
export function useGetBadgesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBadgesQuery | undefined, GetBadgesQueryVariables>;
export function useGetBadgesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBadgesQuery, GetBadgesQueryVariables>(GetBadgesDocument, options);
        }
export type GetBadgesQueryHookResult = ReturnType<typeof useGetBadgesQuery>;
export type GetBadgesLazyQueryHookResult = ReturnType<typeof useGetBadgesLazyQuery>;
export type GetBadgesSuspenseQueryHookResult = ReturnType<typeof useGetBadgesSuspenseQuery>;
export type GetBadgesQueryResult = Apollo.QueryResult<GetBadgesQuery, GetBadgesQueryVariables>;
export const GetBadgeDocument = gql`
    query GET_BADGE($badgeId: ID!) {
  badge(badgeId: $badgeId) {
    _id
    type
    name
    imageUrl
  }
}
    `;

/**
 * __useGetBadgeQuery__
 *
 * To run a query within a React component, call `useGetBadgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgeQuery({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *   },
 * });
 */
export function useGetBadgeQuery(baseOptions: Apollo.QueryHookOptions<GetBadgeQuery, GetBadgeQueryVariables> & ({ variables: GetBadgeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBadgeQuery, GetBadgeQueryVariables>(GetBadgeDocument, options);
      }
export function useGetBadgeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBadgeQuery, GetBadgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBadgeQuery, GetBadgeQueryVariables>(GetBadgeDocument, options);
        }
// @ts-ignore
export function useGetBadgeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBadgeQuery, GetBadgeQueryVariables>): Apollo.UseSuspenseQueryResult<GetBadgeQuery, GetBadgeQueryVariables>;
export function useGetBadgeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBadgeQuery, GetBadgeQueryVariables>): Apollo.UseSuspenseQueryResult<GetBadgeQuery | undefined, GetBadgeQueryVariables>;
export function useGetBadgeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBadgeQuery, GetBadgeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBadgeQuery, GetBadgeQueryVariables>(GetBadgeDocument, options);
        }
export type GetBadgeQueryHookResult = ReturnType<typeof useGetBadgeQuery>;
export type GetBadgeLazyQueryHookResult = ReturnType<typeof useGetBadgeLazyQuery>;
export type GetBadgeSuspenseQueryHookResult = ReturnType<typeof useGetBadgeSuspenseQuery>;
export type GetBadgeQueryResult = Apollo.QueryResult<GetBadgeQuery, GetBadgeQueryVariables>;
export const GetBakeryRecordsDocument = gql`
    query GET_BAKERY_RECORDS {
  bakeryRecords {
    _id
    createdAt
    createdBy
    productId
    fullname
    quantityUsed
    serialNumber
    useDate
    updatedAt
  }
}
    `;

/**
 * __useGetBakeryRecordsQuery__
 *
 * To run a query within a React component, call `useGetBakeryRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBakeryRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBakeryRecordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBakeryRecordsQuery(baseOptions?: Apollo.QueryHookOptions<GetBakeryRecordsQuery, GetBakeryRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBakeryRecordsQuery, GetBakeryRecordsQueryVariables>(GetBakeryRecordsDocument, options);
      }
export function useGetBakeryRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBakeryRecordsQuery, GetBakeryRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBakeryRecordsQuery, GetBakeryRecordsQueryVariables>(GetBakeryRecordsDocument, options);
        }
// @ts-ignore
export function useGetBakeryRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBakeryRecordsQuery, GetBakeryRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBakeryRecordsQuery, GetBakeryRecordsQueryVariables>;
export function useGetBakeryRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBakeryRecordsQuery, GetBakeryRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBakeryRecordsQuery | undefined, GetBakeryRecordsQueryVariables>;
export function useGetBakeryRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBakeryRecordsQuery, GetBakeryRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBakeryRecordsQuery, GetBakeryRecordsQueryVariables>(GetBakeryRecordsDocument, options);
        }
export type GetBakeryRecordsQueryHookResult = ReturnType<typeof useGetBakeryRecordsQuery>;
export type GetBakeryRecordsLazyQueryHookResult = ReturnType<typeof useGetBakeryRecordsLazyQuery>;
export type GetBakeryRecordsSuspenseQueryHookResult = ReturnType<typeof useGetBakeryRecordsSuspenseQuery>;
export type GetBakeryRecordsQueryResult = Apollo.QueryResult<GetBakeryRecordsQuery, GetBakeryRecordsQueryVariables>;
export const GetBundlesFilterDocument = gql`
    query GET_BUNDLES_FILTER($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: BundlesFilterInput) {
  bundlesFilter(
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    bundles {
      ...BundleFragment
    }
  }
}
    ${BundleFragmentFragmentDoc}`;

/**
 * __useGetBundlesFilterQuery__
 *
 * To run a query within a React component, call `useGetBundlesFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBundlesFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBundlesFilterQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBundlesFilterQuery(baseOptions?: Apollo.QueryHookOptions<GetBundlesFilterQuery, GetBundlesFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBundlesFilterQuery, GetBundlesFilterQueryVariables>(GetBundlesFilterDocument, options);
      }
export function useGetBundlesFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBundlesFilterQuery, GetBundlesFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBundlesFilterQuery, GetBundlesFilterQueryVariables>(GetBundlesFilterDocument, options);
        }
// @ts-ignore
export function useGetBundlesFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBundlesFilterQuery, GetBundlesFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GetBundlesFilterQuery, GetBundlesFilterQueryVariables>;
export function useGetBundlesFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBundlesFilterQuery, GetBundlesFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GetBundlesFilterQuery | undefined, GetBundlesFilterQueryVariables>;
export function useGetBundlesFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBundlesFilterQuery, GetBundlesFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBundlesFilterQuery, GetBundlesFilterQueryVariables>(GetBundlesFilterDocument, options);
        }
export type GetBundlesFilterQueryHookResult = ReturnType<typeof useGetBundlesFilterQuery>;
export type GetBundlesFilterLazyQueryHookResult = ReturnType<typeof useGetBundlesFilterLazyQuery>;
export type GetBundlesFilterSuspenseQueryHookResult = ReturnType<typeof useGetBundlesFilterSuspenseQuery>;
export type GetBundlesFilterQueryResult = Apollo.QueryResult<GetBundlesFilterQuery, GetBundlesFilterQueryVariables>;
export const GetBundleDocument = gql`
    query GET_BUNDLE($bundleId: ID!) {
  bundle(bundleId: $bundleId) {
    ...BundleWithBoxesFragment
  }
}
    ${BundleWithBoxesFragmentFragmentDoc}`;

/**
 * __useGetBundleQuery__
 *
 * To run a query within a React component, call `useGetBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBundleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBundleQuery({
 *   variables: {
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function useGetBundleQuery(baseOptions: Apollo.QueryHookOptions<GetBundleQuery, GetBundleQueryVariables> & ({ variables: GetBundleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBundleQuery, GetBundleQueryVariables>(GetBundleDocument, options);
      }
export function useGetBundleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBundleQuery, GetBundleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBundleQuery, GetBundleQueryVariables>(GetBundleDocument, options);
        }
// @ts-ignore
export function useGetBundleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBundleQuery, GetBundleQueryVariables>): Apollo.UseSuspenseQueryResult<GetBundleQuery, GetBundleQueryVariables>;
export function useGetBundleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBundleQuery, GetBundleQueryVariables>): Apollo.UseSuspenseQueryResult<GetBundleQuery | undefined, GetBundleQueryVariables>;
export function useGetBundleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBundleQuery, GetBundleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBundleQuery, GetBundleQueryVariables>(GetBundleDocument, options);
        }
export type GetBundleQueryHookResult = ReturnType<typeof useGetBundleQuery>;
export type GetBundleLazyQueryHookResult = ReturnType<typeof useGetBundleLazyQuery>;
export type GetBundleSuspenseQueryHookResult = ReturnType<typeof useGetBundleSuspenseQuery>;
export type GetBundleQueryResult = Apollo.QueryResult<GetBundleQuery, GetBundleQueryVariables>;
export const GetActiveCategoriesDocument = gql`
    query GET_ACTIVE_CATEGORIES {
  activeCategories {
    _id
    title
    shouldShowSubcategories
  }
}
    `;

/**
 * __useGetActiveCategoriesQuery__
 *
 * To run a query within a React component, call `useGetActiveCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveCategoriesQuery, GetActiveCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCategoriesQuery, GetActiveCategoriesQueryVariables>(GetActiveCategoriesDocument, options);
      }
export function useGetActiveCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCategoriesQuery, GetActiveCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCategoriesQuery, GetActiveCategoriesQueryVariables>(GetActiveCategoriesDocument, options);
        }
// @ts-ignore
export function useGetActiveCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveCategoriesQuery, GetActiveCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveCategoriesQuery, GetActiveCategoriesQueryVariables>;
export function useGetActiveCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveCategoriesQuery, GetActiveCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveCategoriesQuery | undefined, GetActiveCategoriesQueryVariables>;
export function useGetActiveCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveCategoriesQuery, GetActiveCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveCategoriesQuery, GetActiveCategoriesQueryVariables>(GetActiveCategoriesDocument, options);
        }
export type GetActiveCategoriesQueryHookResult = ReturnType<typeof useGetActiveCategoriesQuery>;
export type GetActiveCategoriesLazyQueryHookResult = ReturnType<typeof useGetActiveCategoriesLazyQuery>;
export type GetActiveCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetActiveCategoriesSuspenseQuery>;
export type GetActiveCategoriesQueryResult = Apollo.QueryResult<GetActiveCategoriesQuery, GetActiveCategoriesQueryVariables>;
export const GetCategoriesDocument = gql`
    query GET_CATEGORIES {
  categories {
    _id
    title
    imageUrl
    state
    indexDisplay
    shouldShowSubcategories
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
// @ts-ignore
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesQuery | undefined, GetCategoriesQueryVariables>;
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetDetailedCategoryDocument = gql`
    query GET_DETAILED_CATEGORY($categoryId: String!) {
  detailedCategory(categoryId: $categoryId) {
    ...CategoryFragment
  }
}
    ${CategoryFragmentFragmentDoc}`;

/**
 * __useGetDetailedCategoryQuery__
 *
 * To run a query within a React component, call `useGetDetailedCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetDetailedCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetDetailedCategoryQuery, GetDetailedCategoryQueryVariables> & ({ variables: GetDetailedCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailedCategoryQuery, GetDetailedCategoryQueryVariables>(GetDetailedCategoryDocument, options);
      }
export function useGetDetailedCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailedCategoryQuery, GetDetailedCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailedCategoryQuery, GetDetailedCategoryQueryVariables>(GetDetailedCategoryDocument, options);
        }
// @ts-ignore
export function useGetDetailedCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDetailedCategoryQuery, GetDetailedCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedCategoryQuery, GetDetailedCategoryQueryVariables>;
export function useGetDetailedCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedCategoryQuery, GetDetailedCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedCategoryQuery | undefined, GetDetailedCategoryQueryVariables>;
export function useGetDetailedCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedCategoryQuery, GetDetailedCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailedCategoryQuery, GetDetailedCategoryQueryVariables>(GetDetailedCategoryDocument, options);
        }
export type GetDetailedCategoryQueryHookResult = ReturnType<typeof useGetDetailedCategoryQuery>;
export type GetDetailedCategoryLazyQueryHookResult = ReturnType<typeof useGetDetailedCategoryLazyQuery>;
export type GetDetailedCategorySuspenseQueryHookResult = ReturnType<typeof useGetDetailedCategorySuspenseQuery>;
export type GetDetailedCategoryQueryResult = Apollo.QueryResult<GetDetailedCategoryQuery, GetDetailedCategoryQueryVariables>;
export const GetWarehouseColumnsDocument = gql`
    query GET_WAREHOUSE_COLUMNS {
  warehouseColumns {
    _id
    name
    siteId
    site {
      _id
      hasExternalSetupProcess
      isSecured
      name
      type
      totemId
    }
  }
}
    `;

/**
 * __useGetWarehouseColumnsQuery__
 *
 * To run a query within a React component, call `useGetWarehouseColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarehouseColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarehouseColumnsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWarehouseColumnsQuery(baseOptions?: Apollo.QueryHookOptions<GetWarehouseColumnsQuery, GetWarehouseColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarehouseColumnsQuery, GetWarehouseColumnsQueryVariables>(GetWarehouseColumnsDocument, options);
      }
export function useGetWarehouseColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarehouseColumnsQuery, GetWarehouseColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarehouseColumnsQuery, GetWarehouseColumnsQueryVariables>(GetWarehouseColumnsDocument, options);
        }
// @ts-ignore
export function useGetWarehouseColumnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWarehouseColumnsQuery, GetWarehouseColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarehouseColumnsQuery, GetWarehouseColumnsQueryVariables>;
export function useGetWarehouseColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehouseColumnsQuery, GetWarehouseColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarehouseColumnsQuery | undefined, GetWarehouseColumnsQueryVariables>;
export function useGetWarehouseColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehouseColumnsQuery, GetWarehouseColumnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWarehouseColumnsQuery, GetWarehouseColumnsQueryVariables>(GetWarehouseColumnsDocument, options);
        }
export type GetWarehouseColumnsQueryHookResult = ReturnType<typeof useGetWarehouseColumnsQuery>;
export type GetWarehouseColumnsLazyQueryHookResult = ReturnType<typeof useGetWarehouseColumnsLazyQuery>;
export type GetWarehouseColumnsSuspenseQueryHookResult = ReturnType<typeof useGetWarehouseColumnsSuspenseQuery>;
export type GetWarehouseColumnsQueryResult = Apollo.QueryResult<GetWarehouseColumnsQuery, GetWarehouseColumnsQueryVariables>;
export const GetColumnsDocument = gql`
    query GET_COLUMNS($siteId: ID) {
  columns(siteId: $siteId) {
    ...ColumnFragment
  }
}
    ${ColumnFragmentFragmentDoc}`;

/**
 * __useGetColumnsQuery__
 *
 * To run a query within a React component, call `useGetColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColumnsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetColumnsQuery(baseOptions?: Apollo.QueryHookOptions<GetColumnsQuery, GetColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetColumnsQuery, GetColumnsQueryVariables>(GetColumnsDocument, options);
      }
export function useGetColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetColumnsQuery, GetColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetColumnsQuery, GetColumnsQueryVariables>(GetColumnsDocument, options);
        }
// @ts-ignore
export function useGetColumnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetColumnsQuery, GetColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnsQuery, GetColumnsQueryVariables>;
export function useGetColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnsQuery, GetColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnsQuery | undefined, GetColumnsQueryVariables>;
export function useGetColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnsQuery, GetColumnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetColumnsQuery, GetColumnsQueryVariables>(GetColumnsDocument, options);
        }
export type GetColumnsQueryHookResult = ReturnType<typeof useGetColumnsQuery>;
export type GetColumnsLazyQueryHookResult = ReturnType<typeof useGetColumnsLazyQuery>;
export type GetColumnsSuspenseQueryHookResult = ReturnType<typeof useGetColumnsSuspenseQuery>;
export type GetColumnsQueryResult = Apollo.QueryResult<GetColumnsQuery, GetColumnsQueryVariables>;
export const GetColumnDocument = gql`
    query GET_COLUMN($_id: ID!) {
  column(_id: $_id) {
    ...ColumnFragment
    site {
      _id
      name
      type
      totem {
        _id
        name
        number
        sites {
          _id
          name
        }
        organization {
          _id
          name
        }
      }
    }
    microstoreColumn {
      _id
      columnGroup {
        _id
        name
        columns {
          _id
          name
          positionInColumnGroup
        }
      }
    }
  }
}
    ${ColumnFragmentFragmentDoc}`;

/**
 * __useGetColumnQuery__
 *
 * To run a query within a React component, call `useGetColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColumnQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useGetColumnQuery(baseOptions: Apollo.QueryHookOptions<GetColumnQuery, GetColumnQueryVariables> & ({ variables: GetColumnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetColumnQuery, GetColumnQueryVariables>(GetColumnDocument, options);
      }
export function useGetColumnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetColumnQuery, GetColumnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetColumnQuery, GetColumnQueryVariables>(GetColumnDocument, options);
        }
// @ts-ignore
export function useGetColumnSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetColumnQuery, GetColumnQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnQuery, GetColumnQueryVariables>;
export function useGetColumnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnQuery, GetColumnQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnQuery | undefined, GetColumnQueryVariables>;
export function useGetColumnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnQuery, GetColumnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetColumnQuery, GetColumnQueryVariables>(GetColumnDocument, options);
        }
export type GetColumnQueryHookResult = ReturnType<typeof useGetColumnQuery>;
export type GetColumnLazyQueryHookResult = ReturnType<typeof useGetColumnLazyQuery>;
export type GetColumnSuspenseQueryHookResult = ReturnType<typeof useGetColumnSuspenseQuery>;
export type GetColumnQueryResult = Apollo.QueryResult<GetColumnQuery, GetColumnQueryVariables>;
export const GetColumnsPaginatedDocument = gql`
    query GET_COLUMNS_PAGINATED($offset: Int, $limit: Int, $filters: ColumnsFilterInput) {
  columnsFilter(offset: $offset, limit: $limit, filters: $filters) {
    hasMore
    columns {
      _id
      name
      fullname
      type
    }
  }
}
    `;

/**
 * __useGetColumnsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetColumnsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColumnsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColumnsPaginatedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetColumnsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GetColumnsPaginatedQuery, GetColumnsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetColumnsPaginatedQuery, GetColumnsPaginatedQueryVariables>(GetColumnsPaginatedDocument, options);
      }
export function useGetColumnsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetColumnsPaginatedQuery, GetColumnsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetColumnsPaginatedQuery, GetColumnsPaginatedQueryVariables>(GetColumnsPaginatedDocument, options);
        }
// @ts-ignore
export function useGetColumnsPaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetColumnsPaginatedQuery, GetColumnsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnsPaginatedQuery, GetColumnsPaginatedQueryVariables>;
export function useGetColumnsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnsPaginatedQuery, GetColumnsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnsPaginatedQuery | undefined, GetColumnsPaginatedQueryVariables>;
export function useGetColumnsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnsPaginatedQuery, GetColumnsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetColumnsPaginatedQuery, GetColumnsPaginatedQueryVariables>(GetColumnsPaginatedDocument, options);
        }
export type GetColumnsPaginatedQueryHookResult = ReturnType<typeof useGetColumnsPaginatedQuery>;
export type GetColumnsPaginatedLazyQueryHookResult = ReturnType<typeof useGetColumnsPaginatedLazyQuery>;
export type GetColumnsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetColumnsPaginatedSuspenseQuery>;
export type GetColumnsPaginatedQueryResult = Apollo.QueryResult<GetColumnsPaginatedQuery, GetColumnsPaginatedQueryVariables>;
export const CommentsDocument = gql`
    query Comments($offset: Int!, $limit: Int!) {
  comments(offset: $offset, limit: $limit) {
    comments {
      ...CommentFragment
      answers {
        ...CommentFragment
      }
    }
    hasMore
  }
}
    ${CommentFragmentFragmentDoc}`;

/**
 * __useCommentsQuery__
 *
 * To run a query within a React component, call `useCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCommentsQuery(baseOptions: Apollo.QueryHookOptions<CommentsQuery, CommentsQueryVariables> & ({ variables: CommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
      }
export function useCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
// @ts-ignore
export function useCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>): Apollo.UseSuspenseQueryResult<CommentsQuery, CommentsQueryVariables>;
export function useCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>): Apollo.UseSuspenseQueryResult<CommentsQuery | undefined, CommentsQueryVariables>;
export function useCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export type CommentsQueryHookResult = ReturnType<typeof useCommentsQuery>;
export type CommentsLazyQueryHookResult = ReturnType<typeof useCommentsLazyQuery>;
export type CommentsSuspenseQueryHookResult = ReturnType<typeof useCommentsSuspenseQuery>;
export type CommentsQueryResult = Apollo.QueryResult<CommentsQuery, CommentsQueryVariables>;
export const SearchCompaniesByNameDocument = gql`
    query SEARCH_COMPANIES_BY_NAME($name: String!, $limit: Int) {
  searchCompaniesByName(name: $name, limit: $limit) {
    siret
    siren
    legalName
    isActive
    address
  }
}
    `;

/**
 * __useSearchCompaniesByNameQuery__
 *
 * To run a query within a React component, call `useSearchCompaniesByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompaniesByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompaniesByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchCompaniesByNameQuery(baseOptions: Apollo.QueryHookOptions<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables> & ({ variables: SearchCompaniesByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>(SearchCompaniesByNameDocument, options);
      }
export function useSearchCompaniesByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>(SearchCompaniesByNameDocument, options);
        }
// @ts-ignore
export function useSearchCompaniesByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>): Apollo.UseSuspenseQueryResult<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>;
export function useSearchCompaniesByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>): Apollo.UseSuspenseQueryResult<SearchCompaniesByNameQuery | undefined, SearchCompaniesByNameQueryVariables>;
export function useSearchCompaniesByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>(SearchCompaniesByNameDocument, options);
        }
export type SearchCompaniesByNameQueryHookResult = ReturnType<typeof useSearchCompaniesByNameQuery>;
export type SearchCompaniesByNameLazyQueryHookResult = ReturnType<typeof useSearchCompaniesByNameLazyQuery>;
export type SearchCompaniesByNameSuspenseQueryHookResult = ReturnType<typeof useSearchCompaniesByNameSuspenseQuery>;
export type SearchCompaniesByNameQueryResult = Apollo.QueryResult<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>;
export const GetSiteConsumptionVariationsDocument = gql`
    query GET_SITE_CONSUMPTION_VARIATIONS($siteId: ID!) {
  siteConsumptionVariations(siteId: $siteId) {
    ...ConsumptionVariationFragment
  }
}
    ${ConsumptionVariationFragmentFragmentDoc}`;

/**
 * __useGetSiteConsumptionVariationsQuery__
 *
 * To run a query within a React component, call `useGetSiteConsumptionVariationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteConsumptionVariationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteConsumptionVariationsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteConsumptionVariationsQuery(baseOptions: Apollo.QueryHookOptions<GetSiteConsumptionVariationsQuery, GetSiteConsumptionVariationsQueryVariables> & ({ variables: GetSiteConsumptionVariationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteConsumptionVariationsQuery, GetSiteConsumptionVariationsQueryVariables>(GetSiteConsumptionVariationsDocument, options);
      }
export function useGetSiteConsumptionVariationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteConsumptionVariationsQuery, GetSiteConsumptionVariationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteConsumptionVariationsQuery, GetSiteConsumptionVariationsQueryVariables>(GetSiteConsumptionVariationsDocument, options);
        }
// @ts-ignore
export function useGetSiteConsumptionVariationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteConsumptionVariationsQuery, GetSiteConsumptionVariationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteConsumptionVariationsQuery, GetSiteConsumptionVariationsQueryVariables>;
export function useGetSiteConsumptionVariationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteConsumptionVariationsQuery, GetSiteConsumptionVariationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteConsumptionVariationsQuery | undefined, GetSiteConsumptionVariationsQueryVariables>;
export function useGetSiteConsumptionVariationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteConsumptionVariationsQuery, GetSiteConsumptionVariationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteConsumptionVariationsQuery, GetSiteConsumptionVariationsQueryVariables>(GetSiteConsumptionVariationsDocument, options);
        }
export type GetSiteConsumptionVariationsQueryHookResult = ReturnType<typeof useGetSiteConsumptionVariationsQuery>;
export type GetSiteConsumptionVariationsLazyQueryHookResult = ReturnType<typeof useGetSiteConsumptionVariationsLazyQuery>;
export type GetSiteConsumptionVariationsSuspenseQueryHookResult = ReturnType<typeof useGetSiteConsumptionVariationsSuspenseQuery>;
export type GetSiteConsumptionVariationsQueryResult = Apollo.QueryResult<GetSiteConsumptionVariationsQuery, GetSiteConsumptionVariationsQueryVariables>;
export const GetCreditsDocument = gql`
    query GET_CREDITS($offset: Int!, $userId: String, $types: [CreditType!]) {
  credits(offset: $offset, userId: $userId, types: $types) {
    hasMore
    credits {
      ...PreviewCreditFragment
    }
  }
}
    ${PreviewCreditFragmentFragmentDoc}`;

/**
 * __useGetCreditsQuery__
 *
 * To run a query within a React component, call `useGetCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      userId: // value for 'userId'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetCreditsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditsQuery, GetCreditsQueryVariables> & ({ variables: GetCreditsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditsQuery, GetCreditsQueryVariables>(GetCreditsDocument, options);
      }
export function useGetCreditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditsQuery, GetCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditsQuery, GetCreditsQueryVariables>(GetCreditsDocument, options);
        }
// @ts-ignore
export function useGetCreditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCreditsQuery, GetCreditsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCreditsQuery, GetCreditsQueryVariables>;
export function useGetCreditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditsQuery, GetCreditsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCreditsQuery | undefined, GetCreditsQueryVariables>;
export function useGetCreditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditsQuery, GetCreditsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditsQuery, GetCreditsQueryVariables>(GetCreditsDocument, options);
        }
export type GetCreditsQueryHookResult = ReturnType<typeof useGetCreditsQuery>;
export type GetCreditsLazyQueryHookResult = ReturnType<typeof useGetCreditsLazyQuery>;
export type GetCreditsSuspenseQueryHookResult = ReturnType<typeof useGetCreditsSuspenseQuery>;
export type GetCreditsQueryResult = Apollo.QueryResult<GetCreditsQuery, GetCreditsQueryVariables>;
export const GetTotemCashHistoryDocument = gql`
    query getTotemCashHistory($userId: String!, $limit: Int!, $offset: Int!) {
  totemCashHistory(userId: $userId, limit: $limit, offset: $offset) {
    hasMore
    credits {
      ...PreviewCreditFragment
    }
  }
}
    ${PreviewCreditFragmentFragmentDoc}`;

/**
 * __useGetTotemCashHistoryQuery__
 *
 * To run a query within a React component, call `useGetTotemCashHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotemCashHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotemCashHistoryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetTotemCashHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetTotemCashHistoryQuery, GetTotemCashHistoryQueryVariables> & ({ variables: GetTotemCashHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotemCashHistoryQuery, GetTotemCashHistoryQueryVariables>(GetTotemCashHistoryDocument, options);
      }
export function useGetTotemCashHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotemCashHistoryQuery, GetTotemCashHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotemCashHistoryQuery, GetTotemCashHistoryQueryVariables>(GetTotemCashHistoryDocument, options);
        }
// @ts-ignore
export function useGetTotemCashHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTotemCashHistoryQuery, GetTotemCashHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotemCashHistoryQuery, GetTotemCashHistoryQueryVariables>;
export function useGetTotemCashHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemCashHistoryQuery, GetTotemCashHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotemCashHistoryQuery | undefined, GetTotemCashHistoryQueryVariables>;
export function useGetTotemCashHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemCashHistoryQuery, GetTotemCashHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotemCashHistoryQuery, GetTotemCashHistoryQueryVariables>(GetTotemCashHistoryDocument, options);
        }
export type GetTotemCashHistoryQueryHookResult = ReturnType<typeof useGetTotemCashHistoryQuery>;
export type GetTotemCashHistoryLazyQueryHookResult = ReturnType<typeof useGetTotemCashHistoryLazyQuery>;
export type GetTotemCashHistorySuspenseQueryHookResult = ReturnType<typeof useGetTotemCashHistorySuspenseQuery>;
export type GetTotemCashHistoryQueryResult = Apollo.QueryResult<GetTotemCashHistoryQuery, GetTotemCashHistoryQueryVariables>;
export const GetDeliveriesDocument = gql`
    query GET_DELIVERIES($startDate: String, $endDate: String) {
  deliveries(startDate: $startDate, endDate: $endDate) {
    ...DeliveryFragment
    contentSummary {
      boxCount
      productCount
      totalWeight
      totalVolume
    }
    soldoutRefsCount
  }
}
    ${DeliveryFragmentFragmentDoc}`;

/**
 * __useGetDeliveriesQuery__
 *
 * To run a query within a React component, call `useGetDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveriesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDeliveriesQuery(baseOptions?: Apollo.QueryHookOptions<GetDeliveriesQuery, GetDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveriesQuery, GetDeliveriesQueryVariables>(GetDeliveriesDocument, options);
      }
export function useGetDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveriesQuery, GetDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveriesQuery, GetDeliveriesQueryVariables>(GetDeliveriesDocument, options);
        }
// @ts-ignore
export function useGetDeliveriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeliveriesQuery, GetDeliveriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveriesQuery, GetDeliveriesQueryVariables>;
export function useGetDeliveriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveriesQuery, GetDeliveriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveriesQuery | undefined, GetDeliveriesQueryVariables>;
export function useGetDeliveriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveriesQuery, GetDeliveriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveriesQuery, GetDeliveriesQueryVariables>(GetDeliveriesDocument, options);
        }
export type GetDeliveriesQueryHookResult = ReturnType<typeof useGetDeliveriesQuery>;
export type GetDeliveriesLazyQueryHookResult = ReturnType<typeof useGetDeliveriesLazyQuery>;
export type GetDeliveriesSuspenseQueryHookResult = ReturnType<typeof useGetDeliveriesSuspenseQuery>;
export type GetDeliveriesQueryResult = Apollo.QueryResult<GetDeliveriesQuery, GetDeliveriesQueryVariables>;
export const GetDailyDeliveriesWithPhotosDocument = gql`
    query GET_DAILY_DELIVERIES_WITH_PHOTOS($startDate: String, $endDate: String, $filters: DeliveriesFilterInput) {
  deliveries(startDate: $startDate, endDate: $endDate, filters: $filters) {
    ...DeliveryFragment
    photos {
      type
      urls
    }
    controlPhotos {
      ...ControlPhotoFragment
    }
    siteSetup {
      ...SiteSetupControlPhotosFragment
    }
    freefoodSetup {
      ...FreefoodSetupControlPhotosFragment
    }
  }
}
    ${DeliveryFragmentFragmentDoc}
${ControlPhotoFragmentFragmentDoc}
${SiteSetupControlPhotosFragmentFragmentDoc}
${FreefoodSetupControlPhotosFragmentFragmentDoc}`;

/**
 * __useGetDailyDeliveriesWithPhotosQuery__
 *
 * To run a query within a React component, call `useGetDailyDeliveriesWithPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyDeliveriesWithPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyDeliveriesWithPhotosQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDailyDeliveriesWithPhotosQuery(baseOptions?: Apollo.QueryHookOptions<GetDailyDeliveriesWithPhotosQuery, GetDailyDeliveriesWithPhotosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyDeliveriesWithPhotosQuery, GetDailyDeliveriesWithPhotosQueryVariables>(GetDailyDeliveriesWithPhotosDocument, options);
      }
export function useGetDailyDeliveriesWithPhotosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyDeliveriesWithPhotosQuery, GetDailyDeliveriesWithPhotosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyDeliveriesWithPhotosQuery, GetDailyDeliveriesWithPhotosQueryVariables>(GetDailyDeliveriesWithPhotosDocument, options);
        }
// @ts-ignore
export function useGetDailyDeliveriesWithPhotosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDailyDeliveriesWithPhotosQuery, GetDailyDeliveriesWithPhotosQueryVariables>): Apollo.UseSuspenseQueryResult<GetDailyDeliveriesWithPhotosQuery, GetDailyDeliveriesWithPhotosQueryVariables>;
export function useGetDailyDeliveriesWithPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDailyDeliveriesWithPhotosQuery, GetDailyDeliveriesWithPhotosQueryVariables>): Apollo.UseSuspenseQueryResult<GetDailyDeliveriesWithPhotosQuery | undefined, GetDailyDeliveriesWithPhotosQueryVariables>;
export function useGetDailyDeliveriesWithPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDailyDeliveriesWithPhotosQuery, GetDailyDeliveriesWithPhotosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDailyDeliveriesWithPhotosQuery, GetDailyDeliveriesWithPhotosQueryVariables>(GetDailyDeliveriesWithPhotosDocument, options);
        }
export type GetDailyDeliveriesWithPhotosQueryHookResult = ReturnType<typeof useGetDailyDeliveriesWithPhotosQuery>;
export type GetDailyDeliveriesWithPhotosLazyQueryHookResult = ReturnType<typeof useGetDailyDeliveriesWithPhotosLazyQuery>;
export type GetDailyDeliveriesWithPhotosSuspenseQueryHookResult = ReturnType<typeof useGetDailyDeliveriesWithPhotosSuspenseQuery>;
export type GetDailyDeliveriesWithPhotosQueryResult = Apollo.QueryResult<GetDailyDeliveriesWithPhotosQuery, GetDailyDeliveriesWithPhotosQueryVariables>;
export const GetDeliveryDocument = gql`
    query GET_DELIVERY($deliveryId: ID!) {
  delivery(deliveryId: $deliveryId) {
    _id
    label
    boxes {
      ...BoxFragment
    }
    createdAt
    deliveryDate
    orders {
      _id
      number
      state
      user {
        profile {
          fullname
        }
      }
    }
    stockTransfers {
      _id
      transferDate
      state
      numberOfRefs
      quantityOfProducts
      reassortmentFlow
      originColumn {
        fullname
      }
      destinationColumn {
        fullname
      }
    }
    stockTransfersProductSummary {
      productId
      fullname
      quantityRequested
      quantityPositioned
      quantityPicked
      quantitySoldoutOnline
      quantitySoldoutBundle
    }
    ordersProductSummary {
      productId
      fullname
      quantityRequested
      quantityPositioned
      quantityPicked
      quantitySoldoutOnline
      quantitySoldoutBundle
    }
    organizationName
    isDynamic
    deliveredMicrostoreColumns {
      _id
      name
      type
    }
    deliveryPersonUserId
    deliveryPerson {
      _id
      username
      profile {
        fullname
        firstname
        lastname
      }
    }
    photos {
      type
      urls
    }
    controlPhotos {
      ...ControlPhotoFragment
    }
    roundColor
    roundName
    serviceTime
    siteId
    siteName
    siteSetup {
      ...SiteSetupFragment
    }
    freefoodSetup {
      ...FreefoodSetupFragment
    }
    state
    stateHistory {
      createdAt
      createdByName
      state
    }
    theoricServiceTime
    times {
      preferenceSlot {
        start
        end
      }
      actualSlot {
        start
        end
      }
    }
    totem {
      address
      name
      number
    }
    trackingUrl
    updatedAt
  }
}
    ${BoxFragmentFragmentDoc}
${ControlPhotoFragmentFragmentDoc}
${SiteSetupFragmentFragmentDoc}
${FreefoodSetupFragmentFragmentDoc}`;

/**
 * __useGetDeliveryQuery__
 *
 * To run a query within a React component, call `useGetDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryQuery({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
export function useGetDeliveryQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryQuery, GetDeliveryQueryVariables> & ({ variables: GetDeliveryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryQuery, GetDeliveryQueryVariables>(GetDeliveryDocument, options);
      }
export function useGetDeliveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryQuery, GetDeliveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryQuery, GetDeliveryQueryVariables>(GetDeliveryDocument, options);
        }
// @ts-ignore
export function useGetDeliverySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeliveryQuery, GetDeliveryQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveryQuery, GetDeliveryQueryVariables>;
export function useGetDeliverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryQuery, GetDeliveryQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveryQuery | undefined, GetDeliveryQueryVariables>;
export function useGetDeliverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryQuery, GetDeliveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveryQuery, GetDeliveryQueryVariables>(GetDeliveryDocument, options);
        }
export type GetDeliveryQueryHookResult = ReturnType<typeof useGetDeliveryQuery>;
export type GetDeliveryLazyQueryHookResult = ReturnType<typeof useGetDeliveryLazyQuery>;
export type GetDeliverySuspenseQueryHookResult = ReturnType<typeof useGetDeliverySuspenseQuery>;
export type GetDeliveryQueryResult = Apollo.QueryResult<GetDeliveryQuery, GetDeliveryQueryVariables>;
export const GetDeliveryPlanningForThreeWeeksDocument = gql`
    query GET_DELIVERY_PLANNING_FOR_THREE_WEEKS($siteId: ID!, $mondayDate: String!) {
  getDeliveryPlanningForThreeWeeks(siteId: $siteId, mondayDate: $mondayDate) {
    ...SiteDeliveryPlanningFragment
  }
}
    ${SiteDeliveryPlanningFragmentFragmentDoc}`;

/**
 * __useGetDeliveryPlanningForThreeWeeksQuery__
 *
 * To run a query within a React component, call `useGetDeliveryPlanningForThreeWeeksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryPlanningForThreeWeeksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryPlanningForThreeWeeksQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      mondayDate: // value for 'mondayDate'
 *   },
 * });
 */
export function useGetDeliveryPlanningForThreeWeeksQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryPlanningForThreeWeeksQuery, GetDeliveryPlanningForThreeWeeksQueryVariables> & ({ variables: GetDeliveryPlanningForThreeWeeksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryPlanningForThreeWeeksQuery, GetDeliveryPlanningForThreeWeeksQueryVariables>(GetDeliveryPlanningForThreeWeeksDocument, options);
      }
export function useGetDeliveryPlanningForThreeWeeksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryPlanningForThreeWeeksQuery, GetDeliveryPlanningForThreeWeeksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryPlanningForThreeWeeksQuery, GetDeliveryPlanningForThreeWeeksQueryVariables>(GetDeliveryPlanningForThreeWeeksDocument, options);
        }
// @ts-ignore
export function useGetDeliveryPlanningForThreeWeeksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeliveryPlanningForThreeWeeksQuery, GetDeliveryPlanningForThreeWeeksQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveryPlanningForThreeWeeksQuery, GetDeliveryPlanningForThreeWeeksQueryVariables>;
export function useGetDeliveryPlanningForThreeWeeksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryPlanningForThreeWeeksQuery, GetDeliveryPlanningForThreeWeeksQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveryPlanningForThreeWeeksQuery | undefined, GetDeliveryPlanningForThreeWeeksQueryVariables>;
export function useGetDeliveryPlanningForThreeWeeksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryPlanningForThreeWeeksQuery, GetDeliveryPlanningForThreeWeeksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveryPlanningForThreeWeeksQuery, GetDeliveryPlanningForThreeWeeksQueryVariables>(GetDeliveryPlanningForThreeWeeksDocument, options);
        }
export type GetDeliveryPlanningForThreeWeeksQueryHookResult = ReturnType<typeof useGetDeliveryPlanningForThreeWeeksQuery>;
export type GetDeliveryPlanningForThreeWeeksLazyQueryHookResult = ReturnType<typeof useGetDeliveryPlanningForThreeWeeksLazyQuery>;
export type GetDeliveryPlanningForThreeWeeksSuspenseQueryHookResult = ReturnType<typeof useGetDeliveryPlanningForThreeWeeksSuspenseQuery>;
export type GetDeliveryPlanningForThreeWeeksQueryResult = Apollo.QueryResult<GetDeliveryPlanningForThreeWeeksQuery, GetDeliveryPlanningForThreeWeeksQueryVariables>;
export const GetAllSitesDeliveryPlanningForThreeWeeksDocument = gql`
    query GET_ALL_SITES_DELIVERY_PLANNING_FOR_THREE_WEEKS($mondayDate: String!) {
  getAllSitesDeliveryPlanningForThreeWeeks(mondayDate: $mondayDate) {
    ...SiteDeliveryPlanningFragment
  }
}
    ${SiteDeliveryPlanningFragmentFragmentDoc}`;

/**
 * __useGetAllSitesDeliveryPlanningForThreeWeeksQuery__
 *
 * To run a query within a React component, call `useGetAllSitesDeliveryPlanningForThreeWeeksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSitesDeliveryPlanningForThreeWeeksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSitesDeliveryPlanningForThreeWeeksQuery({
 *   variables: {
 *      mondayDate: // value for 'mondayDate'
 *   },
 * });
 */
export function useGetAllSitesDeliveryPlanningForThreeWeeksQuery(baseOptions: Apollo.QueryHookOptions<GetAllSitesDeliveryPlanningForThreeWeeksQuery, GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables> & ({ variables: GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSitesDeliveryPlanningForThreeWeeksQuery, GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables>(GetAllSitesDeliveryPlanningForThreeWeeksDocument, options);
      }
export function useGetAllSitesDeliveryPlanningForThreeWeeksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSitesDeliveryPlanningForThreeWeeksQuery, GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSitesDeliveryPlanningForThreeWeeksQuery, GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables>(GetAllSitesDeliveryPlanningForThreeWeeksDocument, options);
        }
// @ts-ignore
export function useGetAllSitesDeliveryPlanningForThreeWeeksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllSitesDeliveryPlanningForThreeWeeksQuery, GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllSitesDeliveryPlanningForThreeWeeksQuery, GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables>;
export function useGetAllSitesDeliveryPlanningForThreeWeeksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSitesDeliveryPlanningForThreeWeeksQuery, GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllSitesDeliveryPlanningForThreeWeeksQuery | undefined, GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables>;
export function useGetAllSitesDeliveryPlanningForThreeWeeksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSitesDeliveryPlanningForThreeWeeksQuery, GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSitesDeliveryPlanningForThreeWeeksQuery, GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables>(GetAllSitesDeliveryPlanningForThreeWeeksDocument, options);
        }
export type GetAllSitesDeliveryPlanningForThreeWeeksQueryHookResult = ReturnType<typeof useGetAllSitesDeliveryPlanningForThreeWeeksQuery>;
export type GetAllSitesDeliveryPlanningForThreeWeeksLazyQueryHookResult = ReturnType<typeof useGetAllSitesDeliveryPlanningForThreeWeeksLazyQuery>;
export type GetAllSitesDeliveryPlanningForThreeWeeksSuspenseQueryHookResult = ReturnType<typeof useGetAllSitesDeliveryPlanningForThreeWeeksSuspenseQuery>;
export type GetAllSitesDeliveryPlanningForThreeWeeksQueryResult = Apollo.QueryResult<GetAllSitesDeliveryPlanningForThreeWeeksQuery, GetAllSitesDeliveryPlanningForThreeWeeksQueryVariables>;
export const GetDeliveryZonesDocument = gql`
    query GET_DELIVERY_ZONES {
  deliveryZones {
    ...DeliveryZoneFragment
  }
}
    ${DeliveryZoneFragmentFragmentDoc}`;

/**
 * __useGetDeliveryZonesQuery__
 *
 * To run a query within a React component, call `useGetDeliveryZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDeliveryZonesQuery(baseOptions?: Apollo.QueryHookOptions<GetDeliveryZonesQuery, GetDeliveryZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryZonesQuery, GetDeliveryZonesQueryVariables>(GetDeliveryZonesDocument, options);
      }
export function useGetDeliveryZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryZonesQuery, GetDeliveryZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryZonesQuery, GetDeliveryZonesQueryVariables>(GetDeliveryZonesDocument, options);
        }
// @ts-ignore
export function useGetDeliveryZonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeliveryZonesQuery, GetDeliveryZonesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveryZonesQuery, GetDeliveryZonesQueryVariables>;
export function useGetDeliveryZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryZonesQuery, GetDeliveryZonesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveryZonesQuery | undefined, GetDeliveryZonesQueryVariables>;
export function useGetDeliveryZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryZonesQuery, GetDeliveryZonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveryZonesQuery, GetDeliveryZonesQueryVariables>(GetDeliveryZonesDocument, options);
        }
export type GetDeliveryZonesQueryHookResult = ReturnType<typeof useGetDeliveryZonesQuery>;
export type GetDeliveryZonesLazyQueryHookResult = ReturnType<typeof useGetDeliveryZonesLazyQuery>;
export type GetDeliveryZonesSuspenseQueryHookResult = ReturnType<typeof useGetDeliveryZonesSuspenseQuery>;
export type GetDeliveryZonesQueryResult = Apollo.QueryResult<GetDeliveryZonesQuery, GetDeliveryZonesQueryVariables>;
export const GetDeliveryZoneDocument = gql`
    query GET_DELIVERY_ZONE($_id: ID!) {
  deliveryZone(_id: $_id) {
    ...DeliveryZoneFragment
    sites {
      _id
      name
      organizationName
    }
  }
}
    ${DeliveryZoneFragmentFragmentDoc}`;

/**
 * __useGetDeliveryZoneQuery__
 *
 * To run a query within a React component, call `useGetDeliveryZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryZoneQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useGetDeliveryZoneQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryZoneQuery, GetDeliveryZoneQueryVariables> & ({ variables: GetDeliveryZoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryZoneQuery, GetDeliveryZoneQueryVariables>(GetDeliveryZoneDocument, options);
      }
export function useGetDeliveryZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryZoneQuery, GetDeliveryZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryZoneQuery, GetDeliveryZoneQueryVariables>(GetDeliveryZoneDocument, options);
        }
// @ts-ignore
export function useGetDeliveryZoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeliveryZoneQuery, GetDeliveryZoneQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveryZoneQuery, GetDeliveryZoneQueryVariables>;
export function useGetDeliveryZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryZoneQuery, GetDeliveryZoneQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveryZoneQuery | undefined, GetDeliveryZoneQueryVariables>;
export function useGetDeliveryZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryZoneQuery, GetDeliveryZoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveryZoneQuery, GetDeliveryZoneQueryVariables>(GetDeliveryZoneDocument, options);
        }
export type GetDeliveryZoneQueryHookResult = ReturnType<typeof useGetDeliveryZoneQuery>;
export type GetDeliveryZoneLazyQueryHookResult = ReturnType<typeof useGetDeliveryZoneLazyQuery>;
export type GetDeliveryZoneSuspenseQueryHookResult = ReturnType<typeof useGetDeliveryZoneSuspenseQuery>;
export type GetDeliveryZoneQueryResult = Apollo.QueryResult<GetDeliveryZoneQuery, GetDeliveryZoneQueryVariables>;
export const GetDynamicDeliveryPlanningRowsForDateDocument = gql`
    query GET_DYNAMIC_DELIVERY_PLANNING_ROWS_FOR_DATE($date: String!) {
  getDynamicDeliveryPlanningRowsForDate(date: $date) {
    _id
    columnId
    date
    isManual
    isActive
    rank
    secondaryRank
    finalRank
    tourOrder
    bucket
    totem {
      latitude
      longitude
    }
    thresholds {
      templateType
      contractType
      qualityPassPercent
      criticalPassPercent
      requiredPassPercent
      maxDaysWithoutDelivery
    }
    parentDynamicDeliveryPlanningId
    parentColumn {
      _id
      name
    }
    column {
      _id
      name
      machineCode
      microstoreColumnTemplateName
      type
      useDynamicDelivery
    }
    site {
      _id
      name
      totemId
      organizationName
      contractType
    }
    assignedDelivererId
    referentDelivererId
    deliveryZone {
      _id
      name
      color
    }
    referentDeliverer {
      _id
      profile {
        fullname
      }
    }
    assignedDeliverer {
      _id
      profile {
        fullname
      }
    }
    metrics {
      realFillRatePercent
      transactionalFillRatePercent
      trayFillRatePercent
      missingReferencesPercent
      daysSinceLastDelivery
      kgToDeliver
      volumeCm3ToDeliver
    }
  }
}
    `;

/**
 * __useGetDynamicDeliveryPlanningRowsForDateQuery__
 *
 * To run a query within a React component, call `useGetDynamicDeliveryPlanningRowsForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDynamicDeliveryPlanningRowsForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDynamicDeliveryPlanningRowsForDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetDynamicDeliveryPlanningRowsForDateQuery(baseOptions: Apollo.QueryHookOptions<GetDynamicDeliveryPlanningRowsForDateQuery, GetDynamicDeliveryPlanningRowsForDateQueryVariables> & ({ variables: GetDynamicDeliveryPlanningRowsForDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDynamicDeliveryPlanningRowsForDateQuery, GetDynamicDeliveryPlanningRowsForDateQueryVariables>(GetDynamicDeliveryPlanningRowsForDateDocument, options);
      }
export function useGetDynamicDeliveryPlanningRowsForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDynamicDeliveryPlanningRowsForDateQuery, GetDynamicDeliveryPlanningRowsForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDynamicDeliveryPlanningRowsForDateQuery, GetDynamicDeliveryPlanningRowsForDateQueryVariables>(GetDynamicDeliveryPlanningRowsForDateDocument, options);
        }
// @ts-ignore
export function useGetDynamicDeliveryPlanningRowsForDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDynamicDeliveryPlanningRowsForDateQuery, GetDynamicDeliveryPlanningRowsForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetDynamicDeliveryPlanningRowsForDateQuery, GetDynamicDeliveryPlanningRowsForDateQueryVariables>;
export function useGetDynamicDeliveryPlanningRowsForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDynamicDeliveryPlanningRowsForDateQuery, GetDynamicDeliveryPlanningRowsForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetDynamicDeliveryPlanningRowsForDateQuery | undefined, GetDynamicDeliveryPlanningRowsForDateQueryVariables>;
export function useGetDynamicDeliveryPlanningRowsForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDynamicDeliveryPlanningRowsForDateQuery, GetDynamicDeliveryPlanningRowsForDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDynamicDeliveryPlanningRowsForDateQuery, GetDynamicDeliveryPlanningRowsForDateQueryVariables>(GetDynamicDeliveryPlanningRowsForDateDocument, options);
        }
export type GetDynamicDeliveryPlanningRowsForDateQueryHookResult = ReturnType<typeof useGetDynamicDeliveryPlanningRowsForDateQuery>;
export type GetDynamicDeliveryPlanningRowsForDateLazyQueryHookResult = ReturnType<typeof useGetDynamicDeliveryPlanningRowsForDateLazyQuery>;
export type GetDynamicDeliveryPlanningRowsForDateSuspenseQueryHookResult = ReturnType<typeof useGetDynamicDeliveryPlanningRowsForDateSuspenseQuery>;
export type GetDynamicDeliveryPlanningRowsForDateQueryResult = Apollo.QueryResult<GetDynamicDeliveryPlanningRowsForDateQuery, GetDynamicDeliveryPlanningRowsForDateQueryVariables>;
export const GetEquipmentsDocument = gql`
    query GET_EQUIPMENTS {
  adminEquipments {
    _id
    fullname
    suppliers {
      _id
      name
    }
    imageUrl
    state
  }
}
    `;

/**
 * __useGetEquipmentsQuery__
 *
 * To run a query within a React component, call `useGetEquipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEquipmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetEquipmentsQuery, GetEquipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentsQuery, GetEquipmentsQueryVariables>(GetEquipmentsDocument, options);
      }
export function useGetEquipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentsQuery, GetEquipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentsQuery, GetEquipmentsQueryVariables>(GetEquipmentsDocument, options);
        }
// @ts-ignore
export function useGetEquipmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEquipmentsQuery, GetEquipmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEquipmentsQuery, GetEquipmentsQueryVariables>;
export function useGetEquipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEquipmentsQuery, GetEquipmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEquipmentsQuery | undefined, GetEquipmentsQueryVariables>;
export function useGetEquipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEquipmentsQuery, GetEquipmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEquipmentsQuery, GetEquipmentsQueryVariables>(GetEquipmentsDocument, options);
        }
export type GetEquipmentsQueryHookResult = ReturnType<typeof useGetEquipmentsQuery>;
export type GetEquipmentsLazyQueryHookResult = ReturnType<typeof useGetEquipmentsLazyQuery>;
export type GetEquipmentsSuspenseQueryHookResult = ReturnType<typeof useGetEquipmentsSuspenseQuery>;
export type GetEquipmentsQueryResult = Apollo.QueryResult<GetEquipmentsQuery, GetEquipmentsQueryVariables>;
export const GetDetailedEquipmentDocument = gql`
    query GET_DETAILED_EQUIPMENT($equipmentId: ID!) {
  detailedEquipment(equipmentId: $equipmentId) {
    ...Equipment
  }
}
    ${EquipmentFragmentDoc}`;

/**
 * __useGetDetailedEquipmentQuery__
 *
 * To run a query within a React component, call `useGetDetailedEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedEquipmentQuery({
 *   variables: {
 *      equipmentId: // value for 'equipmentId'
 *   },
 * });
 */
export function useGetDetailedEquipmentQuery(baseOptions: Apollo.QueryHookOptions<GetDetailedEquipmentQuery, GetDetailedEquipmentQueryVariables> & ({ variables: GetDetailedEquipmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailedEquipmentQuery, GetDetailedEquipmentQueryVariables>(GetDetailedEquipmentDocument, options);
      }
export function useGetDetailedEquipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailedEquipmentQuery, GetDetailedEquipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailedEquipmentQuery, GetDetailedEquipmentQueryVariables>(GetDetailedEquipmentDocument, options);
        }
// @ts-ignore
export function useGetDetailedEquipmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDetailedEquipmentQuery, GetDetailedEquipmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedEquipmentQuery, GetDetailedEquipmentQueryVariables>;
export function useGetDetailedEquipmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedEquipmentQuery, GetDetailedEquipmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedEquipmentQuery | undefined, GetDetailedEquipmentQueryVariables>;
export function useGetDetailedEquipmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedEquipmentQuery, GetDetailedEquipmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailedEquipmentQuery, GetDetailedEquipmentQueryVariables>(GetDetailedEquipmentDocument, options);
        }
export type GetDetailedEquipmentQueryHookResult = ReturnType<typeof useGetDetailedEquipmentQuery>;
export type GetDetailedEquipmentLazyQueryHookResult = ReturnType<typeof useGetDetailedEquipmentLazyQuery>;
export type GetDetailedEquipmentSuspenseQueryHookResult = ReturnType<typeof useGetDetailedEquipmentSuspenseQuery>;
export type GetDetailedEquipmentQueryResult = Apollo.QueryResult<GetDetailedEquipmentQuery, GetDetailedEquipmentQueryVariables>;
export const GetExpiryDateRecordsForSiteDocument = gql`
    query GET_EXPIRY_DATE_RECORDS_FOR_SITE($columnId: ID!) {
  getExpiryDateRecordsForSiteQuery(columnId: $columnId) {
    ...ExpiryDateRecordFragment
  }
}
    ${ExpiryDateRecordFragmentFragmentDoc}`;

/**
 * __useGetExpiryDateRecordsForSiteQuery__
 *
 * To run a query within a React component, call `useGetExpiryDateRecordsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpiryDateRecordsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpiryDateRecordsForSiteQuery({
 *   variables: {
 *      columnId: // value for 'columnId'
 *   },
 * });
 */
export function useGetExpiryDateRecordsForSiteQuery(baseOptions: Apollo.QueryHookOptions<GetExpiryDateRecordsForSiteQuery, GetExpiryDateRecordsForSiteQueryVariables> & ({ variables: GetExpiryDateRecordsForSiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpiryDateRecordsForSiteQuery, GetExpiryDateRecordsForSiteQueryVariables>(GetExpiryDateRecordsForSiteDocument, options);
      }
export function useGetExpiryDateRecordsForSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpiryDateRecordsForSiteQuery, GetExpiryDateRecordsForSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpiryDateRecordsForSiteQuery, GetExpiryDateRecordsForSiteQueryVariables>(GetExpiryDateRecordsForSiteDocument, options);
        }
// @ts-ignore
export function useGetExpiryDateRecordsForSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExpiryDateRecordsForSiteQuery, GetExpiryDateRecordsForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetExpiryDateRecordsForSiteQuery, GetExpiryDateRecordsForSiteQueryVariables>;
export function useGetExpiryDateRecordsForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExpiryDateRecordsForSiteQuery, GetExpiryDateRecordsForSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetExpiryDateRecordsForSiteQuery | undefined, GetExpiryDateRecordsForSiteQueryVariables>;
export function useGetExpiryDateRecordsForSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExpiryDateRecordsForSiteQuery, GetExpiryDateRecordsForSiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpiryDateRecordsForSiteQuery, GetExpiryDateRecordsForSiteQueryVariables>(GetExpiryDateRecordsForSiteDocument, options);
        }
export type GetExpiryDateRecordsForSiteQueryHookResult = ReturnType<typeof useGetExpiryDateRecordsForSiteQuery>;
export type GetExpiryDateRecordsForSiteLazyQueryHookResult = ReturnType<typeof useGetExpiryDateRecordsForSiteLazyQuery>;
export type GetExpiryDateRecordsForSiteSuspenseQueryHookResult = ReturnType<typeof useGetExpiryDateRecordsForSiteSuspenseQuery>;
export type GetExpiryDateRecordsForSiteQueryResult = Apollo.QueryResult<GetExpiryDateRecordsForSiteQuery, GetExpiryDateRecordsForSiteQueryVariables>;
export const GetFutureStockVariationsByProductDocument = gql`
    query GET_FUTURE_STOCK_VARIATIONS_BY_PRODUCT($warehouseColumnId: ID!, $productId: String!) {
  futureStockVariationsByProduct(
    warehouseColumnId: $warehouseColumnId
    productId: $productId
  ) {
    ...FutureStockVariationFragment
  }
}
    ${FutureStockVariationFragmentFragmentDoc}`;

/**
 * __useGetFutureStockVariationsByProductQuery__
 *
 * To run a query within a React component, call `useGetFutureStockVariationsByProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFutureStockVariationsByProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFutureStockVariationsByProductQuery({
 *   variables: {
 *      warehouseColumnId: // value for 'warehouseColumnId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetFutureStockVariationsByProductQuery(baseOptions: Apollo.QueryHookOptions<GetFutureStockVariationsByProductQuery, GetFutureStockVariationsByProductQueryVariables> & ({ variables: GetFutureStockVariationsByProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFutureStockVariationsByProductQuery, GetFutureStockVariationsByProductQueryVariables>(GetFutureStockVariationsByProductDocument, options);
      }
export function useGetFutureStockVariationsByProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFutureStockVariationsByProductQuery, GetFutureStockVariationsByProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFutureStockVariationsByProductQuery, GetFutureStockVariationsByProductQueryVariables>(GetFutureStockVariationsByProductDocument, options);
        }
// @ts-ignore
export function useGetFutureStockVariationsByProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFutureStockVariationsByProductQuery, GetFutureStockVariationsByProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetFutureStockVariationsByProductQuery, GetFutureStockVariationsByProductQueryVariables>;
export function useGetFutureStockVariationsByProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFutureStockVariationsByProductQuery, GetFutureStockVariationsByProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetFutureStockVariationsByProductQuery | undefined, GetFutureStockVariationsByProductQueryVariables>;
export function useGetFutureStockVariationsByProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFutureStockVariationsByProductQuery, GetFutureStockVariationsByProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFutureStockVariationsByProductQuery, GetFutureStockVariationsByProductQueryVariables>(GetFutureStockVariationsByProductDocument, options);
        }
export type GetFutureStockVariationsByProductQueryHookResult = ReturnType<typeof useGetFutureStockVariationsByProductQuery>;
export type GetFutureStockVariationsByProductLazyQueryHookResult = ReturnType<typeof useGetFutureStockVariationsByProductLazyQuery>;
export type GetFutureStockVariationsByProductSuspenseQueryHookResult = ReturnType<typeof useGetFutureStockVariationsByProductSuspenseQuery>;
export type GetFutureStockVariationsByProductQueryResult = Apollo.QueryResult<GetFutureStockVariationsByProductQuery, GetFutureStockVariationsByProductQueryVariables>;
export const GetExpiredFutureStockVariationsDocument = gql`
    query GET_EXPIRED_FUTURE_STOCK_VARIATIONS {
  expiredFutureStockVariations {
    ...FutureStockVariationFragment
    productName
  }
}
    ${FutureStockVariationFragmentFragmentDoc}`;

/**
 * __useGetExpiredFutureStockVariationsQuery__
 *
 * To run a query within a React component, call `useGetExpiredFutureStockVariationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpiredFutureStockVariationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpiredFutureStockVariationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExpiredFutureStockVariationsQuery(baseOptions?: Apollo.QueryHookOptions<GetExpiredFutureStockVariationsQuery, GetExpiredFutureStockVariationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpiredFutureStockVariationsQuery, GetExpiredFutureStockVariationsQueryVariables>(GetExpiredFutureStockVariationsDocument, options);
      }
export function useGetExpiredFutureStockVariationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpiredFutureStockVariationsQuery, GetExpiredFutureStockVariationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpiredFutureStockVariationsQuery, GetExpiredFutureStockVariationsQueryVariables>(GetExpiredFutureStockVariationsDocument, options);
        }
// @ts-ignore
export function useGetExpiredFutureStockVariationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExpiredFutureStockVariationsQuery, GetExpiredFutureStockVariationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExpiredFutureStockVariationsQuery, GetExpiredFutureStockVariationsQueryVariables>;
export function useGetExpiredFutureStockVariationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExpiredFutureStockVariationsQuery, GetExpiredFutureStockVariationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExpiredFutureStockVariationsQuery | undefined, GetExpiredFutureStockVariationsQueryVariables>;
export function useGetExpiredFutureStockVariationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExpiredFutureStockVariationsQuery, GetExpiredFutureStockVariationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpiredFutureStockVariationsQuery, GetExpiredFutureStockVariationsQueryVariables>(GetExpiredFutureStockVariationsDocument, options);
        }
export type GetExpiredFutureStockVariationsQueryHookResult = ReturnType<typeof useGetExpiredFutureStockVariationsQuery>;
export type GetExpiredFutureStockVariationsLazyQueryHookResult = ReturnType<typeof useGetExpiredFutureStockVariationsLazyQuery>;
export type GetExpiredFutureStockVariationsSuspenseQueryHookResult = ReturnType<typeof useGetExpiredFutureStockVariationsSuspenseQuery>;
export type GetExpiredFutureStockVariationsQueryResult = Apollo.QueryResult<GetExpiredFutureStockVariationsQuery, GetExpiredFutureStockVariationsQueryVariables>;
export const ReplaceableProductOrdersAndFutureStockVariationsDocument = gql`
    query REPLACEABLE_PRODUCT_ORDERS_AND_FUTURE_STOCK_VARIATIONS($productId: String!) {
  replaceableProductOrdersAndFutureStockVariations(productId: $productId) {
    futureStockVariations {
      ...FutureStockVariationFragment
    }
    orders {
      _id
      date_delivery
      number
      organization {
        name
      }
      products {
        _id
        orderId
        quantity
      }
      state
      totem {
        _id
        number
      }
    }
  }
}
    ${FutureStockVariationFragmentFragmentDoc}`;

/**
 * __useReplaceableProductOrdersAndFutureStockVariationsQuery__
 *
 * To run a query within a React component, call `useReplaceableProductOrdersAndFutureStockVariationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReplaceableProductOrdersAndFutureStockVariationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReplaceableProductOrdersAndFutureStockVariationsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useReplaceableProductOrdersAndFutureStockVariationsQuery(baseOptions: Apollo.QueryHookOptions<ReplaceableProductOrdersAndFutureStockVariationsQuery, ReplaceableProductOrdersAndFutureStockVariationsQueryVariables> & ({ variables: ReplaceableProductOrdersAndFutureStockVariationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReplaceableProductOrdersAndFutureStockVariationsQuery, ReplaceableProductOrdersAndFutureStockVariationsQueryVariables>(ReplaceableProductOrdersAndFutureStockVariationsDocument, options);
      }
export function useReplaceableProductOrdersAndFutureStockVariationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReplaceableProductOrdersAndFutureStockVariationsQuery, ReplaceableProductOrdersAndFutureStockVariationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReplaceableProductOrdersAndFutureStockVariationsQuery, ReplaceableProductOrdersAndFutureStockVariationsQueryVariables>(ReplaceableProductOrdersAndFutureStockVariationsDocument, options);
        }
// @ts-ignore
export function useReplaceableProductOrdersAndFutureStockVariationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReplaceableProductOrdersAndFutureStockVariationsQuery, ReplaceableProductOrdersAndFutureStockVariationsQueryVariables>): Apollo.UseSuspenseQueryResult<ReplaceableProductOrdersAndFutureStockVariationsQuery, ReplaceableProductOrdersAndFutureStockVariationsQueryVariables>;
export function useReplaceableProductOrdersAndFutureStockVariationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReplaceableProductOrdersAndFutureStockVariationsQuery, ReplaceableProductOrdersAndFutureStockVariationsQueryVariables>): Apollo.UseSuspenseQueryResult<ReplaceableProductOrdersAndFutureStockVariationsQuery | undefined, ReplaceableProductOrdersAndFutureStockVariationsQueryVariables>;
export function useReplaceableProductOrdersAndFutureStockVariationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReplaceableProductOrdersAndFutureStockVariationsQuery, ReplaceableProductOrdersAndFutureStockVariationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReplaceableProductOrdersAndFutureStockVariationsQuery, ReplaceableProductOrdersAndFutureStockVariationsQueryVariables>(ReplaceableProductOrdersAndFutureStockVariationsDocument, options);
        }
export type ReplaceableProductOrdersAndFutureStockVariationsQueryHookResult = ReturnType<typeof useReplaceableProductOrdersAndFutureStockVariationsQuery>;
export type ReplaceableProductOrdersAndFutureStockVariationsLazyQueryHookResult = ReturnType<typeof useReplaceableProductOrdersAndFutureStockVariationsLazyQuery>;
export type ReplaceableProductOrdersAndFutureStockVariationsSuspenseQueryHookResult = ReturnType<typeof useReplaceableProductOrdersAndFutureStockVariationsSuspenseQuery>;
export type ReplaceableProductOrdersAndFutureStockVariationsQueryResult = Apollo.QueryResult<ReplaceableProductOrdersAndFutureStockVariationsQuery, ReplaceableProductOrdersAndFutureStockVariationsQueryVariables>;
export const GetPlaceAutocompleteSuggestionsDocument = gql`
    query GET_PLACE_AUTOCOMPLETE_SUGGESTIONS($input: String!) {
  getPlaceAutocompleteSuggestions(input: $input) {
    placeId
    description
  }
}
    `;

/**
 * __useGetPlaceAutocompleteSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetPlaceAutocompleteSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceAutocompleteSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceAutocompleteSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPlaceAutocompleteSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables> & ({ variables: GetPlaceAutocompleteSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>(GetPlaceAutocompleteSuggestionsDocument, options);
      }
export function useGetPlaceAutocompleteSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>(GetPlaceAutocompleteSuggestionsDocument, options);
        }
// @ts-ignore
export function useGetPlaceAutocompleteSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>;
export function useGetPlaceAutocompleteSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlaceAutocompleteSuggestionsQuery | undefined, GetPlaceAutocompleteSuggestionsQueryVariables>;
export function useGetPlaceAutocompleteSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>(GetPlaceAutocompleteSuggestionsDocument, options);
        }
export type GetPlaceAutocompleteSuggestionsQueryHookResult = ReturnType<typeof useGetPlaceAutocompleteSuggestionsQuery>;
export type GetPlaceAutocompleteSuggestionsLazyQueryHookResult = ReturnType<typeof useGetPlaceAutocompleteSuggestionsLazyQuery>;
export type GetPlaceAutocompleteSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetPlaceAutocompleteSuggestionsSuspenseQuery>;
export type GetPlaceAutocompleteSuggestionsQueryResult = Apollo.QueryResult<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>;
export const GetPlaceDetailsDocument = gql`
    query GET_PLACE_DETAILS($placeId: String!) {
  getPlaceDetails(placeId: $placeId) {
    placeId
    name
    formattedAddress
    latitude
    longitude
    city
    zipcode
    country
    streetNumber
  }
}
    `;

/**
 * __useGetPlaceDetailsQuery__
 *
 * To run a query within a React component, call `useGetPlaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceDetailsQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function useGetPlaceDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables> & ({ variables: GetPlaceDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(GetPlaceDetailsDocument, options);
      }
export function useGetPlaceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(GetPlaceDetailsDocument, options);
        }
// @ts-ignore
export function useGetPlaceDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>;
export function useGetPlaceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlaceDetailsQuery | undefined, GetPlaceDetailsQueryVariables>;
export function useGetPlaceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(GetPlaceDetailsDocument, options);
        }
export type GetPlaceDetailsQueryHookResult = ReturnType<typeof useGetPlaceDetailsQuery>;
export type GetPlaceDetailsLazyQueryHookResult = ReturnType<typeof useGetPlaceDetailsLazyQuery>;
export type GetPlaceDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPlaceDetailsSuspenseQuery>;
export type GetPlaceDetailsQueryResult = Apollo.QueryResult<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>;
export const GetSiteLocationPlanogramsDocument = gql`
    query GET_SITE_LOCATION_PLANOGRAMS($siteId: ID!) {
  getSiteLocationPlanograms(siteId: $siteId) {
    ...LocationPlanogramFragment
  }
}
    ${LocationPlanogramFragmentFragmentDoc}`;

/**
 * __useGetSiteLocationPlanogramsQuery__
 *
 * To run a query within a React component, call `useGetSiteLocationPlanogramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteLocationPlanogramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteLocationPlanogramsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteLocationPlanogramsQuery(baseOptions: Apollo.QueryHookOptions<GetSiteLocationPlanogramsQuery, GetSiteLocationPlanogramsQueryVariables> & ({ variables: GetSiteLocationPlanogramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteLocationPlanogramsQuery, GetSiteLocationPlanogramsQueryVariables>(GetSiteLocationPlanogramsDocument, options);
      }
export function useGetSiteLocationPlanogramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteLocationPlanogramsQuery, GetSiteLocationPlanogramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteLocationPlanogramsQuery, GetSiteLocationPlanogramsQueryVariables>(GetSiteLocationPlanogramsDocument, options);
        }
// @ts-ignore
export function useGetSiteLocationPlanogramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteLocationPlanogramsQuery, GetSiteLocationPlanogramsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteLocationPlanogramsQuery, GetSiteLocationPlanogramsQueryVariables>;
export function useGetSiteLocationPlanogramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteLocationPlanogramsQuery, GetSiteLocationPlanogramsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteLocationPlanogramsQuery | undefined, GetSiteLocationPlanogramsQueryVariables>;
export function useGetSiteLocationPlanogramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteLocationPlanogramsQuery, GetSiteLocationPlanogramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteLocationPlanogramsQuery, GetSiteLocationPlanogramsQueryVariables>(GetSiteLocationPlanogramsDocument, options);
        }
export type GetSiteLocationPlanogramsQueryHookResult = ReturnType<typeof useGetSiteLocationPlanogramsQuery>;
export type GetSiteLocationPlanogramsLazyQueryHookResult = ReturnType<typeof useGetSiteLocationPlanogramsLazyQuery>;
export type GetSiteLocationPlanogramsSuspenseQueryHookResult = ReturnType<typeof useGetSiteLocationPlanogramsSuspenseQuery>;
export type GetSiteLocationPlanogramsQueryResult = Apollo.QueryResult<GetSiteLocationPlanogramsQuery, GetSiteLocationPlanogramsQueryVariables>;
export const GetLocationsByWarehouseColumnIdDocument = gql`
    query GET_LOCATIONS_BY_WAREHOUSE_COLUMN_ID($warehouseColumnId: ID!) {
  locationsByWarehouseColumnId(warehouseColumnId: $warehouseColumnId) {
    _id
    index
    state
    datamatrix
    locationType
    productId
    product {
      name
    }
    zone
  }
}
    `;

/**
 * __useGetLocationsByWarehouseColumnIdQuery__
 *
 * To run a query within a React component, call `useGetLocationsByWarehouseColumnIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsByWarehouseColumnIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsByWarehouseColumnIdQuery({
 *   variables: {
 *      warehouseColumnId: // value for 'warehouseColumnId'
 *   },
 * });
 */
export function useGetLocationsByWarehouseColumnIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationsByWarehouseColumnIdQuery, GetLocationsByWarehouseColumnIdQueryVariables> & ({ variables: GetLocationsByWarehouseColumnIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsByWarehouseColumnIdQuery, GetLocationsByWarehouseColumnIdQueryVariables>(GetLocationsByWarehouseColumnIdDocument, options);
      }
export function useGetLocationsByWarehouseColumnIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsByWarehouseColumnIdQuery, GetLocationsByWarehouseColumnIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsByWarehouseColumnIdQuery, GetLocationsByWarehouseColumnIdQueryVariables>(GetLocationsByWarehouseColumnIdDocument, options);
        }
// @ts-ignore
export function useGetLocationsByWarehouseColumnIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationsByWarehouseColumnIdQuery, GetLocationsByWarehouseColumnIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationsByWarehouseColumnIdQuery, GetLocationsByWarehouseColumnIdQueryVariables>;
export function useGetLocationsByWarehouseColumnIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationsByWarehouseColumnIdQuery, GetLocationsByWarehouseColumnIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationsByWarehouseColumnIdQuery | undefined, GetLocationsByWarehouseColumnIdQueryVariables>;
export function useGetLocationsByWarehouseColumnIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationsByWarehouseColumnIdQuery, GetLocationsByWarehouseColumnIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationsByWarehouseColumnIdQuery, GetLocationsByWarehouseColumnIdQueryVariables>(GetLocationsByWarehouseColumnIdDocument, options);
        }
export type GetLocationsByWarehouseColumnIdQueryHookResult = ReturnType<typeof useGetLocationsByWarehouseColumnIdQuery>;
export type GetLocationsByWarehouseColumnIdLazyQueryHookResult = ReturnType<typeof useGetLocationsByWarehouseColumnIdLazyQuery>;
export type GetLocationsByWarehouseColumnIdSuspenseQueryHookResult = ReturnType<typeof useGetLocationsByWarehouseColumnIdSuspenseQuery>;
export type GetLocationsByWarehouseColumnIdQueryResult = Apollo.QueryResult<GetLocationsByWarehouseColumnIdQuery, GetLocationsByWarehouseColumnIdQueryVariables>;
export const GetManualSupplyOrdersDocument = gql`
    query GET_MANUAL_SUPPLY_ORDERS {
  manualSupplyOrders {
    ...SupplyOrderWithSupplierProductsInfoFragment
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;

/**
 * __useGetManualSupplyOrdersQuery__
 *
 * To run a query within a React component, call `useGetManualSupplyOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManualSupplyOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManualSupplyOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManualSupplyOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetManualSupplyOrdersQuery, GetManualSupplyOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManualSupplyOrdersQuery, GetManualSupplyOrdersQueryVariables>(GetManualSupplyOrdersDocument, options);
      }
export function useGetManualSupplyOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManualSupplyOrdersQuery, GetManualSupplyOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManualSupplyOrdersQuery, GetManualSupplyOrdersQueryVariables>(GetManualSupplyOrdersDocument, options);
        }
// @ts-ignore
export function useGetManualSupplyOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManualSupplyOrdersQuery, GetManualSupplyOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetManualSupplyOrdersQuery, GetManualSupplyOrdersQueryVariables>;
export function useGetManualSupplyOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManualSupplyOrdersQuery, GetManualSupplyOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetManualSupplyOrdersQuery | undefined, GetManualSupplyOrdersQueryVariables>;
export function useGetManualSupplyOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManualSupplyOrdersQuery, GetManualSupplyOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManualSupplyOrdersQuery, GetManualSupplyOrdersQueryVariables>(GetManualSupplyOrdersDocument, options);
        }
export type GetManualSupplyOrdersQueryHookResult = ReturnType<typeof useGetManualSupplyOrdersQuery>;
export type GetManualSupplyOrdersLazyQueryHookResult = ReturnType<typeof useGetManualSupplyOrdersLazyQuery>;
export type GetManualSupplyOrdersSuspenseQueryHookResult = ReturnType<typeof useGetManualSupplyOrdersSuspenseQuery>;
export type GetManualSupplyOrdersQueryResult = Apollo.QueryResult<GetManualSupplyOrdersQuery, GetManualSupplyOrdersQueryVariables>;
export const GetManualSupplyOrderSupplierProductsStockVariationDocument = gql`
    query GET_MANUAL_SUPPLY_ORDER_SUPPLIER_PRODUCTS_STOCK_VARIATION {
  manualSupplyOrderSupplierProductsStockVariation {
    productGroupStockVariations {
      ...SupplyOrderProductStockVariationFragment
      isComputed
    }
    supplyOrderStockVariations {
      ...SupplyOrderProductStockVariationFragment
      isComputed
    }
  }
}
    ${SupplyOrderProductStockVariationFragmentFragmentDoc}`;

/**
 * __useGetManualSupplyOrderSupplierProductsStockVariationQuery__
 *
 * To run a query within a React component, call `useGetManualSupplyOrderSupplierProductsStockVariationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManualSupplyOrderSupplierProductsStockVariationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManualSupplyOrderSupplierProductsStockVariationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManualSupplyOrderSupplierProductsStockVariationQuery(baseOptions?: Apollo.QueryHookOptions<GetManualSupplyOrderSupplierProductsStockVariationQuery, GetManualSupplyOrderSupplierProductsStockVariationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManualSupplyOrderSupplierProductsStockVariationQuery, GetManualSupplyOrderSupplierProductsStockVariationQueryVariables>(GetManualSupplyOrderSupplierProductsStockVariationDocument, options);
      }
export function useGetManualSupplyOrderSupplierProductsStockVariationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManualSupplyOrderSupplierProductsStockVariationQuery, GetManualSupplyOrderSupplierProductsStockVariationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManualSupplyOrderSupplierProductsStockVariationQuery, GetManualSupplyOrderSupplierProductsStockVariationQueryVariables>(GetManualSupplyOrderSupplierProductsStockVariationDocument, options);
        }
// @ts-ignore
export function useGetManualSupplyOrderSupplierProductsStockVariationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManualSupplyOrderSupplierProductsStockVariationQuery, GetManualSupplyOrderSupplierProductsStockVariationQueryVariables>): Apollo.UseSuspenseQueryResult<GetManualSupplyOrderSupplierProductsStockVariationQuery, GetManualSupplyOrderSupplierProductsStockVariationQueryVariables>;
export function useGetManualSupplyOrderSupplierProductsStockVariationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManualSupplyOrderSupplierProductsStockVariationQuery, GetManualSupplyOrderSupplierProductsStockVariationQueryVariables>): Apollo.UseSuspenseQueryResult<GetManualSupplyOrderSupplierProductsStockVariationQuery | undefined, GetManualSupplyOrderSupplierProductsStockVariationQueryVariables>;
export function useGetManualSupplyOrderSupplierProductsStockVariationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManualSupplyOrderSupplierProductsStockVariationQuery, GetManualSupplyOrderSupplierProductsStockVariationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManualSupplyOrderSupplierProductsStockVariationQuery, GetManualSupplyOrderSupplierProductsStockVariationQueryVariables>(GetManualSupplyOrderSupplierProductsStockVariationDocument, options);
        }
export type GetManualSupplyOrderSupplierProductsStockVariationQueryHookResult = ReturnType<typeof useGetManualSupplyOrderSupplierProductsStockVariationQuery>;
export type GetManualSupplyOrderSupplierProductsStockVariationLazyQueryHookResult = ReturnType<typeof useGetManualSupplyOrderSupplierProductsStockVariationLazyQuery>;
export type GetManualSupplyOrderSupplierProductsStockVariationSuspenseQueryHookResult = ReturnType<typeof useGetManualSupplyOrderSupplierProductsStockVariationSuspenseQuery>;
export type GetManualSupplyOrderSupplierProductsStockVariationQueryResult = Apollo.QueryResult<GetManualSupplyOrderSupplierProductsStockVariationQuery, GetManualSupplyOrderSupplierProductsStockVariationQueryVariables>;
export const GetMenuInstructionsDocument = gql`
    query GET_MENU_INSTRUCTIONS($dates: [String!]!) {
  menuInstructions(dates: $dates) {
    ...MenuInstructionFragment
  }
}
    ${MenuInstructionFragmentFragmentDoc}`;

/**
 * __useGetMenuInstructionsQuery__
 *
 * To run a query within a React component, call `useGetMenuInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuInstructionsQuery({
 *   variables: {
 *      dates: // value for 'dates'
 *   },
 * });
 */
export function useGetMenuInstructionsQuery(baseOptions: Apollo.QueryHookOptions<GetMenuInstructionsQuery, GetMenuInstructionsQueryVariables> & ({ variables: GetMenuInstructionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuInstructionsQuery, GetMenuInstructionsQueryVariables>(GetMenuInstructionsDocument, options);
      }
export function useGetMenuInstructionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuInstructionsQuery, GetMenuInstructionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuInstructionsQuery, GetMenuInstructionsQueryVariables>(GetMenuInstructionsDocument, options);
        }
// @ts-ignore
export function useGetMenuInstructionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMenuInstructionsQuery, GetMenuInstructionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuInstructionsQuery, GetMenuInstructionsQueryVariables>;
export function useGetMenuInstructionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuInstructionsQuery, GetMenuInstructionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuInstructionsQuery | undefined, GetMenuInstructionsQueryVariables>;
export function useGetMenuInstructionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuInstructionsQuery, GetMenuInstructionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuInstructionsQuery, GetMenuInstructionsQueryVariables>(GetMenuInstructionsDocument, options);
        }
export type GetMenuInstructionsQueryHookResult = ReturnType<typeof useGetMenuInstructionsQuery>;
export type GetMenuInstructionsLazyQueryHookResult = ReturnType<typeof useGetMenuInstructionsLazyQuery>;
export type GetMenuInstructionsSuspenseQueryHookResult = ReturnType<typeof useGetMenuInstructionsSuspenseQuery>;
export type GetMenuInstructionsQueryResult = Apollo.QueryResult<GetMenuInstructionsQuery, GetMenuInstructionsQueryVariables>;
export const GetSiteMenusDocument = gql`
    query GET_SITE_MENUS($siteId: String!, $date: String!) {
  siteMenus(siteId: $siteId, date: $date) {
    ...SiteMenusFragment
  }
}
    ${SiteMenusFragmentFragmentDoc}`;

/**
 * __useGetSiteMenusQuery__
 *
 * To run a query within a React component, call `useGetSiteMenusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteMenusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteMenusQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetSiteMenusQuery(baseOptions: Apollo.QueryHookOptions<GetSiteMenusQuery, GetSiteMenusQueryVariables> & ({ variables: GetSiteMenusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteMenusQuery, GetSiteMenusQueryVariables>(GetSiteMenusDocument, options);
      }
export function useGetSiteMenusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteMenusQuery, GetSiteMenusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteMenusQuery, GetSiteMenusQueryVariables>(GetSiteMenusDocument, options);
        }
// @ts-ignore
export function useGetSiteMenusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteMenusQuery, GetSiteMenusQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteMenusQuery, GetSiteMenusQueryVariables>;
export function useGetSiteMenusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteMenusQuery, GetSiteMenusQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteMenusQuery | undefined, GetSiteMenusQueryVariables>;
export function useGetSiteMenusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteMenusQuery, GetSiteMenusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteMenusQuery, GetSiteMenusQueryVariables>(GetSiteMenusDocument, options);
        }
export type GetSiteMenusQueryHookResult = ReturnType<typeof useGetSiteMenusQuery>;
export type GetSiteMenusLazyQueryHookResult = ReturnType<typeof useGetSiteMenusLazyQuery>;
export type GetSiteMenusSuspenseQueryHookResult = ReturnType<typeof useGetSiteMenusSuspenseQuery>;
export type GetSiteMenusQueryResult = Apollo.QueryResult<GetSiteMenusQuery, GetSiteMenusQueryVariables>;
export const GetMenuProductArrangementsDocument = gql`
    query GET_MENU_PRODUCT_ARRANGEMENTS($date: String!) {
  menuProductArrangements(date: $date) {
    ...MenuProductArrangementFragment
  }
}
    ${MenuProductArrangementFragmentFragmentDoc}`;

/**
 * __useGetMenuProductArrangementsQuery__
 *
 * To run a query within a React component, call `useGetMenuProductArrangementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuProductArrangementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuProductArrangementsQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetMenuProductArrangementsQuery(baseOptions: Apollo.QueryHookOptions<GetMenuProductArrangementsQuery, GetMenuProductArrangementsQueryVariables> & ({ variables: GetMenuProductArrangementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuProductArrangementsQuery, GetMenuProductArrangementsQueryVariables>(GetMenuProductArrangementsDocument, options);
      }
export function useGetMenuProductArrangementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuProductArrangementsQuery, GetMenuProductArrangementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuProductArrangementsQuery, GetMenuProductArrangementsQueryVariables>(GetMenuProductArrangementsDocument, options);
        }
// @ts-ignore
export function useGetMenuProductArrangementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMenuProductArrangementsQuery, GetMenuProductArrangementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuProductArrangementsQuery, GetMenuProductArrangementsQueryVariables>;
export function useGetMenuProductArrangementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuProductArrangementsQuery, GetMenuProductArrangementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuProductArrangementsQuery | undefined, GetMenuProductArrangementsQueryVariables>;
export function useGetMenuProductArrangementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuProductArrangementsQuery, GetMenuProductArrangementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuProductArrangementsQuery, GetMenuProductArrangementsQueryVariables>(GetMenuProductArrangementsDocument, options);
        }
export type GetMenuProductArrangementsQueryHookResult = ReturnType<typeof useGetMenuProductArrangementsQuery>;
export type GetMenuProductArrangementsLazyQueryHookResult = ReturnType<typeof useGetMenuProductArrangementsLazyQuery>;
export type GetMenuProductArrangementsSuspenseQueryHookResult = ReturnType<typeof useGetMenuProductArrangementsSuspenseQuery>;
export type GetMenuProductArrangementsQueryResult = Apollo.QueryResult<GetMenuProductArrangementsQuery, GetMenuProductArrangementsQueryVariables>;
export const GetSiteColumnsDocument = gql`
    query GET_SITE_COLUMNS($siteId: String!) {
  siteWithLocationTemplates(siteId: $siteId) {
    _id
    microstoreColumnGroups {
      _id
      columns {
        _id
        microstoreColumnTemplateName
        type
        shelves {
          _id
          positionInColumn
          locationTable {
            _id
            positionInShelf {
              column
              row
            }
            microstoreLocationTemplate {
              _id
              productArrangementId
              productArrangement {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSiteColumnsQuery__
 *
 * To run a query within a React component, call `useGetSiteColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteColumnsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteColumnsQuery(baseOptions: Apollo.QueryHookOptions<GetSiteColumnsQuery, GetSiteColumnsQueryVariables> & ({ variables: GetSiteColumnsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteColumnsQuery, GetSiteColumnsQueryVariables>(GetSiteColumnsDocument, options);
      }
export function useGetSiteColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteColumnsQuery, GetSiteColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteColumnsQuery, GetSiteColumnsQueryVariables>(GetSiteColumnsDocument, options);
        }
// @ts-ignore
export function useGetSiteColumnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteColumnsQuery, GetSiteColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteColumnsQuery, GetSiteColumnsQueryVariables>;
export function useGetSiteColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteColumnsQuery, GetSiteColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteColumnsQuery | undefined, GetSiteColumnsQueryVariables>;
export function useGetSiteColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteColumnsQuery, GetSiteColumnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteColumnsQuery, GetSiteColumnsQueryVariables>(GetSiteColumnsDocument, options);
        }
export type GetSiteColumnsQueryHookResult = ReturnType<typeof useGetSiteColumnsQuery>;
export type GetSiteColumnsLazyQueryHookResult = ReturnType<typeof useGetSiteColumnsLazyQuery>;
export type GetSiteColumnsSuspenseQueryHookResult = ReturnType<typeof useGetSiteColumnsSuspenseQuery>;
export type GetSiteColumnsQueryResult = Apollo.QueryResult<GetSiteColumnsQuery, GetSiteColumnsQueryVariables>;
export const GetMenuQuantitiesDocument = gql`
    query GET_MENU_QUANTITIES($date: String!) {
  menuQuantities(date: $date) {
    site {
      _id
      name
    }
    columns {
      column {
        _id
        name
      }
      categoryQuantities {
        category {
          _id
          title
        }
        dateQuantities {
          date
          quantity
          quantityFacing
          quantityInstruction
          quantityFacingInstruction
        }
      }
    }
  }
}
    `;

/**
 * __useGetMenuQuantitiesQuery__
 *
 * To run a query within a React component, call `useGetMenuQuantitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuQuantitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuQuantitiesQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetMenuQuantitiesQuery(baseOptions: Apollo.QueryHookOptions<GetMenuQuantitiesQuery, GetMenuQuantitiesQueryVariables> & ({ variables: GetMenuQuantitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuQuantitiesQuery, GetMenuQuantitiesQueryVariables>(GetMenuQuantitiesDocument, options);
      }
export function useGetMenuQuantitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuQuantitiesQuery, GetMenuQuantitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuQuantitiesQuery, GetMenuQuantitiesQueryVariables>(GetMenuQuantitiesDocument, options);
        }
// @ts-ignore
export function useGetMenuQuantitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMenuQuantitiesQuery, GetMenuQuantitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuQuantitiesQuery, GetMenuQuantitiesQueryVariables>;
export function useGetMenuQuantitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuQuantitiesQuery, GetMenuQuantitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMenuQuantitiesQuery | undefined, GetMenuQuantitiesQueryVariables>;
export function useGetMenuQuantitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuQuantitiesQuery, GetMenuQuantitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuQuantitiesQuery, GetMenuQuantitiesQueryVariables>(GetMenuQuantitiesDocument, options);
        }
export type GetMenuQuantitiesQueryHookResult = ReturnType<typeof useGetMenuQuantitiesQuery>;
export type GetMenuQuantitiesLazyQueryHookResult = ReturnType<typeof useGetMenuQuantitiesLazyQuery>;
export type GetMenuQuantitiesSuspenseQueryHookResult = ReturnType<typeof useGetMenuQuantitiesSuspenseQuery>;
export type GetMenuQuantitiesQueryResult = Apollo.QueryResult<GetMenuQuantitiesQuery, GetMenuQuantitiesQueryVariables>;
export const QuantitiesGenerationStatusDocument = gql`
    query QUANTITIES_GENERATION_STATUS {
  quantitiesGenerationStatus
}
    `;

/**
 * __useQuantitiesGenerationStatusQuery__
 *
 * To run a query within a React component, call `useQuantitiesGenerationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuantitiesGenerationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuantitiesGenerationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuantitiesGenerationStatusQuery(baseOptions?: Apollo.QueryHookOptions<QuantitiesGenerationStatusQuery, QuantitiesGenerationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuantitiesGenerationStatusQuery, QuantitiesGenerationStatusQueryVariables>(QuantitiesGenerationStatusDocument, options);
      }
export function useQuantitiesGenerationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuantitiesGenerationStatusQuery, QuantitiesGenerationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuantitiesGenerationStatusQuery, QuantitiesGenerationStatusQueryVariables>(QuantitiesGenerationStatusDocument, options);
        }
// @ts-ignore
export function useQuantitiesGenerationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuantitiesGenerationStatusQuery, QuantitiesGenerationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<QuantitiesGenerationStatusQuery, QuantitiesGenerationStatusQueryVariables>;
export function useQuantitiesGenerationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuantitiesGenerationStatusQuery, QuantitiesGenerationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<QuantitiesGenerationStatusQuery | undefined, QuantitiesGenerationStatusQueryVariables>;
export function useQuantitiesGenerationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuantitiesGenerationStatusQuery, QuantitiesGenerationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuantitiesGenerationStatusQuery, QuantitiesGenerationStatusQueryVariables>(QuantitiesGenerationStatusDocument, options);
        }
export type QuantitiesGenerationStatusQueryHookResult = ReturnType<typeof useQuantitiesGenerationStatusQuery>;
export type QuantitiesGenerationStatusLazyQueryHookResult = ReturnType<typeof useQuantitiesGenerationStatusLazyQuery>;
export type QuantitiesGenerationStatusSuspenseQueryHookResult = ReturnType<typeof useQuantitiesGenerationStatusSuspenseQuery>;
export type QuantitiesGenerationStatusQueryResult = Apollo.QueryResult<QuantitiesGenerationStatusQuery, QuantitiesGenerationStatusQueryVariables>;
export const SiteMenusGenerationStatusDocument = gql`
    query SITE_MENUS_GENERATION_STATUS {
  siteMenusGenerationStatus
}
    `;

/**
 * __useSiteMenusGenerationStatusQuery__
 *
 * To run a query within a React component, call `useSiteMenusGenerationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteMenusGenerationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteMenusGenerationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteMenusGenerationStatusQuery(baseOptions?: Apollo.QueryHookOptions<SiteMenusGenerationStatusQuery, SiteMenusGenerationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteMenusGenerationStatusQuery, SiteMenusGenerationStatusQueryVariables>(SiteMenusGenerationStatusDocument, options);
      }
export function useSiteMenusGenerationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteMenusGenerationStatusQuery, SiteMenusGenerationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteMenusGenerationStatusQuery, SiteMenusGenerationStatusQueryVariables>(SiteMenusGenerationStatusDocument, options);
        }
// @ts-ignore
export function useSiteMenusGenerationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteMenusGenerationStatusQuery, SiteMenusGenerationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<SiteMenusGenerationStatusQuery, SiteMenusGenerationStatusQueryVariables>;
export function useSiteMenusGenerationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteMenusGenerationStatusQuery, SiteMenusGenerationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<SiteMenusGenerationStatusQuery | undefined, SiteMenusGenerationStatusQueryVariables>;
export function useSiteMenusGenerationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteMenusGenerationStatusQuery, SiteMenusGenerationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteMenusGenerationStatusQuery, SiteMenusGenerationStatusQueryVariables>(SiteMenusGenerationStatusDocument, options);
        }
export type SiteMenusGenerationStatusQueryHookResult = ReturnType<typeof useSiteMenusGenerationStatusQuery>;
export type SiteMenusGenerationStatusLazyQueryHookResult = ReturnType<typeof useSiteMenusGenerationStatusLazyQuery>;
export type SiteMenusGenerationStatusSuspenseQueryHookResult = ReturnType<typeof useSiteMenusGenerationStatusSuspenseQuery>;
export type SiteMenusGenerationStatusQueryResult = Apollo.QueryResult<SiteMenusGenerationStatusQuery, SiteMenusGenerationStatusQueryVariables>;
export const GetMessagesSetsPaginatedDocument = gql`
    query GET_MESSAGES_SETS_PAGINATED($offset: Int!, $limit: Int!) {
  messagesSetsPaginated(offset: $offset, limit: $limit) {
    hasMore
    messagesSets {
      ...MessagesSetFragment
    }
  }
}
    ${MessagesSetFragmentFragmentDoc}`;

/**
 * __useGetMessagesSetsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetMessagesSetsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesSetsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesSetsPaginatedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMessagesSetsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetMessagesSetsPaginatedQuery, GetMessagesSetsPaginatedQueryVariables> & ({ variables: GetMessagesSetsPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesSetsPaginatedQuery, GetMessagesSetsPaginatedQueryVariables>(GetMessagesSetsPaginatedDocument, options);
      }
export function useGetMessagesSetsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesSetsPaginatedQuery, GetMessagesSetsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesSetsPaginatedQuery, GetMessagesSetsPaginatedQueryVariables>(GetMessagesSetsPaginatedDocument, options);
        }
// @ts-ignore
export function useGetMessagesSetsPaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessagesSetsPaginatedQuery, GetMessagesSetsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessagesSetsPaginatedQuery, GetMessagesSetsPaginatedQueryVariables>;
export function useGetMessagesSetsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagesSetsPaginatedQuery, GetMessagesSetsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessagesSetsPaginatedQuery | undefined, GetMessagesSetsPaginatedQueryVariables>;
export function useGetMessagesSetsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagesSetsPaginatedQuery, GetMessagesSetsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessagesSetsPaginatedQuery, GetMessagesSetsPaginatedQueryVariables>(GetMessagesSetsPaginatedDocument, options);
        }
export type GetMessagesSetsPaginatedQueryHookResult = ReturnType<typeof useGetMessagesSetsPaginatedQuery>;
export type GetMessagesSetsPaginatedLazyQueryHookResult = ReturnType<typeof useGetMessagesSetsPaginatedLazyQuery>;
export type GetMessagesSetsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetMessagesSetsPaginatedSuspenseQuery>;
export type GetMessagesSetsPaginatedQueryResult = Apollo.QueryResult<GetMessagesSetsPaginatedQuery, GetMessagesSetsPaginatedQueryVariables>;
export const GetMessagesSetsDocument = gql`
    query GET_MESSAGES_SETS {
  messagesSets {
    ...MessagesSetFragment
  }
}
    ${MessagesSetFragmentFragmentDoc}`;

/**
 * __useGetMessagesSetsQuery__
 *
 * To run a query within a React component, call `useGetMessagesSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMessagesSetsQuery(baseOptions?: Apollo.QueryHookOptions<GetMessagesSetsQuery, GetMessagesSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesSetsQuery, GetMessagesSetsQueryVariables>(GetMessagesSetsDocument, options);
      }
export function useGetMessagesSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesSetsQuery, GetMessagesSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesSetsQuery, GetMessagesSetsQueryVariables>(GetMessagesSetsDocument, options);
        }
// @ts-ignore
export function useGetMessagesSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessagesSetsQuery, GetMessagesSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessagesSetsQuery, GetMessagesSetsQueryVariables>;
export function useGetMessagesSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagesSetsQuery, GetMessagesSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessagesSetsQuery | undefined, GetMessagesSetsQueryVariables>;
export function useGetMessagesSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagesSetsQuery, GetMessagesSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessagesSetsQuery, GetMessagesSetsQueryVariables>(GetMessagesSetsDocument, options);
        }
export type GetMessagesSetsQueryHookResult = ReturnType<typeof useGetMessagesSetsQuery>;
export type GetMessagesSetsLazyQueryHookResult = ReturnType<typeof useGetMessagesSetsLazyQuery>;
export type GetMessagesSetsSuspenseQueryHookResult = ReturnType<typeof useGetMessagesSetsSuspenseQuery>;
export type GetMessagesSetsQueryResult = Apollo.QueryResult<GetMessagesSetsQuery, GetMessagesSetsQueryVariables>;
export const GetMessagesSetDocument = gql`
    query GET_MESSAGES_SET($messagesSetId: ID!) {
  messagesSet(messagesSetId: $messagesSetId) {
    ...MessagesSetFragment
  }
}
    ${MessagesSetFragmentFragmentDoc}`;

/**
 * __useGetMessagesSetQuery__
 *
 * To run a query within a React component, call `useGetMessagesSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesSetQuery({
 *   variables: {
 *      messagesSetId: // value for 'messagesSetId'
 *   },
 * });
 */
export function useGetMessagesSetQuery(baseOptions: Apollo.QueryHookOptions<GetMessagesSetQuery, GetMessagesSetQueryVariables> & ({ variables: GetMessagesSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesSetQuery, GetMessagesSetQueryVariables>(GetMessagesSetDocument, options);
      }
export function useGetMessagesSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesSetQuery, GetMessagesSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesSetQuery, GetMessagesSetQueryVariables>(GetMessagesSetDocument, options);
        }
// @ts-ignore
export function useGetMessagesSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessagesSetQuery, GetMessagesSetQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessagesSetQuery, GetMessagesSetQueryVariables>;
export function useGetMessagesSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagesSetQuery, GetMessagesSetQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessagesSetQuery | undefined, GetMessagesSetQueryVariables>;
export function useGetMessagesSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagesSetQuery, GetMessagesSetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessagesSetQuery, GetMessagesSetQueryVariables>(GetMessagesSetDocument, options);
        }
export type GetMessagesSetQueryHookResult = ReturnType<typeof useGetMessagesSetQuery>;
export type GetMessagesSetLazyQueryHookResult = ReturnType<typeof useGetMessagesSetLazyQuery>;
export type GetMessagesSetSuspenseQueryHookResult = ReturnType<typeof useGetMessagesSetSuspenseQuery>;
export type GetMessagesSetQueryResult = Apollo.QueryResult<GetMessagesSetQuery, GetMessagesSetQueryVariables>;
export const GetMicrostoreColumnsDocument = gql`
    query GET_MICROSTORE_COLUMNS {
  microstoreColumns {
    ...MicrostoreColumnFragment
  }
}
    ${MicrostoreColumnFragmentFragmentDoc}`;

/**
 * __useGetMicrostoreColumnsQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreColumnsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMicrostoreColumnsQuery(baseOptions?: Apollo.QueryHookOptions<GetMicrostoreColumnsQuery, GetMicrostoreColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreColumnsQuery, GetMicrostoreColumnsQueryVariables>(GetMicrostoreColumnsDocument, options);
      }
export function useGetMicrostoreColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreColumnsQuery, GetMicrostoreColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreColumnsQuery, GetMicrostoreColumnsQueryVariables>(GetMicrostoreColumnsDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreColumnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnsQuery, GetMicrostoreColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnsQuery, GetMicrostoreColumnsQueryVariables>;
export function useGetMicrostoreColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnsQuery, GetMicrostoreColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnsQuery | undefined, GetMicrostoreColumnsQueryVariables>;
export function useGetMicrostoreColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnsQuery, GetMicrostoreColumnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreColumnsQuery, GetMicrostoreColumnsQueryVariables>(GetMicrostoreColumnsDocument, options);
        }
export type GetMicrostoreColumnsQueryHookResult = ReturnType<typeof useGetMicrostoreColumnsQuery>;
export type GetMicrostoreColumnsLazyQueryHookResult = ReturnType<typeof useGetMicrostoreColumnsLazyQuery>;
export type GetMicrostoreColumnsSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreColumnsSuspenseQuery>;
export type GetMicrostoreColumnsQueryResult = Apollo.QueryResult<GetMicrostoreColumnsQuery, GetMicrostoreColumnsQueryVariables>;
export const GetMicrostoreColumnsPaginatedDocument = gql`
    query GET_MICROSTORE_COLUMNS_PAGINATED($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: MicrostoreColumnsFilterInput) {
  microstoreColumnsFilter(
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    microstoreColumns {
      ...MicrostoreColumnFragment
    }
  }
}
    ${MicrostoreColumnFragmentFragmentDoc}`;

/**
 * __useGetMicrostoreColumnsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreColumnsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreColumnsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreColumnsPaginatedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMicrostoreColumnsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GetMicrostoreColumnsPaginatedQuery, GetMicrostoreColumnsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreColumnsPaginatedQuery, GetMicrostoreColumnsPaginatedQueryVariables>(GetMicrostoreColumnsPaginatedDocument, options);
      }
export function useGetMicrostoreColumnsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreColumnsPaginatedQuery, GetMicrostoreColumnsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreColumnsPaginatedQuery, GetMicrostoreColumnsPaginatedQueryVariables>(GetMicrostoreColumnsPaginatedDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreColumnsPaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnsPaginatedQuery, GetMicrostoreColumnsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnsPaginatedQuery, GetMicrostoreColumnsPaginatedQueryVariables>;
export function useGetMicrostoreColumnsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnsPaginatedQuery, GetMicrostoreColumnsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnsPaginatedQuery | undefined, GetMicrostoreColumnsPaginatedQueryVariables>;
export function useGetMicrostoreColumnsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnsPaginatedQuery, GetMicrostoreColumnsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreColumnsPaginatedQuery, GetMicrostoreColumnsPaginatedQueryVariables>(GetMicrostoreColumnsPaginatedDocument, options);
        }
export type GetMicrostoreColumnsPaginatedQueryHookResult = ReturnType<typeof useGetMicrostoreColumnsPaginatedQuery>;
export type GetMicrostoreColumnsPaginatedLazyQueryHookResult = ReturnType<typeof useGetMicrostoreColumnsPaginatedLazyQuery>;
export type GetMicrostoreColumnsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreColumnsPaginatedSuspenseQuery>;
export type GetMicrostoreColumnsPaginatedQueryResult = Apollo.QueryResult<GetMicrostoreColumnsPaginatedQuery, GetMicrostoreColumnsPaginatedQueryVariables>;
export const GetMicrostoreColumnDocument = gql`
    query GET_MICROSTORE_COLUMN($columnId: ID!) {
  microstoreColumn(columnId: $columnId) {
    ...MicrostoreColumnWithShelvesFragment
  }
}
    ${MicrostoreColumnWithShelvesFragmentFragmentDoc}`;

/**
 * __useGetMicrostoreColumnQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreColumnQuery({
 *   variables: {
 *      columnId: // value for 'columnId'
 *   },
 * });
 */
export function useGetMicrostoreColumnQuery(baseOptions: Apollo.QueryHookOptions<GetMicrostoreColumnQuery, GetMicrostoreColumnQueryVariables> & ({ variables: GetMicrostoreColumnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreColumnQuery, GetMicrostoreColumnQueryVariables>(GetMicrostoreColumnDocument, options);
      }
export function useGetMicrostoreColumnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreColumnQuery, GetMicrostoreColumnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreColumnQuery, GetMicrostoreColumnQueryVariables>(GetMicrostoreColumnDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreColumnSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnQuery, GetMicrostoreColumnQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnQuery, GetMicrostoreColumnQueryVariables>;
export function useGetMicrostoreColumnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnQuery, GetMicrostoreColumnQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnQuery | undefined, GetMicrostoreColumnQueryVariables>;
export function useGetMicrostoreColumnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnQuery, GetMicrostoreColumnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreColumnQuery, GetMicrostoreColumnQueryVariables>(GetMicrostoreColumnDocument, options);
        }
export type GetMicrostoreColumnQueryHookResult = ReturnType<typeof useGetMicrostoreColumnQuery>;
export type GetMicrostoreColumnLazyQueryHookResult = ReturnType<typeof useGetMicrostoreColumnLazyQuery>;
export type GetMicrostoreColumnSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreColumnSuspenseQuery>;
export type GetMicrostoreColumnQueryResult = Apollo.QueryResult<GetMicrostoreColumnQuery, GetMicrostoreColumnQueryVariables>;
export const GetColumnProductsStockInfoDocument = gql`
    query GET_COLUMN_PRODUCTS_STOCK_INFO($columnId: ID!) {
  column(_id: $columnId) {
    _id
    name
    products {
      _id
      brand
      categoryId
      flow
      name
      trackExpiryDate
      volume
      isDoubleCoil
      isWithoutStock
      recipe {
        ingredients {
          productId
        }
      }
      microstoreStockInfo(columnId: $columnId) {
        expiryDateRecordsWarehouse {
          _id
          expiryDate
          initialQuantity
          quantityAtInventory
        }
        stockOnSite
        stockAvailableOnSite
        stockWarehouse
        stockAvailableWarehouse
        stockToRemove
        stockUsedInOtherMicrostores
        stockExpectedInSupplyOrders
        transactionsCountForToday
      }
    }
  }
}
    `;

/**
 * __useGetColumnProductsStockInfoQuery__
 *
 * To run a query within a React component, call `useGetColumnProductsStockInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColumnProductsStockInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColumnProductsStockInfoQuery({
 *   variables: {
 *      columnId: // value for 'columnId'
 *   },
 * });
 */
export function useGetColumnProductsStockInfoQuery(baseOptions: Apollo.QueryHookOptions<GetColumnProductsStockInfoQuery, GetColumnProductsStockInfoQueryVariables> & ({ variables: GetColumnProductsStockInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetColumnProductsStockInfoQuery, GetColumnProductsStockInfoQueryVariables>(GetColumnProductsStockInfoDocument, options);
      }
export function useGetColumnProductsStockInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetColumnProductsStockInfoQuery, GetColumnProductsStockInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetColumnProductsStockInfoQuery, GetColumnProductsStockInfoQueryVariables>(GetColumnProductsStockInfoDocument, options);
        }
// @ts-ignore
export function useGetColumnProductsStockInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetColumnProductsStockInfoQuery, GetColumnProductsStockInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnProductsStockInfoQuery, GetColumnProductsStockInfoQueryVariables>;
export function useGetColumnProductsStockInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnProductsStockInfoQuery, GetColumnProductsStockInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnProductsStockInfoQuery | undefined, GetColumnProductsStockInfoQueryVariables>;
export function useGetColumnProductsStockInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnProductsStockInfoQuery, GetColumnProductsStockInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetColumnProductsStockInfoQuery, GetColumnProductsStockInfoQueryVariables>(GetColumnProductsStockInfoDocument, options);
        }
export type GetColumnProductsStockInfoQueryHookResult = ReturnType<typeof useGetColumnProductsStockInfoQuery>;
export type GetColumnProductsStockInfoLazyQueryHookResult = ReturnType<typeof useGetColumnProductsStockInfoLazyQuery>;
export type GetColumnProductsStockInfoSuspenseQueryHookResult = ReturnType<typeof useGetColumnProductsStockInfoSuspenseQuery>;
export type GetColumnProductsStockInfoQueryResult = Apollo.QueryResult<GetColumnProductsStockInfoQuery, GetColumnProductsStockInfoQueryVariables>;
export const GetMicrostoreColumnPricesDocument = gql`
    query GET_MICROSTORE_COLUMN_PRICES($microstoreColumnId: ID!) {
  microstoreColumnPrices(microstoreColumnId: $microstoreColumnId) {
    productId
    priceTTC
    crossedPriceTTC
  }
}
    `;

/**
 * __useGetMicrostoreColumnPricesQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreColumnPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreColumnPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreColumnPricesQuery({
 *   variables: {
 *      microstoreColumnId: // value for 'microstoreColumnId'
 *   },
 * });
 */
export function useGetMicrostoreColumnPricesQuery(baseOptions: Apollo.QueryHookOptions<GetMicrostoreColumnPricesQuery, GetMicrostoreColumnPricesQueryVariables> & ({ variables: GetMicrostoreColumnPricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreColumnPricesQuery, GetMicrostoreColumnPricesQueryVariables>(GetMicrostoreColumnPricesDocument, options);
      }
export function useGetMicrostoreColumnPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreColumnPricesQuery, GetMicrostoreColumnPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreColumnPricesQuery, GetMicrostoreColumnPricesQueryVariables>(GetMicrostoreColumnPricesDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreColumnPricesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnPricesQuery, GetMicrostoreColumnPricesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnPricesQuery, GetMicrostoreColumnPricesQueryVariables>;
export function useGetMicrostoreColumnPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnPricesQuery, GetMicrostoreColumnPricesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnPricesQuery | undefined, GetMicrostoreColumnPricesQueryVariables>;
export function useGetMicrostoreColumnPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnPricesQuery, GetMicrostoreColumnPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreColumnPricesQuery, GetMicrostoreColumnPricesQueryVariables>(GetMicrostoreColumnPricesDocument, options);
        }
export type GetMicrostoreColumnPricesQueryHookResult = ReturnType<typeof useGetMicrostoreColumnPricesQuery>;
export type GetMicrostoreColumnPricesLazyQueryHookResult = ReturnType<typeof useGetMicrostoreColumnPricesLazyQuery>;
export type GetMicrostoreColumnPricesSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreColumnPricesSuspenseQuery>;
export type GetMicrostoreColumnPricesQueryResult = Apollo.QueryResult<GetMicrostoreColumnPricesQuery, GetMicrostoreColumnPricesQueryVariables>;
export const GetMicrostoreColumnsOfOrganizationDocument = gql`
    query GET_MICROSTORE_COLUMNS_OF_ORGANIZATION($organizationId: String!) {
  microstoreColumnsOfOrganization(organizationId: $organizationId) {
    _id
    name
  }
}
    `;

/**
 * __useGetMicrostoreColumnsOfOrganizationQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreColumnsOfOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreColumnsOfOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreColumnsOfOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetMicrostoreColumnsOfOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetMicrostoreColumnsOfOrganizationQuery, GetMicrostoreColumnsOfOrganizationQueryVariables> & ({ variables: GetMicrostoreColumnsOfOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreColumnsOfOrganizationQuery, GetMicrostoreColumnsOfOrganizationQueryVariables>(GetMicrostoreColumnsOfOrganizationDocument, options);
      }
export function useGetMicrostoreColumnsOfOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreColumnsOfOrganizationQuery, GetMicrostoreColumnsOfOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreColumnsOfOrganizationQuery, GetMicrostoreColumnsOfOrganizationQueryVariables>(GetMicrostoreColumnsOfOrganizationDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreColumnsOfOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnsOfOrganizationQuery, GetMicrostoreColumnsOfOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnsOfOrganizationQuery, GetMicrostoreColumnsOfOrganizationQueryVariables>;
export function useGetMicrostoreColumnsOfOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnsOfOrganizationQuery, GetMicrostoreColumnsOfOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnsOfOrganizationQuery | undefined, GetMicrostoreColumnsOfOrganizationQueryVariables>;
export function useGetMicrostoreColumnsOfOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnsOfOrganizationQuery, GetMicrostoreColumnsOfOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreColumnsOfOrganizationQuery, GetMicrostoreColumnsOfOrganizationQueryVariables>(GetMicrostoreColumnsOfOrganizationDocument, options);
        }
export type GetMicrostoreColumnsOfOrganizationQueryHookResult = ReturnType<typeof useGetMicrostoreColumnsOfOrganizationQuery>;
export type GetMicrostoreColumnsOfOrganizationLazyQueryHookResult = ReturnType<typeof useGetMicrostoreColumnsOfOrganizationLazyQuery>;
export type GetMicrostoreColumnsOfOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreColumnsOfOrganizationSuspenseQuery>;
export type GetMicrostoreColumnsOfOrganizationQueryResult = Apollo.QueryResult<GetMicrostoreColumnsOfOrganizationQuery, GetMicrostoreColumnsOfOrganizationQueryVariables>;
export const GetTruckColumnsDocument = gql`
    query GET_TRUCK_COLUMNS {
  truckColumns {
    _id
    name
    siteName
  }
}
    `;

/**
 * __useGetTruckColumnsQuery__
 *
 * To run a query within a React component, call `useGetTruckColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTruckColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTruckColumnsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTruckColumnsQuery(baseOptions?: Apollo.QueryHookOptions<GetTruckColumnsQuery, GetTruckColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTruckColumnsQuery, GetTruckColumnsQueryVariables>(GetTruckColumnsDocument, options);
      }
export function useGetTruckColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTruckColumnsQuery, GetTruckColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTruckColumnsQuery, GetTruckColumnsQueryVariables>(GetTruckColumnsDocument, options);
        }
// @ts-ignore
export function useGetTruckColumnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTruckColumnsQuery, GetTruckColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTruckColumnsQuery, GetTruckColumnsQueryVariables>;
export function useGetTruckColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTruckColumnsQuery, GetTruckColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTruckColumnsQuery | undefined, GetTruckColumnsQueryVariables>;
export function useGetTruckColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTruckColumnsQuery, GetTruckColumnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTruckColumnsQuery, GetTruckColumnsQueryVariables>(GetTruckColumnsDocument, options);
        }
export type GetTruckColumnsQueryHookResult = ReturnType<typeof useGetTruckColumnsQuery>;
export type GetTruckColumnsLazyQueryHookResult = ReturnType<typeof useGetTruckColumnsLazyQuery>;
export type GetTruckColumnsSuspenseQueryHookResult = ReturnType<typeof useGetTruckColumnsSuspenseQuery>;
export type GetTruckColumnsQueryResult = Apollo.QueryResult<GetTruckColumnsQuery, GetTruckColumnsQueryVariables>;
export const GetMicrostoreColumnGroupsPaginatedDocument = gql`
    query GET_MICROSTORE_COLUMN_GROUPS_PAGINATED($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: MicrostoreColumnGroupFilterInput) {
  microstoreColumnGroupsFilter(
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    microstoreColumnGroups {
      ...MicrostoreColumnGroupFragment
    }
  }
}
    ${MicrostoreColumnGroupFragmentFragmentDoc}`;

/**
 * __useGetMicrostoreColumnGroupsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreColumnGroupsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreColumnGroupsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreColumnGroupsPaginatedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMicrostoreColumnGroupsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GetMicrostoreColumnGroupsPaginatedQuery, GetMicrostoreColumnGroupsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreColumnGroupsPaginatedQuery, GetMicrostoreColumnGroupsPaginatedQueryVariables>(GetMicrostoreColumnGroupsPaginatedDocument, options);
      }
export function useGetMicrostoreColumnGroupsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreColumnGroupsPaginatedQuery, GetMicrostoreColumnGroupsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreColumnGroupsPaginatedQuery, GetMicrostoreColumnGroupsPaginatedQueryVariables>(GetMicrostoreColumnGroupsPaginatedDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreColumnGroupsPaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnGroupsPaginatedQuery, GetMicrostoreColumnGroupsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnGroupsPaginatedQuery, GetMicrostoreColumnGroupsPaginatedQueryVariables>;
export function useGetMicrostoreColumnGroupsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnGroupsPaginatedQuery, GetMicrostoreColumnGroupsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnGroupsPaginatedQuery | undefined, GetMicrostoreColumnGroupsPaginatedQueryVariables>;
export function useGetMicrostoreColumnGroupsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnGroupsPaginatedQuery, GetMicrostoreColumnGroupsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreColumnGroupsPaginatedQuery, GetMicrostoreColumnGroupsPaginatedQueryVariables>(GetMicrostoreColumnGroupsPaginatedDocument, options);
        }
export type GetMicrostoreColumnGroupsPaginatedQueryHookResult = ReturnType<typeof useGetMicrostoreColumnGroupsPaginatedQuery>;
export type GetMicrostoreColumnGroupsPaginatedLazyQueryHookResult = ReturnType<typeof useGetMicrostoreColumnGroupsPaginatedLazyQuery>;
export type GetMicrostoreColumnGroupsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreColumnGroupsPaginatedSuspenseQuery>;
export type GetMicrostoreColumnGroupsPaginatedQueryResult = Apollo.QueryResult<GetMicrostoreColumnGroupsPaginatedQuery, GetMicrostoreColumnGroupsPaginatedQueryVariables>;
export const GetMicrostoreColumnGroupsDocument = gql`
    query GET_MICROSTORE_COLUMN_GROUPS($siteId: ID!) {
  microstoreColumnGroups(siteId: $siteId) {
    ...MicrostoreColumnGroupFragment
  }
}
    ${MicrostoreColumnGroupFragmentFragmentDoc}`;

/**
 * __useGetMicrostoreColumnGroupsQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreColumnGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreColumnGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreColumnGroupsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetMicrostoreColumnGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetMicrostoreColumnGroupsQuery, GetMicrostoreColumnGroupsQueryVariables> & ({ variables: GetMicrostoreColumnGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreColumnGroupsQuery, GetMicrostoreColumnGroupsQueryVariables>(GetMicrostoreColumnGroupsDocument, options);
      }
export function useGetMicrostoreColumnGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreColumnGroupsQuery, GetMicrostoreColumnGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreColumnGroupsQuery, GetMicrostoreColumnGroupsQueryVariables>(GetMicrostoreColumnGroupsDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreColumnGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnGroupsQuery, GetMicrostoreColumnGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnGroupsQuery, GetMicrostoreColumnGroupsQueryVariables>;
export function useGetMicrostoreColumnGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnGroupsQuery, GetMicrostoreColumnGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnGroupsQuery | undefined, GetMicrostoreColumnGroupsQueryVariables>;
export function useGetMicrostoreColumnGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnGroupsQuery, GetMicrostoreColumnGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreColumnGroupsQuery, GetMicrostoreColumnGroupsQueryVariables>(GetMicrostoreColumnGroupsDocument, options);
        }
export type GetMicrostoreColumnGroupsQueryHookResult = ReturnType<typeof useGetMicrostoreColumnGroupsQuery>;
export type GetMicrostoreColumnGroupsLazyQueryHookResult = ReturnType<typeof useGetMicrostoreColumnGroupsLazyQuery>;
export type GetMicrostoreColumnGroupsSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreColumnGroupsSuspenseQuery>;
export type GetMicrostoreColumnGroupsQueryResult = Apollo.QueryResult<GetMicrostoreColumnGroupsQuery, GetMicrostoreColumnGroupsQueryVariables>;
export const GetMicrostoreColumnGroupDocument = gql`
    query GET_MICROSTORE_COLUMN_GROUP($columnGroupId: ID!) {
  microstoreColumnGroup(columnGroupId: $columnGroupId) {
    _id
    name
    positionInSite
    siteId
    avaSalePlaceLocationId
    odooMicrostoreColumnGroupId
    columns {
      _id
      name
      state
      positionInColumnGroup
      microstoreColumnTemplateName
      isPaused
    }
    site {
      _id
      name
      microstoreColumnGroups {
        _id
        name
        positionInSite
        columns {
          _id
        }
      }
      totem {
        _id
        name
        number
        sites {
          _id
          name
        }
        organization {
          _id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetMicrostoreColumnGroupQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreColumnGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreColumnGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreColumnGroupQuery({
 *   variables: {
 *      columnGroupId: // value for 'columnGroupId'
 *   },
 * });
 */
export function useGetMicrostoreColumnGroupQuery(baseOptions: Apollo.QueryHookOptions<GetMicrostoreColumnGroupQuery, GetMicrostoreColumnGroupQueryVariables> & ({ variables: GetMicrostoreColumnGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreColumnGroupQuery, GetMicrostoreColumnGroupQueryVariables>(GetMicrostoreColumnGroupDocument, options);
      }
export function useGetMicrostoreColumnGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreColumnGroupQuery, GetMicrostoreColumnGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreColumnGroupQuery, GetMicrostoreColumnGroupQueryVariables>(GetMicrostoreColumnGroupDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreColumnGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnGroupQuery, GetMicrostoreColumnGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnGroupQuery, GetMicrostoreColumnGroupQueryVariables>;
export function useGetMicrostoreColumnGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnGroupQuery, GetMicrostoreColumnGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnGroupQuery | undefined, GetMicrostoreColumnGroupQueryVariables>;
export function useGetMicrostoreColumnGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnGroupQuery, GetMicrostoreColumnGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreColumnGroupQuery, GetMicrostoreColumnGroupQueryVariables>(GetMicrostoreColumnGroupDocument, options);
        }
export type GetMicrostoreColumnGroupQueryHookResult = ReturnType<typeof useGetMicrostoreColumnGroupQuery>;
export type GetMicrostoreColumnGroupLazyQueryHookResult = ReturnType<typeof useGetMicrostoreColumnGroupLazyQuery>;
export type GetMicrostoreColumnGroupSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreColumnGroupSuspenseQuery>;
export type GetMicrostoreColumnGroupQueryResult = Apollo.QueryResult<GetMicrostoreColumnGroupQuery, GetMicrostoreColumnGroupQueryVariables>;
export const GetMicrostoreColumnTemplatesDocument = gql`
    query GET_MICROSTORE_COLUMN_TEMPLATES {
  microstoreColumnTemplatesQuery {
    ...MicrostoreColumnTemplateFragment
  }
}
    ${MicrostoreColumnTemplateFragmentFragmentDoc}`;

/**
 * __useGetMicrostoreColumnTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreColumnTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreColumnTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreColumnTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMicrostoreColumnTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetMicrostoreColumnTemplatesQuery, GetMicrostoreColumnTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreColumnTemplatesQuery, GetMicrostoreColumnTemplatesQueryVariables>(GetMicrostoreColumnTemplatesDocument, options);
      }
export function useGetMicrostoreColumnTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreColumnTemplatesQuery, GetMicrostoreColumnTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreColumnTemplatesQuery, GetMicrostoreColumnTemplatesQueryVariables>(GetMicrostoreColumnTemplatesDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreColumnTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnTemplatesQuery, GetMicrostoreColumnTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnTemplatesQuery, GetMicrostoreColumnTemplatesQueryVariables>;
export function useGetMicrostoreColumnTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnTemplatesQuery, GetMicrostoreColumnTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnTemplatesQuery | undefined, GetMicrostoreColumnTemplatesQueryVariables>;
export function useGetMicrostoreColumnTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnTemplatesQuery, GetMicrostoreColumnTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreColumnTemplatesQuery, GetMicrostoreColumnTemplatesQueryVariables>(GetMicrostoreColumnTemplatesDocument, options);
        }
export type GetMicrostoreColumnTemplatesQueryHookResult = ReturnType<typeof useGetMicrostoreColumnTemplatesQuery>;
export type GetMicrostoreColumnTemplatesLazyQueryHookResult = ReturnType<typeof useGetMicrostoreColumnTemplatesLazyQuery>;
export type GetMicrostoreColumnTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreColumnTemplatesSuspenseQuery>;
export type GetMicrostoreColumnTemplatesQueryResult = Apollo.QueryResult<GetMicrostoreColumnTemplatesQuery, GetMicrostoreColumnTemplatesQueryVariables>;
export const GetMicrostoreColumnTemplateDocument = gql`
    query GET_MICROSTORE_COLUMN_TEMPLATE($microstoreColumnTemplateId: String!) {
  microstoreColumnTemplateQuery(
    microstoreColumnTemplateId: $microstoreColumnTemplateId
  ) {
    ...MicrostoreColumnTemplateWithAllInfo
  }
}
    ${MicrostoreColumnTemplateWithAllInfoFragmentDoc}`;

/**
 * __useGetMicrostoreColumnTemplateQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreColumnTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreColumnTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreColumnTemplateQuery({
 *   variables: {
 *      microstoreColumnTemplateId: // value for 'microstoreColumnTemplateId'
 *   },
 * });
 */
export function useGetMicrostoreColumnTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetMicrostoreColumnTemplateQuery, GetMicrostoreColumnTemplateQueryVariables> & ({ variables: GetMicrostoreColumnTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreColumnTemplateQuery, GetMicrostoreColumnTemplateQueryVariables>(GetMicrostoreColumnTemplateDocument, options);
      }
export function useGetMicrostoreColumnTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreColumnTemplateQuery, GetMicrostoreColumnTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreColumnTemplateQuery, GetMicrostoreColumnTemplateQueryVariables>(GetMicrostoreColumnTemplateDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreColumnTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnTemplateQuery, GetMicrostoreColumnTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnTemplateQuery, GetMicrostoreColumnTemplateQueryVariables>;
export function useGetMicrostoreColumnTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnTemplateQuery, GetMicrostoreColumnTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnTemplateQuery | undefined, GetMicrostoreColumnTemplateQueryVariables>;
export function useGetMicrostoreColumnTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnTemplateQuery, GetMicrostoreColumnTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreColumnTemplateQuery, GetMicrostoreColumnTemplateQueryVariables>(GetMicrostoreColumnTemplateDocument, options);
        }
export type GetMicrostoreColumnTemplateQueryHookResult = ReturnType<typeof useGetMicrostoreColumnTemplateQuery>;
export type GetMicrostoreColumnTemplateLazyQueryHookResult = ReturnType<typeof useGetMicrostoreColumnTemplateLazyQuery>;
export type GetMicrostoreColumnTemplateSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreColumnTemplateSuspenseQuery>;
export type GetMicrostoreColumnTemplateQueryResult = Apollo.QueryResult<GetMicrostoreColumnTemplateQuery, GetMicrostoreColumnTemplateQueryVariables>;
export const GetMicrostoreColumnTemplatesWithItemDocument = gql`
    query GET_MICROSTORE_COLUMN_TEMPLATES_WITH_ITEM($itemId: String!, $itemType: MicrostoreItemType!) {
  microstoreColumnTemplatesWithItem(itemId: $itemId, itemType: $itemType) {
    _id
    name
    templateLocationCount
    microstoreColumns {
      _id
      siteId
      site {
        name
      }
      name
    }
  }
}
    `;

/**
 * __useGetMicrostoreColumnTemplatesWithItemQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreColumnTemplatesWithItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreColumnTemplatesWithItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreColumnTemplatesWithItemQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      itemType: // value for 'itemType'
 *   },
 * });
 */
export function useGetMicrostoreColumnTemplatesWithItemQuery(baseOptions: Apollo.QueryHookOptions<GetMicrostoreColumnTemplatesWithItemQuery, GetMicrostoreColumnTemplatesWithItemQueryVariables> & ({ variables: GetMicrostoreColumnTemplatesWithItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreColumnTemplatesWithItemQuery, GetMicrostoreColumnTemplatesWithItemQueryVariables>(GetMicrostoreColumnTemplatesWithItemDocument, options);
      }
export function useGetMicrostoreColumnTemplatesWithItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreColumnTemplatesWithItemQuery, GetMicrostoreColumnTemplatesWithItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreColumnTemplatesWithItemQuery, GetMicrostoreColumnTemplatesWithItemQueryVariables>(GetMicrostoreColumnTemplatesWithItemDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreColumnTemplatesWithItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnTemplatesWithItemQuery, GetMicrostoreColumnTemplatesWithItemQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnTemplatesWithItemQuery, GetMicrostoreColumnTemplatesWithItemQueryVariables>;
export function useGetMicrostoreColumnTemplatesWithItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnTemplatesWithItemQuery, GetMicrostoreColumnTemplatesWithItemQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreColumnTemplatesWithItemQuery | undefined, GetMicrostoreColumnTemplatesWithItemQueryVariables>;
export function useGetMicrostoreColumnTemplatesWithItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreColumnTemplatesWithItemQuery, GetMicrostoreColumnTemplatesWithItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreColumnTemplatesWithItemQuery, GetMicrostoreColumnTemplatesWithItemQueryVariables>(GetMicrostoreColumnTemplatesWithItemDocument, options);
        }
export type GetMicrostoreColumnTemplatesWithItemQueryHookResult = ReturnType<typeof useGetMicrostoreColumnTemplatesWithItemQuery>;
export type GetMicrostoreColumnTemplatesWithItemLazyQueryHookResult = ReturnType<typeof useGetMicrostoreColumnTemplatesWithItemLazyQuery>;
export type GetMicrostoreColumnTemplatesWithItemSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreColumnTemplatesWithItemSuspenseQuery>;
export type GetMicrostoreColumnTemplatesWithItemQueryResult = Apollo.QueryResult<GetMicrostoreColumnTemplatesWithItemQuery, GetMicrostoreColumnTemplatesWithItemQueryVariables>;
export const GetMicrostoreItemsDocument = gql`
    query GET_MICROSTORE_ITEMS($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: MicrostoreItemsFilterInput) {
  microstoreItems(
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    items {
      _id
      name
      type
      locationCount
    }
  }
}
    `;

/**
 * __useGetMicrostoreItemsQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreItemsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMicrostoreItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetMicrostoreItemsQuery, GetMicrostoreItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreItemsQuery, GetMicrostoreItemsQueryVariables>(GetMicrostoreItemsDocument, options);
      }
export function useGetMicrostoreItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreItemsQuery, GetMicrostoreItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreItemsQuery, GetMicrostoreItemsQueryVariables>(GetMicrostoreItemsDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreItemsQuery, GetMicrostoreItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreItemsQuery, GetMicrostoreItemsQueryVariables>;
export function useGetMicrostoreItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreItemsQuery, GetMicrostoreItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreItemsQuery | undefined, GetMicrostoreItemsQueryVariables>;
export function useGetMicrostoreItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreItemsQuery, GetMicrostoreItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreItemsQuery, GetMicrostoreItemsQueryVariables>(GetMicrostoreItemsDocument, options);
        }
export type GetMicrostoreItemsQueryHookResult = ReturnType<typeof useGetMicrostoreItemsQuery>;
export type GetMicrostoreItemsLazyQueryHookResult = ReturnType<typeof useGetMicrostoreItemsLazyQuery>;
export type GetMicrostoreItemsSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreItemsSuspenseQuery>;
export type GetMicrostoreItemsQueryResult = Apollo.QueryResult<GetMicrostoreItemsQuery, GetMicrostoreItemsQueryVariables>;
export const MobilePopupsDocument = gql`
    query MobilePopups {
  mobilePopups {
    ...MobilePopupFragment
  }
}
    ${MobilePopupFragmentFragmentDoc}`;

/**
 * __useMobilePopupsQuery__
 *
 * To run a query within a React component, call `useMobilePopupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMobilePopupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMobilePopupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMobilePopupsQuery(baseOptions?: Apollo.QueryHookOptions<MobilePopupsQuery, MobilePopupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MobilePopupsQuery, MobilePopupsQueryVariables>(MobilePopupsDocument, options);
      }
export function useMobilePopupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MobilePopupsQuery, MobilePopupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MobilePopupsQuery, MobilePopupsQueryVariables>(MobilePopupsDocument, options);
        }
// @ts-ignore
export function useMobilePopupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MobilePopupsQuery, MobilePopupsQueryVariables>): Apollo.UseSuspenseQueryResult<MobilePopupsQuery, MobilePopupsQueryVariables>;
export function useMobilePopupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MobilePopupsQuery, MobilePopupsQueryVariables>): Apollo.UseSuspenseQueryResult<MobilePopupsQuery | undefined, MobilePopupsQueryVariables>;
export function useMobilePopupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MobilePopupsQuery, MobilePopupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MobilePopupsQuery, MobilePopupsQueryVariables>(MobilePopupsDocument, options);
        }
export type MobilePopupsQueryHookResult = ReturnType<typeof useMobilePopupsQuery>;
export type MobilePopupsLazyQueryHookResult = ReturnType<typeof useMobilePopupsLazyQuery>;
export type MobilePopupsSuspenseQueryHookResult = ReturnType<typeof useMobilePopupsSuspenseQuery>;
export type MobilePopupsQueryResult = Apollo.QueryResult<MobilePopupsQuery, MobilePopupsQueryVariables>;
export const GetNayaxMdbTemplateDocument = gql`
    query GetNayaxMDBTemplate($nayaxMDBTemplateId: ID!) {
  nayaxMDBTemplate(nayaxMDBTemplateId: $nayaxMDBTemplateId) {
    _id
    name
    associations {
      nayaxMDBCode
      positionInShelf {
        row
        column
      }
      positionInColumn
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetNayaxMdbTemplateQuery__
 *
 * To run a query within a React component, call `useGetNayaxMdbTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNayaxMdbTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNayaxMdbTemplateQuery({
 *   variables: {
 *      nayaxMDBTemplateId: // value for 'nayaxMDBTemplateId'
 *   },
 * });
 */
export function useGetNayaxMdbTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetNayaxMdbTemplateQuery, GetNayaxMdbTemplateQueryVariables> & ({ variables: GetNayaxMdbTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNayaxMdbTemplateQuery, GetNayaxMdbTemplateQueryVariables>(GetNayaxMdbTemplateDocument, options);
      }
export function useGetNayaxMdbTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNayaxMdbTemplateQuery, GetNayaxMdbTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNayaxMdbTemplateQuery, GetNayaxMdbTemplateQueryVariables>(GetNayaxMdbTemplateDocument, options);
        }
// @ts-ignore
export function useGetNayaxMdbTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNayaxMdbTemplateQuery, GetNayaxMdbTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetNayaxMdbTemplateQuery, GetNayaxMdbTemplateQueryVariables>;
export function useGetNayaxMdbTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNayaxMdbTemplateQuery, GetNayaxMdbTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetNayaxMdbTemplateQuery | undefined, GetNayaxMdbTemplateQueryVariables>;
export function useGetNayaxMdbTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNayaxMdbTemplateQuery, GetNayaxMdbTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNayaxMdbTemplateQuery, GetNayaxMdbTemplateQueryVariables>(GetNayaxMdbTemplateDocument, options);
        }
export type GetNayaxMdbTemplateQueryHookResult = ReturnType<typeof useGetNayaxMdbTemplateQuery>;
export type GetNayaxMdbTemplateLazyQueryHookResult = ReturnType<typeof useGetNayaxMdbTemplateLazyQuery>;
export type GetNayaxMdbTemplateSuspenseQueryHookResult = ReturnType<typeof useGetNayaxMdbTemplateSuspenseQuery>;
export type GetNayaxMdbTemplateQueryResult = Apollo.QueryResult<GetNayaxMdbTemplateQuery, GetNayaxMdbTemplateQueryVariables>;
export const GetNayaxMdbTemplatesDocument = gql`
    query GetNayaxMDBTemplates {
  nayaxMDBTemplates {
    _id
    name
    associations {
      nayaxMDBCode
      positionInShelf {
        row
        column
      }
      positionInColumn
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetNayaxMdbTemplatesQuery__
 *
 * To run a query within a React component, call `useGetNayaxMdbTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNayaxMdbTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNayaxMdbTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNayaxMdbTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetNayaxMdbTemplatesQuery, GetNayaxMdbTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNayaxMdbTemplatesQuery, GetNayaxMdbTemplatesQueryVariables>(GetNayaxMdbTemplatesDocument, options);
      }
export function useGetNayaxMdbTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNayaxMdbTemplatesQuery, GetNayaxMdbTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNayaxMdbTemplatesQuery, GetNayaxMdbTemplatesQueryVariables>(GetNayaxMdbTemplatesDocument, options);
        }
// @ts-ignore
export function useGetNayaxMdbTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNayaxMdbTemplatesQuery, GetNayaxMdbTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNayaxMdbTemplatesQuery, GetNayaxMdbTemplatesQueryVariables>;
export function useGetNayaxMdbTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNayaxMdbTemplatesQuery, GetNayaxMdbTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNayaxMdbTemplatesQuery | undefined, GetNayaxMdbTemplatesQueryVariables>;
export function useGetNayaxMdbTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNayaxMdbTemplatesQuery, GetNayaxMdbTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNayaxMdbTemplatesQuery, GetNayaxMdbTemplatesQueryVariables>(GetNayaxMdbTemplatesDocument, options);
        }
export type GetNayaxMdbTemplatesQueryHookResult = ReturnType<typeof useGetNayaxMdbTemplatesQuery>;
export type GetNayaxMdbTemplatesLazyQueryHookResult = ReturnType<typeof useGetNayaxMdbTemplatesLazyQuery>;
export type GetNayaxMdbTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetNayaxMdbTemplatesSuspenseQuery>;
export type GetNayaxMdbTemplatesQueryResult = Apollo.QueryResult<GetNayaxMdbTemplatesQuery, GetNayaxMdbTemplatesQueryVariables>;
export const GetNuBasketDocument = gql`
    query GetNuBasket($nuBasketId: ID!) {
  nuBasket(nuBasketId: $nuBasketId) {
    ...NuBasketFragment
    transactions {
      _id
      createdAt
      priceHT
      productName
      siteName
      newState
      tva
      userFullName
    }
  }
}
    ${NuBasketFragmentFragmentDoc}`;

/**
 * __useGetNuBasketQuery__
 *
 * To run a query within a React component, call `useGetNuBasketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNuBasketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNuBasketQuery({
 *   variables: {
 *      nuBasketId: // value for 'nuBasketId'
 *   },
 * });
 */
export function useGetNuBasketQuery(baseOptions: Apollo.QueryHookOptions<GetNuBasketQuery, GetNuBasketQueryVariables> & ({ variables: GetNuBasketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNuBasketQuery, GetNuBasketQueryVariables>(GetNuBasketDocument, options);
      }
export function useGetNuBasketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNuBasketQuery, GetNuBasketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNuBasketQuery, GetNuBasketQueryVariables>(GetNuBasketDocument, options);
        }
// @ts-ignore
export function useGetNuBasketSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNuBasketQuery, GetNuBasketQueryVariables>): Apollo.UseSuspenseQueryResult<GetNuBasketQuery, GetNuBasketQueryVariables>;
export function useGetNuBasketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNuBasketQuery, GetNuBasketQueryVariables>): Apollo.UseSuspenseQueryResult<GetNuBasketQuery | undefined, GetNuBasketQueryVariables>;
export function useGetNuBasketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNuBasketQuery, GetNuBasketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNuBasketQuery, GetNuBasketQueryVariables>(GetNuBasketDocument, options);
        }
export type GetNuBasketQueryHookResult = ReturnType<typeof useGetNuBasketQuery>;
export type GetNuBasketLazyQueryHookResult = ReturnType<typeof useGetNuBasketLazyQuery>;
export type GetNuBasketSuspenseQueryHookResult = ReturnType<typeof useGetNuBasketSuspenseQuery>;
export type GetNuBasketQueryResult = Apollo.QueryResult<GetNuBasketQuery, GetNuBasketQueryVariables>;
export const OpsParametersDocument = gql`
    query OPS_PARAMETERS {
  opsParameters {
    ...OpsParameterFragment
  }
}
    ${OpsParameterFragmentFragmentDoc}`;

/**
 * __useOpsParametersQuery__
 *
 * To run a query within a React component, call `useOpsParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpsParametersQuery(baseOptions?: Apollo.QueryHookOptions<OpsParametersQuery, OpsParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpsParametersQuery, OpsParametersQueryVariables>(OpsParametersDocument, options);
      }
export function useOpsParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpsParametersQuery, OpsParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpsParametersQuery, OpsParametersQueryVariables>(OpsParametersDocument, options);
        }
// @ts-ignore
export function useOpsParametersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpsParametersQuery, OpsParametersQueryVariables>): Apollo.UseSuspenseQueryResult<OpsParametersQuery, OpsParametersQueryVariables>;
export function useOpsParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpsParametersQuery, OpsParametersQueryVariables>): Apollo.UseSuspenseQueryResult<OpsParametersQuery | undefined, OpsParametersQueryVariables>;
export function useOpsParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpsParametersQuery, OpsParametersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpsParametersQuery, OpsParametersQueryVariables>(OpsParametersDocument, options);
        }
export type OpsParametersQueryHookResult = ReturnType<typeof useOpsParametersQuery>;
export type OpsParametersLazyQueryHookResult = ReturnType<typeof useOpsParametersLazyQuery>;
export type OpsParametersSuspenseQueryHookResult = ReturnType<typeof useOpsParametersSuspenseQuery>;
export type OpsParametersQueryResult = Apollo.QueryResult<OpsParametersQuery, OpsParametersQueryVariables>;
export const GetDetailedOrderDocument = gql`
    query GET_DETAILED_ORDER($orderId: ID!) {
  detailedOrder(orderId: $orderId) {
    ...DetailedOrderFragment
  }
}
    ${DetailedOrderFragmentFragmentDoc}`;

/**
 * __useGetDetailedOrderQuery__
 *
 * To run a query within a React component, call `useGetDetailedOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetDetailedOrderQuery(baseOptions: Apollo.QueryHookOptions<GetDetailedOrderQuery, GetDetailedOrderQueryVariables> & ({ variables: GetDetailedOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailedOrderQuery, GetDetailedOrderQueryVariables>(GetDetailedOrderDocument, options);
      }
export function useGetDetailedOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailedOrderQuery, GetDetailedOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailedOrderQuery, GetDetailedOrderQueryVariables>(GetDetailedOrderDocument, options);
        }
// @ts-ignore
export function useGetDetailedOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDetailedOrderQuery, GetDetailedOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedOrderQuery, GetDetailedOrderQueryVariables>;
export function useGetDetailedOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedOrderQuery, GetDetailedOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedOrderQuery | undefined, GetDetailedOrderQueryVariables>;
export function useGetDetailedOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedOrderQuery, GetDetailedOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailedOrderQuery, GetDetailedOrderQueryVariables>(GetDetailedOrderDocument, options);
        }
export type GetDetailedOrderQueryHookResult = ReturnType<typeof useGetDetailedOrderQuery>;
export type GetDetailedOrderLazyQueryHookResult = ReturnType<typeof useGetDetailedOrderLazyQuery>;
export type GetDetailedOrderSuspenseQueryHookResult = ReturnType<typeof useGetDetailedOrderSuspenseQuery>;
export type GetDetailedOrderQueryResult = Apollo.QueryResult<GetDetailedOrderQuery, GetDetailedOrderQueryVariables>;
export const GetOrdersFromOrganizationDocument = gql`
    query GET_ORDERS_FROM_ORGANIZATION($organizationId: ID!) {
  activeOrdersFromOrganization(organizationId: $organizationId) {
    _id
    deliveryDate
    isPunctual
    number
    totem {
      _id
      name
      number
    }
  }
}
    `;

/**
 * __useGetOrdersFromOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrdersFromOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersFromOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersFromOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrdersFromOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersFromOrganizationQuery, GetOrdersFromOrganizationQueryVariables> & ({ variables: GetOrdersFromOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersFromOrganizationQuery, GetOrdersFromOrganizationQueryVariables>(GetOrdersFromOrganizationDocument, options);
      }
export function useGetOrdersFromOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersFromOrganizationQuery, GetOrdersFromOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersFromOrganizationQuery, GetOrdersFromOrganizationQueryVariables>(GetOrdersFromOrganizationDocument, options);
        }
// @ts-ignore
export function useGetOrdersFromOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrdersFromOrganizationQuery, GetOrdersFromOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersFromOrganizationQuery, GetOrdersFromOrganizationQueryVariables>;
export function useGetOrdersFromOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersFromOrganizationQuery, GetOrdersFromOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersFromOrganizationQuery | undefined, GetOrdersFromOrganizationQueryVariables>;
export function useGetOrdersFromOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersFromOrganizationQuery, GetOrdersFromOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersFromOrganizationQuery, GetOrdersFromOrganizationQueryVariables>(GetOrdersFromOrganizationDocument, options);
        }
export type GetOrdersFromOrganizationQueryHookResult = ReturnType<typeof useGetOrdersFromOrganizationQuery>;
export type GetOrdersFromOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrdersFromOrganizationLazyQuery>;
export type GetOrdersFromOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrdersFromOrganizationSuspenseQuery>;
export type GetOrdersFromOrganizationQueryResult = Apollo.QueryResult<GetOrdersFromOrganizationQuery, GetOrdersFromOrganizationQueryVariables>;
export const GetOrdersOfOrganizationDocument = gql`
    query GET_ORDERS_OF_ORGANIZATION($organizationId: ID!, $windowStart: String, $windowEnd: String) {
  ordersOfOrganization(
    organizationId: $organizationId
    windowStart: $windowStart
    windowEnd: $windowEnd
  ) {
    _id
    deliveryDate
    isPunctual
    number
    totem {
      _id
      name
      number
    }
  }
}
    `;

/**
 * __useGetOrdersOfOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrdersOfOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersOfOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersOfOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      windowStart: // value for 'windowStart'
 *      windowEnd: // value for 'windowEnd'
 *   },
 * });
 */
export function useGetOrdersOfOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersOfOrganizationQuery, GetOrdersOfOrganizationQueryVariables> & ({ variables: GetOrdersOfOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersOfOrganizationQuery, GetOrdersOfOrganizationQueryVariables>(GetOrdersOfOrganizationDocument, options);
      }
export function useGetOrdersOfOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersOfOrganizationQuery, GetOrdersOfOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersOfOrganizationQuery, GetOrdersOfOrganizationQueryVariables>(GetOrdersOfOrganizationDocument, options);
        }
// @ts-ignore
export function useGetOrdersOfOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrdersOfOrganizationQuery, GetOrdersOfOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersOfOrganizationQuery, GetOrdersOfOrganizationQueryVariables>;
export function useGetOrdersOfOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersOfOrganizationQuery, GetOrdersOfOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersOfOrganizationQuery | undefined, GetOrdersOfOrganizationQueryVariables>;
export function useGetOrdersOfOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersOfOrganizationQuery, GetOrdersOfOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersOfOrganizationQuery, GetOrdersOfOrganizationQueryVariables>(GetOrdersOfOrganizationDocument, options);
        }
export type GetOrdersOfOrganizationQueryHookResult = ReturnType<typeof useGetOrdersOfOrganizationQuery>;
export type GetOrdersOfOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrdersOfOrganizationLazyQuery>;
export type GetOrdersOfOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrdersOfOrganizationSuspenseQuery>;
export type GetOrdersOfOrganizationQueryResult = Apollo.QueryResult<GetOrdersOfOrganizationQuery, GetOrdersOfOrganizationQueryVariables>;
export const GetActiveOrForDateOrdersDocument = gql`
    query GET_ACTIVE_OR_FOR_DATE_ORDERS($deliveryDate: String) {
  activeOrForDateOrders(deliveryDate: $deliveryDate) {
    _id
    date_delivery
    isPunctual
    number
    state
    first_order
    totem {
      _id
      name
      number
      state
    }
    organization {
      name
    }
    pausedInfo {
      returnDate
    }
    prices {
      priceTTC
      priceHT
    }
    weekday
  }
}
    `;

/**
 * __useGetActiveOrForDateOrdersQuery__
 *
 * To run a query within a React component, call `useGetActiveOrForDateOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveOrForDateOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveOrForDateOrdersQuery({
 *   variables: {
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function useGetActiveOrForDateOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveOrForDateOrdersQuery, GetActiveOrForDateOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveOrForDateOrdersQuery, GetActiveOrForDateOrdersQueryVariables>(GetActiveOrForDateOrdersDocument, options);
      }
export function useGetActiveOrForDateOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveOrForDateOrdersQuery, GetActiveOrForDateOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveOrForDateOrdersQuery, GetActiveOrForDateOrdersQueryVariables>(GetActiveOrForDateOrdersDocument, options);
        }
// @ts-ignore
export function useGetActiveOrForDateOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveOrForDateOrdersQuery, GetActiveOrForDateOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveOrForDateOrdersQuery, GetActiveOrForDateOrdersQueryVariables>;
export function useGetActiveOrForDateOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveOrForDateOrdersQuery, GetActiveOrForDateOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveOrForDateOrdersQuery | undefined, GetActiveOrForDateOrdersQueryVariables>;
export function useGetActiveOrForDateOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveOrForDateOrdersQuery, GetActiveOrForDateOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveOrForDateOrdersQuery, GetActiveOrForDateOrdersQueryVariables>(GetActiveOrForDateOrdersDocument, options);
        }
export type GetActiveOrForDateOrdersQueryHookResult = ReturnType<typeof useGetActiveOrForDateOrdersQuery>;
export type GetActiveOrForDateOrdersLazyQueryHookResult = ReturnType<typeof useGetActiveOrForDateOrdersLazyQuery>;
export type GetActiveOrForDateOrdersSuspenseQueryHookResult = ReturnType<typeof useGetActiveOrForDateOrdersSuspenseQuery>;
export type GetActiveOrForDateOrdersQueryResult = Apollo.QueryResult<GetActiveOrForDateOrdersQuery, GetActiveOrForDateOrdersQueryVariables>;
export const GetOrganizationsDocument = gql`
    query GET_ORGANIZATIONS {
  organizations {
    _id
    hasSubscription
    name
    nbActiveSite
    nbActiveTotem
    paymentType
    state
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsQuery | undefined, GetOrganizationsQueryVariables>;
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetActiveOrganizationsDocument = gql`
    query GET_ACTIVE_ORGANIZATIONS {
  activeOrganizations {
    _id
    name
  }
}
    `;

/**
 * __useGetActiveOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetActiveOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveOrganizationsQuery, GetActiveOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveOrganizationsQuery, GetActiveOrganizationsQueryVariables>(GetActiveOrganizationsDocument, options);
      }
export function useGetActiveOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveOrganizationsQuery, GetActiveOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveOrganizationsQuery, GetActiveOrganizationsQueryVariables>(GetActiveOrganizationsDocument, options);
        }
// @ts-ignore
export function useGetActiveOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveOrganizationsQuery, GetActiveOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveOrganizationsQuery, GetActiveOrganizationsQueryVariables>;
export function useGetActiveOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveOrganizationsQuery, GetActiveOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveOrganizationsQuery | undefined, GetActiveOrganizationsQueryVariables>;
export function useGetActiveOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveOrganizationsQuery, GetActiveOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveOrganizationsQuery, GetActiveOrganizationsQueryVariables>(GetActiveOrganizationsDocument, options);
        }
export type GetActiveOrganizationsQueryHookResult = ReturnType<typeof useGetActiveOrganizationsQuery>;
export type GetActiveOrganizationsLazyQueryHookResult = ReturnType<typeof useGetActiveOrganizationsLazyQuery>;
export type GetActiveOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetActiveOrganizationsSuspenseQuery>;
export type GetActiveOrganizationsQueryResult = Apollo.QueryResult<GetActiveOrganizationsQuery, GetActiveOrganizationsQueryVariables>;
export const GetOrganizationsPaginatedDocument = gql`
    query GET_ORGANIZATIONS_PAGINATED($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: OrganizationsFilterInput) {
  organizationsFilter(
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    organizations {
      _id
      name
    }
  }
}
    `;

/**
 * __useGetOrganizationsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsPaginatedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOrganizationsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsPaginatedQuery, GetOrganizationsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsPaginatedQuery, GetOrganizationsPaginatedQueryVariables>(GetOrganizationsPaginatedDocument, options);
      }
export function useGetOrganizationsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsPaginatedQuery, GetOrganizationsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsPaginatedQuery, GetOrganizationsPaginatedQueryVariables>(GetOrganizationsPaginatedDocument, options);
        }
// @ts-ignore
export function useGetOrganizationsPaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationsPaginatedQuery, GetOrganizationsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsPaginatedQuery, GetOrganizationsPaginatedQueryVariables>;
export function useGetOrganizationsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsPaginatedQuery, GetOrganizationsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsPaginatedQuery | undefined, GetOrganizationsPaginatedQueryVariables>;
export function useGetOrganizationsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsPaginatedQuery, GetOrganizationsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsPaginatedQuery, GetOrganizationsPaginatedQueryVariables>(GetOrganizationsPaginatedDocument, options);
        }
export type GetOrganizationsPaginatedQueryHookResult = ReturnType<typeof useGetOrganizationsPaginatedQuery>;
export type GetOrganizationsPaginatedLazyQueryHookResult = ReturnType<typeof useGetOrganizationsPaginatedLazyQuery>;
export type GetOrganizationsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsPaginatedSuspenseQuery>;
export type GetOrganizationsPaginatedQueryResult = Apollo.QueryResult<GetOrganizationsPaginatedQuery, GetOrganizationsPaginatedQueryVariables>;
export const GetOrganizationsEligibleToCreditsDocument = gql`
    query GET_ORGANIZATIONS_ELIGIBLE_TO_CREDITS {
  organizationsEligibleToCredits {
    _id
    name
  }
}
    `;

/**
 * __useGetOrganizationsEligibleToCreditsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsEligibleToCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsEligibleToCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsEligibleToCreditsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsEligibleToCreditsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsEligibleToCreditsQuery, GetOrganizationsEligibleToCreditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsEligibleToCreditsQuery, GetOrganizationsEligibleToCreditsQueryVariables>(GetOrganizationsEligibleToCreditsDocument, options);
      }
export function useGetOrganizationsEligibleToCreditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsEligibleToCreditsQuery, GetOrganizationsEligibleToCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsEligibleToCreditsQuery, GetOrganizationsEligibleToCreditsQueryVariables>(GetOrganizationsEligibleToCreditsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationsEligibleToCreditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationsEligibleToCreditsQuery, GetOrganizationsEligibleToCreditsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsEligibleToCreditsQuery, GetOrganizationsEligibleToCreditsQueryVariables>;
export function useGetOrganizationsEligibleToCreditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsEligibleToCreditsQuery, GetOrganizationsEligibleToCreditsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsEligibleToCreditsQuery | undefined, GetOrganizationsEligibleToCreditsQueryVariables>;
export function useGetOrganizationsEligibleToCreditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsEligibleToCreditsQuery, GetOrganizationsEligibleToCreditsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsEligibleToCreditsQuery, GetOrganizationsEligibleToCreditsQueryVariables>(GetOrganizationsEligibleToCreditsDocument, options);
        }
export type GetOrganizationsEligibleToCreditsQueryHookResult = ReturnType<typeof useGetOrganizationsEligibleToCreditsQuery>;
export type GetOrganizationsEligibleToCreditsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsEligibleToCreditsLazyQuery>;
export type GetOrganizationsEligibleToCreditsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsEligibleToCreditsSuspenseQuery>;
export type GetOrganizationsEligibleToCreditsQueryResult = Apollo.QueryResult<GetOrganizationsEligibleToCreditsQuery, GetOrganizationsEligibleToCreditsQueryVariables>;
export const GetOrganizationDocument = gql`
    query GET_ORGANIZATION($organizationId: ID!) {
  organization(organizationId: $organizationId) {
    _id
    admins {
      _id
      fullname
    }
    attachUsersManually
    B2BPriceRange
    createdAt
    domains
    hasDetailedOrderInvoicing
    hasFreefoodIncluded
    hasSubscription
    imageUrl
    mandateSEPA
    maxUsers
    name
    customerType
    paymentTimeType
    paymentType
    hasOdooOrganizationParentInvoicing
    hasPrepaidOrganizationCards
    hasPrepaidSubventions
    sales {
      _id
      fullName
    }
    segregatedInvoicing
    state
    stateHistory {
      createdAt
      createdBy
      createdByName
      state
    }
    stripeId
    termsAcceptanceDate
    totalCoworkers
    updatedAt
    avaClientId
    restrictedProductArrangementId
    odooOrganizationId
    odooInvoiceReference
    odooCompany
    invoiceSettings {
      _id
      organizationId
      consumptionColumns {
        microstoreColumnIds
        priceOptionType
        tva
        priceTiers {
          thresholdMin
          unitPrice
          unitPriceWithoutCup
        }
      }
      rmeColumns {
        microstoreColumnIds
        type
        minimumAmount
        unitPrice
      }
      state
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> & ({ variables: GetOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
// @ts-ignore
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationQuery | undefined, GetOrganizationQueryVariables>;
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetOrganizationConsumptionDocument = gql`
    query GetOrganizationConsumption($organizationId: ID!, $startDate: String!, $endDate: String!) {
  getOrganizationConsumption(
    organizationId: $organizationId
    startDate: $startDate
    endDate: $endDate
  ) {
    organizationId
    startDate
    endDate
    transactionCount
    paidTransactionCount
    freeTransactionCount
    consumedValueHT
    columns {
      microstoreColumnId
      name
      transactionCount
      paidTransactionCount
      freeTransactionCount
      consumedValueHT
    }
    freefood {
      orderCount
      totalHT
      orders {
        orderId
        number
        deliveryDate
        totalHT
        invoicingStatus
        odooInvoiceId
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationConsumptionQuery__
 *
 * To run a query within a React component, call `useGetOrganizationConsumptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationConsumptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationConsumptionQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetOrganizationConsumptionQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationConsumptionQuery, GetOrganizationConsumptionQueryVariables> & ({ variables: GetOrganizationConsumptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationConsumptionQuery, GetOrganizationConsumptionQueryVariables>(GetOrganizationConsumptionDocument, options);
      }
export function useGetOrganizationConsumptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationConsumptionQuery, GetOrganizationConsumptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationConsumptionQuery, GetOrganizationConsumptionQueryVariables>(GetOrganizationConsumptionDocument, options);
        }
// @ts-ignore
export function useGetOrganizationConsumptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationConsumptionQuery, GetOrganizationConsumptionQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationConsumptionQuery, GetOrganizationConsumptionQueryVariables>;
export function useGetOrganizationConsumptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationConsumptionQuery, GetOrganizationConsumptionQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationConsumptionQuery | undefined, GetOrganizationConsumptionQueryVariables>;
export function useGetOrganizationConsumptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationConsumptionQuery, GetOrganizationConsumptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationConsumptionQuery, GetOrganizationConsumptionQueryVariables>(GetOrganizationConsumptionDocument, options);
        }
export type GetOrganizationConsumptionQueryHookResult = ReturnType<typeof useGetOrganizationConsumptionQuery>;
export type GetOrganizationConsumptionLazyQueryHookResult = ReturnType<typeof useGetOrganizationConsumptionLazyQuery>;
export type GetOrganizationConsumptionSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationConsumptionSuspenseQuery>;
export type GetOrganizationConsumptionQueryResult = Apollo.QueryResult<GetOrganizationConsumptionQuery, GetOrganizationConsumptionQueryVariables>;
export const GetOrganizationInvoiceSimulationDocument = gql`
    query GetOrganizationInvoiceSimulation($organizationId: ID!, $startDate: String!, $endDate: String!) {
  getOrganizationInvoiceSimulation(
    organizationId: $organizationId
    startDate: $startDate
    endDate: $endDate
  ) {
    organizationId
    startDate
    endDate
    totalHT
    totalVat
    totalTTC
    collector
    totalsByVat {
      taxRate
      amountHT
      amountVat
    }
    totalsByCategory {
      category
      amountHT
    }
    groups {
      category
      lines {
        type
        name
        quantity
        priceUnit
        taxRate
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationInvoiceSimulationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationInvoiceSimulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationInvoiceSimulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationInvoiceSimulationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetOrganizationInvoiceSimulationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationInvoiceSimulationQuery, GetOrganizationInvoiceSimulationQueryVariables> & ({ variables: GetOrganizationInvoiceSimulationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationInvoiceSimulationQuery, GetOrganizationInvoiceSimulationQueryVariables>(GetOrganizationInvoiceSimulationDocument, options);
      }
export function useGetOrganizationInvoiceSimulationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationInvoiceSimulationQuery, GetOrganizationInvoiceSimulationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationInvoiceSimulationQuery, GetOrganizationInvoiceSimulationQueryVariables>(GetOrganizationInvoiceSimulationDocument, options);
        }
// @ts-ignore
export function useGetOrganizationInvoiceSimulationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationInvoiceSimulationQuery, GetOrganizationInvoiceSimulationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationInvoiceSimulationQuery, GetOrganizationInvoiceSimulationQueryVariables>;
export function useGetOrganizationInvoiceSimulationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationInvoiceSimulationQuery, GetOrganizationInvoiceSimulationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationInvoiceSimulationQuery | undefined, GetOrganizationInvoiceSimulationQueryVariables>;
export function useGetOrganizationInvoiceSimulationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationInvoiceSimulationQuery, GetOrganizationInvoiceSimulationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationInvoiceSimulationQuery, GetOrganizationInvoiceSimulationQueryVariables>(GetOrganizationInvoiceSimulationDocument, options);
        }
export type GetOrganizationInvoiceSimulationQueryHookResult = ReturnType<typeof useGetOrganizationInvoiceSimulationQuery>;
export type GetOrganizationInvoiceSimulationLazyQueryHookResult = ReturnType<typeof useGetOrganizationInvoiceSimulationLazyQuery>;
export type GetOrganizationInvoiceSimulationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationInvoiceSimulationSuspenseQuery>;
export type GetOrganizationInvoiceSimulationQueryResult = Apollo.QueryResult<GetOrganizationInvoiceSimulationQuery, GetOrganizationInvoiceSimulationQueryVariables>;
export const GetPollsDocument = gql`
    query GetPolls($offset: Int!) {
  polls(offset: $offset) {
    hasMore
    polls {
      _id
      createdAt
      numberOfParticipants
      question
    }
  }
}
    `;

/**
 * __useGetPollsQuery__
 *
 * To run a query within a React component, call `useGetPollsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPollsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPollsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPollsQuery(baseOptions: Apollo.QueryHookOptions<GetPollsQuery, GetPollsQueryVariables> & ({ variables: GetPollsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPollsQuery, GetPollsQueryVariables>(GetPollsDocument, options);
      }
export function useGetPollsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPollsQuery, GetPollsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPollsQuery, GetPollsQueryVariables>(GetPollsDocument, options);
        }
// @ts-ignore
export function useGetPollsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPollsQuery, GetPollsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPollsQuery, GetPollsQueryVariables>;
export function useGetPollsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPollsQuery, GetPollsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPollsQuery | undefined, GetPollsQueryVariables>;
export function useGetPollsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPollsQuery, GetPollsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPollsQuery, GetPollsQueryVariables>(GetPollsDocument, options);
        }
export type GetPollsQueryHookResult = ReturnType<typeof useGetPollsQuery>;
export type GetPollsLazyQueryHookResult = ReturnType<typeof useGetPollsLazyQuery>;
export type GetPollsSuspenseQueryHookResult = ReturnType<typeof useGetPollsSuspenseQuery>;
export type GetPollsQueryResult = Apollo.QueryResult<GetPollsQuery, GetPollsQueryVariables>;
export const GetPollDocument = gql`
    query GetPoll($pollId: ID!) {
  poll(pollId: $pollId) {
    ...PollFragment
  }
}
    ${PollFragmentFragmentDoc}`;

/**
 * __useGetPollQuery__
 *
 * To run a query within a React component, call `useGetPollQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPollQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPollQuery({
 *   variables: {
 *      pollId: // value for 'pollId'
 *   },
 * });
 */
export function useGetPollQuery(baseOptions: Apollo.QueryHookOptions<GetPollQuery, GetPollQueryVariables> & ({ variables: GetPollQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPollQuery, GetPollQueryVariables>(GetPollDocument, options);
      }
export function useGetPollLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPollQuery, GetPollQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPollQuery, GetPollQueryVariables>(GetPollDocument, options);
        }
// @ts-ignore
export function useGetPollSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPollQuery, GetPollQueryVariables>): Apollo.UseSuspenseQueryResult<GetPollQuery, GetPollQueryVariables>;
export function useGetPollSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPollQuery, GetPollQueryVariables>): Apollo.UseSuspenseQueryResult<GetPollQuery | undefined, GetPollQueryVariables>;
export function useGetPollSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPollQuery, GetPollQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPollQuery, GetPollQueryVariables>(GetPollDocument, options);
        }
export type GetPollQueryHookResult = ReturnType<typeof useGetPollQuery>;
export type GetPollLazyQueryHookResult = ReturnType<typeof useGetPollLazyQuery>;
export type GetPollSuspenseQueryHookResult = ReturnType<typeof useGetPollSuspenseQuery>;
export type GetPollQueryResult = Apollo.QueryResult<GetPollQuery, GetPollQueryVariables>;
export const GetProductPriceRangesDocument = gql`
    query GET_PRODUCT_PRICE_RANGES {
  productPriceRanges {
    _id
    name
  }
}
    `;

/**
 * __useGetProductPriceRangesQuery__
 *
 * To run a query within a React component, call `useGetProductPriceRangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPriceRangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPriceRangesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductPriceRangesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductPriceRangesQuery, GetProductPriceRangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductPriceRangesQuery, GetProductPriceRangesQueryVariables>(GetProductPriceRangesDocument, options);
      }
export function useGetProductPriceRangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductPriceRangesQuery, GetProductPriceRangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductPriceRangesQuery, GetProductPriceRangesQueryVariables>(GetProductPriceRangesDocument, options);
        }
// @ts-ignore
export function useGetProductPriceRangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductPriceRangesQuery, GetProductPriceRangesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductPriceRangesQuery, GetProductPriceRangesQueryVariables>;
export function useGetProductPriceRangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductPriceRangesQuery, GetProductPriceRangesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductPriceRangesQuery | undefined, GetProductPriceRangesQueryVariables>;
export function useGetProductPriceRangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductPriceRangesQuery, GetProductPriceRangesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductPriceRangesQuery, GetProductPriceRangesQueryVariables>(GetProductPriceRangesDocument, options);
        }
export type GetProductPriceRangesQueryHookResult = ReturnType<typeof useGetProductPriceRangesQuery>;
export type GetProductPriceRangesLazyQueryHookResult = ReturnType<typeof useGetProductPriceRangesLazyQuery>;
export type GetProductPriceRangesSuspenseQueryHookResult = ReturnType<typeof useGetProductPriceRangesSuspenseQuery>;
export type GetProductPriceRangesQueryResult = Apollo.QueryResult<GetProductPriceRangesQuery, GetProductPriceRangesQueryVariables>;
export const GetProductPriceRangeDocument = gql`
    query GET_PRODUCT_PRICE_RANGE($rangeId: ID!) {
  productPriceRange(rangeId: $rangeId) {
    name
    products {
      productId
      price
      crossedPrice
      name
    }
    productArrangements {
      productArrangementId
      price
      crossedPrice
      name
    }
  }
}
    `;

/**
 * __useGetProductPriceRangeQuery__
 *
 * To run a query within a React component, call `useGetProductPriceRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPriceRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPriceRangeQuery({
 *   variables: {
 *      rangeId: // value for 'rangeId'
 *   },
 * });
 */
export function useGetProductPriceRangeQuery(baseOptions: Apollo.QueryHookOptions<GetProductPriceRangeQuery, GetProductPriceRangeQueryVariables> & ({ variables: GetProductPriceRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductPriceRangeQuery, GetProductPriceRangeQueryVariables>(GetProductPriceRangeDocument, options);
      }
export function useGetProductPriceRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductPriceRangeQuery, GetProductPriceRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductPriceRangeQuery, GetProductPriceRangeQueryVariables>(GetProductPriceRangeDocument, options);
        }
// @ts-ignore
export function useGetProductPriceRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductPriceRangeQuery, GetProductPriceRangeQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductPriceRangeQuery, GetProductPriceRangeQueryVariables>;
export function useGetProductPriceRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductPriceRangeQuery, GetProductPriceRangeQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductPriceRangeQuery | undefined, GetProductPriceRangeQueryVariables>;
export function useGetProductPriceRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductPriceRangeQuery, GetProductPriceRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductPriceRangeQuery, GetProductPriceRangeQueryVariables>(GetProductPriceRangeDocument, options);
        }
export type GetProductPriceRangeQueryHookResult = ReturnType<typeof useGetProductPriceRangeQuery>;
export type GetProductPriceRangeLazyQueryHookResult = ReturnType<typeof useGetProductPriceRangeLazyQuery>;
export type GetProductPriceRangeSuspenseQueryHookResult = ReturnType<typeof useGetProductPriceRangeSuspenseQuery>;
export type GetProductPriceRangeQueryResult = Apollo.QueryResult<GetProductPriceRangeQuery, GetProductPriceRangeQueryVariables>;
export const GetProductPricesDocument = gql`
    query GET_PRODUCT_PRICES($productId: ID!) {
  productPrices(productId: $productId) {
    rangeId
    price
    crossedPrice
    type
  }
}
    `;

/**
 * __useGetProductPricesQuery__
 *
 * To run a query within a React component, call `useGetProductPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPricesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductPricesQuery(baseOptions: Apollo.QueryHookOptions<GetProductPricesQuery, GetProductPricesQueryVariables> & ({ variables: GetProductPricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductPricesQuery, GetProductPricesQueryVariables>(GetProductPricesDocument, options);
      }
export function useGetProductPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductPricesQuery, GetProductPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductPricesQuery, GetProductPricesQueryVariables>(GetProductPricesDocument, options);
        }
// @ts-ignore
export function useGetProductPricesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductPricesQuery, GetProductPricesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductPricesQuery, GetProductPricesQueryVariables>;
export function useGetProductPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductPricesQuery, GetProductPricesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductPricesQuery | undefined, GetProductPricesQueryVariables>;
export function useGetProductPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductPricesQuery, GetProductPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductPricesQuery, GetProductPricesQueryVariables>(GetProductPricesDocument, options);
        }
export type GetProductPricesQueryHookResult = ReturnType<typeof useGetProductPricesQuery>;
export type GetProductPricesLazyQueryHookResult = ReturnType<typeof useGetProductPricesLazyQuery>;
export type GetProductPricesSuspenseQueryHookResult = ReturnType<typeof useGetProductPricesSuspenseQuery>;
export type GetProductPricesQueryResult = Apollo.QueryResult<GetProductPricesQuery, GetProductPricesQueryVariables>;
export const GetProductsFromCsvDocument = gql`
    query GET_PRODUCTS_FROM_CSV($rangeId: ID, $csvData: [RangeCsvData!]!) {
  productsFromCsv(rangeId: $rangeId, csvData: $csvData) {
    productsForRange {
      _id
      name
      price
    }
    productArrangementsForRange {
      _id
      name
      price
    }
    idsNotFound
    idsNotActive
    productArrangementsIdsNotFound
    productArrangementsIdsNotActive
  }
}
    `;

/**
 * __useGetProductsFromCsvQuery__
 *
 * To run a query within a React component, call `useGetProductsFromCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsFromCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsFromCsvQuery({
 *   variables: {
 *      rangeId: // value for 'rangeId'
 *      csvData: // value for 'csvData'
 *   },
 * });
 */
export function useGetProductsFromCsvQuery(baseOptions: Apollo.QueryHookOptions<GetProductsFromCsvQuery, GetProductsFromCsvQueryVariables> & ({ variables: GetProductsFromCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsFromCsvQuery, GetProductsFromCsvQueryVariables>(GetProductsFromCsvDocument, options);
      }
export function useGetProductsFromCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsFromCsvQuery, GetProductsFromCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsFromCsvQuery, GetProductsFromCsvQueryVariables>(GetProductsFromCsvDocument, options);
        }
// @ts-ignore
export function useGetProductsFromCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsFromCsvQuery, GetProductsFromCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsFromCsvQuery, GetProductsFromCsvQueryVariables>;
export function useGetProductsFromCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsFromCsvQuery, GetProductsFromCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsFromCsvQuery | undefined, GetProductsFromCsvQueryVariables>;
export function useGetProductsFromCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsFromCsvQuery, GetProductsFromCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsFromCsvQuery, GetProductsFromCsvQueryVariables>(GetProductsFromCsvDocument, options);
        }
export type GetProductsFromCsvQueryHookResult = ReturnType<typeof useGetProductsFromCsvQuery>;
export type GetProductsFromCsvLazyQueryHookResult = ReturnType<typeof useGetProductsFromCsvLazyQuery>;
export type GetProductsFromCsvSuspenseQueryHookResult = ReturnType<typeof useGetProductsFromCsvSuspenseQuery>;
export type GetProductsFromCsvQueryResult = Apollo.QueryResult<GetProductsFromCsvQuery, GetProductsFromCsvQueryVariables>;
export const GetTransferableProductsDocument = gql`
    query GET_TRANSFERABLE_PRODUCTS($originColumnId: ID!, $destinationColumnId: ID!, $transferDate: String) {
  transferableProducts(
    originColumnId: $originColumnId
    destinationColumnId: $destinationColumnId
    transferDate: $transferDate
  ) {
    productId
    fullname
    conditionning
    packagesPerBatch
    originStockAvailable
    destinationStockAvailable
    quantity
  }
}
    `;

/**
 * __useGetTransferableProductsQuery__
 *
 * To run a query within a React component, call `useGetTransferableProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferableProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferableProductsQuery({
 *   variables: {
 *      originColumnId: // value for 'originColumnId'
 *      destinationColumnId: // value for 'destinationColumnId'
 *      transferDate: // value for 'transferDate'
 *   },
 * });
 */
export function useGetTransferableProductsQuery(baseOptions: Apollo.QueryHookOptions<GetTransferableProductsQuery, GetTransferableProductsQueryVariables> & ({ variables: GetTransferableProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferableProductsQuery, GetTransferableProductsQueryVariables>(GetTransferableProductsDocument, options);
      }
export function useGetTransferableProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferableProductsQuery, GetTransferableProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferableProductsQuery, GetTransferableProductsQueryVariables>(GetTransferableProductsDocument, options);
        }
// @ts-ignore
export function useGetTransferableProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferableProductsQuery, GetTransferableProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferableProductsQuery, GetTransferableProductsQueryVariables>;
export function useGetTransferableProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferableProductsQuery, GetTransferableProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferableProductsQuery | undefined, GetTransferableProductsQueryVariables>;
export function useGetTransferableProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferableProductsQuery, GetTransferableProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferableProductsQuery, GetTransferableProductsQueryVariables>(GetTransferableProductsDocument, options);
        }
export type GetTransferableProductsQueryHookResult = ReturnType<typeof useGetTransferableProductsQuery>;
export type GetTransferableProductsLazyQueryHookResult = ReturnType<typeof useGetTransferableProductsLazyQuery>;
export type GetTransferableProductsSuspenseQueryHookResult = ReturnType<typeof useGetTransferableProductsSuspenseQuery>;
export type GetTransferableProductsQueryResult = Apollo.QueryResult<GetTransferableProductsQuery, GetTransferableProductsQueryVariables>;
export const GetTransferableProductsFromCsvDocument = gql`
    query GET_TRANSFERABLE_PRODUCTS_FROM_CSV($originColumnId: ID!, $destinationColumnId: ID!, $csvData: [TransferCsvData]!, $isDestinationQuantity: Boolean!) {
  transferableProductsFromCsv(
    originColumnId: $originColumnId
    destinationColumnId: $destinationColumnId
    csvData: $csvData
    isDestinationQuantity: $isDestinationQuantity
  ) {
    transferableProducts {
      productId
      fullname
      conditionning
      packagesPerBatch
      originStockAvailable
      destinationStockAvailable
      quantity
    }
    idsNotFound
    idsArchived
  }
}
    `;

/**
 * __useGetTransferableProductsFromCsvQuery__
 *
 * To run a query within a React component, call `useGetTransferableProductsFromCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferableProductsFromCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferableProductsFromCsvQuery({
 *   variables: {
 *      originColumnId: // value for 'originColumnId'
 *      destinationColumnId: // value for 'destinationColumnId'
 *      csvData: // value for 'csvData'
 *      isDestinationQuantity: // value for 'isDestinationQuantity'
 *   },
 * });
 */
export function useGetTransferableProductsFromCsvQuery(baseOptions: Apollo.QueryHookOptions<GetTransferableProductsFromCsvQuery, GetTransferableProductsFromCsvQueryVariables> & ({ variables: GetTransferableProductsFromCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferableProductsFromCsvQuery, GetTransferableProductsFromCsvQueryVariables>(GetTransferableProductsFromCsvDocument, options);
      }
export function useGetTransferableProductsFromCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferableProductsFromCsvQuery, GetTransferableProductsFromCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferableProductsFromCsvQuery, GetTransferableProductsFromCsvQueryVariables>(GetTransferableProductsFromCsvDocument, options);
        }
// @ts-ignore
export function useGetTransferableProductsFromCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferableProductsFromCsvQuery, GetTransferableProductsFromCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferableProductsFromCsvQuery, GetTransferableProductsFromCsvQueryVariables>;
export function useGetTransferableProductsFromCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferableProductsFromCsvQuery, GetTransferableProductsFromCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferableProductsFromCsvQuery | undefined, GetTransferableProductsFromCsvQueryVariables>;
export function useGetTransferableProductsFromCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferableProductsFromCsvQuery, GetTransferableProductsFromCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferableProductsFromCsvQuery, GetTransferableProductsFromCsvQueryVariables>(GetTransferableProductsFromCsvDocument, options);
        }
export type GetTransferableProductsFromCsvQueryHookResult = ReturnType<typeof useGetTransferableProductsFromCsvQuery>;
export type GetTransferableProductsFromCsvLazyQueryHookResult = ReturnType<typeof useGetTransferableProductsFromCsvLazyQuery>;
export type GetTransferableProductsFromCsvSuspenseQueryHookResult = ReturnType<typeof useGetTransferableProductsFromCsvSuspenseQuery>;
export type GetTransferableProductsFromCsvQueryResult = Apollo.QueryResult<GetTransferableProductsFromCsvQuery, GetTransferableProductsFromCsvQueryVariables>;
export const GetProductsWithStockByColumnsDocument = gql`
    query GET_PRODUCTS_WITH_STOCK_BY_COLUMNS($columnIds: [ID!]!) {
  productsWithStockByColumns(columnIds: $columnIds) {
    _id
    brand
    categoryId
    expiryDateRecordsWarehouse {
      _id
      expiryDate
      initialQuantity
      quantityAtInventory
    }
    flow
    name
    stockByColumns(columnIds: $columnIds) {
      columnId
      stock
      stockAvailable
    }
    trackExpiryDate
    volume
    isDoubleCoil
    isWithoutStock
  }
}
    `;

/**
 * __useGetProductsWithStockByColumnsQuery__
 *
 * To run a query within a React component, call `useGetProductsWithStockByColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsWithStockByColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsWithStockByColumnsQuery({
 *   variables: {
 *      columnIds: // value for 'columnIds'
 *   },
 * });
 */
export function useGetProductsWithStockByColumnsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsWithStockByColumnsQuery, GetProductsWithStockByColumnsQueryVariables> & ({ variables: GetProductsWithStockByColumnsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsWithStockByColumnsQuery, GetProductsWithStockByColumnsQueryVariables>(GetProductsWithStockByColumnsDocument, options);
      }
export function useGetProductsWithStockByColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsWithStockByColumnsQuery, GetProductsWithStockByColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsWithStockByColumnsQuery, GetProductsWithStockByColumnsQueryVariables>(GetProductsWithStockByColumnsDocument, options);
        }
// @ts-ignore
export function useGetProductsWithStockByColumnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsWithStockByColumnsQuery, GetProductsWithStockByColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsWithStockByColumnsQuery, GetProductsWithStockByColumnsQueryVariables>;
export function useGetProductsWithStockByColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsWithStockByColumnsQuery, GetProductsWithStockByColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsWithStockByColumnsQuery | undefined, GetProductsWithStockByColumnsQueryVariables>;
export function useGetProductsWithStockByColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsWithStockByColumnsQuery, GetProductsWithStockByColumnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsWithStockByColumnsQuery, GetProductsWithStockByColumnsQueryVariables>(GetProductsWithStockByColumnsDocument, options);
        }
export type GetProductsWithStockByColumnsQueryHookResult = ReturnType<typeof useGetProductsWithStockByColumnsQuery>;
export type GetProductsWithStockByColumnsLazyQueryHookResult = ReturnType<typeof useGetProductsWithStockByColumnsLazyQuery>;
export type GetProductsWithStockByColumnsSuspenseQueryHookResult = ReturnType<typeof useGetProductsWithStockByColumnsSuspenseQuery>;
export type GetProductsWithStockByColumnsQueryResult = Apollo.QueryResult<GetProductsWithStockByColumnsQuery, GetProductsWithStockByColumnsQueryVariables>;
export const GetCatalogProductsDocument = gql`
    query GET_CATALOG_PRODUCTS($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: CatalogProductsFilterInput) {
  catalogProducts(
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    products {
      ...CatalogProductFragment
    }
  }
}
    ${CatalogProductFragmentFragmentDoc}`;

/**
 * __useGetCatalogProductsQuery__
 *
 * To run a query within a React component, call `useGetCatalogProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogProductsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCatalogProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetCatalogProductsQuery, GetCatalogProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatalogProductsQuery, GetCatalogProductsQueryVariables>(GetCatalogProductsDocument, options);
      }
export function useGetCatalogProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogProductsQuery, GetCatalogProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatalogProductsQuery, GetCatalogProductsQueryVariables>(GetCatalogProductsDocument, options);
        }
// @ts-ignore
export function useGetCatalogProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCatalogProductsQuery, GetCatalogProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCatalogProductsQuery, GetCatalogProductsQueryVariables>;
export function useGetCatalogProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCatalogProductsQuery, GetCatalogProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCatalogProductsQuery | undefined, GetCatalogProductsQueryVariables>;
export function useGetCatalogProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCatalogProductsQuery, GetCatalogProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCatalogProductsQuery, GetCatalogProductsQueryVariables>(GetCatalogProductsDocument, options);
        }
export type GetCatalogProductsQueryHookResult = ReturnType<typeof useGetCatalogProductsQuery>;
export type GetCatalogProductsLazyQueryHookResult = ReturnType<typeof useGetCatalogProductsLazyQuery>;
export type GetCatalogProductsSuspenseQueryHookResult = ReturnType<typeof useGetCatalogProductsSuspenseQuery>;
export type GetCatalogProductsQueryResult = Apollo.QueryResult<GetCatalogProductsQuery, GetCatalogProductsQueryVariables>;
export const GetDetailedProductDocument = gql`
    query GET_DETAILED_PRODUCT($productId: ID!) {
  detailedProduct(productId: $productId) {
    _id
    comment
    ...ProductFragment
    isOutOfStock
    locations {
      _id
      datamatrix
      locationType
      warehouseColumnId
      warehouseColumn {
        name
      }
    }
    productGroup {
      ...ProductGroupFragment
    }
    productGroupsUsedIn {
      ...ProductGroupFragment
    }
    shouldOrderOnce
  }
}
    ${ProductFragmentFragmentDoc}
${ProductGroupFragmentFragmentDoc}`;

/**
 * __useGetDetailedProductQuery__
 *
 * To run a query within a React component, call `useGetDetailedProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetDetailedProductQuery(baseOptions: Apollo.QueryHookOptions<GetDetailedProductQuery, GetDetailedProductQueryVariables> & ({ variables: GetDetailedProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailedProductQuery, GetDetailedProductQueryVariables>(GetDetailedProductDocument, options);
      }
export function useGetDetailedProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailedProductQuery, GetDetailedProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailedProductQuery, GetDetailedProductQueryVariables>(GetDetailedProductDocument, options);
        }
// @ts-ignore
export function useGetDetailedProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDetailedProductQuery, GetDetailedProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedProductQuery, GetDetailedProductQueryVariables>;
export function useGetDetailedProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedProductQuery, GetDetailedProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedProductQuery | undefined, GetDetailedProductQueryVariables>;
export function useGetDetailedProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedProductQuery, GetDetailedProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailedProductQuery, GetDetailedProductQueryVariables>(GetDetailedProductDocument, options);
        }
export type GetDetailedProductQueryHookResult = ReturnType<typeof useGetDetailedProductQuery>;
export type GetDetailedProductLazyQueryHookResult = ReturnType<typeof useGetDetailedProductLazyQuery>;
export type GetDetailedProductSuspenseQueryHookResult = ReturnType<typeof useGetDetailedProductSuspenseQuery>;
export type GetDetailedProductQueryResult = Apollo.QueryResult<GetDetailedProductQuery, GetDetailedProductQueryVariables>;
export const GetNonArchivedProductsDocument = gql`
    query GET_NON_ARCHIVED_PRODUCTS {
  nonArchivedProducts {
    _id
    name
    brand
    volume
  }
}
    `;

/**
 * __useGetNonArchivedProductsQuery__
 *
 * To run a query within a React component, call `useGetNonArchivedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonArchivedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonArchivedProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNonArchivedProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetNonArchivedProductsQuery, GetNonArchivedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonArchivedProductsQuery, GetNonArchivedProductsQueryVariables>(GetNonArchivedProductsDocument, options);
      }
export function useGetNonArchivedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonArchivedProductsQuery, GetNonArchivedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonArchivedProductsQuery, GetNonArchivedProductsQueryVariables>(GetNonArchivedProductsDocument, options);
        }
// @ts-ignore
export function useGetNonArchivedProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNonArchivedProductsQuery, GetNonArchivedProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNonArchivedProductsQuery, GetNonArchivedProductsQueryVariables>;
export function useGetNonArchivedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNonArchivedProductsQuery, GetNonArchivedProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNonArchivedProductsQuery | undefined, GetNonArchivedProductsQueryVariables>;
export function useGetNonArchivedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNonArchivedProductsQuery, GetNonArchivedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNonArchivedProductsQuery, GetNonArchivedProductsQueryVariables>(GetNonArchivedProductsDocument, options);
        }
export type GetNonArchivedProductsQueryHookResult = ReturnType<typeof useGetNonArchivedProductsQuery>;
export type GetNonArchivedProductsLazyQueryHookResult = ReturnType<typeof useGetNonArchivedProductsLazyQuery>;
export type GetNonArchivedProductsSuspenseQueryHookResult = ReturnType<typeof useGetNonArchivedProductsSuspenseQuery>;
export type GetNonArchivedProductsQueryResult = Apollo.QueryResult<GetNonArchivedProductsQuery, GetNonArchivedProductsQueryVariables>;
export const GetAllProductsDocument = gql`
    query GET_ALL_PRODUCTS {
  getAllProducts {
    _id
    brand
    categoryId
    fullname
    height
    imageUrl
    isDoubleCoil
    isMicrostore
    shouldBeHiddenInStore
    isToBeArchived
    isWithoutStock
    length
    name
    state
    volume
    weight
    width
  }
}
    `;

/**
 * __useGetAllProductsQuery__
 *
 * To run a query within a React component, call `useGetAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
      }
export function useGetAllProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
        }
// @ts-ignore
export function useGetAllProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllProductsQuery, GetAllProductsQueryVariables>;
export function useGetAllProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllProductsQuery | undefined, GetAllProductsQueryVariables>;
export function useGetAllProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
        }
export type GetAllProductsQueryHookResult = ReturnType<typeof useGetAllProductsQuery>;
export type GetAllProductsLazyQueryHookResult = ReturnType<typeof useGetAllProductsLazyQuery>;
export type GetAllProductsSuspenseQueryHookResult = ReturnType<typeof useGetAllProductsSuspenseQuery>;
export type GetAllProductsQueryResult = Apollo.QueryResult<GetAllProductsQuery, GetAllProductsQueryVariables>;
export const GetAvailableForMicrostoreDocument = gql`
    query GET_AVAILABLE_FOR_MICROSTORE {
  availableForMicrostore {
    _id
    brand
    fullname
    height
    imageUrl
    isMicrostore
    shouldBeHiddenInStore
    length
    name
    state
    volume
    weight
    width
  }
}
    `;

/**
 * __useGetAvailableForMicrostoreQuery__
 *
 * To run a query within a React component, call `useGetAvailableForMicrostoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableForMicrostoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableForMicrostoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableForMicrostoreQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableForMicrostoreQuery, GetAvailableForMicrostoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableForMicrostoreQuery, GetAvailableForMicrostoreQueryVariables>(GetAvailableForMicrostoreDocument, options);
      }
export function useGetAvailableForMicrostoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableForMicrostoreQuery, GetAvailableForMicrostoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableForMicrostoreQuery, GetAvailableForMicrostoreQueryVariables>(GetAvailableForMicrostoreDocument, options);
        }
// @ts-ignore
export function useGetAvailableForMicrostoreSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableForMicrostoreQuery, GetAvailableForMicrostoreQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableForMicrostoreQuery, GetAvailableForMicrostoreQueryVariables>;
export function useGetAvailableForMicrostoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableForMicrostoreQuery, GetAvailableForMicrostoreQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableForMicrostoreQuery | undefined, GetAvailableForMicrostoreQueryVariables>;
export function useGetAvailableForMicrostoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableForMicrostoreQuery, GetAvailableForMicrostoreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableForMicrostoreQuery, GetAvailableForMicrostoreQueryVariables>(GetAvailableForMicrostoreDocument, options);
        }
export type GetAvailableForMicrostoreQueryHookResult = ReturnType<typeof useGetAvailableForMicrostoreQuery>;
export type GetAvailableForMicrostoreLazyQueryHookResult = ReturnType<typeof useGetAvailableForMicrostoreLazyQuery>;
export type GetAvailableForMicrostoreSuspenseQueryHookResult = ReturnType<typeof useGetAvailableForMicrostoreSuspenseQuery>;
export type GetAvailableForMicrostoreQueryResult = Apollo.QueryResult<GetAvailableForMicrostoreQuery, GetAvailableForMicrostoreQueryVariables>;
export const GetOffDataDocument = gql`
    query GET_OFF_DATA($barcodes: [String!]!) {
  OFFProductData(barcodes: $barcodes) {
    success
    error
    productNutritionData {
      allergens
      ingredients
      nutrition {
        carbohydrates
        energyKcal
        fat
        fiber
        proteins
        saturatedFat
        sodium
        sugars
      }
      nutriscore
      traces
    }
  }
}
    `;

/**
 * __useGetOffDataQuery__
 *
 * To run a query within a React component, call `useGetOffDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOffDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOffDataQuery({
 *   variables: {
 *      barcodes: // value for 'barcodes'
 *   },
 * });
 */
export function useGetOffDataQuery(baseOptions: Apollo.QueryHookOptions<GetOffDataQuery, GetOffDataQueryVariables> & ({ variables: GetOffDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOffDataQuery, GetOffDataQueryVariables>(GetOffDataDocument, options);
      }
export function useGetOffDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOffDataQuery, GetOffDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOffDataQuery, GetOffDataQueryVariables>(GetOffDataDocument, options);
        }
// @ts-ignore
export function useGetOffDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOffDataQuery, GetOffDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetOffDataQuery, GetOffDataQueryVariables>;
export function useGetOffDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOffDataQuery, GetOffDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetOffDataQuery | undefined, GetOffDataQueryVariables>;
export function useGetOffDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOffDataQuery, GetOffDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOffDataQuery, GetOffDataQueryVariables>(GetOffDataDocument, options);
        }
export type GetOffDataQueryHookResult = ReturnType<typeof useGetOffDataQuery>;
export type GetOffDataLazyQueryHookResult = ReturnType<typeof useGetOffDataLazyQuery>;
export type GetOffDataSuspenseQueryHookResult = ReturnType<typeof useGetOffDataSuspenseQuery>;
export type GetOffDataQueryResult = Apollo.QueryResult<GetOffDataQuery, GetOffDataQueryVariables>;
export const GetProductsByCategoryDocument = gql`
    query GET_PRODUCTS_BY_CATEGORY($categoryId: ID!) {
  getProductsByCategory(categoryId: $categoryId) {
    _id
    availableStock
    fullname
    portion
  }
}
    `;

/**
 * __useGetProductsByCategoryQuery__
 *
 * To run a query within a React component, call `useGetProductsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsByCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetProductsByCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetProductsByCategoryQuery, GetProductsByCategoryQueryVariables> & ({ variables: GetProductsByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsByCategoryQuery, GetProductsByCategoryQueryVariables>(GetProductsByCategoryDocument, options);
      }
export function useGetProductsByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsByCategoryQuery, GetProductsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsByCategoryQuery, GetProductsByCategoryQueryVariables>(GetProductsByCategoryDocument, options);
        }
// @ts-ignore
export function useGetProductsByCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsByCategoryQuery, GetProductsByCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsByCategoryQuery, GetProductsByCategoryQueryVariables>;
export function useGetProductsByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsByCategoryQuery, GetProductsByCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsByCategoryQuery | undefined, GetProductsByCategoryQueryVariables>;
export function useGetProductsByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsByCategoryQuery, GetProductsByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsByCategoryQuery, GetProductsByCategoryQueryVariables>(GetProductsByCategoryDocument, options);
        }
export type GetProductsByCategoryQueryHookResult = ReturnType<typeof useGetProductsByCategoryQuery>;
export type GetProductsByCategoryLazyQueryHookResult = ReturnType<typeof useGetProductsByCategoryLazyQuery>;
export type GetProductsByCategorySuspenseQueryHookResult = ReturnType<typeof useGetProductsByCategorySuspenseQuery>;
export type GetProductsByCategoryQueryResult = Apollo.QueryResult<GetProductsByCategoryQuery, GetProductsByCategoryQueryVariables>;
export const GetTagProductsDocument = gql`
    query GET_TAG_PRODUCTS($tagId: ID!) {
  productsWithTagId(tagId: $tagId) {
    _id
    fullname
  }
}
    `;

/**
 * __useGetTagProductsQuery__
 *
 * To run a query within a React component, call `useGetTagProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagProductsQuery({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useGetTagProductsQuery(baseOptions: Apollo.QueryHookOptions<GetTagProductsQuery, GetTagProductsQueryVariables> & ({ variables: GetTagProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagProductsQuery, GetTagProductsQueryVariables>(GetTagProductsDocument, options);
      }
export function useGetTagProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagProductsQuery, GetTagProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagProductsQuery, GetTagProductsQueryVariables>(GetTagProductsDocument, options);
        }
// @ts-ignore
export function useGetTagProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagProductsQuery, GetTagProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagProductsQuery, GetTagProductsQueryVariables>;
export function useGetTagProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagProductsQuery, GetTagProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagProductsQuery | undefined, GetTagProductsQueryVariables>;
export function useGetTagProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagProductsQuery, GetTagProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagProductsQuery, GetTagProductsQueryVariables>(GetTagProductsDocument, options);
        }
export type GetTagProductsQueryHookResult = ReturnType<typeof useGetTagProductsQuery>;
export type GetTagProductsLazyQueryHookResult = ReturnType<typeof useGetTagProductsLazyQuery>;
export type GetTagProductsSuspenseQueryHookResult = ReturnType<typeof useGetTagProductsSuspenseQuery>;
export type GetTagProductsQueryResult = Apollo.QueryResult<GetTagProductsQuery, GetTagProductsQueryVariables>;
export const GetColumnProductsDocument = gql`
    query GET_COLUMN_PRODUCTS($columnId: ID!, $offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: ColumnProductsFilterInput) {
  columnProducts(
    columnId: $columnId
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    columnProducts {
      ...ColumnProductLight
    }
  }
}
    ${ColumnProductLightFragmentDoc}`;

/**
 * __useGetColumnProductsQuery__
 *
 * To run a query within a React component, call `useGetColumnProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColumnProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColumnProductsQuery({
 *   variables: {
 *      columnId: // value for 'columnId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetColumnProductsQuery(baseOptions: Apollo.QueryHookOptions<GetColumnProductsQuery, GetColumnProductsQueryVariables> & ({ variables: GetColumnProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetColumnProductsQuery, GetColumnProductsQueryVariables>(GetColumnProductsDocument, options);
      }
export function useGetColumnProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetColumnProductsQuery, GetColumnProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetColumnProductsQuery, GetColumnProductsQueryVariables>(GetColumnProductsDocument, options);
        }
// @ts-ignore
export function useGetColumnProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetColumnProductsQuery, GetColumnProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnProductsQuery, GetColumnProductsQueryVariables>;
export function useGetColumnProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnProductsQuery, GetColumnProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnProductsQuery | undefined, GetColumnProductsQueryVariables>;
export function useGetColumnProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnProductsQuery, GetColumnProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetColumnProductsQuery, GetColumnProductsQueryVariables>(GetColumnProductsDocument, options);
        }
export type GetColumnProductsQueryHookResult = ReturnType<typeof useGetColumnProductsQuery>;
export type GetColumnProductsLazyQueryHookResult = ReturnType<typeof useGetColumnProductsLazyQuery>;
export type GetColumnProductsSuspenseQueryHookResult = ReturnType<typeof useGetColumnProductsSuspenseQuery>;
export type GetColumnProductsQueryResult = Apollo.QueryResult<GetColumnProductsQuery, GetColumnProductsQueryVariables>;
export const GetSiteProductsDocument = gql`
    query GET_SITE_PRODUCTS($siteId: ID!, $offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: SiteProductsFilterInput) {
  siteProducts(
    siteId: $siteId
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    siteProducts {
      ...SiteProductLight
    }
  }
}
    ${SiteProductLightFragmentDoc}`;

/**
 * __useGetSiteProductsQuery__
 *
 * To run a query within a React component, call `useGetSiteProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteProductsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSiteProductsQuery(baseOptions: Apollo.QueryHookOptions<GetSiteProductsQuery, GetSiteProductsQueryVariables> & ({ variables: GetSiteProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteProductsQuery, GetSiteProductsQueryVariables>(GetSiteProductsDocument, options);
      }
export function useGetSiteProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteProductsQuery, GetSiteProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteProductsQuery, GetSiteProductsQueryVariables>(GetSiteProductsDocument, options);
        }
// @ts-ignore
export function useGetSiteProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteProductsQuery, GetSiteProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteProductsQuery, GetSiteProductsQueryVariables>;
export function useGetSiteProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteProductsQuery, GetSiteProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteProductsQuery | undefined, GetSiteProductsQueryVariables>;
export function useGetSiteProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteProductsQuery, GetSiteProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteProductsQuery, GetSiteProductsQueryVariables>(GetSiteProductsDocument, options);
        }
export type GetSiteProductsQueryHookResult = ReturnType<typeof useGetSiteProductsQuery>;
export type GetSiteProductsLazyQueryHookResult = ReturnType<typeof useGetSiteProductsLazyQuery>;
export type GetSiteProductsSuspenseQueryHookResult = ReturnType<typeof useGetSiteProductsSuspenseQuery>;
export type GetSiteProductsQueryResult = Apollo.QueryResult<GetSiteProductsQuery, GetSiteProductsQueryVariables>;
export const GetColumnProductDocument = gql`
    query GET_COLUMN_PRODUCT($columnId: ID!, $productId: ID!) {
  columnProduct(columnId: $columnId, productId: $productId) {
    ...ColumnProduct
  }
}
    ${ColumnProductFragmentDoc}`;

/**
 * __useGetColumnProductQuery__
 *
 * To run a query within a React component, call `useGetColumnProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColumnProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColumnProductQuery({
 *   variables: {
 *      columnId: // value for 'columnId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetColumnProductQuery(baseOptions: Apollo.QueryHookOptions<GetColumnProductQuery, GetColumnProductQueryVariables> & ({ variables: GetColumnProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetColumnProductQuery, GetColumnProductQueryVariables>(GetColumnProductDocument, options);
      }
export function useGetColumnProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetColumnProductQuery, GetColumnProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetColumnProductQuery, GetColumnProductQueryVariables>(GetColumnProductDocument, options);
        }
// @ts-ignore
export function useGetColumnProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetColumnProductQuery, GetColumnProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnProductQuery, GetColumnProductQueryVariables>;
export function useGetColumnProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnProductQuery, GetColumnProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnProductQuery | undefined, GetColumnProductQueryVariables>;
export function useGetColumnProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnProductQuery, GetColumnProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetColumnProductQuery, GetColumnProductQueryVariables>(GetColumnProductDocument, options);
        }
export type GetColumnProductQueryHookResult = ReturnType<typeof useGetColumnProductQuery>;
export type GetColumnProductLazyQueryHookResult = ReturnType<typeof useGetColumnProductLazyQuery>;
export type GetColumnProductSuspenseQueryHookResult = ReturnType<typeof useGetColumnProductSuspenseQuery>;
export type GetColumnProductQueryResult = Apollo.QueryResult<GetColumnProductQuery, GetColumnProductQueryVariables>;
export const GetColumnsProductDocument = gql`
    query GET_COLUMNS_PRODUCT($productId: ID!) {
  columnsProduct(productId: $productId) {
    columnId
    stock
    column {
      _id
      fullname
      type
    }
  }
}
    `;

/**
 * __useGetColumnsProductQuery__
 *
 * To run a query within a React component, call `useGetColumnsProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColumnsProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColumnsProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetColumnsProductQuery(baseOptions: Apollo.QueryHookOptions<GetColumnsProductQuery, GetColumnsProductQueryVariables> & ({ variables: GetColumnsProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetColumnsProductQuery, GetColumnsProductQueryVariables>(GetColumnsProductDocument, options);
      }
export function useGetColumnsProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetColumnsProductQuery, GetColumnsProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetColumnsProductQuery, GetColumnsProductQueryVariables>(GetColumnsProductDocument, options);
        }
// @ts-ignore
export function useGetColumnsProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetColumnsProductQuery, GetColumnsProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnsProductQuery, GetColumnsProductQueryVariables>;
export function useGetColumnsProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnsProductQuery, GetColumnsProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnsProductQuery | undefined, GetColumnsProductQueryVariables>;
export function useGetColumnsProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnsProductQuery, GetColumnsProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetColumnsProductQuery, GetColumnsProductQueryVariables>(GetColumnsProductDocument, options);
        }
export type GetColumnsProductQueryHookResult = ReturnType<typeof useGetColumnsProductQuery>;
export type GetColumnsProductLazyQueryHookResult = ReturnType<typeof useGetColumnsProductLazyQuery>;
export type GetColumnsProductSuspenseQueryHookResult = ReturnType<typeof useGetColumnsProductSuspenseQuery>;
export type GetColumnsProductQueryResult = Apollo.QueryResult<GetColumnsProductQuery, GetColumnsProductQueryVariables>;
export const GetMicrostoreProductsDocument = gql`
    query GET_MICROSTORE_PRODUCTS {
  getMicrostoreProducts {
    _id
    brand
    flow
    imageUrl
    name
    trackExpiryDate
    volume
  }
}
    `;

/**
 * __useGetMicrostoreProductsQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMicrostoreProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetMicrostoreProductsQuery, GetMicrostoreProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreProductsQuery, GetMicrostoreProductsQueryVariables>(GetMicrostoreProductsDocument, options);
      }
export function useGetMicrostoreProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreProductsQuery, GetMicrostoreProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreProductsQuery, GetMicrostoreProductsQueryVariables>(GetMicrostoreProductsDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreProductsQuery, GetMicrostoreProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreProductsQuery, GetMicrostoreProductsQueryVariables>;
export function useGetMicrostoreProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreProductsQuery, GetMicrostoreProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreProductsQuery | undefined, GetMicrostoreProductsQueryVariables>;
export function useGetMicrostoreProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreProductsQuery, GetMicrostoreProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreProductsQuery, GetMicrostoreProductsQueryVariables>(GetMicrostoreProductsDocument, options);
        }
export type GetMicrostoreProductsQueryHookResult = ReturnType<typeof useGetMicrostoreProductsQuery>;
export type GetMicrostoreProductsLazyQueryHookResult = ReturnType<typeof useGetMicrostoreProductsLazyQuery>;
export type GetMicrostoreProductsSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreProductsSuspenseQuery>;
export type GetMicrostoreProductsQueryResult = Apollo.QueryResult<GetMicrostoreProductsQuery, GetMicrostoreProductsQueryVariables>;
export const GetProductPreparationDelayDocument = gql`
    query GET_PRODUCT_PREPARATION_DELAY($productId: ID!) {
  productPreparationDelay(productId: $productId)
}
    `;

/**
 * __useGetProductPreparationDelayQuery__
 *
 * To run a query within a React component, call `useGetProductPreparationDelayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPreparationDelayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPreparationDelayQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductPreparationDelayQuery(baseOptions: Apollo.QueryHookOptions<GetProductPreparationDelayQuery, GetProductPreparationDelayQueryVariables> & ({ variables: GetProductPreparationDelayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductPreparationDelayQuery, GetProductPreparationDelayQueryVariables>(GetProductPreparationDelayDocument, options);
      }
export function useGetProductPreparationDelayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductPreparationDelayQuery, GetProductPreparationDelayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductPreparationDelayQuery, GetProductPreparationDelayQueryVariables>(GetProductPreparationDelayDocument, options);
        }
// @ts-ignore
export function useGetProductPreparationDelaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductPreparationDelayQuery, GetProductPreparationDelayQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductPreparationDelayQuery, GetProductPreparationDelayQueryVariables>;
export function useGetProductPreparationDelaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductPreparationDelayQuery, GetProductPreparationDelayQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductPreparationDelayQuery | undefined, GetProductPreparationDelayQueryVariables>;
export function useGetProductPreparationDelaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductPreparationDelayQuery, GetProductPreparationDelayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductPreparationDelayQuery, GetProductPreparationDelayQueryVariables>(GetProductPreparationDelayDocument, options);
        }
export type GetProductPreparationDelayQueryHookResult = ReturnType<typeof useGetProductPreparationDelayQuery>;
export type GetProductPreparationDelayLazyQueryHookResult = ReturnType<typeof useGetProductPreparationDelayLazyQuery>;
export type GetProductPreparationDelaySuspenseQueryHookResult = ReturnType<typeof useGetProductPreparationDelaySuspenseQuery>;
export type GetProductPreparationDelayQueryResult = Apollo.QueryResult<GetProductPreparationDelayQuery, GetProductPreparationDelayQueryVariables>;
export const GetProductsByIdDocument = gql`
    query GET_PRODUCTS_BY_ID($productIds: [ID!]!) {
  getProductsById(productIds: $productIds) {
    _id
    fullname
  }
}
    `;

/**
 * __useGetProductsByIdQuery__
 *
 * To run a query within a React component, call `useGetProductsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsByIdQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useGetProductsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProductsByIdQuery, GetProductsByIdQueryVariables> & ({ variables: GetProductsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsByIdQuery, GetProductsByIdQueryVariables>(GetProductsByIdDocument, options);
      }
export function useGetProductsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsByIdQuery, GetProductsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsByIdQuery, GetProductsByIdQueryVariables>(GetProductsByIdDocument, options);
        }
// @ts-ignore
export function useGetProductsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsByIdQuery, GetProductsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsByIdQuery, GetProductsByIdQueryVariables>;
export function useGetProductsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsByIdQuery, GetProductsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsByIdQuery | undefined, GetProductsByIdQueryVariables>;
export function useGetProductsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsByIdQuery, GetProductsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsByIdQuery, GetProductsByIdQueryVariables>(GetProductsByIdDocument, options);
        }
export type GetProductsByIdQueryHookResult = ReturnType<typeof useGetProductsByIdQuery>;
export type GetProductsByIdLazyQueryHookResult = ReturnType<typeof useGetProductsByIdLazyQuery>;
export type GetProductsByIdSuspenseQueryHookResult = ReturnType<typeof useGetProductsByIdSuspenseQuery>;
export type GetProductsByIdQueryResult = Apollo.QueryResult<GetProductsByIdQuery, GetProductsByIdQueryVariables>;
export const GetSupplierProductsDocument = gql`
    query GET_SUPPLIER_PRODUCTS($supplierId: ID!) {
  getSupplierProducts(supplierId: $supplierId) {
    _id
    fullname
  }
}
    `;

/**
 * __useGetSupplierProductsQuery__
 *
 * To run a query within a React component, call `useGetSupplierProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplierProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplierProductsQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useGetSupplierProductsQuery(baseOptions: Apollo.QueryHookOptions<GetSupplierProductsQuery, GetSupplierProductsQueryVariables> & ({ variables: GetSupplierProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplierProductsQuery, GetSupplierProductsQueryVariables>(GetSupplierProductsDocument, options);
      }
export function useGetSupplierProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplierProductsQuery, GetSupplierProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplierProductsQuery, GetSupplierProductsQueryVariables>(GetSupplierProductsDocument, options);
        }
// @ts-ignore
export function useGetSupplierProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSupplierProductsQuery, GetSupplierProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplierProductsQuery, GetSupplierProductsQueryVariables>;
export function useGetSupplierProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplierProductsQuery, GetSupplierProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplierProductsQuery | undefined, GetSupplierProductsQueryVariables>;
export function useGetSupplierProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplierProductsQuery, GetSupplierProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupplierProductsQuery, GetSupplierProductsQueryVariables>(GetSupplierProductsDocument, options);
        }
export type GetSupplierProductsQueryHookResult = ReturnType<typeof useGetSupplierProductsQuery>;
export type GetSupplierProductsLazyQueryHookResult = ReturnType<typeof useGetSupplierProductsLazyQuery>;
export type GetSupplierProductsSuspenseQueryHookResult = ReturnType<typeof useGetSupplierProductsSuspenseQuery>;
export type GetSupplierProductsQueryResult = Apollo.QueryResult<GetSupplierProductsQuery, GetSupplierProductsQueryVariables>;
export const GetProductsWithRecipesDocument = gql`
    query GET_PRODUCTS_WITH_RECIPES {
  getAllProducts {
    _id
    categoryId
    fullname
    imageUrl
    state
    weightWithoutPackaging
    recipe {
      ingredients {
        productId
        quantity
        hotDrinksIngredientUnit
        product {
          _id
          categoryId
          fullname
          imageUrl
          weightWithoutPackaging
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductsWithRecipesQuery__
 *
 * To run a query within a React component, call `useGetProductsWithRecipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsWithRecipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsWithRecipesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductsWithRecipesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsWithRecipesQuery, GetProductsWithRecipesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsWithRecipesQuery, GetProductsWithRecipesQueryVariables>(GetProductsWithRecipesDocument, options);
      }
export function useGetProductsWithRecipesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsWithRecipesQuery, GetProductsWithRecipesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsWithRecipesQuery, GetProductsWithRecipesQueryVariables>(GetProductsWithRecipesDocument, options);
        }
// @ts-ignore
export function useGetProductsWithRecipesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsWithRecipesQuery, GetProductsWithRecipesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsWithRecipesQuery, GetProductsWithRecipesQueryVariables>;
export function useGetProductsWithRecipesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsWithRecipesQuery, GetProductsWithRecipesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsWithRecipesQuery | undefined, GetProductsWithRecipesQueryVariables>;
export function useGetProductsWithRecipesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsWithRecipesQuery, GetProductsWithRecipesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsWithRecipesQuery, GetProductsWithRecipesQueryVariables>(GetProductsWithRecipesDocument, options);
        }
export type GetProductsWithRecipesQueryHookResult = ReturnType<typeof useGetProductsWithRecipesQuery>;
export type GetProductsWithRecipesLazyQueryHookResult = ReturnType<typeof useGetProductsWithRecipesLazyQuery>;
export type GetProductsWithRecipesSuspenseQueryHookResult = ReturnType<typeof useGetProductsWithRecipesSuspenseQuery>;
export type GetProductsWithRecipesQueryResult = Apollo.QueryResult<GetProductsWithRecipesQuery, GetProductsWithRecipesQueryVariables>;
export const GetProductArrangementsDocument = gql`
    query GET_PRODUCT_ARRANGEMENTS {
  productArrangementsQuery {
    ...ProductArrangementFragment
  }
}
    ${ProductArrangementFragmentFragmentDoc}`;

/**
 * __useGetProductArrangementsQuery__
 *
 * To run a query within a React component, call `useGetProductArrangementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductArrangementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductArrangementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductArrangementsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductArrangementsQuery, GetProductArrangementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductArrangementsQuery, GetProductArrangementsQueryVariables>(GetProductArrangementsDocument, options);
      }
export function useGetProductArrangementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductArrangementsQuery, GetProductArrangementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductArrangementsQuery, GetProductArrangementsQueryVariables>(GetProductArrangementsDocument, options);
        }
// @ts-ignore
export function useGetProductArrangementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductArrangementsQuery, GetProductArrangementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductArrangementsQuery, GetProductArrangementsQueryVariables>;
export function useGetProductArrangementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductArrangementsQuery, GetProductArrangementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductArrangementsQuery | undefined, GetProductArrangementsQueryVariables>;
export function useGetProductArrangementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductArrangementsQuery, GetProductArrangementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductArrangementsQuery, GetProductArrangementsQueryVariables>(GetProductArrangementsDocument, options);
        }
export type GetProductArrangementsQueryHookResult = ReturnType<typeof useGetProductArrangementsQuery>;
export type GetProductArrangementsLazyQueryHookResult = ReturnType<typeof useGetProductArrangementsLazyQuery>;
export type GetProductArrangementsSuspenseQueryHookResult = ReturnType<typeof useGetProductArrangementsSuspenseQuery>;
export type GetProductArrangementsQueryResult = Apollo.QueryResult<GetProductArrangementsQuery, GetProductArrangementsQueryVariables>;
export const GetProductArrangementDocument = gql`
    query GET_PRODUCT_ARRANGEMENT($productArrangementId: String!) {
  productArrangementQuery(productArrangementId: $productArrangementId) {
    ...ProductArrangementWithProductsFragment
  }
}
    ${ProductArrangementWithProductsFragmentFragmentDoc}`;

/**
 * __useGetProductArrangementQuery__
 *
 * To run a query within a React component, call `useGetProductArrangementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductArrangementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductArrangementQuery({
 *   variables: {
 *      productArrangementId: // value for 'productArrangementId'
 *   },
 * });
 */
export function useGetProductArrangementQuery(baseOptions: Apollo.QueryHookOptions<GetProductArrangementQuery, GetProductArrangementQueryVariables> & ({ variables: GetProductArrangementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductArrangementQuery, GetProductArrangementQueryVariables>(GetProductArrangementDocument, options);
      }
export function useGetProductArrangementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductArrangementQuery, GetProductArrangementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductArrangementQuery, GetProductArrangementQueryVariables>(GetProductArrangementDocument, options);
        }
// @ts-ignore
export function useGetProductArrangementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductArrangementQuery, GetProductArrangementQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductArrangementQuery, GetProductArrangementQueryVariables>;
export function useGetProductArrangementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductArrangementQuery, GetProductArrangementQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductArrangementQuery | undefined, GetProductArrangementQueryVariables>;
export function useGetProductArrangementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductArrangementQuery, GetProductArrangementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductArrangementQuery, GetProductArrangementQueryVariables>(GetProductArrangementDocument, options);
        }
export type GetProductArrangementQueryHookResult = ReturnType<typeof useGetProductArrangementQuery>;
export type GetProductArrangementLazyQueryHookResult = ReturnType<typeof useGetProductArrangementLazyQuery>;
export type GetProductArrangementSuspenseQueryHookResult = ReturnType<typeof useGetProductArrangementSuspenseQuery>;
export type GetProductArrangementQueryResult = Apollo.QueryResult<GetProductArrangementQuery, GetProductArrangementQueryVariables>;
export const GetProductGroupDocument = gql`
    query GET_PRODUCT_GROUP($productGroupId: ID!) {
  getProductGroup(productGroupId: $productGroupId) {
    ...ProductGroupFragment
  }
}
    ${ProductGroupFragmentFragmentDoc}`;

/**
 * __useGetProductGroupQuery__
 *
 * To run a query within a React component, call `useGetProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductGroupQuery({
 *   variables: {
 *      productGroupId: // value for 'productGroupId'
 *   },
 * });
 */
export function useGetProductGroupQuery(baseOptions: Apollo.QueryHookOptions<GetProductGroupQuery, GetProductGroupQueryVariables> & ({ variables: GetProductGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductGroupQuery, GetProductGroupQueryVariables>(GetProductGroupDocument, options);
      }
export function useGetProductGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductGroupQuery, GetProductGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductGroupQuery, GetProductGroupQueryVariables>(GetProductGroupDocument, options);
        }
// @ts-ignore
export function useGetProductGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductGroupQuery, GetProductGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductGroupQuery, GetProductGroupQueryVariables>;
export function useGetProductGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductGroupQuery, GetProductGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductGroupQuery | undefined, GetProductGroupQueryVariables>;
export function useGetProductGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductGroupQuery, GetProductGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductGroupQuery, GetProductGroupQueryVariables>(GetProductGroupDocument, options);
        }
export type GetProductGroupQueryHookResult = ReturnType<typeof useGetProductGroupQuery>;
export type GetProductGroupLazyQueryHookResult = ReturnType<typeof useGetProductGroupLazyQuery>;
export type GetProductGroupSuspenseQueryHookResult = ReturnType<typeof useGetProductGroupSuspenseQuery>;
export type GetProductGroupQueryResult = Apollo.QueryResult<GetProductGroupQuery, GetProductGroupQueryVariables>;
export const GetProductGroupsContainingProductsDocument = gql`
    query GET_PRODUCT_GROUPS_CONTAINING_PRODUCTS($productIds: [ID!]!) {
  getProductGroupsContainingProducts(productIds: $productIds) {
    ...ProductGroupFragment
    product {
      _id
      brand
      isToBeArchived
      name
      supplierShortageInfo {
        inShortage
        returnDate
      }
      stock
      volume
    }
  }
}
    ${ProductGroupFragmentFragmentDoc}`;

/**
 * __useGetProductGroupsContainingProductsQuery__
 *
 * To run a query within a React component, call `useGetProductGroupsContainingProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductGroupsContainingProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductGroupsContainingProductsQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useGetProductGroupsContainingProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductGroupsContainingProductsQuery, GetProductGroupsContainingProductsQueryVariables> & ({ variables: GetProductGroupsContainingProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductGroupsContainingProductsQuery, GetProductGroupsContainingProductsQueryVariables>(GetProductGroupsContainingProductsDocument, options);
      }
export function useGetProductGroupsContainingProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductGroupsContainingProductsQuery, GetProductGroupsContainingProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductGroupsContainingProductsQuery, GetProductGroupsContainingProductsQueryVariables>(GetProductGroupsContainingProductsDocument, options);
        }
// @ts-ignore
export function useGetProductGroupsContainingProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductGroupsContainingProductsQuery, GetProductGroupsContainingProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductGroupsContainingProductsQuery, GetProductGroupsContainingProductsQueryVariables>;
export function useGetProductGroupsContainingProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductGroupsContainingProductsQuery, GetProductGroupsContainingProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductGroupsContainingProductsQuery | undefined, GetProductGroupsContainingProductsQueryVariables>;
export function useGetProductGroupsContainingProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductGroupsContainingProductsQuery, GetProductGroupsContainingProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductGroupsContainingProductsQuery, GetProductGroupsContainingProductsQueryVariables>(GetProductGroupsContainingProductsDocument, options);
        }
export type GetProductGroupsContainingProductsQueryHookResult = ReturnType<typeof useGetProductGroupsContainingProductsQuery>;
export type GetProductGroupsContainingProductsLazyQueryHookResult = ReturnType<typeof useGetProductGroupsContainingProductsLazyQuery>;
export type GetProductGroupsContainingProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductGroupsContainingProductsSuspenseQuery>;
export type GetProductGroupsContainingProductsQueryResult = Apollo.QueryResult<GetProductGroupsContainingProductsQuery, GetProductGroupsContainingProductsQueryVariables>;
export const GetProductSwitchesDocument = gql`
    query GET_PRODUCT_SWITCHES {
  getProductSwitches {
    ...ProductSwitchFragment
  }
}
    ${ProductSwitchFragmentFragmentDoc}`;

/**
 * __useGetProductSwitchesQuery__
 *
 * To run a query within a React component, call `useGetProductSwitchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSwitchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSwitchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductSwitchesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductSwitchesQuery, GetProductSwitchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductSwitchesQuery, GetProductSwitchesQueryVariables>(GetProductSwitchesDocument, options);
      }
export function useGetProductSwitchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductSwitchesQuery, GetProductSwitchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductSwitchesQuery, GetProductSwitchesQueryVariables>(GetProductSwitchesDocument, options);
        }
// @ts-ignore
export function useGetProductSwitchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductSwitchesQuery, GetProductSwitchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductSwitchesQuery, GetProductSwitchesQueryVariables>;
export function useGetProductSwitchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductSwitchesQuery, GetProductSwitchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductSwitchesQuery | undefined, GetProductSwitchesQueryVariables>;
export function useGetProductSwitchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductSwitchesQuery, GetProductSwitchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductSwitchesQuery, GetProductSwitchesQueryVariables>(GetProductSwitchesDocument, options);
        }
export type GetProductSwitchesQueryHookResult = ReturnType<typeof useGetProductSwitchesQuery>;
export type GetProductSwitchesLazyQueryHookResult = ReturnType<typeof useGetProductSwitchesLazyQuery>;
export type GetProductSwitchesSuspenseQueryHookResult = ReturnType<typeof useGetProductSwitchesSuspenseQuery>;
export type GetProductSwitchesQueryResult = Apollo.QueryResult<GetProductSwitchesQuery, GetProductSwitchesQueryVariables>;
export const GetQuizzesDocument = gql`
    query GetQuizzes($offset: Int!) {
  quizzes(offset: $offset) {
    hasMore
    quizzes {
      _id
      createdAt
      title
    }
  }
}
    `;

/**
 * __useGetQuizzesQuery__
 *
 * To run a query within a React component, call `useGetQuizzesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizzesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizzesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetQuizzesQuery(baseOptions: Apollo.QueryHookOptions<GetQuizzesQuery, GetQuizzesQueryVariables> & ({ variables: GetQuizzesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuizzesQuery, GetQuizzesQueryVariables>(GetQuizzesDocument, options);
      }
export function useGetQuizzesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuizzesQuery, GetQuizzesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuizzesQuery, GetQuizzesQueryVariables>(GetQuizzesDocument, options);
        }
// @ts-ignore
export function useGetQuizzesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuizzesQuery, GetQuizzesQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuizzesQuery, GetQuizzesQueryVariables>;
export function useGetQuizzesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuizzesQuery, GetQuizzesQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuizzesQuery | undefined, GetQuizzesQueryVariables>;
export function useGetQuizzesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuizzesQuery, GetQuizzesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuizzesQuery, GetQuizzesQueryVariables>(GetQuizzesDocument, options);
        }
export type GetQuizzesQueryHookResult = ReturnType<typeof useGetQuizzesQuery>;
export type GetQuizzesLazyQueryHookResult = ReturnType<typeof useGetQuizzesLazyQuery>;
export type GetQuizzesSuspenseQueryHookResult = ReturnType<typeof useGetQuizzesSuspenseQuery>;
export type GetQuizzesQueryResult = Apollo.QueryResult<GetQuizzesQuery, GetQuizzesQueryVariables>;
export const GetQuizDocument = gql`
    query GetQuiz($quizId: ID!) {
  quiz(quizId: $quizId) {
    ...QuizFragment
  }
}
    ${QuizFragmentFragmentDoc}`;

/**
 * __useGetQuizQuery__
 *
 * To run a query within a React component, call `useGetQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizQuery({
 *   variables: {
 *      quizId: // value for 'quizId'
 *   },
 * });
 */
export function useGetQuizQuery(baseOptions: Apollo.QueryHookOptions<GetQuizQuery, GetQuizQueryVariables> & ({ variables: GetQuizQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuizQuery, GetQuizQueryVariables>(GetQuizDocument, options);
      }
export function useGetQuizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuizQuery, GetQuizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuizQuery, GetQuizQueryVariables>(GetQuizDocument, options);
        }
// @ts-ignore
export function useGetQuizSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuizQuery, GetQuizQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuizQuery, GetQuizQueryVariables>;
export function useGetQuizSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuizQuery, GetQuizQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuizQuery | undefined, GetQuizQueryVariables>;
export function useGetQuizSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuizQuery, GetQuizQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuizQuery, GetQuizQueryVariables>(GetQuizDocument, options);
        }
export type GetQuizQueryHookResult = ReturnType<typeof useGetQuizQuery>;
export type GetQuizLazyQueryHookResult = ReturnType<typeof useGetQuizLazyQuery>;
export type GetQuizSuspenseQueryHookResult = ReturnType<typeof useGetQuizSuspenseQuery>;
export type GetQuizQueryResult = Apollo.QueryResult<GetQuizQuery, GetQuizQueryVariables>;
export const GetRitualsDocument = gql`
    query GET_RITUALS {
  rituals {
    _id
    activeDate
    activeWeekdays
    expiringProductsOnly
    imageUrl
    name
    state
    timeWindow {
      start
      end
    }
  }
}
    `;

/**
 * __useGetRitualsQuery__
 *
 * To run a query within a React component, call `useGetRitualsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRitualsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRitualsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRitualsQuery(baseOptions?: Apollo.QueryHookOptions<GetRitualsQuery, GetRitualsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRitualsQuery, GetRitualsQueryVariables>(GetRitualsDocument, options);
      }
export function useGetRitualsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRitualsQuery, GetRitualsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRitualsQuery, GetRitualsQueryVariables>(GetRitualsDocument, options);
        }
// @ts-ignore
export function useGetRitualsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRitualsQuery, GetRitualsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRitualsQuery, GetRitualsQueryVariables>;
export function useGetRitualsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRitualsQuery, GetRitualsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRitualsQuery | undefined, GetRitualsQueryVariables>;
export function useGetRitualsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRitualsQuery, GetRitualsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRitualsQuery, GetRitualsQueryVariables>(GetRitualsDocument, options);
        }
export type GetRitualsQueryHookResult = ReturnType<typeof useGetRitualsQuery>;
export type GetRitualsLazyQueryHookResult = ReturnType<typeof useGetRitualsLazyQuery>;
export type GetRitualsSuspenseQueryHookResult = ReturnType<typeof useGetRitualsSuspenseQuery>;
export type GetRitualsQueryResult = Apollo.QueryResult<GetRitualsQuery, GetRitualsQueryVariables>;
export const GetDetailedRitualDocument = gql`
    query GET_DETAILED_RITUAL($ritualId: ID!) {
  detailedRitual(ritualId: $ritualId) {
    _id
    activeDate
    activeWeekdays
    associatedDiscount
    billToOrganizationId
    expiringProductsOnly
    imageUrl
    messagesSetId
    name
    repetition
    requiresParticipation
    resetsBetweenPurchases
    restrictedBadgeIds
    restrictedCategoryIds
    restrictedOrganizationIds
    restrictedProductIds
    restrictedSiteIds
    restrictedSubcategoryIds
    restrictedTagIds
    restrictedUserIds
    state
    stateHistory {
      createdAt
      createdBy
      createdByName
      state
    }
    timeWindow {
      start
      end
    }
    type
    supplierPartnershipId
  }
}
    `;

/**
 * __useGetDetailedRitualQuery__
 *
 * To run a query within a React component, call `useGetDetailedRitualQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedRitualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedRitualQuery({
 *   variables: {
 *      ritualId: // value for 'ritualId'
 *   },
 * });
 */
export function useGetDetailedRitualQuery(baseOptions: Apollo.QueryHookOptions<GetDetailedRitualQuery, GetDetailedRitualQueryVariables> & ({ variables: GetDetailedRitualQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailedRitualQuery, GetDetailedRitualQueryVariables>(GetDetailedRitualDocument, options);
      }
export function useGetDetailedRitualLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailedRitualQuery, GetDetailedRitualQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailedRitualQuery, GetDetailedRitualQueryVariables>(GetDetailedRitualDocument, options);
        }
// @ts-ignore
export function useGetDetailedRitualSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDetailedRitualQuery, GetDetailedRitualQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedRitualQuery, GetDetailedRitualQueryVariables>;
export function useGetDetailedRitualSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedRitualQuery, GetDetailedRitualQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedRitualQuery | undefined, GetDetailedRitualQueryVariables>;
export function useGetDetailedRitualSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedRitualQuery, GetDetailedRitualQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailedRitualQuery, GetDetailedRitualQueryVariables>(GetDetailedRitualDocument, options);
        }
export type GetDetailedRitualQueryHookResult = ReturnType<typeof useGetDetailedRitualQuery>;
export type GetDetailedRitualLazyQueryHookResult = ReturnType<typeof useGetDetailedRitualLazyQuery>;
export type GetDetailedRitualSuspenseQueryHookResult = ReturnType<typeof useGetDetailedRitualSuspenseQuery>;
export type GetDetailedRitualQueryResult = Apollo.QueryResult<GetDetailedRitualQuery, GetDetailedRitualQueryVariables>;
export const GetSiteRitualsDocument = gql`
    query GET_SITE_RITUALS($siteId: ID!) {
  siteRituals(siteId: $siteId) {
    _id
    activeWeekdays
    associatedDiscount
    imageUrl
    name
    timeWindow {
      start
      end
    }
  }
}
    `;

/**
 * __useGetSiteRitualsQuery__
 *
 * To run a query within a React component, call `useGetSiteRitualsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteRitualsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteRitualsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteRitualsQuery(baseOptions: Apollo.QueryHookOptions<GetSiteRitualsQuery, GetSiteRitualsQueryVariables> & ({ variables: GetSiteRitualsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteRitualsQuery, GetSiteRitualsQueryVariables>(GetSiteRitualsDocument, options);
      }
export function useGetSiteRitualsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteRitualsQuery, GetSiteRitualsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteRitualsQuery, GetSiteRitualsQueryVariables>(GetSiteRitualsDocument, options);
        }
// @ts-ignore
export function useGetSiteRitualsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteRitualsQuery, GetSiteRitualsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteRitualsQuery, GetSiteRitualsQueryVariables>;
export function useGetSiteRitualsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteRitualsQuery, GetSiteRitualsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteRitualsQuery | undefined, GetSiteRitualsQueryVariables>;
export function useGetSiteRitualsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteRitualsQuery, GetSiteRitualsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteRitualsQuery, GetSiteRitualsQueryVariables>(GetSiteRitualsDocument, options);
        }
export type GetSiteRitualsQueryHookResult = ReturnType<typeof useGetSiteRitualsQuery>;
export type GetSiteRitualsLazyQueryHookResult = ReturnType<typeof useGetSiteRitualsLazyQuery>;
export type GetSiteRitualsSuspenseQueryHookResult = ReturnType<typeof useGetSiteRitualsSuspenseQuery>;
export type GetSiteRitualsQueryResult = Apollo.QueryResult<GetSiteRitualsQuery, GetSiteRitualsQueryVariables>;
export const GetRitualGameForRitualDocument = gql`
    query GET_RITUAL_GAME_FOR_RITUAL($ritualId: ID!) {
  getRitualGameForRitual(ritualId: $ritualId) {
    ...RitualGameFragment
  }
}
    ${RitualGameFragmentFragmentDoc}`;

/**
 * __useGetRitualGameForRitualQuery__
 *
 * To run a query within a React component, call `useGetRitualGameForRitualQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRitualGameForRitualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRitualGameForRitualQuery({
 *   variables: {
 *      ritualId: // value for 'ritualId'
 *   },
 * });
 */
export function useGetRitualGameForRitualQuery(baseOptions: Apollo.QueryHookOptions<GetRitualGameForRitualQuery, GetRitualGameForRitualQueryVariables> & ({ variables: GetRitualGameForRitualQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRitualGameForRitualQuery, GetRitualGameForRitualQueryVariables>(GetRitualGameForRitualDocument, options);
      }
export function useGetRitualGameForRitualLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRitualGameForRitualQuery, GetRitualGameForRitualQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRitualGameForRitualQuery, GetRitualGameForRitualQueryVariables>(GetRitualGameForRitualDocument, options);
        }
// @ts-ignore
export function useGetRitualGameForRitualSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRitualGameForRitualQuery, GetRitualGameForRitualQueryVariables>): Apollo.UseSuspenseQueryResult<GetRitualGameForRitualQuery, GetRitualGameForRitualQueryVariables>;
export function useGetRitualGameForRitualSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRitualGameForRitualQuery, GetRitualGameForRitualQueryVariables>): Apollo.UseSuspenseQueryResult<GetRitualGameForRitualQuery | undefined, GetRitualGameForRitualQueryVariables>;
export function useGetRitualGameForRitualSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRitualGameForRitualQuery, GetRitualGameForRitualQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRitualGameForRitualQuery, GetRitualGameForRitualQueryVariables>(GetRitualGameForRitualDocument, options);
        }
export type GetRitualGameForRitualQueryHookResult = ReturnType<typeof useGetRitualGameForRitualQuery>;
export type GetRitualGameForRitualLazyQueryHookResult = ReturnType<typeof useGetRitualGameForRitualLazyQuery>;
export type GetRitualGameForRitualSuspenseQueryHookResult = ReturnType<typeof useGetRitualGameForRitualSuspenseQuery>;
export type GetRitualGameForRitualQueryResult = Apollo.QueryResult<GetRitualGameForRitualQuery, GetRitualGameForRitualQueryVariables>;
export const GetRitualTemplatesDocument = gql`
    query GET_RITUAL_TEMPLATES {
  ritualTemplates {
    _id
    imageUrl
    name
  }
}
    `;

/**
 * __useGetRitualTemplatesQuery__
 *
 * To run a query within a React component, call `useGetRitualTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRitualTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRitualTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRitualTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetRitualTemplatesQuery, GetRitualTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRitualTemplatesQuery, GetRitualTemplatesQueryVariables>(GetRitualTemplatesDocument, options);
      }
export function useGetRitualTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRitualTemplatesQuery, GetRitualTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRitualTemplatesQuery, GetRitualTemplatesQueryVariables>(GetRitualTemplatesDocument, options);
        }
// @ts-ignore
export function useGetRitualTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRitualTemplatesQuery, GetRitualTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRitualTemplatesQuery, GetRitualTemplatesQueryVariables>;
export function useGetRitualTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRitualTemplatesQuery, GetRitualTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRitualTemplatesQuery | undefined, GetRitualTemplatesQueryVariables>;
export function useGetRitualTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRitualTemplatesQuery, GetRitualTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRitualTemplatesQuery, GetRitualTemplatesQueryVariables>(GetRitualTemplatesDocument, options);
        }
export type GetRitualTemplatesQueryHookResult = ReturnType<typeof useGetRitualTemplatesQuery>;
export type GetRitualTemplatesLazyQueryHookResult = ReturnType<typeof useGetRitualTemplatesLazyQuery>;
export type GetRitualTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetRitualTemplatesSuspenseQuery>;
export type GetRitualTemplatesQueryResult = Apollo.QueryResult<GetRitualTemplatesQuery, GetRitualTemplatesQueryVariables>;
export const GetSenseiBasketDocument = gql`
    query GetSenseiBasket($basketId: ID!) {
  senseiBasket(basketId: $basketId) {
    ...SenseiBasketFragment
    transactions {
      ...DetailedTransactionFragment
    }
  }
}
    ${SenseiBasketFragmentFragmentDoc}
${DetailedTransactionFragmentFragmentDoc}`;

/**
 * __useGetSenseiBasketQuery__
 *
 * To run a query within a React component, call `useGetSenseiBasketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSenseiBasketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSenseiBasketQuery({
 *   variables: {
 *      basketId: // value for 'basketId'
 *   },
 * });
 */
export function useGetSenseiBasketQuery(baseOptions: Apollo.QueryHookOptions<GetSenseiBasketQuery, GetSenseiBasketQueryVariables> & ({ variables: GetSenseiBasketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSenseiBasketQuery, GetSenseiBasketQueryVariables>(GetSenseiBasketDocument, options);
      }
export function useGetSenseiBasketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSenseiBasketQuery, GetSenseiBasketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSenseiBasketQuery, GetSenseiBasketQueryVariables>(GetSenseiBasketDocument, options);
        }
// @ts-ignore
export function useGetSenseiBasketSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSenseiBasketQuery, GetSenseiBasketQueryVariables>): Apollo.UseSuspenseQueryResult<GetSenseiBasketQuery, GetSenseiBasketQueryVariables>;
export function useGetSenseiBasketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSenseiBasketQuery, GetSenseiBasketQueryVariables>): Apollo.UseSuspenseQueryResult<GetSenseiBasketQuery | undefined, GetSenseiBasketQueryVariables>;
export function useGetSenseiBasketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSenseiBasketQuery, GetSenseiBasketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSenseiBasketQuery, GetSenseiBasketQueryVariables>(GetSenseiBasketDocument, options);
        }
export type GetSenseiBasketQueryHookResult = ReturnType<typeof useGetSenseiBasketQuery>;
export type GetSenseiBasketLazyQueryHookResult = ReturnType<typeof useGetSenseiBasketLazyQuery>;
export type GetSenseiBasketSuspenseQueryHookResult = ReturnType<typeof useGetSenseiBasketSuspenseQuery>;
export type GetSenseiBasketQueryResult = Apollo.QueryResult<GetSenseiBasketQuery, GetSenseiBasketQueryVariables>;
export const GetSitesDocument = gql`
    query GET_SITES {
  sites {
    _id
    deliveryDays
    deliveryZone {
      _id
      name
      color
    }
    launchDate
    name
    organizationName
    organizationId
    state
    totemId
    type
  }
}
    `;

/**
 * __useGetSitesQuery__
 *
 * To run a query within a React component, call `useGetSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSitesQuery(baseOptions?: Apollo.QueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
      }
export function useGetSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
        }
// @ts-ignore
export function useGetSitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSitesQuery, GetSitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSitesQuery, GetSitesQueryVariables>;
export function useGetSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSitesQuery, GetSitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSitesQuery | undefined, GetSitesQueryVariables>;
export function useGetSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
        }
export type GetSitesQueryHookResult = ReturnType<typeof useGetSitesQuery>;
export type GetSitesLazyQueryHookResult = ReturnType<typeof useGetSitesLazyQuery>;
export type GetSitesSuspenseQueryHookResult = ReturnType<typeof useGetSitesSuspenseQuery>;
export type GetSitesQueryResult = Apollo.QueryResult<GetSitesQuery, GetSitesQueryVariables>;
export const GetSitesWithReassortmentStockTransfersDocument = gql`
    query GET_SITES_WITH_REASSORTMENT_STOCK_TRANSFERS {
  sites {
    _id
    deliveryDays
    launchDate
    name
    organizationName
    shouldOperateOnTotops
    state
    type
    microstoreColumnGroups {
      _id
      name
      positionInSite
      columns {
        _id
        name
        positionInColumnGroup
        nextReassortmentStockTransfers {
          ...StockTransferFragment
        }
      }
    }
  }
}
    ${StockTransferFragmentFragmentDoc}`;

/**
 * __useGetSitesWithReassortmentStockTransfersQuery__
 *
 * To run a query within a React component, call `useGetSitesWithReassortmentStockTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesWithReassortmentStockTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesWithReassortmentStockTransfersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSitesWithReassortmentStockTransfersQuery(baseOptions?: Apollo.QueryHookOptions<GetSitesWithReassortmentStockTransfersQuery, GetSitesWithReassortmentStockTransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitesWithReassortmentStockTransfersQuery, GetSitesWithReassortmentStockTransfersQueryVariables>(GetSitesWithReassortmentStockTransfersDocument, options);
      }
export function useGetSitesWithReassortmentStockTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitesWithReassortmentStockTransfersQuery, GetSitesWithReassortmentStockTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitesWithReassortmentStockTransfersQuery, GetSitesWithReassortmentStockTransfersQueryVariables>(GetSitesWithReassortmentStockTransfersDocument, options);
        }
// @ts-ignore
export function useGetSitesWithReassortmentStockTransfersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSitesWithReassortmentStockTransfersQuery, GetSitesWithReassortmentStockTransfersQueryVariables>): Apollo.UseSuspenseQueryResult<GetSitesWithReassortmentStockTransfersQuery, GetSitesWithReassortmentStockTransfersQueryVariables>;
export function useGetSitesWithReassortmentStockTransfersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSitesWithReassortmentStockTransfersQuery, GetSitesWithReassortmentStockTransfersQueryVariables>): Apollo.UseSuspenseQueryResult<GetSitesWithReassortmentStockTransfersQuery | undefined, GetSitesWithReassortmentStockTransfersQueryVariables>;
export function useGetSitesWithReassortmentStockTransfersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSitesWithReassortmentStockTransfersQuery, GetSitesWithReassortmentStockTransfersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSitesWithReassortmentStockTransfersQuery, GetSitesWithReassortmentStockTransfersQueryVariables>(GetSitesWithReassortmentStockTransfersDocument, options);
        }
export type GetSitesWithReassortmentStockTransfersQueryHookResult = ReturnType<typeof useGetSitesWithReassortmentStockTransfersQuery>;
export type GetSitesWithReassortmentStockTransfersLazyQueryHookResult = ReturnType<typeof useGetSitesWithReassortmentStockTransfersLazyQuery>;
export type GetSitesWithReassortmentStockTransfersSuspenseQueryHookResult = ReturnType<typeof useGetSitesWithReassortmentStockTransfersSuspenseQuery>;
export type GetSitesWithReassortmentStockTransfersQueryResult = Apollo.QueryResult<GetSitesWithReassortmentStockTransfersQuery, GetSitesWithReassortmentStockTransfersQueryVariables>;
export const GetSitesPaginatedDocument = gql`
    query GET_SITES_PAGINATED($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: SitesFilterInput) {
  sitesFilter(
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    sites {
      ...SiteFragmentFilter
    }
  }
}
    ${SiteFragmentFilterFragmentDoc}`;

/**
 * __useGetSitesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetSitesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesPaginatedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSitesPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GetSitesPaginatedQuery, GetSitesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitesPaginatedQuery, GetSitesPaginatedQueryVariables>(GetSitesPaginatedDocument, options);
      }
export function useGetSitesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitesPaginatedQuery, GetSitesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitesPaginatedQuery, GetSitesPaginatedQueryVariables>(GetSitesPaginatedDocument, options);
        }
// @ts-ignore
export function useGetSitesPaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSitesPaginatedQuery, GetSitesPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetSitesPaginatedQuery, GetSitesPaginatedQueryVariables>;
export function useGetSitesPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSitesPaginatedQuery, GetSitesPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetSitesPaginatedQuery | undefined, GetSitesPaginatedQueryVariables>;
export function useGetSitesPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSitesPaginatedQuery, GetSitesPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSitesPaginatedQuery, GetSitesPaginatedQueryVariables>(GetSitesPaginatedDocument, options);
        }
export type GetSitesPaginatedQueryHookResult = ReturnType<typeof useGetSitesPaginatedQuery>;
export type GetSitesPaginatedLazyQueryHookResult = ReturnType<typeof useGetSitesPaginatedLazyQuery>;
export type GetSitesPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetSitesPaginatedSuspenseQuery>;
export type GetSitesPaginatedQueryResult = Apollo.QueryResult<GetSitesPaginatedQuery, GetSitesPaginatedQueryVariables>;
export const GetSimpleMicrostoreSitesDocument = gql`
    query GET_SIMPLE_MICROSTORE_SITES {
  microstoreSites {
    _id
    organizationName
    microstoreColumnGroups {
      _id
      name
      columns {
        _id
        name
      }
    }
    deliveryDays
    launchDate
    name
    state
    type
  }
}
    `;

/**
 * __useGetSimpleMicrostoreSitesQuery__
 *
 * To run a query within a React component, call `useGetSimpleMicrostoreSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleMicrostoreSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleMicrostoreSitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSimpleMicrostoreSitesQuery(baseOptions?: Apollo.QueryHookOptions<GetSimpleMicrostoreSitesQuery, GetSimpleMicrostoreSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimpleMicrostoreSitesQuery, GetSimpleMicrostoreSitesQueryVariables>(GetSimpleMicrostoreSitesDocument, options);
      }
export function useGetSimpleMicrostoreSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleMicrostoreSitesQuery, GetSimpleMicrostoreSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimpleMicrostoreSitesQuery, GetSimpleMicrostoreSitesQueryVariables>(GetSimpleMicrostoreSitesDocument, options);
        }
// @ts-ignore
export function useGetSimpleMicrostoreSitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSimpleMicrostoreSitesQuery, GetSimpleMicrostoreSitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSimpleMicrostoreSitesQuery, GetSimpleMicrostoreSitesQueryVariables>;
export function useGetSimpleMicrostoreSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSimpleMicrostoreSitesQuery, GetSimpleMicrostoreSitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSimpleMicrostoreSitesQuery | undefined, GetSimpleMicrostoreSitesQueryVariables>;
export function useGetSimpleMicrostoreSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSimpleMicrostoreSitesQuery, GetSimpleMicrostoreSitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSimpleMicrostoreSitesQuery, GetSimpleMicrostoreSitesQueryVariables>(GetSimpleMicrostoreSitesDocument, options);
        }
export type GetSimpleMicrostoreSitesQueryHookResult = ReturnType<typeof useGetSimpleMicrostoreSitesQuery>;
export type GetSimpleMicrostoreSitesLazyQueryHookResult = ReturnType<typeof useGetSimpleMicrostoreSitesLazyQuery>;
export type GetSimpleMicrostoreSitesSuspenseQueryHookResult = ReturnType<typeof useGetSimpleMicrostoreSitesSuspenseQuery>;
export type GetSimpleMicrostoreSitesQueryResult = Apollo.QueryResult<GetSimpleMicrostoreSitesQuery, GetSimpleMicrostoreSitesQueryVariables>;
export const GetMicrostoreSitesPaginatedDocument = gql`
    query GET_MICROSTORE_SITES_PAGINATED($offset: Int!, $filterString: String, $stateFilter: SiteState) {
  microstoreSitesWithColumnGroupsFilter(
    offset: $offset
    filterString: $filterString
    stateFilter: $stateFilter
  ) {
    hasMore
    sites {
      _id
      organizationName
      microstoreColumnGroups {
        _id
        name
        columns {
          _id
          name
        }
      }
      name
      state
      type
    }
  }
}
    `;

/**
 * __useGetMicrostoreSitesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreSitesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreSitesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreSitesPaginatedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      filterString: // value for 'filterString'
 *      stateFilter: // value for 'stateFilter'
 *   },
 * });
 */
export function useGetMicrostoreSitesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetMicrostoreSitesPaginatedQuery, GetMicrostoreSitesPaginatedQueryVariables> & ({ variables: GetMicrostoreSitesPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreSitesPaginatedQuery, GetMicrostoreSitesPaginatedQueryVariables>(GetMicrostoreSitesPaginatedDocument, options);
      }
export function useGetMicrostoreSitesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreSitesPaginatedQuery, GetMicrostoreSitesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreSitesPaginatedQuery, GetMicrostoreSitesPaginatedQueryVariables>(GetMicrostoreSitesPaginatedDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreSitesPaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesPaginatedQuery, GetMicrostoreSitesPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreSitesPaginatedQuery, GetMicrostoreSitesPaginatedQueryVariables>;
export function useGetMicrostoreSitesPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesPaginatedQuery, GetMicrostoreSitesPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreSitesPaginatedQuery | undefined, GetMicrostoreSitesPaginatedQueryVariables>;
export function useGetMicrostoreSitesPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesPaginatedQuery, GetMicrostoreSitesPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreSitesPaginatedQuery, GetMicrostoreSitesPaginatedQueryVariables>(GetMicrostoreSitesPaginatedDocument, options);
        }
export type GetMicrostoreSitesPaginatedQueryHookResult = ReturnType<typeof useGetMicrostoreSitesPaginatedQuery>;
export type GetMicrostoreSitesPaginatedLazyQueryHookResult = ReturnType<typeof useGetMicrostoreSitesPaginatedLazyQuery>;
export type GetMicrostoreSitesPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreSitesPaginatedSuspenseQuery>;
export type GetMicrostoreSitesPaginatedQueryResult = Apollo.QueryResult<GetMicrostoreSitesPaginatedQuery, GetMicrostoreSitesPaginatedQueryVariables>;
export const GetMicrostoreSitesDocument = gql`
    query GET_MICROSTORE_SITES {
  microstoreSitesWithColumnGroups {
    ...SiteFragment
    microstoreColumnGroups {
      _id
      name
      positionInSite
      avaSalePlaceLocationId
      columns {
        _id
        siteId
        columnGroupId
        columnIdToReplace
        isPaused
        microstoreColumnTemplateId
        name
        positionInColumnGroup
        removalDate
        startingDate
        microstoreColumnTemplateName
        type
      }
    }
  }
}
    ${SiteFragmentFragmentDoc}`;

/**
 * __useGetMicrostoreSitesQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreSitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMicrostoreSitesQuery(baseOptions?: Apollo.QueryHookOptions<GetMicrostoreSitesQuery, GetMicrostoreSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreSitesQuery, GetMicrostoreSitesQueryVariables>(GetMicrostoreSitesDocument, options);
      }
export function useGetMicrostoreSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreSitesQuery, GetMicrostoreSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreSitesQuery, GetMicrostoreSitesQueryVariables>(GetMicrostoreSitesDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreSitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesQuery, GetMicrostoreSitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreSitesQuery, GetMicrostoreSitesQueryVariables>;
export function useGetMicrostoreSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesQuery, GetMicrostoreSitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreSitesQuery | undefined, GetMicrostoreSitesQueryVariables>;
export function useGetMicrostoreSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesQuery, GetMicrostoreSitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreSitesQuery, GetMicrostoreSitesQueryVariables>(GetMicrostoreSitesDocument, options);
        }
export type GetMicrostoreSitesQueryHookResult = ReturnType<typeof useGetMicrostoreSitesQuery>;
export type GetMicrostoreSitesLazyQueryHookResult = ReturnType<typeof useGetMicrostoreSitesLazyQuery>;
export type GetMicrostoreSitesSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreSitesSuspenseQuery>;
export type GetMicrostoreSitesQueryResult = Apollo.QueryResult<GetMicrostoreSitesQuery, GetMicrostoreSitesQueryVariables>;
export const GetMicrostoreSitesWithReassortmentStockDocument = gql`
    query GET_MICROSTORE_SITES_WITH_REASSORTMENT_STOCK {
  microstoreSitesWithReassortmentInfo {
    _id
    freshReassortmentInfos {
      filledLocationsRatio
      hasStartedReassortment
      stockByCategories {
        dessert
        main
        smallBites
        starter
      }
    }
    name
    nextDeliveryDate
    reassortmentFreshFacings {
      dessert
      main
      smallBites
      starter
    }
    reassortmentStockTargets {
      dessert
      main
      smallBites
      starter
    }
    reassortmentOnboardingStockTargets {
      dessert
      main
      smallBites
      starter
    }
  }
}
    `;

/**
 * __useGetMicrostoreSitesWithReassortmentStockQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreSitesWithReassortmentStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreSitesWithReassortmentStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreSitesWithReassortmentStockQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMicrostoreSitesWithReassortmentStockQuery(baseOptions?: Apollo.QueryHookOptions<GetMicrostoreSitesWithReassortmentStockQuery, GetMicrostoreSitesWithReassortmentStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreSitesWithReassortmentStockQuery, GetMicrostoreSitesWithReassortmentStockQueryVariables>(GetMicrostoreSitesWithReassortmentStockDocument, options);
      }
export function useGetMicrostoreSitesWithReassortmentStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreSitesWithReassortmentStockQuery, GetMicrostoreSitesWithReassortmentStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreSitesWithReassortmentStockQuery, GetMicrostoreSitesWithReassortmentStockQueryVariables>(GetMicrostoreSitesWithReassortmentStockDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreSitesWithReassortmentStockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesWithReassortmentStockQuery, GetMicrostoreSitesWithReassortmentStockQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreSitesWithReassortmentStockQuery, GetMicrostoreSitesWithReassortmentStockQueryVariables>;
export function useGetMicrostoreSitesWithReassortmentStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesWithReassortmentStockQuery, GetMicrostoreSitesWithReassortmentStockQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreSitesWithReassortmentStockQuery | undefined, GetMicrostoreSitesWithReassortmentStockQueryVariables>;
export function useGetMicrostoreSitesWithReassortmentStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesWithReassortmentStockQuery, GetMicrostoreSitesWithReassortmentStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreSitesWithReassortmentStockQuery, GetMicrostoreSitesWithReassortmentStockQueryVariables>(GetMicrostoreSitesWithReassortmentStockDocument, options);
        }
export type GetMicrostoreSitesWithReassortmentStockQueryHookResult = ReturnType<typeof useGetMicrostoreSitesWithReassortmentStockQuery>;
export type GetMicrostoreSitesWithReassortmentStockLazyQueryHookResult = ReturnType<typeof useGetMicrostoreSitesWithReassortmentStockLazyQuery>;
export type GetMicrostoreSitesWithReassortmentStockSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreSitesWithReassortmentStockSuspenseQuery>;
export type GetMicrostoreSitesWithReassortmentStockQueryResult = Apollo.QueryResult<GetMicrostoreSitesWithReassortmentStockQuery, GetMicrostoreSitesWithReassortmentStockQueryVariables>;
export const GetSiteDocument = gql`
    query GET_SITE($siteId: ID!) {
  site(siteId: $siteId) {
    ...SiteFragment
    microstoreColumnGroups {
      _id
      name
      positionInSite
      columns {
        _id
        name
        state
        positionInColumnGroup
        microstoreColumnTemplateName
        isPaused
      }
    }
    totem {
      _id
      name
      number
      sites {
        _id
        name
      }
      organization {
        _id
        name
      }
    }
  }
}
    ${SiteFragmentFragmentDoc}`;

/**
 * __useGetSiteQuery__
 *
 * To run a query within a React component, call `useGetSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteQuery(baseOptions: Apollo.QueryHookOptions<GetSiteQuery, GetSiteQueryVariables> & ({ variables: GetSiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteQuery, GetSiteQueryVariables>(GetSiteDocument, options);
      }
export function useGetSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteQuery, GetSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteQuery, GetSiteQueryVariables>(GetSiteDocument, options);
        }
// @ts-ignore
export function useGetSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteQuery, GetSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteQuery, GetSiteQueryVariables>;
export function useGetSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteQuery, GetSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteQuery | undefined, GetSiteQueryVariables>;
export function useGetSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteQuery, GetSiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteQuery, GetSiteQueryVariables>(GetSiteDocument, options);
        }
export type GetSiteQueryHookResult = ReturnType<typeof useGetSiteQuery>;
export type GetSiteLazyQueryHookResult = ReturnType<typeof useGetSiteLazyQuery>;
export type GetSiteSuspenseQueryHookResult = ReturnType<typeof useGetSiteSuspenseQuery>;
export type GetSiteQueryResult = Apollo.QueryResult<GetSiteQuery, GetSiteQueryVariables>;
export const GetSiteMetabaseDashboardUrlDocument = gql`
    query GET_SITE_METABASE_DASHBOARD_URL($siteId: ID!) {
  siteMetabaseDashboardUrl(siteId: $siteId)
}
    `;

/**
 * __useGetSiteMetabaseDashboardUrlQuery__
 *
 * To run a query within a React component, call `useGetSiteMetabaseDashboardUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteMetabaseDashboardUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteMetabaseDashboardUrlQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteMetabaseDashboardUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSiteMetabaseDashboardUrlQuery, GetSiteMetabaseDashboardUrlQueryVariables> & ({ variables: GetSiteMetabaseDashboardUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteMetabaseDashboardUrlQuery, GetSiteMetabaseDashboardUrlQueryVariables>(GetSiteMetabaseDashboardUrlDocument, options);
      }
export function useGetSiteMetabaseDashboardUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteMetabaseDashboardUrlQuery, GetSiteMetabaseDashboardUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteMetabaseDashboardUrlQuery, GetSiteMetabaseDashboardUrlQueryVariables>(GetSiteMetabaseDashboardUrlDocument, options);
        }
// @ts-ignore
export function useGetSiteMetabaseDashboardUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteMetabaseDashboardUrlQuery, GetSiteMetabaseDashboardUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteMetabaseDashboardUrlQuery, GetSiteMetabaseDashboardUrlQueryVariables>;
export function useGetSiteMetabaseDashboardUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteMetabaseDashboardUrlQuery, GetSiteMetabaseDashboardUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteMetabaseDashboardUrlQuery | undefined, GetSiteMetabaseDashboardUrlQueryVariables>;
export function useGetSiteMetabaseDashboardUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteMetabaseDashboardUrlQuery, GetSiteMetabaseDashboardUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteMetabaseDashboardUrlQuery, GetSiteMetabaseDashboardUrlQueryVariables>(GetSiteMetabaseDashboardUrlDocument, options);
        }
export type GetSiteMetabaseDashboardUrlQueryHookResult = ReturnType<typeof useGetSiteMetabaseDashboardUrlQuery>;
export type GetSiteMetabaseDashboardUrlLazyQueryHookResult = ReturnType<typeof useGetSiteMetabaseDashboardUrlLazyQuery>;
export type GetSiteMetabaseDashboardUrlSuspenseQueryHookResult = ReturnType<typeof useGetSiteMetabaseDashboardUrlSuspenseQuery>;
export type GetSiteMetabaseDashboardUrlQueryResult = Apollo.QueryResult<GetSiteMetabaseDashboardUrlQuery, GetSiteMetabaseDashboardUrlQueryVariables>;
export const GetMicrostoreSiteDocument = gql`
    query GET_MICROSTORE_SITE($siteId: ID!) {
  siteWithLocationInfo(siteId: $siteId) {
    ...SiteWithLocationInfoFragment
  }
}
    ${SiteWithLocationInfoFragmentFragmentDoc}`;

/**
 * __useGetMicrostoreSiteQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetMicrostoreSiteQuery(baseOptions: Apollo.QueryHookOptions<GetMicrostoreSiteQuery, GetMicrostoreSiteQueryVariables> & ({ variables: GetMicrostoreSiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreSiteQuery, GetMicrostoreSiteQueryVariables>(GetMicrostoreSiteDocument, options);
      }
export function useGetMicrostoreSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreSiteQuery, GetMicrostoreSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreSiteQuery, GetMicrostoreSiteQueryVariables>(GetMicrostoreSiteDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreSiteQuery, GetMicrostoreSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreSiteQuery, GetMicrostoreSiteQueryVariables>;
export function useGetMicrostoreSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreSiteQuery, GetMicrostoreSiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreSiteQuery | undefined, GetMicrostoreSiteQueryVariables>;
export function useGetMicrostoreSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreSiteQuery, GetMicrostoreSiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreSiteQuery, GetMicrostoreSiteQueryVariables>(GetMicrostoreSiteDocument, options);
        }
export type GetMicrostoreSiteQueryHookResult = ReturnType<typeof useGetMicrostoreSiteQuery>;
export type GetMicrostoreSiteLazyQueryHookResult = ReturnType<typeof useGetMicrostoreSiteLazyQuery>;
export type GetMicrostoreSiteSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreSiteSuspenseQuery>;
export type GetMicrostoreSiteQueryResult = Apollo.QueryResult<GetMicrostoreSiteQuery, GetMicrostoreSiteQueryVariables>;
export const GetMicrostoreSitesWithLocationsInfoDocument = gql`
    query GET_MICROSTORE_SITES_WITH_LOCATIONS_INFO($siteIds: [ID!]!) {
  sites(siteIds: $siteIds) {
    _id
    isSecured
    name
    microstoreColumnGroups {
      ...MicrostoreColumnGroupWithColumnsFragment
    }
  }
}
    ${MicrostoreColumnGroupWithColumnsFragmentFragmentDoc}`;

/**
 * __useGetMicrostoreSitesWithLocationsInfoQuery__
 *
 * To run a query within a React component, call `useGetMicrostoreSitesWithLocationsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrostoreSitesWithLocationsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrostoreSitesWithLocationsInfoQuery({
 *   variables: {
 *      siteIds: // value for 'siteIds'
 *   },
 * });
 */
export function useGetMicrostoreSitesWithLocationsInfoQuery(baseOptions: Apollo.QueryHookOptions<GetMicrostoreSitesWithLocationsInfoQuery, GetMicrostoreSitesWithLocationsInfoQueryVariables> & ({ variables: GetMicrostoreSitesWithLocationsInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrostoreSitesWithLocationsInfoQuery, GetMicrostoreSitesWithLocationsInfoQueryVariables>(GetMicrostoreSitesWithLocationsInfoDocument, options);
      }
export function useGetMicrostoreSitesWithLocationsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrostoreSitesWithLocationsInfoQuery, GetMicrostoreSitesWithLocationsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrostoreSitesWithLocationsInfoQuery, GetMicrostoreSitesWithLocationsInfoQueryVariables>(GetMicrostoreSitesWithLocationsInfoDocument, options);
        }
// @ts-ignore
export function useGetMicrostoreSitesWithLocationsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesWithLocationsInfoQuery, GetMicrostoreSitesWithLocationsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreSitesWithLocationsInfoQuery, GetMicrostoreSitesWithLocationsInfoQueryVariables>;
export function useGetMicrostoreSitesWithLocationsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesWithLocationsInfoQuery, GetMicrostoreSitesWithLocationsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetMicrostoreSitesWithLocationsInfoQuery | undefined, GetMicrostoreSitesWithLocationsInfoQueryVariables>;
export function useGetMicrostoreSitesWithLocationsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMicrostoreSitesWithLocationsInfoQuery, GetMicrostoreSitesWithLocationsInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMicrostoreSitesWithLocationsInfoQuery, GetMicrostoreSitesWithLocationsInfoQueryVariables>(GetMicrostoreSitesWithLocationsInfoDocument, options);
        }
export type GetMicrostoreSitesWithLocationsInfoQueryHookResult = ReturnType<typeof useGetMicrostoreSitesWithLocationsInfoQuery>;
export type GetMicrostoreSitesWithLocationsInfoLazyQueryHookResult = ReturnType<typeof useGetMicrostoreSitesWithLocationsInfoLazyQuery>;
export type GetMicrostoreSitesWithLocationsInfoSuspenseQueryHookResult = ReturnType<typeof useGetMicrostoreSitesWithLocationsInfoSuspenseQuery>;
export type GetMicrostoreSitesWithLocationsInfoQueryResult = Apollo.QueryResult<GetMicrostoreSitesWithLocationsInfoQuery, GetMicrostoreSitesWithLocationsInfoQueryVariables>;
export const GetFreshProductsWarehouseStockInfoDocument = gql`
    query GET_FRESH_PRODUCTS_WAREHOUSE_STOCK_INFO {
  getFreshProductsWarehouseStockInfo {
    dessert {
      stockAvailableWithReassortment
      stockExpectedInSupplyOrders
      availableWarehouseStock
    }
    main {
      stockAvailableWithReassortment
      stockExpectedInSupplyOrders
      availableWarehouseStock
    }
    smallBites {
      stockAvailableWithReassortment
      stockExpectedInSupplyOrders
      availableWarehouseStock
    }
    starter {
      stockAvailableWithReassortment
      stockExpectedInSupplyOrders
      availableWarehouseStock
    }
  }
}
    `;

/**
 * __useGetFreshProductsWarehouseStockInfoQuery__
 *
 * To run a query within a React component, call `useGetFreshProductsWarehouseStockInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreshProductsWarehouseStockInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreshProductsWarehouseStockInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFreshProductsWarehouseStockInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetFreshProductsWarehouseStockInfoQuery, GetFreshProductsWarehouseStockInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreshProductsWarehouseStockInfoQuery, GetFreshProductsWarehouseStockInfoQueryVariables>(GetFreshProductsWarehouseStockInfoDocument, options);
      }
export function useGetFreshProductsWarehouseStockInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreshProductsWarehouseStockInfoQuery, GetFreshProductsWarehouseStockInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreshProductsWarehouseStockInfoQuery, GetFreshProductsWarehouseStockInfoQueryVariables>(GetFreshProductsWarehouseStockInfoDocument, options);
        }
// @ts-ignore
export function useGetFreshProductsWarehouseStockInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFreshProductsWarehouseStockInfoQuery, GetFreshProductsWarehouseStockInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetFreshProductsWarehouseStockInfoQuery, GetFreshProductsWarehouseStockInfoQueryVariables>;
export function useGetFreshProductsWarehouseStockInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFreshProductsWarehouseStockInfoQuery, GetFreshProductsWarehouseStockInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetFreshProductsWarehouseStockInfoQuery | undefined, GetFreshProductsWarehouseStockInfoQueryVariables>;
export function useGetFreshProductsWarehouseStockInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFreshProductsWarehouseStockInfoQuery, GetFreshProductsWarehouseStockInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFreshProductsWarehouseStockInfoQuery, GetFreshProductsWarehouseStockInfoQueryVariables>(GetFreshProductsWarehouseStockInfoDocument, options);
        }
export type GetFreshProductsWarehouseStockInfoQueryHookResult = ReturnType<typeof useGetFreshProductsWarehouseStockInfoQuery>;
export type GetFreshProductsWarehouseStockInfoLazyQueryHookResult = ReturnType<typeof useGetFreshProductsWarehouseStockInfoLazyQuery>;
export type GetFreshProductsWarehouseStockInfoSuspenseQueryHookResult = ReturnType<typeof useGetFreshProductsWarehouseStockInfoSuspenseQuery>;
export type GetFreshProductsWarehouseStockInfoQueryResult = Apollo.QueryResult<GetFreshProductsWarehouseStockInfoQuery, GetFreshProductsWarehouseStockInfoQueryVariables>;
export const GetNextMsDeliveryDateDocument = gql`
    query GET_NEXT_MS_DELIVERY_DATE {
  getNextMSDeliveryDate
}
    `;

/**
 * __useGetNextMsDeliveryDateQuery__
 *
 * To run a query within a React component, call `useGetNextMsDeliveryDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextMsDeliveryDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextMsDeliveryDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextMsDeliveryDateQuery(baseOptions?: Apollo.QueryHookOptions<GetNextMsDeliveryDateQuery, GetNextMsDeliveryDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextMsDeliveryDateQuery, GetNextMsDeliveryDateQueryVariables>(GetNextMsDeliveryDateDocument, options);
      }
export function useGetNextMsDeliveryDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextMsDeliveryDateQuery, GetNextMsDeliveryDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextMsDeliveryDateQuery, GetNextMsDeliveryDateQueryVariables>(GetNextMsDeliveryDateDocument, options);
        }
// @ts-ignore
export function useGetNextMsDeliveryDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNextMsDeliveryDateQuery, GetNextMsDeliveryDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetNextMsDeliveryDateQuery, GetNextMsDeliveryDateQueryVariables>;
export function useGetNextMsDeliveryDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNextMsDeliveryDateQuery, GetNextMsDeliveryDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetNextMsDeliveryDateQuery | undefined, GetNextMsDeliveryDateQueryVariables>;
export function useGetNextMsDeliveryDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNextMsDeliveryDateQuery, GetNextMsDeliveryDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNextMsDeliveryDateQuery, GetNextMsDeliveryDateQueryVariables>(GetNextMsDeliveryDateDocument, options);
        }
export type GetNextMsDeliveryDateQueryHookResult = ReturnType<typeof useGetNextMsDeliveryDateQuery>;
export type GetNextMsDeliveryDateLazyQueryHookResult = ReturnType<typeof useGetNextMsDeliveryDateLazyQuery>;
export type GetNextMsDeliveryDateSuspenseQueryHookResult = ReturnType<typeof useGetNextMsDeliveryDateSuspenseQuery>;
export type GetNextMsDeliveryDateQueryResult = Apollo.QueryResult<GetNextMsDeliveryDateQuery, GetNextMsDeliveryDateQueryVariables>;
export const GetSetupSiteInventoryDocument = gql`
    query GET_SETUP_SITE_INVENTORY($siteSetupId: ID!) {
  getSetupSiteInventory(siteSetupId: $siteSetupId) {
    ...SiteInventoryFragment
  }
}
    ${SiteInventoryFragmentFragmentDoc}`;

/**
 * __useGetSetupSiteInventoryQuery__
 *
 * To run a query within a React component, call `useGetSetupSiteInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSetupSiteInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSetupSiteInventoryQuery({
 *   variables: {
 *      siteSetupId: // value for 'siteSetupId'
 *   },
 * });
 */
export function useGetSetupSiteInventoryQuery(baseOptions: Apollo.QueryHookOptions<GetSetupSiteInventoryQuery, GetSetupSiteInventoryQueryVariables> & ({ variables: GetSetupSiteInventoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSetupSiteInventoryQuery, GetSetupSiteInventoryQueryVariables>(GetSetupSiteInventoryDocument, options);
      }
export function useGetSetupSiteInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSetupSiteInventoryQuery, GetSetupSiteInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSetupSiteInventoryQuery, GetSetupSiteInventoryQueryVariables>(GetSetupSiteInventoryDocument, options);
        }
// @ts-ignore
export function useGetSetupSiteInventorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSetupSiteInventoryQuery, GetSetupSiteInventoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetSetupSiteInventoryQuery, GetSetupSiteInventoryQueryVariables>;
export function useGetSetupSiteInventorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSetupSiteInventoryQuery, GetSetupSiteInventoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetSetupSiteInventoryQuery | undefined, GetSetupSiteInventoryQueryVariables>;
export function useGetSetupSiteInventorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSetupSiteInventoryQuery, GetSetupSiteInventoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSetupSiteInventoryQuery, GetSetupSiteInventoryQueryVariables>(GetSetupSiteInventoryDocument, options);
        }
export type GetSetupSiteInventoryQueryHookResult = ReturnType<typeof useGetSetupSiteInventoryQuery>;
export type GetSetupSiteInventoryLazyQueryHookResult = ReturnType<typeof useGetSetupSiteInventoryLazyQuery>;
export type GetSetupSiteInventorySuspenseQueryHookResult = ReturnType<typeof useGetSetupSiteInventorySuspenseQuery>;
export type GetSetupSiteInventoryQueryResult = Apollo.QueryResult<GetSetupSiteInventoryQuery, GetSetupSiteInventoryQueryVariables>;
export const GetSiteSetupsForDateDocument = gql`
    query GET_SITE_SETUPS_FOR_DATE($date: String!) {
  getSiteSetupsForDate(date: $date) {
    _id
    createdAt
    date
    delivery {
      isDynamic
    }
    freefoodSetup {
      ...FreefoodSetupFragment
    }
    isFinishForced
    microstoreColumnGroupSetups {
      ...MicrostoreColumnGroupSetupFragment
    }
    siteId
    site {
      _id
      organizationName
      microstoreColumnGroups {
        _id
        name
        columns {
          _id
          name
        }
      }
      name
      state
      type
    }
    state
    stateHistory {
      createdAt
      createdBy
      createdByName
      state
    }
    updatedAt
  }
}
    ${FreefoodSetupFragmentFragmentDoc}
${MicrostoreColumnGroupSetupFragmentFragmentDoc}`;

/**
 * __useGetSiteSetupsForDateQuery__
 *
 * To run a query within a React component, call `useGetSiteSetupsForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteSetupsForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteSetupsForDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetSiteSetupsForDateQuery(baseOptions: Apollo.QueryHookOptions<GetSiteSetupsForDateQuery, GetSiteSetupsForDateQueryVariables> & ({ variables: GetSiteSetupsForDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteSetupsForDateQuery, GetSiteSetupsForDateQueryVariables>(GetSiteSetupsForDateDocument, options);
      }
export function useGetSiteSetupsForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteSetupsForDateQuery, GetSiteSetupsForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteSetupsForDateQuery, GetSiteSetupsForDateQueryVariables>(GetSiteSetupsForDateDocument, options);
        }
// @ts-ignore
export function useGetSiteSetupsForDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteSetupsForDateQuery, GetSiteSetupsForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteSetupsForDateQuery, GetSiteSetupsForDateQueryVariables>;
export function useGetSiteSetupsForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteSetupsForDateQuery, GetSiteSetupsForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteSetupsForDateQuery | undefined, GetSiteSetupsForDateQueryVariables>;
export function useGetSiteSetupsForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteSetupsForDateQuery, GetSiteSetupsForDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteSetupsForDateQuery, GetSiteSetupsForDateQueryVariables>(GetSiteSetupsForDateDocument, options);
        }
export type GetSiteSetupsForDateQueryHookResult = ReturnType<typeof useGetSiteSetupsForDateQuery>;
export type GetSiteSetupsForDateLazyQueryHookResult = ReturnType<typeof useGetSiteSetupsForDateLazyQuery>;
export type GetSiteSetupsForDateSuspenseQueryHookResult = ReturnType<typeof useGetSiteSetupsForDateSuspenseQuery>;
export type GetSiteSetupsForDateQueryResult = Apollo.QueryResult<GetSiteSetupsForDateQuery, GetSiteSetupsForDateQueryVariables>;
export const GetSiteSetupDocument = gql`
    query GET_SITE_SETUP($siteSetupId: ID!) {
  getSiteSetup(siteSetupId: $siteSetupId) {
    ...SiteSetupFragment
  }
}
    ${SiteSetupFragmentFragmentDoc}`;

/**
 * __useGetSiteSetupQuery__
 *
 * To run a query within a React component, call `useGetSiteSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteSetupQuery({
 *   variables: {
 *      siteSetupId: // value for 'siteSetupId'
 *   },
 * });
 */
export function useGetSiteSetupQuery(baseOptions: Apollo.QueryHookOptions<GetSiteSetupQuery, GetSiteSetupQueryVariables> & ({ variables: GetSiteSetupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteSetupQuery, GetSiteSetupQueryVariables>(GetSiteSetupDocument, options);
      }
export function useGetSiteSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteSetupQuery, GetSiteSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteSetupQuery, GetSiteSetupQueryVariables>(GetSiteSetupDocument, options);
        }
// @ts-ignore
export function useGetSiteSetupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteSetupQuery, GetSiteSetupQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteSetupQuery, GetSiteSetupQueryVariables>;
export function useGetSiteSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteSetupQuery, GetSiteSetupQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteSetupQuery | undefined, GetSiteSetupQueryVariables>;
export function useGetSiteSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteSetupQuery, GetSiteSetupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteSetupQuery, GetSiteSetupQueryVariables>(GetSiteSetupDocument, options);
        }
export type GetSiteSetupQueryHookResult = ReturnType<typeof useGetSiteSetupQuery>;
export type GetSiteSetupLazyQueryHookResult = ReturnType<typeof useGetSiteSetupLazyQuery>;
export type GetSiteSetupSuspenseQueryHookResult = ReturnType<typeof useGetSiteSetupSuspenseQuery>;
export type GetSiteSetupQueryResult = Apollo.QueryResult<GetSiteSetupQuery, GetSiteSetupQueryVariables>;
export const GetSiteSetupDeliveryDocument = gql`
    query GET_SITE_SETUP_DELIVERY($siteSetupId: ID!) {
  getSiteSetup(siteSetupId: $siteSetupId) {
    _id
    delivery {
      _id
      boxes {
        _id
        orderId
        products {
          _id
          boxId
          quantity
          quantityPicked
        }
        siteId
      }
    }
  }
}
    `;

/**
 * __useGetSiteSetupDeliveryQuery__
 *
 * To run a query within a React component, call `useGetSiteSetupDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteSetupDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteSetupDeliveryQuery({
 *   variables: {
 *      siteSetupId: // value for 'siteSetupId'
 *   },
 * });
 */
export function useGetSiteSetupDeliveryQuery(baseOptions: Apollo.QueryHookOptions<GetSiteSetupDeliveryQuery, GetSiteSetupDeliveryQueryVariables> & ({ variables: GetSiteSetupDeliveryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteSetupDeliveryQuery, GetSiteSetupDeliveryQueryVariables>(GetSiteSetupDeliveryDocument, options);
      }
export function useGetSiteSetupDeliveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteSetupDeliveryQuery, GetSiteSetupDeliveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteSetupDeliveryQuery, GetSiteSetupDeliveryQueryVariables>(GetSiteSetupDeliveryDocument, options);
        }
// @ts-ignore
export function useGetSiteSetupDeliverySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteSetupDeliveryQuery, GetSiteSetupDeliveryQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteSetupDeliveryQuery, GetSiteSetupDeliveryQueryVariables>;
export function useGetSiteSetupDeliverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteSetupDeliveryQuery, GetSiteSetupDeliveryQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteSetupDeliveryQuery | undefined, GetSiteSetupDeliveryQueryVariables>;
export function useGetSiteSetupDeliverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteSetupDeliveryQuery, GetSiteSetupDeliveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteSetupDeliveryQuery, GetSiteSetupDeliveryQueryVariables>(GetSiteSetupDeliveryDocument, options);
        }
export type GetSiteSetupDeliveryQueryHookResult = ReturnType<typeof useGetSiteSetupDeliveryQuery>;
export type GetSiteSetupDeliveryLazyQueryHookResult = ReturnType<typeof useGetSiteSetupDeliveryLazyQuery>;
export type GetSiteSetupDeliverySuspenseQueryHookResult = ReturnType<typeof useGetSiteSetupDeliverySuspenseQuery>;
export type GetSiteSetupDeliveryQueryResult = Apollo.QueryResult<GetSiteSetupDeliveryQuery, GetSiteSetupDeliveryQueryVariables>;
export const GetSiteSetupsBySiteIdDocument = gql`
    query GET_SITE_SETUPS_BY_SITE_ID($siteId: String!, $date: String!) {
  getSiteSetupsBySiteId(siteId: $siteId, date: $date) {
    _id
    createdAt
    date
    delivery {
      isDynamic
    }
    deliveryPerson {
      _id
      fullname
    }
    freefoodSetup {
      ...FreefoodSetupFragment
    }
    isFinishForced
    issues {
      productsIssues {
        comment
        productId
        brokenDuringDeliveryQuantity
        brokenOnSiteAfterInventoryQuantity
        brokenOnSiteBeforeInventoryQuantity
        expiredDeliveredQuantity
        expiredOnSiteAfterInventoryQuantity
        expiredOnSiteBeforeInventoryQuantity
        notEnoughPlaceQuantity
        otherBeforeInventoryQuantity
        otherAfterInventoryOrDuringDeliveryQuantity
        unexpectedOnSiteQuantity
        wrongQuantityDelivered
      }
    }
    microstoreColumnGroupSetups {
      ...MicrostoreColumnGroupSetupFragment
    }
    siteId
    site {
      _id
      organizationName
      microstoreColumnGroups {
        _id
        name
        columns {
          _id
          name
        }
      }
      name
      state
      type
    }
    state
    stateHistory {
      createdAt
      createdBy
      createdByName
      state
    }
    updatedAt
  }
}
    ${FreefoodSetupFragmentFragmentDoc}
${MicrostoreColumnGroupSetupFragmentFragmentDoc}`;

/**
 * __useGetSiteSetupsBySiteIdQuery__
 *
 * To run a query within a React component, call `useGetSiteSetupsBySiteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteSetupsBySiteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteSetupsBySiteIdQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetSiteSetupsBySiteIdQuery(baseOptions: Apollo.QueryHookOptions<GetSiteSetupsBySiteIdQuery, GetSiteSetupsBySiteIdQueryVariables> & ({ variables: GetSiteSetupsBySiteIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteSetupsBySiteIdQuery, GetSiteSetupsBySiteIdQueryVariables>(GetSiteSetupsBySiteIdDocument, options);
      }
export function useGetSiteSetupsBySiteIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteSetupsBySiteIdQuery, GetSiteSetupsBySiteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteSetupsBySiteIdQuery, GetSiteSetupsBySiteIdQueryVariables>(GetSiteSetupsBySiteIdDocument, options);
        }
// @ts-ignore
export function useGetSiteSetupsBySiteIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteSetupsBySiteIdQuery, GetSiteSetupsBySiteIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteSetupsBySiteIdQuery, GetSiteSetupsBySiteIdQueryVariables>;
export function useGetSiteSetupsBySiteIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteSetupsBySiteIdQuery, GetSiteSetupsBySiteIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteSetupsBySiteIdQuery | undefined, GetSiteSetupsBySiteIdQueryVariables>;
export function useGetSiteSetupsBySiteIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteSetupsBySiteIdQuery, GetSiteSetupsBySiteIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteSetupsBySiteIdQuery, GetSiteSetupsBySiteIdQueryVariables>(GetSiteSetupsBySiteIdDocument, options);
        }
export type GetSiteSetupsBySiteIdQueryHookResult = ReturnType<typeof useGetSiteSetupsBySiteIdQuery>;
export type GetSiteSetupsBySiteIdLazyQueryHookResult = ReturnType<typeof useGetSiteSetupsBySiteIdLazyQuery>;
export type GetSiteSetupsBySiteIdSuspenseQueryHookResult = ReturnType<typeof useGetSiteSetupsBySiteIdSuspenseQuery>;
export type GetSiteSetupsBySiteIdQueryResult = Apollo.QueryResult<GetSiteSetupsBySiteIdQuery, GetSiteSetupsBySiteIdQueryVariables>;
export const GetSnapshotMicrostoreForDateDocument = gql`
    query GET_SNAPSHOT_MICROSTORE_FOR_DATE($siteId: String!, $snapshotDate: String!) {
  getSnapshotMicrostoreForDate(siteId: $siteId, snapshotDate: $snapshotDate) {
    _id
    createdAt
    columnGroups {
      columnGroupId
      columns {
        columnId
        columnIdToReplace
        isPaused
        removalDate
        shelves {
          shelfId
          locationTable {
            locationId
            productId
          }
        }
        startingDate
      }
    }
    siteId
    snapshotDate
  }
}
    `;

/**
 * __useGetSnapshotMicrostoreForDateQuery__
 *
 * To run a query within a React component, call `useGetSnapshotMicrostoreForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnapshotMicrostoreForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnapshotMicrostoreForDateQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      snapshotDate: // value for 'snapshotDate'
 *   },
 * });
 */
export function useGetSnapshotMicrostoreForDateQuery(baseOptions: Apollo.QueryHookOptions<GetSnapshotMicrostoreForDateQuery, GetSnapshotMicrostoreForDateQueryVariables> & ({ variables: GetSnapshotMicrostoreForDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSnapshotMicrostoreForDateQuery, GetSnapshotMicrostoreForDateQueryVariables>(GetSnapshotMicrostoreForDateDocument, options);
      }
export function useGetSnapshotMicrostoreForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSnapshotMicrostoreForDateQuery, GetSnapshotMicrostoreForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSnapshotMicrostoreForDateQuery, GetSnapshotMicrostoreForDateQueryVariables>(GetSnapshotMicrostoreForDateDocument, options);
        }
// @ts-ignore
export function useGetSnapshotMicrostoreForDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSnapshotMicrostoreForDateQuery, GetSnapshotMicrostoreForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetSnapshotMicrostoreForDateQuery, GetSnapshotMicrostoreForDateQueryVariables>;
export function useGetSnapshotMicrostoreForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSnapshotMicrostoreForDateQuery, GetSnapshotMicrostoreForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetSnapshotMicrostoreForDateQuery | undefined, GetSnapshotMicrostoreForDateQueryVariables>;
export function useGetSnapshotMicrostoreForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSnapshotMicrostoreForDateQuery, GetSnapshotMicrostoreForDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSnapshotMicrostoreForDateQuery, GetSnapshotMicrostoreForDateQueryVariables>(GetSnapshotMicrostoreForDateDocument, options);
        }
export type GetSnapshotMicrostoreForDateQueryHookResult = ReturnType<typeof useGetSnapshotMicrostoreForDateQuery>;
export type GetSnapshotMicrostoreForDateLazyQueryHookResult = ReturnType<typeof useGetSnapshotMicrostoreForDateLazyQuery>;
export type GetSnapshotMicrostoreForDateSuspenseQueryHookResult = ReturnType<typeof useGetSnapshotMicrostoreForDateSuspenseQuery>;
export type GetSnapshotMicrostoreForDateQueryResult = Apollo.QueryResult<GetSnapshotMicrostoreForDateQuery, GetSnapshotMicrostoreForDateQueryVariables>;
export const GetStockTransfersDocument = gql`
    query GET_STOCK_TRANSFERS($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: StockTransfersFilterInput) {
  stockTransfers(
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    stockTransfers {
      _id
      transferDate
      state
      destinationColumn {
        fullname
      }
      originColumn {
        fullname
      }
      quantityOfProducts
      numberOfRefs
      reassortmentFlow
      isForReassortment
      shouldUpdateStockImmediately
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetStockTransfersQuery__
 *
 * To run a query within a React component, call `useGetStockTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockTransfersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetStockTransfersQuery(baseOptions?: Apollo.QueryHookOptions<GetStockTransfersQuery, GetStockTransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockTransfersQuery, GetStockTransfersQueryVariables>(GetStockTransfersDocument, options);
      }
export function useGetStockTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockTransfersQuery, GetStockTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockTransfersQuery, GetStockTransfersQueryVariables>(GetStockTransfersDocument, options);
        }
// @ts-ignore
export function useGetStockTransfersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockTransfersQuery, GetStockTransfersQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTransfersQuery, GetStockTransfersQueryVariables>;
export function useGetStockTransfersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTransfersQuery, GetStockTransfersQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTransfersQuery | undefined, GetStockTransfersQueryVariables>;
export function useGetStockTransfersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTransfersQuery, GetStockTransfersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockTransfersQuery, GetStockTransfersQueryVariables>(GetStockTransfersDocument, options);
        }
export type GetStockTransfersQueryHookResult = ReturnType<typeof useGetStockTransfersQuery>;
export type GetStockTransfersLazyQueryHookResult = ReturnType<typeof useGetStockTransfersLazyQuery>;
export type GetStockTransfersSuspenseQueryHookResult = ReturnType<typeof useGetStockTransfersSuspenseQuery>;
export type GetStockTransfersQueryResult = Apollo.QueryResult<GetStockTransfersQuery, GetStockTransfersQueryVariables>;
export const GetReturnedStockTransfersDocument = gql`
    query GET_RETURNED_STOCK_TRANSFERS($transferDate: String!) {
  returnedStockTransfers(transferDate: $transferDate) {
    _id
    state
    originColumn {
      fullname
    }
    products {
      productId
      fullname
      originStockAvailable
      destinationStockAvailable
      quantity
    }
    updatedAt
  }
}
    `;

/**
 * __useGetReturnedStockTransfersQuery__
 *
 * To run a query within a React component, call `useGetReturnedStockTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnedStockTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnedStockTransfersQuery({
 *   variables: {
 *      transferDate: // value for 'transferDate'
 *   },
 * });
 */
export function useGetReturnedStockTransfersQuery(baseOptions: Apollo.QueryHookOptions<GetReturnedStockTransfersQuery, GetReturnedStockTransfersQueryVariables> & ({ variables: GetReturnedStockTransfersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnedStockTransfersQuery, GetReturnedStockTransfersQueryVariables>(GetReturnedStockTransfersDocument, options);
      }
export function useGetReturnedStockTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnedStockTransfersQuery, GetReturnedStockTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnedStockTransfersQuery, GetReturnedStockTransfersQueryVariables>(GetReturnedStockTransfersDocument, options);
        }
// @ts-ignore
export function useGetReturnedStockTransfersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReturnedStockTransfersQuery, GetReturnedStockTransfersQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnedStockTransfersQuery, GetReturnedStockTransfersQueryVariables>;
export function useGetReturnedStockTransfersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnedStockTransfersQuery, GetReturnedStockTransfersQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnedStockTransfersQuery | undefined, GetReturnedStockTransfersQueryVariables>;
export function useGetReturnedStockTransfersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnedStockTransfersQuery, GetReturnedStockTransfersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReturnedStockTransfersQuery, GetReturnedStockTransfersQueryVariables>(GetReturnedStockTransfersDocument, options);
        }
export type GetReturnedStockTransfersQueryHookResult = ReturnType<typeof useGetReturnedStockTransfersQuery>;
export type GetReturnedStockTransfersLazyQueryHookResult = ReturnType<typeof useGetReturnedStockTransfersLazyQuery>;
export type GetReturnedStockTransfersSuspenseQueryHookResult = ReturnType<typeof useGetReturnedStockTransfersSuspenseQuery>;
export type GetReturnedStockTransfersQueryResult = Apollo.QueryResult<GetReturnedStockTransfersQuery, GetReturnedStockTransfersQueryVariables>;
export const GetStockTransferDocument = gql`
    query GET_STOCK_TRANSFER($stockTransferId: ID!) {
  stockTransfer(stockTransferId: $stockTransferId) {
    ...StockTransferFragment
  }
}
    ${StockTransferFragmentFragmentDoc}`;

/**
 * __useGetStockTransferQuery__
 *
 * To run a query within a React component, call `useGetStockTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockTransferQuery({
 *   variables: {
 *      stockTransferId: // value for 'stockTransferId'
 *   },
 * });
 */
export function useGetStockTransferQuery(baseOptions: Apollo.QueryHookOptions<GetStockTransferQuery, GetStockTransferQueryVariables> & ({ variables: GetStockTransferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockTransferQuery, GetStockTransferQueryVariables>(GetStockTransferDocument, options);
      }
export function useGetStockTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockTransferQuery, GetStockTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockTransferQuery, GetStockTransferQueryVariables>(GetStockTransferDocument, options);
        }
// @ts-ignore
export function useGetStockTransferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockTransferQuery, GetStockTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTransferQuery, GetStockTransferQueryVariables>;
export function useGetStockTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTransferQuery, GetStockTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTransferQuery | undefined, GetStockTransferQueryVariables>;
export function useGetStockTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTransferQuery, GetStockTransferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockTransferQuery, GetStockTransferQueryVariables>(GetStockTransferDocument, options);
        }
export type GetStockTransferQueryHookResult = ReturnType<typeof useGetStockTransferQuery>;
export type GetStockTransferLazyQueryHookResult = ReturnType<typeof useGetStockTransferLazyQuery>;
export type GetStockTransferSuspenseQueryHookResult = ReturnType<typeof useGetStockTransferSuspenseQuery>;
export type GetStockTransferQueryResult = Apollo.QueryResult<GetStockTransferQuery, GetStockTransferQueryVariables>;
export const GetColumnProductStocksDocument = gql`
    query GET_COLUMN_PRODUCT_STOCKS($columnId: ID!) {
  column(_id: $columnId) {
    _id
    productStocks {
      ...StockTreeColumnProduct
    }
  }
}
    ${StockTreeColumnProductFragmentDoc}`;

/**
 * __useGetColumnProductStocksQuery__
 *
 * To run a query within a React component, call `useGetColumnProductStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColumnProductStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColumnProductStocksQuery({
 *   variables: {
 *      columnId: // value for 'columnId'
 *   },
 * });
 */
export function useGetColumnProductStocksQuery(baseOptions: Apollo.QueryHookOptions<GetColumnProductStocksQuery, GetColumnProductStocksQueryVariables> & ({ variables: GetColumnProductStocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetColumnProductStocksQuery, GetColumnProductStocksQueryVariables>(GetColumnProductStocksDocument, options);
      }
export function useGetColumnProductStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetColumnProductStocksQuery, GetColumnProductStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetColumnProductStocksQuery, GetColumnProductStocksQueryVariables>(GetColumnProductStocksDocument, options);
        }
// @ts-ignore
export function useGetColumnProductStocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetColumnProductStocksQuery, GetColumnProductStocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnProductStocksQuery, GetColumnProductStocksQueryVariables>;
export function useGetColumnProductStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnProductStocksQuery, GetColumnProductStocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetColumnProductStocksQuery | undefined, GetColumnProductStocksQueryVariables>;
export function useGetColumnProductStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetColumnProductStocksQuery, GetColumnProductStocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetColumnProductStocksQuery, GetColumnProductStocksQueryVariables>(GetColumnProductStocksDocument, options);
        }
export type GetColumnProductStocksQueryHookResult = ReturnType<typeof useGetColumnProductStocksQuery>;
export type GetColumnProductStocksLazyQueryHookResult = ReturnType<typeof useGetColumnProductStocksLazyQuery>;
export type GetColumnProductStocksSuspenseQueryHookResult = ReturnType<typeof useGetColumnProductStocksSuspenseQuery>;
export type GetColumnProductStocksQueryResult = Apollo.QueryResult<GetColumnProductStocksQuery, GetColumnProductStocksQueryVariables>;
export const GetSiteProductsTreeDocument = gql`
    query GET_SITE_PRODUCTS_TREE($siteId: ID!, $offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: SiteProductsFilterInput) {
  siteProducts(
    siteId: $siteId
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    siteProducts {
      productId
      product {
        _id
        fullname
      }
      stock
      targetStock
      availableStock {
        isUnlimited
        value
      }
      merchantValuation
      columnsCount
      latestStockVariations {
        _id
        createdAt
        delta
        type
        ref
        explanation
      }
    }
  }
}
    `;

/**
 * __useGetSiteProductsTreeQuery__
 *
 * To run a query within a React component, call `useGetSiteProductsTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteProductsTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteProductsTreeQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSiteProductsTreeQuery(baseOptions: Apollo.QueryHookOptions<GetSiteProductsTreeQuery, GetSiteProductsTreeQueryVariables> & ({ variables: GetSiteProductsTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteProductsTreeQuery, GetSiteProductsTreeQueryVariables>(GetSiteProductsTreeDocument, options);
      }
export function useGetSiteProductsTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteProductsTreeQuery, GetSiteProductsTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteProductsTreeQuery, GetSiteProductsTreeQueryVariables>(GetSiteProductsTreeDocument, options);
        }
// @ts-ignore
export function useGetSiteProductsTreeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteProductsTreeQuery, GetSiteProductsTreeQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteProductsTreeQuery, GetSiteProductsTreeQueryVariables>;
export function useGetSiteProductsTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteProductsTreeQuery, GetSiteProductsTreeQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteProductsTreeQuery | undefined, GetSiteProductsTreeQueryVariables>;
export function useGetSiteProductsTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteProductsTreeQuery, GetSiteProductsTreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteProductsTreeQuery, GetSiteProductsTreeQueryVariables>(GetSiteProductsTreeDocument, options);
        }
export type GetSiteProductsTreeQueryHookResult = ReturnType<typeof useGetSiteProductsTreeQuery>;
export type GetSiteProductsTreeLazyQueryHookResult = ReturnType<typeof useGetSiteProductsTreeLazyQuery>;
export type GetSiteProductsTreeSuspenseQueryHookResult = ReturnType<typeof useGetSiteProductsTreeSuspenseQuery>;
export type GetSiteProductsTreeQueryResult = Apollo.QueryResult<GetSiteProductsTreeQuery, GetSiteProductsTreeQueryVariables>;
export const GetSiteProductsColumnStocksDocument = gql`
    query GET_SITE_PRODUCTS_COLUMN_STOCKS($siteId: ID!, $limit: Int, $filters: SiteProductsFilterInput) {
  siteProducts(siteId: $siteId, offset: 0, limit: $limit, filters: $filters) {
    siteProducts {
      productId
      columnStocks {
        ...StockTreeColumnProduct
      }
    }
  }
}
    ${StockTreeColumnProductFragmentDoc}`;

/**
 * __useGetSiteProductsColumnStocksQuery__
 *
 * To run a query within a React component, call `useGetSiteProductsColumnStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteProductsColumnStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteProductsColumnStocksQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSiteProductsColumnStocksQuery(baseOptions: Apollo.QueryHookOptions<GetSiteProductsColumnStocksQuery, GetSiteProductsColumnStocksQueryVariables> & ({ variables: GetSiteProductsColumnStocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteProductsColumnStocksQuery, GetSiteProductsColumnStocksQueryVariables>(GetSiteProductsColumnStocksDocument, options);
      }
export function useGetSiteProductsColumnStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteProductsColumnStocksQuery, GetSiteProductsColumnStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteProductsColumnStocksQuery, GetSiteProductsColumnStocksQueryVariables>(GetSiteProductsColumnStocksDocument, options);
        }
// @ts-ignore
export function useGetSiteProductsColumnStocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteProductsColumnStocksQuery, GetSiteProductsColumnStocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteProductsColumnStocksQuery, GetSiteProductsColumnStocksQueryVariables>;
export function useGetSiteProductsColumnStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteProductsColumnStocksQuery, GetSiteProductsColumnStocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteProductsColumnStocksQuery | undefined, GetSiteProductsColumnStocksQueryVariables>;
export function useGetSiteProductsColumnStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteProductsColumnStocksQuery, GetSiteProductsColumnStocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteProductsColumnStocksQuery, GetSiteProductsColumnStocksQueryVariables>(GetSiteProductsColumnStocksDocument, options);
        }
export type GetSiteProductsColumnStocksQueryHookResult = ReturnType<typeof useGetSiteProductsColumnStocksQuery>;
export type GetSiteProductsColumnStocksLazyQueryHookResult = ReturnType<typeof useGetSiteProductsColumnStocksLazyQuery>;
export type GetSiteProductsColumnStocksSuspenseQueryHookResult = ReturnType<typeof useGetSiteProductsColumnStocksSuspenseQuery>;
export type GetSiteProductsColumnStocksQueryResult = Apollo.QueryResult<GetSiteProductsColumnStocksQuery, GetSiteProductsColumnStocksQueryVariables>;
export const GetSiteProductColumnStocksDocument = gql`
    query GET_SITE_PRODUCT_COLUMN_STOCKS($siteId: ID!, $productId: ID!) {
  siteProduct(siteId: $siteId, productId: $productId) {
    productId
    columnStocks {
      ...StockTreeColumnProduct
    }
  }
}
    ${StockTreeColumnProductFragmentDoc}`;

/**
 * __useGetSiteProductColumnStocksQuery__
 *
 * To run a query within a React component, call `useGetSiteProductColumnStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteProductColumnStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteProductColumnStocksQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetSiteProductColumnStocksQuery(baseOptions: Apollo.QueryHookOptions<GetSiteProductColumnStocksQuery, GetSiteProductColumnStocksQueryVariables> & ({ variables: GetSiteProductColumnStocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteProductColumnStocksQuery, GetSiteProductColumnStocksQueryVariables>(GetSiteProductColumnStocksDocument, options);
      }
export function useGetSiteProductColumnStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteProductColumnStocksQuery, GetSiteProductColumnStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteProductColumnStocksQuery, GetSiteProductColumnStocksQueryVariables>(GetSiteProductColumnStocksDocument, options);
        }
// @ts-ignore
export function useGetSiteProductColumnStocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteProductColumnStocksQuery, GetSiteProductColumnStocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteProductColumnStocksQuery, GetSiteProductColumnStocksQueryVariables>;
export function useGetSiteProductColumnStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteProductColumnStocksQuery, GetSiteProductColumnStocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetSiteProductColumnStocksQuery | undefined, GetSiteProductColumnStocksQueryVariables>;
export function useGetSiteProductColumnStocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteProductColumnStocksQuery, GetSiteProductColumnStocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteProductColumnStocksQuery, GetSiteProductColumnStocksQueryVariables>(GetSiteProductColumnStocksDocument, options);
        }
export type GetSiteProductColumnStocksQueryHookResult = ReturnType<typeof useGetSiteProductColumnStocksQuery>;
export type GetSiteProductColumnStocksLazyQueryHookResult = ReturnType<typeof useGetSiteProductColumnStocksLazyQuery>;
export type GetSiteProductColumnStocksSuspenseQueryHookResult = ReturnType<typeof useGetSiteProductColumnStocksSuspenseQuery>;
export type GetSiteProductColumnStocksQueryResult = Apollo.QueryResult<GetSiteProductColumnStocksQuery, GetSiteProductColumnStocksQueryVariables>;
export const GetStockVariationsForDateDocument = gql`
    query GET_STOCK_VARIATIONS_FOR_DATE($date: String!) {
  getStockVariationsForDate(date: $date) {
    ...StockVariationFragment
  }
}
    ${StockVariationFragmentFragmentDoc}`;

/**
 * __useGetStockVariationsForDateQuery__
 *
 * To run a query within a React component, call `useGetStockVariationsForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockVariationsForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockVariationsForDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetStockVariationsForDateQuery(baseOptions: Apollo.QueryHookOptions<GetStockVariationsForDateQuery, GetStockVariationsForDateQueryVariables> & ({ variables: GetStockVariationsForDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockVariationsForDateQuery, GetStockVariationsForDateQueryVariables>(GetStockVariationsForDateDocument, options);
      }
export function useGetStockVariationsForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockVariationsForDateQuery, GetStockVariationsForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockVariationsForDateQuery, GetStockVariationsForDateQueryVariables>(GetStockVariationsForDateDocument, options);
        }
// @ts-ignore
export function useGetStockVariationsForDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockVariationsForDateQuery, GetStockVariationsForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockVariationsForDateQuery, GetStockVariationsForDateQueryVariables>;
export function useGetStockVariationsForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockVariationsForDateQuery, GetStockVariationsForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockVariationsForDateQuery | undefined, GetStockVariationsForDateQueryVariables>;
export function useGetStockVariationsForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockVariationsForDateQuery, GetStockVariationsForDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockVariationsForDateQuery, GetStockVariationsForDateQueryVariables>(GetStockVariationsForDateDocument, options);
        }
export type GetStockVariationsForDateQueryHookResult = ReturnType<typeof useGetStockVariationsForDateQuery>;
export type GetStockVariationsForDateLazyQueryHookResult = ReturnType<typeof useGetStockVariationsForDateLazyQuery>;
export type GetStockVariationsForDateSuspenseQueryHookResult = ReturnType<typeof useGetStockVariationsForDateSuspenseQuery>;
export type GetStockVariationsForDateQueryResult = Apollo.QueryResult<GetStockVariationsForDateQuery, GetStockVariationsForDateQueryVariables>;
export const GetSubcategoriesDocument = gql`
    query GetSubcategories {
  subcategories {
    ...Subcategory
  }
}
    ${SubcategoryFragmentDoc}`;

/**
 * __useGetSubcategoriesQuery__
 *
 * To run a query within a React component, call `useGetSubcategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubcategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubcategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubcategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>(GetSubcategoriesDocument, options);
      }
export function useGetSubcategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>(GetSubcategoriesDocument, options);
        }
// @ts-ignore
export function useGetSubcategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>;
export function useGetSubcategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubcategoriesQuery | undefined, GetSubcategoriesQueryVariables>;
export function useGetSubcategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>(GetSubcategoriesDocument, options);
        }
export type GetSubcategoriesQueryHookResult = ReturnType<typeof useGetSubcategoriesQuery>;
export type GetSubcategoriesLazyQueryHookResult = ReturnType<typeof useGetSubcategoriesLazyQuery>;
export type GetSubcategoriesSuspenseQueryHookResult = ReturnType<typeof useGetSubcategoriesSuspenseQuery>;
export type GetSubcategoriesQueryResult = Apollo.QueryResult<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>;
export const GetSubcategoriesOfCategoryDocument = gql`
    query GetSubcategoriesOfCategory($categoryId: ID!) {
  subcategoriesOfCategory(categoryId: $categoryId) {
    ...Subcategory
  }
}
    ${SubcategoryFragmentDoc}`;

/**
 * __useGetSubcategoriesOfCategoryQuery__
 *
 * To run a query within a React component, call `useGetSubcategoriesOfCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubcategoriesOfCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubcategoriesOfCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetSubcategoriesOfCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetSubcategoriesOfCategoryQuery, GetSubcategoriesOfCategoryQueryVariables> & ({ variables: GetSubcategoriesOfCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubcategoriesOfCategoryQuery, GetSubcategoriesOfCategoryQueryVariables>(GetSubcategoriesOfCategoryDocument, options);
      }
export function useGetSubcategoriesOfCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubcategoriesOfCategoryQuery, GetSubcategoriesOfCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubcategoriesOfCategoryQuery, GetSubcategoriesOfCategoryQueryVariables>(GetSubcategoriesOfCategoryDocument, options);
        }
// @ts-ignore
export function useGetSubcategoriesOfCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubcategoriesOfCategoryQuery, GetSubcategoriesOfCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubcategoriesOfCategoryQuery, GetSubcategoriesOfCategoryQueryVariables>;
export function useGetSubcategoriesOfCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubcategoriesOfCategoryQuery, GetSubcategoriesOfCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubcategoriesOfCategoryQuery | undefined, GetSubcategoriesOfCategoryQueryVariables>;
export function useGetSubcategoriesOfCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubcategoriesOfCategoryQuery, GetSubcategoriesOfCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubcategoriesOfCategoryQuery, GetSubcategoriesOfCategoryQueryVariables>(GetSubcategoriesOfCategoryDocument, options);
        }
export type GetSubcategoriesOfCategoryQueryHookResult = ReturnType<typeof useGetSubcategoriesOfCategoryQuery>;
export type GetSubcategoriesOfCategoryLazyQueryHookResult = ReturnType<typeof useGetSubcategoriesOfCategoryLazyQuery>;
export type GetSubcategoriesOfCategorySuspenseQueryHookResult = ReturnType<typeof useGetSubcategoriesOfCategorySuspenseQuery>;
export type GetSubcategoriesOfCategoryQueryResult = Apollo.QueryResult<GetSubcategoriesOfCategoryQuery, GetSubcategoriesOfCategoryQueryVariables>;
export const GetSubventionsDocument = gql`
    query GET_SUBVENTIONS {
  subventions {
    ...SubventionFragment
  }
}
    ${SubventionFragmentFragmentDoc}`;

/**
 * __useGetSubventionsQuery__
 *
 * To run a query within a React component, call `useGetSubventionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubventionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubventionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubventionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubventionsQuery, GetSubventionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubventionsQuery, GetSubventionsQueryVariables>(GetSubventionsDocument, options);
      }
export function useGetSubventionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubventionsQuery, GetSubventionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubventionsQuery, GetSubventionsQueryVariables>(GetSubventionsDocument, options);
        }
// @ts-ignore
export function useGetSubventionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubventionsQuery, GetSubventionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubventionsQuery, GetSubventionsQueryVariables>;
export function useGetSubventionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubventionsQuery, GetSubventionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubventionsQuery | undefined, GetSubventionsQueryVariables>;
export function useGetSubventionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubventionsQuery, GetSubventionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubventionsQuery, GetSubventionsQueryVariables>(GetSubventionsDocument, options);
        }
export type GetSubventionsQueryHookResult = ReturnType<typeof useGetSubventionsQuery>;
export type GetSubventionsLazyQueryHookResult = ReturnType<typeof useGetSubventionsLazyQuery>;
export type GetSubventionsSuspenseQueryHookResult = ReturnType<typeof useGetSubventionsSuspenseQuery>;
export type GetSubventionsQueryResult = Apollo.QueryResult<GetSubventionsQuery, GetSubventionsQueryVariables>;
export const GetSubventionDocument = gql`
    query GET_SUBVENTION($subventionId: ID!) {
  subvention(subventionId: $subventionId) {
    ...SubventionFragment
  }
}
    ${SubventionFragmentFragmentDoc}`;

/**
 * __useGetSubventionQuery__
 *
 * To run a query within a React component, call `useGetSubventionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubventionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubventionQuery({
 *   variables: {
 *      subventionId: // value for 'subventionId'
 *   },
 * });
 */
export function useGetSubventionQuery(baseOptions: Apollo.QueryHookOptions<GetSubventionQuery, GetSubventionQueryVariables> & ({ variables: GetSubventionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubventionQuery, GetSubventionQueryVariables>(GetSubventionDocument, options);
      }
export function useGetSubventionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubventionQuery, GetSubventionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubventionQuery, GetSubventionQueryVariables>(GetSubventionDocument, options);
        }
// @ts-ignore
export function useGetSubventionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubventionQuery, GetSubventionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubventionQuery, GetSubventionQueryVariables>;
export function useGetSubventionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubventionQuery, GetSubventionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubventionQuery | undefined, GetSubventionQueryVariables>;
export function useGetSubventionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubventionQuery, GetSubventionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubventionQuery, GetSubventionQueryVariables>(GetSubventionDocument, options);
        }
export type GetSubventionQueryHookResult = ReturnType<typeof useGetSubventionQuery>;
export type GetSubventionLazyQueryHookResult = ReturnType<typeof useGetSubventionLazyQuery>;
export type GetSubventionSuspenseQueryHookResult = ReturnType<typeof useGetSubventionSuspenseQuery>;
export type GetSubventionQueryResult = Apollo.QueryResult<GetSubventionQuery, GetSubventionQueryVariables>;
export const GetSuppliersDocument = gql`
    query GET_SUPPLIERS {
  suppliers {
    _id
    name
    state
  }
}
    `;

/**
 * __useGetSuppliersQuery__
 *
 * To run a query within a React component, call `useGetSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuppliersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
      }
export function useGetSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
        }
// @ts-ignore
export function useGetSuppliersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuppliersQuery, GetSuppliersQueryVariables>;
export function useGetSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuppliersQuery | undefined, GetSuppliersQueryVariables>;
export function useGetSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
        }
export type GetSuppliersQueryHookResult = ReturnType<typeof useGetSuppliersQuery>;
export type GetSuppliersLazyQueryHookResult = ReturnType<typeof useGetSuppliersLazyQuery>;
export type GetSuppliersSuspenseQueryHookResult = ReturnType<typeof useGetSuppliersSuspenseQuery>;
export type GetSuppliersQueryResult = Apollo.QueryResult<GetSuppliersQuery, GetSuppliersQueryVariables>;
export const GetPaginatedFilteredSuppliersDocument = gql`
    query GET_PAGINATED_FILTERED_SUPPLIERS($offset: Int!, $filterString: String, $shouldHideArchived: Boolean) {
  paginatedFilteredSuppliers(
    offset: $offset
    filterString: $filterString
    shouldHideArchived: $shouldHideArchived
  ) {
    hasMore
    suppliers {
      _id
      name
      state
    }
  }
}
    `;

/**
 * __useGetPaginatedFilteredSuppliersQuery__
 *
 * To run a query within a React component, call `useGetPaginatedFilteredSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedFilteredSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedFilteredSuppliersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      filterString: // value for 'filterString'
 *      shouldHideArchived: // value for 'shouldHideArchived'
 *   },
 * });
 */
export function useGetPaginatedFilteredSuppliersQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedFilteredSuppliersQuery, GetPaginatedFilteredSuppliersQueryVariables> & ({ variables: GetPaginatedFilteredSuppliersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedFilteredSuppliersQuery, GetPaginatedFilteredSuppliersQueryVariables>(GetPaginatedFilteredSuppliersDocument, options);
      }
export function useGetPaginatedFilteredSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedFilteredSuppliersQuery, GetPaginatedFilteredSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedFilteredSuppliersQuery, GetPaginatedFilteredSuppliersQueryVariables>(GetPaginatedFilteredSuppliersDocument, options);
        }
// @ts-ignore
export function useGetPaginatedFilteredSuppliersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedFilteredSuppliersQuery, GetPaginatedFilteredSuppliersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedFilteredSuppliersQuery, GetPaginatedFilteredSuppliersQueryVariables>;
export function useGetPaginatedFilteredSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedFilteredSuppliersQuery, GetPaginatedFilteredSuppliersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedFilteredSuppliersQuery | undefined, GetPaginatedFilteredSuppliersQueryVariables>;
export function useGetPaginatedFilteredSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedFilteredSuppliersQuery, GetPaginatedFilteredSuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedFilteredSuppliersQuery, GetPaginatedFilteredSuppliersQueryVariables>(GetPaginatedFilteredSuppliersDocument, options);
        }
export type GetPaginatedFilteredSuppliersQueryHookResult = ReturnType<typeof useGetPaginatedFilteredSuppliersQuery>;
export type GetPaginatedFilteredSuppliersLazyQueryHookResult = ReturnType<typeof useGetPaginatedFilteredSuppliersLazyQuery>;
export type GetPaginatedFilteredSuppliersSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedFilteredSuppliersSuspenseQuery>;
export type GetPaginatedFilteredSuppliersQueryResult = Apollo.QueryResult<GetPaginatedFilteredSuppliersQuery, GetPaginatedFilteredSuppliersQueryVariables>;
export const GetDetailedSupplierDocument = gql`
    query GET_DETAILED_SUPPLIER($supplierId: ID!) {
  detailedSupplier(supplierId: $supplierId) {
    ...SupplierFragment
  }
}
    ${SupplierFragmentFragmentDoc}`;

/**
 * __useGetDetailedSupplierQuery__
 *
 * To run a query within a React component, call `useGetDetailedSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedSupplierQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useGetDetailedSupplierQuery(baseOptions: Apollo.QueryHookOptions<GetDetailedSupplierQuery, GetDetailedSupplierQueryVariables> & ({ variables: GetDetailedSupplierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailedSupplierQuery, GetDetailedSupplierQueryVariables>(GetDetailedSupplierDocument, options);
      }
export function useGetDetailedSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailedSupplierQuery, GetDetailedSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailedSupplierQuery, GetDetailedSupplierQueryVariables>(GetDetailedSupplierDocument, options);
        }
// @ts-ignore
export function useGetDetailedSupplierSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDetailedSupplierQuery, GetDetailedSupplierQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedSupplierQuery, GetDetailedSupplierQueryVariables>;
export function useGetDetailedSupplierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedSupplierQuery, GetDetailedSupplierQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedSupplierQuery | undefined, GetDetailedSupplierQueryVariables>;
export function useGetDetailedSupplierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedSupplierQuery, GetDetailedSupplierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailedSupplierQuery, GetDetailedSupplierQueryVariables>(GetDetailedSupplierDocument, options);
        }
export type GetDetailedSupplierQueryHookResult = ReturnType<typeof useGetDetailedSupplierQuery>;
export type GetDetailedSupplierLazyQueryHookResult = ReturnType<typeof useGetDetailedSupplierLazyQuery>;
export type GetDetailedSupplierSuspenseQueryHookResult = ReturnType<typeof useGetDetailedSupplierSuspenseQuery>;
export type GetDetailedSupplierQueryResult = Apollo.QueryResult<GetDetailedSupplierQuery, GetDetailedSupplierQueryVariables>;
export const SupplierDiscountsDocument = gql`
    query SupplierDiscounts {
  supplierDiscounts {
    ...SupplierDiscountFragment
  }
}
    ${SupplierDiscountFragmentFragmentDoc}`;

/**
 * __useSupplierDiscountsQuery__
 *
 * To run a query within a React component, call `useSupplierDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierDiscountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupplierDiscountsQuery(baseOptions?: Apollo.QueryHookOptions<SupplierDiscountsQuery, SupplierDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierDiscountsQuery, SupplierDiscountsQueryVariables>(SupplierDiscountsDocument, options);
      }
export function useSupplierDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierDiscountsQuery, SupplierDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierDiscountsQuery, SupplierDiscountsQueryVariables>(SupplierDiscountsDocument, options);
        }
// @ts-ignore
export function useSupplierDiscountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupplierDiscountsQuery, SupplierDiscountsQueryVariables>): Apollo.UseSuspenseQueryResult<SupplierDiscountsQuery, SupplierDiscountsQueryVariables>;
export function useSupplierDiscountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierDiscountsQuery, SupplierDiscountsQueryVariables>): Apollo.UseSuspenseQueryResult<SupplierDiscountsQuery | undefined, SupplierDiscountsQueryVariables>;
export function useSupplierDiscountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplierDiscountsQuery, SupplierDiscountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplierDiscountsQuery, SupplierDiscountsQueryVariables>(SupplierDiscountsDocument, options);
        }
export type SupplierDiscountsQueryHookResult = ReturnType<typeof useSupplierDiscountsQuery>;
export type SupplierDiscountsLazyQueryHookResult = ReturnType<typeof useSupplierDiscountsLazyQuery>;
export type SupplierDiscountsSuspenseQueryHookResult = ReturnType<typeof useSupplierDiscountsSuspenseQuery>;
export type SupplierDiscountsQueryResult = Apollo.QueryResult<SupplierDiscountsQuery, SupplierDiscountsQueryVariables>;
export const GetSupplierPartnershipsDocument = gql`
    query GET_SUPPLIER_PARTNERSHIPS {
  supplierPartnerships {
    ...SupplierPartnershipFragment
  }
}
    ${SupplierPartnershipFragmentFragmentDoc}`;

/**
 * __useGetSupplierPartnershipsQuery__
 *
 * To run a query within a React component, call `useGetSupplierPartnershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplierPartnershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplierPartnershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupplierPartnershipsQuery(baseOptions?: Apollo.QueryHookOptions<GetSupplierPartnershipsQuery, GetSupplierPartnershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplierPartnershipsQuery, GetSupplierPartnershipsQueryVariables>(GetSupplierPartnershipsDocument, options);
      }
export function useGetSupplierPartnershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplierPartnershipsQuery, GetSupplierPartnershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplierPartnershipsQuery, GetSupplierPartnershipsQueryVariables>(GetSupplierPartnershipsDocument, options);
        }
// @ts-ignore
export function useGetSupplierPartnershipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSupplierPartnershipsQuery, GetSupplierPartnershipsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplierPartnershipsQuery, GetSupplierPartnershipsQueryVariables>;
export function useGetSupplierPartnershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplierPartnershipsQuery, GetSupplierPartnershipsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplierPartnershipsQuery | undefined, GetSupplierPartnershipsQueryVariables>;
export function useGetSupplierPartnershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplierPartnershipsQuery, GetSupplierPartnershipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupplierPartnershipsQuery, GetSupplierPartnershipsQueryVariables>(GetSupplierPartnershipsDocument, options);
        }
export type GetSupplierPartnershipsQueryHookResult = ReturnType<typeof useGetSupplierPartnershipsQuery>;
export type GetSupplierPartnershipsLazyQueryHookResult = ReturnType<typeof useGetSupplierPartnershipsLazyQuery>;
export type GetSupplierPartnershipsSuspenseQueryHookResult = ReturnType<typeof useGetSupplierPartnershipsSuspenseQuery>;
export type GetSupplierPartnershipsQueryResult = Apollo.QueryResult<GetSupplierPartnershipsQuery, GetSupplierPartnershipsQueryVariables>;
export const GetSupplyOrdersDocument = gql`
    query GET_SUPPLY_ORDERS($displayLimitDateFormatted: String!) {
  supplyOrders(displayLimitDateFormatted: $displayLimitDateFormatted) {
    ...SupplyOrderFragment
    description
    isAtSoldOutRisk
    isMerged
    issues {
      ...SupplyOrderProductIssueFragment
    }
    products {
      _id
      quantity
      supplyOrderId
    }
  }
}
    ${SupplyOrderFragmentFragmentDoc}
${SupplyOrderProductIssueFragmentFragmentDoc}`;

/**
 * __useGetSupplyOrdersQuery__
 *
 * To run a query within a React component, call `useGetSupplyOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplyOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplyOrdersQuery({
 *   variables: {
 *      displayLimitDateFormatted: // value for 'displayLimitDateFormatted'
 *   },
 * });
 */
export function useGetSupplyOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables> & ({ variables: GetSupplyOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>(GetSupplyOrdersDocument, options);
      }
export function useGetSupplyOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>(GetSupplyOrdersDocument, options);
        }
// @ts-ignore
export function useGetSupplyOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>;
export function useGetSupplyOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplyOrdersQuery | undefined, GetSupplyOrdersQueryVariables>;
export function useGetSupplyOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>(GetSupplyOrdersDocument, options);
        }
export type GetSupplyOrdersQueryHookResult = ReturnType<typeof useGetSupplyOrdersQuery>;
export type GetSupplyOrdersLazyQueryHookResult = ReturnType<typeof useGetSupplyOrdersLazyQuery>;
export type GetSupplyOrdersSuspenseQueryHookResult = ReturnType<typeof useGetSupplyOrdersSuspenseQuery>;
export type GetSupplyOrdersQueryResult = Apollo.QueryResult<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>;
export const GetSupplyOrderWithSupplierProductsInfoDocument = gql`
    query GET_SUPPLY_ORDER_WITH_SUPPLIER_PRODUCTS_INFO($supplyOrderId: String!) {
  supplyOrderWithSupplierProductsInfo(supplyOrderId: $supplyOrderId) {
    ...SupplyOrderWithSupplierProductsInfoFragment
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;

/**
 * __useGetSupplyOrderWithSupplierProductsInfoQuery__
 *
 * To run a query within a React component, call `useGetSupplyOrderWithSupplierProductsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplyOrderWithSupplierProductsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplyOrderWithSupplierProductsInfoQuery({
 *   variables: {
 *      supplyOrderId: // value for 'supplyOrderId'
 *   },
 * });
 */
export function useGetSupplyOrderWithSupplierProductsInfoQuery(baseOptions: Apollo.QueryHookOptions<GetSupplyOrderWithSupplierProductsInfoQuery, GetSupplyOrderWithSupplierProductsInfoQueryVariables> & ({ variables: GetSupplyOrderWithSupplierProductsInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplyOrderWithSupplierProductsInfoQuery, GetSupplyOrderWithSupplierProductsInfoQueryVariables>(GetSupplyOrderWithSupplierProductsInfoDocument, options);
      }
export function useGetSupplyOrderWithSupplierProductsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplyOrderWithSupplierProductsInfoQuery, GetSupplyOrderWithSupplierProductsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplyOrderWithSupplierProductsInfoQuery, GetSupplyOrderWithSupplierProductsInfoQueryVariables>(GetSupplyOrderWithSupplierProductsInfoDocument, options);
        }
// @ts-ignore
export function useGetSupplyOrderWithSupplierProductsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSupplyOrderWithSupplierProductsInfoQuery, GetSupplyOrderWithSupplierProductsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplyOrderWithSupplierProductsInfoQuery, GetSupplyOrderWithSupplierProductsInfoQueryVariables>;
export function useGetSupplyOrderWithSupplierProductsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplyOrderWithSupplierProductsInfoQuery, GetSupplyOrderWithSupplierProductsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplyOrderWithSupplierProductsInfoQuery | undefined, GetSupplyOrderWithSupplierProductsInfoQueryVariables>;
export function useGetSupplyOrderWithSupplierProductsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplyOrderWithSupplierProductsInfoQuery, GetSupplyOrderWithSupplierProductsInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupplyOrderWithSupplierProductsInfoQuery, GetSupplyOrderWithSupplierProductsInfoQueryVariables>(GetSupplyOrderWithSupplierProductsInfoDocument, options);
        }
export type GetSupplyOrderWithSupplierProductsInfoQueryHookResult = ReturnType<typeof useGetSupplyOrderWithSupplierProductsInfoQuery>;
export type GetSupplyOrderWithSupplierProductsInfoLazyQueryHookResult = ReturnType<typeof useGetSupplyOrderWithSupplierProductsInfoLazyQuery>;
export type GetSupplyOrderWithSupplierProductsInfoSuspenseQueryHookResult = ReturnType<typeof useGetSupplyOrderWithSupplierProductsInfoSuspenseQuery>;
export type GetSupplyOrderWithSupplierProductsInfoQueryResult = Apollo.QueryResult<GetSupplyOrderWithSupplierProductsInfoQuery, GetSupplyOrderWithSupplierProductsInfoQueryVariables>;
export const GetSupplyOrderSupplierProductsStockVariationDocument = gql`
    query GET_SUPPLY_ORDER_SUPPLIER_PRODUCTS_STOCK_VARIATION($supplyOrderId: String!) {
  supplyOrderSupplierProductsStockVariation(supplyOrderId: $supplyOrderId) {
    productGroupStockVariations {
      ...SupplyOrderProductStockVariationFragment
      isComputed
    }
    supplyOrderStockVariations {
      ...SupplyOrderProductStockVariationFragment
      isComputed
    }
  }
}
    ${SupplyOrderProductStockVariationFragmentFragmentDoc}`;

/**
 * __useGetSupplyOrderSupplierProductsStockVariationQuery__
 *
 * To run a query within a React component, call `useGetSupplyOrderSupplierProductsStockVariationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplyOrderSupplierProductsStockVariationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplyOrderSupplierProductsStockVariationQuery({
 *   variables: {
 *      supplyOrderId: // value for 'supplyOrderId'
 *   },
 * });
 */
export function useGetSupplyOrderSupplierProductsStockVariationQuery(baseOptions: Apollo.QueryHookOptions<GetSupplyOrderSupplierProductsStockVariationQuery, GetSupplyOrderSupplierProductsStockVariationQueryVariables> & ({ variables: GetSupplyOrderSupplierProductsStockVariationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplyOrderSupplierProductsStockVariationQuery, GetSupplyOrderSupplierProductsStockVariationQueryVariables>(GetSupplyOrderSupplierProductsStockVariationDocument, options);
      }
export function useGetSupplyOrderSupplierProductsStockVariationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplyOrderSupplierProductsStockVariationQuery, GetSupplyOrderSupplierProductsStockVariationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplyOrderSupplierProductsStockVariationQuery, GetSupplyOrderSupplierProductsStockVariationQueryVariables>(GetSupplyOrderSupplierProductsStockVariationDocument, options);
        }
// @ts-ignore
export function useGetSupplyOrderSupplierProductsStockVariationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSupplyOrderSupplierProductsStockVariationQuery, GetSupplyOrderSupplierProductsStockVariationQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplyOrderSupplierProductsStockVariationQuery, GetSupplyOrderSupplierProductsStockVariationQueryVariables>;
export function useGetSupplyOrderSupplierProductsStockVariationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplyOrderSupplierProductsStockVariationQuery, GetSupplyOrderSupplierProductsStockVariationQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplyOrderSupplierProductsStockVariationQuery | undefined, GetSupplyOrderSupplierProductsStockVariationQueryVariables>;
export function useGetSupplyOrderSupplierProductsStockVariationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplyOrderSupplierProductsStockVariationQuery, GetSupplyOrderSupplierProductsStockVariationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupplyOrderSupplierProductsStockVariationQuery, GetSupplyOrderSupplierProductsStockVariationQueryVariables>(GetSupplyOrderSupplierProductsStockVariationDocument, options);
        }
export type GetSupplyOrderSupplierProductsStockVariationQueryHookResult = ReturnType<typeof useGetSupplyOrderSupplierProductsStockVariationQuery>;
export type GetSupplyOrderSupplierProductsStockVariationLazyQueryHookResult = ReturnType<typeof useGetSupplyOrderSupplierProductsStockVariationLazyQuery>;
export type GetSupplyOrderSupplierProductsStockVariationSuspenseQueryHookResult = ReturnType<typeof useGetSupplyOrderSupplierProductsStockVariationSuspenseQuery>;
export type GetSupplyOrderSupplierProductsStockVariationQueryResult = Apollo.QueryResult<GetSupplyOrderSupplierProductsStockVariationQuery, GetSupplyOrderSupplierProductsStockVariationQueryVariables>;
export const GetProductsToOrderOnceForSupplyOrderDocument = gql`
    query GET_PRODUCTS_TO_ORDER_ONCE_FOR_SUPPLY_ORDER($supplyOrderId: String!) {
  productsToOrderOnceForSupplyOrder(supplyOrderId: $supplyOrderId) {
    _id
    suppliers {
      prices {
        packagesPerBatch
      }
    }
  }
}
    `;

/**
 * __useGetProductsToOrderOnceForSupplyOrderQuery__
 *
 * To run a query within a React component, call `useGetProductsToOrderOnceForSupplyOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsToOrderOnceForSupplyOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsToOrderOnceForSupplyOrderQuery({
 *   variables: {
 *      supplyOrderId: // value for 'supplyOrderId'
 *   },
 * });
 */
export function useGetProductsToOrderOnceForSupplyOrderQuery(baseOptions: Apollo.QueryHookOptions<GetProductsToOrderOnceForSupplyOrderQuery, GetProductsToOrderOnceForSupplyOrderQueryVariables> & ({ variables: GetProductsToOrderOnceForSupplyOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsToOrderOnceForSupplyOrderQuery, GetProductsToOrderOnceForSupplyOrderQueryVariables>(GetProductsToOrderOnceForSupplyOrderDocument, options);
      }
export function useGetProductsToOrderOnceForSupplyOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsToOrderOnceForSupplyOrderQuery, GetProductsToOrderOnceForSupplyOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsToOrderOnceForSupplyOrderQuery, GetProductsToOrderOnceForSupplyOrderQueryVariables>(GetProductsToOrderOnceForSupplyOrderDocument, options);
        }
// @ts-ignore
export function useGetProductsToOrderOnceForSupplyOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsToOrderOnceForSupplyOrderQuery, GetProductsToOrderOnceForSupplyOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsToOrderOnceForSupplyOrderQuery, GetProductsToOrderOnceForSupplyOrderQueryVariables>;
export function useGetProductsToOrderOnceForSupplyOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsToOrderOnceForSupplyOrderQuery, GetProductsToOrderOnceForSupplyOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsToOrderOnceForSupplyOrderQuery | undefined, GetProductsToOrderOnceForSupplyOrderQueryVariables>;
export function useGetProductsToOrderOnceForSupplyOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsToOrderOnceForSupplyOrderQuery, GetProductsToOrderOnceForSupplyOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsToOrderOnceForSupplyOrderQuery, GetProductsToOrderOnceForSupplyOrderQueryVariables>(GetProductsToOrderOnceForSupplyOrderDocument, options);
        }
export type GetProductsToOrderOnceForSupplyOrderQueryHookResult = ReturnType<typeof useGetProductsToOrderOnceForSupplyOrderQuery>;
export type GetProductsToOrderOnceForSupplyOrderLazyQueryHookResult = ReturnType<typeof useGetProductsToOrderOnceForSupplyOrderLazyQuery>;
export type GetProductsToOrderOnceForSupplyOrderSuspenseQueryHookResult = ReturnType<typeof useGetProductsToOrderOnceForSupplyOrderSuspenseQuery>;
export type GetProductsToOrderOnceForSupplyOrderQueryResult = Apollo.QueryResult<GetProductsToOrderOnceForSupplyOrderQuery, GetProductsToOrderOnceForSupplyOrderQueryVariables>;
export const GetTagsDocument = gql`
    query GET_TAGS {
  tags {
    ...TagQueryFragment
  }
}
    ${TagQueryFragmentFragmentDoc}`;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
// @ts-ignore
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagsQuery, GetTagsQueryVariables>;
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagsQuery | undefined, GetTagsQueryVariables>;
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetTagDocument = gql`
    query GET_TAG($tagId: ID!) {
  tag(tagId: $tagId) {
    ...TagQueryFragment
  }
}
    ${TagQueryFragmentFragmentDoc}`;

/**
 * __useGetTagQuery__
 *
 * To run a query within a React component, call `useGetTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagQuery({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useGetTagQuery(baseOptions: Apollo.QueryHookOptions<GetTagQuery, GetTagQueryVariables> & ({ variables: GetTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
      }
export function useGetTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
        }
// @ts-ignore
export function useGetTagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagQuery, GetTagQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagQuery, GetTagQueryVariables>;
export function useGetTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagQuery, GetTagQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagQuery | undefined, GetTagQueryVariables>;
export function useGetTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
        }
export type GetTagQueryHookResult = ReturnType<typeof useGetTagQuery>;
export type GetTagLazyQueryHookResult = ReturnType<typeof useGetTagLazyQuery>;
export type GetTagSuspenseQueryHookResult = ReturnType<typeof useGetTagSuspenseQuery>;
export type GetTagQueryResult = Apollo.QueryResult<GetTagQuery, GetTagQueryVariables>;
export const GetTermsRecordsDocument = gql`
    query GET_TERMS_RECORDS {
  termsRecords {
    _id
    createdAt
    termsOfUseUrl
  }
}
    `;

/**
 * __useGetTermsRecordsQuery__
 *
 * To run a query within a React component, call `useGetTermsRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsRecordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTermsRecordsQuery(baseOptions?: Apollo.QueryHookOptions<GetTermsRecordsQuery, GetTermsRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsRecordsQuery, GetTermsRecordsQueryVariables>(GetTermsRecordsDocument, options);
      }
export function useGetTermsRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsRecordsQuery, GetTermsRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsRecordsQuery, GetTermsRecordsQueryVariables>(GetTermsRecordsDocument, options);
        }
// @ts-ignore
export function useGetTermsRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTermsRecordsQuery, GetTermsRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTermsRecordsQuery, GetTermsRecordsQueryVariables>;
export function useGetTermsRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTermsRecordsQuery, GetTermsRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTermsRecordsQuery | undefined, GetTermsRecordsQueryVariables>;
export function useGetTermsRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTermsRecordsQuery, GetTermsRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTermsRecordsQuery, GetTermsRecordsQueryVariables>(GetTermsRecordsDocument, options);
        }
export type GetTermsRecordsQueryHookResult = ReturnType<typeof useGetTermsRecordsQuery>;
export type GetTermsRecordsLazyQueryHookResult = ReturnType<typeof useGetTermsRecordsLazyQuery>;
export type GetTermsRecordsSuspenseQueryHookResult = ReturnType<typeof useGetTermsRecordsSuspenseQuery>;
export type GetTermsRecordsQueryResult = Apollo.QueryResult<GetTermsRecordsQuery, GetTermsRecordsQueryVariables>;
export const GetThermometersDocument = gql`
    query GET_THERMOMETERS {
  getThermometers {
    ...ThermometerFragment
  }
}
    ${ThermometerFragmentFragmentDoc}`;

/**
 * __useGetThermometersQuery__
 *
 * To run a query within a React component, call `useGetThermometersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThermometersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThermometersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThermometersQuery(baseOptions?: Apollo.QueryHookOptions<GetThermometersQuery, GetThermometersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThermometersQuery, GetThermometersQueryVariables>(GetThermometersDocument, options);
      }
export function useGetThermometersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThermometersQuery, GetThermometersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThermometersQuery, GetThermometersQueryVariables>(GetThermometersDocument, options);
        }
// @ts-ignore
export function useGetThermometersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetThermometersQuery, GetThermometersQueryVariables>): Apollo.UseSuspenseQueryResult<GetThermometersQuery, GetThermometersQueryVariables>;
export function useGetThermometersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThermometersQuery, GetThermometersQueryVariables>): Apollo.UseSuspenseQueryResult<GetThermometersQuery | undefined, GetThermometersQueryVariables>;
export function useGetThermometersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThermometersQuery, GetThermometersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThermometersQuery, GetThermometersQueryVariables>(GetThermometersDocument, options);
        }
export type GetThermometersQueryHookResult = ReturnType<typeof useGetThermometersQuery>;
export type GetThermometersLazyQueryHookResult = ReturnType<typeof useGetThermometersLazyQuery>;
export type GetThermometersSuspenseQueryHookResult = ReturnType<typeof useGetThermometersSuspenseQuery>;
export type GetThermometersQueryResult = Apollo.QueryResult<GetThermometersQuery, GetThermometersQueryVariables>;
export const GetTotemDocument = gql`
    query GET_TOTEM($totemId: ID!) {
  totem(totemId: $totemId) {
    _id
    fullname
    accessTime
    address
    address_details
    consigneDelivery
    city
    country
    deliveryInstructions
    equipments {
      equipmentId
      quantity
      comment
    }
    latitude
    longitude
    mainUser {
      _id
      fullName
    }
    microstore {
      _id
      name
    }
    minimumOrderAmountInfo {
      minimumBakeryAmount
      minimumDryAmount
      minimumFreshAmount
      minimumCatererAmount
      minimumFruitAmount
      minimumTotalAmount
    }
    name
    needSignature
    number
    organization {
      _id
      name
    }
    organizationId
    primaryTotemId
    recentOrders {
      _id
      deliveryDate
      deliveryState
      state
    }
    sites {
      _id
      name
      state
      type
      deliveryType
      createdAt
    }
    state
    stateHistory {
      createdAt
      createdBy
      createdByName
      state
    }
    type
    zipcode
  }
}
    `;

/**
 * __useGetTotemQuery__
 *
 * To run a query within a React component, call `useGetTotemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotemQuery({
 *   variables: {
 *      totemId: // value for 'totemId'
 *   },
 * });
 */
export function useGetTotemQuery(baseOptions: Apollo.QueryHookOptions<GetTotemQuery, GetTotemQueryVariables> & ({ variables: GetTotemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotemQuery, GetTotemQueryVariables>(GetTotemDocument, options);
      }
export function useGetTotemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotemQuery, GetTotemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotemQuery, GetTotemQueryVariables>(GetTotemDocument, options);
        }
// @ts-ignore
export function useGetTotemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTotemQuery, GetTotemQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotemQuery, GetTotemQueryVariables>;
export function useGetTotemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemQuery, GetTotemQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotemQuery | undefined, GetTotemQueryVariables>;
export function useGetTotemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemQuery, GetTotemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotemQuery, GetTotemQueryVariables>(GetTotemDocument, options);
        }
export type GetTotemQueryHookResult = ReturnType<typeof useGetTotemQuery>;
export type GetTotemLazyQueryHookResult = ReturnType<typeof useGetTotemLazyQuery>;
export type GetTotemSuspenseQueryHookResult = ReturnType<typeof useGetTotemSuspenseQuery>;
export type GetTotemQueryResult = Apollo.QueryResult<GetTotemQuery, GetTotemQueryVariables>;
export const GetTotemsOfOrganizationDocument = gql`
    query GET_TOTEMS_OF_ORGANIZATION($organizationId: String!) {
  totemsOfOrganization(organizationId: $organizationId) {
    _id
    name
    number
  }
}
    `;

/**
 * __useGetTotemsOfOrganizationQuery__
 *
 * To run a query within a React component, call `useGetTotemsOfOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotemsOfOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotemsOfOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetTotemsOfOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetTotemsOfOrganizationQuery, GetTotemsOfOrganizationQueryVariables> & ({ variables: GetTotemsOfOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotemsOfOrganizationQuery, GetTotemsOfOrganizationQueryVariables>(GetTotemsOfOrganizationDocument, options);
      }
export function useGetTotemsOfOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotemsOfOrganizationQuery, GetTotemsOfOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotemsOfOrganizationQuery, GetTotemsOfOrganizationQueryVariables>(GetTotemsOfOrganizationDocument, options);
        }
// @ts-ignore
export function useGetTotemsOfOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTotemsOfOrganizationQuery, GetTotemsOfOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotemsOfOrganizationQuery, GetTotemsOfOrganizationQueryVariables>;
export function useGetTotemsOfOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemsOfOrganizationQuery, GetTotemsOfOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotemsOfOrganizationQuery | undefined, GetTotemsOfOrganizationQueryVariables>;
export function useGetTotemsOfOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemsOfOrganizationQuery, GetTotemsOfOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotemsOfOrganizationQuery, GetTotemsOfOrganizationQueryVariables>(GetTotemsOfOrganizationDocument, options);
        }
export type GetTotemsOfOrganizationQueryHookResult = ReturnType<typeof useGetTotemsOfOrganizationQuery>;
export type GetTotemsOfOrganizationLazyQueryHookResult = ReturnType<typeof useGetTotemsOfOrganizationLazyQuery>;
export type GetTotemsOfOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetTotemsOfOrganizationSuspenseQuery>;
export type GetTotemsOfOrganizationQueryResult = Apollo.QueryResult<GetTotemsOfOrganizationQuery, GetTotemsOfOrganizationQueryVariables>;
export const GetDetailedTotemsOfOrganizationDocument = gql`
    query GET_DETAILED_TOTEMS_OF_ORGANIZATION($organizationId: String!) {
  totemsOfOrganization(organizationId: $organizationId) {
    _id
    fullname
    accessTime
    address
    address_details
    consigneDelivery
    city
    country
    deliveryInstructions
    equipments {
      equipmentId
      quantity
      comment
    }
    latitude
    longitude
    mainUser {
      _id
      fullName
    }
    microstore {
      _id
      name
    }
    minimumOrderAmountInfo {
      minimumBakeryAmount
      minimumDryAmount
      minimumFreshAmount
      minimumCatererAmount
      minimumFruitAmount
      minimumTotalAmount
    }
    name
    needSignature
    number
    organizationId
    primaryTotemId
    recentOrders {
      _id
      deliveryDate
      deliveryState
      state
    }
    sites {
      _id
      name
      state
      type
      deliveryType
      createdAt
    }
    state
    stateHistory {
      createdAt
      createdBy
      createdByName
      state
    }
    type
    zipcode
  }
}
    `;

/**
 * __useGetDetailedTotemsOfOrganizationQuery__
 *
 * To run a query within a React component, call `useGetDetailedTotemsOfOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedTotemsOfOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedTotemsOfOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetDetailedTotemsOfOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetDetailedTotemsOfOrganizationQuery, GetDetailedTotemsOfOrganizationQueryVariables> & ({ variables: GetDetailedTotemsOfOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailedTotemsOfOrganizationQuery, GetDetailedTotemsOfOrganizationQueryVariables>(GetDetailedTotemsOfOrganizationDocument, options);
      }
export function useGetDetailedTotemsOfOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailedTotemsOfOrganizationQuery, GetDetailedTotemsOfOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailedTotemsOfOrganizationQuery, GetDetailedTotemsOfOrganizationQueryVariables>(GetDetailedTotemsOfOrganizationDocument, options);
        }
// @ts-ignore
export function useGetDetailedTotemsOfOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDetailedTotemsOfOrganizationQuery, GetDetailedTotemsOfOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedTotemsOfOrganizationQuery, GetDetailedTotemsOfOrganizationQueryVariables>;
export function useGetDetailedTotemsOfOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedTotemsOfOrganizationQuery, GetDetailedTotemsOfOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetDetailedTotemsOfOrganizationQuery | undefined, GetDetailedTotemsOfOrganizationQueryVariables>;
export function useGetDetailedTotemsOfOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailedTotemsOfOrganizationQuery, GetDetailedTotemsOfOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailedTotemsOfOrganizationQuery, GetDetailedTotemsOfOrganizationQueryVariables>(GetDetailedTotemsOfOrganizationDocument, options);
        }
export type GetDetailedTotemsOfOrganizationQueryHookResult = ReturnType<typeof useGetDetailedTotemsOfOrganizationQuery>;
export type GetDetailedTotemsOfOrganizationLazyQueryHookResult = ReturnType<typeof useGetDetailedTotemsOfOrganizationLazyQuery>;
export type GetDetailedTotemsOfOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetDetailedTotemsOfOrganizationSuspenseQuery>;
export type GetDetailedTotemsOfOrganizationQueryResult = Apollo.QueryResult<GetDetailedTotemsOfOrganizationQuery, GetDetailedTotemsOfOrganizationQueryVariables>;
export const GetTotemsWithEquipmentsDocument = gql`
    query GET_TOTEMS_WITH_EQUIPMENTS {
  totemsWithEquipments {
    _id
    number
    equipments {
      equipmentId
      quantity
    }
    organization {
      _id
      name
    }
  }
}
    `;

/**
 * __useGetTotemsWithEquipmentsQuery__
 *
 * To run a query within a React component, call `useGetTotemsWithEquipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotemsWithEquipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotemsWithEquipmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotemsWithEquipmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetTotemsWithEquipmentsQuery, GetTotemsWithEquipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotemsWithEquipmentsQuery, GetTotemsWithEquipmentsQueryVariables>(GetTotemsWithEquipmentsDocument, options);
      }
export function useGetTotemsWithEquipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotemsWithEquipmentsQuery, GetTotemsWithEquipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotemsWithEquipmentsQuery, GetTotemsWithEquipmentsQueryVariables>(GetTotemsWithEquipmentsDocument, options);
        }
// @ts-ignore
export function useGetTotemsWithEquipmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTotemsWithEquipmentsQuery, GetTotemsWithEquipmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotemsWithEquipmentsQuery, GetTotemsWithEquipmentsQueryVariables>;
export function useGetTotemsWithEquipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemsWithEquipmentsQuery, GetTotemsWithEquipmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotemsWithEquipmentsQuery | undefined, GetTotemsWithEquipmentsQueryVariables>;
export function useGetTotemsWithEquipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemsWithEquipmentsQuery, GetTotemsWithEquipmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotemsWithEquipmentsQuery, GetTotemsWithEquipmentsQueryVariables>(GetTotemsWithEquipmentsDocument, options);
        }
export type GetTotemsWithEquipmentsQueryHookResult = ReturnType<typeof useGetTotemsWithEquipmentsQuery>;
export type GetTotemsWithEquipmentsLazyQueryHookResult = ReturnType<typeof useGetTotemsWithEquipmentsLazyQuery>;
export type GetTotemsWithEquipmentsSuspenseQueryHookResult = ReturnType<typeof useGetTotemsWithEquipmentsSuspenseQuery>;
export type GetTotemsWithEquipmentsQueryResult = Apollo.QueryResult<GetTotemsWithEquipmentsQuery, GetTotemsWithEquipmentsQueryVariables>;
export const GetActiveTotemsDocument = gql`
    query GET_ACTIVE_TOTEMS {
  activeTotems {
    _id
    address
    city
    country
    name
    number
    organizationId
    zipcode
  }
}
    `;

/**
 * __useGetActiveTotemsQuery__
 *
 * To run a query within a React component, call `useGetActiveTotemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveTotemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveTotemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveTotemsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveTotemsQuery, GetActiveTotemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveTotemsQuery, GetActiveTotemsQueryVariables>(GetActiveTotemsDocument, options);
      }
export function useGetActiveTotemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveTotemsQuery, GetActiveTotemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveTotemsQuery, GetActiveTotemsQueryVariables>(GetActiveTotemsDocument, options);
        }
// @ts-ignore
export function useGetActiveTotemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveTotemsQuery, GetActiveTotemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveTotemsQuery, GetActiveTotemsQueryVariables>;
export function useGetActiveTotemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveTotemsQuery, GetActiveTotemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveTotemsQuery | undefined, GetActiveTotemsQueryVariables>;
export function useGetActiveTotemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveTotemsQuery, GetActiveTotemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveTotemsQuery, GetActiveTotemsQueryVariables>(GetActiveTotemsDocument, options);
        }
export type GetActiveTotemsQueryHookResult = ReturnType<typeof useGetActiveTotemsQuery>;
export type GetActiveTotemsLazyQueryHookResult = ReturnType<typeof useGetActiveTotemsLazyQuery>;
export type GetActiveTotemsSuspenseQueryHookResult = ReturnType<typeof useGetActiveTotemsSuspenseQuery>;
export type GetActiveTotemsQueryResult = Apollo.QueryResult<GetActiveTotemsQuery, GetActiveTotemsQueryVariables>;
export const GetTotemsFilterDocument = gql`
    query GET_TOTEMS_FILTER($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: TotemsFilterInput) {
  totemsFilter(
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    totems {
      _id
      name
      fullname
      number
      state
      type
      organization {
        _id
        name
      }
      sites {
        _id
        name
      }
    }
  }
}
    `;

/**
 * __useGetTotemsFilterQuery__
 *
 * To run a query within a React component, call `useGetTotemsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotemsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotemsFilterQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTotemsFilterQuery(baseOptions?: Apollo.QueryHookOptions<GetTotemsFilterQuery, GetTotemsFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotemsFilterQuery, GetTotemsFilterQueryVariables>(GetTotemsFilterDocument, options);
      }
export function useGetTotemsFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotemsFilterQuery, GetTotemsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotemsFilterQuery, GetTotemsFilterQueryVariables>(GetTotemsFilterDocument, options);
        }
// @ts-ignore
export function useGetTotemsFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTotemsFilterQuery, GetTotemsFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotemsFilterQuery, GetTotemsFilterQueryVariables>;
export function useGetTotemsFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemsFilterQuery, GetTotemsFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GetTotemsFilterQuery | undefined, GetTotemsFilterQueryVariables>;
export function useGetTotemsFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemsFilterQuery, GetTotemsFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotemsFilterQuery, GetTotemsFilterQueryVariables>(GetTotemsFilterDocument, options);
        }
export type GetTotemsFilterQueryHookResult = ReturnType<typeof useGetTotemsFilterQuery>;
export type GetTotemsFilterLazyQueryHookResult = ReturnType<typeof useGetTotemsFilterLazyQuery>;
export type GetTotemsFilterSuspenseQueryHookResult = ReturnType<typeof useGetTotemsFilterSuspenseQuery>;
export type GetTotemsFilterQueryResult = Apollo.QueryResult<GetTotemsFilterQuery, GetTotemsFilterQueryVariables>;
export const GetAllRegularTotemClosedDayDocument = gql`
    query GET_ALL_REGULAR_TOTEM_CLOSED_DAY {
  getAllRegularTotemClosedDay {
    ...TotemClosedDayFragment
  }
}
    ${TotemClosedDayFragmentFragmentDoc}`;

/**
 * __useGetAllRegularTotemClosedDayQuery__
 *
 * To run a query within a React component, call `useGetAllRegularTotemClosedDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRegularTotemClosedDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRegularTotemClosedDayQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRegularTotemClosedDayQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRegularTotemClosedDayQuery, GetAllRegularTotemClosedDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRegularTotemClosedDayQuery, GetAllRegularTotemClosedDayQueryVariables>(GetAllRegularTotemClosedDayDocument, options);
      }
export function useGetAllRegularTotemClosedDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRegularTotemClosedDayQuery, GetAllRegularTotemClosedDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRegularTotemClosedDayQuery, GetAllRegularTotemClosedDayQueryVariables>(GetAllRegularTotemClosedDayDocument, options);
        }
// @ts-ignore
export function useGetAllRegularTotemClosedDaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllRegularTotemClosedDayQuery, GetAllRegularTotemClosedDayQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllRegularTotemClosedDayQuery, GetAllRegularTotemClosedDayQueryVariables>;
export function useGetAllRegularTotemClosedDaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRegularTotemClosedDayQuery, GetAllRegularTotemClosedDayQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllRegularTotemClosedDayQuery | undefined, GetAllRegularTotemClosedDayQueryVariables>;
export function useGetAllRegularTotemClosedDaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRegularTotemClosedDayQuery, GetAllRegularTotemClosedDayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRegularTotemClosedDayQuery, GetAllRegularTotemClosedDayQueryVariables>(GetAllRegularTotemClosedDayDocument, options);
        }
export type GetAllRegularTotemClosedDayQueryHookResult = ReturnType<typeof useGetAllRegularTotemClosedDayQuery>;
export type GetAllRegularTotemClosedDayLazyQueryHookResult = ReturnType<typeof useGetAllRegularTotemClosedDayLazyQuery>;
export type GetAllRegularTotemClosedDaySuspenseQueryHookResult = ReturnType<typeof useGetAllRegularTotemClosedDaySuspenseQuery>;
export type GetAllRegularTotemClosedDayQueryResult = Apollo.QueryResult<GetAllRegularTotemClosedDayQuery, GetAllRegularTotemClosedDayQueryVariables>;
export const GetAllRegularTotemClosedReceptionDayDocument = gql`
    query GET_ALL_REGULAR_TOTEM_CLOSED_RECEPTION_DAY {
  getAllRegularTotemClosedReceptionDay {
    ...TotemClosedReceptionDayFragment
  }
}
    ${TotemClosedReceptionDayFragmentFragmentDoc}`;

/**
 * __useGetAllRegularTotemClosedReceptionDayQuery__
 *
 * To run a query within a React component, call `useGetAllRegularTotemClosedReceptionDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRegularTotemClosedReceptionDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRegularTotemClosedReceptionDayQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRegularTotemClosedReceptionDayQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRegularTotemClosedReceptionDayQuery, GetAllRegularTotemClosedReceptionDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRegularTotemClosedReceptionDayQuery, GetAllRegularTotemClosedReceptionDayQueryVariables>(GetAllRegularTotemClosedReceptionDayDocument, options);
      }
export function useGetAllRegularTotemClosedReceptionDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRegularTotemClosedReceptionDayQuery, GetAllRegularTotemClosedReceptionDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRegularTotemClosedReceptionDayQuery, GetAllRegularTotemClosedReceptionDayQueryVariables>(GetAllRegularTotemClosedReceptionDayDocument, options);
        }
// @ts-ignore
export function useGetAllRegularTotemClosedReceptionDaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllRegularTotemClosedReceptionDayQuery, GetAllRegularTotemClosedReceptionDayQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllRegularTotemClosedReceptionDayQuery, GetAllRegularTotemClosedReceptionDayQueryVariables>;
export function useGetAllRegularTotemClosedReceptionDaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRegularTotemClosedReceptionDayQuery, GetAllRegularTotemClosedReceptionDayQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllRegularTotemClosedReceptionDayQuery | undefined, GetAllRegularTotemClosedReceptionDayQueryVariables>;
export function useGetAllRegularTotemClosedReceptionDaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRegularTotemClosedReceptionDayQuery, GetAllRegularTotemClosedReceptionDayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRegularTotemClosedReceptionDayQuery, GetAllRegularTotemClosedReceptionDayQueryVariables>(GetAllRegularTotemClosedReceptionDayDocument, options);
        }
export type GetAllRegularTotemClosedReceptionDayQueryHookResult = ReturnType<typeof useGetAllRegularTotemClosedReceptionDayQuery>;
export type GetAllRegularTotemClosedReceptionDayLazyQueryHookResult = ReturnType<typeof useGetAllRegularTotemClosedReceptionDayLazyQuery>;
export type GetAllRegularTotemClosedReceptionDaySuspenseQueryHookResult = ReturnType<typeof useGetAllRegularTotemClosedReceptionDaySuspenseQuery>;
export type GetAllRegularTotemClosedReceptionDayQueryResult = Apollo.QueryResult<GetAllRegularTotemClosedReceptionDayQuery, GetAllRegularTotemClosedReceptionDayQueryVariables>;
export const GetTourPlanningForDateDocument = gql`
    query GET_TOUR_PLANNING_FOR_DATE($birthdayDate: String!) {
  tourPlanningForDate(birthdayDate: $birthdayDate) {
    tours {
      ...TourFragment
    }
    unassignedDeliveries {
      ...TourDeliveryFragment
    }
    unassignedTasks {
      ...TourTaskFragment
    }
  }
}
    ${TourFragmentFragmentDoc}
${TourDeliveryFragmentFragmentDoc}
${TourTaskFragmentFragmentDoc}`;

/**
 * __useGetTourPlanningForDateQuery__
 *
 * To run a query within a React component, call `useGetTourPlanningForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTourPlanningForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTourPlanningForDateQuery({
 *   variables: {
 *      birthdayDate: // value for 'birthdayDate'
 *   },
 * });
 */
export function useGetTourPlanningForDateQuery(baseOptions: Apollo.QueryHookOptions<GetTourPlanningForDateQuery, GetTourPlanningForDateQueryVariables> & ({ variables: GetTourPlanningForDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTourPlanningForDateQuery, GetTourPlanningForDateQueryVariables>(GetTourPlanningForDateDocument, options);
      }
export function useGetTourPlanningForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTourPlanningForDateQuery, GetTourPlanningForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTourPlanningForDateQuery, GetTourPlanningForDateQueryVariables>(GetTourPlanningForDateDocument, options);
        }
// @ts-ignore
export function useGetTourPlanningForDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTourPlanningForDateQuery, GetTourPlanningForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetTourPlanningForDateQuery, GetTourPlanningForDateQueryVariables>;
export function useGetTourPlanningForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTourPlanningForDateQuery, GetTourPlanningForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetTourPlanningForDateQuery | undefined, GetTourPlanningForDateQueryVariables>;
export function useGetTourPlanningForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTourPlanningForDateQuery, GetTourPlanningForDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTourPlanningForDateQuery, GetTourPlanningForDateQueryVariables>(GetTourPlanningForDateDocument, options);
        }
export type GetTourPlanningForDateQueryHookResult = ReturnType<typeof useGetTourPlanningForDateQuery>;
export type GetTourPlanningForDateLazyQueryHookResult = ReturnType<typeof useGetTourPlanningForDateLazyQuery>;
export type GetTourPlanningForDateSuspenseQueryHookResult = ReturnType<typeof useGetTourPlanningForDateSuspenseQuery>;
export type GetTourPlanningForDateQueryResult = Apollo.QueryResult<GetTourPlanningForDateQuery, GetTourPlanningForDateQueryVariables>;
export const GetTourDocument = gql`
    query GET_TOUR($tourId: ID!) {
  tour(tourId: $tourId) {
    ...TourFragment
    date
    stateHistory {
      state
      createdAt
      createdBy
      createdByName
    }
    deliveries {
      ...TourDetailsDeliveryFragment
    }
  }
}
    ${TourFragmentFragmentDoc}
${TourDetailsDeliveryFragmentFragmentDoc}`;

/**
 * __useGetTourQuery__
 *
 * To run a query within a React component, call `useGetTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTourQuery({
 *   variables: {
 *      tourId: // value for 'tourId'
 *   },
 * });
 */
export function useGetTourQuery(baseOptions: Apollo.QueryHookOptions<GetTourQuery, GetTourQueryVariables> & ({ variables: GetTourQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTourQuery, GetTourQueryVariables>(GetTourDocument, options);
      }
export function useGetTourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTourQuery, GetTourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTourQuery, GetTourQueryVariables>(GetTourDocument, options);
        }
// @ts-ignore
export function useGetTourSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTourQuery, GetTourQueryVariables>): Apollo.UseSuspenseQueryResult<GetTourQuery, GetTourQueryVariables>;
export function useGetTourSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTourQuery, GetTourQueryVariables>): Apollo.UseSuspenseQueryResult<GetTourQuery | undefined, GetTourQueryVariables>;
export function useGetTourSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTourQuery, GetTourQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTourQuery, GetTourQueryVariables>(GetTourDocument, options);
        }
export type GetTourQueryHookResult = ReturnType<typeof useGetTourQuery>;
export type GetTourLazyQueryHookResult = ReturnType<typeof useGetTourLazyQuery>;
export type GetTourSuspenseQueryHookResult = ReturnType<typeof useGetTourSuspenseQuery>;
export type GetTourQueryResult = Apollo.QueryResult<GetTourQuery, GetTourQueryVariables>;
export const GetTasksWithPhotosDocument = gql`
    query GET_TASKS_WITH_PHOTOS($startDate: String!, $endDate: String!) {
  tasks(startDate: $startDate, endDate: $endDate) {
    _id
    type
    date
    site {
      _id
      name
      organizationName
    }
    instructions {
      _id
      label
      controlPhotos {
        ...ControlPhotoFragment
      }
    }
  }
}
    ${ControlPhotoFragmentFragmentDoc}`;

/**
 * __useGetTasksWithPhotosQuery__
 *
 * To run a query within a React component, call `useGetTasksWithPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksWithPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksWithPhotosQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetTasksWithPhotosQuery(baseOptions: Apollo.QueryHookOptions<GetTasksWithPhotosQuery, GetTasksWithPhotosQueryVariables> & ({ variables: GetTasksWithPhotosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksWithPhotosQuery, GetTasksWithPhotosQueryVariables>(GetTasksWithPhotosDocument, options);
      }
export function useGetTasksWithPhotosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksWithPhotosQuery, GetTasksWithPhotosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksWithPhotosQuery, GetTasksWithPhotosQueryVariables>(GetTasksWithPhotosDocument, options);
        }
// @ts-ignore
export function useGetTasksWithPhotosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTasksWithPhotosQuery, GetTasksWithPhotosQueryVariables>): Apollo.UseSuspenseQueryResult<GetTasksWithPhotosQuery, GetTasksWithPhotosQueryVariables>;
export function useGetTasksWithPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTasksWithPhotosQuery, GetTasksWithPhotosQueryVariables>): Apollo.UseSuspenseQueryResult<GetTasksWithPhotosQuery | undefined, GetTasksWithPhotosQueryVariables>;
export function useGetTasksWithPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTasksWithPhotosQuery, GetTasksWithPhotosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksWithPhotosQuery, GetTasksWithPhotosQueryVariables>(GetTasksWithPhotosDocument, options);
        }
export type GetTasksWithPhotosQueryHookResult = ReturnType<typeof useGetTasksWithPhotosQuery>;
export type GetTasksWithPhotosLazyQueryHookResult = ReturnType<typeof useGetTasksWithPhotosLazyQuery>;
export type GetTasksWithPhotosSuspenseQueryHookResult = ReturnType<typeof useGetTasksWithPhotosSuspenseQuery>;
export type GetTasksWithPhotosQueryResult = Apollo.QueryResult<GetTasksWithPhotosQuery, GetTasksWithPhotosQueryVariables>;
export const GetTransactionsDocument = gql`
    query GET_TRANSACTIONS($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: TransactionsFilterInput) {
  transactions(
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    hasMore
    transactions {
      ...PreviewTransactionFragment
    }
  }
}
    ${PreviewTransactionFragmentFragmentDoc}`;

/**
 * __useGetTransactionsQuery__
 *
 * To run a query within a React component, call `useGetTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
      }
export function useGetTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
// @ts-ignore
export function useGetTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionsQuery, GetTransactionsQueryVariables>;
export function useGetTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionsQuery | undefined, GetTransactionsQueryVariables>;
export function useGetTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export type GetTransactionsQueryHookResult = ReturnType<typeof useGetTransactionsQuery>;
export type GetTransactionsLazyQueryHookResult = ReturnType<typeof useGetTransactionsLazyQuery>;
export type GetTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionsSuspenseQuery>;
export type GetTransactionsQueryResult = Apollo.QueryResult<GetTransactionsQuery, GetTransactionsQueryVariables>;
export const GetTransactionDocument = gql`
    query GET_TRANSACTION($transactionId: ID!) {
  transaction(transactionId: $transactionId) {
    ...DetailedTransactionFragment
  }
}
    ${DetailedTransactionFragmentFragmentDoc}`;

/**
 * __useGetTransactionQuery__
 *
 * To run a query within a React component, call `useGetTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useGetTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables> & ({ variables: GetTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
      }
export function useGetTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
        }
// @ts-ignore
export function useGetTransactionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionQuery, GetTransactionQueryVariables>;
export function useGetTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionQuery | undefined, GetTransactionQueryVariables>;
export function useGetTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
        }
export type GetTransactionQueryHookResult = ReturnType<typeof useGetTransactionQuery>;
export type GetTransactionLazyQueryHookResult = ReturnType<typeof useGetTransactionLazyQuery>;
export type GetTransactionSuspenseQueryHookResult = ReturnType<typeof useGetTransactionSuspenseQuery>;
export type GetTransactionQueryResult = Apollo.QueryResult<GetTransactionQuery, GetTransactionQueryVariables>;
export const GetAllTrayCapacitiesDocument = gql`
    query GetAllTrayCapacities {
  allTrayCapacities {
    _id
    microstoreColumnId
    microstoreColumn {
      _id
      name
      siteId
      siteName
      microstoreColumnTemplateName
    }
    locations {
      microstoreLocationId
      productId
      product {
        _id
        name
        fullname
      }
      currentLevel
      unitPerPackage
      microstoreLocation {
        microstoreLocationTemplate {
          trayMaxCapacity
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllTrayCapacitiesQuery__
 *
 * To run a query within a React component, call `useGetAllTrayCapacitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTrayCapacitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTrayCapacitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTrayCapacitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTrayCapacitiesQuery, GetAllTrayCapacitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTrayCapacitiesQuery, GetAllTrayCapacitiesQueryVariables>(GetAllTrayCapacitiesDocument, options);
      }
export function useGetAllTrayCapacitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTrayCapacitiesQuery, GetAllTrayCapacitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTrayCapacitiesQuery, GetAllTrayCapacitiesQueryVariables>(GetAllTrayCapacitiesDocument, options);
        }
// @ts-ignore
export function useGetAllTrayCapacitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTrayCapacitiesQuery, GetAllTrayCapacitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTrayCapacitiesQuery, GetAllTrayCapacitiesQueryVariables>;
export function useGetAllTrayCapacitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTrayCapacitiesQuery, GetAllTrayCapacitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTrayCapacitiesQuery | undefined, GetAllTrayCapacitiesQueryVariables>;
export function useGetAllTrayCapacitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTrayCapacitiesQuery, GetAllTrayCapacitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTrayCapacitiesQuery, GetAllTrayCapacitiesQueryVariables>(GetAllTrayCapacitiesDocument, options);
        }
export type GetAllTrayCapacitiesQueryHookResult = ReturnType<typeof useGetAllTrayCapacitiesQuery>;
export type GetAllTrayCapacitiesLazyQueryHookResult = ReturnType<typeof useGetAllTrayCapacitiesLazyQuery>;
export type GetAllTrayCapacitiesSuspenseQueryHookResult = ReturnType<typeof useGetAllTrayCapacitiesSuspenseQuery>;
export type GetAllTrayCapacitiesQueryResult = Apollo.QueryResult<GetAllTrayCapacitiesQuery, GetAllTrayCapacitiesQueryVariables>;
export const GetTrayCapacityByColumnDocument = gql`
    query GET_TRAY_CAPACITY_BY_COLUMN($microstoreColumnId: String!) {
  trayCapacityByMicrostoreColumnId(microstoreColumnId: $microstoreColumnId) {
    _id
    microstoreColumnId
    locations {
      microstoreLocationId
      microstoreLocation {
        microstoreLocationTemplate {
          trayMaxCapacity
        }
      }
      productId
      product {
        _id
        name
        fullname
        imageUrl
      }
      currentLevel
      unitPerPackage
    }
  }
}
    `;

/**
 * __useGetTrayCapacityByColumnQuery__
 *
 * To run a query within a React component, call `useGetTrayCapacityByColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrayCapacityByColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrayCapacityByColumnQuery({
 *   variables: {
 *      microstoreColumnId: // value for 'microstoreColumnId'
 *   },
 * });
 */
export function useGetTrayCapacityByColumnQuery(baseOptions: Apollo.QueryHookOptions<GetTrayCapacityByColumnQuery, GetTrayCapacityByColumnQueryVariables> & ({ variables: GetTrayCapacityByColumnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrayCapacityByColumnQuery, GetTrayCapacityByColumnQueryVariables>(GetTrayCapacityByColumnDocument, options);
      }
export function useGetTrayCapacityByColumnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrayCapacityByColumnQuery, GetTrayCapacityByColumnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrayCapacityByColumnQuery, GetTrayCapacityByColumnQueryVariables>(GetTrayCapacityByColumnDocument, options);
        }
// @ts-ignore
export function useGetTrayCapacityByColumnSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTrayCapacityByColumnQuery, GetTrayCapacityByColumnQueryVariables>): Apollo.UseSuspenseQueryResult<GetTrayCapacityByColumnQuery, GetTrayCapacityByColumnQueryVariables>;
export function useGetTrayCapacityByColumnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrayCapacityByColumnQuery, GetTrayCapacityByColumnQueryVariables>): Apollo.UseSuspenseQueryResult<GetTrayCapacityByColumnQuery | undefined, GetTrayCapacityByColumnQueryVariables>;
export function useGetTrayCapacityByColumnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrayCapacityByColumnQuery, GetTrayCapacityByColumnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrayCapacityByColumnQuery, GetTrayCapacityByColumnQueryVariables>(GetTrayCapacityByColumnDocument, options);
        }
export type GetTrayCapacityByColumnQueryHookResult = ReturnType<typeof useGetTrayCapacityByColumnQuery>;
export type GetTrayCapacityByColumnLazyQueryHookResult = ReturnType<typeof useGetTrayCapacityByColumnLazyQuery>;
export type GetTrayCapacityByColumnSuspenseQueryHookResult = ReturnType<typeof useGetTrayCapacityByColumnSuspenseQuery>;
export type GetTrayCapacityByColumnQueryResult = Apollo.QueryResult<GetTrayCapacityByColumnQuery, GetTrayCapacityByColumnQueryVariables>;
export const GetUrbantzRoundPresetsDocument = gql`
    query GET_URBANTZ_ROUND_PRESETS {
  getUrbantzRoundPresets {
    ...UrbantzRoundPresetFragment
  }
}
    ${UrbantzRoundPresetFragmentFragmentDoc}`;

/**
 * __useGetUrbantzRoundPresetsQuery__
 *
 * To run a query within a React component, call `useGetUrbantzRoundPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUrbantzRoundPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUrbantzRoundPresetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUrbantzRoundPresetsQuery(baseOptions?: Apollo.QueryHookOptions<GetUrbantzRoundPresetsQuery, GetUrbantzRoundPresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUrbantzRoundPresetsQuery, GetUrbantzRoundPresetsQueryVariables>(GetUrbantzRoundPresetsDocument, options);
      }
export function useGetUrbantzRoundPresetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUrbantzRoundPresetsQuery, GetUrbantzRoundPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUrbantzRoundPresetsQuery, GetUrbantzRoundPresetsQueryVariables>(GetUrbantzRoundPresetsDocument, options);
        }
// @ts-ignore
export function useGetUrbantzRoundPresetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUrbantzRoundPresetsQuery, GetUrbantzRoundPresetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUrbantzRoundPresetsQuery, GetUrbantzRoundPresetsQueryVariables>;
export function useGetUrbantzRoundPresetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUrbantzRoundPresetsQuery, GetUrbantzRoundPresetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUrbantzRoundPresetsQuery | undefined, GetUrbantzRoundPresetsQueryVariables>;
export function useGetUrbantzRoundPresetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUrbantzRoundPresetsQuery, GetUrbantzRoundPresetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUrbantzRoundPresetsQuery, GetUrbantzRoundPresetsQueryVariables>(GetUrbantzRoundPresetsDocument, options);
        }
export type GetUrbantzRoundPresetsQueryHookResult = ReturnType<typeof useGetUrbantzRoundPresetsQuery>;
export type GetUrbantzRoundPresetsLazyQueryHookResult = ReturnType<typeof useGetUrbantzRoundPresetsLazyQuery>;
export type GetUrbantzRoundPresetsSuspenseQueryHookResult = ReturnType<typeof useGetUrbantzRoundPresetsSuspenseQuery>;
export type GetUrbantzRoundPresetsQueryResult = Apollo.QueryResult<GetUrbantzRoundPresetsQuery, GetUrbantzRoundPresetsQueryVariables>;
export const GetToteamMessagesDocument = gql`
    query GET_TOTEAM_MESSAGES {
  toteamMessages {
    message
    userFullName
  }
}
    `;

/**
 * __useGetToteamMessagesQuery__
 *
 * To run a query within a React component, call `useGetToteamMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToteamMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToteamMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetToteamMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetToteamMessagesQuery, GetToteamMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetToteamMessagesQuery, GetToteamMessagesQueryVariables>(GetToteamMessagesDocument, options);
      }
export function useGetToteamMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetToteamMessagesQuery, GetToteamMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetToteamMessagesQuery, GetToteamMessagesQueryVariables>(GetToteamMessagesDocument, options);
        }
// @ts-ignore
export function useGetToteamMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetToteamMessagesQuery, GetToteamMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetToteamMessagesQuery, GetToteamMessagesQueryVariables>;
export function useGetToteamMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetToteamMessagesQuery, GetToteamMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetToteamMessagesQuery | undefined, GetToteamMessagesQueryVariables>;
export function useGetToteamMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetToteamMessagesQuery, GetToteamMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetToteamMessagesQuery, GetToteamMessagesQueryVariables>(GetToteamMessagesDocument, options);
        }
export type GetToteamMessagesQueryHookResult = ReturnType<typeof useGetToteamMessagesQuery>;
export type GetToteamMessagesLazyQueryHookResult = ReturnType<typeof useGetToteamMessagesLazyQuery>;
export type GetToteamMessagesSuspenseQueryHookResult = ReturnType<typeof useGetToteamMessagesSuspenseQuery>;
export type GetToteamMessagesQueryResult = Apollo.QueryResult<GetToteamMessagesQuery, GetToteamMessagesQueryVariables>;
export const GetToteamUsersDocument = gql`
    query GET_TOTEAM_USERS {
  toteamUsers {
    _id
    profile {
      fullname
    }
  }
}
    `;

/**
 * __useGetToteamUsersQuery__
 *
 * To run a query within a React component, call `useGetToteamUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToteamUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToteamUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetToteamUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetToteamUsersQuery, GetToteamUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetToteamUsersQuery, GetToteamUsersQueryVariables>(GetToteamUsersDocument, options);
      }
export function useGetToteamUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetToteamUsersQuery, GetToteamUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetToteamUsersQuery, GetToteamUsersQueryVariables>(GetToteamUsersDocument, options);
        }
// @ts-ignore
export function useGetToteamUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetToteamUsersQuery, GetToteamUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetToteamUsersQuery, GetToteamUsersQueryVariables>;
export function useGetToteamUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetToteamUsersQuery, GetToteamUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetToteamUsersQuery | undefined, GetToteamUsersQueryVariables>;
export function useGetToteamUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetToteamUsersQuery, GetToteamUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetToteamUsersQuery, GetToteamUsersQueryVariables>(GetToteamUsersDocument, options);
        }
export type GetToteamUsersQueryHookResult = ReturnType<typeof useGetToteamUsersQuery>;
export type GetToteamUsersLazyQueryHookResult = ReturnType<typeof useGetToteamUsersLazyQuery>;
export type GetToteamUsersSuspenseQueryHookResult = ReturnType<typeof useGetToteamUsersSuspenseQuery>;
export type GetToteamUsersQueryResult = Apollo.QueryResult<GetToteamUsersQuery, GetToteamUsersQueryVariables>;
export const GetUserDocument = gql`
    query GET_USER($userId: ID!) {
  userFromAdmin(userId: $userId) {
    ...AdminUserFragment
  }
}
    ${AdminUserFragmentFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
// @ts-ignore
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery | undefined, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUsersDocument = gql`
    query GET_USERS($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: UsersFilterInput) {
  users(
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    sortOrder: $sortOrder
    filters: $filters
  ) {
    users {
      _id
      createdAt
      lastSeenAt
      username
      source
      lastSite {
        _id
        name
      }
      permissions {
        userGroup
      }
      profile {
        fullname
        state
        organizationId
        organizationName
      }
      organization {
        _id
        name
      }
    }
    hasMore
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetOrganizationUsersDocument = gql`
    query GET_ORGANIZATION_USERS($organizationId: String!) {
  organizationUsers(organizationId: $organizationId) {
    _id
    createdAt
    lastSeenAt
    username
    source
    lastSite {
      _id
      name
    }
    permissions {
      userGroup
      totemId
    }
    profile {
      fullname
      state
    }
  }
}
    `;

/**
 * __useGetOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUsersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationUsersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables> & ({ variables: GetOrganizationUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
      }
export function useGetOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
        }
// @ts-ignore
export function useGetOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>;
export function useGetOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationUsersQuery | undefined, GetOrganizationUsersQueryVariables>;
export function useGetOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
        }
export type GetOrganizationUsersQueryHookResult = ReturnType<typeof useGetOrganizationUsersQuery>;
export type GetOrganizationUsersLazyQueryHookResult = ReturnType<typeof useGetOrganizationUsersLazyQuery>;
export type GetOrganizationUsersSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationUsersSuspenseQuery>;
export type GetOrganizationUsersQueryResult = Apollo.QueryResult<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>;
export const GetDeliveryPeopleDocument = gql`
    query GET_DELIVERY_PEOPLE {
  getDeliveryPeople {
    _id
    profile {
      fullname
    }
    username
  }
}
    `;

/**
 * __useGetDeliveryPeopleQuery__
 *
 * To run a query within a React component, call `useGetDeliveryPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryPeopleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDeliveryPeopleQuery(baseOptions?: Apollo.QueryHookOptions<GetDeliveryPeopleQuery, GetDeliveryPeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryPeopleQuery, GetDeliveryPeopleQueryVariables>(GetDeliveryPeopleDocument, options);
      }
export function useGetDeliveryPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryPeopleQuery, GetDeliveryPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryPeopleQuery, GetDeliveryPeopleQueryVariables>(GetDeliveryPeopleDocument, options);
        }
// @ts-ignore
export function useGetDeliveryPeopleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeliveryPeopleQuery, GetDeliveryPeopleQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveryPeopleQuery, GetDeliveryPeopleQueryVariables>;
export function useGetDeliveryPeopleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryPeopleQuery, GetDeliveryPeopleQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeliveryPeopleQuery | undefined, GetDeliveryPeopleQueryVariables>;
export function useGetDeliveryPeopleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryPeopleQuery, GetDeliveryPeopleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveryPeopleQuery, GetDeliveryPeopleQueryVariables>(GetDeliveryPeopleDocument, options);
        }
export type GetDeliveryPeopleQueryHookResult = ReturnType<typeof useGetDeliveryPeopleQuery>;
export type GetDeliveryPeopleLazyQueryHookResult = ReturnType<typeof useGetDeliveryPeopleLazyQuery>;
export type GetDeliveryPeopleSuspenseQueryHookResult = ReturnType<typeof useGetDeliveryPeopleSuspenseQuery>;
export type GetDeliveryPeopleQueryResult = Apollo.QueryResult<GetDeliveryPeopleQuery, GetDeliveryPeopleQueryVariables>;
export const GetUsersByGroupsDocument = gql`
    query GET_USERS_BY_GROUPS($userGroups: [UserPermission!]!) {
  usersByGroups(userGroups: $userGroups) {
    _id
    username
    profile {
      fullname
    }
  }
}
    `;

/**
 * __useGetUsersByGroupsQuery__
 *
 * To run a query within a React component, call `useGetUsersByGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByGroupsQuery({
 *   variables: {
 *      userGroups: // value for 'userGroups'
 *   },
 * });
 */
export function useGetUsersByGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByGroupsQuery, GetUsersByGroupsQueryVariables> & ({ variables: GetUsersByGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByGroupsQuery, GetUsersByGroupsQueryVariables>(GetUsersByGroupsDocument, options);
      }
export function useGetUsersByGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByGroupsQuery, GetUsersByGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByGroupsQuery, GetUsersByGroupsQueryVariables>(GetUsersByGroupsDocument, options);
        }
// @ts-ignore
export function useGetUsersByGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersByGroupsQuery, GetUsersByGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersByGroupsQuery, GetUsersByGroupsQueryVariables>;
export function useGetUsersByGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByGroupsQuery, GetUsersByGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersByGroupsQuery | undefined, GetUsersByGroupsQueryVariables>;
export function useGetUsersByGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByGroupsQuery, GetUsersByGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersByGroupsQuery, GetUsersByGroupsQueryVariables>(GetUsersByGroupsDocument, options);
        }
export type GetUsersByGroupsQueryHookResult = ReturnType<typeof useGetUsersByGroupsQuery>;
export type GetUsersByGroupsLazyQueryHookResult = ReturnType<typeof useGetUsersByGroupsLazyQuery>;
export type GetUsersByGroupsSuspenseQueryHookResult = ReturnType<typeof useGetUsersByGroupsSuspenseQuery>;
export type GetUsersByGroupsQueryResult = Apollo.QueryResult<GetUsersByGroupsQuery, GetUsersByGroupsQueryVariables>;
export const GetTestSenseiGateTokenDocument = gql`
    query GET_TEST_SENSEI_GATE_TOKEN($senseiUserId: ID!, $isStaff: Boolean!) {
  testSenseiGateToken(senseiUserId: $senseiUserId, isStaff: $isStaff)
}
    `;

/**
 * __useGetTestSenseiGateTokenQuery__
 *
 * To run a query within a React component, call `useGetTestSenseiGateTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestSenseiGateTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestSenseiGateTokenQuery({
 *   variables: {
 *      senseiUserId: // value for 'senseiUserId'
 *      isStaff: // value for 'isStaff'
 *   },
 * });
 */
export function useGetTestSenseiGateTokenQuery(baseOptions: Apollo.QueryHookOptions<GetTestSenseiGateTokenQuery, GetTestSenseiGateTokenQueryVariables> & ({ variables: GetTestSenseiGateTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestSenseiGateTokenQuery, GetTestSenseiGateTokenQueryVariables>(GetTestSenseiGateTokenDocument, options);
      }
export function useGetTestSenseiGateTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestSenseiGateTokenQuery, GetTestSenseiGateTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestSenseiGateTokenQuery, GetTestSenseiGateTokenQueryVariables>(GetTestSenseiGateTokenDocument, options);
        }
// @ts-ignore
export function useGetTestSenseiGateTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTestSenseiGateTokenQuery, GetTestSenseiGateTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetTestSenseiGateTokenQuery, GetTestSenseiGateTokenQueryVariables>;
export function useGetTestSenseiGateTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTestSenseiGateTokenQuery, GetTestSenseiGateTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetTestSenseiGateTokenQuery | undefined, GetTestSenseiGateTokenQueryVariables>;
export function useGetTestSenseiGateTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTestSenseiGateTokenQuery, GetTestSenseiGateTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestSenseiGateTokenQuery, GetTestSenseiGateTokenQueryVariables>(GetTestSenseiGateTokenDocument, options);
        }
export type GetTestSenseiGateTokenQueryHookResult = ReturnType<typeof useGetTestSenseiGateTokenQuery>;
export type GetTestSenseiGateTokenLazyQueryHookResult = ReturnType<typeof useGetTestSenseiGateTokenLazyQuery>;
export type GetTestSenseiGateTokenSuspenseQueryHookResult = ReturnType<typeof useGetTestSenseiGateTokenSuspenseQuery>;
export type GetTestSenseiGateTokenQueryResult = Apollo.QueryResult<GetTestSenseiGateTokenQuery, GetTestSenseiGateTokenQueryVariables>;
export const GetWarehouseDeliveriesDocument = gql`
    query GET_WAREHOUSE_DELIVERIES($searchDate: String) {
  warehouseDeliveries(searchDate: $searchDate) {
    ...WarehouseDeliveryFragment
  }
}
    ${WarehouseDeliveryFragmentFragmentDoc}`;

/**
 * __useGetWarehouseDeliveriesQuery__
 *
 * To run a query within a React component, call `useGetWarehouseDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarehouseDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarehouseDeliveriesQuery({
 *   variables: {
 *      searchDate: // value for 'searchDate'
 *   },
 * });
 */
export function useGetWarehouseDeliveriesQuery(baseOptions?: Apollo.QueryHookOptions<GetWarehouseDeliveriesQuery, GetWarehouseDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarehouseDeliveriesQuery, GetWarehouseDeliveriesQueryVariables>(GetWarehouseDeliveriesDocument, options);
      }
export function useGetWarehouseDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarehouseDeliveriesQuery, GetWarehouseDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarehouseDeliveriesQuery, GetWarehouseDeliveriesQueryVariables>(GetWarehouseDeliveriesDocument, options);
        }
// @ts-ignore
export function useGetWarehouseDeliveriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWarehouseDeliveriesQuery, GetWarehouseDeliveriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarehouseDeliveriesQuery, GetWarehouseDeliveriesQueryVariables>;
export function useGetWarehouseDeliveriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehouseDeliveriesQuery, GetWarehouseDeliveriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarehouseDeliveriesQuery | undefined, GetWarehouseDeliveriesQueryVariables>;
export function useGetWarehouseDeliveriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehouseDeliveriesQuery, GetWarehouseDeliveriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWarehouseDeliveriesQuery, GetWarehouseDeliveriesQueryVariables>(GetWarehouseDeliveriesDocument, options);
        }
export type GetWarehouseDeliveriesQueryHookResult = ReturnType<typeof useGetWarehouseDeliveriesQuery>;
export type GetWarehouseDeliveriesLazyQueryHookResult = ReturnType<typeof useGetWarehouseDeliveriesLazyQuery>;
export type GetWarehouseDeliveriesSuspenseQueryHookResult = ReturnType<typeof useGetWarehouseDeliveriesSuspenseQuery>;
export type GetWarehouseDeliveriesQueryResult = Apollo.QueryResult<GetWarehouseDeliveriesQuery, GetWarehouseDeliveriesQueryVariables>;
export const GetWarehouseDeliveryDocument = gql`
    query GET_WAREHOUSE_DELIVERY($warehouseDeliveryId: String!) {
  warehouseDelivery(warehouseDeliveryId: $warehouseDeliveryId) {
    ...WarehouseDeliveryFragment
  }
}
    ${WarehouseDeliveryFragmentFragmentDoc}`;

/**
 * __useGetWarehouseDeliveryQuery__
 *
 * To run a query within a React component, call `useGetWarehouseDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarehouseDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarehouseDeliveryQuery({
 *   variables: {
 *      warehouseDeliveryId: // value for 'warehouseDeliveryId'
 *   },
 * });
 */
export function useGetWarehouseDeliveryQuery(baseOptions: Apollo.QueryHookOptions<GetWarehouseDeliveryQuery, GetWarehouseDeliveryQueryVariables> & ({ variables: GetWarehouseDeliveryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarehouseDeliveryQuery, GetWarehouseDeliveryQueryVariables>(GetWarehouseDeliveryDocument, options);
      }
export function useGetWarehouseDeliveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarehouseDeliveryQuery, GetWarehouseDeliveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarehouseDeliveryQuery, GetWarehouseDeliveryQueryVariables>(GetWarehouseDeliveryDocument, options);
        }
// @ts-ignore
export function useGetWarehouseDeliverySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWarehouseDeliveryQuery, GetWarehouseDeliveryQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarehouseDeliveryQuery, GetWarehouseDeliveryQueryVariables>;
export function useGetWarehouseDeliverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehouseDeliveryQuery, GetWarehouseDeliveryQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarehouseDeliveryQuery | undefined, GetWarehouseDeliveryQueryVariables>;
export function useGetWarehouseDeliverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehouseDeliveryQuery, GetWarehouseDeliveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWarehouseDeliveryQuery, GetWarehouseDeliveryQueryVariables>(GetWarehouseDeliveryDocument, options);
        }
export type GetWarehouseDeliveryQueryHookResult = ReturnType<typeof useGetWarehouseDeliveryQuery>;
export type GetWarehouseDeliveryLazyQueryHookResult = ReturnType<typeof useGetWarehouseDeliveryLazyQuery>;
export type GetWarehouseDeliverySuspenseQueryHookResult = ReturnType<typeof useGetWarehouseDeliverySuspenseQuery>;
export type GetWarehouseDeliveryQueryResult = Apollo.QueryResult<GetWarehouseDeliveryQuery, GetWarehouseDeliveryQueryVariables>;
export const GetWarehouseReturnForDateDocument = gql`
    query GET_WAREHOUSE_RETURN_FOR_DATE($date: String) {
  getWarehouseReturnsForDate(date: $date) {
    ...WarehouseReturnFragment
  }
}
    ${WarehouseReturnFragmentFragmentDoc}`;

/**
 * __useGetWarehouseReturnForDateQuery__
 *
 * To run a query within a React component, call `useGetWarehouseReturnForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarehouseReturnForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarehouseReturnForDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetWarehouseReturnForDateQuery(baseOptions?: Apollo.QueryHookOptions<GetWarehouseReturnForDateQuery, GetWarehouseReturnForDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarehouseReturnForDateQuery, GetWarehouseReturnForDateQueryVariables>(GetWarehouseReturnForDateDocument, options);
      }
export function useGetWarehouseReturnForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarehouseReturnForDateQuery, GetWarehouseReturnForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarehouseReturnForDateQuery, GetWarehouseReturnForDateQueryVariables>(GetWarehouseReturnForDateDocument, options);
        }
// @ts-ignore
export function useGetWarehouseReturnForDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWarehouseReturnForDateQuery, GetWarehouseReturnForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarehouseReturnForDateQuery, GetWarehouseReturnForDateQueryVariables>;
export function useGetWarehouseReturnForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehouseReturnForDateQuery, GetWarehouseReturnForDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarehouseReturnForDateQuery | undefined, GetWarehouseReturnForDateQueryVariables>;
export function useGetWarehouseReturnForDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehouseReturnForDateQuery, GetWarehouseReturnForDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWarehouseReturnForDateQuery, GetWarehouseReturnForDateQueryVariables>(GetWarehouseReturnForDateDocument, options);
        }
export type GetWarehouseReturnForDateQueryHookResult = ReturnType<typeof useGetWarehouseReturnForDateQuery>;
export type GetWarehouseReturnForDateLazyQueryHookResult = ReturnType<typeof useGetWarehouseReturnForDateLazyQuery>;
export type GetWarehouseReturnForDateSuspenseQueryHookResult = ReturnType<typeof useGetWarehouseReturnForDateSuspenseQuery>;
export type GetWarehouseReturnForDateQueryResult = Apollo.QueryResult<GetWarehouseReturnForDateQuery, GetWarehouseReturnForDateQueryVariables>;
export const GetWarehouseReturnDocument = gql`
    query GET_WAREHOUSE_RETURN($warehouseReturnId: ID!) {
  getWarehouseReturn(warehouseReturnId: $warehouseReturnId) {
    ...WarehouseReturnFragment
  }
}
    ${WarehouseReturnFragmentFragmentDoc}`;

/**
 * __useGetWarehouseReturnQuery__
 *
 * To run a query within a React component, call `useGetWarehouseReturnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarehouseReturnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarehouseReturnQuery({
 *   variables: {
 *      warehouseReturnId: // value for 'warehouseReturnId'
 *   },
 * });
 */
export function useGetWarehouseReturnQuery(baseOptions: Apollo.QueryHookOptions<GetWarehouseReturnQuery, GetWarehouseReturnQueryVariables> & ({ variables: GetWarehouseReturnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarehouseReturnQuery, GetWarehouseReturnQueryVariables>(GetWarehouseReturnDocument, options);
      }
export function useGetWarehouseReturnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarehouseReturnQuery, GetWarehouseReturnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarehouseReturnQuery, GetWarehouseReturnQueryVariables>(GetWarehouseReturnDocument, options);
        }
// @ts-ignore
export function useGetWarehouseReturnSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWarehouseReturnQuery, GetWarehouseReturnQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarehouseReturnQuery, GetWarehouseReturnQueryVariables>;
export function useGetWarehouseReturnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehouseReturnQuery, GetWarehouseReturnQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarehouseReturnQuery | undefined, GetWarehouseReturnQueryVariables>;
export function useGetWarehouseReturnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehouseReturnQuery, GetWarehouseReturnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWarehouseReturnQuery, GetWarehouseReturnQueryVariables>(GetWarehouseReturnDocument, options);
        }
export type GetWarehouseReturnQueryHookResult = ReturnType<typeof useGetWarehouseReturnQuery>;
export type GetWarehouseReturnLazyQueryHookResult = ReturnType<typeof useGetWarehouseReturnLazyQuery>;
export type GetWarehouseReturnSuspenseQueryHookResult = ReturnType<typeof useGetWarehouseReturnSuspenseQuery>;
export type GetWarehouseReturnQueryResult = Apollo.QueryResult<GetWarehouseReturnQuery, GetWarehouseReturnQueryVariables>;
export const AuditLogCreatedDocument = gql`
    subscription AUDIT_LOG_CREATED($collectionDocumentId: String!) {
  auditLogCreated(collectionDocumentId: $collectionDocumentId) {
    ...AuditLogFragment
  }
}
    ${AuditLogFragmentFragmentDoc}`;

/**
 * __useAuditLogCreatedSubscription__
 *
 * To run a query within a React component, call `useAuditLogCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogCreatedSubscription({
 *   variables: {
 *      collectionDocumentId: // value for 'collectionDocumentId'
 *   },
 * });
 */
export function useAuditLogCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<AuditLogCreatedSubscription, AuditLogCreatedSubscriptionVariables> & ({ variables: AuditLogCreatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AuditLogCreatedSubscription, AuditLogCreatedSubscriptionVariables>(AuditLogCreatedDocument, options);
      }
export type AuditLogCreatedSubscriptionHookResult = ReturnType<typeof useAuditLogCreatedSubscription>;
export type AuditLogCreatedSubscriptionResult = Apollo.SubscriptionResult<AuditLogCreatedSubscription>;
export const BundleUpdatedDocument = gql`
    subscription BUNDLE_UPDATED {
  bundleUpdated {
    ...BundleFragment
  }
}
    ${BundleFragmentFragmentDoc}`;

/**
 * __useBundleUpdatedSubscription__
 *
 * To run a query within a React component, call `useBundleUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBundleUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBundleUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useBundleUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<BundleUpdatedSubscription, BundleUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<BundleUpdatedSubscription, BundleUpdatedSubscriptionVariables>(BundleUpdatedDocument, options);
      }
export type BundleUpdatedSubscriptionHookResult = ReturnType<typeof useBundleUpdatedSubscription>;
export type BundleUpdatedSubscriptionResult = Apollo.SubscriptionResult<BundleUpdatedSubscription>;
export const DeliveriesUpdatedDocument = gql`
    subscription DELIVERIES_UPDATED {
  deliveriesUpdated {
    ...DeliveryFragment
  }
}
    ${DeliveryFragmentFragmentDoc}`;

/**
 * __useDeliveriesUpdatedSubscription__
 *
 * To run a query within a React component, call `useDeliveriesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeliveriesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveriesUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useDeliveriesUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeliveriesUpdatedSubscription, DeliveriesUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeliveriesUpdatedSubscription, DeliveriesUpdatedSubscriptionVariables>(DeliveriesUpdatedDocument, options);
      }
export type DeliveriesUpdatedSubscriptionHookResult = ReturnType<typeof useDeliveriesUpdatedSubscription>;
export type DeliveriesUpdatedSubscriptionResult = Apollo.SubscriptionResult<DeliveriesUpdatedSubscription>;
export const DeliveryPlanningUpdatedDocument = gql`
    subscription DELIVERY_PLANNING_UPDATED($siteIds: [ID!]) {
  deliveryPlanningUpdated(siteIds: $siteIds) {
    _id
    siteId
    date
    isManual
    isActive
  }
}
    `;

/**
 * __useDeliveryPlanningUpdatedSubscription__
 *
 * To run a query within a React component, call `useDeliveryPlanningUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryPlanningUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryPlanningUpdatedSubscription({
 *   variables: {
 *      siteIds: // value for 'siteIds'
 *   },
 * });
 */
export function useDeliveryPlanningUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeliveryPlanningUpdatedSubscription, DeliveryPlanningUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeliveryPlanningUpdatedSubscription, DeliveryPlanningUpdatedSubscriptionVariables>(DeliveryPlanningUpdatedDocument, options);
      }
export type DeliveryPlanningUpdatedSubscriptionHookResult = ReturnType<typeof useDeliveryPlanningUpdatedSubscription>;
export type DeliveryPlanningUpdatedSubscriptionResult = Apollo.SubscriptionResult<DeliveryPlanningUpdatedSubscription>;
export const UpdatedProductDocument = gql`
    subscription UPDATED_PRODUCT($productId: ID!) {
  updatedProduct(productId: $productId) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;

/**
 * __useUpdatedProductSubscription__
 *
 * To run a query within a React component, call `useUpdatedProductSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedProductSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedProductSubscription({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useUpdatedProductSubscription(baseOptions: Apollo.SubscriptionHookOptions<UpdatedProductSubscription, UpdatedProductSubscriptionVariables> & ({ variables: UpdatedProductSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedProductSubscription, UpdatedProductSubscriptionVariables>(UpdatedProductDocument, options);
      }
export type UpdatedProductSubscriptionHookResult = ReturnType<typeof useUpdatedProductSubscription>;
export type UpdatedProductSubscriptionResult = Apollo.SubscriptionResult<UpdatedProductSubscription>;
export const UpdatedProductsDocument = gql`
    subscription UPDATED_PRODUCTS {
  updatedProducts {
    ...CatalogProductFragment
  }
}
    ${CatalogProductFragmentFragmentDoc}`;

/**
 * __useUpdatedProductsSubscription__
 *
 * To run a query within a React component, call `useUpdatedProductsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedProductsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedProductsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUpdatedProductsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedProductsSubscription, UpdatedProductsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedProductsSubscription, UpdatedProductsSubscriptionVariables>(UpdatedProductsDocument, options);
      }
export type UpdatedProductsSubscriptionHookResult = ReturnType<typeof useUpdatedProductsSubscription>;
export type UpdatedProductsSubscriptionResult = Apollo.SubscriptionResult<UpdatedProductsSubscription>;
export const ProductStockUpdatedDocument = gql`
    subscription PRODUCT_STOCK_UPDATED($siteId: ID!) {
  productStockUpdated(siteId: $siteId) {
    _id
    stock
  }
}
    `;

/**
 * __useProductStockUpdatedSubscription__
 *
 * To run a query within a React component, call `useProductStockUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProductStockUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductStockUpdatedSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useProductStockUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProductStockUpdatedSubscription, ProductStockUpdatedSubscriptionVariables> & ({ variables: ProductStockUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProductStockUpdatedSubscription, ProductStockUpdatedSubscriptionVariables>(ProductStockUpdatedDocument, options);
      }
export type ProductStockUpdatedSubscriptionHookResult = ReturnType<typeof useProductStockUpdatedSubscription>;
export type ProductStockUpdatedSubscriptionResult = Apollo.SubscriptionResult<ProductStockUpdatedSubscription>;
export const SitesUpdatedDocument = gql`
    subscription SITES_UPDATED($siteId: ID) {
  siteUpdated(siteId: $siteId) {
    ...SiteFragment
  }
}
    ${SiteFragmentFragmentDoc}`;

/**
 * __useSitesUpdatedSubscription__
 *
 * To run a query within a React component, call `useSitesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSitesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesUpdatedSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSitesUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SitesUpdatedSubscription, SitesUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SitesUpdatedSubscription, SitesUpdatedSubscriptionVariables>(SitesUpdatedDocument, options);
      }
export type SitesUpdatedSubscriptionHookResult = ReturnType<typeof useSitesUpdatedSubscription>;
export type SitesUpdatedSubscriptionResult = Apollo.SubscriptionResult<SitesUpdatedSubscription>;
export const SiteSetupCreatedDocument = gql`
    subscription SITE_SETUP_CREATED {
  siteSetupCreated {
    ...SiteSetupFragment
  }
}
    ${SiteSetupFragmentFragmentDoc}`;

/**
 * __useSiteSetupCreatedSubscription__
 *
 * To run a query within a React component, call `useSiteSetupCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSiteSetupCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSetupCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSiteSetupCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SiteSetupCreatedSubscription, SiteSetupCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SiteSetupCreatedSubscription, SiteSetupCreatedSubscriptionVariables>(SiteSetupCreatedDocument, options);
      }
export type SiteSetupCreatedSubscriptionHookResult = ReturnType<typeof useSiteSetupCreatedSubscription>;
export type SiteSetupCreatedSubscriptionResult = Apollo.SubscriptionResult<SiteSetupCreatedSubscription>;
export const SiteSetupUpdatedDocument = gql`
    subscription SITE_SETUP_UPDATED($siteSetupId: ID) {
  siteSetupUpdated(siteSetupId: $siteSetupId) {
    ...SiteSetupFragment
  }
}
    ${SiteSetupFragmentFragmentDoc}`;

/**
 * __useSiteSetupUpdatedSubscription__
 *
 * To run a query within a React component, call `useSiteSetupUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSiteSetupUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSetupUpdatedSubscription({
 *   variables: {
 *      siteSetupId: // value for 'siteSetupId'
 *   },
 * });
 */
export function useSiteSetupUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SiteSetupUpdatedSubscription, SiteSetupUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SiteSetupUpdatedSubscription, SiteSetupUpdatedSubscriptionVariables>(SiteSetupUpdatedDocument, options);
      }
export type SiteSetupUpdatedSubscriptionHookResult = ReturnType<typeof useSiteSetupUpdatedSubscription>;
export type SiteSetupUpdatedSubscriptionResult = Apollo.SubscriptionResult<SiteSetupUpdatedSubscription>;
export const StockTransfersUpdatedDocument = gql`
    subscription STOCK_TRANSFERS_UPDATED($stockTransferId: ID) {
  stockTransferUpdated(stockTransferId: $stockTransferId) {
    _id
    createdAt
    deliveryId
    destinationColumnId
    destinationColumn {
      fullname
    }
    numberOfRefs
    originColumnId
    originColumn {
      fullname
    }
    products {
      productId
      fullname
      originStockAvailable
      destinationStockAvailable
      quantity
    }
    quantityOfProducts
    state
    stateHistory {
      state
      createdAt
      createdBy
    }
    transferDate
    updatedAt
  }
}
    `;

/**
 * __useStockTransfersUpdatedSubscription__
 *
 * To run a query within a React component, call `useStockTransfersUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStockTransfersUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockTransfersUpdatedSubscription({
 *   variables: {
 *      stockTransferId: // value for 'stockTransferId'
 *   },
 * });
 */
export function useStockTransfersUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<StockTransfersUpdatedSubscription, StockTransfersUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<StockTransfersUpdatedSubscription, StockTransfersUpdatedSubscriptionVariables>(StockTransfersUpdatedDocument, options);
      }
export type StockTransfersUpdatedSubscriptionHookResult = ReturnType<typeof useStockTransfersUpdatedSubscription>;
export type StockTransfersUpdatedSubscriptionResult = Apollo.SubscriptionResult<StockTransfersUpdatedSubscription>;
export const SupplierUpdatedDocument = gql`
    subscription SUPPLIER_UPDATED {
  supplierUpdated {
    ...SupplierFragment
  }
}
    ${SupplierFragmentFragmentDoc}`;

/**
 * __useSupplierUpdatedSubscription__
 *
 * To run a query within a React component, call `useSupplierUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSupplierUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSupplierUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SupplierUpdatedSubscription, SupplierUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SupplierUpdatedSubscription, SupplierUpdatedSubscriptionVariables>(SupplierUpdatedDocument, options);
      }
export type SupplierUpdatedSubscriptionHookResult = ReturnType<typeof useSupplierUpdatedSubscription>;
export type SupplierUpdatedSubscriptionResult = Apollo.SubscriptionResult<SupplierUpdatedSubscription>;
export const SupplyOrdersUpdatedOrCreatedDocument = gql`
    subscription SUPPLY_ORDERS_UPDATED_OR_CREATED {
  supplyOrdersUpdatedOrCreated {
    ...SupplyOrderFragment
  }
}
    ${SupplyOrderFragmentFragmentDoc}`;

/**
 * __useSupplyOrdersUpdatedOrCreatedSubscription__
 *
 * To run a query within a React component, call `useSupplyOrdersUpdatedOrCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSupplyOrdersUpdatedOrCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplyOrdersUpdatedOrCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSupplyOrdersUpdatedOrCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SupplyOrdersUpdatedOrCreatedSubscription, SupplyOrdersUpdatedOrCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SupplyOrdersUpdatedOrCreatedSubscription, SupplyOrdersUpdatedOrCreatedSubscriptionVariables>(SupplyOrdersUpdatedOrCreatedDocument, options);
      }
export type SupplyOrdersUpdatedOrCreatedSubscriptionHookResult = ReturnType<typeof useSupplyOrdersUpdatedOrCreatedSubscription>;
export type SupplyOrdersUpdatedOrCreatedSubscriptionResult = Apollo.SubscriptionResult<SupplyOrdersUpdatedOrCreatedSubscription>;
export const SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedDocument = gql`
    subscription SUPPLY_ORDERS_WITH_SUPPLIER_PRODUCTS_INFO_UPDATED_OR_CREATED {
  supplyOrdersUpdatedOrCreated {
    ...SupplyOrderWithSupplierProductsInfoFragment
  }
}
    ${SupplyOrderWithSupplierProductsInfoFragmentFragmentDoc}`;

/**
 * __useSupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription__
 *
 * To run a query within a React component, call `useSupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription, SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription, SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscriptionVariables>(SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedDocument, options);
      }
export type SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscriptionHookResult = ReturnType<typeof useSupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription>;
export type SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscriptionResult = Apollo.SubscriptionResult<SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription>;
export const WarehouseDeliveryUpdatedDocument = gql`
    subscription WAREHOUSE_DELIVERY_UPDATED {
  warehouseDeliveryUpdated {
    ...WarehouseDeliveryFragment
  }
}
    ${WarehouseDeliveryFragmentFragmentDoc}`;

/**
 * __useWarehouseDeliveryUpdatedSubscription__
 *
 * To run a query within a React component, call `useWarehouseDeliveryUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseDeliveryUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseDeliveryUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWarehouseDeliveryUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WarehouseDeliveryUpdatedSubscription, WarehouseDeliveryUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WarehouseDeliveryUpdatedSubscription, WarehouseDeliveryUpdatedSubscriptionVariables>(WarehouseDeliveryUpdatedDocument, options);
      }
export type WarehouseDeliveryUpdatedSubscriptionHookResult = ReturnType<typeof useWarehouseDeliveryUpdatedSubscription>;
export type WarehouseDeliveryUpdatedSubscriptionResult = Apollo.SubscriptionResult<WarehouseDeliveryUpdatedSubscription>;
export const WarehouseReturnCreatedOrUpdatedDocument = gql`
    subscription WAREHOUSE_RETURN_CREATED_OR_UPDATED($warehouseReturnId: ID) {
  warehouseReturnCreatedOrUpdated(warehouseReturnId: $warehouseReturnId) {
    ...WarehouseReturnFragment
  }
}
    ${WarehouseReturnFragmentFragmentDoc}`;

/**
 * __useWarehouseReturnCreatedOrUpdatedSubscription__
 *
 * To run a query within a React component, call `useWarehouseReturnCreatedOrUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseReturnCreatedOrUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseReturnCreatedOrUpdatedSubscription({
 *   variables: {
 *      warehouseReturnId: // value for 'warehouseReturnId'
 *   },
 * });
 */
export function useWarehouseReturnCreatedOrUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WarehouseReturnCreatedOrUpdatedSubscription, WarehouseReturnCreatedOrUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WarehouseReturnCreatedOrUpdatedSubscription, WarehouseReturnCreatedOrUpdatedSubscriptionVariables>(WarehouseReturnCreatedOrUpdatedDocument, options);
      }
export type WarehouseReturnCreatedOrUpdatedSubscriptionHookResult = ReturnType<typeof useWarehouseReturnCreatedOrUpdatedSubscription>;
export type WarehouseReturnCreatedOrUpdatedSubscriptionResult = Apollo.SubscriptionResult<WarehouseReturnCreatedOrUpdatedSubscription>;